import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ConstraintNumber: { input: any; output: any; }
  ConstraintString: { input: any; output: any; }
  ISODate: { input: any; output: any; }
  ISODateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type GqlAccount = {
  __typename?: 'Account';
  accountAlias: Scalars['String']['output'];
  accountGuid: Scalars['String']['output'];
  availableBalance: Scalars['Float']['output'];
  bankName: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
};

export type GqlAccountBalance = {
  __typename?: 'AccountBalance';
  accountBalanceCents: Scalars['Int']['output'];
  accountBalanceCurrency: Scalars['String']['output'];
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  insufficient: Scalars['Boolean']['output'];
  multiplier: Scalars['Float']['output'];
  orderTotalCents: Scalars['Int']['output'];
  orderTotalCurrency: Scalars['String']['output'];
  pendingTransactionTotalCents?: Maybe<Scalars['Int']['output']>;
  phase: Scalars['String']['output'];
};

export type GqlAccountDetailsInput = {
  accountAlias?: InputMaybe<Scalars['String']['input']>;
  accountNumber: Scalars['String']['input'];
  accountOwners?: InputMaybe<Array<Scalars['String']['input']>>;
  accountType: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type GqlAchBatch = {
  __typename?: 'AchBatch';
  effectiveDate?: Maybe<GqlGoogleProtobufTimestamp>;
  estimatedSettledAt?: Maybe<GqlGoogleProtobufTimestamp>;
  failedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName: Scalars['String']['output'];
  generatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String']['output'];
  processedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  status: Scalars['String']['output'];
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchEntry = {
  __typename?: 'AchEntry';
  achFileId?: Maybe<Scalars['String']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  secCode?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']['output']>;
  transactionCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchEntryV2 = {
  __typename?: 'AchEntryV2';
  achFileId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  batchFileId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  effectiveAt?: Maybe<GqlGoogleProtobufTimestamp>;
  failedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  secCode?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']['output']>;
  transactionCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchRawBatchFile = {
  __typename?: 'AchRawBatchFile';
  fileString: Scalars['String']['output'];
};

export type GqlAchReturn = {
  __typename?: 'AchReturn';
  achEntryId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
};

export type GqlAchReturnDetailReport = {
  __typename?: 'AchReturnDetailReport';
  achReturnDetailReport?: Maybe<Array<Maybe<GqlAchReturnDetailReportRow>>>;
};

export type GqlAchReturnDetailReportResponse = {
  __typename?: 'AchReturnDetailReportResponse';
  data?: Maybe<GqlAchReturnDetailReport>;
};

export type GqlAchReturnDetailReportRow = {
  __typename?: 'AchReturnDetailReportRow';
  companyName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<GqlGoogleProtobufTimestamp>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnCodeCount?: Maybe<Scalars['Int']['output']>;
  totalReturns?: Maybe<Scalars['Int']['output']>;
};

export type GqlAchReturnFileUploadResult = {
  __typename?: 'AchReturnFileUploadResult';
  error?: Maybe<GqlErrorMessage>;
  identificationNumber: Scalars['String']['output'];
  markedAsReturned: Scalars['Boolean']['output'];
};

export type GqlAchReturnResponse = {
  __typename?: 'AchReturnResponse';
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  discretionaryData?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  originalAchEntry: Scalars['String']['output'];
  rdfiIdentification?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  secCode?: Maybe<Scalars['String']['output']>;
  transactionCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV2 = {
  __typename?: 'AchReturnV2';
  achEntryId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV4 = {
  __typename?: 'AchReturnV4';
  achEntryId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReturnV5 = {
  __typename?: 'AchReturnV5';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalTraceNumber?: Maybe<Scalars['String']['output']>;
  originalTransactionDate?: Maybe<GqlGoogleProtobufTimestamp>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnTraceNumber?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  returnedSourceId?: Maybe<Scalars['String']['output']>;
  returnedSourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlAchReversal = {
  __typename?: 'AchReversal';
  achEntryId: Scalars['String']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<GqlGoogleProtobufTimestamp>;
  state?: Maybe<Scalars['String']['output']>;
  successfulAt?: Maybe<GqlGoogleProtobufTimestamp>;
  traceNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlActionEstimates = {
  __typename?: 'ActionEstimates';
  delivery?: Maybe<GqlActionEstimatesValues>;
  pickup?: Maybe<GqlActionEstimatesValues>;
};

export type GqlActionEstimatesValues = {
  __typename?: 'ActionEstimatesValues';
  deliveryTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  rangeInMinutes?: Maybe<Scalars['Int']['output']>;
  readyInMinutes?: Maybe<Scalars['Float']['output']>;
};

export type GqlActivateBankAccountResponse = {
  __typename?: 'ActivateBankAccountResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlActivatePaymentMethodResponse = {
  __typename?: 'ActivatePaymentMethodResponse';
  genericResponse?: Maybe<GqlGenericResponse>;
};

export type GqlActiveDispenariesResult = {
  __typename?: 'ActiveDispenariesResult';
  dispensaries?: Maybe<Array<Maybe<GqlActiveDispensaries>>>;
  meta?: Maybe<GqlActiveDispensariesMeta>;
};

export type GqlActiveDispensaries = {
  __typename?: 'ActiveDispensaries';
  _id?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<GqlActiveDispensariesIntegration>;
  profile?: Maybe<GqlActiveDispensariesProfile>;
};

export type GqlActiveDispensariesIntegration = {
  __typename?: 'ActiveDispensariesIntegration';
  adapter?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlActiveDispensariesMeta = {
  __typename?: 'ActiveDispensariesMeta';
  allStates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlActiveDispensariesProfile = {
  __typename?: 'ActiveDispensariesProfile';
  cName?: Maybe<Scalars['String']['output']>;
  /** @deprecated To be removed */
  chain?: Maybe<Scalars['String']['output']>;
  connectedProductPercentage?: Maybe<Scalars['Float']['output']>;
  embeddedPageViews?: Maybe<Scalars['Int']['output']>;
  hideFromCCT?: Maybe<Scalars['Boolean']['output']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']['output']>;
  menuScore?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum AdInventoryId {
  /** @deprecated legacy AD inventoryID */
  categoryBrandAuc = 'category_brand_auc',
  categoryCarouselAuc = 'category_carousel_auc',
  /** @deprecated legacy AD inventoryID */
  homeBrandAuc = 'home_brand_auc',
  homeCarouselAuc = 'home_carousel_auc'
}

export type GqlAdSettings = {
  __typename?: 'AdSettings';
  enableAdsForDefault?: Maybe<Scalars['Boolean']['output']>;
  enableAdsForEmbedded?: Maybe<Scalars['Boolean']['output']>;
  enableAdsForKiosk?: Maybe<Scalars['Boolean']['output']>;
  enableAdsForStoreFront?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlAdTrackers = {
  __typename?: 'AdTrackers';
  clickUrl: Scalars['String']['output'];
  impressionUrl: Scalars['String']['output'];
};

export type GqlAddressBasedDispensaryDataResult = {
  __typename?: 'AddressBasedDispensaryDataResult';
  deliveryInfo: GqlDispensaries_DeliveryInfo;
  taxes?: Maybe<Array<GqlDispensaries_TaxConfig_Tax>>;
};

export type GqlAdminOrderListType = {
  __typename?: 'AdminOrderListType';
  orders?: Maybe<Array<Maybe<GqlAdminOrderType>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlAdminOrderType = {
  __typename?: 'AdminOrderType';
  _id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  deliveryEstimate?: Maybe<Scalars['String']['output']>;
  deliveryInfo?: Maybe<GqlOrders_DeliveryInfo>;
  deliveryOption?: Maybe<Scalars['Boolean']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  dispoTimezone?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationEstimates?: Maybe<GqlDurationEstimates>;
  effectiveStatus?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fleetManagementTask?: Maybe<GqlOrders_FleetManagementTask>;
  hypur?: Maybe<GqlHypurDetails>;
  isAfterHoursOrder?: Maybe<Scalars['Boolean']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isKioskOrder?: Maybe<Scalars['Boolean']['output']>;
  isScheduledOrder?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  moneris?: Maybe<Array<Maybe<GqlMonerisDetails>>>;
  onfleetTask?: Maybe<GqlOrders_FleetManagementTask>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<GqlPaymentDetails>>>;
  paysafe?: Maybe<GqlPaysafeDetails>;
  pos?: Maybe<GqlOrders_Pos>;
  reopened?: Maybe<Scalars['Boolean']['output']>;
  reservation?: Maybe<GqlOrderReservation>;
  status?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type GqlAdsInspectorDutchieAdDecisionData = {
  __typename?: 'AdsInspectorDutchieAdDecisionData';
  adProviderDecisionId: Scalars['String']['output'];
  adProviderFilters: Scalars['JSON']['output'];
  adType: Scalars['String']['output'];
  items: Array<GqlAdsInspectorDutchieAdDecisionItemData>;
  maxItems?: Maybe<Scalars['Int']['output']>;
  menuFilters: Scalars['JSON']['output'];
  minItems?: Maybe<Scalars['Int']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
};

export type GqlAdsInspectorDutchieAdDecisionEvent = {
  __typename?: 'AdsInspectorDutchieAdDecisionEvent';
  data: GqlAdsInspectorDutchieAdDecisionData;
  timestamp: Scalars['ISODateTime']['output'];
};

export type GqlAdsInspectorDutchieAdDecisionItemData = {
  __typename?: 'AdsInspectorDutchieAdDecisionItemData';
  adProviderDecisionId: Scalars['String']['output'];
  adProviderDecisionItemId: Scalars['String']['output'];
  brandId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  clickUrl: Scalars['String']['output'];
  impressionUrl: Scalars['String']['output'];
  libraryProductId: Scalars['String']['output'];
  menuProductId?: Maybe<Scalars['String']['output']>;
  rejectedReasons: Array<Scalars['String']['output']>;
};

export type GqlAdsInspectorDutchieAdTrackerData = {
  __typename?: 'AdsInspectorDutchieAdTrackerData';
  adProviderDecisionId: Scalars['String']['output'];
  adProviderDecisionItemId: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  trackerType: Scalars['String']['output'];
  uiPlacement: Scalars['String']['output'];
  uiPlacementIndex: Scalars['Int']['output'];
  uiVariant: Scalars['String']['output'];
  uiVersion: Scalars['String']['output'];
};

export type GqlAdsInspectorDutchieAdTrackerEvent = {
  __typename?: 'AdsInspectorDutchieAdTrackerEvent';
  data: GqlAdsInspectorDutchieAdTrackerData;
  timestamp: Scalars['ISODateTime']['output'];
};

export type GqlAdsInspectorEvents = {
  __typename?: 'AdsInspectorEvents';
  dutchieAdDecisions: Array<GqlAdsInspectorDutchieAdDecisionEvent>;
  dutchieAdTrackers: Array<GqlAdsInspectorDutchieAdTrackerEvent>;
  timeframe: GqlAdsInspectorEventsTimeframe;
  totalCount: Scalars['Int']['output'];
};

export type GqlAdsInspectorEventsInput = {
  dispensaryId: Scalars['String']['input'];
  menuVariant: Scalars['String']['input'];
};

export type GqlAdsInspectorEventsTimeframe = {
  __typename?: 'AdsInspectorEventsTimeframe';
  end?: Maybe<Scalars['ISODateTime']['output']>;
  start?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlAeroSyncLinkStart = {
  __typename?: 'AeroSyncLinkStart';
  token: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type GqlAgeVerification = {
  __typename?: 'AgeVerification';
  isAgeVerified: Scalars['Boolean']['output'];
};

export type GqlAllotmentCheckInput = {
  cart: Array<GqlCartItemInput>;
  dateOfBirth: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  medicalCardNumber: Scalars['String']['input'];
};

export type GqlAllotmentDetail = {
  __typename?: 'AllotmentDetail';
  category?: Maybe<Scalars['String']['output']>;
  isUnlimited?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  parentCategory?: Maybe<Scalars['String']['output']>;
  remainingThisCycle?: Maybe<Scalars['Float']['output']>;
  remainingWithCart?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<AllotmentStatus>;
  unit?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
  usedInCart?: Maybe<Scalars['Float']['output']>;
  usedThisCycle?: Maybe<Scalars['Float']['output']>;
};

export type GqlAllotmentInfo = {
  __typename?: 'AllotmentInfo';
  details?: Maybe<Array<Maybe<GqlAllotmentDetail>>>;
  error?: Maybe<Scalars['String']['output']>;
  status: AllotmentStatus;
};

export enum AllotmentStatus {
  error = 'ERROR',
  exceeded = 'EXCEEDED',
  withinLimits = 'WITHIN_LIMITS'
}

export type GqlAnalyticsInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type GqlAnalyticsMeta = {
  __typename?: 'AnalyticsMeta';
  count?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlAnalyticsOrdersByDate = {
  __typename?: 'AnalyticsOrdersByDate';
  date?: Maybe<Scalars['String']['output']>;
  totalOrders?: Maybe<Scalars['Int']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlAnalyticsPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlAnalyticsSort = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlApplicableCategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlApplicationRule = {
  __typename?: 'ApplicationRule';
  _id?: Maybe<Scalars['String']['output']>;
  applicationType?: Maybe<ApplicationType>;
  comparisonOperator?: Maybe<ComparisonOperators>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type GqlApplicationRuleInput = {
  applicationType?: InputMaybe<ApplicationType>;
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum ApplicationScope {
  all = 'ALL',
  each = 'EACH'
}

export enum ApplicationType {
  quantity = 'quantity',
  totalQuantity = 'totalQuantity'
}

export type GqlAppliedReward = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  copy?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated using costV2 to change from Int to Float */
  cost?: InputMaybe<Scalars['Int']['input']>;
  costV2?: InputMaybe<Scalars['Float']['input']>;
  discountId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isRedeemableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rewardType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlApproveInstoreCartAuthorization = {
  __typename?: 'ApproveInstoreCartAuthorization';
  authorized: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlApproveInstoreCartResponse = {
  __typename?: 'ApproveInstoreCartResponse';
  authorization: GqlApproveInstoreCartAuthorization;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlAssessment = {
  __typename?: 'Assessment';
  createdAt: GqlGoogleProtobufTimestamp;
  decision: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalType: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  transactionId: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
};

export type GqlAudienceCondition = {
  __typename?: 'AudienceCondition';
  segmentId: Scalars['String']['output'];
};

export type GqlAudienceConditionInput = {
  segmentId: Scalars['String']['input'];
};

export type GqlBackInStockSubscriptionStatus = {
  __typename?: 'BackInStockSubscriptionStatus';
  subscribed: Scalars['Boolean']['output'];
};

export type GqlBankAccount = {
  __typename?: 'BankAccount';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlBankAccountDetails = {
  __typename?: 'BankAccountDetails';
  accountAlias: Scalars['String']['output'];
  aggregator: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  billingAddressId?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['ISODateTime']['output']>;
  financialInstitutionLogo?: Maybe<Scalars['String']['output']>;
  lastDigits: Scalars['String']['output'];
  status: ConnectionStatus;
};

export type GqlBankAccountPaymentMethod = {
  __typename?: 'BankAccountPaymentMethod';
  bankAccountDetails: GqlBankAccountDetails;
  createdAt: Scalars['ISODateTime']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type?: Maybe<DutchiePayPaymentMethodType>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlBankAccounts = {
  __typename?: 'BankAccounts';
  bankAccounts?: Maybe<Array<GqlBankAccount>>;
};

export type GqlBankDetails = {
  __typename?: 'BankDetails';
  accountAlias?: Maybe<Scalars['String']['output']>;
  bankName: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
  linked?: Maybe<Scalars['Boolean']['output']>;
  ownerName?: Maybe<Array<Scalars['String']['output']>>;
};

export type GqlBaseOrderingSettings = {
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlBasicSettingsInput = {
  checkoutMessage?: InputMaybe<Scalars['String']['input']>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  pickupReminders?: InputMaybe<GqlPickupRemindersInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlBillingAddress = {
  __typename?: 'BillingAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlBillingAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export enum BillingPeriod {
  annual = 'annual',
  monthly = 'monthly',
  quarterly = 'quarterly'
}

export type GqlBillingSubscription = {
  __typename?: 'BillingSubscription';
  chargebeePlan: GqlChargebeePlan;
  chargebeeSubscription?: Maybe<GqlChargebeeSubscription>;
  chargebeeSubscriptionId?: Maybe<Scalars['String']['output']>;
  dispensaryBilling?: Maybe<GqlDispensaryBilling>;
  dispensaryBillingId?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manualPayments?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlBogoConditionItem = {
  __typename?: 'BogoConditionItem';
  _id?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlBogoConditionItemInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  enterpriseProductId?: InputMaybe<Scalars['String']['input']>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']['input']>;
  selectedCategoriesAndSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlBogoRewardItem = {
  __typename?: 'BogoRewardItem';
  _id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use applicationRules */
  applicationRule?: Maybe<GqlApplicationRule>;
  applicationRules?: Maybe<Array<GqlApplicationRule>>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  dollarDiscount?: Maybe<Scalars['String']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  percentDiscount?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetPrice?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlBogoRewardItemInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  dollarDiscount?: InputMaybe<Scalars['String']['input']>;
  enterpriseProductId?: InputMaybe<Scalars['String']['input']>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  percentDiscount?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']['input']>;
  selectedCategoriesAndSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetPrice?: InputMaybe<Scalars['String']['input']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlBogoSavingsObj = {
  __typename?: 'BogoSavingsObj';
  displayAsPercentDiscount?: Maybe<Scalars['Boolean']['output']>;
  individual?: Maybe<Array<Maybe<GqlBogoSavings_Individual>>>;
  isDiscountToCartReward?: Maybe<Scalars['Boolean']['output']>;
  menuBogoDiscount?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type GqlBogoSavings_Individual = {
  __typename?: 'BogoSavings_Individual';
  conditionQuantity?: Maybe<Scalars['Int']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  displayAsPercentDiscount?: Maybe<Scalars['Boolean']['output']>;
  isDiscountToCartReward?: Maybe<Scalars['Boolean']['output']>;
  maxApplicable?: Maybe<Scalars['Int']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  percentDiscount?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
};

export type GqlBrand = {
  __typename?: 'Brand';
  /** @deprecated Use id */
  _id: Scalars['ID']['output'];
  aliasList: Array<Maybe<Scalars['String']['output']>>;
  brandCollisions?: Maybe<Array<GqlBrandCollision>>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  creatorUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  enterprise?: Maybe<GqlEnterprise>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isGlobal: Scalars['Boolean']['output'];
  libraryProductsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentBrand?: Maybe<GqlBrand>;
  parentBrandId?: Maybe<Scalars['ID']['output']>;
  productsCount: Scalars['Int']['output'];
  regions?: Maybe<Array<GqlRegion>>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandCampaignDailyInsight = {
  __typename?: 'BrandCampaignDailyInsight';
  clicks: Scalars['Int']['output'];
  date: Scalars['ISODateTime']['output'];
  impressions: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  spend: Scalars['Float']['output'];
};

export type GqlBrandCampaignInsight = {
  __typename?: 'BrandCampaignInsight';
  adType: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  category: Scalars['String']['output'];
  insights: Array<GqlBrandCampaignDailyInsight>;
  state: Scalars['String']['output'];
  subbrand?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandCampaignInsightsFilterInput = {
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  startDate?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlBrandCategory = {
  __typename?: 'BrandCategory';
  details: GqlBrandCategoryDetails;
  insights: GqlBrandInventoryInsights;
};

export type GqlBrandCategoryDetails = {
  __typename?: 'BrandCategoryDetails';
  ecomCategory: Scalars['String']['output'];
};

export type GqlBrandCategoryInsightsSummary = {
  __typename?: 'BrandCategoryInsightsSummary';
  categories: Array<GqlBrandCategory>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandCollision = {
  __typename?: 'BrandCollision';
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  firstBrand: GqlBrand;
  id: Scalars['ID']['output'];
  isAllowed: Scalars['Boolean']['output'];
  secondBrand: GqlBrand;
};

export type GqlBrandCollisionList = {
  __typename?: 'BrandCollisionList';
  brandCollisions: Array<GqlBrandCollision>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandEnterpriseSetting = {
  __typename?: 'BrandEnterpriseSetting';
  adsEnabled: Scalars['Boolean']['output'];
  enterprise: GqlEnterprise;
  id: Scalars['ID']['output'];
};

export type GqlBrandExportsFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BrandExportsStatusEnum>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandExportsResponse = {
  __typename?: 'BrandExportsResponse';
  exports: Array<GqlFilteredCatalogExport>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandExportsSortByEnum {
  completedAt = 'completedAt',
  filename = 'filename',
  name = 'name',
  processedCount = 'processedCount',
  status = 'status',
  userName = 'user_name'
}

export type GqlBrandExportsSortInput = {
  sortBy?: InputMaybe<BrandExportsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum BrandExportsStatusEnum {
  completed = 'completed',
  failed = 'failed',
  inProgress = 'in_progress',
  pending = 'pending'
}

export type GqlBrandFundedDiscount = {
  __typename?: 'BrandFundedDiscount';
  applicationMethod?: Maybe<BrandFundedDiscountApplicationMethod>;
  approvedAt?: Maybe<Scalars['ISODateTime']['output']>;
  approvedByUserId?: Maybe<Scalars['ID']['output']>;
  availableOnline?: Maybe<Scalars['Boolean']['output']>;
  brandFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  brandFilters?: Maybe<Array<Scalars['String']['output']>>;
  brandId: Scalars['ID']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  brandNotes?: Maybe<Scalars['String']['output']>;
  categoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  categoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  code?: Maybe<Scalars['String']['output']>;
  constraints?: Maybe<Array<GqlBrandFundedDiscountConstraint>>;
  createdAt: Scalars['ISODateTime']['output'];
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  customerGroups?: Maybe<Array<Scalars['String']['output']>>;
  customerSegments?: Maybe<Array<Scalars['String']['output']>>;
  customerTypes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  discountMethod: BrandFundedDiscountDiscountMethod;
  discountValue?: Maybe<Scalars['Int']['output']>;
  distributionDetails?: Maybe<Scalars['JSON']['output']>;
  distributionMethod: BrandFundedDiscountDistributionMethod;
  dposLspId: Scalars['Int']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
  effectiveFundingMethodAmountCents?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  fundingAllocationPercent: Scalars['Int']['output'];
  fundingLimitCents: Scalars['Int']['output'];
  fundingMethod?: Maybe<BrandFundedDiscountFundingMethod>;
  fundingMethodAmountCents?: Maybe<Scalars['Int']['output']>;
  fundingMethodPercent?: Maybe<Scalars['Int']['output']>;
  fundingProgressPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  libraryProductIdExclusions?: Maybe<Array<Scalars['String']['output']>>;
  libraryProductIds?: Maybe<Array<Scalars['String']['output']>>;
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  maximumUsesPerCustomer?: Maybe<Scalars['Int']['output']>;
  maximumUsesTotal?: Maybe<Scalars['Int']['output']>;
  minimumOrderAmountCents?: Maybe<Scalars['Int']['output']>;
  minimumQuantity?: Maybe<Scalars['Int']['output']>;
  onlineName?: Maybe<Scalars['String']['output']>;
  promoName: Scalars['String']['output'];
  retailerNotes?: Maybe<Scalars['String']['output']>;
  rewardApplicationType?: Maybe<BrandFundedDiscountRewardApplicationType>;
  rewardApplyTo?: Maybe<BrandFundedDiscountRewardApplyTo>;
  rewardCartContains?: Maybe<BrandFundedDiscountRewardCartContains>;
  rewardConditionType?: Maybe<BrandFundedDiscountRewardConditionType>;
  rewardConditionValueMax?: Maybe<Scalars['Int']['output']>;
  rewardConditionValueMin?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['ISODateTime']['output'];
  status: BrandFundedDiscountStatus;
  statusLastModifiedAt?: Maybe<Scalars['ISODateTime']['output']>;
  subcategoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  subcategoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  totalFundedAmountCents?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export enum BrandFundedDiscountApplicationMethod {
  automatic = 'automatic',
  code = 'code',
  manual = 'manual'
}

export type GqlBrandFundedDiscountConstraint = {
  __typename?: 'BrandFundedDiscountConstraint';
  brandFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  brandFilters?: Maybe<Array<Scalars['String']['output']>>;
  cartContains?: Maybe<BrandFundedDiscountConstraintCartContains>;
  categoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  categoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  conditionType?: Maybe<BrandFundedDiscountConstraintConditionType>;
  conditionValueMax?: Maybe<Scalars['Int']['output']>;
  conditionValueMin?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  includeNonCannabisItems?: Maybe<Scalars['Boolean']['output']>;
  libraryProductIdExclusions?: Maybe<Array<Scalars['String']['output']>>;
  libraryProductIds?: Maybe<Array<Scalars['String']['output']>>;
  requireSameProduct?: Maybe<Scalars['Boolean']['output']>;
  subcategoryFilterExclusions?: Maybe<Array<Scalars['String']['output']>>;
  subcategoryFilters?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export enum BrandFundedDiscountConstraintCartContains {
  atLeast = 'at_least',
  between = 'between',
  every = 'every',
  exactly = 'exactly'
}

export enum BrandFundedDiscountConstraintConditionType {
  totalItems = 'total_items',
  totalSpend = 'total_spend',
  totalWeight = 'total_weight'
}

export type GqlBrandFundedDiscountConstraintInput = {
  brandFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  brandFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  cartContains?: InputMaybe<BrandFundedDiscountConstraintCartContains>;
  categoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  conditionType?: InputMaybe<BrandFundedDiscountConstraintConditionType>;
  conditionValueMax?: InputMaybe<Scalars['Int']['input']>;
  conditionValueMin?: InputMaybe<Scalars['Int']['input']>;
  includeNonCannabisItems?: InputMaybe<Scalars['Boolean']['input']>;
  libraryProductIdExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requireSameProduct?: InputMaybe<Scalars['Boolean']['input']>;
  subcategoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  subcategoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum BrandFundedDiscountDiscountMethod {
  amountOff = 'amount_off',
  percentOff = 'percent_off',
  priceToAmountEachItem = 'price_to_amount_each_item',
  priceToAmountTotalAmount = 'price_to_amount_total_amount'
}

export enum BrandFundedDiscountDistributionMethod {
  equalAllocation = 'equal_allocation',
  manualAllocation = 'manual_allocation',
  orderBasedAllocation = 'order_based_allocation'
}

export type GqlBrandFundedDiscountFiltersInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<BrandFundedDiscountStatus>>;
};

export enum BrandFundedDiscountFundingMethod {
  dollarsPerApplication = 'dollars_per_application',
  registerDiscount = 'register_discount',
  straightPayAgreement = 'straight_pay_agreement',
  wholesaleCost = 'wholesale_cost'
}

export type GqlBrandFundedDiscountImageUpload = {
  __typename?: 'BrandFundedDiscountImageUpload';
  imageUrl: Scalars['String']['output'];
};

export type GqlBrandFundedDiscountImageUploadInput = {
  base64: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type GqlBrandFundedDiscountInput = {
  applicationMethod?: InputMaybe<BrandFundedDiscountApplicationMethod>;
  availableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  brandFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  brandFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  brandId: Scalars['String']['input'];
  brandNotes?: InputMaybe<Scalars['String']['input']>;
  categoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  constraints?: InputMaybe<Array<GqlBrandFundedDiscountConstraintInput>>;
  customerGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  customerSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  customerTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountMethod: BrandFundedDiscountDiscountMethod;
  discountValue?: InputMaybe<Scalars['Int']['input']>;
  distributionDetails?: InputMaybe<Scalars['JSON']['input']>;
  distributionMethod: BrandFundedDiscountDistributionMethod;
  dposLspId: Scalars['Int']['input'];
  dposLspName: Scalars['String']['input'];
  dposServerRegion: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  fundingAllocationPercent: Scalars['Int']['input'];
  fundingLimitCents: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  libraryProductIdExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maximumUsesPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  maximumUsesTotal?: InputMaybe<Scalars['Int']['input']>;
  minimumOrderAmountCents?: InputMaybe<Scalars['Int']['input']>;
  minimumQuantity?: InputMaybe<Scalars['Int']['input']>;
  onlineName?: InputMaybe<Scalars['String']['input']>;
  promoName: Scalars['String']['input'];
  rewardApplicationType?: InputMaybe<BrandFundedDiscountRewardApplicationType>;
  rewardApplyTo?: InputMaybe<BrandFundedDiscountRewardApplyTo>;
  rewardCartContains?: InputMaybe<BrandFundedDiscountRewardCartContains>;
  rewardConditionType?: InputMaybe<BrandFundedDiscountRewardConditionType>;
  rewardConditionValueMax?: InputMaybe<Scalars['Int']['input']>;
  rewardConditionValueMin?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISODateTime']['input'];
  status?: InputMaybe<BrandFundedDiscountStatus>;
  subcategoryFilterExclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  subcategoryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlBrandFundedDiscountList = {
  __typename?: 'BrandFundedDiscountList';
  data: Array<GqlBrandFundedDiscountSummary>;
  meta: GqlBrandFundedDiscountMeta;
};

export type GqlBrandFundedDiscountMeta = {
  __typename?: 'BrandFundedDiscountMeta';
  totalCount: Scalars['Int']['output'];
};

export type GqlBrandFundedDiscountQualifiedProduct = {
  __typename?: 'BrandFundedDiscountQualifiedProduct';
  brandId: Scalars['String']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandFundedDiscountQualifiedProductList = {
  __typename?: 'BrandFundedDiscountQualifiedProductList';
  data: Array<GqlBrandFundedDiscountQualifiedProduct>;
  meta: GqlBrandFundedDiscountQualifiedProductMeta;
};

export type GqlBrandFundedDiscountQualifiedProductMeta = {
  __typename?: 'BrandFundedDiscountQualifiedProductMeta';
  totalCount: Scalars['Int']['output'];
};

export type GqlBrandFundedDiscountQualifiedProductsFiltersInput = {
  excludedBrands?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedProducts?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedSubcategories?: InputMaybe<Array<Scalars['String']['input']>>;
  includedBrands?: InputMaybe<Array<Scalars['String']['input']>>;
  includedCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  includedProducts?: InputMaybe<Array<Scalars['String']['input']>>;
  includedSubcategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum BrandFundedDiscountQualifiedProductsSortBy {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt'
}

export type GqlBrandFundedDiscountQualifiedProductsSortInput = {
  sortBy?: InputMaybe<BrandFundedDiscountQualifiedProductsSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum BrandFundedDiscountRewardApplicationType {
  differentProducts = 'different_products',
  highestPricedFromRequirements = 'highest_priced_from_requirements',
  lowestPricedFromRequirements = 'lowest_priced_from_requirements',
  sameProducts = 'same_products'
}

export enum BrandFundedDiscountRewardApplyTo {
  allItems = 'all_items',
  highestPrice = 'highest_price',
  lowestPrice = 'lowest_price'
}

export enum BrandFundedDiscountRewardCartContains {
  atLeast = 'at_least',
  between = 'between',
  every = 'every',
  exactly = 'exactly'
}

export enum BrandFundedDiscountRewardConditionType {
  totalItems = 'total_items',
  totalSpend = 'total_spend',
  totalWeight = 'total_weight'
}

export enum BrandFundedDiscountSortBy {
  createdAt = 'createdAt',
  endDate = 'endDate',
  promoName = 'promoName',
  startDate = 'startDate',
  status = 'status'
}

export type GqlBrandFundedDiscountSortInput = {
  sortBy?: InputMaybe<BrandFundedDiscountSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export enum BrandFundedDiscountStatus {
  active = 'active',
  approved = 'approved',
  cancelled = 'cancelled',
  cancelledInProgress = 'cancelled_in_progress',
  completed = 'completed',
  draft = 'draft',
  paused = 'paused',
  pendingApproval = 'pending_approval',
  rejected = 'rejected'
}

export type GqlBrandFundedDiscountSummary = {
  __typename?: 'BrandFundedDiscountSummary';
  applicationMethod?: Maybe<BrandFundedDiscountApplicationMethod>;
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  fundingLimitCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  lspName: Scalars['String']['output'];
  promoName: Scalars['String']['output'];
  startDate: Scalars['ISODateTime']['output'];
  status: BrandFundedDiscountStatus;
};

export type GqlBrandFundedDiscountUpdateInput = {
  expectedLastModifiedAt: Scalars['ISODateTime']['input'];
  status: BrandFundedDiscountStatus;
};

export type GqlBrandImportHistory = {
  __typename?: 'BrandImportHistory';
  brandId?: Maybe<Scalars['ID']['output']>;
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importLevelError?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryDetail = {
  __typename?: 'BrandImportHistoryDetail';
  brandId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  importLevelError?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  rows: Array<GqlBrandImportHistoryDetailRow>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryDetailFilterInput = {
  status?: InputMaybe<Array<BrandImportHistoryDetailStatusEnum>>;
};

export type GqlBrandImportHistoryDetailResponse = {
  __typename?: 'BrandImportHistoryDetailResponse';
  data: GqlBrandImportHistoryDetail;
  meta?: Maybe<GqlMeta>;
};

export type GqlBrandImportHistoryDetailRow = {
  __typename?: 'BrandImportHistoryDetailRow';
  attributes: GqlBrandImportHistoryDetailRowAttributes;
};

export type GqlBrandImportHistoryDetailRowAttributes = {
  __typename?: 'BrandImportHistoryDetailRowAttributes';
  columnValues?: Maybe<Scalars['JSONObject']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  csvRowNumber: Scalars['Int']['output'];
  importErrors?: Maybe<Array<GqlBrandImportHistoryDetailRowImportError>>;
  libraryProductImportId: Scalars['ID']['output'];
  status?: Maybe<BrandImportHistoryDetailStatusEnum>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlBrandImportHistoryDetailRowImportError = {
  __typename?: 'BrandImportHistoryDetailRowImportError';
  columnName?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export enum BrandImportHistoryDetailStatusEnum {
  failed = 'failed',
  imagesProcessed = 'images_processed',
  pending = 'pending',
  success = 'success'
}

export type GqlBrandImportHistoryFailedRowsExport = {
  __typename?: 'BrandImportHistoryFailedRowsExport';
  failedRowsCsvUrl: Scalars['String']['output'];
};

export type GqlBrandImportHistoryFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BrandImportStatusEnum>>;
};

export type GqlBrandImportHistoryResponse = {
  __typename?: 'BrandImportHistoryResponse';
  histories?: Maybe<Array<Maybe<GqlBrandImportHistory>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandImportHistorySortByEnum {
  createdAt = 'createdAt',
  failureCount = 'failureCount',
  name = 'name',
  status = 'status',
  successCount = 'successCount',
  userName = 'user_name'
}

export type GqlBrandImportHistorySortInput = {
  sortBy?: InputMaybe<BrandImportHistorySortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandImportHistoryUploadResponse = {
  __typename?: 'BrandImportHistoryUploadResponse';
  brandId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importLevelError?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  rows: Array<GqlBrandImportHistoryDetailRow>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status?: Maybe<BrandImportStatusEnum>;
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlBrandImportHistoryUser = {
  __typename?: 'BrandImportHistoryUser';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum BrandImportStatusEnum {
  allRowsFailed = 'all_rows_failed',
  failed = 'failed',
  imported = 'imported',
  inProgress = 'in_progress',
  partiallyImported = 'partially_imported',
  pending = 'pending'
}

export type GqlBrandInventoryInsights = {
  __typename?: 'BrandInventoryInsights';
  avgSalesPerDay30d?: Maybe<Scalars['Float']['output']>;
  daysOnHand?: Maybe<Scalars['Float']['output']>;
  daysOnMenu30d?: Maybe<Scalars['Float']['output']>;
  daysSold30d?: Maybe<Scalars['Float']['output']>;
  excessInventoryValue?: Maybe<InventoryOpportunityEnum>;
  gmvOpportunity?: Maybe<InventoryOpportunityEnum>;
  gmvPerWeek?: Maybe<Scalars['Float']['output']>;
  lastRestockDate?: Maybe<Scalars['String']['output']>;
  rawExcessInventoryValue?: Maybe<Scalars['Float']['output']>;
  rawGmvOpportunity?: Maybe<Scalars['Float']['output']>;
  sellThroughRate?: Maybe<Scalars['Float']['output']>;
  status: InventoryStatusEnum;
  unitsRemaining?: Maybe<Scalars['Int']['output']>;
};

export type GqlBrandKeyMetric = {
  __typename?: 'BrandKeyMetric';
  changePct: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type GqlBrandKeyMetrics = {
  __typename?: 'BrandKeyMetrics';
  avgUnitPrice: GqlBrandKeyMetric;
  gmv: GqlBrandKeyMetric;
  unitsSold: GqlBrandKeyMetric;
};

export type GqlBrandList = {
  __typename?: 'BrandList';
  brands: Array<Maybe<GqlBrand>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandLocation = {
  __typename?: 'BrandLocation';
  details: GqlBrandLocationDetails;
  insights: GqlBrandRetailerInsights;
  settings: GqlBrandRetailerSettings;
};

export type GqlBrandLocationDetails = {
  __typename?: 'BrandLocationDetails';
  dposLocationId: Scalars['ID']['output'];
  dposLocationName: Scalars['String']['output'];
  dposLspId: Scalars['ID']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
  isoRegionCode: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  subdivision: Scalars['String']['output'];
  subdivisionName?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandLocationsInsightsSummary = {
  __typename?: 'BrandLocationsInsightsSummary';
  locations: Array<GqlBrandLocation>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandLsp = {
  __typename?: 'BrandLsp';
  details: GqlBrandLspDetails;
  insights: GqlBrandRetailerInsights;
  settings: GqlBrandRetailerSettings;
};

export type GqlBrandLspDetails = {
  __typename?: 'BrandLspDetails';
  dposLspId: Scalars['ID']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
  isoRegionCode?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
  subdivisionName?: Maybe<Scalars['String']['output']>;
};

export type GqlBrandLspItem = {
  __typename?: 'BrandLspItem';
  details: GqlBrandLspDetails;
  focusedAccount: Scalars['Boolean']['output'];
};

export type GqlBrandLspsFilterInput = {
  inventoryLevel: InventoryLevelEnum;
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  optInStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlBrandLspsInsightsSummary = {
  __typename?: 'BrandLspsInsightsSummary';
  lsps: Array<GqlBrandLsp>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandMergeHistoriesSortByEnum {
  createdAt = 'createdAt',
  revertedAt = 'revertedAt'
}

export type GqlBrandMergeHistory = {
  __typename?: 'BrandMergeHistory';
  createdAt: Scalars['ISODateTime']['output'];
  destinationBrand: GqlBrand;
  destinationBrandId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  revertedAt?: Maybe<Scalars['ISODateTime']['output']>;
  sourceBrand: GqlBrand;
  sourceBrandId: Scalars['ID']['output'];
  user?: Maybe<GqlUsers>;
  userId: Scalars['ID']['output'];
};

export type GqlBrandMergeHistoryList = {
  __typename?: 'BrandMergeHistoryList';
  brandMergeHistories: Array<GqlBrandMergeHistory>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandOverviewLsp = {
  __typename?: 'BrandOverviewLsp';
  details: GqlBrandOverviewLspDetails;
  locationCount: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  settings: GqlBrandOverviewLspSettings;
};

export type GqlBrandOverviewLspDetails = {
  __typename?: 'BrandOverviewLspDetails';
  dposLspId: Scalars['String']['output'];
  dposLspImageUrl?: Maybe<Scalars['String']['output']>;
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
};

export type GqlBrandOverviewLspSettings = {
  __typename?: 'BrandOverviewLspSettings';
  optInStatus: Scalars['Boolean']['output'];
};

export type GqlBrandOverviewLspsFilterInput = {
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  optInStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlBrandOverviewLspsSummary = {
  __typename?: 'BrandOverviewLspsSummary';
  lsps: Array<GqlBrandOverviewLsp>;
  meta?: Maybe<GqlQueryInfoType>;
};

export enum BrandPortalProductSearchApprovalStatusFilterEnum {
  approved = 'approved',
  draft = 'draft',
  inReview = 'in_review',
  pending = 'pending',
  rejected = 'rejected'
}

export type GqlBrandPortalProductSearchResponse = {
  __typename?: 'BrandPortalProductSearchResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlBrandPortalProductSearchResult>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlBrandPortalProductSearchResult = {
  __typename?: 'BrandPortalProductSearchResult';
  approvalStatus?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  complianceRegionId: Scalars['ID']['output'];
  createdAt: Scalars['ISODateTime']['output'];
  id: Scalars['ID']['output'];
  menuScore?: Maybe<Scalars['Float']['output']>;
  modelName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum BrandPortalProductSearchSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export type GqlBrandProduct = {
  __typename?: 'BrandProduct';
  details: GqlBrandProductDetails;
  insights: GqlBrandInventoryInsights;
};

export type GqlBrandProductDetails = {
  __typename?: 'BrandProductDetails';
  productId: Scalars['ID']['output'];
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
};

export type GqlBrandProductInsightsSummary = {
  __typename?: 'BrandProductInsightsSummary';
  meta?: Maybe<GqlQueryInfoType>;
  products: Array<GqlBrandProduct>;
};

export type GqlBrandRegion = {
  __typename?: 'BrandRegion';
  isoRegionCode: Scalars['String']['output'];
  subdivision: Scalars['String']['output'];
  subdivisionName: Scalars['String']['output'];
};

export type GqlBrandRegionsFilterInput = {
  inventoryLevel: InventoryLevelEnum;
};

export type GqlBrandRetailerInsights = {
  __typename?: 'BrandRetailerInsights';
  categoryLowStockAlerts: Scalars['Int']['output'];
  categoryOutOfStockAlerts: Scalars['Int']['output'];
  excessInventoryValue?: Maybe<InventoryOpportunityEnum>;
  expiringStockAlerts: Scalars['Int']['output'];
  gmvOpportunity: InventoryOpportunityEnum;
  lowStockAlerts: Scalars['Int']['output'];
  outOfStockAlerts: Scalars['Int']['output'];
  overStockAlerts: Scalars['Int']['output'];
  rawExcessInventoryValue?: Maybe<Scalars['Float']['output']>;
  rawGmvOpportunity?: Maybe<Scalars['Float']['output']>;
};

export type GqlBrandRetailerSettings = {
  __typename?: 'BrandRetailerSettings';
  optInStatus: Scalars['Boolean']['output'];
};

export enum BrandSortByEnum {
  description = 'description',
  dispensary = 'dispensary',
  imageUrl = 'imageUrl',
  name = 'name',
  productsCount = 'productsCount',
  score = 'score',
  updatedAt = 'updatedAt'
}

export type GqlBrandSummary = {
  __typename?: 'BrandSummary';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  centsChange?: Maybe<Scalars['Float']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  numProducts?: Maybe<Scalars['Int']['output']>;
  percentChange?: Maybe<Scalars['Float']['output']>;
  percentSales?: Maybe<Scalars['Float']['output']>;
  totalSalesCents?: Maybe<Scalars['Float']['output']>;
};

export type GqlBrandUser = {
  __typename?: 'BrandUser';
  authorizedBrandIds: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  emails: Array<GqlUserEmails>;
  id: Scalars['ID']['output'];
  profile?: Maybe<GqlBrandUserProfile>;
};

export type GqlBrandUserAccount = {
  __typename?: 'BrandUserAccount';
  accessToken?: Maybe<Scalars['String']['output']>;
  emails: Array<GqlUserEmails>;
  id: Scalars['ID']['output'];
  profile?: Maybe<GqlBrandUserProfile>;
};

export type GqlBrandUserFocusedAccount = {
  __typename?: 'BrandUserFocusedAccount';
  dposLspId: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
};

export type GqlBrandUserList = {
  __typename?: 'BrandUserList';
  brandUsers: Array<GqlBrandUser>;
  meta?: Maybe<GqlMeta>;
};

export type GqlBrandUserPermissions = {
  __typename?: 'BrandUserPermissions';
  manageAdCampaigns: Scalars['Boolean']['output'];
  manageBrandGroup: Scalars['Boolean']['output'];
  manageBrands: Scalars['Boolean']['output'];
};

export type GqlBrandUserProfile = {
  __typename?: 'BrandUserProfile';
  firstName?: Maybe<Scalars['String']['output']>;
  focusedAccounts?: Maybe<Array<GqlBrandUserFocusedAccount>>;
  lastName?: Maybe<Scalars['String']['output']>;
  parentBrand: GqlBrand;
  parentBrandId: Scalars['ID']['output'];
  permissions?: Maybe<GqlBrandUserPermissions>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum BrandUsersSortBy {
  createdAt = 'created_at'
}

export type GqlBrandsSummaryInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBucket = {
  __typename?: 'Bucket';
  checkedOutAt?: Maybe<Scalars['ISODateTime']['output']>;
  checkedOutBy?: Maybe<GqlUsers>;
  completedReviewsCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  createdBy?: Maybe<GqlUsers>;
  filters?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products: Array<Maybe<GqlProducts>>;
  productsCount: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlBucketProduct = {
  __typename?: 'BucketProduct';
  bucketId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  oldProductData?: Maybe<GqlOldProductData>;
  product?: Maybe<GqlProducts>;
  productId?: Maybe<Scalars['ID']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['ID']['output']>;
  reviewedByUser?: Maybe<GqlUsers>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlBucketProductsMeta = {
  __typename?: 'BucketProductsMeta';
  reviewers?: Maybe<Array<Maybe<GqlUsers>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlBucketV2 = {
  __typename?: 'BucketV2';
  checkedOutAt?: Maybe<Scalars['ISODateTime']['output']>;
  checkedOutBy?: Maybe<GqlUsers>;
  completedReviewsCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  createdBy?: Maybe<GqlUsers>;
  filters?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productIds: Array<Maybe<Scalars['String']['output']>>;
  productsCount: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlBulkLibraryProductStatusUpdateMeta = {
  __typename?: 'BulkLibraryProductStatusUpdateMeta';
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlBulkLibraryProductStatusUpdateResponse = {
  __typename?: 'BulkLibraryProductStatusUpdateResponse';
  meta?: Maybe<GqlBulkLibraryProductStatusUpdateMeta>;
};

export type GqlBulkLibraryProductUpdateMeta = {
  __typename?: 'BulkLibraryProductUpdateMeta';
  jobId?: Maybe<Scalars['String']['output']>;
  statusPath?: Maybe<Scalars['String']['output']>;
};

export type GqlBulkLibraryProductUpdateResponse = {
  __typename?: 'BulkLibraryProductUpdateResponse';
  meta?: Maybe<GqlBulkLibraryProductUpdateMeta>;
};

export type GqlBulkLibraryProductUpdates = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBulkLibraryProductUploadError = {
  __typename?: 'BulkLibraryProductUploadError';
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export enum BulkLibraryProductUploadJobStatus {
  complete = 'complete',
  error = 'error',
  pending = 'pending',
  processing = 'processing'
}

export type GqlBulkLibraryProductUploadMetadata = {
  __typename?: 'BulkLibraryProductUploadMetadata';
  errorCount?: Maybe<Scalars['Int']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlBulkLibraryProductUploadResponse = {
  __typename?: 'BulkLibraryProductUploadResponse';
  jobStatusId: Scalars['ID']['output'];
};

export type GqlBulkLibraryProductUploadStatusResponse = {
  __typename?: 'BulkLibraryProductUploadStatusResponse';
  errors?: Maybe<Array<GqlBulkLibraryProductUploadError>>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<GqlBulkLibraryProductUploadMetadata>;
  status: BulkLibraryProductUploadJobStatus;
  userId: Scalars['ID']['output'];
};

/** Individual Product with buying data for delivery/pickup */
export type GqlBuyingOption = {
  __typename?: 'BuyingOption';
  delivery?: Maybe<GqlDurationEstimateRange>;
  distance?: Maybe<Scalars['String']['output']>;
  pickup?: Maybe<GqlDurationEstimateRange>;
  product: GqlProducts;
};

export enum CacheControlScope {
  private = 'PRIVATE',
  public = 'PUBLIC'
}

export type GqlCalculateCheckout = {
  __typename?: 'CalculateCheckout';
  items: Array<GqlCalculateCheckoutItem>;
  priceSummary: GqlPriceSummary;
};

export type GqlCalculateCheckoutInput = {
  dispensaryId: Scalars['String']['input'];
  items: Array<GqlCalculateCheckoutInputItem>;
  orderType: ReservationSlotTypes;
  pricingType: MenuPricingTypes;
};

export type GqlCalculateCheckoutInputItem = {
  option: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GqlCalculateCheckoutItem = {
  __typename?: 'CalculateCheckoutItem';
  basePrice?: Maybe<Scalars['Float']['output']>;
  discounts?: Maybe<GqlItemDiscounts>;
  errors: Array<Scalars['String']['output']>;
  isDiscounted?: Maybe<Scalars['Boolean']['output']>;
  option: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  taxes?: Maybe<GqlItemTaxes>;
  valid: Scalars['Boolean']['output'];
};

export type GqlCalculationResults = {
  __typename?: 'CalculationResults';
  cartItemPrices?: Maybe<Array<Maybe<GqlCartItem>>>;
  discount?: Maybe<Scalars['Int']['output']>;
  discountGamification?: Maybe<GqlCalculationResults_CartGamification>;
  discountWithoutLoyalty?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Array<Maybe<GqlFees>>>;
  grandTotal?: Maybe<Scalars['Int']['output']>;
  itemTaxes?: Maybe<Array<Maybe<GqlItemTax>>>;
  loyaltyAppliedAsDiscount?: Maybe<Scalars['Float']['output']>;
  loyaltyPointsUsed?: Maybe<Scalars['Int']['output']>;
  originalTotal?: Maybe<Scalars['Int']['output']>;
  posCustomerId?: Maybe<Scalars['Int']['output']>;
  rewardValidationErrors?: Maybe<Array<Maybe<GqlRewardValidationError>>>;
  roundedDifference?: Maybe<Scalars['Int']['output']>;
  subTotal?: Maybe<Scalars['Int']['output']>;
  taxInclusivePricing?: Maybe<Scalars['Boolean']['output']>;
  taxes?: Maybe<Scalars['Int']['output']>;
  totalBottleDepositTax?: Maybe<Scalars['Int']['output']>;
  totalCannabisTax?: Maybe<Scalars['Int']['output']>;
  totalSalesTax?: Maybe<Scalars['Int']['output']>;
};

export type GqlCalculationResults_CartGamification = {
  __typename?: 'CalculationResults_CartGamification';
  gamificationDetails?: Maybe<Array<Maybe<GqlGamificationDetailItem>>>;
};

export type GqlCalculationsInput = {
  cart: Array<GqlCartItemInput>;
  codeRedemptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated 3/12/25: Use ecomUserId instead */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerTypeId: Scalars['Int']['input'];
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryScheduleId?: InputMaybe<Scalars['Int']['input']>;
  deliveryState?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet2?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  ecomUserId?: InputMaybe<Scalars['String']['input']>;
  includeGamification?: InputMaybe<Scalars['Boolean']['input']>;
  isDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyPointsApplied?: InputMaybe<Scalars['Float']['input']>;
  payerId?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  platformType?: InputMaybe<PlatformType>;
  posCustomerId?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<PreOrderType>;
  rewardRedemptions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type GqlCampaignSummary = {
  __typename?: 'CampaignSummary';
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']['output']>;
  conversionPercentage?: Maybe<Scalars['Float']['output']>;
  conversionPercentageUnitChange?: Maybe<Scalars['Float']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type GqlCannabinoid = {
  __typename?: 'Cannabinoid';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Major type of cannabis for a product */
export enum CannabisType {
  highCbd = 'HIGH_CBD',
  hybrid = 'HYBRID',
  indica = 'INDICA',
  nA = 'N_A',
  sativa = 'SATIVA',
  seed = 'SEED'
}

export type GqlCartItem = {
  __typename?: 'CartItem';
  discounts?: Maybe<Array<Maybe<GqlDiscount>>>;
  ecommKey?: Maybe<Scalars['String']['output']>;
  menuPrice?: Maybe<Scalars['Int']['output']>;
  pricingTierAdjustment?: Maybe<Scalars['Int']['output']>;
  pricingTierAdjustmentTotal?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  summaryPrice?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
  unitWeightGrams?: Maybe<Scalars['Float']['output']>;
};

export type GqlCartItemInput = {
  ecommKey?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  unitWeightGrams?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlCartSummary = {
  __typename?: 'CartSummary';
  createdAt: Scalars['ISODateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  valueInCents: Scalars['Float']['output'];
};

export enum Categories {
  accessories = 'ACCESSORIES',
  apparel = 'APPAREL',
  cbd = 'CBD',
  clones = 'CLONES',
  concentrate = 'CONCENTRATE',
  edible = 'EDIBLE',
  flower = 'FLOWER',
  /** Pain - should really be PRE-ROLLS */
  prerolls = 'PREROLLS',
  seeds = 'SEEDS',
  tincture = 'TINCTURE',
  topicals = 'TOPICALS',
  vaporizers = 'VAPORIZERS'
}

export type GqlCategoriesInput = {
  items?: InputMaybe<Array<InputMaybe<GqlCategoryInput>>>;
  mobileDisplay?: InputMaybe<CategoriesMobileDisplayOption>;
  style?: InputMaybe<RadiusOption>;
  type?: InputMaybe<CategoriesTypeOption>;
};

export enum CategoriesMobileDisplayOption {
  grid = 'GRID',
  row = 'ROW'
}

export enum CategoriesTypeOption {
  compact = 'COMPACT',
  large = 'LARGE',
  stacked = 'STACKED',
  text = 'TEXT'
}

export type GqlCategoryInput = {
  cardDisplayName?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  collectionId?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  isOutlet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCategoryLineItem = {
  __typename?: 'CategoryLineItem';
  categoryOption?: Maybe<Scalars['String']['output']>;
  percentOfTotal?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export enum CategoryMenuOrder {
  featuredBrands = 'featuredBrands',
  featuredProducts = 'featuredProducts',
  popular = 'popular',
  potencyHighToLow = 'potencyHighToLow',
  potencyLowToHigh = 'potencyLowToHigh',
  priceHighToLow = 'priceHighToLow',
  priceLowToHigh = 'priceLowToHigh',
  recentlyAdded = 'recentlyAdded',
  relevance = 'relevance'
}

export type GqlCategoryPhoto = {
  __typename?: 'CategoryPhoto';
  category?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
};

export type GqlCategorySubcategories = {
  __typename?: 'CategorySubcategories';
  category: Scalars['String']['output'];
  subcategories: Array<Scalars['String']['output']>;
};

export type GqlCategorySummary = {
  __typename?: 'CategorySummary';
  category?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlChain = {
  __typename?: 'Chain';
  chainId?: Maybe<Scalars['String']['output']>;
  dispensaryCount?: Maybe<Scalars['Int']['output']>;
  dispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseId?: Maybe<Scalars['String']['output']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlChainBillingMigrationInput = {
  chargebeeCustomerId: Scalars['ID']['input'];
  chargebeeSubscriptionId: Scalars['ID']['input'];
  dispensaryId: Scalars['ID']['input'];
  manualPayments: Scalars['Boolean']['input'];
};

export type GqlChainBillingReturn = {
  __typename?: 'ChainBillingReturn';
  error?: Maybe<Array<Maybe<GqlChainBillingReturnData>>>;
  success?: Maybe<Array<Maybe<GqlChainBillingReturnData>>>;
};

export type GqlChainBillingReturnData = {
  __typename?: 'ChainBillingReturnData';
  chain?: Maybe<Scalars['Boolean']['output']>;
  chargebeeCustomerId?: Maybe<Scalars['String']['output']>;
  chargebeeSubscriptionId?: Maybe<Scalars['String']['output']>;
  dispensaryBillingId?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  manualPayments?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  previousChargebeeCustomerId?: Maybe<Scalars['String']['output']>;
  previousChargebeeSubscriptionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlChainDropdownOption = {
  __typename?: 'ChainDropdownOption';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlChainFilterInput = {
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlChainList = {
  __typename?: 'ChainList';
  chains?: Maybe<Array<Maybe<GqlChain>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlChainPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlChainSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

export type GqlChangeHistoryObject = {
  __typename?: 'ChangeHistoryObject';
  date?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export enum ChangeRequestActionType {
  createBrand = 'create_brand',
  createProduct = 'create_product',
  deleteProduct = 'delete_product',
  updateBrand = 'update_brand',
  updateProduct = 'update_product'
}

export enum ChannelSources {
  embedded = 'EMBEDDED',
  kiosk = 'KIOSK',
  main = 'MAIN',
  retailerMobile = 'RETAILER_MOBILE'
}

export type GqlChargeBeeHostedPage = {
  __typename?: 'ChargeBeeHostedPage';
  createdAt?: Maybe<Scalars['String']['output']>;
  embed?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlChargebeeCard = {
  __typename?: 'ChargebeeCard';
  brand?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type GqlChargebeeContact = {
  __typename?: 'ChargebeeContact';
  email?: Maybe<Scalars['String']['output']>;
  sendBillingEmail?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlChargebeeCustomer = {
  __typename?: 'ChargebeeCustomer';
  company?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<GqlChargebeeContact>>>;
  id?: Maybe<Scalars['ID']['output']>;
  locationCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlChargebeeDownload = {
  __typename?: 'ChargebeeDownload';
  downloadUrl: Scalars['String']['output'];
  object: Scalars['String']['output'];
  validTill: Scalars['Int']['output'];
};

export type GqlChargebeeLineItem = {
  __typename?: 'ChargebeeLineItem';
  amount?: Maybe<Scalars['Int']['output']>;
  dateFrom?: Maybe<Scalars['Int']['output']>;
  dateTo?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type GqlChargebeePaymentSource = {
  __typename?: 'ChargebeePaymentSource';
  card?: Maybe<GqlChargebeeCard>;
  customerId?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlChargebeePlan = {
  __typename?: 'ChargebeePlan';
  period: Scalars['Int']['output'];
  periodUnit: Scalars['String']['output'];
};

export type GqlChargebeeSubscription = {
  __typename?: 'ChargebeeSubscription';
  activatedAt?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  currentTermEnd?: Maybe<Scalars['Int']['output']>;
  currentTermStart?: Maybe<Scalars['Int']['output']>;
  invoices?: Maybe<Array<Maybe<GqlInvoice>>>;
  nextBillingAt?: Maybe<Scalars['Int']['output']>;
  planAmount?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  trialEnd?: Maybe<Scalars['Int']['output']>;
  trialStart?: Maybe<Scalars['Int']['output']>;
};

export type GqlChargebeeSubscriptionV2 = {
  __typename?: 'ChargebeeSubscriptionV2';
  activatedAt?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  currentTermEnd?: Maybe<Scalars['Int']['output']>;
  currentTermStart?: Maybe<Scalars['Int']['output']>;
  invoices?: Maybe<Array<GqlInvoice>>;
  nextBillingAt?: Maybe<Scalars['Int']['output']>;
  planAmount?: Maybe<Scalars['Int']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  retailerId?: Maybe<Scalars['ID']['output']>;
  startedAt?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  trialEnd?: Maybe<Scalars['Int']['output']>;
  trialStart?: Maybe<Scalars['Int']['output']>;
};

export type GqlCharity = {
  __typename?: 'Charity';
  charitableOrganizationId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  feeDonationId: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl: Scalars['String']['output'];
};

export type GqlChaseHostedProfileCredentials = GqlCheckoutCredentialsBase & {
  __typename?: 'ChaseHostedProfileCredentials';
  adapter: Scalars['String']['output'];
  uID: Scalars['String']['output'];
};

export type GqlCheckPurchaseLimitsCartItem = {
  id: Scalars['String']['input'];
  option: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GqlCheckPurchaseLimitsInput = {
  customerState: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  existingItems: Array<GqlCheckPurchaseLimitsCartItem>;
  idToAdd: Scalars['String']['input'];
  isChangingQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  isMedical?: InputMaybe<Scalars['Boolean']['input']>;
  option: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCheckPurchaseLimitsResult = {
  __typename?: 'CheckPurchaseLimitsResult';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  passesCheck: Scalars['Boolean']['output'];
};

export type GqlCheckout = {
  __typename?: 'Checkout';
  address?: Maybe<GqlCheckoutAddress>;
  dispensaryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<GqlCheckoutItem>;
  orderType: Scalars['String']['output'];
  pricingType: Scalars['String']['output'];
};

export type GqlCheckoutAddress = {
  __typename?: 'CheckoutAddress';
  city?: Maybe<Scalars['String']['output']>;
  deliverable: Scalars['Boolean']['output'];
  formatted?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<GqlCheckoutAddressGeometry>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type GqlCheckoutAddressGeometry = {
  __typename?: 'CheckoutAddressGeometry';
  coordinates?: Maybe<Array<Scalars['Float']['output']>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlCheckoutAddressInput = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type GqlCheckoutCredentialsBase = {
  adapter: Scalars['String']['output'];
};

export type GqlCheckoutItem = {
  __typename?: 'CheckoutItem';
  checkoutId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  option: Scalars['String']['output'];
  product?: Maybe<GqlProducts>;
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type GqlCollection = {
  __typename?: 'Collection';
  allConditions: Scalars['Boolean']['output'];
  audienceConditions?: Maybe<Array<GqlAudienceCondition>>;
  cardBadgeColor?: Maybe<Scalars['String']['output']>;
  cardBadgeEnabled: Scalars['Boolean']['output'];
  cardBadgeTitle?: Maybe<Scalars['String']['output']>;
  cardDisplayName?: Maybe<Scalars['String']['output']>;
  cardImage?: Maybe<Scalars['String']['output']>;
  conditions: Array<GqlCondition>;
  customCategory?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAccessibleToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isOutlet?: Maybe<Scalars['Boolean']['output']>;
  matchAllAudienceConditions?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use matchAllAudienceConditions instead */
  matchAllSegmentConditions?: Maybe<Scalars['Boolean']['output']>;
  navigationEnabled: Scalars['Boolean']['output'];
  navigationTitle?: Maybe<Scalars['String']['output']>;
  outletTimerEnabled?: Maybe<Scalars['Boolean']['output']>;
  outletTimerMessage?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  productCount: Scalars['Int']['output'];
  schedule?: Maybe<GqlSchedule>;
  /** @deprecated Use audienceConditions instead */
  segmentConditions?: Maybe<Array<GqlAudienceCondition>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GqlCollectionCardBadge = {
  __typename?: 'CollectionCardBadge';
  color?: Maybe<Scalars['String']['output']>;
  isAccessibleToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GqlCollectionPositionsInput = {
  collectionId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCollectionProductCount = {
  __typename?: 'CollectionProductCount';
  id?: Maybe<Scalars['ID']['output']>;
  productCount: Scalars['Int']['output'];
};

export enum CollisionType {
  globalToGlobal = 'globalToGlobal',
  globalToLocal = 'globalToLocal',
  localToGlobal = 'localToGlobal',
  localToLocal = 'localToLocal'
}

export type GqlColorInput = {
  buttonsLinks?: InputMaybe<Scalars['String']['input']>;
  discountTag?: InputMaybe<Scalars['String']['input']>;
  navBar?: InputMaybe<Scalars['String']['input']>;
  productCardButton?: InputMaybe<ProductCardButtonOption>;
  staffPickTag?: InputMaybe<Scalars['String']['input']>;
};

export type GqlColorSettings = {
  __typename?: 'ColorSettings';
  linkColor?: Maybe<Scalars['String']['output']>;
  navBarColor?: Maybe<Scalars['String']['output']>;
};

export type GqlColorSettingsInputV2 = {
  linkColor: LinkColor;
  navBarColor: NavBarColor;
};

export type GqlColorSettingsV2 = {
  __typename?: 'ColorSettingsV2';
  linkColor: LinkColor;
  navBarColor: NavBarColor;
};

export type GqlColors = {
  __typename?: 'Colors';
  buttonsLinks?: Maybe<Scalars['String']['output']>;
  discountTag?: Maybe<Scalars['String']['output']>;
  navBar?: Maybe<Scalars['String']['output']>;
  productCardButton?: Maybe<ProductCardButtonOption>;
  staffPickTag?: Maybe<Scalars['String']['output']>;
};

export type GqlCommunicationSettings = {
  __typename?: 'CommunicationSettings';
  optInEmail?: Maybe<Scalars['Boolean']['output']>;
  optInPush?: Maybe<Scalars['Boolean']['output']>;
  optInSMS?: Maybe<Scalars['Boolean']['output']>;
};

export enum ComparisonOperators {
  between = 'between',
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo'
}

export type GqlCompleteAggregatorLinkResponse = {
  __typename?: 'CompleteAggregatorLinkResponse';
  paymentMethods: Array<Maybe<GqlBankAccountPaymentMethod>>;
};

export type GqlCondition = {
  __typename?: 'Condition';
  condition: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemKey: Scalars['String']['output'];
  itemValue: Scalars['String']['output'];
  productCollectionId: Scalars['String']['output'];
};

export enum ConditionType {
  item = 'ITEM',
  quantity = 'QUANTITY',
  spend = 'SPEND',
  weight = 'WEIGHT'
}

export type GqlConnectProductPreviewResponse = {
  __typename?: 'ConnectProductPreviewResponse';
  previewProduct: GqlPreviewProduct;
};

export enum ConnectionStatus {
  connectionStatusActive = 'CONNECTION_STATUS_ACTIVE',
  connectionStatusError = 'CONNECTION_STATUS_ERROR',
  connectionStatusPendingExpiration = 'CONNECTION_STATUS_PENDING_EXPIRATION',
  connectionStatusRevoked = 'CONNECTION_STATUS_REVOKED',
  connectionStatusUnspecified = 'CONNECTION_STATUS_UNSPECIFIED'
}

export type GqlConsumerDispensaryIntegrations = {
  __typename?: 'ConsumerDispensaryIntegrations';
  alpineiq?: Maybe<GqlDispensaries_Integrations>;
  dutchieposloyalty?: Maybe<GqlDispensaries_Integrations>;
  fyllo?: Maybe<GqlDispensaries_Integrations>;
  leaflogix?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  springbig?: Maybe<GqlDispensaries_Integrations>;
};

export type GqlConsumerStreamCredentials = {
  __typename?: 'ConsumerStreamCredentials';
  id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type GqlConsumerUser = {
  __typename?: 'ConsumerUser';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<GqlCustomers>>>;
  email?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<GqlConsumerUserProfile>;
};

export type GqlContactCrmProperty = GqlCrmProperty & {
  __typename?: 'ContactCrmProperty';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlContentChangeRequestAttributes = {
  __typename?: 'ContentChangeRequestAttributes';
  brandId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbdContent?: Maybe<GqlContentChangeRequestPotency>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  effects?: Maybe<Scalars['JSON']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  menu_score?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thcContent?: Maybe<GqlContentChangeRequestPotency>;
};

export type GqlContentChangeRequestComputedAttributes = {
  __typename?: 'ContentChangeRequestComputedAttributes';
  actionType?: Maybe<ChangeRequestActionType>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  authorId?: Maybe<Scalars['ID']['output']>;
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  complianceRegionId?: Maybe<Scalars['String']['output']>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GqlContentChangeRequestFilters = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GqlContentChangeRequestMeta = {
  __typename?: 'ContentChangeRequestMeta';
  filters?: Maybe<GqlContentChangeRequestMetaFilters>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlContentChangeRequestMetaFilterNumber = {
  __typename?: 'ContentChangeRequestMetaFilterNumber';
  label?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlContentChangeRequestMetaFilterText = {
  __typename?: 'ContentChangeRequestMetaFilterText';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlContentChangeRequestMetaFilters = {
  __typename?: 'ContentChangeRequestMetaFilters';
  approvalStatus?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
  brand?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
  score?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterNumber>>>;
  state?: Maybe<Array<Maybe<GqlContentChangeRequestMetaFilterText>>>;
};

export type GqlContentChangeRequestPotency = {
  __typename?: 'ContentChangeRequestPotency';
  range?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type GqlContentChangeRequestSort = {
  sortBy: ContentChangeRequestSortByEnum;
  sortDirection: StringSortDirections;
};

export enum ContentChangeRequestSortByEnum {
  approvalStatus = 'approvalStatus',
  brandName = 'brandName',
  category = 'category',
  connectedCount = 'connectedCount',
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  description = 'description',
  name = 'name',
  productName = 'productName',
  score = 'score',
  state = 'state'
}

export type GqlContentChangeRequests = {
  __typename?: 'ContentChangeRequests';
  contentChangeRequests?: Maybe<Array<Maybe<GqlSerializableContentChangeRequest>>>;
  meta?: Maybe<GqlContentChangeRequestMeta>;
};

export type GqlContentStatistics = {
  __typename?: 'ContentStatistics';
  connectedPercentage?: Maybe<Scalars['Float']['output']>;
  menuScore?: Maybe<Scalars['Float']['output']>;
};

export type GqlCopyLibraryProductErrors = {
  __typename?: 'CopyLibraryProductErrors';
  errors?: Maybe<Scalars['String']['output']>;
  state_library_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlCopyLibraryProductMeta = {
  __typename?: 'CopyLibraryProductMeta';
  errors?: Maybe<Array<Maybe<GqlCopyLibraryProductErrors>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlCopyLibraryProductResponse = {
  __typename?: 'CopyLibraryProductResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  meta?: Maybe<GqlCopyLibraryProductMeta>;
};

/** Response from copying assets to locations */
export type GqlCopyToLocationsResponse = {
  __typename?: 'CopyToLocationsResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GqlCouponList = {
  __typename?: 'CouponList';
  coupons?: Maybe<Array<Maybe<GqlCoupons>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlCouponSummary = {
  __typename?: 'CouponSummary';
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']['output']>;
  averageUsageChangePercentage?: Maybe<Scalars['Float']['output']>;
  couponId?: Maybe<Scalars['String']['output']>;
  couponName?: Maybe<Scalars['String']['output']>;
  currentUsage?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  prevTotalSales?: Maybe<Scalars['Float']['output']>;
  prevUsage?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

export type GqlCouponValidationResponse = {
  __typename?: 'CouponValidationResponse';
  coupon?: Maybe<GqlCoupons>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GqlCouponValueInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCoupon_ApplicableCategoriesInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dollar?: InputMaybe<Scalars['Float']['input']>;
  expDate?: InputMaybe<Scalars['String']['input']>;
  fixedDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlCoupons = {
  __typename?: 'Coupons';
  _id: Scalars['String']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  addedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by percentDiscount || fixedDiscountInCents */
  amount?: Maybe<Scalars['String']['output']>;
  applicableCategories?: Maybe<Array<Maybe<GqlCouponApplicableCategory>>>;
  code?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  expDate?: Maybe<Scalars['String']['output']>;
  fixedDiscountInCents?: Maybe<Scalars['Int']['output']>;
  numAllowedUses?: Maybe<Scalars['Int']['output']>;
  numUses?: Maybe<Scalars['Int']['output']>;
  oneUsePerCustomer?: Maybe<Scalars['Boolean']['output']>;
  percentDiscount?: Maybe<Scalars['Float']['output']>;
  reimbursed?: Maybe<Scalars['Boolean']['output']>;
  restrictions?: Maybe<GqlCouponRestrictions>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlCreateBankAccountResponse = {
  __typename?: 'CreateBankAccountResponse';
  bankAccount?: Maybe<GqlPaymentMethod>;
};

export type GqlCreateBillingGroupInput = {
  enterpriseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  notificationEmails: Array<Scalars['String']['input']>;
  payment: GqlPaymentMethodInput;
  retailers: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type GqlCreateCheckoutInputCartItem = {
  option: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GqlCreateCheckoutInputCustomerInfo = {
  address?: InputMaybe<GqlCheckoutAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateFraudAccountResponse = {
  __typename?: 'CreateFraudAccountResponse';
  success: Scalars['Boolean']['output'];
};

export type GqlCreateFraudInput = {
  name: Scalars['String']['input'];
  paymentMethods: Array<InputMaybe<GqlFraudPaymentMethod>>;
  phone: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GqlCreateInstoreCartUrlResponse = {
  __typename?: 'CreateInstoreCartUrlResponse';
  instoreCartUrl: Scalars['String']['output'];
};

export type GqlCreateMxEnrollmentResponse = {
  __typename?: 'CreateMxEnrollmentResponse';
  billingAddress?: Maybe<GqlBillingAddress>;
  url: Scalars['String']['output'];
};

export type GqlCreateOrUpdateAchReturnResponse = {
  __typename?: 'CreateOrUpdateAchReturnResponse';
  achReturn: GqlAchReturnV2;
};

export type GqlCreateOrUpdateAchReturnResponseV4 = {
  __typename?: 'CreateOrUpdateAchReturnResponseV4';
  achReturn: GqlAchReturnV4;
};

export type GqlCreateOrUpdateAchReturnResponseV5 = {
  __typename?: 'CreateOrUpdateAchReturnResponseV5';
  achReturn: GqlAchReturnV5;
};

export type GqlCreateOrderError = {
  __typename?: 'CreateOrderError';
  extensions?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['JSON']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type GqlCreateOrderResponse = {
  __typename?: 'CreateOrderResponse';
  errors?: Maybe<Array<Maybe<GqlCreateOrderError>>>;
  order?: Maybe<GqlOrders>;
  valid: Scalars['Boolean']['output'];
};

export type GqlCreatePosMedUserInput = {
  alcoholUse: Scalars['Boolean']['input'];
  bipolar: Scalars['Boolean']['input'];
  bipolarManager?: InputMaybe<Scalars['String']['input']>;
  bipolarMedications?: InputMaybe<Scalars['String']['input']>;
  bipolarRisk?: InputMaybe<Scalars['Boolean']['input']>;
  bipolarStable?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  currentMedicalCannabisUse: Scalars['Boolean']['input'];
  currentlyBreastfeeding?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth: Scalars['String']['input'];
  driversLicense: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  historyOfSuicide?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalizedOrSurguries: Scalars['Boolean']['input'];
  howOftenAlcohol?: InputMaybe<Scalars['String']['input']>;
  howOftenTobacco?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  listMentalHealthConditions?: InputMaybe<Scalars['String']['input']>;
  listOfAllergies?: InputMaybe<Scalars['String']['input']>;
  listOfMedications?: InputMaybe<Scalars['String']['input']>;
  medAllergies: Scalars['Boolean']['input'];
  medicalCondition: Scalars['String']['input'];
  mentalConditions: Scalars['Boolean']['input'];
  mentalMedications?: InputMaybe<Scalars['String']['input']>;
  opioidsOrLithium: Scalars['Boolean']['input'];
  opioidsOrLithiumDoctor?: InputMaybe<Scalars['String']['input']>;
  opioidsOrLithiumReason?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  physicallyDisabled: Scalars['Boolean']['input'];
  preferredDispensary?: InputMaybe<Scalars['String']['input']>;
  recentHospitalizationReason?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  takingMedications: Scalars['Boolean']['input'];
  tobaccoUse: Scalars['Boolean']['input'];
  unit: Scalars['String']['input'];
  waitingAtDispensary: Scalars['Boolean']['input'];
  zipCode: Scalars['String']['input'];
};

export type GqlCreatePaymentCard = {
  billingPostalCode: Scalars['String']['input'];
  cardholderFirstName?: InputMaybe<Scalars['String']['input']>;
  cardholderLastName?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type GqlCreatePaymentCustomerDetails = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GqlCreatePaymentPayment = {
  __typename?: 'CreatePaymentPayment';
  amount?: Maybe<Scalars['Int']['output']>;
  checkoutToken?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  tipAMount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<GqlGoogleProtobufTimestamp>;
};

export type GqlCreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse';
  payment: GqlCreatePaymentPayment;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlCreatePointsBoostInput = {
  dispensaryId: Scalars['String']['input'];
  program?: InputMaybe<Scalars['String']['input']>;
  signedUpForLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  signedUpForPbb?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type GqlCreatePrintJobInput = {
  dispensaryId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  printerId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreatePrintJobResponse = {
  __typename?: 'CreatePrintJobResponse';
  printJob: GqlPrintJob;
  success: Scalars['Boolean']['output'];
};

export type GqlCreateRetailerEnrollmentResponse = {
  __typename?: 'CreateRetailerEnrollmentResponse';
  paymentMethod: GqlDutchiePayPaymentMethod;
};

export type GqlCrmProperties = {
  __typename?: 'CrmProperties';
  foreignProperties?: Maybe<GqlPropertyTypes>;
  localProperties?: Maybe<GqlPropertyTypes>;
};

export type GqlCrmProperty = {
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlCrossingMindsAuthResponse = {
  __typename?: 'CrossingMindsAuthResponse';
  jwtToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type GqlCurbsideArrival = {
  __typename?: 'CurbsideArrival';
  arrivalInformation?: Maybe<Scalars['String']['output']>;
  arrivedAt?: Maybe<Scalars['ISODateTime']['output']>;
  clearedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<GqlOrders>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlCurbsidePickupInput = {
  arrivalInformationInstructions?: InputMaybe<Scalars['String']['input']>;
  checkoutMessage?: InputMaybe<Scalars['String']['input']>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableCurbsideArrivals?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  pickupReminders?: InputMaybe<GqlPickupRemindersInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlCurbsidePickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'CurbsidePickupOrderingSettings';
  arrivalInformationInstructions?: Maybe<Scalars['String']['output']>;
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableCurbsideArrivals?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlCustomCategoryPhoto = {
  __typename?: 'CustomCategoryPhoto';
  category?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum CustomFont {
  exo = 'EXO',
  firaSans = 'FIRA_SANS',
  heebo = 'HEEBO',
  lato = 'LATO',
  matter = 'MATTER',
  merriweather = 'MERRIWEATHER',
  notoSans = 'NOTO_SANS',
  nunito = 'NUNITO',
  proximaNova = 'PROXIMA_NOVA',
  rokkitt = 'ROKKITT',
  volkhov = 'VOLKHOV',
  vollkorn = 'VOLLKORN',
  workSans = 'WORK_SANS'
}

export type GqlCustomMobileMenu = {
  __typename?: 'CustomMobileMenu';
  items: Array<GqlCustomMobileMenuItem>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomMobileMenuItem = {
  __typename?: 'CustomMobileMenuItem';
  items?: Maybe<Array<GqlCustomMobileMenuItem>>;
  label: Scalars['String']['output'];
  openInExternalBrowser?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomNavigation = {
  __typename?: 'CustomNavigation';
  dispensaryId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  items: Array<GqlCustomNavigationItem>;
  label: Scalars['String']['output'];
};

export type GqlCustomNavigationItem = {
  __typename?: 'CustomNavigationItem';
  connectedId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<GqlCustomNavigationItem>;
  label: Scalars['String']['output'];
  navigationType: CustomNavigationItemType;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomNavigationItemInput = {
  connectedId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<GqlCustomNavigationItemInput>>;
  label: Scalars['String']['input'];
  navigationType: CustomNavigationItemType;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomNavigationItemType {
  brand = 'BRAND',
  category = 'CATEGORY',
  collection = 'COLLECTION',
  link = 'LINK',
  section = 'SECTION'
}

export type GqlCustomerDetailsResponse = {
  __typename?: 'CustomerDetailsResponse';
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  successfulOrderCount: Scalars['Int']['output'];
};

export type GqlCustomerSubscription = {
  __typename?: 'CustomerSubscription';
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export enum CustomerType {
  medical = 'medical',
  recreational = 'recreational'
}

export type GqlCustomerUnsubscribe = {
  __typename?: 'CustomerUnsubscribe';
  dispensary?: Maybe<GqlDispensaries>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlCustomers = {
  __typename?: 'Customers';
  _id?: Maybe<Scalars['String']['output']>;
  ageVerified?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numOrders?: Maybe<Scalars['Int']['output']>;
  ordersTotal?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  subscriptions?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  textSubscription?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomersList = {
  __typename?: 'CustomersList';
  customers?: Maybe<Array<Maybe<GqlCustomers>>>;
  meta?: Maybe<GqlMeta>;
};

export type GqlCustomizationProvider = {
  __typename?: 'CustomizationProvider';
  /** @deprecated Replaced by manifestUrl */
  manifestURL?: Maybe<Scalars['String']['output']>;
  manifestUrl?: Maybe<Scalars['String']['output']>;
  modulePath?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by modulePath */
  themeName?: Maybe<Scalars['String']['output']>;
};

export type GqlCustomizedCategories = {
  __typename?: 'CustomizedCategories';
  items?: Maybe<Array<Maybe<GqlCustomizedCategory>>>;
  mobileDisplay?: Maybe<CategoriesMobileDisplayOption>;
  style?: Maybe<RadiusOption>;
  type?: Maybe<CategoriesTypeOption>;
};

export type GqlCustomizedCategory = {
  __typename?: 'CustomizedCategory';
  cardDisplayName?: Maybe<Scalars['String']['output']>;
  cardImage?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  collectionId?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  isOutlet?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDateRange = {
  max?: InputMaybe<Scalars['ISODateTime']['input']>;
  min?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlDealCrmProperty = GqlCrmProperty & {
  __typename?: 'DealCrmProperty';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GqlDeliveryFeeTiers = {
  __typename?: 'DeliveryFeeTiers';
  feeInCents?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  maximumInCents?: Maybe<Scalars['Int']['output']>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeliveryInput = {
  checkoutMessage?: InputMaybe<Scalars['String']['input']>;
  deliveryFeeTiers?: InputMaybe<Array<InputMaybe<GqlFeeTiersInput>>>;
  deliveryMode?: InputMaybe<DeliveryModes>;
  deliveryRadius?: InputMaybe<GqlDeliveryRadiusInput>;
  deliveryZipCodes?: InputMaybe<Array<InputMaybe<GqlDeliveryZipCodesInputV2>>>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export enum DeliveryModes {
  cityLimits = 'cityLimits',
  drawn = 'drawn',
  radius = 'radius',
  zipCode = 'zipCode'
}

export type GqlDeliveryOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'DeliveryOrderingSettings';
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  deliveryFeeTiers?: Maybe<Array<Maybe<GqlDeliveryFeeTiers>>>;
  deliveryMode?: Maybe<DeliveryModes>;
  deliveryRadius?: Maybe<GqlDeliveryRadius>;
  deliveryZipCodes?: Maybe<Array<Maybe<GqlDeliveryZipCodes>>>;
  deliveryZones?: Maybe<Array<Maybe<GqlDeliveryZones>>>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export enum DeliveryPolicy {
  destinationBased = 'destinationBased',
  originBased = 'originBased'
}

export type GqlDeliveryRadius = {
  __typename?: 'DeliveryRadius';
  orderMinimum?: Maybe<GqlOrderMinimum>;
  radiusInMiles?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeliveryRadiusInput = {
  orderMinimum?: InputMaybe<GqlOrderMinimumInput>;
  radiusInMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDeliveryZipCodes = {
  __typename?: 'DeliveryZipCodes';
  feeInCents?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type GqlDeliveryZipCodesInputV2 = {
  feeInCents?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDeliveryZones = {
  __typename?: 'DeliveryZones';
  _id?: Maybe<Scalars['String']['output']>;
  area?: Maybe<GqlPolygon>;
  feeInCents?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeliveryZonesInputV2 = {
  _id?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<GqlPolygonInput>;
  feeInCents?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDetailItem = {
  __typename?: 'DetailItem';
  basePrice?: Maybe<Scalars['Float']['output']>;
  basePriceMult?: Maybe<Scalars['Float']['output']>;
  bogoSavings?: Maybe<GqlBogoSavingsObj>;
  bottleDepositTaxCents?: Maybe<Scalars['Float']['output']>;
  canonicalEffectivePotencyMg?: Maybe<Scalars['Float']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOnSale?: Maybe<Scalars['Boolean']['output']>;
  isVapeTaxed?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  menuBasePrice?: Maybe<Scalars['Float']['output']>;
  menuCannabisTax?: Maybe<Scalars['Float']['output']>;
  menuIndividualPrice?: Maybe<Scalars['Float']['output']>;
  menuPrice?: Maybe<Scalars['Float']['output']>;
  menuSaleAdjustment?: Maybe<Scalars['Float']['output']>;
  menuSalesTax?: Maybe<Scalars['Float']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  posId?: Maybe<Scalars['String']['output']>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  productBrand?: Maybe<Scalars['String']['output']>;
  productBrandId?: Maybe<Scalars['String']['output']>;
  productCategory?: Maybe<Scalars['String']['output']>;
  productSubcategory?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  type?: Maybe<Scalars['String']['output']>;
  weightInGrams?: Maybe<Scalars['Float']['output']>;
  weightInMg?: Maybe<Scalars['Float']['output']>;
  wholesalePrice?: Maybe<Scalars['Float']['output']>;
};

export type GqlDeviceAccessCode = {
  __typename?: 'DeviceAccessCode';
  accessCode: Scalars['String']['output'];
  channel: Scalars['String']['output'];
  channelKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GqlDeviceConnection = {
  __typename?: 'DeviceConnection';
  accessToken: Scalars['String']['output'];
};

export type GqlDevice_Config = {
  __typename?: 'Device_config';
  getDeliveryOrders?: Maybe<Scalars['Boolean']['output']>;
  getKioskOrders?: Maybe<Scalars['Boolean']['output']>;
  getPickupOrders?: Maybe<Scalars['Boolean']['output']>;
  orderSort?: Maybe<GqlDevice_Config_OrderSort>;
  /** @deprecated Replaced by getPickupOrders, getDeliveryOrders, getKioskOrders */
  orderSource?: Maybe<Scalars['String']['output']>;
};

export type GqlDevice_Config_Input = {
  getDeliveryOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getKioskOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
  orderSort?: InputMaybe<GqlDevice_Config_OrderSort_Input>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDevice_Config_OrderSort = {
  __typename?: 'Device_config_orderSort';
  sortBy?: Maybe<Device_OrderSortOptions>;
  sortDirection?: Maybe<StringSortDirections>;
};

export type GqlDevice_Config_OrderSort_Input = {
  sortBy?: InputMaybe<Device_OrderSortOptions>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlDevice_FeatureFlags = {
  __typename?: 'Device_featureFlags';
  enableBatchPrint?: Maybe<Scalars['Boolean']['output']>;
};

export enum Device_OrderSortOptions {
  createdAt = 'createdAt',
  reservation = 'reservation'
}

export type GqlDevices = {
  __typename?: 'Devices';
  _id?: Maybe<Scalars['String']['output']>;
  accessCode?: Maybe<Scalars['String']['output']>;
  autoPrintDevice?: Maybe<Scalars['Boolean']['output']>;
  buildNumber?: Maybe<Scalars['String']['output']>;
  config?: Maybe<GqlDevice_Config>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<GqlDevice_FeatureFlags>;
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  printerConnected?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['String']['output']>;
};

export type GqlDisconnectBankAccountResponse = {
  __typename?: 'DisconnectBankAccountResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDiscount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Int']['output']>;
  applicationMethod?: Maybe<Scalars['String']['output']>;
  discountId?: Maybe<Scalars['Int']['output']>;
  isLoyaltyReward?: Maybe<Scalars['Boolean']['output']>;
  isPaymentIncentive?: Maybe<Scalars['Boolean']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlDiscountBundle = {
  __typename?: 'DiscountBundle';
  _id?: Maybe<Scalars['String']['output']>;
  applyTo?: Maybe<ApplicationScope>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDiscountBundleInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applyTo?: InputMaybe<ApplicationScope>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDiscountCategory = {
  __typename?: 'DiscountCategory';
  name: Scalars['String']['output'];
  nonCannabis: Scalars['Boolean']['output'];
};

export type GqlDiscountCategoryList = {
  __typename?: 'DiscountCategoryList';
  categories: Array<GqlDiscountCategory>;
  id: Scalars['ID']['output'];
};

export type GqlDiscountLoc = {
  __typename?: 'DiscountLoc';
  details: GqlDiscountLocDetails;
};

export type GqlDiscountLocDetails = {
  __typename?: 'DiscountLocDetails';
  dposLocationId: Scalars['String']['output'];
  dposLocationName: Scalars['String']['output'];
  dposLspId: Scalars['String']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
};

export type GqlDiscountLsp = {
  __typename?: 'DiscountLsp';
  details: GqlDiscountLspDetails;
  focusedAccount: Scalars['Boolean']['output'];
};

export type GqlDiscountLspDetails = {
  __typename?: 'DiscountLspDetails';
  dposLspId: Scalars['ID']['output'];
  dposLspName: Scalars['String']['output'];
  dposServerRegion: Scalars['String']['output'];
};

export type GqlDiscountRegion = {
  __typename?: 'DiscountRegion';
  country: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  isoRegionCode: Scalars['String']['output'];
  subdivision: Scalars['String']['output'];
  subdivisionName: Scalars['String']['output'];
};

export type GqlDiscountSubcategory = {
  __typename?: 'DiscountSubcategory';
  category: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nonCannabis: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type GqlDiscountSubcategoryList = {
  __typename?: 'DiscountSubcategoryList';
  id: Scalars['ID']['output'];
  subcategories: Array<GqlDiscountSubcategory>;
};

export type GqlDiscountToCart = {
  __typename?: 'DiscountToCart';
  _id?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDiscountToCartInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum DiscountType {
  dollarDiscount = 'dollarDiscount',
  percentDiscount = 'percentDiscount',
  targetPrice = 'targetPrice'
}

export type GqlDispensaries = {
  __typename?: 'Dispensaries';
  SpecialLogoImage?: Maybe<Scalars['String']['output']>;
  acceptsCreditCardTips?: Maybe<Scalars['Boolean']['output']>;
  acceptsDutchiePayTips?: Maybe<Scalars['Boolean']['output']>;
  acceptsTips?: Maybe<Scalars['Boolean']['output']>;
  actionEstimates?: Maybe<GqlActionEstimates>;
  activeCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  adSettings?: Maybe<GqlAdSettings>;
  address?: Maybe<Scalars['String']['output']>;
  admins?: Maybe<Array<Maybe<GqlDispensaries_Profile_Admins>>>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  aeropay?: Maybe<Scalars['Boolean']['output']>;
  ageVerificationBannerColor?: Maybe<Scalars['String']['output']>;
  ageVerificationBannerHtml?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  alt36?: Maybe<Scalars['Boolean']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  brandedDutchiePayEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use brandedDutchiePayLogoLight */
  brandedDutchiePayLogo?: Maybe<Scalars['String']['output']>;
  brandedDutchiePayLogoDark?: Maybe<Scalars['String']['output']>;
  brandedDutchiePayLogoLight?: Maybe<Scalars['String']['output']>;
  brandedDutchiePayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use brandedDutchiePayLogoDark */
  brandedDutchiePayWordmark?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  canPay?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  cashOnly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  cashless?: Maybe<Scalars['Boolean']['output']>;
  categoryLimits?: Maybe<Array<Maybe<GqlDispensaries_CategoryLimits>>>;
  categoryLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  categoryPhotos?: Maybe<Array<Maybe<GqlCategoryPhoto>>>;
  chain?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  check?: Maybe<Scalars['Boolean']['output']>;
  collectionsNavigation?: Maybe<Array<Maybe<GqlCollection>>>;
  /** @deprecated use WebCustomizationSettings.colorSettings - 10/25/22 */
  colorSettings?: Maybe<GqlColorSettings>;
  consumerDispensaryIntegrations?: Maybe<GqlConsumerDispensaryIntegrations>;
  coordinates?: Maybe<GqlDispensaries_Profile_Coordinates>;
  /** @deprecated Use ISO field */
  createdAt?: Maybe<Scalars['String']['output']>;
  createdAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  /** @deprecated Removed support - 4/12/20 */
  creditCard?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  creditCardAtDoor?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  creditCardByPhone?: Maybe<Scalars['Boolean']['output']>;
  customCategoryPhotos?: Maybe<Array<Maybe<GqlCustomCategoryPhoto>>>;
  customDomainSettings?: Maybe<GqlDispensaries_Profile_CustomDomain_Settings>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  debitOnly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated covered by DeliveryOrderingSettings in ordering-settings */
  deliveryArea?: Maybe<GqlPolygon>;
  /** @deprecated used and defined in ordering-settings */
  deliveryFee?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined within hours-settings */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated Fetch delivery info separately instead */
  deliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMin?: Maybe<Scalars['String']['output']>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMode?: Maybe<DeliveryModes>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  dposLspName?: Maybe<Scalars['String']['output']>;
  drivers?: Maybe<Array<Maybe<GqlDispensaries_Profile_Drivers>>>;
  durationEstimateOverrides?: Maybe<GqlDurationEstimates>;
  /** @deprecated defined in hours-settings */
  effectiveHours?: Maybe<GqlEffectiveHours>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmation?: Maybe<Scalars['Boolean']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  embedBackUrl?: Maybe<Scalars['String']['output']>;
  embedSettings?: Maybe<GqlDispensaries_Profile_Embed_Settings>;
  embeddedLogoImage?: Maybe<Scalars['String']['output']>;
  embeddedMenuUrl?: Maybe<Scalars['String']['output']>;
  enabledOrderTypes?: Maybe<GqlEnabledOrderTypes>;
  /** @deprecated Taxes V1 */
  exciseTax?: Maybe<GqlDispensaries_ExciseTax>;
  featureFlags: GqlDispensaries_FeatureFlags;
  featuredBrandsSettings: Array<GqlFeaturedBrandsSetting>;
  featuredProductsSettings: Array<GqlFeaturedProductsSetting>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  /** @deprecated Use ISO field */
  firstActiveAt?: Maybe<Scalars['String']['output']>;
  firstActiveAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  fleetManagementIntegration?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  fullName?: Maybe<Scalars['String']['output']>;
  googleAnalyticsID?: Maybe<Scalars['String']['output']>;
  googleTagManager?: Maybe<GqlDispensaries_GoogleTagManagerConfig>;
  /** @deprecated use storeSettings.requireEmailAddressForGuestCheckout - RTL, 4/28/2021 */
  guestEmailRequired?: Maybe<Scalars['Boolean']['output']>;
  hasMenuIntegration: Scalars['Boolean']['output'];
  hideFromCCT?: Maybe<Scalars['Boolean']['output']>;
  hoursSettings?: Maybe<GqlDispensaryHoursSettings>;
  id: Scalars['String']['output'];
  imageBanners?: Maybe<Array<Maybe<GqlImageBanner>>>;
  includeSalesTaxInMenu?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Taxes V1 */
  inclusiveSalesTax?: Maybe<Scalars['Boolean']['output']>;
  isLibrary?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated defined in ordering-settings as KioskOrderingSettings */
  kioskConfig?: Maybe<GqlDispensaries_KioskConfig>;
  /** @deprecated defined within KioskOrderingSettings in ordering-settings */
  kioskInstructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined within KioskOrderingSettings in ordering-settings */
  kioskOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastThirtyDaysSales?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  linx?: Maybe<Scalars['Boolean']['output']>;
  listImage?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GqlDispensaries_Profile_Location>;
  logoImage?: Maybe<Scalars['String']['output']>;
  /** @deprecated used and defined in ordering-settings as deliveryRadiusInMiles */
  maxDeliveryDistance?: Maybe<Scalars['Float']['output']>;
  medSubjectToExciseTax?: Maybe<Scalars['Boolean']['output']>;
  medicalDispensary?: Maybe<Scalars['Boolean']['output']>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  menuBannerColor?: Maybe<Scalars['String']['output']>;
  menuBannerHtml?: Maybe<Scalars['String']['output']>;
  menuBannerTextBannerCollapsed?: Maybe<Scalars['Boolean']['output']>;
  menuIntegration?: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>;
  menuOrder?: Maybe<Scalars['String']['output']>;
  menuOrderSettings: Array<GqlMenuOrderSetting>;
  menuScore?: Maybe<Scalars['Float']['output']>;
  menuScoresByCategory?: Maybe<Array<Maybe<GqlMenuScore>>>;
  menuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  /** @deprecated Use menuOrderSettings instead */
  menuSortSettings?: Maybe<Array<GqlMenuSortSetting>>;
  menuUrl?: Maybe<Scalars['String']['output']>;
  menuWeights?: Maybe<Scalars['String']['output']>;
  merrcoPublicToken?: Maybe<Scalars['String']['output']>;
  messagingSettings?: Maybe<GqlDispensaries_MessagingSettings>;
  mixAndMatchPricingWeights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * convenience properties used frequently on server and client. Derived based on orderTypesConfig. See serializer for detail
   * @deprecated use OrderTypesConfig.offerAnyPickupService
   */
  offerAnyPickupService?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerCurbsidePickup?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerDriveThruPickup?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use orderTypesConfigV2 or enabledOrderTypes 07/2022 */
  offerPickup?: Maybe<Scalars['Boolean']['output']>;
  openInfoForDevice?: Maybe<GqlOpenInfoForDevice>;
  orderStatusEmailSettings?: Maybe<GqlOrderStatusEmailSettings>;
  /**
   * nested payment-type-per-order-type data; used in admin settings and checkout
   * @deprecated use OrderTypesConfigV2
   */
  orderTypesConfig?: Maybe<GqlOrderTypesConfig>;
  orderTypesConfigV2?: Maybe<GqlOrderTypesConfigV2>;
  ordersArePaused?: Maybe<Scalars['Boolean']['output']>;
  ordersConfig?: Maybe<GqlDispensaries_OrdersConfig>;
  /** @deprecated legacy payment option */
  payInStore?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  payOnlineHypur?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  payOnlineMerrco?: Maybe<Scalars['Boolean']['output']>;
  paymentFees?: Maybe<Array<Maybe<GqlDispensaries_PaymentFees>>>;
  /** booleans of all payment types the dispo accepts (derived from nested orderTypesConfig data). Existing references to profile-level bools should be changed to reference this list */
  paymentTypesAccepted?: Maybe<GqlPaymentTypesConfig>;
  /** @deprecated Use paymentTypesAccepted 11/2020 */
  paytender?: Maybe<Scalars['Boolean']['output']>;
  personalizationSettings?: Maybe<GqlPersonalizationSettings>;
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined in hours-settings */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated defined in ordering-settings */
  pickupMinimum?: Maybe<GqlPickupMinimum>;
  plusSettings?: Maybe<GqlDispensaries_Profile_Plus_Settings>;
  printedMenuSettings?: Maybe<GqlDispensaries_PrintedMenuSettings>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  productCategorySummary?: Maybe<Array<Maybe<GqlCategorySummary>>>;
  recDispensary?: Maybe<Scalars['Boolean']['output']>;
  remoteExtensions?: Maybe<GqlRemoteExtensions>;
  removeMedicalCardFieldsAtCheckout?: Maybe<Scalars['Boolean']['output']>;
  requirePhotoIdForDelivery?: Maybe<Scalars['Boolean']['output']>;
  requirePhotoIdForPickup?: Maybe<Scalars['Boolean']['output']>;
  requiresDriversLicense?: Maybe<Scalars['Boolean']['output']>;
  requiresDriversLicenseForPickup?: Maybe<Scalars['Boolean']['output']>;
  reservationsAvailableByOrderType?: Maybe<GqlReservationsAvailableByOrderType>;
  retailer: GqlRetailer;
  salesTax?: Maybe<Scalars['Float']['output']>;
  seoSettings?: Maybe<GqlSeoSettings>;
  /** @deprecated defined in hours-settings in HoursSettingsForOrderType */
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
  specialsSettings?: Maybe<GqlSpecialsSettings>;
  /** @deprecated Use consumerDispensaryIntegrations.springbig.enabled field */
  springbigEnabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Moved to storeSettings 7/11/2019 */
  stealthMode?: Maybe<Scalars['Boolean']['output']>;
  storeSettings: GqlDispensaries_StoreSettings;
  tags?: Maybe<GqlProductTags>;
  taxCalculationMethod: Scalars['String']['output'];
  taxConfig: GqlDispensaries_TaxConfig;
  temporalLocation?: Maybe<GqlTemporalLocation>;
  /** @deprecated Not possible in aggregations anymore. Use separate query for device lookup. */
  terminals?: Maybe<Array<Maybe<GqlDispensaries_Terminals>>>;
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ISO field */
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  webCustomizationSettings?: Maybe<GqlWebCustomizationSettings>;
  webCustomizationSettingsV2?: Maybe<GqlWebCustomizationSettingsV2>;
};


export type GqlDispensariesCollectionsNavigationArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlDispensariesImageBannersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlDispensariesMenuSectionsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlDispensariesAdSettingsByMenuVariantResult = {
  __typename?: 'DispensariesAdSettingsByMenuVariantResult';
  adSettings?: Maybe<GqlAdSettings>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensariesPersonalizationSettingsByMenuVariantResult = {
  __typename?: 'DispensariesPersonalizationSettingsByMenuVariantResult';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personalizationSettings?: Maybe<GqlPersonalizationSettings>;
};

export type GqlDispensaries_GoogleTagManagerConfig = {
  __typename?: 'Dispensaries_GoogleTagManagerConfig';
  containerIds?: Maybe<Scalars['JSON']['output']>;
  flags?: Maybe<Scalars['JSON']['output']>;
  gtmID?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_TaxConfig = {
  __typename?: 'Dispensaries_TaxConfig';
  calculationMethod: Scalars['String']['output'];
  discountTaxOrder: Scalars['String']['output'];
  taxes: Array<Maybe<GqlDispensaries_TaxConfig_Tax>>;
  version: Scalars['Int']['output'];
};

export type GqlDispensaries_TaxConfig_Tax = {
  __typename?: 'Dispensaries_TaxConfig_Tax';
  applyTo: GqlDispensaries_TaxConfig_Tax_ApplyTo;
  deliveryPolicy?: Maybe<DeliveryPolicy>;
  destinationRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  includeStateSalesTaxInDestinationRate?: Maybe<Scalars['Boolean']['output']>;
  medical: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  potency?: Maybe<PotencyType>;
  potencyRate?: Maybe<Scalars['Float']['output']>;
  rate: Scalars['Float']['output'];
  recreational: Scalars['Boolean']['output'];
  stages: Array<Maybe<GqlDispensaries_TaxConfig_Tax_Stage>>;
  taxBasis?: Maybe<Scalars['String']['output']>;
  type: TaxType;
};

export type GqlDispensaries_TaxConfig_Tax_ApplyTo = {
  __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo';
  hemp: Scalars['Boolean']['output'];
  types: Array<Maybe<Scalars['String']['output']>>;
};

export type GqlDispensaries_TaxConfig_Tax_Stage = {
  __typename?: 'Dispensaries_TaxConfig_Tax_Stage';
  op: Dispensaries_TaxConfig_Tax_Stage_Ops;
  type: Dispensaries_TaxConfig_Tax_Stage_Types;
};

export enum Dispensaries_TaxConfig_Tax_Stage_Ops {
  add = 'add',
  noop = 'noop',
  subtract = 'subtract'
}

export enum Dispensaries_TaxConfig_Tax_Stage_Types {
  checkout = 'checkout',
  menu = 'menu',
  pos = 'pos'
}

export type GqlDispensaries_CategoryLimits = {
  __typename?: 'Dispensaries_categoryLimits';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_DeliveryInfo = {
  __typename?: 'Dispensaries_deliveryInfo';
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  feeType?: Maybe<FeeTypes>;
  feeVaries?: Maybe<Scalars['Boolean']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  minimumVaries?: Maybe<Scalars['Boolean']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
  withinBounds?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_ExciseTax = {
  __typename?: 'Dispensaries_exciseTax';
  local?: Maybe<Scalars['Float']['output']>;
  medicalLocal?: Maybe<Scalars['Float']['output']>;
  medicalState?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['Float']['output']>;
};

export type GqlDispensaries_FeatureFlags = {
  __typename?: 'Dispensaries_featureFlags';
  /** @deprecated General Availability 2/23/21 */
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated General Availability 7/09/2020 */
  enableArrivals?: Maybe<Scalars['Boolean']['output']>;
  enableMenuImport?: Maybe<Scalars['Boolean']['output']>;
  enableMixAndMatch?: Maybe<Scalars['Boolean']['output']>;
  enableNonTerminalAutoConfirm?: Maybe<Scalars['Boolean']['output']>;
  enablePausedOrders?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated General Availability 2/23/21 */
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  hideDeliveryEstimate?: Maybe<Scalars['Boolean']['output']>;
  hideMyAccount?: Maybe<Scalars['Boolean']['output']>;
  hideStoreHours?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_FleetManagementIntegration_Credentials = {
  __typename?: 'Dispensaries_fleetManagementIntegration_credentials';
  apiKey?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ordersEnabled?: Maybe<Scalars['Boolean']['output']>;
  rewardsProgramPointsBoost?: Maybe<Scalars['Int']['output']>;
};

export type GqlDispensaries_FleetManagementIntegration_Flags = {
  __typename?: 'Dispensaries_fleetManagementIntegration_flags';
  combineDiscounts?: Maybe<Scalars['Boolean']['output']>;
  fleetManagementStatus?: Maybe<Scalars['String']['output']>;
  onfleetStatus?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Integrations = {
  __typename?: 'Dispensaries_integrations';
  adapter?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<GqlDispensaries_FleetManagementIntegration_Credentials>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  flags?: Maybe<GqlDispensaries_FleetManagementIntegration_Flags>;
  integrationCategory?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_KioskConfig = {
  __typename?: 'Dispensaries_kioskConfig';
  directedOrders?: Maybe<Scalars['Boolean']['output']>;
  fullNameOnly?: Maybe<Scalars['Boolean']['output']>;
  hideEmailField?: Maybe<Scalars['Boolean']['output']>;
  hidePhoneField?: Maybe<Scalars['Boolean']['output']>;
  notesField?: Maybe<Scalars['Boolean']['output']>;
  phoneRequired?: Maybe<Scalars['Boolean']['output']>;
  showBirthdateField?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_MessagingSettings = {
  __typename?: 'Dispensaries_messagingSettings';
  disableReadyForPickup?: Maybe<Scalars['Boolean']['output']>;
  disableStartDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_OrdersConfig = {
  __typename?: 'Dispensaries_ordersConfig';
  autoClose?: Maybe<Scalars['Boolean']['output']>;
  autoConfirm?: Maybe<Scalars['Boolean']['output']>;
  posItemNames?: Maybe<Scalars['Boolean']['output']>;
  terminalReceiptOptions?: Maybe<GqlTerminalReceiptOptions>;
};

export type GqlDispensaries_PaymentFees = {
  __typename?: 'Dispensaries_paymentFees';
  fee?: Maybe<Scalars['Float']['output']>;
  feeType?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_PrintedMenuSettings = {
  __typename?: 'Dispensaries_printedMenuSettings';
  Categories?: Maybe<Array<Maybe<GqlPrintedMenuSettings_CategoryEntry>>>;
  FooterText?: Maybe<GqlPrintedMenuSettings_Text>;
  HeaderText?: Maybe<GqlPrintedMenuSettings_Text>;
  MenuType?: Maybe<GqlPrintedMenuSettings_Type>;
  Order?: Maybe<GqlPrintedMenuSettings_Type>;
  PageBreaks?: Maybe<GqlPrintedMenuSettings_PageBreaks>;
  Photos?: Maybe<GqlPrintedMenuSettings_Photos>;
  StrainTypes?: Maybe<Array<Maybe<GqlPrintedMenuSettings_StrainTypesEntry>>>;
};

export type GqlDispensaries_Profile_Admins = {
  __typename?: 'Dispensaries_profile_admins';
  active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Coordinates = {
  __typename?: 'Dispensaries_profile_coordinates';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type GqlDispensaries_Profile_CustomDomain_Settings = {
  __typename?: 'Dispensaries_profile_customDomain_settings';
  /** @deprecated use domain instead */
  cloudflareDomain?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Drivers = {
  __typename?: 'Dispensaries_profile_drivers';
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Embed_Settings = {
  __typename?: 'Dispensaries_profile_embed_settings';
  applyToAllLocations?: Maybe<Scalars['Boolean']['output']>;
  autoGTM?: Maybe<Scalars['Boolean']['output']>;
  autoScroll?: Maybe<Scalars['Boolean']['output']>;
  autoScrollOffset?: Maybe<Scalars['Int']['output']>;
  disablePageLoadsAtTop?: Maybe<Scalars['Boolean']['output']>;
  disableRouting?: Maybe<Scalars['Boolean']['output']>;
  disclaimerText?: Maybe<Scalars['String']['output']>;
  disclaimerTextHtml?: Maybe<Scalars['String']['output']>;
  enableFullScreenEmbeddedCheckout?: Maybe<Scalars['Boolean']['output']>;
  iframeCSS?: Maybe<Scalars['String']['output']>;
  pageCSS?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_FeeTiers = {
  __typename?: 'Dispensaries_profile_feeTiers';
  fee?: Maybe<Scalars['String']['output']>;
  feeType?: Maybe<FeeTypes>;
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  percentFee?: Maybe<Scalars['Float']['output']>;
};

export type GqlDispensaries_Profile_Hours = {
  __typename?: 'Dispensaries_profile_hours';
  Friday?: Maybe<GqlDayBounds>;
  Monday?: Maybe<GqlDayBounds>;
  Saturday?: Maybe<GqlDayBounds>;
  Sunday?: Maybe<GqlDayBounds>;
  Thursday?: Maybe<GqlDayBounds>;
  Tuesday?: Maybe<GqlDayBounds>;
  Wednesday?: Maybe<GqlDayBounds>;
};

export type GqlDispensaries_Profile_Location = {
  __typename?: 'Dispensaries_profile_location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<GqlDispensaries_Profile_Location_Geometry>;
  ln1?: Maybe<Scalars['String']['output']>;
  ln2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Location_Geometry = {
  __typename?: 'Dispensaries_profile_location_geometry';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_MedicalCard = {
  __typename?: 'Dispensaries_profile_medicalCard';
  expirationDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_Profile_Plus_Settings = {
  __typename?: 'Dispensaries_profile_plus_settings';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  defaultReturnUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaries_StoreSettings = {
  __typename?: 'Dispensaries_storeSettings';
  collapseProductDescription: Scalars['Boolean']['output'];
  customTermsText?: Maybe<Scalars['String']['output']>;
  customerMessagingTermsAccepted: Scalars['Boolean']['output'];
  defaultViewStyle: MenuViewStyles;
  disableGuestCheckout: Scalars['Boolean']['output'];
  disableGuestDOB: Scalars['Boolean']['output'];
  disablePurchaseLimits: Scalars['Boolean']['output'];
  displayKioskAnonymousCheckoutDisclaimer?: Maybe<Scalars['Boolean']['output']>;
  displayPhoneConfirmation: Scalars['Boolean']['output'];
  dontCombineWeightedProducts: Scalars['Boolean']['output'];
  dontMapSubcategoriesByProductName?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated used and defined in ordering-settings */
  enableAfterHoursOrderingForDelivery: Scalars['Boolean']['output'];
  /** @deprecated used and defined per order type in ordering-settings */
  enableAfterHoursOrderingForPickup: Scalars['Boolean']['output'];
  enableCustomTerms?: Maybe<Scalars['Boolean']['output']>;
  enableDutchiePayConsumerSurcharge?: Maybe<Scalars['Boolean']['output']>;
  enableLLxSaleDiscountSync?: Maybe<Scalars['Boolean']['output']>;
  enableLimitPerCustomer: Scalars['Boolean']['output'];
  enableMixAndMatchPricingForDelivery: Scalars['Boolean']['output'];
  enableMixAndMatchPricingForPickup: Scalars['Boolean']['output'];
  enableOmniauthLoginCheckout?: Maybe<Scalars['Boolean']['output']>;
  enableOrderStatusEmails: Scalars['Boolean']['output'];
  enableProductUrgencyMessaging?: Maybe<Scalars['Boolean']['output']>;
  enableRoundToNearestDollar?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated used and defined in ordering-settings */
  enableScheduledOrderingForDelivery: Scalars['Boolean']['output'];
  /** @deprecated used and defined per order type in ordering-settings */
  enableScheduledOrderingForPickup: Scalars['Boolean']['output'];
  enableStorefrontAgeGate: Scalars['Boolean']['output'];
  /** @deprecated Age verification gate feature has been removed */
  hardAgeGateAgeVerification: Scalars['Boolean']['output'];
  hardAgeGateHideMenuContent: Scalars['Boolean']['output'];
  hideAddressFromDutchieMain: Scalars['Boolean']['output'];
  hideDiscountsFromConsumer?: Maybe<Scalars['Boolean']['output']>;
  hideEffects: Scalars['Boolean']['output'];
  hideFilters?: Maybe<Scalars['Boolean']['output']>;
  hideFromMobileApp?: Maybe<Scalars['Boolean']['output']>;
  hideOutOfStockProducts: Scalars['Boolean']['output'];
  hideRoundingLineItem?: Maybe<Scalars['Boolean']['output']>;
  isolatedMenus: Scalars['Boolean']['output'];
  keepUncombinedWeights?: Maybe<Scalars['Boolean']['output']>;
  prioritizeStaffPicksInSearchResults: Scalars['Boolean']['output'];
  provideBackInstockEmailNotifications: Scalars['Boolean']['output'];
  quantityLimit: Scalars['Int']['output'];
  quantityLimitMaxAvailable: Scalars['Boolean']['output'];
  requireEmailAddressForGuestCheckout: Scalars['Boolean']['output'];
  requireMedCardPhotoForDelivery?: Maybe<Scalars['Boolean']['output']>;
  requireMedCardPhotoForPickup?: Maybe<Scalars['Boolean']['output']>;
  requirePaymentMethodSelection?: Maybe<Scalars['Boolean']['output']>;
  requireTermsAcceptance?: Maybe<Scalars['Boolean']['output']>;
  restrictSalesLanguage?: Maybe<Scalars['Boolean']['output']>;
  rewardsIntegrationConfiguration?: Maybe<GqlRewards_Integration_Configuration>;
  showLoyaltyRewards?: Maybe<Scalars['Boolean']['output']>;
  showMobileAppSmartBanner?: Maybe<Scalars['Boolean']['output']>;
  showPOSPackageId: Scalars['Boolean']['output'];
  stealthMode: Scalars['Boolean']['output'];
  subscriptions: GqlDispensaries_Subscriptions;
  usePotencyForConcentrateLimits?: Maybe<Scalars['Boolean']['output']>;
  useStandardEquivalentForEdiblesLimits?: Maybe<Scalars['Boolean']['output']>;
  useStateRegulatedImageWatermarks?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_Subscriptions = {
  __typename?: 'Dispensaries_subscriptions';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaries_SubscriptionsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaries_Terminals = {
  __typename?: 'Dispensaries_terminals';
  _id?: Maybe<Scalars['String']['output']>;
  config?: Maybe<GqlDevice_Config>;
  /** @deprecated Use ISO field */
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  lastSeenAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryAccountManagers = {
  __typename?: 'DispensaryAccountManagers';
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryAdSettings = {
  __typename?: 'DispensaryAdSettings';
  enableAdsForDefault: Scalars['Boolean']['output'];
  enableAdsForEmbedded: Scalars['Boolean']['output'];
  enableAdsForKiosk: Scalars['Boolean']['output'];
  enableAdsForStoreFront: Scalars['Boolean']['output'];
};

export type GqlDispensaryAdSettingsInput = {
  enableAdsForDefault: Scalars['Boolean']['input'];
  enableAdsForEmbedded: Scalars['Boolean']['input'];
  enableAdsForKiosk: Scalars['Boolean']['input'];
  enableAdsForStoreFront: Scalars['Boolean']['input'];
};

export type GqlDispensaryAssetUploadResponse = {
  __typename?: 'DispensaryAssetUploadResponse';
  fileIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlDispensaryBilling = {
  __typename?: 'DispensaryBilling';
  billingSubscription: GqlBillingSubscription;
  chain?: Maybe<Scalars['Boolean']['output']>;
  chargebeeCustomer?: Maybe<GqlChargebeeCustomer>;
  chargebeeCustomerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentSources?: Maybe<Array<Maybe<GqlChargebeePaymentSource>>>;
};

export type GqlDispensaryBillingV2 = {
  __typename?: 'DispensaryBillingV2';
  chain?: Maybe<Scalars['Boolean']['output']>;
  chargebeeCustomer?: Maybe<GqlChargebeeCustomer>;
  paymentSources?: Maybe<Array<Maybe<GqlChargebeePaymentSource>>>;
  retailerId?: Maybe<Scalars['ID']['output']>;
};

export type GqlDispensaryCalcsInput = {
  deliveryInfo?: InputMaybe<GqlDispensaryDeliveryInfoInput>;
  dispensaryTimezone?: InputMaybe<Scalars['String']['input']>;
  feeTiers?: InputMaybe<Array<InputMaybe<GqlDispensaryFeeTiersInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<GqlDispensaryLocationInput>;
  mixAndMatchPricingWeights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentFees?: InputMaybe<Array<InputMaybe<GqlDispensaryPaymentFeeInput>>>;
  specialsSettings?: InputMaybe<GqlDispensarySpecialsSettingsInput>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
  taxConfig?: InputMaybe<GqlDispensaryTaxConfigInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useDartDiscountsPath?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryDeliveryInfoInput = {
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeVaries?: InputMaybe<Scalars['Boolean']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  minimumVaries?: InputMaybe<Scalars['Boolean']['input']>;
  withinBounds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryDropdownOption = {
  __typename?: 'DispensaryDropdownOption';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryFeeTiersInput = {
  fee?: InputMaybe<Scalars['String']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensaryHoursSettings = {
  __typename?: 'DispensaryHoursSettings';
  curbsidePickup?: Maybe<GqlHoursSettingsForOrderType>;
  delivery?: Maybe<GqlHoursSettingsForOrderType>;
  driveThruPickup?: Maybe<GqlHoursSettingsForOrderType>;
  inStorePickup?: Maybe<GqlHoursSettingsForOrderType>;
};

export type GqlDispensaryLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<GqlGeometryInput>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  ln2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export enum DispensaryOrderType {
  all = 'All',
  deliveryOnly = 'DeliveryOnly',
  kiosk = 'Kiosk',
  pickupAndDelivery = 'PickupAndDelivery',
  pickupOnly = 'PickupOnly'
}

export type GqlDispensaryPaymentFeeInput = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryPersonalizationSettings = {
  __typename?: 'DispensaryPersonalizationSettings';
  enablePersonalizationForDefault: Scalars['Boolean']['output'];
  enablePersonalizationForEmbedded: Scalars['Boolean']['output'];
  enablePersonalizationForKiosk: Scalars['Boolean']['output'];
  enablePersonalizationForStoreFront: Scalars['Boolean']['output'];
  enableSortByRelevance?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlDispensaryPersonalizationSettingsInput = {
  enablePersonalizationForDefault: Scalars['Boolean']['input'];
  enablePersonalizationForEmbedded: Scalars['Boolean']['input'];
  enablePersonalizationForKiosk: Scalars['Boolean']['input'];
  enablePersonalizationForStoreFront: Scalars['Boolean']['input'];
  enableSortByRelevance?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DispensaryRoles {
  complianceAndLegal = 'complianceAndLegal',
  customerSales = 'customerSales',
  customerSupport = 'customerSupport',
  financeAndAccounting = 'financeAndAccounting',
  fulfillmentAndDelivery = 'fulfillmentAndDelivery',
  informationTechnology = 'informationTechnology',
  inventoryManagement = 'inventoryManagement',
  marketingAndPromotions = 'marketingAndPromotions',
  storeOperations = 'storeOperations',
  unknown = 'unknown'
}

export enum DispensarySortByType {
  deliveryEstimate = 'deliveryEstimate',
  deliveryFee = 'deliveryFee',
  deliveryMin = 'deliveryMin',
  distance = 'distance',
  integration = 'integration',
  pickupTime = 'pickupTime',
  terminal = 'terminal'
}

export type GqlDispensarySpecialsSettingsInput = {
  discountBehavior?: InputMaybe<Scalars['String']['input']>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']['input']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryStreamToken = {
  __typename?: 'DispensaryStreamToken';
  dispensaryId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type GqlDispensaryTaxConfigInput = {
  calculationMethod?: InputMaybe<Scalars['String']['input']>;
  discountTaxOrder?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Array<InputMaybe<GqlTaxConfigTaxInput>>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlDriveThruPickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'DriveThruPickupOrderingSettings';
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlDropdownOption = {
  __typename?: 'DropdownOption';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlDurationEstimateRange = {
  __typename?: 'DurationEstimateRange';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  highInMinutes?: Maybe<Scalars['Float']['output']>;
  lowInMinutes?: Maybe<Scalars['Float']['output']>;
};

export type GqlDurationEstimates = {
  __typename?: 'DurationEstimates';
  delivery?: Maybe<GqlDurationEstimateRange>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<GqlDurationEstimateRange>;
};

export type GqlDutchiePay = {
  __typename?: 'DutchiePay';
  preAuth?: Maybe<GqlDutchiePayPreAuth>;
};

export type GqlDutchiePayEnrollment = {
  __typename?: 'DutchiePayEnrollment';
  bankAccounts: Array<Maybe<GqlMxBankAccount>>;
  billingAddress?: Maybe<GqlBillingAddress>;
  enrollment: GqlStatus;
};

export type GqlDutchiePayPaymentMethod = {
  __typename?: 'DutchiePayPaymentMethod';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  entity?: Maybe<GqlEntity>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DutchiePayPaymentMethodType {
  paymentMethodTypeBankAccount = 'PAYMENT_METHOD_TYPE_BANK_ACCOUNT',
  paymentMethodTypeUnspecified = 'PAYMENT_METHOD_TYPE_UNSPECIFIED'
}

export type GqlDutchiePayPreAuth = {
  __typename?: 'DutchiePayPreAuth';
  amount: Scalars['Int']['output'];
  callbackUrl: Scalars['String']['output'];
  currency: Scalars['Int']['output'];
  paymentId: Scalars['String']['output'];
};

export type GqlDutchiePosLoyaltyConfig = {
  __typename?: 'DutchiePosLoyaltyConfig';
  dispensaryId?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  /** @deprecated use expirationDate on RewardsListV2 instead */
  loyaltyDaysToExpiration?: Maybe<Scalars['Int']['output']>;
  loyaltyRequireOptIn: Scalars['Boolean']['output'];
  mode?: Maybe<Scalars['String']['output']>;
  onlineDescription?: Maybe<Scalars['String']['output']>;
  onlineName?: Maybe<Scalars['String']['output']>;
  redemptionType?: Maybe<Scalars['String']['output']>;
  referralConfig?: Maybe<GqlDutchieReferralConfig>;
  tierEarningBasis?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<GqlDutchiePosLoyaltyTier>>>;
};

export type GqlDutchiePosLoyaltyTier = {
  __typename?: 'DutchiePosLoyaltyTier';
  badgeColor: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  threshold: Scalars['Int']['output'];
};

export type GqlDutchieReferralConfig = {
  __typename?: 'DutchieReferralConfig';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  learnMoreUrl?: Maybe<Scalars['String']['output']>;
  minimumPurchaseAmount?: Maybe<Scalars['Float']['output']>;
  receiverReward?: Maybe<Scalars['Float']['output']>;
  senderReward?: Maybe<Scalars['Float']['output']>;
};

export type GqlEcommerceAbandonedCartsResponse = {
  __typename?: 'EcommerceAbandonedCartsResponse';
  carts?: Maybe<Array<Maybe<GqlCartSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlEcommerceConversionFunnel = {
  __typename?: 'EcommerceConversionFunnel';
  addedToCart?: Maybe<GqlEcommercePercent>;
  interacted?: Maybe<GqlEcommercePercent>;
  placedOrder?: Maybe<GqlEcommercePercent>;
  visitedCheckout?: Maybe<GqlEcommercePercent>;
  visitedMenu?: Maybe<GqlEcommercePercent>;
};

export type GqlEcommercePercent = {
  __typename?: 'EcommercePercent';
  currentValue?: Maybe<Scalars['Float']['output']>;
  percentOfVisits?: Maybe<Scalars['Float']['output']>;
  unitDifferenceFromLastPeriod?: Maybe<Scalars['Float']['output']>;
};

export type GqlEcommerceValue = {
  __typename?: 'EcommerceValue';
  currentValue?: Maybe<Scalars['Float']['output']>;
  percentDifference?: Maybe<Scalars['Float']['output']>;
};

export enum Effect {
  body = 'BODY',
  calm = 'CALM',
  clearMind = 'CLEAR_MIND',
  comfort = 'COMFORT',
  creative = 'CREATIVE',
  energetic = 'ENERGETIC',
  euphoric = 'EUPHORIC',
  focused = 'FOCUSED',
  happy = 'HAPPY',
  inspired = 'INSPIRED',
  joints = 'JOINTS',
  mind = 'MIND',
  muscles = 'MUSCLES',
  painRelief = 'PAIN_RELIEF',
  relaxed = 'RELAXED',
  skinHealth = 'SKIN_HEALTH',
  sleepy = 'SLEEPY'
}

export type GqlEffectiveHours = {
  __typename?: 'EffectiveHours';
  /** @deprecated new HoursSettingsForOrderType in hours-settings has effective hours per order type */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  /** @deprecated new HoursSettingsForOrderType in hours-settings has effective hours per order type */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
};

export type GqlEnabledOrderTypes = {
  __typename?: 'EnabledOrderTypes';
  curbsidePickup?: Maybe<Scalars['Boolean']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  driveThruPickup?: Maybe<Scalars['Boolean']['output']>;
  inStorePickup?: Maybe<Scalars['Boolean']['output']>;
  kiosk?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlEnterprise = {
  __typename?: 'Enterprise';
  accountTier?: Maybe<Scalars['String']['output']>;
  billingVersion: Scalars['Int']['output'];
  createdAt: Scalars['ISODateTime']['output'];
  hasDposLoyalty?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  primaryContactId?: Maybe<Scalars['ID']['output']>;
  retailers: Array<GqlRetailer>;
  uniqueName: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseBrand = {
  __typename?: 'EnterpriseBrand';
  name?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlEnterpriseCategory = {
  __typename?: 'EnterpriseCategory';
  category?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseDispensaryAdSettings = {
  __typename?: 'EnterpriseDispensaryAdSettings';
  adSettings: GqlDispensaryAdSettings;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlEnterpriseDispensaryPersonalizationSettings = {
  __typename?: 'EnterpriseDispensaryPersonalizationSettings';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  personalizationSettings: GqlDispensaryPersonalizationSettings;
  status: Scalars['String']['output'];
};

export type GqlEnterpriseDispensaryProduct = {
  __typename?: 'EnterpriseDispensaryProduct';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Wrong location and not used. (ENG-25806) 04/11/2022 */
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Wrong location and not used. (ENG-25806) 04/11/2022 */
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseLoyaltySettings = {
  __typename?: 'EnterpriseLoyaltySettings';
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dposLoyaltyIsoRegionCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseId: Scalars['ID']['output'];
  landingPageUrl?: Maybe<Scalars['String']['output']>;
  loyaltyEnrollmentUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  uniqueName: Scalars['String']['output'];
};

export type GqlEnterpriseLoyaltySettingsInput = {
  dposLoyaltyIsoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlEnterpriseMobileAppSettings = {
  __typename?: 'EnterpriseMobileAppSettings';
  androidAppIcon?: Maybe<Scalars['String']['output']>;
  androidExistingVersion?: Maybe<Scalars['String']['output']>;
  androidExistingVersionCode?: Maybe<Scalars['Int']['output']>;
  androidOrganizationName?: Maybe<Scalars['String']['output']>;
  androidPackageName?: Maybe<Scalars['String']['output']>;
  androidSplashBackgroundColor?: Maybe<Scalars['String']['output']>;
  automaticScreenshotGeneration?: Maybe<Scalars['Boolean']['output']>;
  buildForIpad?: Maybe<Scalars['Boolean']['output']>;
  firebaseProjectId?: Maybe<Scalars['String']['output']>;
  headerImage?: Maybe<Scalars['String']['output']>;
  iosAppIcon?: Maybe<Scalars['String']['output']>;
  iosAppStoreId?: Maybe<Scalars['String']['output']>;
  iosBundleIdentifier?: Maybe<Scalars['String']['output']>;
  iosExistingVersion?: Maybe<Scalars['String']['output']>;
  iosSplashBackgroundColor?: Maybe<Scalars['String']['output']>;
  iosTeamId?: Maybe<Scalars['String']['output']>;
  iosTeamName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseMobileAppSettingsInput = {
  androidAppIcon?: InputMaybe<Scalars['String']['input']>;
  androidExistingVersion?: InputMaybe<Scalars['String']['input']>;
  androidExistingVersionCode?: InputMaybe<Scalars['Int']['input']>;
  androidOrganizationName?: InputMaybe<Scalars['String']['input']>;
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
  androidSplashBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  automaticScreenshotGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  buildForIpad?: InputMaybe<Scalars['Boolean']['input']>;
  firebaseProjectId?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  iosAppIcon?: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId?: InputMaybe<Scalars['String']['input']>;
  iosBundleIdentifier?: InputMaybe<Scalars['String']['input']>;
  iosExistingVersion?: InputMaybe<Scalars['String']['input']>;
  iosSplashBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  iosTeamId?: InputMaybe<Scalars['String']['input']>;
  iosTeamName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlEnterpriseProduct = {
  __typename?: 'EnterpriseProduct';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  dispensaryProducts?: Maybe<Array<Maybe<GqlEnterpriseDispensaryProduct>>>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseProducts = {
  __typename?: 'EnterpriseProducts';
  brands?: Maybe<Array<Maybe<GqlEnterpriseBrand>>>;
  categories?: Maybe<Array<Maybe<GqlEnterpriseCategory>>>;
  products?: Maybe<Array<Maybe<GqlEnterpriseProduct>>>;
};

export type GqlEnterpriseSpecial = {
  __typename?: 'EnterpriseSpecial';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  applyRewardsToConditions?: Maybe<Scalars['Boolean']['output']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoConditions?: Maybe<Array<Maybe<GqlBogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoRewards?: Maybe<Array<Maybe<GqlBogoRewardItem>>>;
  cipher?: Maybe<Scalars['JSON']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  discountedPrices?: Maybe<Scalars['JSON']['output']>;
  dispensaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  dollarDiscount?: Maybe<Scalars['Boolean']['output']>;
  duplicatedFrom?: Maybe<Scalars['String']['output']>;
  earliestStartStamp?: Maybe<Scalars['ISODateTime']['output']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailSpecial?: Maybe<Scalars['Boolean']['output']>;
  endDay?: Maybe<Scalars['ISODateTime']['output']>;
  endStamp?: Maybe<Scalars['ISODateTime']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  enterpriseId?: Maybe<Scalars['String']['output']>;
  enterpriseSpecialId?: Maybe<Scalars['String']['output']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']['output']>;
  excludedProducts?: Maybe<Array<Maybe<GqlSpecialsExcludedProducts>>>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inactiveDispensaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  itemsForAPrice?: Maybe<GqlItemsForAPrice>;
  latestEndStamp?: Maybe<Scalars['ISODateTime']['output']>;
  localTime?: Maybe<Scalars['Boolean']['output']>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  menuType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  productDiscounts?: Maybe<Scalars['JSON']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productGroupRewards?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recurring?: Maybe<GqlSpecialsRecurring>;
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use dispensaries instead. 11/11/2021 */
  retailers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  scope?: Maybe<SpecialScopes>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  specialRestrictions?: Maybe<Scalars['JSON']['output']>;
  specialType?: Maybe<SpecialTypes>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  startDay?: Maybe<Scalars['ISODateTime']['output']>;
  startStamp?: Maybe<Scalars['ISODateTime']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlEnterpriseSpecialInputV2 = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableToItemsOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  applicationMethod?: InputMaybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: InputMaybe<Scalars['Boolean']['input']>;
  bogoConditionLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoConditions?: InputMaybe<Array<InputMaybe<GqlBogoConditionItemInput>>>;
  bogoRewardLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoRewards?: InputMaybe<Array<InputMaybe<GqlBogoRewardItemInput>>>;
  cipher?: InputMaybe<Scalars['JSON']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  conditionLogicOperator?: InputMaybe<LogicOperator>;
  conditions?: InputMaybe<Array<InputMaybe<GqlV4ConditionInput>>>;
  consumerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  discountBundle?: InputMaybe<GqlDiscountBundleInput>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  discountToCart?: InputMaybe<GqlDiscountToCartInput>;
  discountedPrices?: InputMaybe<Scalars['JSON']['input']>;
  dispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayRank?: InputMaybe<Scalars['Int']['input']>;
  dollarDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['String']['input']>;
  earliestStartStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  editedStartStamp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<GqlSpecialEmailInput>;
  emailSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  endDay?: InputMaybe<Scalars['String']['input']>;
  endStamp?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  enterpriseSpecialId?: InputMaybe<Scalars['String']['input']>;
  excludeConditionItemsFromRewards?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedProductsInput>>>;
  firstTimeConsumerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  generatedByPOS?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  inactiveDispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inactiveDispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAvailableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  itemsForAPrice?: InputMaybe<GqlItemsForAPriceInput>;
  latestEndStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  localTime?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyPointsToRedeem?: InputMaybe<Scalars['Int']['input']>;
  manualDefaultApplyTo?: InputMaybe<ManualDefaultApplyTo>;
  menuDisplay?: InputMaybe<GqlSpecialMenuDisplayInput>;
  menuDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  menuDisplayImage?: InputMaybe<Scalars['String']['input']>;
  menuDisplayName?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<OrderType>;
  origin?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  percentDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  productDiscounts?: InputMaybe<Array<InputMaybe<GqlProductDiscount>>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productGroupRewards?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quantityUsed?: InputMaybe<Scalars['Int']['input']>;
  recurring?: InputMaybe<GqlSpecialsInputRecurring>;
  redemptionLimit?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerCart?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['Int']['input']>;
  reimbursed?: InputMaybe<Scalars['Boolean']['input']>;
  requireManagerApproval?: InputMaybe<Scalars['Boolean']['input']>;
  rewardLogicOperator?: InputMaybe<LogicOperator>;
  rewards?: InputMaybe<Array<InputMaybe<GqlV4RewardInput>>>;
  saleDiscounts?: InputMaybe<Array<InputMaybe<GqlSaleDiscountInput>>>;
  schedule?: InputMaybe<GqlSpecialScheduleInput>;
  scope?: InputMaybe<SpecialScopes>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialRestrictions?: InputMaybe<Array<InputMaybe<GqlSpecialRestriction>>>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  specialVersion?: InputMaybe<Scalars['Int']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
  stackingMode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDay?: InputMaybe<Scalars['String']['input']>;
  startStamp?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SpecialStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  targetPrice?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  totalAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlEnterpriseSpecialsHistory = {
  __typename?: 'EnterpriseSpecialsHistory';
  enterpriseSpecialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
};

export type GqlEnterpriseSpecialsSettings = {
  __typename?: 'EnterpriseSpecialsSettings';
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  enableIndividualDiscountStacking?: Maybe<Scalars['Boolean']['output']>;
  enableIndividualSpecialPrecedence?: Maybe<Scalars['Boolean']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  permissionEnabled?: Maybe<Scalars['Boolean']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
};

export type GqlEnterpriseSpecialsSettingsInput = {
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']['input']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']['input']>;
  permissionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
};

export type GqlEntity = {
  __typename?: 'Entity';
  externalId?: Maybe<Scalars['String']['output']>;
  externalType?: Maybe<EntityTypes>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlEntityLinkingCodeResponse = {
  __typename?: 'EntityLinkingCodeResponse';
  code: Scalars['String']['output'];
};

export enum EntityTypes {
  dispensary = 'Dispensary',
  user = 'User'
}

export type GqlErrorMessage = {
  __typename?: 'ErrorMessage';
  message: Scalars['String']['output'];
};

export type GqlExcludedBogoProduct = {
  __typename?: 'ExcludedBOGOProduct';
  Name?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type GqlExcludedBogoProducts = {
  __typename?: 'ExcludedBOGOProducts';
  conditions?: Maybe<Array<Maybe<GqlExcludedBogoProduct>>>;
  rewards?: Maybe<Array<Maybe<GqlExcludedBogoProduct>>>;
};

export type GqlExclusion = {
  __typename?: 'Exclusion';
  _id?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  matchOperator?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<ProductGroup>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weightOperator?: Maybe<WeightOperator>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlExclusionInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  matchOperator?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<ProductGroup>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightOperator?: InputMaybe<WeightOperator>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlExists = {
  __typename?: 'Exists';
  _id?: Maybe<Scalars['String']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlExport = {
  __typename?: 'Export';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type GqlExportFilteredCatalogFilterInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  hasImages?: InputMaybe<Scalars['Boolean']['input']>;
  stateLibrary?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<LibraryProductStatusEnum>;
};

export type GqlExportFilteredCatalogResponse = {
  __typename?: 'ExportFilteredCatalogResponse';
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  filters: GqlExportFilteredCatalogResponseFilters;
  name: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  progressPercentage: Scalars['Float']['output'];
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status: ExportFilteredCatalogStatusEnum;
  totalCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlExportFilteredCatalogResponseFilters = {
  __typename?: 'ExportFilteredCatalogResponseFilters';
  brandIds?: Maybe<Array<Scalars['ID']['output']>>;
  category?: Maybe<Array<Scalars['String']['output']>>;
  search?: Maybe<Scalars['String']['output']>;
  stateLibrary?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<LibraryProductStatusEnum>;
};

export enum ExportFilteredCatalogStatusEnum {
  completed = 'completed',
  failed = 'failed',
  inProgress = 'inProgress',
  pending = 'pending'
}

export type GqlExtensionData = {
  __typename?: 'ExtensionData';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlExtensionDataInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type GqlFeaturedBrandsSetting = {
  __typename?: 'FeaturedBrandsSetting';
  brandIds: Array<Scalars['String']['output']>;
  category: Scalars['String']['output'];
};

export type GqlFeaturedProductsSetting = {
  __typename?: 'FeaturedProductsSetting';
  category: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type GqlFeeTiersInput = {
  feeInCents?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  maximumInCents?: InputMaybe<Scalars['Int']['input']>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export enum FeeTypes {
  flat = 'flat',
  percent = 'percent'
}

export type GqlFees = {
  __typename?: 'Fees';
  deliveryFee?: Maybe<Scalars['Boolean']['output']>;
  feeAmount?: Maybe<Scalars['Int']['output']>;
  feeItemId?: Maybe<Scalars['Int']['output']>;
  feeName?: Maybe<Scalars['String']['output']>;
  paymentFee?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlFilteredBrandSummaryResponse = {
  __typename?: 'FilteredBrandSummaryResponse';
  brands?: Maybe<Array<Maybe<GqlBrandSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlFilteredCatalogExport = {
  __typename?: 'FilteredCatalogExport';
  completedAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFailed: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  progressPercentage: Scalars['Float']['output'];
  s3Url?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['ISODateTime']['output']>;
  status: BrandExportsStatusEnum;
  totalCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  user?: Maybe<GqlBrandImportHistoryUser>;
};

export type GqlFilteredEnterpriseSpecials = {
  __typename?: 'FilteredEnterpriseSpecials';
  queryInfo?: Maybe<GqlFilteredSpecialsInfo>;
  specials?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
};

export type GqlFilteredProductSummaryResponse = {
  __typename?: 'FilteredProductSummaryResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  products?: Maybe<Array<Maybe<GqlProductSummary>>>;
};

export type GqlFilteredSpecials = {
  __typename?: 'FilteredSpecials';
  queryInfo?: Maybe<GqlFilteredSpecialsInfo>;
  specials?: Maybe<Array<Maybe<GqlSpecials>>>;
};

export type GqlFilteredSpecialsInfo = {
  __typename?: 'FilteredSpecialsInfo';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlFindLibraryProductsResponse = {
  __typename?: 'FindLibraryProductsResponse';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
};

export type GqlFontInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type GqlFontSettings = {
  __typename?: 'FontSettings';
  family: CustomFont;
};

export type GqlFontSettingsInput = {
  family: CustomFont;
};

export type GqlFonts = {
  __typename?: 'Fonts';
  body?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
};

export type GqlFraudPaymentMethod = {
  paymentType: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type GqlFundRethinkResponse = {
  __typename?: 'FundRethinkResponse';
  redirectUrl: Scalars['String']['output'];
};

export type GqlGamificationDetailItem = {
  __typename?: 'GamificationDetailItem';
  discountId?: Maybe<Scalars['Int']['output']>;
  meetsAllConstraints?: Maybe<Scalars['Boolean']['output']>;
  satisfiers?: Maybe<Array<Maybe<GqlGamificationDetailItem_Satisfier>>>;
};

export type GqlGamificationDetailItem_Satisfier = {
  __typename?: 'GamificationDetailItem_Satisfier';
  minimumThreshold?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<Maybe<GqlGamificationDetailItem_Satisfiers_Product>>>;
  thresholdMet?: Maybe<Scalars['Boolean']['output']>;
  thresholdType?: Maybe<Scalars['String']['output']>;
};

export type GqlGamificationDetailItem_Satisfiers_Product = {
  __typename?: 'GamificationDetailItem_Satisfiers_Product';
  amount?: Maybe<Scalars['Float']['output']>;
  ecommKey?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
};

export type GqlGenericExportResponse = {
  __typename?: 'GenericExportResponse';
  count?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlGenericResponse = {
  __typename?: 'GenericResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlGeoJson_Features = {
  __typename?: 'GeoJson_features';
  geometry?: Maybe<GqlGeoJson_Geometry>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlGeoJson_FeaturesInput = {
  geometry?: InputMaybe<GqlGeoJson_GeometryInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGeoJson_Geometry = {
  __typename?: 'GeoJson_geometry';
  coordinates?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlGeoJson_GeometryInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGeographicSearchBounds = {
  lat: Scalars['String']['input'];
  lon: Scalars['String']['input'];
  radius: Scalars['String']['input'];
};

export type GqlGeometryInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type GqlGetAchPaymentDetailsResponse = {
  __typename?: 'GetAchPaymentDetailsResponse';
  payment?: Maybe<GqlPayment>;
};

export type GqlGetAchPaymentFraudAssessmentsResponse = {
  __typename?: 'GetAchPaymentFraudAssessmentsResponse';
  assessments: Array<GqlAssessment>;
};

export type GqlGetCollectionProductCountConditionInput = {
  condition: Scalars['String']['input'];
  itemKey: Scalars['String']['input'];
  itemValue: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlGetCollectionProductCountInput = {
  allConditions: Scalars['Boolean']['input'];
  conditions: Array<InputMaybe<GqlGetCollectionProductCountConditionInput>>;
};

export type GqlGetOrderSortInput = {
  desc: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type GqlGetOrderType = {
  __typename?: 'GetOrderType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<GqlOrders>;
};

export type GqlGetPersonalizedProductsInput = {
  dispensaryId: Scalars['String']['input'];
  filter: GqlPersonalizedProductsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlGetPersonalizedProductsV2Input = {
  dispensaryId: Scalars['String']['input'];
  filters: GqlPersonalizedProductsFilterV2;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelName: PersonalizedProductsModelNames;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlGetRawAchBatchFileResponse = {
  __typename?: 'GetRawAchBatchFileResponse';
  data?: Maybe<GqlAchRawBatchFile>;
};

export type GqlGetSortedProductRecommendationsInput = {
  dispensaryId: Scalars['String']['input'];
  filter: GqlPersonalizedProductsFilterV2;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlGetSponsoredBrandInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  filters?: InputMaybe<GqlGetSponsoredResourceFilters>;
  inventoryId: AdInventoryId;
  maximumProducts?: InputMaybe<Scalars['Int']['input']>;
  minimumProducts?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlGetSponsoredProductsInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  filters?: InputMaybe<GqlGetSponsoredResourceFilters>;
  inventoryId: SponsoredProductsInventoryId;
  limit: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGetSponsoredResourceFilters = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  potencyCbd?: InputMaybe<GqlPotencyRange>;
  potencyThc?: InputMaybe<GqlPotencyRange>;
  strainTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGetUserStatusResponse = {
  __typename?: 'GetUserStatusResponse';
  eligible: Scalars['Boolean']['output'];
  incentive?: Maybe<GqlIncentive>;
};

export enum GlobalMenuOrder {
  popular = 'popular',
  potencyHighToLow = 'potencyHighToLow',
  potencyLowToHigh = 'potencyLowToHigh',
  priceHighToLow = 'priceHighToLow',
  priceLowToHigh = 'priceLowToHigh',
  recentlyAdded = 'recentlyAdded',
  relevance = 'relevance'
}

export type GqlGlobalReward = {
  __typename?: 'GlobalReward';
  amountOff?: Maybe<Scalars['Int']['output']>;
  discountType?: Maybe<DiscountType>;
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  percentDiscount?: Maybe<Scalars['Float']['output']>;
};

export type GqlGlobalRewardInput = {
  amountOff?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<DiscountType>;
  discountedPrice?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlGlobalThreshold = {
  __typename?: 'GlobalThreshold';
  comparisonOperator?: Maybe<ComparisonOperators>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  thresholdType?: Maybe<GlobalThresholdType>;
  weight?: Maybe<GqlWeight>;
};

export type GqlGlobalThresholdInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  thresholdType?: InputMaybe<GlobalThresholdType>;
  weight?: InputMaybe<GqlWeightInput>;
};

export enum GlobalThresholdType {
  totalPrice = 'TOTAL_PRICE',
  totalQuantity = 'TOTAL_QUANTITY',
  totalWeight = 'TOTAL_WEIGHT'
}

export type GqlGoogleProtobufTimestamp = {
  __typename?: 'GoogleProtobufTimestamp';
  nanos?: Maybe<Scalars['Int']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

export type GqlHealthCheck = {
  __typename?: 'HealthCheck';
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlHoursForOrderType = {
  effectiveHours?: InputMaybe<GqlWeeklyHoursInput>;
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlHoursSettingsForOrderType = {
  __typename?: 'HoursSettingsForOrderType';
  effectiveHours?: Maybe<GqlWeeklyHours>;
  hours?: Maybe<GqlWeeklyHours>;
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
};

export type GqlHoursSettingsForOrderTypeInput = {
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlHoursSettingsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  delivery?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlHoursSettingsForOrderTypeInput>;
};

export type GqlHypurDetails = {
  __typename?: 'HypurDetails';
  id: Scalars['String']['output'];
};

export type GqlHypurRedirect = {
  __typename?: 'HypurRedirect';
  url: Scalars['String']['output'];
};

export type GqlHypurToken = {
  __typename?: 'HypurToken';
  accessToken: Scalars['String']['output'];
  embedded: Scalars['Boolean']['output'];
};

export type GqlIpInfo = {
  __typename?: 'IPInfo';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  loc?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Scalars['String']['output']>;
  postal?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlIdImage = {
  __typename?: 'IdImage';
  key?: Maybe<Scalars['String']['output']>;
};

export type GqlIdUrl = {
  __typename?: 'IdUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlIdentityAdmin = {
  __typename?: 'IdentityAdmin';
  _id: Scalars['ID']['output'];
  chainDispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  emails: Array<Maybe<GqlUserEmails>>;
  enterpriseId?: Maybe<Scalars['ID']['output']>;
  profile: GqlIdentityAdminProfile;
  zendeskSingleSignOnToken?: Maybe<Scalars['String']['output']>;
  zendeskWidgetToken?: Maybe<Scalars['String']['output']>;
};

export type GqlIdentityAdminProfile = {
  __typename?: 'IdentityAdminProfile';
  acceptedTOS?: Maybe<Scalars['ISODateTime']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  audioNotificationsOnNewArrivalsDisabled?: Maybe<Scalars['Boolean']['output']>;
  audioNotificationsOnNewOrdersDisabled?: Maybe<Scalars['Boolean']['output']>;
  browserNotification?: Maybe<Scalars['Boolean']['output']>;
  chainID?: Maybe<Scalars['String']['output']>;
  chainId?: Maybe<Scalars['String']['output']>;
  desktopNotification?: Maybe<Scalars['Boolean']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstViewedTOS?: Maybe<Scalars['ISODateTime']['output']>;
  focusedAccounts?: Maybe<Array<GqlBrandUserFocusedAccount>>;
  fullName?: Maybe<Scalars['String']['output']>;
  isWeeklyReportEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  managedBrandIds?: Maybe<Array<Scalars['ID']['output']>>;
  parentBrandId?: Maybe<Scalars['ID']['output']>;
  permissions?: Maybe<GqlIdentityAdminProfilePermissions>;
  phone?: Maybe<Scalars['String']['output']>;
  roleAtDispensary?: Maybe<DispensaryRoles>;
  streamTokens?: Maybe<Array<Maybe<GqlDispensaryStreamToken>>>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlIdentityAdminProfilePermissions = {
  __typename?: 'IdentityAdminProfilePermissions';
  allLocations: Scalars['Boolean']['output'];
  analytics: Scalars['Boolean']['output'];
  billing: Scalars['Boolean']['output'];
  customers: Scalars['Boolean']['output'];
  dispensaryIds?: Maybe<Array<Scalars['String']['output']>>;
  driver: Scalars['Boolean']['output'];
  editBrandUsers?: Maybe<Scalars['Boolean']['output']>;
  enterpriseAdmin?: Maybe<Scalars['Boolean']['output']>;
  enterpriseSpecials?: Maybe<Scalars['Boolean']['output']>;
  manageAdCampaigns: Scalars['Boolean']['output'];
  manageAds?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use manageBrandGroup */
  manageAllBrands?: Maybe<Scalars['Boolean']['output']>;
  manageBrandGroup?: Maybe<Scalars['Boolean']['output']>;
  manageBrands?: Maybe<Scalars['Boolean']['output']>;
  managePersonalization?: Maybe<Scalars['Boolean']['output']>;
  menu: Scalars['Boolean']['output'];
  menuReview?: Maybe<Scalars['Boolean']['output']>;
  messaging: Scalars['Boolean']['output'];
  orders: Scalars['Boolean']['output'];
  promote: Scalars['Boolean']['output'];
  settings: Scalars['Boolean']['output'];
  superMenuReview?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  techSupportFeatures?: Maybe<Scalars['Boolean']['output']>;
  users: Scalars['Boolean']['output'];
};

export type GqlIdentityConsumer = {
  __typename?: 'IdentityConsumer';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  emails: Array<Maybe<GqlUserEmails>>;
  payByBankEnrollmentStatus?: Maybe<GqlShowEnrollmentResponse>;
  profile: GqlIdentityConsumerProfile;
  segmentIds: Array<Scalars['String']['output']>;
};


export type GqlIdentityConsumerSegmentIdsArgs = {
  dispensaryId: Scalars['String']['input'];
};

export type GqlIdentityConsumerProfile = {
  __typename?: 'IdentityConsumerProfile';
  address?: Maybe<GqlConsumerUserProfileAddressType>;
  birthday?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  inStoreEnrollmentCompleted?: Maybe<Scalars['Boolean']['output']>;
  isExternalUser?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<GqlConsumerUserMedicalCard>;
  phone?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlImageBanner = {
  __typename?: 'ImageBanner';
  _id: Scalars['String']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  bannerType?: Maybe<ImageBannerType>;
  connectedId?: Maybe<Scalars['String']['output']>;
  connectedStatus?: Maybe<Scalars['String']['output']>;
  connectedType?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use platforms.link instead */
  link?: Maybe<Scalars['String']['output']>;
  mobileImage: Scalars['String']['output'];
  /** @deprecated Use platforms.openInNewTab instead */
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  platforms?: Maybe<Array<Maybe<GqlImageBannerPlatform>>>;
  position: Scalars['Int']['output'];
  schedule?: Maybe<GqlSchedule>;
};

export type GqlImageBannerPlatform = {
  __typename?: 'ImageBannerPlatform';
  enabled: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  type: ImageBannerPlatformType;
};

export type GqlImageBannerPlatformInput = {
  enabled: Scalars['Boolean']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  type: ImageBannerPlatformType;
};

export enum ImageBannerPlatformType {
  iosMobileApp = 'iosMobileApp',
  kiosk = 'kiosk',
  web = 'web'
}

export enum ImageBannerType {
  category = 'category',
  collection = 'collection',
  link = 'link',
  special = 'special'
}

export enum ImageOrigin {
  admin = 'admin',
  library = 'library',
  pos = 'pos'
}

export enum ImageVariantKeyEnum {
  specialLogoImage = 'SpecialLogoImage',
  bannerImage = 'bannerImage',
  brandedDutchiePayLogoDark = 'brandedDutchiePayLogoDark',
  brandedDutchiePayLogoLight = 'brandedDutchiePayLogoLight',
  embeddedLogoImage = 'embeddedLogoImage',
  listImage = 'listImage',
  logoImage = 'logoImage'
}

export type GqlImgixSettings = {
  __typename?: 'ImgixSettings';
  border?: Maybe<Scalars['String']['output']>;
  fit?: Maybe<ImgixSettings_FitType>;
  mark?: Maybe<Scalars['String']['output']>;
  markpad?: Maybe<Scalars['Int']['output']>;
  markscale?: Maybe<Scalars['Int']['output']>;
};

export enum ImgixSettings_FitType {
  crop = 'crop',
  fill = 'fill',
  fillmax = 'fillmax'
}

export type GqlImportMenuCsvInput = {
  customFieldMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomFieldInput>>>;
  id: Scalars['String']['input'];
  menuImportData?: InputMaybe<Scalars['String']['input']>;
};

export type GqlInStorePickupOrderingSettings = GqlBaseOrderingSettings & {
  __typename?: 'InStorePickupOrderingSettings';
  checkoutMessage?: Maybe<Scalars['String']['output']>;
  enableASAPOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableAfterHoursOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledOrdering?: Maybe<Scalars['Boolean']['output']>;
  orderMinimum?: Maybe<GqlOrderMinimum>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  pickupReminders?: Maybe<GqlPickupReminders>;
  /** @deprecated replaced by v2 to remove slots from type - RTL 8/9/21 */
  scheduledOrderingConfig?: Maybe<GqlReservationOptionsForOrderType>;
  scheduledOrderingConfigV2?: Maybe<GqlScheduledOrderingConfigV2>;
};

export type GqlIncentive = {
  __typename?: 'Incentive';
  active: Scalars['Boolean']['output'];
  amountCents: Scalars['Int']['output'];
  cohortName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GqlInsightsFilterInput = {
  inventoryLevel: InventoryLevelEnum;
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  lspAccounts?: InputMaybe<Array<GqlLspAccountFilter>>;
  optInStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InsightsSortByEnum {
  excessOpportunity = 'excessOpportunity',
  gmvOpportunity = 'gmvOpportunity'
}

export type GqlInsightsSortInput = {
  sortBy?: InputMaybe<InsightsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlInstoreAnalyticsToken = {
  __typename?: 'InstoreAnalyticsToken';
  instoreAnalyticsTokenId: Scalars['String']['output'];
};

export type GqlInstoreCart = {
  __typename?: 'InstoreCart';
  currency: Scalars['String']['output'];
  discounts?: Maybe<Array<GqlSubtotalItem>>;
  fees?: Maybe<Array<GqlSubtotalItem>>;
  id: Scalars['String']['output'];
  items: Array<GqlInstoreCartItem>;
  subtotalCents: Scalars['Int']['output'];
  taxes: Array<GqlSubtotalItem>;
  tipCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export type GqlInstoreCartDataType = {
  __typename?: 'InstoreCartDataType';
  instoreCart: GqlInstoreCart;
  retailerId: Scalars['String']['output'];
  tippingDisabled: Scalars['Boolean']['output'];
};

export type GqlInstoreCartItem = {
  __typename?: 'InstoreCartItem';
  brandName: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  valueCents: Scalars['Int']['output'];
};

export type GqlIntegrations = {
  __typename?: 'Integrations';
  _id?: Maybe<Scalars['String']['output']>;
  adapter?: Maybe<Scalars['String']['output']>;
  categoryMapping?: Maybe<Array<Maybe<GqlIntegrationsCategoryMapping>>>;
  credentials?: Maybe<Scalars['JSON']['output']>;
  crmPipelineMapping?: Maybe<GqlIntegrationsPipelineMapping>;
  crmPropertyMapping?: Maybe<Array<Maybe<GqlIntegrationsPropertyMapping>>>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  failedSyncs?: Maybe<Scalars['Int']['output']>;
  fieldMapping?: Maybe<Array<Maybe<GqlIntegrationsFieldMapping>>>;
  flags?: Maybe<Scalars['JSON']['output']>;
  integrationCategory?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  isRunning?: Maybe<Scalars['Boolean']['output']>;
  kioskThresholds?: Maybe<Scalars['JSON']['output']>;
  lastImportedAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  /** @deprecated Use ISO field */
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  lastSyncAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<GqlIntegrationsMeta>;
  pending?: Maybe<Scalars['Boolean']['output']>;
  syncFailureMessage?: Maybe<Scalars['String']['output']>;
  syncFailureType?: Maybe<Scalars['String']['output']>;
  thresholds?: Maybe<Scalars['JSON']['output']>;
  types?: Maybe<Scalars['JSON']['output']>;
  weights?: Maybe<Scalars['JSON']['output']>;
};

export type GqlIntegrationsAdapterStatus = {
  __typename?: 'IntegrationsAdapterStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<IntegrationsAdapterStatusCode>;
};

export enum IntegrationsAdapterStatusCode {
  degraded = 'DEGRADED',
  down = 'DOWN',
  normal = 'NORMAL'
}

export type GqlIntegrationsCategoryMapping = {
  __typename?: 'IntegrationsCategoryMapping';
  foreignCategory?: Maybe<Scalars['String']['output']>;
  localCategory?: Maybe<Scalars['String']['output']>;
  localSubcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsCustomFieldInput = {
  foreignField?: InputMaybe<Scalars['String']['input']>;
  localField?: InputMaybe<Scalars['String']['input']>;
};

export type GqlIntegrationsCustomPropertyInput = {
  foreignProperty?: InputMaybe<Scalars['String']['input']>;
  localProperty?: InputMaybe<Scalars['String']['input']>;
};

export type GqlIntegrationsCustomTypeInput = {
  foreignCategory?: InputMaybe<Scalars['String']['input']>;
  localCategory?: InputMaybe<Scalars['String']['input']>;
  localSubcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlIntegrationsFieldMapping = {
  __typename?: 'IntegrationsFieldMapping';
  foreignField?: Maybe<Scalars['String']['output']>;
  localField?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsMeta = {
  __typename?: 'IntegrationsMeta';
  custom_types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shopifyFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlIntegrationsPipelineMapping = {
  __typename?: 'IntegrationsPipelineMapping';
  mappings?: Maybe<GqlMappingTypes>;
  pipelineId?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsPropertyMapping = {
  __typename?: 'IntegrationsPropertyMapping';
  foreignProperty?: Maybe<Scalars['String']['output']>;
  localProperty?: Maybe<Scalars['String']['output']>;
};

export type GqlIntegrationsUpdateCrmFieldsInput = {
  crmPropertyMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomPropertyInput>>>;
  id: Scalars['String']['input'];
};

export type GqlIntegrationsUpdateFieldsInput = {
  customFieldMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomFieldInput>>>;
  id: Scalars['String']['input'];
};

export type GqlIntegrationsUpdateHubspotPipelinesInput = {
  crmPipelineMapping?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
};

export type GqlIntegrationsUpdateInput = {
  adapter?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  crmPipelineMapping?: InputMaybe<Scalars['JSON']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlIntegrationsUpdateThresholdsInput = {
  id: Scalars['String']['input'];
  kioskThresholds?: InputMaybe<Scalars['JSON']['input']>;
  thresholds?: InputMaybe<Scalars['JSON']['input']>;
};

export type GqlIntegrationsUpdateTypesInput = {
  customCategoryMapping?: InputMaybe<Array<InputMaybe<GqlIntegrationsCustomTypeInput>>>;
  id: Scalars['String']['input'];
};

export enum InternalDataLoaders {
  archivedOrderLoader = 'archivedOrderLoader',
  availableReservationsLoader = 'availableReservationsLoader',
  brandLoader = 'brandLoader',
  bucketProductLoader = 'bucketProductLoader',
  chargebeeCustomerLoader = 'chargebeeCustomerLoader',
  chargebeeInvoiceLoader = 'chargebeeInvoiceLoader',
  chargebeePaymentSourceLoader = 'chargebeePaymentSourceLoader',
  chargebeePlanLoader = 'chargebeePlanLoader',
  chargebeeSubscriptionLoader = 'chargebeeSubscriptionLoader',
  collectionLoader = 'collectionLoader',
  curbsideArrivalByOrderLoader = 'curbsideArrivalByOrderLoader',
  dispensaryBillingLoader = 'dispensaryBillingLoader',
  dispensaryLoader = 'dispensaryLoader',
  integrationsByDispensaryLoader = 'integrationsByDispensaryLoader',
  libraryProductLoader = 'libraryProductLoader',
  orderLoader = 'orderLoader',
  productLoader = 'productLoader',
  strainByTerpeneLoader = 'strainByTerpeneLoader',
  strainLoader = 'strainLoader',
  terpeneByStrainLoader = 'terpeneByStrainLoader',
  userLoader = 'userLoader'
}

export enum InventoryLevelEnum {
  excess = 'excess',
  low = 'low'
}

export enum InventoryOpportunityEnum {
  high = 'High',
  low = 'Low',
  medium = 'Medium'
}

export enum InventoryStatusEnum {
  expiring = 'expiring',
  healthy = 'healthy',
  lowStock = 'lowStock',
  outOfStock = 'outOfStock',
  overStock = 'overStock'
}

export type GqlInvoice = {
  __typename?: 'Invoice';
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountPaid?: Maybe<Scalars['Int']['output']>;
  billingCycle?: Maybe<Scalars['String']['output']>;
  creditsApplied?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lineItems?: Maybe<Array<Maybe<GqlChargebeeLineItem>>>;
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type GqlIrlEvent = {
  __typename?: 'IrlEvent';
  description: Scalars['String']['output'];
  hasIncentive: Scalars['Boolean']['output'];
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  irlEventId: Scalars['ID']['output'];
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  optInRequired: Scalars['Boolean']['output'];
  shopNowUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type GqlIrlEventReward = {
  __typename?: 'IrlEventReward';
  description?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['String']['output']>;
  rewardImageUrl?: Maybe<Scalars['String']['output']>;
  rewardName?: Maybe<Scalars['String']['output']>;
  rewardType: IrlEventRewardType;
  shopNowUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GqlIrlEventRewardResponse = {
  __typename?: 'IrlEventRewardResponse';
  primary: GqlIrlEventReward;
};

export enum IrlEventRewardType {
  discount = 'discount',
  loyalty = 'loyalty',
  none = 'none'
}

export enum IrlEventTrackingEvent {
  enrolledLoyalty = 'enrolledLoyalty',
  login = 'login',
  noRewardExistingLoyaltyUser = 'noRewardExistingLoyaltyUser',
  noRewardNewLoyaltyUser = 'noRewardNewLoyaltyUser',
  noRewardNoLoyaltyUser = 'noRewardNoLoyaltyUser',
  open = 'open',
  rewardExistingLoyaltyUser = 'rewardExistingLoyaltyUser',
  rewardNewLoyaltyUser = 'rewardNewLoyaltyUser',
  rewardNoLoyaltyUser = 'rewardNoLoyaltyUser',
  shopNowClicked = 'shopNowClicked',
  signup = 'signup',
  skippedLoyalty = 'skippedLoyalty'
}

export type GqlItemDiscounts = {
  __typename?: 'ItemDiscounts';
  total?: Maybe<Scalars['Int']['output']>;
};

export type GqlItemTax = {
  __typename?: 'ItemTax';
  feeItemId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  showOnCheckout?: Maybe<Scalars['Boolean']['output']>;
  showOnMenu?: Maybe<Scalars['Boolean']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxType?: Maybe<Scalars['String']['output']>;
};

export type GqlItemTaxes = {
  __typename?: 'ItemTaxes';
  cannabis?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GqlItemsForAPrice = {
  __typename?: 'ItemsForAPrice';
  _id?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlItemsForAPriceInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlKioskInput = {
  anonymousCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  directedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fullNameOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hideEmailField?: InputMaybe<Scalars['Boolean']['input']>;
  hidePhoneField?: InputMaybe<Scalars['Boolean']['input']>;
  kioskInstructions?: InputMaybe<Scalars['String']['input']>;
  notesField?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
  phoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
  timeout?: InputMaybe<GqlKioskTimeoutInput>;
  type?: InputMaybe<KioskTypes>;
};

export type GqlKioskOrderingSettings = {
  __typename?: 'KioskOrderingSettings';
  anonymousCheckout?: Maybe<Scalars['Boolean']['output']>;
  directedOrders?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fullNameOnly?: Maybe<Scalars['Boolean']['output']>;
  hideEmailField?: Maybe<Scalars['Boolean']['output']>;
  hidePhoneField?: Maybe<Scalars['Boolean']['output']>;
  kioskInstructions?: Maybe<Scalars['String']['output']>;
  notesField?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  phoneRequired?: Maybe<Scalars['Boolean']['output']>;
  showBirthdateField?: Maybe<Scalars['Boolean']['output']>;
  timeout?: Maybe<GqlTimeoutConfig>;
  type?: Maybe<KioskTypes>;
};

export type GqlKioskTerminal = {
  __typename?: 'KioskTerminal';
  dispensaryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
};

export type GqlKioskTimeoutInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum KioskTypes {
  basic = 'BASIC',
  pro = 'PRO'
}

export type GqlLegacyCalculationResults = {
  __typename?: 'LegacyCalculationResults';
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  bottleDepositTaxExistence?: Maybe<GqlTaxExistence>;
  cannabisTax?: Maybe<Scalars['Float']['output']>;
  cannabisTaxExistence?: Maybe<GqlTaxExistence>;
  cartSubtotal?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  details?: Maybe<Array<Maybe<GqlDetailItem>>>;
  lineitems?: Maybe<Array<Maybe<GqlLineItem>>>;
  menuTotal?: Maybe<Scalars['Float']['output']>;
  mixAndMatch?: Maybe<Scalars['Float']['output']>;
  otherFees?: Maybe<Scalars['Float']['output']>;
  paymentFee?: Maybe<Scalars['Int']['output']>;
  paymentIncentives?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  receipt?: Maybe<Scalars['JSON']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  rounding?: Maybe<Scalars['Float']['output']>;
  roundupForCharityAmount?: Maybe<Scalars['Float']['output']>;
  salesTaxExistence?: Maybe<GqlTaxExistence>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tip?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type GqlLegacyCalculationsInput = {
  appliedRewards?: InputMaybe<Array<InputMaybe<GqlAppliedReward>>>;
  bypassCanadaDeliveryTax?: InputMaybe<Scalars['Boolean']['input']>;
  cart?: InputMaybe<Scalars['JSON']['input']>;
  couponValue?: InputMaybe<GqlCouponValueInput>;
  deliveryOption?: InputMaybe<Scalars['String']['input']>;
  dispensary?: InputMaybe<GqlDispensaryCalcsInput>;
  firstTimePBBUser?: InputMaybe<Scalars['Boolean']['input']>;
  manualDiscount?: InputMaybe<Scalars['Float']['input']>;
  medicalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  priceService?: InputMaybe<Scalars['String']['input']>;
  roundupForCharityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tipValue?: InputMaybe<GqlTipValueInput>;
  toMenu?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlLibraryProduct = {
  __typename?: 'LibraryProduct';
  availableForWholesale?: Maybe<Scalars['Boolean']['output']>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  cannabinoids?: Maybe<Array<GqlProducts_CannabinoidV2>>;
  caseSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbdContent?: Maybe<GqlProductPotency>;
  changeRequests?: Maybe<Array<GqlProductChangeRequest>>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<GqlUsers>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  effects?: Maybe<Scalars['JSON']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<GqlProducts_Images>>>;
  menuScore: Scalars['Float']['output'];
  minimumOrderQuantity?: Maybe<Scalars['Int']['output']>;
  msrpCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  price: Scalars['Float']['output'];
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  productBatchId?: Maybe<Scalars['ID']['output']>;
  productTemplate?: Maybe<Scalars['Boolean']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockImage?: Maybe<Scalars['String']['output']>;
  stockImageAliases?: Maybe<Scalars['String']['output']>;
  stockImageCategory?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  terpenes?: Maybe<Array<GqlProducts_Terpene>>;
  thcContent?: Maybe<GqlProductPotency>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  updatedByBrand?: Maybe<Scalars['Boolean']['output']>;
  wholesalePriceInCents?: Maybe<Scalars['Int']['output']>;
};

export type GqlLibraryProductCannabinoidsInputV2 = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cannabinoidId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlLibraryProductChangeImpactCount = {
  __typename?: 'LibraryProductChangeImpactCount';
  count?: Maybe<Scalars['Int']['output']>;
};

export type GqlLibraryProductChangeImpactResponse = {
  __typename?: 'LibraryProductChangeImpactResponse';
  totalCount?: Maybe<GqlLibraryProductChangeImpactCount>;
};

export type GqlLibraryProductLimitPerCustomerInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlLibraryProductManualInventoryInput = {
  inventory?: InputMaybe<Scalars['Int']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
};

export type GqlLibraryProductPotencyInput = {
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  unit: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum LibraryProductSortByEnum {
  brandName = 'brandName',
  category = 'category',
  connectedCount = 'connectedCount',
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  description = 'description',
  menuScore = 'menuScore',
  name = 'name',
  stateLibrary = 'stateLibrary'
}

export enum LibraryProductStatusEnum {
  active = 'Active',
  archived = 'Archived',
  inactive = 'Inactive'
}

export type GqlLibraryProductTerpenesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  terpeneId: Scalars['ID']['input'];
  unit: PotencyUnit;
  value?: InputMaybe<Scalars['Float']['input']>;
  values: Array<InputMaybe<Scalars['Float']['input']>>;
};

export type GqlLibraryProducts = {
  __typename?: 'LibraryProducts';
  libraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlLineItem = {
  __typename?: 'LineItem';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum LinkColor {
  aqua_1 = 'AQUA_1',
  aqua_2 = 'AQUA_2',
  aqua_3 = 'AQUA_3',
  blue_1 = 'BLUE_1',
  blue_2 = 'BLUE_2',
  blue_3 = 'BLUE_3',
  blue_4 = 'BLUE_4',
  blue_5 = 'BLUE_5',
  green_1 = 'GREEN_1',
  green_2 = 'GREEN_2',
  green_3 = 'GREEN_3',
  green_4 = 'GREEN_4',
  harvestBlue_1 = 'HARVEST_BLUE_1',
  orange_1 = 'ORANGE_1',
  orange_2 = 'ORANGE_2',
  orange_3 = 'ORANGE_3',
  pink_1 = 'PINK_1',
  pink_2 = 'PINK_2',
  purple_1 = 'PURPLE_1',
  purple_2 = 'PURPLE_2',
  purple_3 = 'PURPLE_3',
  purple_4 = 'PURPLE_4',
  red_1 = 'RED_1',
  red_2 = 'RED_2',
  red_3 = 'RED_3'
}

export type GqlListAccountBalancesResponse = {
  __typename?: 'ListAccountBalancesResponse';
  accountBalances: Array<GqlAccountBalance>;
};

export type GqlListAchBatchesResponse = {
  __typename?: 'ListAchBatchesResponse';
  achBatches?: Maybe<Array<GqlAchBatch>>;
};

export type GqlListAchEntriesResponse = {
  __typename?: 'ListAchEntriesResponse';
  achEntries?: Maybe<Array<GqlAchEntry>>;
};

export type GqlListAchEntriesResponseV3 = {
  __typename?: 'ListAchEntriesResponseV3';
  achEntries: Array<GqlAchEntryV2>;
};

export type GqlListAchReturnsResponse = {
  __typename?: 'ListAchReturnsResponse';
  achReturns?: Maybe<Array<GqlAchReturn>>;
};

export type GqlListAchReturnsResponseV3 = {
  __typename?: 'ListAchReturnsResponseV3';
  achReturns: Array<GqlAchReturnV2>;
};

export type GqlListAchReturnsResponseV4 = {
  __typename?: 'ListAchReturnsResponseV4';
  achReturns: Array<GqlAchReturnV4>;
};

export type GqlListAchReturnsResponseV5 = {
  __typename?: 'ListAchReturnsResponseV5';
  achReturns: Array<GqlAchReturnV5>;
};

export enum ListBrandsSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export type GqlListEntitiesResponse = {
  __typename?: 'ListEntitiesResponse';
  entities: Array<GqlEntity>;
};

export enum ListLibraryProductsSortByEnum {
  createdAt = 'createdAt',
  name = 'name'
}

export enum LoaderType {
  hasMany = 'HAS_MANY',
  hasOne = 'HAS_ONE',
  join = 'JOIN'
}

export type GqlLocationStatsProductOption = {
  __typename?: 'LocationStatsProductOption';
  price: Scalars['Float']['output'];
  weight: Scalars['String']['output'];
};

export enum LogicOperator {
  and = 'AND',
  or = 'OR'
}

export type GqlLoginAdmin = {
  __typename?: 'LoginAdmin';
  accessToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GqlIdentityAdmin>;
};

export type GqlLoginConsumer = {
  __typename?: 'LoginConsumer';
  accessToken?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  transferToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GqlIdentityConsumer>;
};

export type GqlLoyaltyMemberResponse = {
  __typename?: 'LoyaltyMemberResponse';
  isLoyaltyMember?: Maybe<Scalars['Boolean']['output']>;
  posCustomerId?: Maybe<Scalars['String']['output']>;
};

export type GqlLoyaltyPassDispensaries = {
  __typename?: 'LoyaltyPassDispensaries';
  locGlobalIds: Array<Scalars['String']['output']>;
  locIds: Array<Scalars['Int']['output']>;
  lspGlobalIds: Array<Scalars['String']['output']>;
  lspIds: Array<Scalars['Int']['output']>;
};

export type GqlLoyaltyPassToken = {
  __typename?: 'LoyaltyPassToken';
  etag?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type GqlLoyaltyPassUrl = {
  __typename?: 'LoyaltyPassUrl';
  shortUrl?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GqlLspAccount = {
  dposLspId: Scalars['String']['input'];
  dposServerRegion: Scalars['String']['input'];
};

export type GqlLspAccountFilter = {
  dposLspId: Scalars['ID']['input'];
  dposServerRegion: Scalars['String']['input'];
};

export type GqlLspBrand = {
  __typename?: 'LspBrand';
  brand: GqlBrand;
  insights: GqlLspBrandInsightsLight;
  settings?: Maybe<GqlLspBrandSettings>;
};

export type GqlLspBrandInsightsLight = {
  __typename?: 'LspBrandInsightsLight';
  totalSales: Scalars['Int']['output'];
};

export type GqlLspBrandSearchSort = {
  sortBy: LspBrandSearchSortByEnum;
  sortDirection: StringSortDirections;
};

export enum LspBrandSearchSortByEnum {
  name = 'name'
}

export type GqlLspBrandSettings = {
  __typename?: 'LspBrandSettings';
  createdAt: Scalars['ISODateTime']['output'];
  dataSharingEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlLspBrandSettingsBulkInput = {
  brandId: Scalars['String']['input'];
  settings: GqlLspBrandSettingsInput;
};

export type GqlLspBrandSettingsInput = {
  dataSharingEnabled: Scalars['Boolean']['input'];
};

export type GqlLspBrandsList = {
  __typename?: 'LspBrandsList';
  queryInfo: GqlQueryInfoType;
  results: Array<GqlLspBrand>;
};

export type GqlMxLinkStart = {
  __typename?: 'MXLinkStart';
  widgetUrl: Scalars['String']['output'];
};

export enum ManualDefaultApplyTo {
  allitems = 'ALLITEMS',
  distributed = 'DISTRIBUTED',
  justone = 'JUSTONE',
  wholeline = 'WHOLELINE'
}

export type GqlMappingTypes = {
  __typename?: 'MappingTypes';
  abandoned?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['String']['output']>;
  confirmed?: Maybe<Scalars['String']['output']>;
  inTransit?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['String']['output']>;
};

export type GqlMarkAchEntryAsReturnedResponse = {
  __typename?: 'MarkAchEntryAsReturnedResponse';
  achReturn: GqlAchReturn;
};

export type GqlMarkAchEntryAsReturnedResponseV3 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV3';
  achReturn: GqlAchReturnV2;
};

export type GqlMarkAchEntryAsReturnedResponseV4 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV4';
  achReturn: GqlAchReturnV4;
};

export type GqlMarkAchEntryAsReturnedResponseV5 = {
  __typename?: 'MarkAchEntryAsReturnedResponseV5';
  achReturn: GqlAchReturnV5;
};

export type GqlMarketingCampaignsResponse = {
  __typename?: 'MarketingCampaignsResponse';
  campaigns?: Maybe<Array<Maybe<GqlCampaignSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlMarketingCouponsResponse = {
  __typename?: 'MarketingCouponsResponse';
  coupons?: Maybe<Array<Maybe<GqlCouponSummary>>>;
  meta?: Maybe<GqlAnalyticsMeta>;
};

export type GqlMarketingDataPointsResponse = {
  __typename?: 'MarketingDataPointsResponse';
  marketingRevenue?: Maybe<Array<Maybe<GqlMarketingRevenue>>>;
  totalCampaignsCents?: Maybe<Scalars['Float']['output']>;
  totalCouponsCents?: Maybe<Scalars['Float']['output']>;
  totalRevenueCents?: Maybe<Scalars['Float']['output']>;
  totalSpecialsCents?: Maybe<Scalars['Float']['output']>;
};

export type GqlMarketingRevenue = {
  __typename?: 'MarketingRevenue';
  campaignsCents?: Maybe<Scalars['Float']['output']>;
  couponsCents?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  revenueCents?: Maybe<Scalars['Float']['output']>;
  specialsCents?: Maybe<Scalars['Float']['output']>;
};

export type GqlMarketingSpecialsResponse = {
  __typename?: 'MarketingSpecialsResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  specials?: Maybe<Array<Maybe<GqlSpecialSummary>>>;
};

export type GqlMarketplaceProduct = {
  __typename?: 'MarketplaceProduct';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['ID']['output']>;
  cannabinoids: Array<GqlNamedProductPotency>;
  category: Scalars['String']['output'];
  cbdContent?: Maybe<GqlProductPotency>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  terpenes: Array<GqlNamedProductPotency>;
  thcContent?: Maybe<GqlProductPotency>;
};

export type GqlMarketplaceProductLocation = {
  __typename?: 'MarketplaceProductLocation';
  consumerType?: Maybe<ProductConsumerType>;
  id?: Maybe<Scalars['String']['output']>;
  point: GqlMarketplaceProductLocationGeometry;
};

export type GqlMarketplaceProductLocationGeometry = {
  __typename?: 'MarketplaceProductLocationGeometry';
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
};

export type GqlMarketplaceProductLocationStats = {
  __typename?: 'MarketplaceProductLocationStats';
  marketplaceProduct: GqlMarketplaceProduct;
  nearbyStoreCount: Scalars['Int']['output'];
  options?: Maybe<Array<GqlLocationStatsProductOption>>;
};

export type GqlMarketplaceProductOption = {
  __typename?: 'MarketplaceProductOption';
  price: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  weight: Scalars['String']['output'];
};

export type GqlMarketplaceProductSearchResult = {
  __typename?: 'MarketplaceProductSearchResult';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  cbdContent?: Maybe<GqlProductPotency>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<GqlProducts_Images>>>;
  locations: Array<Maybe<GqlMarketplaceProductLocation>>;
  minPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  options: Array<Maybe<GqlMarketplaceProductOption>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stockImage?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thcContent?: Maybe<GqlProductPotency>;
  totalTerpenes?: Maybe<GqlProductPotency>;
};

export type GqlMaxReservationSlot = {
  __typename?: 'MaxReservationSlot';
  active?: Maybe<Scalars['Boolean']['output']>;
  currentCount?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['ISODate']['output']>;
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  isNextDaySlot?: Maybe<Scalars['Boolean']['output']>;
  maxOrders?: Maybe<Scalars['Int']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlMaxReservationSlotInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  currentCount?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['ISODate']['input']>;
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  maxOrders?: InputMaybe<Scalars['Int']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMaxReservationSlotsByDay = {
  __typename?: 'MaxReservationSlotsByDay';
  Friday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Monday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Saturday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Sunday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Thursday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Tuesday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  Wednesday?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
};

export type GqlMaxReservationSlotsByDayInput = {
  Friday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Monday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Saturday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Sunday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Thursday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Tuesday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  Wednesday?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
};

export type GqlMaxReservationSlotsByOrderType = {
  __typename?: 'MaxReservationSlotsByOrderType';
  curbsidePickup?: Maybe<GqlMaxReservationSlotsGroup>;
  delivery?: Maybe<GqlMaxReservationSlotsGroup>;
  driveThruPickup?: Maybe<GqlMaxReservationSlotsGroup>;
  inStorePickup?: Maybe<GqlMaxReservationSlotsGroup>;
};

export type GqlMaxReservationSlotsGroup = {
  __typename?: 'MaxReservationSlotsGroup';
  maxReservationSlotsByDate?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  maxReservationSlotsByDay?: Maybe<GqlMaxReservationSlotsByDay>;
};

export type GqlMenuCleanup = {
  __typename?: 'MenuCleanup';
  products: Array<Maybe<GqlProducts>>;
  queryInfo: GqlQueryInfoType;
};

export type GqlMenuDesignInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  menuDisplayImage?: InputMaybe<Scalars['String']['input']>;
  menuDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMenuFilterTerpene = {
  __typename?: 'MenuFilterTerpene';
  compound_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  potency_id?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
  unitSymbol: Scalars['String']['output'];
  values: Array<Scalars['Float']['output']>;
};

export type GqlMenuFilters = {
  __typename?: 'MenuFilters';
  brands: Array<Maybe<GqlBrand>>;
  categoriesSubcategories: Array<GqlCategorySubcategories>;
  effects: Array<Maybe<Scalars['String']['output']>>;
  hasProductsOnSpecial?: Maybe<Scalars['Boolean']['output']>;
  strainTypes: Array<Maybe<Scalars['String']['output']>>;
  subcategories: Array<Maybe<Scalars['String']['output']>>;
  terpenes: Array<Maybe<GqlMenuFilterTerpene>>;
  weights: Array<Maybe<Scalars['String']['output']>>;
};

export type GqlMenuOrderSetting = {
  __typename?: 'MenuOrderSetting';
  category: Scalars['String']['output'];
  menuOrder: CategoryMenuOrder;
};

export type GqlMenuScore = {
  __typename?: 'MenuScore';
  category?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlMenuSection = {
  __typename?: 'MenuSection';
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionSchedule?: Maybe<GqlSchedule>;
  dispensary: GqlDispensaries;
  dispensaryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<GqlImageBanner>;
  label: Scalars['String']['output'];
  linkLabel: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  products?: Maybe<Array<Scalars['ID']['output']>>;
  sectionName?: Maybe<Scalars['String']['output']>;
  sectionType: MenuSectionType;
  sortBy?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export enum MenuSectionType {
  brand = 'BRAND',
  category = 'CATEGORY',
  collection = 'COLLECTION',
  custom = 'CUSTOM',
  image = 'IMAGE',
  offers = 'OFFERS',
  recentlyViewed = 'RECENTLY_VIEWED',
  specials = 'SPECIALS',
  staffPicks = 'STAFF_PICKS',
  subcategory = 'SUBCATEGORY',
  topSellers = 'TOP_SELLERS'
}

export type GqlMenuSortSetting = {
  __typename?: 'MenuSortSetting';
  brands?: Maybe<Array<Scalars['String']['output']>>;
  category: Scalars['String']['output'];
  menuOrder: Scalars['String']['output'];
};

export type GqlMenuSortSettingInput = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  category: Scalars['String']['input'];
  menuOrder: Scalars['String']['input'];
};

export enum MenuTypes {
  both = 'both',
  medical = 'medical',
  recreational = 'recreational'
}

export enum MenuViewStyles {
  cards = 'cards',
  list = 'list'
}

export type GqlMeta = {
  __typename?: 'Meta';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GqlMobileCustomization = {
  __typename?: 'MobileCustomization';
  bottomBarActiveColor?: Maybe<Scalars['String']['output']>;
  bottomBarBackgroundColor?: Maybe<Scalars['String']['output']>;
  bottomBarInactiveColor?: Maybe<Scalars['String']['output']>;
  headerBackgroundColor?: Maybe<Scalars['String']['output']>;
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  tabLabels?: Maybe<GqlMobileCustomizationTabLabels>;
};

export type GqlMobileCustomizationInput = {
  bottomBarActiveColor?: InputMaybe<Scalars['String']['input']>;
  bottomBarBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  bottomBarInactiveColor?: InputMaybe<Scalars['String']['input']>;
  headerBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  tabLabels?: InputMaybe<GqlMobileCustomizationTabLabelsInput>;
};

export type GqlMobileCustomizationTabLabels = {
  __typename?: 'MobileCustomizationTabLabels';
  account?: Maybe<Scalars['String']['output']>;
  cart?: Maybe<Scalars['String']['output']>;
  pay?: Maybe<Scalars['String']['output']>;
  shop?: Maybe<Scalars['String']['output']>;
  specials?: Maybe<Scalars['String']['output']>;
};

export type GqlMobileCustomizationTabLabelsInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  cart?: InputMaybe<Scalars['String']['input']>;
  pay?: InputMaybe<Scalars['String']['input']>;
  shop?: InputMaybe<Scalars['String']['input']>;
  specials?: InputMaybe<Scalars['String']['input']>;
};

export enum Modules {
  fraud = 'fraud',
  incentives = 'incentives',
  paymentProcessing = 'paymentProcessing',
  reporting = 'reporting'
}

export type GqlMonerisCard = {
  __typename?: 'MonerisCard';
  brand?: Maybe<Scalars['String']['output']>;
  lastDigits?: Maybe<Scalars['String']['output']>;
};

export type GqlMonerisDetails = {
  __typename?: 'MonerisDetails';
  card: GqlMonerisCard;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionNumber: Scalars['String']['output'];
};

export type GqlMonerisHtProfileCredentials = GqlCheckoutCredentialsBase & {
  __typename?: 'MonerisHTProfileCredentials';
  adapter: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
};

export type GqlMonerisTokenizationProfile = {
  __typename?: 'MonerisTokenizationProfile';
  profileId: Scalars['String']['output'];
};

export type GqlMongoProduct = {
  __typename?: 'MongoProduct';
  id: Scalars['ID']['output'];
};

export type GqlMutation = {
  __typename?: 'Mutation';
  acceptBrandPortalTos?: Maybe<GqlGenericResponse>;
  acceptTermsOfService?: Maybe<GqlGenericResponse>;
  activateBankAccount?: Maybe<GqlActivateBankAccountResponse>;
  /** @deprecated Use activatePaymentMethodV2 */
  activatePaymentMethod: GqlGenericResponse;
  activatePaymentMethodV2: GqlActivatePaymentMethodResponse;
  activatePrinter: GqlGenericResponse;
  addBankPaymentMethodV2?: Maybe<GqlGenericResponse>;
  addCustomerToOrder?: Maybe<GqlOrderUpdated>;
  addDispensaryCustomer?: Maybe<GqlGenericResponse>;
  addPaymentMethodV2?: Maybe<GqlGenericResponse>;
  addSubscriptionToChain?: Maybe<GqlGenericResponse>;
  approveInstoreCart?: Maybe<GqlApproveInstoreCartResponse>;
  archiveOrder?: Maybe<GqlGenericResponse>;
  archiveProduct?: Maybe<GqlProducts>;
  brandPortalSecureUpload?: Maybe<GqlIdImage>;
  bulkCreateLspBrandSettings: Array<Maybe<GqlLspBrandSettings>>;
  bulkEndSpecialsV2?: Maybe<GqlGenericResponse>;
  bulkLibraryProductDelete?: Maybe<GqlGenericResponse>;
  bulkLibraryProductRestore?: Maybe<GqlGenericResponse>;
  bulkLibraryProductUpdate?: Maybe<GqlBulkLibraryProductUpdateResponse>;
  bulkLibraryProductUpload?: Maybe<GqlBulkLibraryProductUploadResponse>;
  bulkUpdateMenuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  changeRequestApproveProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestCreateProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestDeleteProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestLockProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestRejectProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestUnlockProduct?: Maybe<GqlProductChangeRequest>;
  changeRequestUpdateProduct?: Maybe<GqlProductChangeRequest>;
  checkInBucketV2?: Maybe<GqlBucket>;
  /** @deprecated Use checkOutBucketV3 mutation */
  checkOutBucketV2: GqlBucket;
  checkOutBucketV3: GqlBucketV2;
  claimPublicContextSessionByPhone?: Maybe<GqlPublicContextSession>;
  clearAdsInspectorEvents: GqlGenericResponse;
  clearAllCurbsideArrivals: GqlGenericResponse;
  clearAllFeatureFlagOverrides?: Maybe<GqlGenericResponse>;
  clearCurbsideArrival: GqlGenericResponse;
  closeBucket: GqlBucket;
  completeAggregatorLink: GqlCompleteAggregatorLinkResponse;
  computeWithPriceCartV2?: Maybe<GqlCalculationResults>;
  connectDeviceV2?: Maybe<GqlDeviceConnection>;
  connectProduct?: Maybe<GqlGenericResponse>;
  connectProductPreview?: Maybe<GqlConnectProductPreviewResponse>;
  consumeDeviceAccessCode?: Maybe<GqlDeviceAccessCode>;
  consumerSignup?: Maybe<GqlLoginConsumer>;
  copyLibraryProduct?: Maybe<GqlCopyLibraryProductResponse>;
  copyToLocations?: Maybe<GqlCopyToLocationsResponse>;
  /** @deprecated Use createAlpineUserV2 */
  createAlpineUser?: Maybe<GqlRewardUserResponse>;
  createAlpineUserV2?: Maybe<GqlRewardUserResponse>;
  createBackInStockSubscription?: Maybe<GqlGenericResponse>;
  createBankAccount?: Maybe<GqlCreateBankAccountResponse>;
  createBillingGroup?: Maybe<GqlGenericResponse>;
  createBrandEnterpriseSettings: Array<GqlBrandEnterpriseSetting>;
  createBrandFundedDiscount: GqlBrandFundedDiscount;
  createBrandUser?: Maybe<GqlBrandUser>;
  createBrandV2?: Maybe<GqlBrand>;
  createBucketForLibraryItem: GqlBucket;
  /** @deprecated Use createBucketV3 mutation */
  createBucketV2: GqlBucket;
  createBucketV3: GqlBucket;
  createCheckout?: Maybe<GqlCheckout>;
  createCollection: GqlCollection;
  createCouponV2?: Maybe<GqlCoupons>;
  createDeviceAccessCode?: Maybe<GqlDeviceAccessCode>;
  createDutchiePosLoyaltyMember?: Maybe<GqlRewardUserResponse>;
  createDutchiePosLoyaltyMemberV2?: Maybe<GqlLoyaltyMemberResponse>;
  createEnterpriseDutchiePosLoyaltyMember?: Maybe<GqlGenericResponse>;
  createEnterpriseDutchiePosLoyaltyMemberV2?: Maybe<GqlLoyaltyMemberResponse>;
  createEnterpriseLoyaltySettings?: Maybe<GqlEnterpriseLoyaltySettings>;
  createEnterpriseSpecialV2?: Maybe<GqlGenericResponse>;
  createEnterpriseSpecialsSettings?: Maybe<GqlGenericResponse>;
  createFraudAccount?: Maybe<GqlCreateFraudAccountResponse>;
  createInstoreCartUrl?: Maybe<GqlCreateInstoreCartUrlResponse>;
  createIntegration?: Maybe<GqlIntegrations>;
  createLibraryProduct?: Maybe<GqlProducts>;
  createLibraryProductV2?: Maybe<GqlLibraryProduct>;
  createLibraryProductV3?: Maybe<GqlLibraryProduct>;
  createLoyaltyPassToken?: Maybe<GqlLoyaltyPassToken>;
  /** @deprecated Use getLoyaltyPassUrl instead for default client caching */
  createLoyaltyPassUrl?: Maybe<GqlLoyaltyPassUrl>;
  createLspBrandSettings: GqlLspBrandSettings;
  createMenuSection?: Maybe<GqlMenuSection>;
  createMxEnrollment?: Maybe<GqlCreateMxEnrollmentResponse>;
  /** @deprecated Use createOrUpdateAchReturnV5 */
  createOrUpdateAchReturn?: Maybe<GqlCreateOrUpdateAchReturnResponse>;
  createOrUpdateAchReturnV5?: Maybe<GqlCreateOrUpdateAchReturnResponseV5>;
  /** @deprecated Use createOrUpdateAchReturnV5 */
  createOrUpdateAchReturnv4?: Maybe<GqlCreateOrUpdateAchReturnResponseV4>;
  createOrderV2?: Maybe<GqlCreateOrderResponse>;
  createOrderingSuspensionV2?: Maybe<GqlOrderingSuspension>;
  createPOSMedUser?: Maybe<GqlGenericResponse>;
  createPayment?: Maybe<GqlCreatePaymentResponse>;
  createPlusApiKeyV2?: Maybe<GqlPlusApiKey>;
  createPlusEnterpriseApiKey?: Maybe<GqlPlusApiKey>;
  createPointsBoost?: Maybe<GqlGenericResponse>;
  createPrintJob: GqlCreatePrintJobResponse;
  createProduct?: Maybe<GqlProducts>;
  createPublicContextSession?: Maybe<GqlPublicContextSession>;
  createRedemption?: Maybe<GqlRedemption>;
  createReservationSlots?: Maybe<GqlGenericResponse>;
  createRetailerEnrollment?: Maybe<GqlCreateRetailerEnrollmentResponse>;
  createSpecialV3?: Maybe<GqlSpecials>;
  createSpringbigUser?: Maybe<GqlRewardUserResponse>;
  createStrainV2?: Maybe<GqlStrain>;
  createTerpeneV2?: Maybe<GqlTerpene>;
  createUser?: Maybe<GqlUsers>;
  crossingMindsLogin?: Maybe<GqlCrossingMindsAuthResponse>;
  deleteAccount: GqlDeleteAccountResponse;
  deleteBackInStockSubscription?: Maybe<GqlGenericResponse>;
  deleteBrand?: Maybe<GqlBrand>;
  deleteCollection?: Maybe<GqlGenericResponse>;
  deleteCoupon?: Maybe<GqlGenericResponse>;
  deleteCouponV2?: Maybe<GqlGenericResponse>;
  deleteDeviceV2?: Maybe<GqlDevices>;
  deleteEnterpriseSpecial?: Maybe<GqlGenericResponse>;
  deleteLibraryProduct?: Maybe<GqlLibraryProduct>;
  deletePrinter: GqlGenericResponse;
  deleteSpecialHours?: Maybe<GqlGenericResponse>;
  deleteSpecialV2?: Maybe<GqlSpecials>;
  deleteStrain?: Maybe<GqlStrain>;
  deleteSubscription?: Maybe<GqlGenericResponse>;
  deleteTerpene?: Maybe<GqlTerpene>;
  deleteUser?: Maybe<GqlUsers>;
  destroyMenuSection?: Maybe<GqlGenericResponse>;
  deviceHeartbeat?: Maybe<GqlGenericResponse>;
  disconnectBankAccount?: Maybe<GqlDisconnectBankAccountResponse>;
  /** Disconnect a dispensary product from its library product & mark the bucket product as disconnected */
  disconnectBucketProduct?: Maybe<GqlGenericResponse>;
  /** Disconnect a product from its library product */
  disconnectProduct?: Maybe<GqlGenericResponse>;
  dispensaryDemoRequest?: Maybe<GqlGenericResponse>;
  dispensaryOnboarding?: Maybe<GqlGenericResponse>;
  dispensaryRemoveFromChain?: Maybe<GqlGenericResponse>;
  dispensaryUpdate?: Maybe<GqlGenericResponse>;
  dispensaryUpdateHoursSettings?: Maybe<GqlGenericResponse>;
  dispensaryUpdateOptionsSettings?: Maybe<GqlGenericResponse>;
  dispensaryUpdateStatus?: Maybe<GqlGenericResponse>;
  dispensaryUpdateTaxConfiguration?: Maybe<GqlGenericResponse>;
  dispensaryUploadOnboardingAsset?: Maybe<GqlDispensaryAssetUploadResponse>;
  editCustomerV2?: Maybe<GqlGenericResponse>;
  emailIntegrationCredentials?: Maybe<GqlGenericResponse>;
  endEnterpriseSpecial?: Maybe<GqlGenericResponse>;
  endOrderingSuspensionV2?: Maybe<GqlOrderingSuspension>;
  endSpecialV2: GqlSpecials;
  expirePlusApiKey?: Maybe<GqlPlusApiKey>;
  expirePlusEnterpriseApiKey?: Maybe<GqlPlusApiKey>;
  exportCouponsSummaries?: Maybe<GqlGenericResponse>;
  exportCustomerReport?: Maybe<GqlGenericExportResponse>;
  exportDispensaryCustomers?: Maybe<GqlGenericResponse>;
  exportFilteredBrandsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCampaignsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCartsSummaries?: Maybe<GqlGenericResponse>;
  exportFilteredCatalog: GqlExportFilteredCatalogResponse;
  exportFilteredProductSummaries?: Maybe<GqlGenericResponse>;
  exportOrderReport?: Maybe<GqlGenericExportResponse>;
  exportOrders?: Maybe<GqlGenericResponse>;
  exportSpecialsSummaries?: Maybe<GqlGenericResponse>;
  findOrCreateReferralCode?: Maybe<GqlReferralCode>;
  forceDiscountSync?: Maybe<GqlGenericResponse>;
  generateDispensaryUserStreamToken?: Maybe<GqlDispensaryStreamToken>;
  generateHypurRedirectV3?: Maybe<GqlHypurRedirect>;
  generateHypurTokenV2?: Maybe<GqlHypurToken>;
  importCustomerCSV?: Maybe<GqlGenericResponse>;
  importDeliveryZipCodes?: Maybe<GqlGenericResponse>;
  importMenuCSV?: Maybe<GqlGenericResponse>;
  incrementClicks?: Maybe<GqlGenericResponse>;
  /** @deprecated Use integrationsDeleteInArma */
  integrationsDelete?: Maybe<GqlGenericResponse>;
  integrationsDeleteInArma?: Maybe<GqlGenericResponse>;
  integrationsForceSyncInArma?: Maybe<GqlGenericResponse>;
  integrationsSuggestion?: Maybe<GqlGenericResponse>;
  /** @deprecated Use updateIntegration */
  integrationsUpdate?: Maybe<GqlGenericResponse>;
  integrationsUpdateCrmFields?: Maybe<GqlGenericResponse>;
  integrationsUpdateFields?: Maybe<GqlGenericResponse>;
  integrationsUpdateHubspotPipelines?: Maybe<GqlGenericResponse>;
  integrationsUpdateThresholds?: Maybe<GqlGenericResponse>;
  integrationsUpdateTypes?: Maybe<GqlGenericResponse>;
  /** @deprecated Use integrationsWipeMenuInArma */
  integrationsWipeMenu?: Maybe<GqlGenericResponse>;
  integrationsWipeMenuInArma?: Maybe<GqlGenericResponse>;
  libraryProductChangeImpact?: Maybe<GqlProductImpactResponse>;
  libraryProductChangeImpactV3?: Maybe<GqlLibraryProductChangeImpactResponse>;
  logAnalyticsPayload?: Maybe<GqlGenericResponse>;
  loginAdmin?: Maybe<GqlLoginAdmin>;
  loginAdminViaToken?: Maybe<GqlLoginAdmin>;
  loginConsumer?: Maybe<GqlLoginConsumer>;
  logout?: Maybe<GqlGenericResponse>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturned?: Maybe<GqlMarkAchEntryAsReturnedResponse>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturnedV3?: Maybe<GqlMarkAchEntryAsReturnedResponseV3>;
  /** @deprecated Use markAchEntryAsReturnedV5 */
  markAchEntryAsReturnedV4?: Maybe<GqlMarkAchEntryAsReturnedResponseV4>;
  markAchEntryAsReturnedV5?: Maybe<GqlMarkAchEntryAsReturnedResponseV5>;
  markCurbsideArrivalArrivedV2: GqlCurbsideArrival;
  markOrderAutoPrinted?: Maybe<GqlGenericResponse>;
  markOrderPOSFailed?: Maybe<GqlOrderUpdated>;
  markOrderPrinted?: Maybe<GqlGenericResponse>;
  markOrdersBatchPrinted?: Maybe<GqlGenericResponse>;
  mergeBrand?: Maybe<GqlBrand>;
  mergeBrands?: Maybe<GqlGenericResponse>;
  /** @deprecated Use parseAchReturnFileUploadV2 */
  parseAchReturnFileUpload?: Maybe<GqlParseAchReturnFileUploadResponse>;
  parseAchReturnFileUploadV2?: Maybe<GqlParseAchReturnFileUploadResponse>;
  pauseSubscription?: Maybe<GqlGenericResponse>;
  persistCheckout?: Maybe<GqlGenericResponse>;
  persistCheckoutV2?: Maybe<GqlPersistCheckoutResponse>;
  printOrderOnTerminal?: Maybe<GqlOrderPrinted>;
  recordUserAcceptance?: Maybe<GqlRecordUserAcceptanceResponse>;
  rejectReasons: Array<RejectionReasons>;
  removeCategoryMenuOrder: GqlGenericResponse;
  removeItem?: Maybe<GqlCheckout>;
  removeSubscriptionFromChain?: Maybe<GqlGenericResponse>;
  reopenOrder?: Maybe<GqlGenericResponse>;
  resetPasswordV2?: Maybe<GqlGenericResponse>;
  /** @deprecated Use createOrUpdateAchReturnV4 */
  respondToAchReturn?: Maybe<GqlRespondToAchReturnResponse>;
  resumeSubscription?: Maybe<GqlGenericResponse>;
  reversePayment?: Maybe<GqlReversePaymentResponse>;
  reverseSettlement?: Maybe<GqlReverseSettlementResponse>;
  revertBrandMerge?: Maybe<GqlBrandMergeHistory>;
  runChainBillingMigration?: Maybe<GqlChainBillingReturn>;
  saveCustomNavigation?: Maybe<GqlCustomNavigation>;
  sendBrandUserPasswordResetEmail?: Maybe<GqlGenericResponse>;
  sendCompleteAccountSetupEmail?: Maybe<GqlGenericResponse>;
  sendLoginCode?: Maybe<GqlGenericResponse>;
  sendPasswordResetEmailV2?: Maybe<GqlGenericResponse>;
  /** @deprecated Account verification feature has been sunset. */
  sendVerificationToken?: Maybe<GqlGenericResponse>;
  serverSideCalculations?: Maybe<GqlLegacyCalculationResults>;
  setCategoryFeaturedBrands: GqlGenericResponse;
  setCategoryFeaturedProducts: GqlGenericResponse;
  setCategoryMenuOrder: GqlGenericResponse;
  setFeatureFlagOverride?: Maybe<GqlGenericResponse>;
  setGlobalMenuOrder: GqlGenericResponse;
  setPasswordV2?: Maybe<GqlGenericResponse>;
  setViewedTermsOfService?: Maybe<GqlGenericResponse>;
  setupBillingV2?: Maybe<GqlGenericResponse>;
  setupRetailerBankPaymentMethod?: Maybe<GqlGenericResponse>;
  setupRetailerBilling?: Maybe<GqlGenericResponse>;
  setupRetailerCreditPaymentMethod?: Maybe<GqlGenericResponse>;
  /** @deprecated Moving to V2 for skip reasons change */
  skipBucketProduct: GqlGenericResponse;
  skipBucketProductV2: GqlGenericResponse;
  sortMenuSections?: Maybe<GqlGenericResponse>;
  speculativeProductUpdate?: Maybe<GqlProducts>;
  startPreAuthCheck?: Maybe<GqlStartPreAuthCheckResponse>;
  trackIrlEvent?: Maybe<GqlGenericResponse>;
  trackIrlEventByDispensary?: Maybe<GqlGenericResponse>;
  unarchiveOrder?: Maybe<GqlGenericResponse>;
  unenrollPayByBankUser: GqlUnenrollEnrollmentResponse;
  unsubscribeDispensaryCustomers?: Maybe<GqlGenericResponse>;
  updateAutoPrintDevicesV2?: Maybe<GqlGenericResponse>;
  updateBillingGroup?: Maybe<GqlGenericResponse>;
  updateBillingNotifications?: Maybe<GqlGenericResponse>;
  updateBrandCollision?: Maybe<GqlBrandCollision>;
  updateBrandEnterpriseSetting: GqlBrandEnterpriseSetting;
  updateBrandFundedDiscount: GqlBrandFundedDiscount;
  updateBrandImportHistoryName: GqlBrandImportHistoryDetailResponse;
  updateBrandUser?: Maybe<GqlBrandUser>;
  updateBrandUserAccount?: Maybe<GqlBrandUserAccount>;
  updateBrandV2?: Maybe<GqlBrand>;
  updateChainDispensariesImage?: Maybe<GqlGenericResponse>;
  updateChangeRequestCreateProduct?: Maybe<GqlProductChangeRequest>;
  updateChangeRequestUpdateProduct?: Maybe<GqlProductChangeRequest>;
  updateChargebeeSubscription?: Maybe<GqlGenericResponse>;
  updateCheckout?: Maybe<GqlCheckout>;
  updateCname?: Maybe<GqlGenericResponse>;
  updateCollection: GqlCollection;
  updateCollectionPositions: Array<GqlCollection>;
  updateConsumerUser?: Maybe<GqlGenericResponse>;
  updateCoupon?: Maybe<GqlCoupons>;
  updateCurbsideArrivalV2?: Maybe<GqlCurbsideArrival>;
  updateCustomerCommunicationSettings?: Maybe<GqlPreferenceSettingsResponse>;
  updateCustomerSubscription?: Maybe<GqlGenericResponse>;
  updateDevice?: Maybe<GqlDevices>;
  updateDispensaryAdSettings?: Maybe<GqlGenericResponse>;
  updateDispensaryCustomer?: Maybe<GqlGenericResponse>;
  updateDispensaryPersonalizationSettings?: Maybe<GqlGenericResponse>;
  updateDutchiePosLoyaltyMember?: Maybe<GqlGenericResponse>;
  updateEmail?: Maybe<GqlGenericResponse>;
  updateEmailV2?: Maybe<GqlGenericResponse>;
  updateEnterpriseAdSettings?: Maybe<GqlUpdateEnterpriseAdSettingsResponse>;
  updateEnterpriseLoyaltySettings?: Maybe<GqlEnterpriseLoyaltySettings>;
  updateEnterpriseMobileAppSettings?: Maybe<GqlEnterpriseMobileAppSettings>;
  updateEnterprisePersonalizationSettings?: Maybe<GqlUpdateEnterprisePersonalizationSettingsResponse>;
  updateEnterpriseSpecialV2?: Maybe<GqlGenericResponse>;
  updateEnterpriseSpecialsSettings?: Maybe<GqlGenericResponse>;
  updateEnterpriseWebCustomizationSettingsV2?: Maybe<GqlGenericResponse>;
  updateHoursSettings?: Maybe<GqlGenericResponse>;
  updateImageBanners?: Maybe<GqlGenericResponse>;
  updateIntegration?: Maybe<GqlIntegrations>;
  updateKioskOrderPayment?: Maybe<GqlGenericResponse>;
  updateLibraryProduct?: Maybe<GqlUpdateLibraryProductResponse>;
  updateMenuSection?: Maybe<GqlMenuSection>;
  updateOrderStatus?: Maybe<GqlOrders>;
  updateOrderV2?: Maybe<GqlOrders>;
  updateOrderingSettings?: Maybe<GqlGenericResponse>;
  updatePasswordV2?: Maybe<GqlPasswordUpdate>;
  updatePlusOAuthProvider: GqlPlusOAuthProvider;
  updatePrinter: GqlGenericResponse;
  updateProduct?: Maybe<GqlProducts>;
  /** @deprecated Use setCategoryMenuOrder, setCategoryMenuOrderCustom, or setCategoryMenuOrderBrand mutations instead. This mutation has ambiguous behavior and mixes multiple responsibilities. */
  updateProductSort?: Maybe<GqlGenericResponse>;
  updateProductStatus?: Maybe<GqlProducts>;
  updateProfileV2?: Maybe<GqlGenericResponse>;
  updatePublicContextSession?: Maybe<GqlPublicContextSession>;
  updatePushNotificationToken?: Maybe<GqlGenericResponse>;
  updateQuantity?: Maybe<GqlCheckout>;
  updateRemoteExtensions?: Maybe<GqlGenericResponse>;
  updateReservationSlots?: Maybe<GqlGenericResponse>;
  updateSeoSettings?: Maybe<GqlGenericResponse>;
  updateSingleDispensaryAdSettings?: Maybe<GqlUpdateSingleDispensaryAdSettingsResponse>;
  updateSingleDispensaryPersonalizationSettings?: Maybe<GqlUpdateSingleDispensaryPersonalizationSettingsResponse>;
  updateSpecialMenuDesign?: Maybe<GqlGenericResponse>;
  updateSpecialV3?: Maybe<GqlSpecials>;
  updateSpecialsSortOrder?: Maybe<GqlGenericResponse>;
  updateStrainV2?: Maybe<GqlStrain>;
  updateSubscriptionBillingPeriod?: Maybe<GqlGenericResponse>;
  updateSubscriptionManualPayments?: Maybe<GqlGenericResponse>;
  updateSubscriptionPrice?: Maybe<GqlGenericResponse>;
  updateSubscriptionTrial?: Maybe<GqlGenericResponse>;
  updateTerpeneV2?: Maybe<GqlTerpene>;
  updateTextSetting?: Maybe<GqlGenericResponse>;
  updateUser?: Maybe<GqlUsers>;
  updateUserEmail?: Maybe<GqlGenericResponse>;
  updateUserPermissions?: Maybe<GqlGenericResponse>;
  updateUserRoleV2?: Maybe<GqlGenericResponse>;
  updateWebCustomizationSettings?: Maybe<GqlGenericResponse>;
  updateWebCustomizationSettingsV2?: Maybe<GqlGenericResponse>;
  uploadBrandFundedDiscountImage: GqlBrandFundedDiscountImageUpload;
  uploadCsvImport: GqlBrandImportHistoryUploadResponse;
  uploadImage?: Maybe<GqlImageUrl>;
  uploadSecureImage?: Maybe<GqlIdImage>;
  upsertPurchaseOrder: GqlPurchaseOrderDetail;
  /** @deprecated Account verification feature has been sunset. */
  validateVerificationToken?: Maybe<GqlGenericResponse>;
  verifyBucketProducts: GqlGenericResponse;
  verifyLoginCode?: Maybe<GqlVerifyLoginCodeResponse>;
};


export type GqlMutationAcceptBrandPortalTosArgs = {
  resetToken: Scalars['String']['input'];
};


export type GqlMutationActivateBankAccountArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationActivatePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationActivatePaymentMethodV2Args = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationActivatePrinterArgs = {
  deviceIdentifier: Scalars['String']['input'];
};


export type GqlMutationAddBankPaymentMethodV2Args = {
  accountId: Scalars['String']['input'];
  chargebeeCustomerId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};


export type GqlMutationAddCustomerToOrderArgs = {
  input?: InputMaybe<GqlAddCustomerToOrderInput>;
};


export type GqlMutationAddDispensaryCustomerArgs = {
  customer: GqlDispensaryCustomerInput;
};


export type GqlMutationAddPaymentMethodV2Args = {
  chargebeeCustomerId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type GqlMutationAddSubscriptionToChainArgs = {
  chargebeeCustomerId: Scalars['String']['input'];
  dispensaryIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type GqlMutationApproveInstoreCartArgs = {
  instoreCartId: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  tipCents: Scalars['Int']['input'];
};


export type GqlMutationArchiveOrderArgs = {
  input: GqlArchiveOrderInput;
};


export type GqlMutationArchiveProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationBrandPortalSecureUploadArgs = {
  brandId: Scalars['ID']['input'];
  encoding?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['String']['input'];
  mime?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationBulkCreateLspBrandSettingsArgs = {
  updates: Array<GqlLspBrandSettingsBulkInput>;
};


export type GqlMutationBulkEndSpecialsV2Args = {
  input: GqlEndSpecialsInput;
};


export type GqlMutationBulkLibraryProductDeleteArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlMutationBulkLibraryProductRestoreArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlMutationBulkLibraryProductUpdateArgs = {
  libraryProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updates: GqlBulkLibraryProductUpdates;
};


export type GqlMutationBulkLibraryProductUploadArgs = {
  s3Key: Scalars['String']['input'];
};


export type GqlMutationBulkUpdateMenuSectionsArgs = {
  deletes?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispensaryId: Scalars['String']['input'];
  menuSections?: InputMaybe<Array<GqlMenuSectionBulkUpdateInput>>;
};


export type GqlMutationChangeRequestApproveProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationChangeRequestCreateProductArgs = {
  brandId: Scalars['String']['input'];
  complianceRegionId: Scalars['String']['input'];
  contentAttributes: GqlUpdatedLibraryProduct;
};


export type GqlMutationChangeRequestDeleteProductArgs = {
  productId: Scalars['String']['input'];
};


export type GqlMutationChangeRequestLockProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationChangeRequestRejectProductArgs = {
  feedback: Scalars['String']['input'];
  id: Scalars['String']['input'];
  rejectionReasons: Array<RejectionReasons>;
};


export type GqlMutationChangeRequestUnlockProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationChangeRequestUpdateProductArgs = {
  contentAttributes: GqlUpdatedLibraryProduct;
  productId: Scalars['String']['input'];
};


export type GqlMutationCheckInBucketV2Args = {
  uuid: Scalars['String']['input'];
};


export type GqlMutationCheckOutBucketV2Args = {
  bucketId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type GqlMutationCheckOutBucketV3Args = {
  bucketId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type GqlMutationClaimPublicContextSessionByPhoneArgs = {
  id: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type GqlMutationClearAdsInspectorEventsArgs = {
  input: GqlAdsInspectorEventsInput;
};


export type GqlMutationClearAllCurbsideArrivalsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationClearCurbsideArrivalArgs = {
  arrivalId: Scalars['String']['input'];
};


export type GqlMutationCloseBucketArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationCompleteAggregatorLinkArgs = {
  aggregator: Scalars['String']['input'];
  aggregatorToken: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  plaid?: InputMaybe<GqlPlaidLinkMetadata>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationComputeWithPriceCartV2Args = {
  input: GqlCalculationsInput;
};


export type GqlMutationConnectDeviceV2Args = {
  connectionToken: Scalars['String']['input'];
};


export type GqlMutationConnectProductArgs = {
  id: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
  omitFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GqlMutationConnectProductPreviewArgs = {
  id: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
};


export type GqlMutationConsumeDeviceAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationConsumerSignupArgs = {
  input: GqlConsumerSignupInput;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCopyLibraryProductArgs = {
  id: Scalars['String']['input'];
  stateLibraryIds: Array<Scalars['String']['input']>;
};


export type GqlMutationCopyToLocationsArgs = {
  dispensaryId: Scalars['String']['input'];
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  enterpriseId: Scalars['ID']['input'];
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  itemId: Scalars['String']['input'];
  klass: Scalars['String']['input'];
};


export type GqlMutationCreateAlpineUserArgs = {
  acceptedTerms: Scalars['Boolean']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  favoriteStore: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  program: Scalars['String']['input'];
};


export type GqlMutationCreateAlpineUserV2Args = {
  acceptedTerms: Scalars['Boolean']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  favoriteStore: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  program: Scalars['String']['input'];
};


export type GqlMutationCreateBackInStockSubscriptionArgs = {
  productId: Scalars['String']['input'];
};


export type GqlMutationCreateBankAccountArgs = {
  adapter: Scalars['String']['input'];
  aggregatorToken: Scalars['String']['input'];
  billingAddressId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateBillingGroupArgs = {
  billingGroup: GqlCreateBillingGroupInput;
};


export type GqlMutationCreateBrandEnterpriseSettingsArgs = {
  brandId: Scalars['String']['input'];
  settings: Array<GqlBrandEnterpriseSettingsInput>;
};


export type GqlMutationCreateBrandFundedDiscountArgs = {
  input?: InputMaybe<GqlBrandFundedDiscountInput>;
};


export type GqlMutationCreateBrandUserArgs = {
  updates: GqlBrandUserCreateInput;
};


export type GqlMutationCreateBrandV2Args = {
  brand: GqlBrandInput;
};


export type GqlMutationCreateBucketForLibraryItemArgs = {
  libraryItemId: Scalars['ID']['input'];
};


export type GqlMutationCreateBucketV2Args = {
  bucket: GqlCreateBucketInput;
};


export type GqlMutationCreateBucketV3Args = {
  bucket: GqlCreateBucketInputV3;
};


export type GqlMutationCreateCheckoutArgs = {
  cart: Array<GqlCreateCheckoutInputCartItem>;
  dispensaryId: Scalars['String']['input'];
  orderType: ReservationSlotTypes;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  pricingType: CustomerType;
};


export type GqlMutationCreateCollectionArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateCollectionInput;
};


export type GqlMutationCreateCouponV2Args = {
  coupon: GqlCreateCouponInput;
};


export type GqlMutationCreateDutchiePosLoyaltyMemberArgs = {
  dispensaryId: Scalars['String']['input'];
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateDutchiePosLoyaltyMemberV2Args = {
  dispensaryId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateEnterpriseDutchiePosLoyaltyMemberArgs = {
  enterpriseId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  isoRegionCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateEnterpriseDutchiePosLoyaltyMemberV2Args = {
  enterpriseId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  isoRegionCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateEnterpriseLoyaltySettingsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateEnterpriseSpecialV2Args = {
  input: GqlEnterpriseSpecialInputV2;
};


export type GqlMutationCreateEnterpriseSpecialsSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  input?: InputMaybe<GqlEnterpriseSpecialsSettingsInput>;
};


export type GqlMutationCreateFraudAccountArgs = {
  payload: GqlCreateFraudInput;
};


export type GqlMutationCreateInstoreCartUrlArgs = {
  orderId: Scalars['String']['input'];
};


export type GqlMutationCreateIntegrationArgs = {
  integration: GqlIntegrationsUpdateInput;
};


export type GqlMutationCreateLibraryProductArgs = {
  product: GqlProductCreateInput;
  state: Scalars['String']['input'];
};


export type GqlMutationCreateLibraryProductV2Args = {
  libraryProduct: GqlNewLibraryProduct;
  state: Scalars['String']['input'];
};


export type GqlMutationCreateLibraryProductV3Args = {
  libraryProduct: GqlNewLibraryProductV2;
  state: Scalars['String']['input'];
};


export type GqlMutationCreateLoyaltyPassTokenArgs = {
  dispensaryId: Scalars['String']['input'];
  etag?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateLoyaltyPassUrlArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationCreateLspBrandSettingsArgs = {
  brandId: Scalars['String']['input'];
  settings: GqlLspBrandSettingsInput;
};


export type GqlMutationCreateMenuSectionArgs = {
  menuSection: GqlMenuSectionCreateInput;
};


export type GqlMutationCreateMxEnrollmentArgs = {
  billingAddress: GqlBillingAddressInput;
  entityEmail: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  entityType: EntityTypes;
  isMobileApp: Scalars['Boolean']['input'];
};


export type GqlMutationCreateOrUpdateAchReturnArgs = {
  achEntryId: Scalars['String']['input'];
  achReturnId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationCreateOrUpdateAchReturnV5Args = {
  achEntryId: Scalars['String']['input'];
  achReturnId?: InputMaybe<Scalars['String']['input']>;
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationCreateOrUpdateAchReturnv4Args = {
  achEntryId: Scalars['String']['input'];
  achReturnId?: InputMaybe<Scalars['String']['input']>;
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationCreateOrderV2Args = {
  order?: InputMaybe<GqlOrdersCreateInput>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationCreateOrderingSuspensionV2Args = {
  dispensaryId: Scalars['ID']['input'];
};


export type GqlMutationCreatePosMedUserArgs = {
  dispensaryId: Scalars['String']['input'];
  user: GqlCreatePosMedUserInput;
};


export type GqlMutationCreatePaymentArgs = {
  amount: Scalars['Int']['input'];
  card?: InputMaybe<GqlCreatePaymentCard>;
  checkoutToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  customerDetails: GqlCreatePaymentCustomerDetails;
  ecommLocationId: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  tipAmount?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlMutationCreatePlusApiKeyV2Args = {
  dispensaryId: Scalars['String']['input'];
  keyType: PlusApiKeyType;
};


export type GqlMutationCreatePlusEnterpriseApiKeyArgs = {
  enterpriseId: Scalars['String']['input'];
  keyType: PlusApiKeyType;
};


export type GqlMutationCreatePointsBoostArgs = {
  input: GqlCreatePointsBoostInput;
};


export type GqlMutationCreatePrintJobArgs = {
  input: GqlCreatePrintJobInput;
};


export type GqlMutationCreateProductArgs = {
  product?: InputMaybe<GqlProductCreateInput>;
};


export type GqlMutationCreatePublicContextSessionArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationCreateRedemptionArgs = {
  code: Scalars['String']['input'];
  receiverUserId: Scalars['String']['input'];
};


export type GqlMutationCreateReservationSlotsArgs = {
  input: GqlReservationSlotsCreateInput;
};


export type GqlMutationCreateRetailerEnrollmentArgs = {
  accountDetails: GqlAccountDetailsInput;
  billingAddress: GqlBillingAddressInput;
  entityId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  serviceFeeDetails: GqlServiceFeeInput;
};


export type GqlMutationCreateSpecialV3Args = {
  input: GqlSpecialsInputV3;
};


export type GqlMutationCreateSpringbigUserArgs = {
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type GqlMutationCreateStrainV2Args = {
  strain: GqlStrainInput;
};


export type GqlMutationCreateTerpeneV2Args = {
  terpene: GqlTerpeneInput;
};


export type GqlMutationCreateUserArgs = {
  user: GqlUsersCreateInput;
};


export type GqlMutationDeleteBackInStockSubscriptionArgs = {
  productId: Scalars['String']['input'];
};


export type GqlMutationDeleteBrandArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteCollectionArgs = {
  collectionId: Scalars['String']['input'];
};


export type GqlMutationDeleteCouponArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteCouponV2Args = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteDeviceV2Args = {
  id: Scalars['ID']['input'];
};


export type GqlMutationDeleteEnterpriseSpecialArgs = {
  enterprise_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteLibraryProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeletePrinterArgs = {
  printerId: Scalars['String']['input'];
};


export type GqlMutationDeleteSpecialHoursArgs = {
  dispensaryId: Scalars['String']['input'];
  specialHoursIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationDeleteSpecialV2Args = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteStrainArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteSubscriptionArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationDeleteTerpeneArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDeleteUserArgs = {
  user: GqlUsersDeleteInput;
};


export type GqlMutationDestroyMenuSectionArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type GqlMutationDeviceHeartbeatArgs = {
  printerConnected: Scalars['Boolean']['input'];
  versionNumber: Scalars['String']['input'];
};


export type GqlMutationDisconnectBankAccountArgs = {
  mxAccountInfo: GqlMxAccountInfo;
};


export type GqlMutationDisconnectBucketProductArgs = {
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type GqlMutationDisconnectProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationDispensaryDemoRequestArgs = {
  input: GqlDispensaryDemoRequestInput;
};


export type GqlMutationDispensaryOnboardingArgs = {
  input: GqlDispensaryOnboardingInput;
};


export type GqlMutationDispensaryRemoveFromChainArgs = {
  input: GqlDispensaryRemoveFromChainInput;
};


export type GqlMutationDispensaryUpdateArgs = {
  input: GqlDispensaryUpdateInput;
};


export type GqlMutationDispensaryUpdateHoursSettingsArgs = {
  input: GqlDispensaryUpdateHoursSettingsInput;
};


export type GqlMutationDispensaryUpdateOptionsSettingsArgs = {
  input: GqlDispensaryUpdateOptionsSettingsInput;
};


export type GqlMutationDispensaryUpdateStatusArgs = {
  input: GqlDispensaryUpdateStatusInput;
};


export type GqlMutationDispensaryUpdateTaxConfigurationArgs = {
  input?: InputMaybe<GqlDispensaryUpdateInput>;
};


export type GqlMutationDispensaryUploadOnboardingAssetArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationEditCustomerV2Args = {
  billingContactEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billingNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  chargebeeCustomerId: Scalars['String']['input'];
};


export type GqlMutationEmailIntegrationCredentialsArgs = {
  input?: InputMaybe<GqlIntegrationCredsInput>;
};


export type GqlMutationEndEnterpriseSpecialArgs = {
  enterprise_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlMutationEndOrderingSuspensionV2Args = {
  dispensaryId: Scalars['ID']['input'];
};


export type GqlMutationEndSpecialV2Args = {
  id: Scalars['String']['input'];
};


export type GqlMutationExpirePlusApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationExpirePlusEnterpriseApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationExportCouponsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportCustomerReportArgs = {
  export: GqlExportCustomerReportInput;
};


export type GqlMutationExportDispensaryCustomersArgs = {
  input: GqlCustomerExportInput;
};


export type GqlMutationExportFilteredBrandsSummariesArgs = {
  input: GqlBrandsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCampaignsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCartsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportFilteredCatalogArgs = {
  filters?: InputMaybe<GqlExportFilteredCatalogFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationExportFilteredProductSummariesArgs = {
  input: GqlProductsSummaryInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationExportOrderReportArgs = {
  export: GqlExportOrderReportInput;
};


export type GqlMutationExportOrdersArgs = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type GqlMutationExportSpecialsSummariesArgs = {
  input: GqlAnalyticsInput;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlMutationFindOrCreateReferralCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  lspName: Scalars['String']['input'];
  posUniqueId?: InputMaybe<Scalars['String']['input']>;
  senderUserId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationForceDiscountSyncArgs = {
  integration_id: Scalars['String']['input'];
};


export type GqlMutationGenerateDispensaryUserStreamTokenArgs = {
  input: GqlDispensaryUserStreamTokenInput;
};


export type GqlMutationGenerateHypurRedirectV3Args = {
  dispensaryId: Scalars['String']['input'];
  embedded: Scalars['Boolean']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  v2?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationGenerateHypurTokenV2Args = {
  code: Scalars['String']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};


export type GqlMutationImportCustomerCsvArgs = {
  CSV: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationImportDeliveryZipCodesArgs = {
  csv: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationImportMenuCsvArgs = {
  input: GqlImportMenuCsvInput;
};


export type GqlMutationIncrementClicksArgs = {
  special: GqlIncrementClicksInput;
};


export type GqlMutationIntegrationsDeleteArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsDeleteInArmaArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsForceSyncInArmaArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsSuggestionArgs = {
  dispensaryId: Scalars['String']['input'];
  suggestion?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationIntegrationsUpdateArgs = {
  input: GqlIntegrationsUpdateInput;
};


export type GqlMutationIntegrationsUpdateCrmFieldsArgs = {
  input: GqlIntegrationsUpdateCrmFieldsInput;
};


export type GqlMutationIntegrationsUpdateFieldsArgs = {
  input: GqlIntegrationsUpdateFieldsInput;
};


export type GqlMutationIntegrationsUpdateHubspotPipelinesArgs = {
  input: GqlIntegrationsUpdateHubspotPipelinesInput;
};


export type GqlMutationIntegrationsUpdateThresholdsArgs = {
  input: GqlIntegrationsUpdateThresholdsInput;
};


export type GqlMutationIntegrationsUpdateTypesArgs = {
  input: GqlIntegrationsUpdateTypesInput;
};


export type GqlMutationIntegrationsWipeMenuArgs = {
  integrationId: Scalars['String']['input'];
};


export type GqlMutationIntegrationsWipeMenuInArmaArgs = {
  dispensaryId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
};


export type GqlMutationLibraryProductChangeImpactArgs = {
  product: GqlProductCreateInput;
};


export type GqlMutationLibraryProductChangeImpactV3Args = {
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlMutationLogAnalyticsPayloadArgs = {
  payload: Scalars['JSONObject']['input'];
};


export type GqlMutationLoginAdminArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type GqlMutationLoginAdminViaTokenArgs = {
  transferToken: Scalars['String']['input'];
};


export type GqlMutationLoginConsumerArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationMarkAchEntryAsReturnedArgs = {
  achEntryId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  originalTraceNumber: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
};


export type GqlMutationMarkAchEntryAsReturnedV3Args = {
  achEntryId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationMarkAchEntryAsReturnedV4Args = {
  achEntryId: Scalars['String']['input'];
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationMarkAchEntryAsReturnedV5Args = {
  achEntryId: Scalars['String']['input'];
  returnCode: Scalars['String']['input'];
  returnTraceNumber: Scalars['String']['input'];
  submitAchEntry?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationMarkCurbsideArrivalArrivedV2Args = {
  token: Scalars['String']['input'];
};


export type GqlMutationMarkOrderAutoPrintedArgs = {
  input?: InputMaybe<GqlMarkOrderAutoPrintedInput>;
};


export type GqlMutationMarkOrderPosFailedArgs = {
  input?: InputMaybe<GqlMarkOrderPosFailedInput>;
};


export type GqlMutationMarkOrderPrintedArgs = {
  input?: InputMaybe<GqlMarkOrderPrintedInput>;
};


export type GqlMutationMarkOrdersBatchPrintedArgs = {
  input?: InputMaybe<GqlMarkOrdersBatchPrintedInput>;
};


export type GqlMutationMergeBrandArgs = {
  destinationBrandId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlMutationMergeBrandsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type GqlMutationParseAchReturnFileUploadArgs = {
  file: Scalars['String']['input'];
};


export type GqlMutationParseAchReturnFileUploadV2Args = {
  file: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type GqlMutationPauseSubscriptionArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationPersistCheckoutArgs = {
  dispensaryId: Scalars['String']['input'];
  order: Scalars['JSON']['input'];
  token: Scalars['String']['input'];
};


export type GqlMutationPersistCheckoutV2Args = {
  dispensaryId: Scalars['String']['input'];
  order: Scalars['JSON']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationPrintOrderOnTerminalArgs = {
  input?: InputMaybe<GqlPrintOrderInput>;
};


export type GqlMutationRecordUserAcceptanceArgs = {
  acceptanceDocumentId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  userId: Scalars['String']['input'];
};


export type GqlMutationRemoveCategoryMenuOrderArgs = {
  input: GqlRemoveCategoryMenuOrderInput;
};


export type GqlMutationRemoveItemArgs = {
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
};


export type GqlMutationRemoveSubscriptionFromChainArgs = {
  chargebeeCustomerId: Scalars['String']['input'];
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type GqlMutationReopenOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationResetPasswordV2Args = {
  input: GqlResetPasswordInput;
};


export type GqlMutationRespondToAchReturnArgs = {
  achReturnId: Scalars['String']['input'];
  discretionaryData?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  rdfiIdentification?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  secCode?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationResumeSubscriptionArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationReversePaymentArgs = {
  achEntryId: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationReverseSettlementArgs = {
  achEntryId: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationRevertBrandMergeArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationRunChainBillingMigrationArgs = {
  input: Array<GqlChainBillingMigrationInput>;
};


export type GqlMutationSaveCustomNavigationArgs = {
  input: GqlSaveCustomNavigationInput;
};


export type GqlMutationSendBrandUserPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type GqlMutationSendCompleteAccountSetupEmailArgs = {
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationSendLoginCodeArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationSendPasswordResetEmailV2Args = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type GqlMutationSendVerificationTokenArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['String']['input'];
};


export type GqlMutationServerSideCalculationsArgs = {
  input: GqlLegacyCalculationsInput;
};


export type GqlMutationSetCategoryFeaturedBrandsArgs = {
  input: GqlSetCategoryFeaturedBrandsInput;
};


export type GqlMutationSetCategoryFeaturedProductsArgs = {
  input: GqlSetCategoryFeaturedProductsInput;
};


export type GqlMutationSetCategoryMenuOrderArgs = {
  input: GqlSetCategoryMenuOrderInput;
};


export type GqlMutationSetFeatureFlagOverrideArgs = {
  overrides: Scalars['JSON']['input'];
};


export type GqlMutationSetGlobalMenuOrderArgs = {
  input: GqlSetGlobalMenuOrderInput;
};


export type GqlMutationSetPasswordV2Args = {
  input: GqlSetPasswordInput;
};


export type GqlMutationSetupBillingV2Args = {
  customerName: Scalars['String']['input'];
  dispensaryIds: Array<Scalars['String']['input']>;
};


export type GqlMutationSetupRetailerBankPaymentMethodArgs = {
  accountId: Scalars['String']['input'];
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
  token: Scalars['String']['input'];
};


export type GqlMutationSetupRetailerBillingArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationSetupRetailerCreditPaymentMethodArgs = {
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
  token: Scalars['String']['input'];
};


export type GqlMutationSkipBucketProductArgs = {
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type GqlMutationSkipBucketProductV2Args = {
  bucketId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  skipReasons: Array<SkipReasonEnum>;
};


export type GqlMutationSortMenuSectionsArgs = {
  dispensaryId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};


export type GqlMutationSpeculativeProductUpdateArgs = {
  bucketId: Scalars['String']['input'];
  product?: InputMaybe<GqlProductCreateInput>;
  productId: Scalars['String']['input'];
};


export type GqlMutationStartPreAuthCheckArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type GqlMutationTrackIrlEventArgs = {
  input: GqlTrackIrlEventInput;
};


export type GqlMutationTrackIrlEventByDispensaryArgs = {
  input: GqlTrackIrlEventByDispensaryInput;
};


export type GqlMutationUnarchiveOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlMutationUnenrollPayByBankUserArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlMutationUnsubscribeDispensaryCustomersArgs = {
  input: GqlUnsubscribeDispensaryCustomersInput;
};


export type GqlMutationUpdateAutoPrintDevicesV2Args = {
  deviceIds: Array<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationUpdateBillingGroupArgs = {
  billingGroup: GqlUpdateBillingGroupInput;
};


export type GqlMutationUpdateBillingNotificationsArgs = {
  billingContactEmails: Array<InputMaybe<Scalars['String']['input']>>;
  billingNotificationEnabled: Scalars['Boolean']['input'];
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationUpdateBrandCollisionArgs = {
  brandCollision: GqlBrandCollisionInput;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateBrandEnterpriseSettingArgs = {
  id: Scalars['ID']['input'];
  settings: GqlBrandEnterpriseSettingsInput;
};


export type GqlMutationUpdateBrandFundedDiscountArgs = {
  id: Scalars['ID']['input'];
  input: GqlBrandFundedDiscountUpdateInput;
};


export type GqlMutationUpdateBrandImportHistoryNameArgs = {
  brandId: Scalars['ID']['input'];
  importId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type GqlMutationUpdateBrandUserArgs = {
  id: Scalars['ID']['input'];
  updates: GqlBrandUserUpdateInput;
};


export type GqlMutationUpdateBrandUserAccountArgs = {
  updates: GqlBrandUserUpdateAccountInput;
};


export type GqlMutationUpdateBrandV2Args = {
  brand: GqlBrandInput;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateChainDispensariesImageArgs = {
  dispensaryId: Scalars['String']['input'];
  image_variant_keys?: InputMaybe<Array<ImageVariantKeyEnum>>;
};


export type GqlMutationUpdateChangeRequestCreateProductArgs = {
  complianceRegionId?: InputMaybe<Scalars['String']['input']>;
  contentAttributes?: InputMaybe<GqlUpdatedLibraryProduct>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateChangeRequestUpdateProductArgs = {
  contentAttributes?: InputMaybe<GqlUpdatedLibraryProduct>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type GqlMutationUpdateChargebeeSubscriptionArgs = {
  billingPeriod?: InputMaybe<BillingPeriod>;
  chargebeeSubscriptionId: Scalars['String']['input'];
  endFreeTrial?: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialEndDate?: InputMaybe<Scalars['Int']['input']>;
  manualPayments?: InputMaybe<Scalars['Boolean']['input']>;
  pauseSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlMutationUpdateCheckoutArgs = {
  address?: InputMaybe<GqlCheckoutAddressInput>;
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  orderType: Scalars['String']['input'];
  pricingType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateCnameArgs = {
  cname: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlMutationUpdateCollectionArgs = {
  collectionId: Scalars['String']['input'];
  input: GqlUpdateCollectionInput;
};


export type GqlMutationUpdateCollectionPositionsArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateCollectionPositionsInput;
};


export type GqlMutationUpdateConsumerUserArgs = {
  user: GqlConsumerUserProfileInput;
};


export type GqlMutationUpdateCouponArgs = {
  coupon: GqlUpdateCouponInput;
};


export type GqlMutationUpdateCurbsideArrivalV2Args = {
  arrivalInformation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type GqlMutationUpdateCustomerCommunicationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInPush?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationUpdateCustomerSubscriptionArgs = {
  customerId: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
};


export type GqlMutationUpdateDeviceArgs = {
  device: GqlUpdateDeviceInput;
};


export type GqlMutationUpdateDispensaryAdSettingsArgs = {
  input: GqlUpdateDispensaryAdSettingsInput;
};


export type GqlMutationUpdateDispensaryCustomerArgs = {
  customer: GqlDispensaryCustomerInput;
};


export type GqlMutationUpdateDispensaryPersonalizationSettingsArgs = {
  input: GqlUpdateDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateDutchiePosLoyaltyMemberArgs = {
  dispensaryId: Scalars['String']['input'];
  lastAndroidLoginUtc?: InputMaybe<Scalars['String']['input']>;
  lastIosLoginUtc?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type GqlMutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type GqlMutationUpdateEmailV2Args = {
  email: Scalars['String']['input'];
};


export type GqlMutationUpdateEnterpriseAdSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  settings: GqlDispensaryAdSettingsInput;
};


export type GqlMutationUpdateEnterpriseLoyaltySettingsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateEnterpriseMobileAppSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  input?: InputMaybe<GqlEnterpriseMobileAppSettingsInput>;
};


export type GqlMutationUpdateEnterprisePersonalizationSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateEnterpriseSpecialV2Args = {
  id: Scalars['String']['input'];
  input: GqlEnterpriseSpecialInputV2;
};


export type GqlMutationUpdateEnterpriseSpecialsSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
  input?: InputMaybe<GqlEnterpriseSpecialsSettingsInput>;
};


export type GqlMutationUpdateEnterpriseWebCustomizationSettingsV2Args = {
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
};


export type GqlMutationUpdateHoursSettingsArgs = {
  input: GqlHoursSettingsUpdateInput;
};


export type GqlMutationUpdateImageBannersArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateImageBannersInput;
};


export type GqlMutationUpdateIntegrationArgs = {
  integration: GqlIntegrationsUpdateInput;
  integrationId: Scalars['String']['input'];
};


export type GqlMutationUpdateKioskOrderPaymentArgs = {
  input?: InputMaybe<GqlUpdateKioskOrderPaymentInput>;
};


export type GqlMutationUpdateLibraryProductArgs = {
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlMutationUpdateMenuSectionArgs = {
  id: Scalars['ID']['input'];
  menuSection: GqlMenuSectionUpdateInput;
};


export type GqlMutationUpdateOrderStatusArgs = {
  order?: InputMaybe<GqlOrdersStatusUpdateInput>;
};


export type GqlMutationUpdateOrderV2Args = {
  input?: InputMaybe<GqlOrdersCreateInput>;
};


export type GqlMutationUpdateOrderingSettingsArgs = {
  input: GqlOrderingSettingsUpdateInput;
};


export type GqlMutationUpdatePasswordV2Args = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type GqlMutationUpdatePlusOAuthProviderArgs = {
  enterpriseId: Scalars['String']['input'];
  input: GqlPlusOAuthProviderInput;
};


export type GqlMutationUpdatePrinterArgs = {
  input: GqlUpdatePrinterInput;
};


export type GqlMutationUpdateProductArgs = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  omitFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product?: InputMaybe<GqlProductCreateInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateProductSortArgs = {
  input: GqlUpdateProductSortInput;
};


export type GqlMutationUpdateProductStatusArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type GqlMutationUpdateProfileV2Args = {
  profile: GqlConsumerUserProfileInput;
};


export type GqlMutationUpdatePublicContextSessionArgs = {
  id: Scalars['String']['input'];
  loginMethodVerified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationUpdatePushNotificationTokenArgs = {
  dispensaryId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type GqlMutationUpdateQuantityArgs = {
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};


export type GqlMutationUpdateRemoteExtensionsArgs = {
  dispensaryId: Scalars['String']['input'];
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  input: GqlUpdateRemoteExtensionsInput;
};


export type GqlMutationUpdateReservationSlotsArgs = {
  input: GqlReservationSlotsUpdateInput;
};


export type GqlMutationUpdateSeoSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateSeoSettingsInput;
};


export type GqlMutationUpdateSingleDispensaryAdSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryAdSettingsInput;
};


export type GqlMutationUpdateSingleDispensaryPersonalizationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};


export type GqlMutationUpdateSpecialMenuDesignArgs = {
  id: Scalars['ID']['input'];
  input: GqlMenuDesignInput;
};


export type GqlMutationUpdateSpecialV3Args = {
  id: Scalars['String']['input'];
  input: GqlSpecialsInputV3;
};


export type GqlMutationUpdateSpecialsSortOrderArgs = {
  input: GqlSortOrderInput;
};


export type GqlMutationUpdateStrainV2Args = {
  id: Scalars['String']['input'];
  strain: GqlStrainInput;
};


export type GqlMutationUpdateSubscriptionBillingPeriodArgs = {
  billingPeriod: BillingPeriod;
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationUpdateSubscriptionManualPaymentsArgs = {
  manualPayments: Scalars['Boolean']['input'];
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationUpdateSubscriptionPriceArgs = {
  priceInCents: Scalars['String']['input'];
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationUpdateSubscriptionTrialArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  retailerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type GqlMutationUpdateTerpeneV2Args = {
  id: Scalars['String']['input'];
  terpene: GqlTerpeneInput;
};


export type GqlMutationUpdateTextSettingArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationUpdateUserArgs = {
  user: GqlUsersUpdateInput;
};


export type GqlMutationUpdateUserEmailArgs = {
  currentEmail: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};


export type GqlMutationUpdateUserPermissionsArgs = {
  email: Scalars['String']['input'];
  permission: Scalars['String']['input'];
};


export type GqlMutationUpdateUserRoleV2Args = {
  email: Scalars['String']['input'];
  role: UserRoles;
};


export type GqlMutationUpdateWebCustomizationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsInput;
};


export type GqlMutationUpdateWebCustomizationSettingsV2Args = {
  dispensaryId: Scalars['String']['input'];
  input: GqlUpdateWebCustomizationSettingsV2Input;
};


export type GqlMutationUploadBrandFundedDiscountImageArgs = {
  imageFile: GqlBrandFundedDiscountImageUploadInput;
};


export type GqlMutationUploadCsvImportArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  csvFile: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};


export type GqlMutationUploadImageArgs = {
  input: GqlImageUploadInput;
};


export type GqlMutationUploadSecureImageArgs = {
  input: GqlImageUploadInput;
};


export type GqlMutationUpsertPurchaseOrderArgs = {
  input: GqlUpsertPurchaseOrderInput;
};


export type GqlMutationValidateVerificationTokenArgs = {
  token: Scalars['String']['input'];
};


export type GqlMutationVerifyBucketProductsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type GqlMutationVerifyLoginCodeArgs = {
  code: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMxAccountInfo = {
  memberGuid: Scalars['String']['input'];
  userGuid: Scalars['String']['input'];
};

export type GqlMxBankAccount = {
  __typename?: 'MxBankAccount';
  accountAlias: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  bankName: Scalars['String']['output'];
  billingAddressId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  entityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
  mx?: Maybe<GqlMxResponse>;
  status: Scalars['String']['output'];
};

export type GqlMxBankAccounts = {
  __typename?: 'MxBankAccounts';
  bankAccounts?: Maybe<Array<GqlMxBankAccount>>;
};

export type GqlMxMemberVerification = {
  __typename?: 'MxMemberVerification';
  accounts: Array<GqlAccount>;
  identificationComplete: Scalars['Boolean']['output'];
  needsAccountSelection: Scalars['Boolean']['output'];
  needsMfa: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlMxResponse = {
  __typename?: 'MxResponse';
  connectionStatus: Scalars['String']['output'];
  widgetUrl: Scalars['String']['output'];
};

export type GqlNamedProductPotency = {
  __typename?: 'NamedProductPotency';
  name: Scalars['String']['output'];
  range: Array<Scalars['Float']['output']>;
  unit: Scalars['String']['output'];
};

export enum NavBarColor {
  aliceBlue = 'ALICE_BLUE',
  lightBrown = 'LIGHT_BROWN',
  white = 'WHITE',
  whiteSmoke = 'WHITE_SMOKE'
}

export type GqlNewLibraryProduct = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  connectedCount?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlNewLibraryProductV2 = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']['input']>;
  availableForWholesale?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  caseSize?: InputMaybe<Scalars['Int']['input']>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  connectedCount?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']['input']>;
  msrpCents?: InputMaybe<Scalars['Int']['input']>;
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stockImage?: InputMaybe<Scalars['String']['input']>;
  stockImageAliases?: InputMaybe<Scalars['String']['input']>;
  stockImageCategory?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wholesalePriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlNextServiceForOrderType = {
  closeMoment?: InputMaybe<Scalars['String']['input']>;
  openMoment?: InputMaybe<Scalars['String']['input']>;
  openString?: InputMaybe<Scalars['String']['input']>;
};

export type GqlNsfAchReturnReport = {
  __typename?: 'NsfAchReturnReport';
  nsfAchReturnReport?: Maybe<Array<Maybe<GqlNsfAchReturnReportRow>>>;
};

export type GqlNsfAchReturnReportResponse = {
  __typename?: 'NsfAchReturnReportResponse';
  data?: Maybe<GqlNsfAchReturnReport>;
};

export type GqlNsfAchReturnReportRow = {
  __typename?: 'NsfAchReturnReportRow';
  companyName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<GqlGoogleProtobufTimestamp>;
  dollarAmount?: Maybe<Scalars['Float']['output']>;
  endUserName?: Maybe<Scalars['String']['output']>;
  returnCode?: Maybe<Scalars['String']['output']>;
};

export type GqlOldProductData = {
  __typename?: 'OldProductData';
  CBDContent?: Maybe<GqlProductPotency>;
  Name?: Maybe<Scalars['String']['output']>;
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  THCContent?: Maybe<GqlProductPotency>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlOpenInfoForDevice = {
  __typename?: 'OpenInfoForDevice';
  nextServiceString?: Maybe<Scalars['String']['output']>;
  shouldDeviceDisplayClosed?: Maybe<Scalars['Boolean']['output']>;
  shouldDevicePlayOrderAlert?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOpenInfoForOrderType = {
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  nextService?: InputMaybe<GqlNextServiceForOrderType>;
};

export type GqlOrderEditEvents = {
  __typename?: 'OrderEditEvents';
  agentName?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['String']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  byType?: Maybe<Scalars['String']['output']>;
};

export type GqlOrderList = {
  __typename?: 'OrderList';
  orders?: Maybe<Array<Maybe<GqlOrders>>>;
  queryInfo?: Maybe<GqlQueryInfoType>;
};

export type GqlOrderMinimum = {
  __typename?: 'OrderMinimum';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
};

export type GqlOrderMinimumInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlOrderPrinted = {
  __typename?: 'OrderPrinted';
  printed?: Maybe<Scalars['Boolean']['output']>;
};

export enum OrderQueryStatuses {
  active = 'active',
  all = 'all',
  allIncludingArchived = 'allIncludingArchived',
  archived = 'archived',
  closed = 'closed'
}

export type GqlOrderReservation = {
  __typename?: 'OrderReservation';
  endTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  startTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlOrderReservationInput = {
  endTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlOrderSchedulingDataInput = {
  afterHoursEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  afterHoursInEffect?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
  orderTypeHours?: InputMaybe<GqlHoursForOrderType>;
  orderTypeOpenInfo?: InputMaybe<GqlOpenInfoForOrderType>;
  reservationSlots?: InputMaybe<Array<InputMaybe<GqlReservationSlotsForOrderType>>>;
  scheduledOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingOption?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOrderStatusEmailSettings = {
  __typename?: 'OrderStatusEmailSettings';
  disableConfirmed?: Maybe<Scalars['Boolean']['output']>;
  disableOutForDelivery?: Maybe<Scalars['Boolean']['output']>;
  disablePaymentError?: Maybe<Scalars['Boolean']['output']>;
  disablePaymentLifecycle?: Maybe<Scalars['Boolean']['output']>;
  disableReadyForPickup?: Maybe<Scalars['Boolean']['output']>;
  disableSubmitted?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrderStatusEvents = {
  __typename?: 'OrderStatusEvents';
  agentName?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['String']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  byType?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
};

export enum OrderType {
  delivery = 'delivery',
  kiosk = 'kiosk',
  pickupAll = 'pickup_all',
  pickupCurbside = 'pickup_curbside',
  pickupDrivethru = 'pickup_drivethru',
  pickupInstore = 'pickup_instore'
}

export type GqlOrderTypeConfig = {
  __typename?: 'OrderTypeConfig';
  anonymousCheckout?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<GqlPaymentTypesConfig>;
  timeout?: Maybe<GqlTimeoutConfig>;
};

export enum OrderTypes {
  all = 'all',
  delivery = 'delivery',
  kiosk = 'kiosk',
  pickup = 'pickup'
}

export type GqlOrderTypesConfig = {
  __typename?: 'OrderTypesConfig';
  curbsidePickup?: Maybe<GqlOrderTypeConfig>;
  delivery?: Maybe<GqlOrderTypeConfig>;
  driveThruPickup?: Maybe<GqlOrderTypeConfig>;
  kiosk?: Maybe<GqlOrderTypeConfig>;
  offerAnyPickupService?: Maybe<Scalars['Boolean']['output']>;
  offerDeliveryService?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<GqlOrderTypeConfig>;
};

export type GqlOrderTypesConfigV2 = {
  __typename?: 'OrderTypesConfigV2';
  curbsidePickup?: Maybe<GqlCurbsidePickupOrderingSettings>;
  delivery?: Maybe<GqlDeliveryOrderingSettings>;
  driveThruPickup?: Maybe<GqlDriveThruPickupOrderingSettings>;
  inStorePickup?: Maybe<GqlInStorePickupOrderingSettings>;
  kiosk?: Maybe<GqlKioskOrderingSettings>;
  offerAnyPickupService?: Maybe<Scalars['Boolean']['output']>;
  offerDeliveryService?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrderUpdated = {
  __typename?: 'OrderUpdated';
  updated?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrder_BottleDepositTaxExistence = {
  __typename?: 'Order_bottleDepositTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_CannabisTaxExistence = {
  __typename?: 'Order_cannabisTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_Product = {
  __typename?: 'Order_product';
  AdditionalOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CBDContent?: Maybe<GqlProductPotency>;
  Image?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Marked for removal */
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  Prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  Status?: Maybe<Scalars['String']['output']>;
  THCContent?: Maybe<GqlProductPotency>;
  _id?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<GqlBrand>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  integrationKey?: Maybe<Scalars['String']['output']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  productName?: Maybe<Scalars['String']['output']>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlOrder_SalesTaxExistence = {
  __typename?: 'Order_salesTaxExistence';
  med?: Maybe<GqlOrder_TaxStages>;
  rec?: Maybe<GqlOrder_TaxStages>;
};

export type GqlOrder_TaxStages = {
  __typename?: 'Order_taxStages';
  checkout?: Maybe<Scalars['Boolean']['output']>;
  menu?: Maybe<Scalars['Boolean']['output']>;
  pos?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrderingSettingsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlCurbsidePickupInput>;
  delivery?: InputMaybe<GqlDeliveryInput>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlBasicSettingsInput>;
  inStorePickup?: InputMaybe<GqlBasicSettingsInput>;
  kiosk?: InputMaybe<GqlKioskInput>;
};

export type GqlOrderingSuspension = {
  __typename?: 'OrderingSuspension';
  id: Scalars['String']['output'];
};

export type GqlOrders = {
  __typename?: 'Orders';
  apartmentNum?: Maybe<Scalars['String']['output']>;
  appliedRewards?: Maybe<Array<Maybe<GqlReward>>>;
  archivedAtISO?: Maybe<Scalars['ISODateTime']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  autoClosed?: Maybe<Scalars['Boolean']['output']>;
  autoConfirmed?: Maybe<Scalars['Boolean']['output']>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  bottleDepositTaxExistence?: Maybe<GqlOrder_BottleDepositTaxExistence>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cannabisTax?: Maybe<Scalars['Float']['output']>;
  cannabisTaxExistence?: Maybe<GqlOrder_CannabisTaxExistence>;
  closedByDriver?: Maybe<Scalars['Boolean']['output']>;
  closedByTerminal?: Maybe<Scalars['Boolean']['output']>;
  coupon?: Maybe<GqlCoupons>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  creditTotal?: Maybe<Scalars['String']['output']>;
  curbsideArrivalInfo?: Maybe<GqlCurbsideArrival>;
  customer?: Maybe<GqlOrders_Customer>;
  customerState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by durationEstimates.delivery - 10/04/19 */
  deliveryEstimate?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  deliveryInfo?: Maybe<GqlOrders_DeliveryInfo>;
  destinationTerminal?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlOrders_Dispensary>;
  dispoTimezone?: Maybe<Scalars['String']['output']>;
  driverEmail?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverNumber?: Maybe<Scalars['String']['output']>;
  driversLicense?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationEstimates?: Maybe<GqlDurationEstimates>;
  dutchiePay?: Maybe<GqlDutchiePay>;
  editEvents?: Maybe<Array<Maybe<GqlOrderEditEvents>>>;
  embedded?: Maybe<Scalars['Boolean']['output']>;
  fleetManagementTask?: Maybe<GqlOrders_FleetManagementTask>;
  guestCustomer?: Maybe<GqlOrders_GuestCustomer>;
  hypur?: Maybe<GqlHypurDetails>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHoursOrder?: Maybe<Scalars['Boolean']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isCurbsidePickupOrder?: Maybe<Scalars['Boolean']['output']>;
  isDriveThruPickupOrder?: Maybe<Scalars['Boolean']['output']>;
  isExternalUserOrder?: Maybe<Scalars['Boolean']['output']>;
  isGuestOrder?: Maybe<Scalars['Boolean']['output']>;
  isKioskOrder?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated temporary field to toggle compatibility with outdated clients */
  isPTPOT?: Maybe<Scalars['Boolean']['output']>;
  isPreviewOrder?: Maybe<Scalars['Boolean']['output']>;
  linx?: Maybe<GqlOrders_Linx>;
  manualDiscount?: Maybe<GqlOrders_ManualDiscount>;
  medicalCard?: Maybe<GqlOrders_MedicalCard>;
  medicalOrder?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mixAndMatch?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  moneris?: Maybe<Array<Maybe<GqlMonerisDetails>>>;
  orderId?: Maybe<Scalars['String']['output']>;
  orders: Array<GqlOrders_Order>;
  otherFees?: Maybe<Scalars['Float']['output']>;
  paymentFee?: Maybe<Scalars['Float']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<GqlPaymentDetails>>>;
  paysafe?: Maybe<GqlPaysafeDetails>;
  platformType?: Maybe<PlatformType>;
  pos?: Maybe<GqlOrders_Pos>;
  preOrderType?: Maybe<PreOrderType>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  printCommandsJson?: Maybe<Scalars['JSON']['output']>;
  printCommandsWithLogoJson?: Maybe<Scalars['JSON']['output']>;
  receipt?: Maybe<Scalars['JSONObject']['output']>;
  receiptURL?: Maybe<Scalars['String']['output']>;
  reservation?: Maybe<GqlOrderReservation>;
  salesTaxExistence?: Maybe<GqlOrder_SalesTaxExistence>;
  signatureImage?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusEvents?: Maybe<Array<Maybe<GqlOrderStatusEvents>>>;
  statusTimes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subtotal?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  termsAccepted?: Maybe<Scalars['Boolean']['output']>;
  tipAmount?: Maybe<Scalars['Float']['output']>;
  tipValue?: Maybe<GqlOrders_TipValue>;
  total?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['String']['output']>;
  updateOrderToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  variantSource?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Pos = {
  __typename?: 'Orders_POS';
  externalID?: Maybe<Scalars['String']['output']>;
  failureAcks?: Maybe<GqlOrders_Pos_FailureLocations>;
  failureReason?: Maybe<Scalars['String']['output']>;
  failureType?: Maybe<Scalars['String']['output']>;
  humanReadableError?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Pos_FailureLocations = {
  __typename?: 'Orders_POS_FailureLocations';
  terminal?: Maybe<Scalars['Boolean']['output']>;
  web?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrders_Customer = {
  __typename?: 'Orders_customer';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<GqlOrders_Customer_Emails>>>;
  profile?: Maybe<GqlOrders_Customer_Profile>;
};

export type GqlOrders_Customer_Emails = {
  __typename?: 'Orders_customer_emails';
  address?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrders_Customer_Profile = {
  __typename?: 'Orders_customer_profile';
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  cart?: Maybe<GqlOrders_Customer_Profile_Cart>;
  coords?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  driversLicense?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linx?: Maybe<GqlOrders_Customer_Profile_Linx>;
  medicalCard?: Maybe<GqlOrders_MedicalCard>;
  phone?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlOrders_Customer_Profile_Cart = {
  __typename?: 'Orders_customer_profile_cart';
  orderItems?: Maybe<Array<Maybe<GqlOrders_Customer_Profile_Cart_OrderItems>>>;
};

export type GqlOrders_Customer_Profile_Cart_OrderItems = {
  __typename?: 'Orders_customer_profile_cart_orderItems';
  additionalOption?: Maybe<Scalars['String']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rawOption?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Customer_Profile_Linx = {
  __typename?: 'Orders_customer_profile_linx';
  license?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_DeliveryInfo = {
  __typename?: 'Orders_deliveryInfo';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNum?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryOption?: Maybe<Scalars['Boolean']['output']>;
  lastSearchedAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GqlOrders_Location>;
  nonDeliveryAddress?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Dispensary = {
  __typename?: 'Orders_dispensary';
  _id?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  aeropay?: Maybe<Scalars['Boolean']['output']>;
  alt36?: Maybe<Scalars['Boolean']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  canPay?: Maybe<Scalars['Boolean']['output']>;
  chain?: Maybe<Scalars['String']['output']>;
  check?: Maybe<Scalars['Boolean']['output']>;
  creditCardAtDoor?: Maybe<Scalars['Boolean']['output']>;
  creditCardByPhone?: Maybe<Scalars['Boolean']['output']>;
  customDomainSettings?: Maybe<GqlDispensaries_Profile_CustomDomain_Settings>;
  debitOnly?: Maybe<Scalars['Boolean']['output']>;
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  deliveryMin?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<GqlDispensaries_FeatureFlags>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  linx?: Maybe<Scalars['Boolean']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerDelivery?: Maybe<Scalars['Boolean']['output']>;
  ordersConfig?: Maybe<GqlDispensaries_OrdersConfig>;
  /** @deprecated legacy payment option */
  payInStore?: Maybe<Scalars['Boolean']['output']>;
  payOnlineHypur?: Maybe<Scalars['Boolean']['output']>;
  payOnlineMerrco?: Maybe<Scalars['Boolean']['output']>;
  paytender?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  plusSettings?: Maybe<GqlDispensaries_Profile_Plus_Settings>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_FleetManagementTask = {
  __typename?: 'Orders_fleetManagementTask';
  adapter?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  timeCreated?: Maybe<Scalars['String']['output']>;
  timeLastModified?: Maybe<Scalars['String']['output']>;
  trackingURL?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_GuestCustomer = {
  __typename?: 'Orders_guestCustomer';
  birthDay?: Maybe<Scalars['String']['output']>;
  birthMonth?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Linx = {
  __typename?: 'Orders_linx';
  license?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Location = {
  __typename?: 'Orders_location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  ln1?: Maybe<Scalars['String']['output']>;
  ln2?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_ManualDiscount = {
  __typename?: 'Orders_manualDiscount';
  fixedDiscountInCents?: Maybe<Scalars['Int']['output']>;
  percentDiscount?: Maybe<Scalars['Int']['output']>;
};

export type GqlOrders_MedicalCard = {
  __typename?: 'Orders_medicalCard';
  expirationDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_Order = {
  __typename?: 'Orders_order';
  additionalOption?: Maybe<Scalars['String']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<GqlOrder_Product>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rawOption?: Maybe<Scalars['String']['output']>;
};

export type GqlOrders_TipValue = {
  __typename?: 'Orders_tipValue';
  dollar?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

/** Outlet collection timer info for displaying countdown on product pages */
export type GqlOutletCollectionInfo = {
  __typename?: 'OutletCollectionInfo';
  /** ISO date string for when the outlet collection ends */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Custom message to display with the timer (e.g., 'Order soon. Outlet closes in') */
  timerMessage?: Maybe<Scalars['String']['output']>;
};

export type GqlParseAchReturnFileUploadResponse = {
  __typename?: 'ParseAchReturnFileUploadResponse';
  data: Array<GqlAchReturnFileUploadResult>;
};

export type GqlPasswordUpdate = {
  __typename?: 'PasswordUpdate';
  accessToken: Scalars['String']['output'];
};

export type GqlPayment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Int']['output']>;
  checkoutToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<GqlGoogleProtobufTimestamp>;
  id?: Maybe<Scalars['String']['output']>;
  payee?: Maybe<GqlEntity>;
  payer?: Maybe<GqlEntity>;
  paymentMethod?: Maybe<GqlDutchiePayPaymentMethod>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlPaymentCard = {
  __typename?: 'PaymentCard';
  brand?: Maybe<Scalars['String']['output']>;
  lastDigits?: Maybe<Scalars['String']['output']>;
};

export type GqlPaymentDetails = {
  __typename?: 'PaymentDetails';
  card: GqlPaymentCard;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionNumber: Scalars['String']['output'];
};

export type GqlPaymentInfoInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type GqlPaymentMethod = {
  __typename?: 'PaymentMethod';
  bankAccount?: Maybe<GqlBankDetails>;
  billingAddress?: Maybe<GqlBillingAddress>;
  createdAt?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPaymentMethodInput = {
  paymentInfo: GqlPaymentInfoInput;
  paymentType: PaymentType;
  period: PaymentPeriod;
};

export enum PaymentPeriod {
  annually = 'annually',
  monthly = 'monthly',
  quarterly = 'quarterly'
}

export type GqlPaymentRestrictions = {
  __typename?: 'PaymentRestrictions';
  payByBankSignupIncentive?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPaymentRestrictionsInput = {
  payByBankSignupIncentive?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PaymentStatus {
  paymentStatusAuthorized = 'PAYMENT_STATUS_AUTHORIZED',
  paymentStatusAuthorizing = 'PAYMENT_STATUS_AUTHORIZING',
  paymentStatusCancelled = 'PAYMENT_STATUS_CANCELLED',
  paymentStatusCancelling = 'PAYMENT_STATUS_CANCELLING',
  paymentStatusCaptured = 'PAYMENT_STATUS_CAPTURED',
  paymentStatusCapturing = 'PAYMENT_STATUS_CAPTURING',
  paymentStatusDeclined = 'PAYMENT_STATUS_DECLINED',
  paymentStatusFailed = 'PAYMENT_STATUS_FAILED',
  paymentStatusFinalized = 'PAYMENT_STATUS_FINALIZED',
  paymentStatusFinalizing = 'PAYMENT_STATUS_FINALIZING',
  paymentStatusNew = 'PAYMENT_STATUS_NEW',
  paymentStatusRefunded = 'PAYMENT_STATUS_REFUNDED',
  paymentStatusRefunding = 'PAYMENT_STATUS_REFUNDING',
  paymentStatusRefundPending = 'PAYMENT_STATUS_REFUND_PENDING',
  paymentStatusUnspecified = 'PAYMENT_STATUS_UNSPECIFIED'
}

export enum PaymentType {
  bankAccount = 'bankAccount',
  creditCard = 'creditCard',
  manualPayments = 'manualPayments'
}

export type GqlPaymentTypeConfig = {
  __typename?: 'PaymentTypeConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  orderTypes?: Maybe<GqlPaymentsOrderTypes>;
  type?: Maybe<PaymentsPaymentType>;
};

export type GqlPaymentTypesConfig = {
  __typename?: 'PaymentTypesConfig';
  aeropay?: Maybe<Scalars['Boolean']['output']>;
  alt36?: Maybe<Scalars['Boolean']['output']>;
  canPay?: Maybe<Scalars['Boolean']['output']>;
  cash?: Maybe<Scalars['Boolean']['output']>;
  check?: Maybe<Scalars['Boolean']['output']>;
  creditCardAtDoor?: Maybe<Scalars['Boolean']['output']>;
  creditCardByPhone?: Maybe<Scalars['Boolean']['output']>;
  debit?: Maybe<Scalars['Boolean']['output']>;
  dutchiePay?: Maybe<Scalars['Boolean']['output']>;
  linx?: Maybe<Scalars['Boolean']['output']>;
  payOnlineChase?: Maybe<Scalars['Boolean']['output']>;
  payOnlineHypur?: Maybe<Scalars['Boolean']['output']>;
  payOnlineMerrco?: Maybe<Scalars['Boolean']['output']>;
  payOnlineMoneris?: Maybe<Scalars['Boolean']['output']>;
  paytender?: Maybe<Scalars['Boolean']['output']>;
  rethinkPay?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPaymentsCheckoutCredentials = GqlChaseHostedProfileCredentials | GqlMonerisHtProfileCredentials;

export type GqlPaymentsIsoDate = {
  nanos?: InputMaybe<Scalars['Int']['input']>;
  seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPaymentsOrderTypes = {
  __typename?: 'PaymentsOrderTypes';
  curbsidePickup?: Maybe<Scalars['Boolean']['output']>;
  delivery?: Maybe<Scalars['Boolean']['output']>;
  driveThruPickup?: Maybe<Scalars['Boolean']['output']>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
};

export enum PaymentsPaymentType {
  paymentTypeDutchiePay = 'PAYMENT_TYPE_DUTCHIE_PAY',
  paymentTypeRethink = 'PAYMENT_TYPE_RETHINK',
  paymentTypeUnspecified = 'PAYMENT_TYPE_UNSPECIFIED'
}

export type GqlPaysafeAuthorizations = {
  __typename?: 'PaysafeAuthorizations';
  amount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlPaysafeCard = {
  __typename?: 'PaysafeCard';
  lastDigits?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPaysafeDetails = {
  __typename?: 'PaysafeDetails';
  authorizations?: Maybe<Array<Maybe<GqlPaysafeAuthorizations>>>;
  card?: Maybe<GqlPaysafeCard>;
  refunds?: Maybe<Array<Maybe<GqlPaysafeRefunds>>>;
  settlements?: Maybe<Array<Maybe<GqlPaysafeSettlements>>>;
};

export type GqlPaysafeRefunds = {
  __typename?: 'PaysafeRefunds';
  amount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlPaysafeSettlements = {
  __typename?: 'PaysafeSettlements';
  amount?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlPendingDispensariesResult = {
  __typename?: 'PendingDispensariesResult';
  dispensaries?: Maybe<Array<Maybe<GqlDispensaries>>>;
  meta?: Maybe<GqlMeta>;
};

export type GqlPersistCheckoutResponse = {
  __typename?: 'PersistCheckoutResponse';
  checkoutToken: Scalars['String']['output'];
};

export type GqlPersonalizationSettings = {
  __typename?: 'PersonalizationSettings';
  enablePersonalizationForDefault?: Maybe<Scalars['Boolean']['output']>;
  enablePersonalizationForEmbedded?: Maybe<Scalars['Boolean']['output']>;
  enablePersonalizationForKiosk?: Maybe<Scalars['Boolean']['output']>;
  enablePersonalizationForStoreFront?: Maybe<Scalars['Boolean']['output']>;
  enableSortByRelevance?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPersonalizedProducts = {
  __typename?: 'PersonalizedProducts';
  products: Array<GqlProducts>;
};

export type GqlPersonalizedProductsFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  menuType: ProductMenuTypes;
};

export type GqlPersonalizedProductsFilterV2 = {
  category?: InputMaybe<Scalars['String']['input']>;
  menuType: ProductMenuTypes;
  menuVariant?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonalizedProductsModelNames {
  cartToppers = 'cart_toppers',
  oftenBoughtWith = 'often_bought_with',
  recommendedForYou = 'recommended_for_you',
  relatedItems = 'related_items'
}

export type GqlPickupMinimum = {
  __typename?: 'PickupMinimum';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minimumInCents?: Maybe<Scalars['Int']['output']>;
};

export type GqlPickupMinimumInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minimumInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPickupReminders = {
  __typename?: 'PickupReminders';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  reminderMessage?: Maybe<Scalars['String']['output']>;
  reminderMinutesAfterReady?: Maybe<Scalars['Int']['output']>;
};

export type GqlPickupRemindersInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  reminderMessage?: InputMaybe<Scalars['String']['input']>;
  reminderMinutesAfterReady?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPipelineProperties = {
  __typename?: 'PipelineProperties';
  pipelines?: Maybe<Array<Maybe<GqlPipelinePropertyTypes>>>;
};

export type GqlPipelinePropertyTypes = {
  __typename?: 'PipelinePropertyTypes';
  id?: Maybe<Scalars['String']['output']>;
  stages?: Maybe<Array<Maybe<GqlPipelineStageProperty>>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlPipelineStageProperty = {
  __typename?: 'PipelineStageProperty';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlPlaidLinkAccounts = {
  id: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type GqlPlaidLinkInstitution = {
  institutionId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GqlPlaidLinkMetadata = {
  accounts: Array<InputMaybe<GqlPlaidLinkAccounts>>;
  institution: GqlPlaidLinkInstitution;
  linkSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPlaidLinkStart = {
  __typename?: 'PlaidLinkStart';
  linkToken: Scalars['String']['output'];
};

export enum PlatformType {
  kiosk = 'KIOSK',
  mobile = 'MOBILE',
  onlineMenu = 'ONLINE_MENU'
}

export type GqlPlusApiKey = {
  __typename?: 'PlusApiKey';
  createdAt: Scalars['ISODateTime']['output'];
  fresh: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  keyType: PlusApiKeyType;
  lastRequestAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export enum PlusApiKeyType {
  public = 'PUBLIC',
  secret = 'SECRET'
}

export type GqlPlusOAuthProvider = {
  __typename?: 'PlusOAuthProvider';
  authorizationUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  enterpriseId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  site: Scalars['String']['output'];
  tokenUrl: Scalars['String']['output'];
  userInfoUrl: Scalars['String']['output'];
};

export type GqlPlusOAuthProviderInput = {
  authorizationUrl: Scalars['String']['input'];
  brandLogo?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  name: Scalars['String']['input'];
  site: Scalars['String']['input'];
  tokenUrl: Scalars['String']['input'];
  userInfoUrl: Scalars['String']['input'];
};

export type GqlPolygon = {
  __typename?: 'Polygon';
  features?: Maybe<Array<Maybe<GqlGeoJson_Features>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPolygonInput = {
  features?: InputMaybe<Array<InputMaybe<GqlGeoJson_FeaturesInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPopularDispensary = {
  __typename?: 'PopularDispensary';
  actionEstimates?: Maybe<GqlActionEstimates>;
  cName?: Maybe<Scalars['String']['output']>;
  /** @deprecated covered by DeliveryOrderingSettings in ordering-settings */
  deliveryArea?: Maybe<GqlPolygon>;
  /** @deprecated used and defined in ordering-settings */
  deliveryFee?: Maybe<Scalars['String']['output']>;
  /** @deprecated defined within hours-settings */
  deliveryHours?: Maybe<GqlDispensaries_Profile_Hours>;
  deliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMin?: Maybe<Scalars['String']['output']>;
  /** @deprecated used and defined in ordering-settings */
  deliveryMode?: Maybe<DeliveryModes>;
  distance?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<GqlDispensaries_FeatureFlags>;
  feeTiers?: Maybe<Array<Maybe<GqlDispensaries_Profile_FeeTiers>>>;
  hoursSettings?: Maybe<GqlDispensaryHoursSettings>;
  id?: Maybe<Scalars['String']['output']>;
  listImage?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GqlDispensaries_Profile_Location>;
  /** @deprecated used and defined in ordering-settings */
  maxDeliveryDistance?: Maybe<Scalars['Int']['output']>;
  medicalDispensary?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated use OrderTypesConfigV2 */
  orderTypesConfig?: Maybe<GqlOrderTypesConfig>;
  orderTypesConfigV2?: Maybe<GqlOrderTypesConfigV2>;
  /** @deprecated defined in hours-settings */
  pickupHours?: Maybe<GqlDispensaries_Profile_Hours>;
  recDispensary?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated defined within HoursSettingsForOrderType in ordering-settings */
  specialHours?: Maybe<Array<Maybe<GqlSpecialHours>>>;
  storeSettings?: Maybe<GqlDispensaries_StoreSettings>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlPosMedCardInfo = {
  __typename?: 'PosMedCardInfo';
  expirationDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPosOrder = {
  __typename?: 'PosOrder';
  fees?: Maybe<Array<GqlPosOrderFee>>;
  grandTotal: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  items?: Maybe<Array<GqlPosOrderItem>>;
  locationDetails: GqlPosOrderLocationDetails;
  lspId: Scalars['Int']['output'];
  lspLocId: Scalars['Int']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderSource?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  shipmentDeliveredLocal: Scalars['String']['output'];
  subTotal: Scalars['Float']['output'];
  tipAmount: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type GqlPosOrderFee = {
  __typename?: 'PosOrderFee';
  amount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlPosOrderItem = {
  __typename?: 'PosOrderItem';
  brandName?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type GqlPosOrderLocationDetails = {
  __typename?: 'PosOrderLocationDetails';
  city?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type GqlPosOrders = {
  __typename?: 'PosOrders';
  meta?: Maybe<GqlPosOrdersMeta>;
  orders?: Maybe<Array<GqlPosOrder>>;
};

export type GqlPosOrdersMeta = {
  __typename?: 'PosOrdersMeta';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Chemical compound for a Potency -- THC, CBD, and so forth */
export enum PotencyCompound {
  cbd = 'CBD',
  thc = 'THC'
}

/**
 * Search parameters for a Product's Potency. Allows for more complex
 * searching of products based on a Potency range
 */
export type GqlPotencyProductSearch = {
  /** Deprecated: Remove with ticket ENG-14662 */
  compound: PotencyCompound;
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  unit: PotencyUnit;
};

export type GqlPotencyRange = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum PotencyType {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo',
  notApplicable = 'notApplicable'
}

export enum PotencyUnit {
  milligrams = 'MILLIGRAMS',
  milligramsPerGram = 'MILLIGRAMS_PER_GRAM',
  milligramsPerMl = 'MILLIGRAMS_PER_ML',
  percentage = 'PERCENTAGE'
}

export enum PreOrderType {
  curbside = 'CURBSIDE',
  delivery = 'DELIVERY',
  driveThru = 'DRIVE_THRU',
  kiosk = 'KIOSK',
  pickup = 'PICKUP'
}

export type GqlPreferenceSettings = {
  __typename?: 'PreferenceSettings';
  emailAddress?: Maybe<Scalars['String']['output']>;
  optInEmail?: Maybe<Scalars['Boolean']['output']>;
  optInPush?: Maybe<Scalars['Boolean']['output']>;
  optInSMS?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlPreferenceSettingsResponse = {
  __typename?: 'PreferenceSettingsResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPreviewMongoProduct = {
  __typename?: 'PreviewMongoProduct';
  _id?: Maybe<Scalars['String']['output']>;
  additionalOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<GqlBrand>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  cbdContent?: Maybe<GqlProductPotency>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  duplicatedProductId?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Scalars['JSON']['output']>;
  featured?: Maybe<GqlProducts_Featured>;
  forcedPotencyUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imgixSettings?: Maybe<GqlProducts_ImgixSettings>;
  integrationKey?: Maybe<Scalars['String']['output']>;
  isBelowKioskThreshold?: Maybe<Scalars['Boolean']['output']>;
  isBelowThreshold?: Maybe<Scalars['Boolean']['output']>;
  limitsPerCustomer?: Maybe<Array<Maybe<GqlProducts_LimitPerCustomer>>>;
  manualInventory?: Maybe<Array<Maybe<GqlProducts_ManualInventory>>>;
  matchedLibraryItems?: Maybe<Array<Maybe<GqlProducts_MatchedLibraryItems>>>;
  matchedLibraryItemsConfidence?: Maybe<Scalars['Float']['output']>;
  measurements?: Maybe<GqlProducts_Measurements>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  medicalSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  modifiedAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  nonArmsLength?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  optionsBelowKioskThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  optionsBelowThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  originalPrices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overrides?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pastCNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  posMetaData?: Maybe<GqlProducts_PosMetaData>;
  preCropImage?: Maybe<Scalars['String']['output']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  rawMedicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rawPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No longer reliable with menuType-specific specials 07/26/20 */
  special?: Maybe<Scalars['Boolean']['output']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  speculativeEdits?: Maybe<Array<Maybe<GqlProducts>>>;
  status?: Maybe<Scalars['String']['output']>;
  strain?: Maybe<GqlStrain>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['String']['output']>;
  thcContent?: Maybe<GqlProductPotency>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByAdminAt?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesalePrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlPreviewProduct = {
  __typename?: 'PreviewProduct';
  appliedLibraryAttributes: GqlPreviewMongoProduct;
  product: GqlPreviewMongoProduct;
  productBatch?: Maybe<GqlProductBatch>;
  productImages: Array<Maybe<GqlProducts_Images>>;
  terpenes: Array<GqlProducts_Terpene>;
};

export type GqlPriceSummary = {
  __typename?: 'PriceSummary';
  discounts: Scalars['Int']['output'];
  fees: Scalars['Int']['output'];
  mixAndMatch: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
  /** Total before taxes, fees, etc. */
  subtotal: Scalars['Int']['output'];
  taxes: Scalars['Int']['output'];
  /** Final total including taxes, fees, etc. */
  total: Scalars['Int']['output'];
};

export enum PrintAction {
  confirm = 'confirm',
  reprint = 'reprint'
}

export type GqlPrintJob = {
  __typename?: 'PrintJob';
  _id: Scalars['String']['output'];
  assignedToPrinterId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  dispensaryId: Scalars['String']['output'];
  printAfter: Scalars['ISODateTime']['output'];
  referenceId: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlPrintedMenuSettings_CategoryEntry = {
  __typename?: 'PrintedMenuSettings_CategoryEntry';
  category?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_CategoryEntryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_PageBreaks = {
  __typename?: 'PrintedMenuSettings_PageBreaks';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  subcategoryEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_PageBreaksInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  subcategoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_Photos = {
  __typename?: 'PrintedMenuSettings_Photos';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPrintedMenuSettings_PhotosInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintedMenuSettings_StrainTypesEntry = {
  __typename?: 'PrintedMenuSettings_StrainTypesEntry';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
};

export type GqlPrintedMenuSettings_StrainTypesEntryInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrintedMenuSettings_Text = {
  __typename?: 'PrintedMenuSettings_Text';
  text?: Maybe<Scalars['String']['output']>;
};

export type GqlPrintedMenuSettings_TextInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrintedMenuSettings_Type = {
  __typename?: 'PrintedMenuSettings_Type';
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlPrintedMenuSettings_TypeInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrinter = {
  __typename?: 'Printer';
  _id: Scalars['String']['output'];
  adoptedAt?: Maybe<Scalars['ISODateTime']['output']>;
  adoptedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  deviceIdentifier: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  dispensaryId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  isRecentlyActive?: Maybe<Scalars['Boolean']['output']>;
  lastError?: Maybe<Scalars['ISODateTime']['output']>;
  lastJobId?: Maybe<Scalars['ISODateTime']['output']>;
  lastPrintAt?: Maybe<Scalars['ISODateTime']['output']>;
  lastSeenAt?: Maybe<Scalars['ISODateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  queueConfig?: Maybe<GqlPrinterQueueConfig>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlPrinterQueueConfig = {
  __typename?: 'PrinterQueueConfig';
  orderTypes: Array<Scalars['String']['output']>;
};

export type GqlPrinterQueueConfigInput = {
  orderTypes: Array<Scalars['String']['input']>;
};

export type GqlProductBatch = {
  __typename?: 'ProductBatch';
  active: Scalars['Boolean']['output'];
  digest?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
};

/** Resulting type from getProductBuyingOptions call */
export type GqlProductBuyingOptionsResult = {
  __typename?: 'ProductBuyingOptionsResult';
  buyingOptions: Array<GqlBuyingOption>;
  marketplaceProduct: GqlMarketplaceProduct;
  weightOptions?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ProductCardButtonOption {
  solid = 'SOLID',
  tinted = 'TINTED'
}

export enum ProductCardDefaultViewOption {
  card = 'CARD',
  list = 'LIST'
}

export enum ProductCardTextAlignmentOption {
  center = 'CENTER',
  left = 'LEFT'
}

export type GqlProductCards = {
  __typename?: 'ProductCards';
  defaultViewLarge?: Maybe<ProductCardDefaultViewOption>;
  defaultViewSmall?: Maybe<ProductCardDefaultViewOption>;
  fullWidthImages?: Maybe<Scalars['Boolean']['output']>;
  showProductWeight?: Maybe<Scalars['Boolean']['output']>;
  textAlignment?: Maybe<ProductCardTextAlignmentOption>;
};

export type GqlProductCardsInput = {
  defaultViewLarge?: InputMaybe<ProductCardDefaultViewOption>;
  defaultViewSmall?: InputMaybe<ProductCardDefaultViewOption>;
  fullWidthImages?: InputMaybe<Scalars['Boolean']['input']>;
  showProductWeight?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<ProductCardTextAlignmentOption>;
};

/** A Product's Category */
export enum ProductCategory {
  accessories = 'ACCESSORIES',
  allCategories = 'ALL_CATEGORIES',
  apparel = 'APPAREL',
  cbd = 'CBD',
  clones = 'CLONES',
  concentrate = 'CONCENTRATE',
  edible = 'EDIBLE',
  flower = 'FLOWER',
  hide = 'HIDE',
  nA = 'N_A',
  preRolls = 'PRE_ROLLS',
  seeds = 'SEEDS',
  tincture = 'TINCTURE',
  topicals = 'TOPICALS',
  vaporizers = 'VAPORIZERS'
}

export type GqlProductChangeEvent = {
  __typename?: 'ProductChangeEvent';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<GqlUsers>;
  event: ProductChangeEventType;
  id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  newValues?: Maybe<Scalars['JSON']['output']>;
  oldValues?: Maybe<Scalars['JSON']['output']>;
  productId: Scalars['ID']['output'];
  versionId?: Maybe<Scalars['ID']['output']>;
};

export enum ProductChangeEventType {
  brandUpdate = 'brand_update',
  contentTeamCreate = 'content_team_create',
  contentTeamUpdate = 'content_team_update',
  distributedMatchLibrary = 'distributed_match_library',
  engineeringMaintenance = 'engineering_maintenance',
  inventoryUpdate = 'inventory_update',
  libraryConnection = 'library_connection',
  libraryUpdate = 'library_update',
  matchingBrand = 'matching_brand',
  matchingConcentrations = 'matching_concentrations',
  matchingLibrary = 'matching_library',
  matchingStrain = 'matching_strain',
  menuSyncArchive = 'menu_sync_archive',
  menuSyncInsert = 'menu_sync_insert',
  menuSyncUpdate = 'menu_sync_update',
  retailerAdminCreate = 'retailer_admin_create',
  retailerAdminUpdate = 'retailer_admin_update'
}

export type GqlProductChangeRequest = {
  __typename?: 'ProductChangeRequest';
  actionType: ChangeRequestActionType;
  approvalStatus: Scalars['String']['output'];
  approvedAt?: Maybe<Scalars['ISODateTime']['output']>;
  authorId: Scalars['ID']['output'];
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID']['output'];
  complianceRegionId?: Maybe<Scalars['ID']['output']>;
  contentAttributes: GqlLibraryProduct;
  createdAt: Scalars['ISODateTime']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  rejectedAt?: Maybe<Scalars['ISODateTime']['output']>;
  rejectionReasons?: Maybe<Array<RejectionReasons>>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISODateTime']['output'];
};

/** A type that indicates medical or recreational products only */
export enum ProductConsumerType {
  med = 'MED',
  rec = 'REC'
}

export type GqlProductCrmProperty = GqlCrmProperty & {
  __typename?: 'ProductCrmProperty';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlProductDemandCount = {
  __typename?: 'ProductDemandCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
};

export type GqlProductDiscount = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProductEffect = {
  __typename?: 'ProductEffect';
  name: Scalars['String']['output'];
  power: Scalars['Int']['output'];
};

export type GqlProductFilters = {
  __typename?: 'ProductFilters';
  chainDropdownOptions?: Maybe<Array<Maybe<GqlChainDropdownOption>>>;
  dispensaryDropdownOptions: Array<Maybe<GqlDispensaryDropdownOption>>;
  statesDropdownOptions: Array<Maybe<GqlDropdownOption>>;
};

export enum ProductGroup {
  all = 'all',
  brand = 'brand',
  brands = 'brands',
  categories = 'categories',
  category = 'category',
  individual = 'individual',
  inventoryTags = 'inventory_tags',
  productTags = 'product_tags',
  strains = 'strains',
  vendors = 'vendors'
}

export type GqlProductImpactResponse = {
  __typename?: 'ProductImpactResponse';
  count?: Maybe<Scalars['Int']['output']>;
};

export type GqlProductInsightsFilterInput = {
  inventoryLevel?: InputMaybe<InventoryLevelEnum>;
};

export enum ProductMenuTypes {
  med = 'med',
  rec = 'rec'
}

export type GqlProductPotency = {
  __typename?: 'ProductPotency';
  range?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  unit: Scalars['String']['output'];
  /** @deprecated Use range */
  value?: Maybe<Scalars['String']['output']>;
};

/** How much a product is listed for at a Dispensary */
export type GqlProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Float']['output'];
  salesAmount?: Maybe<Scalars['Float']['output']>;
};

export type GqlProductRecommendation = {
  __typename?: 'ProductRecommendation';
  clickUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  impressionUrl?: Maybe<Scalars['String']['output']>;
};

export type GqlProductRecommendations = {
  __typename?: 'ProductRecommendations';
  adapter?: Maybe<Scalars['String']['output']>;
  products: Array<GqlProductRecommendation>;
};

export type GqlProductSummary = {
  __typename?: 'ProductSummary';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dollarChange?: Maybe<Scalars['Float']['output']>;
  numSold?: Maybe<Scalars['Int']['output']>;
  percentChange?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  sales?: Maybe<Scalars['Float']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
};

export type GqlProductTag = {
  __typename?: 'ProductTag';
  tagId?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type GqlProductTags = {
  __typename?: 'ProductTags';
  inventoryTags?: Maybe<Array<Maybe<GqlProductTag>>>;
  productTags?: Maybe<Array<Maybe<GqlProductTag>>>;
};

export type GqlProducts = {
  __typename?: 'Products';
  AdditionalOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Standardize onto CBDContent 12/19/19 */
  CBD?: Maybe<Scalars['String']['output']>;
  CBDContent?: Maybe<GqlProductPotency>;
  Description?: Maybe<Scalars['String']['output']>;
  DispensaryID?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  POSMetaData?: Maybe<GqlProducts_PosMetaData>;
  Prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  Status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Standardize onto THCContent 12/19/19 */
  THC?: Maybe<Scalars['String']['output']>;
  THCContent?: Maybe<GqlProductPotency>;
  _id?: Maybe<Scalars['String']['output']>;
  adTrackers?: Maybe<GqlAdTrackers>;
  adminEdits?: Maybe<Array<Maybe<GqlProducts_AdminEdit>>>;
  bottleDepositTaxCents?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<GqlBrand>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  cName?: Maybe<Scalars['String']['output']>;
  cannabinoidsV2?: Maybe<Array<Maybe<GqlProducts_CannabinoidV2>>>;
  cbdContent?: Maybe<GqlProductPotency>;
  certificateOfAnalysisEnabled?: Maybe<Scalars['Boolean']['output']>;
  collectionCardBadge?: Maybe<GqlCollectionCardBadge>;
  collections?: Maybe<Array<Maybe<GqlProducts_Collection>>>;
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  connectedAt?: Maybe<Scalars['String']['output']>;
  connectedBy?: Maybe<Scalars['String']['output']>;
  connectedByUser?: Maybe<GqlUsers>;
  connectedCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  duplicatedProductId?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Scalars['JSON']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<GqlProducts_Featured>;
  forcedPotencyUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<GqlProducts_Images>>;
  imgixSettings?: Maybe<GqlProducts_ImgixSettings>;
  integrationKey?: Maybe<Scalars['String']['output']>;
  isBelowKioskThreshold?: Maybe<Scalars['Boolean']['output']>;
  isBelowThreshold?: Maybe<Scalars['Boolean']['output']>;
  libraryProduct?: Maybe<GqlLibraryProduct>;
  libraryProductId?: Maybe<Scalars['String']['output']>;
  libraryProductScore?: Maybe<Scalars['Float']['output']>;
  limitsPerCustomer?: Maybe<Array<Maybe<GqlProducts_LimitPerCustomer>>>;
  manualInventory?: Maybe<Array<Maybe<GqlProducts_ManualInventory>>>;
  matchedLibraryItems?: Maybe<Array<Maybe<GqlProducts_MatchedLibraryItems>>>;
  matchedLibraryItemsConfidence?: Maybe<Scalars['Float']['output']>;
  measurements?: Maybe<GqlProducts_Measurements>;
  medicalOnly?: Maybe<Scalars['Boolean']['output']>;
  medicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  medicalSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  nonArmsLength?: Maybe<Scalars['Boolean']['output']>;
  optionsBelowKioskThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  optionsBelowThreshold?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  originalPrices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Outlet collection timer info for displaying countdown on product detail pages */
  outletCollectionInfo?: Maybe<GqlOutletCollectionInfo>;
  overrides?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pastCNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Removed. Server side only field. 6/2/21 */
  popularSortKey?: Maybe<Scalars['Float']['output']>;
  posMetaData?: Maybe<GqlProducts_PosMetaData>;
  preCropImage?: Maybe<Scalars['String']['output']>;
  preTaxMedPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  preTaxRecPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  prices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pricingTierData?: Maybe<GqlProducts_PricingTierData>;
  productTemplate?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<ProductsProvider>;
  rawMedicalPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rawOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rawPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recOnly?: Maybe<Scalars['Boolean']['output']>;
  recPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recSpecialPrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No longer reliable with menuType-specific specials 07/26/20 */
  special?: Maybe<Scalars['Boolean']['output']>;
  specialData?: Maybe<GqlProducts_SpecialData>;
  specialIdsPerOption?: Maybe<Array<Maybe<GqlProducts_SpecialIdsPerOption>>>;
  speculativeEdits?: Maybe<Array<Maybe<GqlProducts>>>;
  stockImage?: Maybe<Scalars['String']['output']>;
  stockImageAliases?: Maybe<Scalars['String']['output']>;
  stockImageCategory?: Maybe<Scalars['String']['output']>;
  strain?: Maybe<GqlStrain>;
  strainType?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['String']['output']>;
  terpenes?: Maybe<Array<Maybe<GqlProducts_Terpene>>>;
  thcContent?: Maybe<GqlProductPotency>;
  totalTerpenes?: Maybe<GqlProductPotency>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByAdminAt?: Maybe<Scalars['String']['output']>;
  updatedByUser?: Maybe<GqlUsers>;
  /** @deprecated No longer needed. 09/02/25 */
  useBetterPotencyTaxes?: Maybe<Scalars['Boolean']['output']>;
  vapeTaxApplicable?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesalePrices?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlProductsList = {
  __typename?: 'ProductsList';
  /** @deprecated Use menu filters instead 8/3/23 */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products: Array<Maybe<GqlProducts>>;
  queryInfo: GqlQueryInfoType;
};

export type GqlProductsPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductsProvider {
  crossingMinds = 'crossingMinds',
  dutchie = 'dutchie',
  moloco = 'moloco'
}

export type GqlProductsSalesByCategory = {
  __typename?: 'ProductsSalesByCategory';
  categoryOptions?: Maybe<Array<Maybe<GqlDropdownOption>>>;
  lineItems?: Maybe<Array<Maybe<GqlCategoryLineItem>>>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlProductsSummaryInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  increment?: InputMaybe<Scalars['String']['input']>;
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  strain?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_CannabinoidInputV2 = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cannabinoidId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlProducts_CannabinoidV2 = {
  __typename?: 'Products_CannabinoidV2';
  active?: Maybe<Scalars['Boolean']['output']>;
  cannabinoid?: Maybe<GqlCannabinoid>;
  cannabinoidId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<PotencyUnit>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_Collection = {
  __typename?: 'Products_Collection';
  id?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_Images = {
  __typename?: 'Products_Images';
  _id?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  digest?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  origin: ImageOrigin;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  url: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_ImagesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  origin: ImageOrigin;
  updatedAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  url: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_PosMetaData = {
  __typename?: 'Products_POSMetaData';
  activeBatchTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalBrandId?: Maybe<Scalars['String']['output']>;
  canonicalBrandName?: Maybe<Scalars['String']['output']>;
  canonicalCategory?: Maybe<Scalars['String']['output']>;
  canonicalCategoryId?: Maybe<Scalars['String']['output']>;
  canonicalID?: Maybe<Scalars['String']['output']>;
  canonicalImgUrl?: Maybe<Scalars['String']['output']>;
  canonicalLabResultUrl?: Maybe<Scalars['String']['output']>;
  canonicalName?: Maybe<Scalars['String']['output']>;
  canonicalPackageId?: Maybe<Scalars['String']['output']>;
  canonicalProductTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalSKU?: Maybe<Scalars['String']['output']>;
  canonicalStrainId?: Maybe<Scalars['String']['output']>;
  canonicalVendorId?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<GqlProducts_PosMetaData_Children>>>;
  integrationID?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_PosMetaData_Children = {
  __typename?: 'Products_POSMetaData_children';
  activeBatchTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalBrandId?: Maybe<Scalars['String']['output']>;
  canonicalBrandName?: Maybe<Scalars['String']['output']>;
  canonicalCategory?: Maybe<Scalars['String']['output']>;
  canonicalCategoryId?: Maybe<Scalars['String']['output']>;
  canonicalEffectivePotencyMg?: Maybe<Scalars['Float']['output']>;
  canonicalID?: Maybe<Scalars['String']['output']>;
  canonicalImgUrl?: Maybe<Scalars['String']['output']>;
  canonicalLabResultUrl?: Maybe<Scalars['String']['output']>;
  canonicalName?: Maybe<Scalars['String']['output']>;
  canonicalPackageId?: Maybe<Scalars['String']['output']>;
  canonicalProductTags?: Maybe<Array<Maybe<GqlTag>>>;
  canonicalSKU?: Maybe<Scalars['String']['output']>;
  canonicalStrainId?: Maybe<Scalars['String']['output']>;
  canonicalVendorId?: Maybe<Scalars['String']['output']>;
  kioskQuantityAvailable?: Maybe<Scalars['Float']['output']>;
  medPrice?: Maybe<Scalars['Float']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  packageQuantity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityAvailable?: Maybe<Scalars['Float']['output']>;
  recEquivalent?: Maybe<GqlProducts_PosMetaData_Children_Equivalent>;
  recPrice?: Maybe<Scalars['Float']['output']>;
  standardEquivalent?: Maybe<GqlProducts_PosMetaData_Children_Equivalent>;
};

export type GqlProducts_PosMetaData_Children_Equivalent = {
  __typename?: 'Products_POSMetaData_children_equivalent';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_PosMetaData_Children_StandardEquivalent = {
  __typename?: 'Products_POSMetaData_children_standardEquivalent';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_Terpene = {
  __typename?: 'Products_Terpene';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  libraryTerpene?: Maybe<GqlTerpene>;
  name?: Maybe<Scalars['String']['output']>;
  terpeneId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<PotencyUnit>;
  unitSymbol?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_TerpeneInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  terpeneId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<PotencyUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type GqlProducts_AdminEdit = {
  __typename?: 'Products_adminEdit';
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type GqlProducts_Featured = {
  __typename?: 'Products_featured';
  current?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_FeaturedInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_ImgixSettings = {
  __typename?: 'Products_imgixSettings';
  productCard?: Maybe<GqlImgixSettings>;
  productModal?: Maybe<GqlImgixSettings>;
};

export type GqlProducts_LimitPerCustomer = {
  __typename?: 'Products_limitPerCustomer';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_LimitPerCustomerInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_ManualInventory = {
  __typename?: 'Products_manualInventory';
  inventory?: Maybe<Scalars['Int']['output']>;
  option?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_ManualInventoryInput = {
  inventory?: InputMaybe<Scalars['Int']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProducts_MatchedLibraryItems = {
  __typename?: 'Products_matchedLibraryItems';
  _id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type GqlProducts_Measurement = {
  __typename?: 'Products_measurement';
  unit?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type GqlProducts_Measurements = {
  __typename?: 'Products_measurements';
  netWeight?: Maybe<GqlProducts_Measurement>;
  volume?: Maybe<GqlProducts_Measurement>;
};

export type GqlProducts_PricingTierData = {
  __typename?: 'Products_pricingTierData';
  generatedTiersId?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<GqlProducts_PricingTierData_Tiers>>>;
  tiersId?: Maybe<Scalars['String']['output']>;
  tiersName?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_PricingTierData_Tiers = {
  __typename?: 'Products_pricingTierData_tiers';
  endWeight?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  pricePerGram?: Maybe<Scalars['Float']['output']>;
  startWeight?: Maybe<Scalars['Float']['output']>;
  weightUOM?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_SpecialData = {
  __typename?: 'Products_specialData';
  bogoSpecials?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials>>>;
  /** @deprecated Need to apply more than one special 7/20/20 */
  discount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Need to apply more than one special 7/20/20 */
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  saleSpecials?: Maybe<Array<Maybe<GqlProducts_SpecialData_SaleSpecials>>>;
};

export type GqlProducts_SpecialData_BogoSpecials = {
  __typename?: 'Products_specialData_bogoSpecials';
  applyRewardsToConditions?: Maybe<Scalars['Boolean']['output']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoConditions?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials_BogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoRewards?: Maybe<Array<Maybe<GqlProducts_SpecialData_BogoSpecials_BogoRewardItem>>>;
  createdBy?: Maybe<Scalars['String']['output']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated In favor of stackingBehavior 03/29/22 */
  discountBehavior?: Maybe<Scalars['String']['output']>;
  discountBundle?: Maybe<GqlProducts_SpecialData_BogoSpecials_DiscountBundle>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  endStamp?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer required 10/07/24 */
  ensureCumulativeNonstacking?: Maybe<Scalars['Boolean']['output']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']['output']>;
  excludedProducts?: Maybe<GqlExcludedBogoProducts>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  itemsForAPrice?: Maybe<GqlProducts_SpecialData_BogoSpecials_ItemsForAPrice>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  menuType?: Maybe<Scalars['String']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  qualifyingConditionOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  qualifyingOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  qualifyingRewardOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']['output']>;
  recurringEndDate?: Maybe<Scalars['String']['output']>;
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  settingsDerivedFrom?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  specialName?: Maybe<Scalars['String']['output']>;
  specialType?: Maybe<Scalars['String']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']['output']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 12/03/25 */
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlProducts_SpecialData_BogoSpecials_BogoConditionItem = {
  __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem';
  _id?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<Products_SpecialData_ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlProducts_SpecialData_BogoSpecials_BogoRewardItem = {
  __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem';
  _id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use applicationRules */
  applicationRule?: Maybe<GqlApplicationRule>;
  applicationRules?: Maybe<Array<GqlApplicationRule>>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  dollarDiscount?: Maybe<Scalars['String']['output']>;
  enterpriseProductId?: Maybe<Scalars['String']['output']>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  percentDiscount?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requiresSingleSku?: Maybe<Scalars['Boolean']['output']>;
  selectedCategoriesAndSubcategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetPrice?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<Products_SpecialData_ComparisonOperators>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlProducts_SpecialData_BogoSpecials_DiscountBundle = {
  __typename?: 'Products_specialData_bogoSpecials_discountBundle';
  _id?: Maybe<Scalars['String']['output']>;
  applyTo?: Maybe<ApplicationScope>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_SpecialData_BogoSpecials_DiscountToCart = {
  __typename?: 'Products_specialData_bogoSpecials_discountToCart';
  _id?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlProducts_SpecialData_BogoSpecials_ItemsForAPrice = {
  __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice';
  _id?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum Products_SpecialData_ComparisonOperators {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo'
}

export type GqlProducts_SpecialData_SaleSpecials = {
  __typename?: 'Products_specialData_saleSpecials';
  createdBy?: Maybe<Scalars['String']['output']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  dollarDiscount?: Maybe<Scalars['Boolean']['output']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  menuType?: Maybe<Scalars['String']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']['output']>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  settingsDerivedFrom?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  specialName?: Maybe<Scalars['String']['output']>;
  specialRestrictions?: Maybe<Scalars['JSON']['output']>;
  specialType?: Maybe<Scalars['String']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']['output']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 12/03/25 */
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlProducts_SpecialIdsPerOption = {
  __typename?: 'Products_specialIdsPerOption';
  conditionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  option?: Maybe<Scalars['String']['output']>;
  rewardIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlProgramResponse = {
  __typename?: 'ProgramResponse';
  rewardRedemption?: Maybe<GqlRewardRedemptionDetails>;
};

export type GqlPromo = {
  __typename?: 'Promo';
  html: Scalars['String']['output'];
  recipient: Scalars['JSON']['output'];
};

export type GqlPropertyTypes = {
  __typename?: 'PropertyTypes';
  contact?: Maybe<Array<Maybe<GqlContactCrmProperty>>>;
  deal?: Maybe<Array<Maybe<GqlDealCrmProperty>>>;
  product?: Maybe<Array<Maybe<GqlProductCrmProperty>>>;
};

export type GqlPublicContextSession = {
  __typename?: 'PublicContextSession';
  accessToken?: Maybe<Scalars['String']['output']>;
  claimedByUserId?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  loginMethodVerified?: Maybe<Scalars['Boolean']['output']>;
  status: PublicContextSessionStatus;
};

export enum PublicContextSessionStatus {
  claimed = 'CLAIMED',
  expired = 'EXPIRED',
  unclaimed = 'UNCLAIMED'
}

export type GqlPurchaseOrder = {
  __typename?: 'PurchaseOrder';
  actualArrivalDate?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdByEmail: Array<Scalars['String']['output']>;
  destinationDposLocId?: Maybe<Scalars['Int']['output']>;
  destinationDposLspId?: Maybe<Scalars['Int']['output']>;
  destinationDposServerRegion?: Maybe<Scalars['String']['output']>;
  expectedArrivalDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  items: Scalars['Int']['output'];
  purchaseOrderItems: Array<GqlPurchaseOrderLineItem>;
  purchaseOrderNumber: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  shippingInformation?: Maybe<Scalars['String']['output']>;
  sourceDposLocId: Scalars['Int']['output'];
  sourceDposLspId: Scalars['Int']['output'];
  sourceDposServerRegion: Scalars['String']['output'];
  status: PurchaseOrderStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum PurchaseOrderCatalogSource {
  brand = 'brand',
  retailer = 'retailer'
}

export type GqlPurchaseOrderDetail = {
  __typename?: 'PurchaseOrderDetail';
  actionRequiredBy?: Maybe<Scalars['String']['output']>;
  actioningPartyEngagedAt?: Maybe<Scalars['String']['output']>;
  actualArrivalDate?: Maybe<Scalars['String']['output']>;
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLineOne?: Maybe<Scalars['String']['output']>;
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  addressRecipientName?: Maybe<Scalars['String']['output']>;
  addressRegion?: Maybe<Scalars['String']['output']>;
  addressZipCode?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdByEmail: Array<Scalars['String']['output']>;
  createdFromPurchaseOrderId?: Maybe<Scalars['String']['output']>;
  currentVersion?: Maybe<Scalars['Int']['output']>;
  destinationDposLocId?: Maybe<Scalars['Int']['output']>;
  destinationDposLspId?: Maybe<Scalars['Int']['output']>;
  destinationDposServerRegion?: Maybe<Scalars['String']['output']>;
  expectedArrivalDate?: Maybe<Scalars['String']['output']>;
  hasUnresolvedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  items: Scalars['Int']['output'];
  notes: Array<GqlPurchaseOrderNote>;
  purchaseOrderItems: Array<GqlPurchaseOrderItem>;
  purchaseOrderNumber: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  requestedSubtotalInCents: Scalars['Int']['output'];
  requestedTaxInCents: Scalars['Int']['output'];
  shippingInformation?: Maybe<Scalars['String']['output']>;
  sourceDposLocId: Scalars['Int']['output'];
  sourceDposLocName: Scalars['String']['output'];
  sourceDposLspId: Scalars['Int']['output'];
  sourceDposLspName: Scalars['String']['output'];
  sourceDposServerRegion: Scalars['String']['output'];
  status: PurchaseOrderStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  versions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  viewingVersion?: Maybe<Scalars['Int']['output']>;
};

export type GqlPurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  caseSize?: Maybe<Scalars['Int']['output']>;
  catalogLinkApproved: Scalars['Boolean']['output'];
  catalogLinkRejected: Scalars['Boolean']['output'];
  catalogSource: PurchaseOrderCatalogSource;
  confirmedQuantity: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  hasUnresolvedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  itemStatus: PurchaseOrderItemStatus;
  libraryProductId?: Maybe<Scalars['String']['output']>;
  minimumOrderQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes: Array<GqlPurchaseOrderNote>;
  originalPurchaseOrderItemId?: Maybe<Scalars['String']['output']>;
  previousState?: Maybe<Scalars['JSON']['output']>;
  purchaseOrderId: Scalars['String']['output'];
  purchaseOrderItemPackages: Array<GqlPurchaseOrderItemPackage>;
  requestedQuantity: Scalars['Int']['output'];
  requestedSubtotalInCents: Scalars['Int']['output'];
  requestedTaxInCents: Scalars['Int']['output'];
  retailerMetrcItemName?: Maybe<Scalars['String']['output']>;
  retailerProductCategory?: Maybe<Scalars['String']['output']>;
  retailerProductName?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  suggestedLibraryProductId?: Maybe<Scalars['String']['output']>;
  taxInCents: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
  unitPriceInCents: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlPurchaseOrderItemPackage = {
  __typename?: 'PurchaseOrderItemPackage';
  createdAt: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['String']['output']>;
  flowerEquivalent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  manufacturingDate?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['String']['output'];
  packagingDate?: Maybe<Scalars['String']['output']>;
  purchaseOrderItemId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum PurchaseOrderItemStatus {
  confirmed = 'confirmed',
  pending = 'pending',
  rejected = 'rejected',
  substituted = 'substituted'
}

export type GqlPurchaseOrderLineItem = {
  __typename?: 'PurchaseOrderLineItem';
  confirmedQuantity: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  libraryProductId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  purchaseOrderId: Scalars['String']['output'];
  requestedQuantity: Scalars['Int']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
  unitPriceInCents: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type GqlPurchaseOrderList = {
  __typename?: 'PurchaseOrderList';
  data: Array<GqlPurchaseOrderSummary>;
  meta: GqlPurchaseOrderMeta;
};

export type GqlPurchaseOrderMeta = {
  __typename?: 'PurchaseOrderMeta';
  totalCount: Scalars['Int']['output'];
};

export type GqlPurchaseOrderNote = {
  __typename?: 'PurchaseOrderNote';
  authorEmail: Scalars['String']['output'];
  authorParty: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notableId: Scalars['String']['output'];
  notableType: Scalars['String']['output'];
};

export enum PurchaseOrderStatus {
  amended = 'amended',
  cancelled = 'cancelled',
  closedReceived = 'closed_received',
  confirmed = 'confirmed',
  openDraft = 'open_draft',
  partiallyConfirmed = 'partially_confirmed',
  pendingManagerApproval = 'pending_manager_approval',
  rejected = 'rejected',
  rejectedByFulfillment = 'rejected_by_fulfillment',
  shipped = 'shipped',
  submitted = 'submitted'
}

export type GqlPurchaseOrderSummary = {
  __typename?: 'PurchaseOrderSummary';
  actionRequiredBy?: Maybe<Scalars['String']['output']>;
  actioningPartyEngagedAt?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdByEmail: Array<Scalars['String']['output']>;
  expectedArrivalDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  items: Scalars['Int']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  requestedSubtotalInCents: Scalars['Int']['output'];
  sourceDposLocId: Scalars['Int']['output'];
  sourceDposLocName: Scalars['String']['output'];
  sourceDposLspId: Scalars['Int']['output'];
  sourceDposLspName: Scalars['String']['output'];
  sourceDposServerRegion: Scalars['String']['output'];
  status: PurchaseOrderStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type GqlPurchaseOrdersFilterInput = {
  destinationDposLocId?: InputMaybe<Scalars['String']['input']>;
  destinationDposLspId?: InputMaybe<Scalars['String']['input']>;
  destinationDposServerRegion?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspId?: InputMaybe<Scalars['String']['input']>;
  sourceDposServerRegion?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPurchaseOrdersListFiltersInput = {
  actionRequiredBy?: InputMaybe<Scalars['String']['input']>;
  actioningPartyEngagedAt?: InputMaybe<Scalars['Boolean']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateField?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  sourceDposLocId?: InputMaybe<Scalars['String']['input']>;
  sourceDposLspId?: InputMaybe<Scalars['String']['input']>;
  sourceDposServerRegion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<PurchaseOrderStatus>>>;
};

export enum PurchaseOrdersSortBy {
  createdAt = 'created_at',
  purchaseOrderNumber = 'purchase_order_number',
  status = 'status',
  updatedAt = 'updated_at'
}

export type GqlPurchaseOrdersSortInput = {
  sortBy?: InputMaybe<PurchaseOrdersSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlQuery = {
  __typename?: 'Query';
  AchReturnDetailReport?: Maybe<GqlAchReturnDetailReportResponse>;
  NsfAchReturnReport?: Maybe<GqlNsfAchReturnReportResponse>;
  activeDispensaries?: Maybe<GqlActiveDispenariesResult>;
  activeProductsCheck?: Maybe<Array<Maybe<GqlProducts>>>;
  addressResidentialCheck?: Maybe<GqlValidationResponse>;
  archivedProductLookup?: Maybe<Array<Maybe<GqlProducts>>>;
  availableSegments: Array<GqlSegment>;
  brandPortalProductSearch?: Maybe<GqlBrandPortalProductSearchResponse>;
  bulkLibraryProductUpdateStatus?: Maybe<GqlBulkLibraryProductStatusUpdateResponse>;
  bulkLibraryProductUploadStatus?: Maybe<GqlBulkLibraryProductUploadStatusResponse>;
  calculateCheckout?: Maybe<GqlCalculateCheckout>;
  chainDispensariesByStatus?: Maybe<Array<Maybe<GqlDispensaries>>>;
  chainDispensaryIds: Array<Maybe<Scalars['String']['output']>>;
  chainDispensaryNamesAndIds?: Maybe<Array<Maybe<GqlDispensaries>>>;
  changeRequestProduct?: Maybe<GqlProductChangeRequest>;
  checkAgeVerification: GqlAgeVerification;
  checkAllotment?: Maybe<GqlAllotmentInfo>;
  checkPurchaseLimits?: Maybe<GqlCheckPurchaseLimitsResult>;
  computeWithPriceCart?: Maybe<GqlCalculationResults>;
  connectNewProductPreview?: Maybe<GqlConnectProductPreviewResponse>;
  consumerPosOrder?: Maybe<GqlPosOrder>;
  consumerPosOrders?: Maybe<GqlPosOrders>;
  contentStatistics?: Maybe<GqlContentStatistics>;
  createPaymentMethod?: Maybe<GqlMxMemberVerification>;
  /** @deprecated Use getCurbsideArrivals */
  curbsideArrivalsForDispensary?: Maybe<Array<Maybe<GqlCurbsideArrival>>>;
  currentDevice?: Maybe<GqlDevices>;
  dispensaryCustomers?: Maybe<GqlCustomersList>;
  enterpriseAdSettings: Array<GqlEnterpriseDispensaryAdSettings>;
  enterpriseLoyaltySettings?: Maybe<GqlEnterpriseLoyaltySettings>;
  enterpriseMobileAppSettings?: Maybe<GqlEnterpriseMobileAppSettings>;
  enterprisePersonalizationSettings: Array<GqlEnterpriseDispensaryPersonalizationSettings>;
  enterpriseProducts?: Maybe<GqlEnterpriseProducts>;
  enterpriseProductsV2?: Maybe<GqlEnterpriseProducts>;
  enterpriseSpecials?: Maybe<Array<Maybe<GqlEnterpriseSpecial>>>;
  enterpriseSpecialsV3?: Maybe<GqlFilteredEnterpriseSpecials>;
  filteredCoupons?: Maybe<GqlCouponList>;
  filteredDispensaries?: Maybe<Array<Maybe<GqlDispensaries>>>;
  filteredIntegrations?: Maybe<Array<Maybe<GqlIntegrations>>>;
  filteredOrders?: Maybe<GqlOrderList>;
  filteredProducts?: Maybe<GqlProductsList>;
  filteredSpecials?: Maybe<GqlFilteredSpecials>;
  filteredSpecialsV2?: Maybe<GqlFilteredSpecials>;
  filteredStrains?: Maybe<GqlStrainList>;
  /** @deprecated Use getCustomerSubscriptions */
  filteredSubscriptions?: Maybe<Array<Maybe<GqlSubscriptionCustomers>>>;
  filteredTerpenes?: Maybe<Array<Maybe<GqlTerpene>>>;
  filteredUsers?: Maybe<Array<Maybe<GqlUsers>>>;
  findCustomizationProvider?: Maybe<GqlCustomizationProvider>;
  findLibraryProducts?: Maybe<GqlFindLibraryProductsResponse>;
  fundRethink: GqlFundRethinkResponse;
  geolocate?: Maybe<GqlIpInfo>;
  getAchPaymentDetails?: Maybe<GqlGetAchPaymentDetailsResponse>;
  getAddressBasedDispensaryData?: Maybe<GqlAddressBasedDispensaryDataResult>;
  getAdsInspectorEvents: GqlAdsInspectorEvents;
  getBackInStockSubscriptionStatus?: Maybe<GqlBackInStockSubscriptionStatus>;
  /** @deprecated Use listBankAccounts query */
  getBankAccountsV2?: Maybe<GqlBankAccounts>;
  getBillingSubscriptions: Array<Maybe<GqlBillingSubscription>>;
  getBrand?: Maybe<GqlBrand>;
  getBrandCampaignInsights: Array<GqlBrandCampaignInsight>;
  getBrandCollisions?: Maybe<GqlBrandCollisionList>;
  getBrandEnterpriseSettings: Array<GqlBrandEnterpriseSetting>;
  getBrandExports: GqlBrandExportsResponse;
  getBrandFundedDiscount?: Maybe<GqlBrandFundedDiscount>;
  getBrandImportHistory: GqlBrandImportHistoryResponse;
  getBrandImportHistoryDetail: GqlBrandImportHistoryDetailResponse;
  getBrandImportHistoryFailedRowsExport: GqlBrandImportHistoryFailedRowsExport;
  getBrandKeyMetrics: GqlBrandKeyMetrics;
  getBrandLocationCategoriesInsights: GqlBrandCategoryInsightsSummary;
  getBrandLocationProductsInsights: GqlBrandProductInsightsSummary;
  getBrandLocationsInsights: GqlBrandLocationsInsightsSummary;
  getBrandLspCategoriesInsights: GqlBrandCategoryInsightsSummary;
  getBrandLspProductsInsights: GqlBrandProductInsightsSummary;
  getBrandLsps: Array<GqlBrandLspItem>;
  getBrandLspsInsights: GqlBrandLspsInsightsSummary;
  getBrandMergeHistories?: Maybe<GqlBrandMergeHistoryList>;
  getBrandOverviewLsps: GqlBrandOverviewLspsSummary;
  getBrandRegions: Array<GqlBrandRegion>;
  getBrandUser?: Maybe<GqlBrandUser>;
  getBrandUsers?: Maybe<GqlBrandUserList>;
  getBrandsV2?: Maybe<Array<Maybe<GqlBrand>>>;
  getBucket: GqlBucket;
  getBuckets: Array<Maybe<GqlBucket>>;
  getCannabinoids: Array<GqlCannabinoid>;
  getCategoriesListForDiscountRequirements: GqlDiscountCategoryList;
  getChainsV2?: Maybe<GqlChainList>;
  getChargebeeHostedPage?: Maybe<GqlChargeBeeHostedPage>;
  getCheckout?: Maybe<GqlCheckout>;
  getCollection: GqlCollection;
  getCollectionProductCount: GqlCollectionProductCount;
  getCollections: Array<GqlCollection>;
  getCollectionsNavigation: Array<GqlCollection>;
  getConsumerStreamToken?: Maybe<GqlConsumerStreamCredentials>;
  getConsumerUser?: Maybe<GqlConsumerUser>;
  getCurbsideArrivalByToken?: Maybe<GqlCurbsideArrival>;
  getCurbsideArrivals: Array<GqlCurbsideArrival>;
  /** @deprecated Replaced by getCustomNavigation */
  getCustomMobileMenu?: Maybe<GqlCustomMobileMenu>;
  getCustomNavigation?: Maybe<GqlCustomNavigation>;
  getCustomerCommunicationSettings?: Maybe<GqlCommunicationSettings>;
  getCustomerDetails: GqlCustomerDetailsResponse;
  getCustomerSubscriptions: Array<GqlCustomerSubscription>;
  /** @deprecated Use getAddressBasedDispensaryData instead */
  getDeliveryInfo?: Maybe<GqlDispensaries_DeliveryInfo>;
  getDevices: Array<GqlDevices>;
  getDispensariesAdSettingsByMenuVariant?: Maybe<Array<GqlDispensariesAdSettingsByMenuVariantResult>>;
  getDispensariesByPersonalizationSettings?: Maybe<Array<GqlDispensariesPersonalizationSettingsByMenuVariantResult>>;
  getDispensaryCharities: Array<GqlCharity>;
  /** @deprecated Use ShowEnrollment */
  getDutchiePayEnrollment: GqlDutchiePayEnrollment;
  getDutchiePosLoyaltyConfig?: Maybe<GqlDutchiePosLoyaltyConfig>;
  getEcommerceAbandonedCarts?: Maybe<GqlEcommerceAbandonedCartsResponse>;
  /** @deprecated Use getDutchiePayEnrollment */
  getEnrollmentStatus?: Maybe<GqlUserEnrollment>;
  getEnterprise?: Maybe<GqlEnterprise>;
  getEnterpriseByName?: Maybe<Array<Maybe<GqlEnterprise>>>;
  getEnterpriseSpecial?: Maybe<GqlEnterpriseSpecial>;
  getEnterpriseSpecialsHistory?: Maybe<GqlEnterpriseSpecialsHistory>;
  getEnterpriseSpecialsSettings?: Maybe<GqlEnterpriseSpecialsSettings>;
  getEntityLinkingCode?: Maybe<GqlEntityLinkingCodeResponse>;
  getExport: GqlExport;
  getFilteredBrandSummaries?: Maybe<GqlFilteredBrandSummaryResponse>;
  getFilteredProductSummaries?: Maybe<GqlFilteredProductSummaryResponse>;
  getInstoreAnalyticsToken?: Maybe<GqlInstoreAnalyticsToken>;
  getInstoreCart?: Maybe<GqlShowInstoreCartResponse>;
  getInvoicePdf: GqlChargebeeDownload;
  getIrlEvent?: Maybe<GqlIrlEvent>;
  getIrlEventByDispensary?: Maybe<GqlIrlEvent>;
  getIrlEventReward?: Maybe<GqlIrlEventRewardResponse>;
  getIrlEventRewardByDispensary?: Maybe<GqlIrlEventRewardResponse>;
  getKioskTerminals: Array<GqlKioskTerminal>;
  getLibraryProduct?: Maybe<GqlLibraryProduct>;
  getLocsByLspAccount: Array<GqlDiscountLoc>;
  getLoyaltyPassUrl?: Maybe<GqlLoyaltyPassUrl>;
  getLspsByIsoRegionCodeForDiscounts: Array<GqlDiscountLsp>;
  getMarketingCampaigns?: Maybe<GqlMarketingCampaignsResponse>;
  getMarketingCoupons?: Maybe<GqlMarketingCouponsResponse>;
  getMarketingDataPoints?: Maybe<GqlMarketingDataPointsResponse>;
  getMarketingSpecials?: Maybe<GqlMarketingSpecialsResponse>;
  /** get MarketplaceProduct information from a given id */
  getMarketplaceProduct: GqlMarketplaceProduct;
  /** Gets location based stats for a Marketplace Product */
  getMarketplaceProductLocationStats: GqlMarketplaceProductLocationStats;
  getMenuSections?: Maybe<Array<Maybe<GqlMenuSection>>>;
  getMenuSectionsAdmin?: Maybe<Array<Maybe<GqlMenuSection>>>;
  getMonerisTokenizationProfile?: Maybe<GqlMonerisTokenizationProfile>;
  /** @deprecated Use getRecommendedProducts. */
  getMostPurchasedProducts?: Maybe<Array<GqlMongoProduct>>;
  getOrder?: Maybe<GqlGetOrderType>;
  getOrderForDelivery?: Maybe<GqlOrders>;
  getOrders?: Maybe<GqlAdminOrderListType>;
  getPaymentStatus: GqlRethinkStatus;
  getPaymentsCheckoutCredentials?: Maybe<GqlPaymentsCheckoutCredentials>;
  getPersonalizedProducts?: Maybe<GqlPersonalizedProducts>;
  getPersonalizedProductsV2?: Maybe<GqlPersonalizedProducts>;
  getPlusApiKeys?: Maybe<Array<GqlPlusApiKey>>;
  getPlusEnterpriseApiKeys?: Maybe<Array<GqlPlusApiKey>>;
  getPlusOAuthProviders: Array<Maybe<GqlPlusOAuthProvider>>;
  getPopularDispensaries: Array<GqlPopularDispensary>;
  getPosMedCardInfo?: Maybe<GqlPosMedCardInfo>;
  getProductBuyingOptions?: Maybe<GqlProductBuyingOptionsResult>;
  getProductDemandCounts?: Maybe<Array<Maybe<GqlProductDemandCount>>>;
  getProductSalesByCategory?: Maybe<GqlProductsSalesByCategory>;
  getPromo: GqlPromo;
  getPublicContextSession?: Maybe<GqlPublicContextSession>;
  getPurchaseOrder: GqlPurchaseOrderDetail;
  getPurchaseOrders: Array<Maybe<GqlPurchaseOrder>>;
  getRawAchBatchFile?: Maybe<GqlGetRawAchBatchFileResponse>;
  getRecentlyViewedProducts?: Maybe<Array<GqlProducts>>;
  getRecentlyViewedProductsV2?: Maybe<Array<GqlMongoProduct>>;
  getRecommendedProducts: Array<GqlProducts>;
  getRegionsListForDiscounts: Array<GqlDiscountRegion>;
  getRemoteIntegrationValue?: Maybe<Scalars['String']['output']>;
  getReportingBrands: GqlReportingBrands;
  getReservationSlotsByOrderType?: Maybe<GqlMaxReservationSlotsByOrderType>;
  getRetailer?: Maybe<GqlRetailer>;
  getRetailerByDispensaryId?: Maybe<Array<Maybe<GqlRetailer>>>;
  getRetailerEnrollmentStatus?: Maybe<GqlRetailerEnrollment>;
  getRetailersByEnterpriseId?: Maybe<Array<Maybe<GqlRetailer>>>;
  getRewardsV2?: Maybe<GqlRewardsListV2>;
  getSortedProductRecommendations?: Maybe<GqlProductRecommendations>;
  getSpecialGamification?: Maybe<GqlSpecialGamificationList>;
  getSpecialMenuCards?: Maybe<GqlSpecialMenuCardResponse>;
  getSpecialsHistory?: Maybe<GqlSpecialsHistory>;
  getSponsoredBrand?: Maybe<GqlSponsoredBrand>;
  getSponsoredProducts: Array<GqlProducts>;
  getStateLibraries: Array<GqlStateLibrary>;
  getStockImage?: Maybe<GqlStockImage>;
  getStrain?: Maybe<GqlStrain>;
  getSubcategoriesListForDiscountRequirements: GqlDiscountSubcategoryList;
  getSubscriptionsV2: Array<Maybe<GqlSubscriptionV2>>;
  getTerpene?: Maybe<GqlTerpene>;
  getTimezone?: Maybe<GqlGetTimezoneResult>;
  getTopProduct?: Maybe<GqlTopProduct>;
  getTrackedCart?: Maybe<GqlTrackedCart>;
  getTrendingBrands?: Maybe<GqlTrendingBrandsResponse>;
  getUserIncentiveEligibility?: Maybe<GqlGetUserStatusResponse>;
  getUserQuery?: Maybe<GqlUsers>;
  healthCheck?: Maybe<GqlHealthCheck>;
  hubspotCrmProperties?: Maybe<GqlCrmProperties>;
  hubspotPipelineProperties?: Maybe<GqlPipelineProperties>;
  /** @deprecated Use libraryProductChangeImpactV3 mutation */
  libraryProductChangeImpactV2?: Maybe<GqlLibraryProductChangeImpactResponse>;
  listAccountBalances?: Maybe<GqlListAccountBalancesResponse>;
  listAchBatches?: Maybe<GqlListAchBatchesResponse>;
  /** @deprecated Use listAchEntriesV4 */
  listAchEntries?: Maybe<GqlListAchEntriesResponse>;
  /** @deprecated Use listAchEntriesV4 */
  listAchEntriesV3?: Maybe<GqlListAchEntriesResponseV3>;
  listAchEntriesV4?: Maybe<GqlListAchEntriesResponseV3>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturns?: Maybe<GqlListAchReturnsResponse>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturnsV3?: Maybe<GqlListAchReturnsResponseV3>;
  /** @deprecated Use listAchReturnsV5 */
  listAchReturnsV4?: Maybe<GqlListAchReturnsResponseV4>;
  listAchReturnsV5?: Maybe<GqlListAchReturnsResponseV5>;
  /** @deprecated Only used for MX, we no longer use MX */
  listBankAccounts?: Maybe<GqlMxBankAccounts>;
  listBrandFundedDiscountQualifiedProducts: GqlBrandFundedDiscountQualifiedProductList;
  listBrandFundedDiscounts: GqlBrandFundedDiscountList;
  listBrands: GqlBrandList;
  listEntities?: Maybe<GqlListEntitiesResponse>;
  listEntityFraudAssessments?: Maybe<GqlGetAchPaymentFraudAssessmentsResponse>;
  listLibraryProducts?: Maybe<GqlLibraryProducts>;
  listLoyaltyPassDispensaries?: Maybe<GqlLoyaltyPassDispensaries>;
  listPurchaseOrders: GqlPurchaseOrderList;
  listRegions: Array<Maybe<GqlRegion>>;
  listRetailerPaymentTypesStatus?: Maybe<GqlRetailerPaymentTypes>;
  listTransactionFraudAssessments?: Maybe<GqlGetAchPaymentFraudAssessmentsResponse>;
  /** @deprecated Use moving to V2 for scope change */
  matchLibraryProducts?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  matchLibraryProductsV2?: Maybe<Array<Maybe<GqlLibraryProduct>>>;
  matchingProducts?: Maybe<Array<Maybe<GqlProducts>>>;
  meAdmin?: Maybe<GqlIdentityAdmin>;
  meConsumer?: Maybe<GqlIdentityConsumer>;
  menuFilters?: Maybe<GqlMenuFilters>;
  menuFiltersV2?: Maybe<GqlMenuFilters>;
  pendingDispensaries?: Maybe<GqlPendingDispensariesResult>;
  printJob: GqlPrintJob;
  printers: Array<GqlPrinter>;
  productChangeEvents?: Maybe<Array<Maybe<GqlProductChangeEvent>>>;
  productFilters?: Maybe<GqlProductFilters>;
  salesOrdersQuery?: Maybe<GqlSalesOrdersQueryResponse>;
  searchBrandOverviewLsps: GqlBrandOverviewLspsSummary;
  searchBrandsV2?: Maybe<GqlBrandList>;
  searchBucketProducts?: Maybe<GqlSearchBucketProductsResponse>;
  searchEnterpriseByName?: Maybe<Array<Maybe<GqlEnterprise>>>;
  searchLibraryProducts?: Maybe<GqlLibraryProducts>;
  searchLspBrands: GqlLspBrandsList;
  searchProductChangeRequests?: Maybe<GqlContentChangeRequests>;
  /** Gets valid filters for Products in the search radius */
  searchProductFilters: Array<GqlSearchProductCategoryFilter>;
  /** Search Products in the marketplace based on a series of filters */
  searchProducts: GqlSearchProductsResult;
  secureImageUrlV2?: Maybe<GqlIdUrl>;
  showEnrollment: GqlShowEnrollmentResponse;
  /** @deprecated Use startAggregatorLinkV2 mutation */
  startAggregatorLink: GqlStartAggregatorLinkResponse;
  startAggregatorLinkV2: GqlStartAggregatorLinkV2Response;
  statesWithDispensaries: Array<GqlState>;
  superAdminCustomers?: Maybe<GqlCustomersList>;
  superProducts?: Maybe<GqlMenuCleanup>;
  testPlusOAuthProviders: GqlTestPlusOAuthProviderResponse;
  unsubscribeCustomerQuery?: Maybe<GqlCustomerUnsubscribe>;
  /** @deprecated To remove */
  userExistsCheck?: Maybe<GqlExists>;
  validateCouponQuery?: Maybe<GqlCouponValidationResponse>;
  validatePasswordResetTokenQuery?: Maybe<GqlValidationResponse>;
  validatePasswordTokenQuery?: Maybe<GqlValidationResponse>;
  verifyMxMember?: Maybe<GqlMxMemberVerification>;
};


export type GqlQueryAchReturnDetailReportArgs = {
  endDate?: InputMaybe<GqlPaymentsIsoDate>;
  startDate?: InputMaybe<GqlPaymentsIsoDate>;
};


export type GqlQueryNsfAchReturnReportArgs = {
  endDate?: InputMaybe<GqlPaymentsIsoDate>;
  startDate?: InputMaybe<GqlPaymentsIsoDate>;
};


export type GqlQueryActiveDispensariesArgs = {
  params?: InputMaybe<GqlActiveDispensariesInput>;
};


export type GqlQueryActiveProductsCheckArgs = {
  filter?: InputMaybe<GqlActiveProductsCheckInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryAddressResidentialCheckArgs = {
  input?: InputMaybe<GqlAddressResidentialCheckInput>;
};


export type GqlQueryArchivedProductLookupArgs = {
  cname: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryAvailableSegmentsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryBrandPortalProductSearchArgs = {
  filters?: InputMaybe<GqlBrandPortalProductSearchFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlBrandPortalProductSearchSort>;
};


export type GqlQueryBulkLibraryProductUpdateStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type GqlQueryBulkLibraryProductUploadStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type GqlQueryCalculateCheckoutArgs = {
  checkout: GqlCalculateCheckoutInput;
};


export type GqlQueryChainDispensariesByStatusArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryChainDispensaryIdsArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryChainDispensaryNamesAndIdsArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryChangeRequestProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryCheckAgeVerificationArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryCheckAllotmentArgs = {
  input: GqlAllotmentCheckInput;
};


export type GqlQueryCheckPurchaseLimitsArgs = {
  inputs: GqlCheckPurchaseLimitsInput;
};


export type GqlQueryComputeWithPriceCartArgs = {
  input: GqlCalculationsInput;
};


export type GqlQueryConnectNewProductPreviewArgs = {
  dispensaryId: Scalars['String']['input'];
  libraryProductId: Scalars['String']['input'];
};


export type GqlQueryConsumerPosOrderArgs = {
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type GqlQueryConsumerPosOrdersArgs = {
  dispensaryId: Scalars['String']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryCreatePaymentMethodArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  memberGuid: Scalars['String']['input'];
};


export type GqlQueryCurbsideArrivalsForDispensaryArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryDispensaryCustomersArgs = {
  filter?: InputMaybe<GqlCustomersFilterInput>;
  pagination?: InputMaybe<GqlCustomersPaginationInput>;
  sort?: InputMaybe<GqlCustomersSortInput>;
};


export type GqlQueryEnterpriseAdSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseLoyaltySettingsArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseMobileAppSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterprisePersonalizationSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseProductsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseProductsV2Args = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseSpecialsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryEnterpriseSpecialsV3Args = {
  enterpriseId: Scalars['ID']['input'];
  filter?: InputMaybe<GqlFilteredSpecialsInputV2>;
};


export type GqlQueryFilteredCouponsArgs = {
  filter?: InputMaybe<GqlCouponsFilterInput>;
  pagination?: InputMaybe<GqlCouponsPaginationInput>;
  sort?: InputMaybe<GqlCouponsSortInput>;
};


export type GqlQueryFilteredDispensariesArgs = {
  filter?: InputMaybe<GqlDispensariesFilterInput>;
};


export type GqlQueryFilteredIntegrationsArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryFilteredOrdersArgs = {
  filter?: InputMaybe<GqlOrdersFilterInput>;
  pagination?: InputMaybe<GqlOrdersPaginationInput>;
  sort?: InputMaybe<GqlOrdersSortInput>;
};


export type GqlQueryFilteredProductsArgs = {
  filter?: InputMaybe<GqlProductsFilterInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  showAllSpecialProducts?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryFilteredSpecialsArgs = {
  filter?: InputMaybe<GqlFilteredSpecialsInput>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryFilteredSpecialsV2Args = {
  filter?: InputMaybe<GqlFilteredSpecialsInput>;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryFilteredStrainsArgs = {
  filter?: InputMaybe<GqlStrainsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlStrainsSortInput>;
};


export type GqlQueryFilteredSubscriptionsArgs = {
  filter?: InputMaybe<GqlSubscriptionsFilterInput>;
};


export type GqlQueryFilteredTerpenesArgs = {
  filter?: InputMaybe<GqlTerpenesFilter>;
  sort?: InputMaybe<GqlTerpenesSort>;
};


export type GqlQueryFilteredUsersArgs = {
  filter?: InputMaybe<GqlUsersFilterInput>;
};


export type GqlQueryFindCustomizationProviderArgs = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryFindLibraryProductsArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryFundRethinkArgs = {
  ecommLocationId: Scalars['String']['input'];
};


export type GqlQueryGetAchPaymentDetailsArgs = {
  paymentId: Scalars['String']['input'];
};


export type GqlQueryGetAddressBasedDispensaryDataArgs = {
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
};


export type GqlQueryGetAdsInspectorEventsArgs = {
  input: GqlAdsInspectorEventsInput;
};


export type GqlQueryGetBackInStockSubscriptionStatusArgs = {
  productId: Scalars['String']['input'];
};


export type GqlQueryGetBankAccountsV2Args = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  paymentMethodIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryGetBillingSubscriptionsArgs = {
  dispensaries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GqlQueryGetBrandArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetBrandCampaignInsightsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandCampaignInsightsFilterInput>;
};


export type GqlQueryGetBrandCollisionsArgs = {
  filters?: InputMaybe<GqlBrandCollisionFilters>;
  pagination?: InputMaybe<GqlPagination>;
  sort?: InputMaybe<GqlBrandCollisionsSort>;
};


export type GqlQueryGetBrandEnterpriseSettingsArgs = {
  brandId: Scalars['String']['input'];
};


export type GqlQueryGetBrandExportsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandExportsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandExportsSortInput>;
};


export type GqlQueryGetBrandFundedDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetBrandImportHistoryArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandImportHistoryFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandImportHistorySortInput>;
};


export type GqlQueryGetBrandImportHistoryDetailArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandImportHistoryDetailFilterInput>;
  importId: Scalars['ID']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetBrandImportHistoryFailedRowsExportArgs = {
  brandId: Scalars['ID']['input'];
  importId: Scalars['ID']['input'];
};


export type GqlQueryGetBrandKeyMetricsArgs = {
  brandId: Scalars['ID']['input'];
};


export type GqlQueryGetBrandLocationCategoriesInsightsArgs = {
  brandId: Scalars['ID']['input'];
  dposLocationId: Scalars['ID']['input'];
  dposLspId: Scalars['ID']['input'];
  dposServerRegion: Scalars['String']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLocationProductsInsightsArgs = {
  brandId: Scalars['ID']['input'];
  dposLocationId: Scalars['ID']['input'];
  dposLspId: Scalars['ID']['input'];
  dposServerRegion: Scalars['String']['input'];
  filters?: InputMaybe<GqlProductInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLocationsInsightsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspCategoriesInsightsArgs = {
  brandId: Scalars['ID']['input'];
  dposLspId: Scalars['ID']['input'];
  dposServerRegion: Scalars['String']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspProductsInsightsArgs = {
  brandId: Scalars['ID']['input'];
  dposLspId: Scalars['ID']['input'];
  dposServerRegion: Scalars['String']['input'];
  filters?: InputMaybe<GqlProductInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandLspsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandLspsFilterInput>;
};


export type GqlQueryGetBrandLspsInsightsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlInsightsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlInsightsSortInput>;
};


export type GqlQueryGetBrandMergeHistoriesArgs = {
  filters?: InputMaybe<GqlBrandMergeHistoriesFilters>;
  page?: InputMaybe<GqlBrandMergeHistoriesPagination>;
  sort?: InputMaybe<GqlBrandMergeHistoriesSort>;
};


export type GqlQueryGetBrandOverviewLspsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandOverviewLspsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetBrandRegionsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandRegionsFilterInput>;
};


export type GqlQueryGetBrandUserArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetBrandUsersArgs = {
  filter?: InputMaybe<GqlBrandUsersFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandUsersSortInput>;
};


export type GqlQueryGetBrandsV2Args = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type GqlQueryGetBucketArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetBucketsArgs = {
  sort?: InputMaybe<GqlBrandsSortInput>;
};


export type GqlQueryGetChainsV2Args = {
  filter?: InputMaybe<GqlChainFilterInput>;
  pagination?: InputMaybe<GqlChainPaginationInput>;
  sort?: InputMaybe<GqlChainSortInput>;
};


export type GqlQueryGetChargebeeHostedPageArgs = {
  chargebeeCustomerId: Scalars['String']['input'];
  pageType: Scalars['String']['input'];
};


export type GqlQueryGetCheckoutArgs = {
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCollectionArgs = {
  collectionId: Scalars['String']['input'];
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCollectionProductCountArgs = {
  dispensaryId: Scalars['String']['input'];
  input: GqlGetCollectionProductCountInput;
};


export type GqlQueryGetCollectionsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCollectionsNavigationArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryGetConsumerStreamTokenArgs = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetConsumerUserArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetCurbsideArrivalByTokenArgs = {
  token: Scalars['String']['input'];
};


export type GqlQueryGetCurbsideArrivalsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCustomMobileMenuArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCustomNavigationArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetCustomerCommunicationSettingsArgs = {
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type GqlQueryGetDeliveryInfoArgs = {
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
};


export type GqlQueryGetDevicesArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetDispensariesAdSettingsByMenuVariantArgs = {
  input: GqlGetDispensariesAdSettingsByMenuVariantInput;
};


export type GqlQueryGetDispensariesByPersonalizationSettingsArgs = {
  input: GqlGetDispensariesByPersonalizationSettingsInput;
};


export type GqlQueryGetDispensaryCharitiesArgs = {
  dispensaryId: Scalars['String']['input'];
  menuType: Scalars['String']['input'];
};


export type GqlQueryGetDutchiePayEnrollmentArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlQueryGetDutchiePosLoyaltyConfigArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetEcommerceAbandonedCartsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetEnrollmentStatusArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlQueryGetEnterpriseArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetEnterpriseByNameArgs = {
  uniqueName: Scalars['ID']['input'];
};


export type GqlQueryGetEnterpriseSpecialArgs = {
  enterpriseSpecialId: Scalars['ID']['input'];
};


export type GqlQueryGetEnterpriseSpecialsHistoryArgs = {
  enterpriseId: Scalars['ID']['input'];
  enterpriseSpecialId: Scalars['ID']['input'];
};


export type GqlQueryGetEnterpriseSpecialsSettingsArgs = {
  enterpriseId: Scalars['ID']['input'];
};


export type GqlQueryGetExportArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetFilteredBrandSummariesArgs = {
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetFilteredProductSummariesArgs = {
  input: GqlProductsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetInstoreCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetInvoicePdfArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetIrlEventArgs = {
  enterpriseId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetIrlEventByDispensaryArgs = {
  dispensaryId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
};


export type GqlQueryGetIrlEventRewardArgs = {
  ecommUserId: Scalars['String']['input'];
  enterpriseId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetIrlEventRewardByDispensaryArgs = {
  dispensaryId: Scalars['String']['input'];
  ecommUserId: Scalars['String']['input'];
  irlEventId: Scalars['ID']['input'];
};


export type GqlQueryGetKioskTerminalsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetLibraryProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetLocsByLspAccountArgs = {
  lspAccount: GqlLspAccount;
};


export type GqlQueryGetLoyaltyPassUrlArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetLspsByIsoRegionCodeForDiscountsArgs = {
  isoRegionCode: Scalars['String']['input'];
};


export type GqlQueryGetMarketingCampaignsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketingCouponsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketingDataPointsArgs = {
  input: GqlAnalyticsInput;
};


export type GqlQueryGetMarketingSpecialsArgs = {
  input: GqlAnalyticsInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetMarketplaceProductArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetMarketplaceProductLocationStatsArgs = {
  bounds: GqlGeographicSearchBounds;
  marketplaceProductId: Scalars['ID']['input'];
};


export type GqlQueryGetMenuSectionsArgs = {
  dispensaryId: Scalars['String']['input'];
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryGetMenuSectionsAdminArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetMonerisTokenizationProfileArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetMostPurchasedProductsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetOrderForDeliveryArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetOrdersArgs = {
  input: GqlGetOrdersInput;
};


export type GqlQueryGetPaymentStatusArgs = {
  paymentId: Scalars['String']['input'];
};


export type GqlQueryGetPaymentsCheckoutCredentialsArgs = {
  adapter: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetPersonalizedProductsArgs = {
  input: GqlGetPersonalizedProductsInput;
};


export type GqlQueryGetPersonalizedProductsV2Args = {
  input: GqlGetPersonalizedProductsV2Input;
};


export type GqlQueryGetPlusApiKeysArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetPlusEnterpriseApiKeysArgs = {
  enterpriseId: Scalars['String']['input'];
};


export type GqlQueryGetPlusOAuthProvidersArgs = {
  enterpriseId: Scalars['String']['input'];
};


export type GqlQueryGetPopularDispensariesArgs = {
  lat: Scalars['String']['input'];
  lon: Scalars['String']['input'];
};


export type GqlQueryGetPosMedCardInfoArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetProductBuyingOptionsArgs = {
  bounds: GqlGeographicSearchBounds;
  marketplaceProductId: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<StringSortDirections>;
  weights?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryGetProductDemandCountsArgs = {
  dispensaryId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};


export type GqlQueryGetProductSalesByCategoryArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQueryGetPromoArgs = {
  id: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
};


export type GqlQueryGetPublicContextSessionArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetPurchaseOrderArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetPurchaseOrdersArgs = {
  filters?: InputMaybe<GqlPurchaseOrdersFilterInput>;
};


export type GqlQueryGetRawAchBatchFileArgs = {
  achBatchId: Scalars['String']['input'];
};


export type GqlQueryGetRecentlyViewedProductsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetRecentlyViewedProductsV2Args = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetRecommendedProductsArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetRemoteIntegrationValueArgs = {
  dispensaryId: Scalars['String']['input'];
  key: Scalars['String']['input'];
};


export type GqlQueryGetReportingBrandsArgs = {
  filters?: InputMaybe<GqlReportingBrandsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
};


export type GqlQueryGetReservationSlotsByOrderTypeArgs = {
  dispensaryId: Scalars['ID']['input'];
  reservationType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetRetailerArgs = {
  id: Scalars['ID']['input'];
};


export type GqlQueryGetRetailerByDispensaryIdArgs = {
  dispensaryIds: Array<Scalars['ID']['input']>;
};


export type GqlQueryGetRetailerEnrollmentStatusArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
};


export type GqlQueryGetRetailersByEnterpriseIdArgs = {
  enterpriseIds: Array<Scalars['ID']['input']>;
};


export type GqlQueryGetRewardsV2Args = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetSortedProductRecommendationsArgs = {
  input: GqlGetSortedProductRecommendationsInput;
};


export type GqlQueryGetSpecialGamificationArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GqlQueryGetSpecialMenuCardsArgs = {
  dispensaryId: Scalars['ID']['input'];
  ecomUserId?: InputMaybe<Scalars['String']['input']>;
  menuType: Scalars['String']['input'];
  platformType?: InputMaybe<Scalars['String']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetSpecialsHistoryArgs = {
  specialId: Scalars['ID']['input'];
};


export type GqlQueryGetSponsoredBrandArgs = {
  input: GqlGetSponsoredBrandInput;
};


export type GqlQueryGetSponsoredProductsArgs = {
  input: GqlGetSponsoredProductsInput;
};


export type GqlQueryGetStockImageArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetStrainArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetSubcategoriesListForDiscountRequirementsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryGetSubscriptionsV2Args = {
  retailers: Array<InputMaybe<GqlRetailerInput>>;
};


export type GqlQueryGetTerpeneArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryGetTimezoneArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  timeStamp?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryGetTopProductArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQueryGetTrackedCartArgs = {
  checkoutToken: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryGetTrendingBrandsArgs = {
  input: GqlBrandsSummaryInput;
  pagination?: InputMaybe<GqlAnalyticsPagination>;
  sort?: InputMaybe<GqlAnalyticsSort>;
};


export type GqlQueryGetUserIncentiveEligibilityArgs = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};


export type GqlQueryGetUserQueryArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryHubspotCrmPropertiesArgs = {
  integrationId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryHubspotPipelinePropertiesArgs = {
  integrationId?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryLibraryProductChangeImpactV2Args = {
  id: Scalars['String']['input'];
  updates: GqlUpdatedLibraryProduct;
};


export type GqlQueryListAccountBalancesArgs = {
  userId: Scalars['String']['input'];
};


export type GqlQueryListAchBatchesArgs = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  generatedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  generatedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  processedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  processedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
};


export type GqlQueryListAchEntriesArgs = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchEntriesV3Args = {
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryListAchEntriesV4Args = {
  achBatchId?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  effectiveStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  failedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  submittedEndDate?: InputMaybe<GqlPaymentsIsoDate>;
  submittedStartDate?: InputMaybe<GqlPaymentsIsoDate>;
  traceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsArgs = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['String']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsV3Args = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['Int']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['Int']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsV4Args = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['String']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListAchReturnsV5Args = {
  achEntryId?: InputMaybe<Scalars['String']['input']>;
  originalTraceNumber?: InputMaybe<Scalars['String']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnTraceNumber?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListBankAccountsArgs = {
  aggregator: Scalars['String']['input'];
};


export type GqlQueryListBrandFundedDiscountQualifiedProductsArgs = {
  filters?: InputMaybe<GqlBrandFundedDiscountQualifiedProductsFiltersInput>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlBrandFundedDiscountQualifiedProductsSortInput>;
};


export type GqlQueryListBrandFundedDiscountsArgs = {
  filters?: InputMaybe<GqlBrandFundedDiscountFiltersInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlBrandFundedDiscountSortInput>;
};


export type GqlQueryListBrandsArgs = {
  filters?: InputMaybe<GqlListBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlListBrandsSort>;
};


export type GqlQueryListEntitiesArgs = {
  externalType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryListEntityFraudAssessmentsArgs = {
  externalId: Scalars['String']['input'];
  externalType: Scalars['String']['input'];
};


export type GqlQueryListLibraryProductsArgs = {
  filters?: InputMaybe<GqlListLibraryProductsFilters>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlListLibraryProductsSort>;
};


export type GqlQueryListLoyaltyPassDispensariesArgs = {
  lspGlobalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lspIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type GqlQueryListPurchaseOrdersArgs = {
  filters?: InputMaybe<GqlPurchaseOrdersListFiltersInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlPurchaseOrdersSortInput>;
};


export type GqlQueryListRetailerPaymentTypesStatusArgs = {
  ecommLocationId: Scalars['String']['input'];
};


export type GqlQueryListTransactionFraudAssessmentsArgs = {
  transactionId: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
};


export type GqlQueryMatchLibraryProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMatchLibraryProductsV2Args = {
  brand?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMatchingProductsArgs = {
  bypassOnlineThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productLibraryState?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMenuFiltersArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  pricingType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryMenuFiltersV2Args = {
  category?: InputMaybe<Scalars['String']['input']>;
  checkMinSpendOffers?: InputMaybe<Scalars['Boolean']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  hasProductsOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  isKioskMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  pricingType?: InputMaybe<MenuPricingTypes>;
  search?: InputMaybe<Scalars['String']['input']>;
  showAllSpecialProducts?: InputMaybe<Scalars['Boolean']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GqlQueryPendingDispensariesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSortInput>;
};


export type GqlQueryPrintJobArgs = {
  id: Scalars['String']['input'];
};


export type GqlQueryPrintersArgs = {
  dispensaryId: Scalars['String']['input'];
};


export type GqlQueryProductChangeEventsArgs = {
  productId: Scalars['ID']['input'];
};


export type GqlQuerySalesOrdersQueryArgs = {
  input: GqlSharedSalesInput;
};


export type GqlQuerySearchBrandOverviewLspsArgs = {
  brandId: Scalars['ID']['input'];
  filters?: InputMaybe<GqlBrandOverviewLspsFilterInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search: Scalars['String']['input'];
};


export type GqlQuerySearchBrandsV2Args = {
  filters?: InputMaybe<GqlSearchBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchBrandsSort>;
};


export type GqlQuerySearchBucketProductsArgs = {
  filter?: InputMaybe<GqlSearchBucketProductFilter>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlSearchBucketProductSort>;
};


export type GqlQuerySearchEnterpriseByNameArgs = {
  keyword: Scalars['String']['input'];
};


export type GqlQuerySearchLibraryProductsArgs = {
  filters?: InputMaybe<GqlSearchLibraryProductsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchLibraryProductsSort>;
};


export type GqlQuerySearchLspBrandsArgs = {
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlLspBrandSearchSort>;
};


export type GqlQuerySearchProductChangeRequestsArgs = {
  filters?: InputMaybe<GqlContentChangeRequestFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  sort?: InputMaybe<GqlContentChangeRequestSort>;
};


export type GqlQuerySearchProductFiltersArgs = {
  bounds: GqlGeographicSearchBounds;
};


export type GqlQuerySearchProductsArgs = {
  filters: GqlSearchProductsInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<StringSortDirections>;
};


export type GqlQuerySecureImageUrlV2Args = {
  id: Scalars['String']['input'];
};


export type GqlQueryStartAggregatorLinkArgs = {
  aggregator: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  linkCustomizationName?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryStartAggregatorLinkV2Args = {
  aggregator: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  linkCustomizationName?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};


export type GqlQuerySuperAdminCustomersArgs = {
  filter?: InputMaybe<GqlSuperAdminCustomersFilter>;
  pagination?: InputMaybe<GqlCustomersPaginationInput>;
  sort?: InputMaybe<GqlCustomersSortInput>;
};


export type GqlQuerySuperProductsArgs = {
  filter?: InputMaybe<GqlSuperProductsInput>;
};


export type GqlQueryTestPlusOAuthProvidersArgs = {
  enterpriseId: Scalars['String']['input'];
};


export type GqlQueryUnsubscribeCustomerQueryArgs = {
  customerId: Scalars['String']['input'];
};


export type GqlQueryUserExistsCheckArgs = {
  input?: InputMaybe<GqlUserIdExistsInput>;
};


export type GqlQueryValidateCouponQueryArgs = {
  code: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  isReapplying?: InputMaybe<Scalars['Boolean']['input']>;
  orderSubtotalInCents: Scalars['Int']['input'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<GqlCouponValidationProductInput>>>;
};


export type GqlQueryValidatePasswordResetTokenQueryArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryValidatePasswordTokenQueryArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type GqlQueryVerifyMxMemberArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  memberGuid: Scalars['String']['input'];
};

export type GqlRadius = {
  __typename?: 'Radius';
  default?: Maybe<RadiusOption>;
};

export type GqlRadiusInput = {
  default?: InputMaybe<RadiusOption>;
};

export enum RadiusOption {
  rounded = 'ROUNDED',
  roundedRectangle = 'ROUNDED_RECTANGLE',
  square = 'SQUARE'
}

export enum RangeBehaviors {
  betweenXAndY = 'BETWEEN_X_AND_Y',
  everyX = 'EVERY_X',
  fromXToY = 'FROM_X_TO_Y'
}

export type GqlRecordUserAcceptanceResponse = {
  __typename?: 'RecordUserAcceptanceResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlRedemption = {
  __typename?: 'Redemption';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lspId?: Maybe<Scalars['String']['output']>;
  lspName?: Maybe<Scalars['String']['output']>;
  receiverUserId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlRedemptionInput = {
  dispensaryId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  program: Scalars['String']['input'];
  rewardId: Scalars['String']['input'];
  rewardType: Scalars['String']['input'];
};

export type GqlReferralCode = {
  __typename?: 'ReferralCode';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  learnMoreUrl?: Maybe<Scalars['String']['output']>;
  lspName?: Maybe<Scalars['String']['output']>;
  receiverPoints?: Maybe<Scalars['String']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  senderEcommId?: Maybe<Scalars['String']['output']>;
  senderPoints?: Maybe<Scalars['String']['output']>;
  senderPosUniqueId?: Maybe<Scalars['String']['output']>;
};

export type GqlRegion = {
  __typename?: 'Region';
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subdivision?: Maybe<Scalars['String']['output']>;
  subdivisionName?: Maybe<Scalars['String']['output']>;
};

export enum RejectionReasons {
  compliance = 'compliance',
  incompleteInfo = 'incomplete_info',
  photoGuidelines = 'photo_guidelines'
}

export type GqlRemoteExtensions = {
  __typename?: 'RemoteExtensions';
  builderKey?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<GqlRemoteExtensionsConfiguration>;
};

export type GqlRemoteExtensionsConfiguration = {
  __typename?: 'RemoteExtensionsConfiguration';
  extensionData?: Maybe<Array<GqlExtensionData>>;
  manifestUrl?: Maybe<Scalars['String']['output']>;
  modulePath?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

export type GqlRemoteExtensionsInput = {
  extensionData?: InputMaybe<Array<GqlExtensionDataInput>>;
  manifestUrl: Scalars['String']['input'];
  modulePath: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

export type GqlRemoveCategoryMenuOrderInput = {
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};

export type GqlReportingBrand = {
  __typename?: 'ReportingBrand';
  brandId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentBrandId?: Maybe<Scalars['ID']['output']>;
};

export type GqlReportingBrands = {
  __typename?: 'ReportingBrands';
  brands: Array<GqlReportingBrand>;
  meta?: Maybe<GqlQueryInfoType>;
};

export type GqlReportingBrandsFilterInput = {
  parentBrandsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlReservationConfig = {
  __typename?: 'ReservationConfig';
  /** @deprecated replaced by reservationsAvailableByOrderType */
  delivery?: Maybe<GqlReservationOptionsForOrderType>;
  /** @deprecated replaced by orderTypesConfigV2 */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated replaced by reservationsAvailableByOrderType */
  pickup?: Maybe<GqlReservationOptionsForOrderType>;
};

export type GqlReservationConfigInput = {
  delivery?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  pickup?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
};

export type GqlReservationOptionsForOrderType = {
  __typename?: 'ReservationOptionsForOrderType';
  advancedDayOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  advancedDayOrderingLimit?: Maybe<Scalars['Int']['output']>;
  incrementInMinutes?: Maybe<Scalars['Int']['output']>;
  maxReservationSlotsByDate?: Maybe<Array<Maybe<GqlMaxReservationSlot>>>;
  maxReservationSlotsByDay?: Maybe<GqlMaxReservationSlotsByDay>;
  nextAvailableInMinutes?: Maybe<Scalars['Int']['output']>;
  orderLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  sameDayDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlReservationOptionsForOrderTypeInput = {
  advancedDayOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  advancedDayOrderingLimit?: InputMaybe<Scalars['Int']['input']>;
  incrementInMinutes: Scalars['Int']['input'];
  maxReservationSlotsByDate?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  maxReservationSlotsByDay?: InputMaybe<GqlMaxReservationSlotsByDayInput>;
  nextAvailableInMinutes: Scalars['Int']['input'];
  orderLimitsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sameDayDeliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReservationSlotTypes {
  all = 'all',
  curbsidePickup = 'curbsidePickup',
  delivery = 'delivery',
  driveThruPickup = 'driveThruPickup',
  inStorePickup = 'inStorePickup'
}

export type GqlReservationSlotsCreateInput = {
  curbsidePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  delivery?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  orderType?: InputMaybe<ReservationSlotTypes>;
  timezone: Scalars['String']['input'];
};

export type GqlReservationSlotsForOrderType = {
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelPrefix?: InputMaybe<Scalars['String']['input']>;
  reservation?: InputMaybe<GqlReservationsAvailableForOrderType>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlReservationSlotsInfoForOrderTypeInput = {
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  enableASAPOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<GqlWeeklyHoursInput>;
  scheduledOrderingConfig?: InputMaybe<GqlReservationOptionsForOrderTypeInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsInput>>>;
};

export type GqlReservationSlotsUpdateInput = {
  curbsidePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  delivery?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInputV2>>>;
  dispensaryId: Scalars['String']['input'];
  driveThruPickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  inStorePickup?: InputMaybe<GqlReservationSlotsInfoForOrderTypeInput>;
  listOfReservationSlots?: InputMaybe<Array<InputMaybe<GqlMaxReservationSlotInput>>>;
  orderType?: InputMaybe<ReservationSlotTypes>;
  timezone: Scalars['String']['input'];
};

export type GqlReservationsAvailable = {
  __typename?: 'ReservationsAvailable';
  active?: Maybe<Scalars['Boolean']['output']>;
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  endTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
  isNextDaySlot?: Maybe<Scalars['Boolean']['output']>;
  quantityRemaining?: Maybe<Scalars['Int']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  startTimeISO?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlReservationsAvailableByOrderType = {
  __typename?: 'ReservationsAvailableByOrderType';
  curbsidePickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  delivery?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  driveThruPickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  inStorePickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
  /** @deprecated replaced by inStorePickup via rollout.use-updated-ordering-configurations */
  pickup?: Maybe<Array<Maybe<GqlReservationsAvailable>>>;
};

export type GqlReservationsAvailableForOrderType = {
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  endTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  quantityRemaining?: InputMaybe<Scalars['Int']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  startTimeISO?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlRespondToAchReturnResponse = {
  __typename?: 'RespondToAchReturnResponse';
  achReturnResponse: GqlAchReturnResponse;
};

export enum RestMethods {
  del = 'del',
  get = 'get',
  patch = 'patch',
  post = 'post',
  postMultipart = 'postMultipart',
  put = 'put'
}

export enum RestService {
  armageddon = 'armageddon',
  cms = 'cms'
}

export type GqlRestriction = {
  discountType?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum RestrictionType {
  all = 'ALL',
  brand = 'BRAND',
  category = 'CATEGORY',
  inventoryTag = 'INVENTORY_TAG',
  product = 'PRODUCT',
  productTag = 'PRODUCT_TAG',
  strain = 'STRAIN',
  subcategory = 'SUBCATEGORY',
  vendor = 'VENDOR',
  weight = 'WEIGHT'
}

export type GqlRetailer = {
  __typename?: 'Retailer';
  accountTier?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  assignedToBillingGroup?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  dispensaryId: Scalars['ID']['output'];
  enterprise?: Maybe<GqlEnterprise>;
  enterpriseId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  medLicense?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profile: GqlRetailerProfile;
  recLicense?: Maybe<Scalars['Boolean']['output']>;
  status: RetailerStatus;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlRetailerEnrollment = {
  __typename?: 'RetailerEnrollment';
  enrollment?: Maybe<GqlStatus>;
};

export type GqlRetailerInput = {
  assignedToBillingGroup?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type GqlRetailerPaymentTypes = {
  __typename?: 'RetailerPaymentTypes';
  paymentTypes: Array<Maybe<GqlPaymentTypeConfig>>;
};

export type GqlRetailerProfile = {
  __typename?: 'RetailerProfile';
  location?: Maybe<GqlRetailerProfileLocation>;
  medicalDispensary?: Maybe<Scalars['Boolean']['output']>;
  recDispensary?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlRetailerProfileLocation = {
  __typename?: 'RetailerProfileLocation';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum RetailerStatus {
  archived = 'archived',
  closed = 'closed',
  open = 'open',
  pending = 'pending'
}

export type GqlRethinkStatus = {
  __typename?: 'RethinkStatus';
  status: RethinkStatuses;
};

export enum RethinkStatuses {
  authorized = 'authorized',
  authorizing = 'authorizing',
  cancelled = 'cancelled',
  cancelling = 'cancelling',
  captured = 'captured',
  capturing = 'capturing',
  declined = 'declined',
  failed = 'failed',
  finalized = 'finalized',
  finalizing = 'finalizing',
  new = 'new',
  refundPending = 'refund_pending',
  refunded = 'refunded',
  refunding = 'refunding'
}

export type GqlReversePaymentResponse = {
  __typename?: 'ReversePaymentResponse';
  achReversal: GqlAchReversal;
};

export type GqlReverseSettlementResponse = {
  __typename?: 'ReverseSettlementResponse';
  achReversal: GqlAchReversal;
};

export type GqlReward = {
  __typename?: 'Reward';
  available?: Maybe<Scalars['Boolean']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<Scalars['String']['output']>;
  /** @deprecated using costV2 to change from Int to Float */
  cost?: Maybe<Scalars['Int']['output']>;
  costV2?: Maybe<Scalars['Float']['output']>;
  discountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  redemptionAttempts?: Maybe<Array<Maybe<GqlRewardRedemptionResponse>>>;
  rewardType?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  copy?: InputMaybe<Scalars['String']['input']>;
  discountId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rewardType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RewardRedeemBy {
  dutchie = 'Dutchie',
  pos = 'POS'
}

export type GqlRewardRedemptionDetails = {
  __typename?: 'RewardRedemptionDetails';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardRedemptionResponse = {
  __typename?: 'RewardRedemptionResponse';
  programResponse?: Maybe<GqlProgramResponse>;
  redeemBy?: Maybe<RewardRedeemBy>;
  status?: Maybe<RewardStatus>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum RewardStatus {
  pending = 'pending',
  redeemed = 'redeemed'
}

export enum RewardType {
  bundle = 'bundle',
  discountBundle = 'discountBundle',
  discountToCart = 'discountToCart',
  item = 'item',
  itemsForADiscount = 'itemsForADiscount',
  itemsForAPrice = 'itemsForAPrice'
}

export type GqlRewardUserResponse = {
  __typename?: 'RewardUserResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  wallet?: Maybe<GqlRewardsListV2>;
};

export type GqlRewardV2 = {
  __typename?: 'RewardV2';
  available: Scalars['Boolean']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<Scalars['String']['output']>;
  /** @deprecated using costV2 to change from Int to Float */
  cost: Scalars['Int']['output'];
  costV2: Scalars['Float']['output'];
  discountId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  isRedeemableOnline?: Maybe<Scalars['Boolean']['output']>;
  operator: Scalars['String']['output'];
  redemptionAttempts?: Maybe<Array<Maybe<GqlRewardRedemptionResponse>>>;
  rewardType: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlRewardValidationError = {
  __typename?: 'RewardValidationError';
  discountCode?: Maybe<Scalars['String']['output']>;
  discountId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardsActivity = {
  __typename?: 'RewardsActivity';
  comment?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  isAdjustment?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lspName?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
  transactionDateUtc?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type GqlRewardsIntegrationConfigurationInput = {
  rewardsProgramDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayEnrollment?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlRewardsList = {
  __typename?: 'RewardsList';
  auth?: Maybe<GqlUserAuthInfo>;
  balance?: Maybe<Scalars['String']['output']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']['output']>;
  rewardBrand?: Maybe<Scalars['String']['output']>;
  rewards: Array<Maybe<GqlReward>>;
  userHasWallet?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlRewardsListV2 = {
  __typename?: 'RewardsListV2';
  auth?: Maybe<GqlUserAuthInfo>;
  balance: Scalars['String']['output'];
  currentYearTierBalance?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']['output']>;
  isRevokedFromReferralProgram?: Maybe<Scalars['Boolean']['output']>;
  posCustomerId?: Maybe<Scalars['String']['output']>;
  posUniqueId?: Maybe<Scalars['String']['output']>;
  rewardBrand: Scalars['String']['output'];
  rewards: Array<Maybe<GqlRewardV2>>;
  rewardsActivity?: Maybe<Array<Maybe<GqlRewardsActivity>>>;
  tierId?: Maybe<Scalars['Int']['output']>;
  tierName?: Maybe<Scalars['String']['output']>;
  userHasWallet: Scalars['Boolean']['output'];
};

export type GqlRewards_Integration_Configuration = {
  __typename?: 'Rewards_integration_configuration';
  rewardsProgramDisplayDescription?: Maybe<Scalars['String']['output']>;
  rewardsProgramDisplayEnrollment?: Maybe<Scalars['String']['output']>;
  rewardsProgramDisplayName?: Maybe<Scalars['String']['output']>;
};

export type GqlRewards_Integration_ConfigurationInput = {
  rewardsProgramDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayEnrollment?: InputMaybe<Scalars['String']['input']>;
  rewardsProgramDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSaleDiscount = {
  __typename?: 'SaleDiscount';
  _id?: Maybe<Scalars['String']['output']>;
  brandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<DiscountType>;
  enterpriseProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclusions?: Maybe<Array<Maybe<GqlExclusion>>>;
  inventoryTags?: Maybe<Array<Scalars['String']['output']>>;
  productGroup?: Maybe<ProductGroup>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weightOperator?: Maybe<WeightOperator>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlSaleDiscountInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  enterpriseProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlExclusionInput>>>;
  inventoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  requiresSingleSku?: InputMaybe<Scalars['Boolean']['input']>;
  strainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightOperator?: InputMaybe<ComparisonOperators>;
  weights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlSaveCustomNavigationInput = {
  dispensaryId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  items: Array<GqlCustomNavigationItemInput>;
  label: Scalars['String']['input'];
  targetDispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlSchedule = {
  __typename?: 'Schedule';
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  id: Scalars['ID']['output'];
  startDate: Scalars['ISODateTime']['output'];
  timeRanges?: Maybe<Array<GqlTimeRange>>;
};

export type GqlScheduleInput = {
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISODateTime']['input'];
  timeRanges?: InputMaybe<Array<GqlTimeRangeInput>>;
};

export type GqlScheduledOrderingConfigV2 = {
  __typename?: 'ScheduledOrderingConfigV2';
  advancedDayOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  advancedDayOrderingLimit?: Maybe<Scalars['Int']['output']>;
  incrementInMinutes?: Maybe<Scalars['Int']['output']>;
  nextAvailableInMinutes?: Maybe<Scalars['Int']['output']>;
  orderLimitsEnabled?: Maybe<Scalars['Boolean']['output']>;
  sameDayDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlSearchBucketProductFilter = {
  endTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  reviewedBy?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  verified?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSearchBucketProductSort = {
  sortBy: SearchBucketProductSortByEnum;
  sortDirection: StringSortDirections;
};

export enum SearchBucketProductSortByEnum {
  reviewedAt = 'reviewedAt'
}

export type GqlSearchBucketProductsResponse = {
  __typename?: 'SearchBucketProductsResponse';
  bucketProducts?: Maybe<Array<Maybe<GqlBucketProduct>>>;
  meta?: Maybe<GqlBucketProductsMeta>;
};

export type GqlSearchProductCategoryFilter = {
  __typename?: 'SearchProductCategoryFilter';
  brands?: Maybe<Array<GqlSearchProductFilterBrand>>;
  category: ProductCategory;
  consumerTypes?: Maybe<Array<ProductConsumerType>>;
  src: Scalars['String']['output'];
  strainTypes?: Maybe<Array<Scalars['String']['output']>>;
  subcategories?: Maybe<Array<Scalars['String']['output']>>;
  weights?: Maybe<Array<Scalars['String']['output']>>;
};

export type GqlSearchProductFilterBrand = {
  __typename?: 'SearchProductFilterBrand';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Input object for the searchProducts query */
export type GqlSearchProductsInput = {
  bounds: GqlGeographicSearchBounds;
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cannabisTypes?: InputMaybe<Array<CannabisType>>;
  categories: Array<ProductCategory>;
  cbdPotency?: InputMaybe<GqlPotencyProductSearch>;
  consumerType?: InputMaybe<ProductConsumerType>;
  effects?: InputMaybe<Array<Effect>>;
  /** Deprecated: Remove with ticket ENG-14662. This field does nothing. Use cbdPotency and thcPotency instead. */
  potency?: InputMaybe<GqlPotencyProductSearch>;
  subcategories?: InputMaybe<Array<Scalars['String']['input']>>;
  thcPotency?: InputMaybe<GqlPotencyProductSearch>;
  weights?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlSearchProductsMetaResult = {
  __typename?: 'SearchProductsMetaResult';
  page?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Output from the searchProducts query */
export type GqlSearchProductsResult = {
  __typename?: 'SearchProductsResult';
  /** List of products found */
  marketplaceProducts?: Maybe<Array<GqlMarketplaceProductSearchResult>>;
  meta?: Maybe<GqlSearchProductsMetaResult>;
};

export type GqlSegment = {
  __typename?: 'Segment';
  audienceCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GqlSeoSettings = {
  __typename?: 'SeoSettings';
  enabled: Scalars['Boolean']['output'];
};

export type GqlSerializableContentChangeRequest = {
  __typename?: 'SerializableContentChangeRequest';
  actionType: ChangeRequestActionType;
  approvalStatus: Scalars['String']['output'];
  approvedAt?: Maybe<Scalars['ISODateTime']['output']>;
  authorId: Scalars['ID']['output'];
  brand?: Maybe<GqlBrand>;
  brandId: Scalars['ID']['output'];
  complianceRegionId?: Maybe<Scalars['ID']['output']>;
  computedAttributes?: Maybe<GqlContentChangeRequestComputedAttributes>;
  contentAttributes?: Maybe<GqlContentChangeRequestAttributes>;
  createdAt: Scalars['ISODateTime']['output'];
  createdBy?: Maybe<GqlUsers>;
  dispensary?: Maybe<GqlDispensaries>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<GqlLibraryProduct>;
  productId?: Maybe<Scalars['ID']['output']>;
  rejectedAt?: Maybe<Scalars['ISODateTime']['output']>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISODateTime']['output'];
};

export type GqlServiceFeeInput = {
  currency: Scalars['String']['input'];
  flatFeeCents?: InputMaybe<Scalars['Int']['input']>;
  percentageFee?: InputMaybe<Scalars['Float']['input']>;
};

export enum Services {
  acceptancesService = 'AcceptancesService',
  accountBalancesService = 'AccountBalancesService',
  achBatchesService = 'AchBatchesService',
  achEntriesService = 'AchEntriesService',
  achReturnReportsService = 'AchReturnReportsService',
  achReturnsService = 'AchReturnsService',
  achReversalsService = 'AchReversalsService',
  bankAccountsService = 'BankAccountsService',
  billingAddressesService = 'BillingAddressesService',
  customersService = 'CustomersService',
  eligibilityService = 'EligibilityService',
  enrollmentsService = 'EnrollmentsService',
  entitiesService = 'EntitiesService',
  entityLinkingsService = 'EntityLinkingsService',
  fraudAssessmentsService = 'FraudAssessmentsService',
  fraudEventsService = 'FraudEventsService',
  instoreAnalyticsTokensService = 'InstoreAnalyticsTokensService',
  instoreCartsService = 'InstoreCartsService',
  messageProxyService = 'MessageProxyService',
  paymentMethodsService = 'PaymentMethodsService',
  paymentsService = 'PaymentsService',
  preAuthsService = 'PreAuthsService',
  registrationService = 'RegistrationService',
  retailerEnrollmentsService = 'RetailerEnrollmentsService',
  retailerPaymentTypesService = 'RetailerPaymentTypesService',
  walletsService = 'WalletsService',
  widgetUrlService = 'WidgetUrlService'
}

export type GqlSetCategoryFeaturedBrandsInput = {
  brandIds: Array<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
};

export type GqlSetCategoryFeaturedProductsInput = {
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type GqlSetCategoryMenuOrderInput = {
  category: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  menuOrder: CategoryMenuOrder;
};

export type GqlSetGlobalMenuOrderInput = {
  dispensaryId: Scalars['String']['input'];
  menuOrder: GlobalMenuOrder;
};

export type GqlSharedSalesInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  clientTimezone?: InputMaybe<Scalars['String']['input']>;
  customerType?: InputMaybe<CustomerType>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  orderType?: InputMaybe<OrderType>;
  prevEndDate?: InputMaybe<Scalars['String']['input']>;
  prevStartDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type GqlShowEnrollmentResponse = {
  __typename?: 'ShowEnrollmentResponse';
  enrollmentStatus: StatusTypes;
  paymentMethods: Array<Maybe<GqlBankAccountPaymentMethod>>;
  requiresAggregatorMigration?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlShowInstoreCartResponse = {
  __typename?: 'ShowInstoreCartResponse';
  instoreCartData?: Maybe<GqlInstoreCartDataType>;
};

export enum SkipReasonEnum {
  combinedWeights = 'COMBINED_WEIGHTS',
  conflictingData = 'CONFLICTING_DATA',
  insufficientData = 'INSUFFICIENT_DATA',
  libraryGap = 'LIBRARY_GAP',
  libraryGapWithTemplate = 'LIBRARY_GAP_WITH_TEMPLATE',
  other = 'OTHER'
}

export enum SortByOptions {
  sourceBrandProductsCount = 'sourceBrandProductsCount',
  targetBrandProductsCount = 'targetBrandProductsCount'
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type GqlSortOrderInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GqlSpecialSortOrder>>>;
};

export type GqlSortProductProxy = {
  DispensaryID: Scalars['String']['input'];
  _id: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

export enum SpecialApplicationMethodTypes {
  automatic = 'AUTOMATIC',
  byAlpineiq = 'BY_ALPINEIQ',
  byCode = 'BY_CODE',
  byFyllo = 'BY_FYLLO',
  bySpringbig = 'BY_SPRINGBIG',
  manual = 'MANUAL'
}

export type GqlSpecialEmail = {
  __typename?: 'SpecialEmail';
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialEmailInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialGamificationList = {
  __typename?: 'SpecialGamificationList';
  gamificationThresholds?: Maybe<Array<Maybe<GqlGamificationDetailItem>>>;
};

export type GqlSpecialHours = {
  __typename?: 'SpecialHours';
  endDate: Scalars['String']['output'];
  hoursPerDay?: Maybe<Array<Maybe<GqlSpecialHoursDay>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type GqlSpecialHoursDay = {
  __typename?: 'SpecialHoursDay';
  date: Scalars['String']['output'];
  /** @deprecated new SpecialHoursDay in hours-settings is order type agnostic */
  deliveryHours: GqlDayBounds;
  hours: GqlDayBounds;
  /** @deprecated new SpecialHoursDay in hours-settings is order type agnostic */
  pickupHours: GqlDayBounds;
};

export type GqlSpecialHoursSettingsDayInput = {
  date: Scalars['String']['input'];
  hours: GqlDayBoundsInput;
};

export type GqlSpecialHoursSettingsInput = {
  endDate: Scalars['String']['input'];
  hoursPerDay?: InputMaybe<Array<InputMaybe<GqlSpecialHoursSettingsDayInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GqlSpecialMenuCard = {
  __typename?: 'SpecialMenuCard';
  _id?: Maybe<Scalars['String']['output']>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  posDiscountId?: Maybe<Scalars['String']['output']>;
  specialType?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialMenuCardResponse = {
  __typename?: 'SpecialMenuCardResponse';
  menuCards?: Maybe<Array<Maybe<GqlSpecialMenuCard>>>;
};

export type GqlSpecialMenuDisplay = {
  __typename?: 'SpecialMenuDisplay';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialMenuDisplayInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum SpecialMenuType {
  both = 'BOTH',
  medical = 'MEDICAL',
  recreational = 'RECREATIONAL'
}

export type GqlSpecialRestriction = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<GqlRestriction>;
};

export type GqlSpecialRestrictions = {
  __typename?: 'SpecialRestrictions';
  key: Scalars['String']['output'];
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<Scalars['String']['output']>;
  weights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlSpecialRestrictionsInput = {
  key: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['String']['input']>;
  weightOperator?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialSchedule = {
  __typename?: 'SpecialSchedule';
  days?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  endDate?: Maybe<Scalars['ISODateTime']['output']>;
  endStamp?: Maybe<Scalars['ISODateTime']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startStamp?: Maybe<Scalars['ISODateTime']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialScheduleInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['ISODateTime']['input']>;
  endStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startStamp?: InputMaybe<Scalars['ISODateTime']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum SpecialScopes {
  enterprise = 'enterprise',
  retailer = 'retailer'
}

export enum SpecialSortKey {
  email = 'EMAIL',
  endStamp = 'END_STAMP',
  name = 'NAME',
  specialType = 'SPECIAL_TYPE',
  startStamp = 'START_STAMP'
}

export type GqlSpecialSortOrder = {
  _id?: InputMaybe<Scalars['String']['input']>;
  displayRank?: InputMaybe<Scalars['Int']['input']>;
};

export enum SpecialSource {
  dutchie = 'DUTCHIE',
  pos = 'POS'
}

export enum SpecialStatus {
  active = 'ACTIVE',
  archived = 'ARCHIVED'
}

export type GqlSpecialSummary = {
  __typename?: 'SpecialSummary';
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueChangePercentage?: Maybe<Scalars['Float']['output']>;
  clickThroughPercentage?: Maybe<Scalars['Float']['output']>;
  conversionChangePercentage?: Maybe<Scalars['Float']['output']>;
  conversionPercentage?: Maybe<Scalars['Float']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  emailSent?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  specialId?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum SpecialTemporalStatus {
  past = 'PAST',
  presentOrFuture = 'PRESENT_OR_FUTURE'
}

export enum SpecialType {
  coupon = 'COUPON',
  offer = 'OFFER',
  sale = 'SALE'
}

export enum SpecialTypes {
  bogo = 'bogo',
  sale = 'sale'
}

export type GqlSpecials = {
  __typename?: 'Specials';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  applicableToItemsOnSpecial?: Maybe<Scalars['Boolean']['output']>;
  applicationMethod?: Maybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: Maybe<Scalars['Boolean']['output']>;
  applyToNoGroups?: Maybe<Scalars['Boolean']['output']>;
  bogoConditionLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoConditions?: Maybe<Array<Maybe<GqlBogoConditionItem>>>;
  bogoRewardLogicOperator?: Maybe<Scalars['String']['output']>;
  bogoRewards?: Maybe<Array<Maybe<GqlBogoRewardItem>>>;
  clicks?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  conditionLogicOperator?: Maybe<LogicOperator>;
  conditions?: Maybe<Array<Maybe<GqlV4Condition>>>;
  consumerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  consumerTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  directPOSProductIdMapping?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  discountBundle?: Maybe<GqlDiscountBundle>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  discountToCart?: Maybe<GqlDiscountToCart>;
  discountedPrices?: Maybe<Scalars['JSON']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  dollarDiscount?: Maybe<Scalars['Boolean']['output']>;
  duplicatedFrom?: Maybe<Scalars['String']['output']>;
  eligibleProductOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<GqlSpecialEmail>;
  emailSpecial?: Maybe<Scalars['Boolean']['output']>;
  endDay?: Maybe<Scalars['String']['output']>;
  endStamp?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  endedBy?: Maybe<Scalars['String']['output']>;
  excludeConditionItemsFromRewards?: Maybe<Scalars['Boolean']['output']>;
  excludedProducts?: Maybe<Array<Maybe<GqlSpecialsExcludedProducts>>>;
  firstTimeConsumerOnly?: Maybe<Scalars['Boolean']['output']>;
  generatedByPOS?: Maybe<Scalars['Boolean']['output']>;
  globalApplicationRules?: Maybe<Array<Maybe<GqlApplicationRule>>>;
  globalConditionThresholds?: Maybe<Array<Maybe<GqlGlobalThreshold>>>;
  globalReward?: Maybe<GqlGlobalReward>;
  globalRewardThresholds?: Maybe<Array<Maybe<GqlGlobalThreshold>>>;
  heading?: Maybe<Scalars['String']['output']>;
  inactiveDispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isAvailableOnline?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  itemsForAPrice?: Maybe<GqlItemsForAPrice>;
  loyaltyPointsToRedeem?: Maybe<Scalars['Int']['output']>;
  manualDefaultApplyTo?: Maybe<ManualDefaultApplyTo>;
  menuDisplay?: Maybe<GqlSpecialMenuDisplay>;
  menuDisplayDescription?: Maybe<Scalars['String']['output']>;
  menuDisplayImage?: Maybe<Scalars['String']['output']>;
  menuDisplayName?: Maybe<Scalars['String']['output']>;
  menuType?: Maybe<Scalars['String']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<OrderType>;
  origin?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  payByBankIncentiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentRestrictions?: Maybe<GqlPaymentRestrictions>;
  percentDiscount?: Maybe<Scalars['Boolean']['output']>;
  platformType?: Maybe<Array<Maybe<PlatformType>>>;
  preOrderType?: Maybe<Array<Maybe<PreOrderType>>>;
  productDiscounts?: Maybe<Scalars['JSON']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productGroupRewards?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quantityUsed?: Maybe<Scalars['Int']['output']>;
  rawPOSWeightMapping?: Maybe<Scalars['Boolean']['output']>;
  recurring?: Maybe<GqlSpecialsRecurring>;
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerCart?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']['output']>;
  reimbursed?: Maybe<Scalars['Boolean']['output']>;
  requireManagerApproval?: Maybe<Scalars['Boolean']['output']>;
  rewardLogicOperator?: Maybe<LogicOperator>;
  rewards?: Maybe<Array<Maybe<GqlV4Reward>>>;
  saleDiscounts?: Maybe<Array<Maybe<GqlSaleDiscount>>>;
  schedule?: Maybe<GqlSpecialSchedule>;
  scope?: Maybe<SpecialScopes>;
  /** @deprecated No longer needed 11/21/24 */
  skipV4Merge?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use _id instead 5/21/2021 */
  specialId?: Maybe<Scalars['String']['output']>;
  specialRestrictions?: Maybe<Scalars['JSON']['output']>;
  specialType?: Maybe<SpecialTypes>;
  specialVersion?: Maybe<Scalars['Int']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingMode?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startDay?: Maybe<Scalars['String']['output']>;
  startStamp?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SpecialStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<Scalars['Boolean']['output']>;
  totalAllowedUses?: Maybe<Scalars['Int']['output']>;
  totalQuantity?: Maybe<GqlTotalQuantity>;
  totalSpend?: Maybe<GqlTotalSpend>;
  totalWeight?: Maybe<GqlTotalWeight>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer needed 01/07/25 */
  useGreedOptimizedCalculator?: Maybe<Scalars['Boolean']['output']>;
  useLatestCartCalculator?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer needed 12/03/25 */
  useTotalQtyCalcsFix?: Maybe<Scalars['Boolean']['output']>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlSpecialsExcludedBogo = {
  __typename?: 'SpecialsExcludedBOGO';
  Name?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialsExcludedBogoInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  _id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialsExcludedProducts = {
  __typename?: 'SpecialsExcludedProducts';
  Name?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Maybe<GqlSpecialsExcludedBogo>>>;
  key?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<Maybe<GqlSpecialsExcludedBogo>>>;
};

export type GqlSpecialsExcludedProductsInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  _id?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedBogoInput>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedBogoInput>>>;
};

export type GqlSpecialsHistory = {
  __typename?: 'SpecialsHistory';
  id?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<Maybe<GqlSpecials>>>;
};

export type GqlSpecialsInputV3 = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableToItemsOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  applicationMethod?: InputMaybe<SpecialApplicationMethodTypes>;
  applyRewardsToConditions?: InputMaybe<Scalars['Boolean']['input']>;
  applyToNoGroups?: InputMaybe<Scalars['Boolean']['input']>;
  bogoConditionLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoConditions?: InputMaybe<Array<InputMaybe<GqlBogoConditionItemInput>>>;
  bogoRewardLogicOperator?: InputMaybe<Scalars['String']['input']>;
  bogoRewards?: InputMaybe<Array<InputMaybe<GqlBogoRewardItemInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  conditionLogicOperator?: InputMaybe<LogicOperator>;
  conditions?: InputMaybe<Array<InputMaybe<GqlV4ConditionInput>>>;
  consumerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  directPOSProductIdMapping?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  discountBundle?: InputMaybe<GqlDiscountBundleInput>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  discountToCart?: InputMaybe<GqlDiscountToCartInput>;
  discountedPrices?: InputMaybe<Scalars['JSON']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  displayRank?: InputMaybe<Scalars['Int']['input']>;
  dollarDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['String']['input']>;
  editedStartStamp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<GqlSpecialEmailInput>;
  emailSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  endDay?: InputMaybe<Scalars['String']['input']>;
  endStamp?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  endedBy?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  excludeConditionItemsFromRewards?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<GqlSpecialsExcludedProductsInput>>>;
  firstTimeConsumerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  generatedByPOS?: InputMaybe<Scalars['Boolean']['input']>;
  globalApplicationRules?: InputMaybe<Array<InputMaybe<GqlApplicationRuleInput>>>;
  globalConditionThresholds?: InputMaybe<Array<InputMaybe<GqlGlobalThresholdInput>>>;
  globalReward?: InputMaybe<GqlGlobalRewardInput>;
  globalRewardThresholds?: InputMaybe<Array<InputMaybe<GqlGlobalThresholdInput>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  inactiveDispensaryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAvailableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  itemsForAPrice?: InputMaybe<GqlItemsForAPriceInput>;
  loyaltyPointsToRedeem?: InputMaybe<Scalars['Int']['input']>;
  manualDefaultApplyTo?: InputMaybe<ManualDefaultApplyTo>;
  menuDisplay?: InputMaybe<GqlSpecialMenuDisplayInput>;
  menuDisplayDescription?: InputMaybe<Scalars['String']['input']>;
  menuDisplayImage?: InputMaybe<Scalars['String']['input']>;
  menuDisplayName?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  minorVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<OrderType>;
  origin?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['String']['input']>;
  paymentRestrictions?: InputMaybe<GqlPaymentRestrictionsInput>;
  percentDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  platformType?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  preOrderType?: InputMaybe<Array<InputMaybe<PreOrderType>>>;
  productDiscounts?: InputMaybe<Array<InputMaybe<GqlProductDiscount>>>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productGroupRewards?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quantityUsed?: InputMaybe<Scalars['Int']['input']>;
  rawPOSWeightMapping?: InputMaybe<Scalars['Boolean']['input']>;
  recurring?: InputMaybe<GqlSpecialsInputRecurring>;
  redemptionLimit?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerCart?: InputMaybe<Scalars['Int']['input']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['Int']['input']>;
  requireManagerApproval?: InputMaybe<Scalars['Boolean']['input']>;
  rewardLogicOperator?: InputMaybe<LogicOperator>;
  rewards?: InputMaybe<Array<InputMaybe<GqlV4RewardInput>>>;
  saleDiscounts?: InputMaybe<Array<InputMaybe<GqlSaleDiscountInput>>>;
  schedule?: InputMaybe<GqlSpecialScheduleInput>;
  scope?: InputMaybe<SpecialScopes>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialRestrictions?: InputMaybe<Array<InputMaybe<GqlSpecialRestriction>>>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  specialVersion?: InputMaybe<Scalars['Int']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
  stackingMode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDay?: InputMaybe<Scalars['String']['input']>;
  startStamp?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  targetPrice?: InputMaybe<Scalars['Boolean']['input']>;
  totalAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<GqlTotalQuantityInput>;
  totalSpend?: InputMaybe<GqlTotalSpendInput>;
  totalWeight?: InputMaybe<GqlTotalWeightInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlSpecialsRecurring = {
  __typename?: 'SpecialsRecurring';
  days?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  setEndDate?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialsSettings = {
  __typename?: 'SpecialsSettings';
  discountBehavior?: Maybe<Scalars['String']['output']>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  discountStacking?: Maybe<Scalars['Boolean']['output']>;
  enableIndividualDiscountStacking?: Maybe<Scalars['Boolean']['output']>;
  enableIndividualSpecialPrecedence?: Maybe<Scalars['Boolean']['output']>;
  nonStackingBehavior?: Maybe<Scalars['String']['output']>;
  stackingBehavior?: Maybe<Scalars['String']['output']>;
};

export type GqlSpecialsSettingsInput = {
  discountBehavior?: InputMaybe<Scalars['String']['input']>;
  discountPrecedence?: InputMaybe<Scalars['String']['input']>;
  discountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualDiscountStacking?: InputMaybe<Scalars['Boolean']['input']>;
  enableIndividualSpecialPrecedence?: InputMaybe<Scalars['Boolean']['input']>;
  nonStackingBehavior?: InputMaybe<Scalars['String']['input']>;
  stackingBehavior?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSponsoredBrand = {
  __typename?: 'SponsoredBrand';
  campaignId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<GqlProducts>;
  trackers: GqlAdTrackers;
};

export type GqlSponsoredProduct = {
  __typename?: 'SponsoredProduct';
  product: GqlProducts;
  trackers: GqlAdTrackers;
};

export enum SponsoredProductsInventoryId {
  cartTopperProductAuc = 'cart_topper_product_auc',
  categoryProductAuc = 'category_product_auc',
  pdpProductAuc = 'pdp_product_auc',
  searchProductAuc = 'search_product_auc'
}

export enum StackingBehavior {
  compounding = 'COMPOUNDING',
  cumulative = 'CUMULATIVE',
  prohibited = 'PROHIBITED'
}

export type GqlStartAggregatorLinkResponse = {
  __typename?: 'StartAggregatorLinkResponse';
  mx: GqlMxLinkStart;
  plaid: GqlPlaidLinkStart;
};

export type GqlStartAggregatorLinkV2Response = {
  __typename?: 'StartAggregatorLinkV2Response';
  aerosync?: Maybe<GqlAeroSyncLinkStart>;
  plaid?: Maybe<GqlPlaidLinkStart>;
};

export type GqlStartPreAuthCheckResponse = {
  __typename?: 'StartPreAuthCheckResponse';
  channelName?: Maybe<Scalars['String']['output']>;
  checkId?: Maybe<Scalars['String']['output']>;
  status: StartPreAuthCheckResponseStatus;
};

export enum StartPreAuthCheckResponseStatus {
  statusFailed = 'STATUS_FAILED',
  statusPending = 'STATUS_PENDING',
  statusReady = 'STATUS_READY',
  statusUnspecified = 'STATUS_UNSPECIFIED'
}

export type GqlState = {
  __typename?: 'State';
  cities: Array<Maybe<Scalars['String']['output']>>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GqlStateLibrary = {
  __typename?: 'StateLibrary';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GqlStatus = {
  __typename?: 'Status';
  mx?: Maybe<GqlMxResponse>;
  status: StatusTypes;
};

export enum StatusTypes {
  statusAcceptTerms = 'STATUS_ACCEPT_TERMS',
  statusAccountDisconnected = 'STATUS_ACCOUNT_DISCONNECTED',
  statusAccountPending = 'STATUS_ACCOUNT_PENDING',
  statusAggregatorError = 'STATUS_AGGREGATOR_ERROR',
  statusEnrolled = 'STATUS_ENROLLED',
  statusNoAccount = 'STATUS_NO_ACCOUNT',
  statusUnenrolled = 'STATUS_UNENROLLED',
  statusUnspecified = 'STATUS_UNSPECIFIED'
}

export type GqlStockImage = {
  __typename?: 'StockImage';
  aliasOrder?: Maybe<Scalars['Int']['output']>;
  aliasRegex?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type GqlStrain = {
  __typename?: 'Strain';
  /** @deprecated Use id */
  _id?: Maybe<Scalars['String']['output']>;
  aromas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  potentialHealthBenefits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ratio?: Maybe<Scalars['String']['output']>;
  terpenes?: Maybe<Array<Maybe<GqlTerpene>>>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlStrainLabels = {
  __typename?: 'StrainLabels';
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GqlStrainList = {
  __typename?: 'StrainList';
  queryInfo?: Maybe<GqlQueryInfoType>;
  strains?: Maybe<Array<Maybe<GqlStrain>>>;
};

export enum StrainSortByEnum {
  description = 'description',
  effects = 'effects',
  imageUrl = 'imageUrl',
  name = 'name',
  potentialHealthBenefits = 'potentialHealthBenefits'
}

export enum StringSortDirections {
  asc = 'asc',
  desc = 'desc'
}

export type GqlSubscriptionCustomers = {
  __typename?: 'SubscriptionCustomers';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dateAdded?: Maybe<Scalars['String']['output']>;
  dispensary?: Maybe<GqlDispensaries>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  dispensaryName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  emailSubscription?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numOrders?: Maybe<Scalars['Float']['output']>;
  orderTotal?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  textSubscription?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GqlSubscriptionV2 = {
  __typename?: 'SubscriptionV2';
  assignedToBillingGroup?: Maybe<Scalars['Boolean']['output']>;
  chargebeePlan?: Maybe<GqlChargebeePlan>;
  chargebeeSubscription?: Maybe<GqlChargebeeSubscriptionV2>;
  dispensaryBilling?: Maybe<GqlDispensaryBillingV2>;
  id: Scalars['ID']['output'];
  manualPayments?: Maybe<Scalars['Boolean']['output']>;
  retailerId: Scalars['ID']['output'];
};

export type GqlSubscriptionsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlSubtotalItem = {
  __typename?: 'SubtotalItem';
  name: Scalars['String']['output'];
  valueCents: Scalars['Int']['output'];
};

export type GqlTag = {
  __typename?: 'Tag';
  tagId?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type GqlTaxApplyToInput = {
  hemp?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlTaxConfigTaxInput = {
  applyTo?: InputMaybe<GqlTaxApplyToInput>;
  deliveryPolicy?: InputMaybe<Scalars['String']['input']>;
  destinationRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeStateSalesTaxInDestinationRate?: InputMaybe<Scalars['Boolean']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  potency?: InputMaybe<Scalars['String']['input']>;
  potencyRate?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  recreational?: InputMaybe<Scalars['Boolean']['input']>;
  stages?: InputMaybe<Array<InputMaybe<GqlTaxStageInput>>>;
  taxBasis?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlTaxExistence = {
  __typename?: 'TaxExistence';
  med?: Maybe<GqlTaxExistenceInside>;
  rec?: Maybe<GqlTaxExistenceInside>;
};

export type GqlTaxExistenceInside = {
  __typename?: 'TaxExistenceInside';
  checkout?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
};

export type GqlTaxStageInput = {
  op?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum TaxType {
  bottleDeposit = 'bottleDeposit',
  cannabis = 'cannabis',
  sales = 'sales'
}

export type GqlTemporalLocation = {
  __typename?: 'TemporalLocation';
  coordinates?: Maybe<Scalars['JSONObject']['output']>;
  lastUpdatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  nearbyEnabled?: Maybe<Scalars['Boolean']['output']>;
  onDuty?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlTerminalReceiptOptions = {
  __typename?: 'TerminalReceiptOptions';
  birthdate?: Maybe<Scalars['Boolean']['output']>;
  customerNameOption?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['Boolean']['output']>;
  disableSocialImpact?: Maybe<Scalars['Boolean']['output']>;
  groupLineItemsBy?: Maybe<Scalars['String']['output']>;
  medical?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['Boolean']['output']>;
  potencyInfo?: Maybe<Scalars['Boolean']['output']>;
  sortLineItemsBy?: Maybe<Scalars['String']['output']>;
};

export type GqlTerpene = {
  __typename?: 'Terpene';
  aliasList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aromas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  potentialHealthBenefits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strains: Array<Maybe<GqlStrain>>;
  unitSymbol?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
};

export type GqlTestPlusOAuthProviderResponse = {
  __typename?: 'TestPlusOAuthProviderResponse';
  success: Scalars['Boolean']['output'];
};

export type GqlTextTransformInput = {
  buttons?: InputMaybe<TextTransformOption>;
  links?: InputMaybe<TextTransformOption>;
  tags?: InputMaybe<TextTransformOption>;
};

export enum TextTransformOption {
  lower = 'LOWER',
  sentence = 'SENTENCE',
  title = 'TITLE',
  upper = 'UPPER'
}

export type GqlTextTransforms = {
  __typename?: 'TextTransforms';
  buttons?: Maybe<TextTransformOption>;
  links?: Maybe<TextTransformOption>;
  tags?: Maybe<TextTransformOption>;
};

export type GqlThreshold = {
  __typename?: 'Threshold';
  comparisonOperator?: Maybe<ComparisonOperators>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  thresholdType?: Maybe<ThresholdType>;
  weight?: Maybe<GqlWeight>;
};

export type GqlThresholdInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  thresholdType?: InputMaybe<ThresholdType>;
  weight?: InputMaybe<GqlWeightInput>;
};

export enum ThresholdType {
  price = 'PRICE',
  quantity = 'QUANTITY',
  totalPrice = 'TOTAL_PRICE',
  totalQuantity = 'TOTAL_QUANTITY',
  totalWeight = 'TOTAL_WEIGHT',
  weight = 'WEIGHT'
}

export type GqlTimeRange = {
  __typename?: 'TimeRange';
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['String']['output'];
};

export type GqlTimeRangeInput = {
  dayOfWeek: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type GqlTimeoutConfig = {
  __typename?: 'TimeoutConfig';
  duration?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlTipValueInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlTopProduct = {
  __typename?: 'TopProduct';
  product?: Maybe<GqlProducts>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type GqlTotalQuantity = {
  __typename?: 'TotalQuantity';
  enabled: Scalars['Boolean']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalQuantityInput = {
  enabled: Scalars['Boolean']['input'];
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityOperator: ComparisonOperators;
};

export type GqlTotalSpend = {
  __typename?: 'TotalSpend';
  enabled: Scalars['Boolean']['output'];
  maximumSpend?: Maybe<Scalars['Float']['output']>;
  minimumSpend?: Maybe<Scalars['Float']['output']>;
  spendOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalSpendInput = {
  enabled: Scalars['Boolean']['input'];
  maximumSpend?: InputMaybe<Scalars['Float']['input']>;
  minimumSpend: Scalars['Float']['input'];
  spendOperator: ComparisonOperators;
};

export type GqlTotalWeight = {
  __typename?: 'TotalWeight';
  enabled: Scalars['Boolean']['output'];
  weight?: Maybe<Scalars['String']['output']>;
  weightOperator?: Maybe<ComparisonOperators>;
};

export type GqlTotalWeightInput = {
  enabled: Scalars['Boolean']['input'];
  weight: Scalars['String']['input'];
  weightOperator: ComparisonOperators;
};

export type GqlTrackIrlEventByDispensaryInput = {
  dispensaryId: Scalars['String']['input'];
  ecommUserId?: InputMaybe<Scalars['String']['input']>;
  event: IrlEventTrackingEvent;
  irlEventId: Scalars['ID']['input'];
  userCookie: Scalars['String']['input'];
};

export type GqlTrackIrlEventInput = {
  ecommUserId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId: Scalars['String']['input'];
  event: IrlEventTrackingEvent;
  irlEventId: Scalars['ID']['input'];
  isoRegionCode: Scalars['String']['input'];
  userCookie: Scalars['String']['input'];
};

export type GqlTrackedCart = {
  __typename?: 'TrackedCart';
  createdAt?: Maybe<Scalars['String']['output']>;
  dispensaryId: Scalars['String']['output'];
  order?: Maybe<Scalars['JSON']['output']>;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GqlTrending = {
  __typename?: 'Trending';
  brandId?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  dollarHistoryThisPeriod?: Maybe<Array<Maybe<GqlChangeHistoryObject>>>;
  percentChangeFromLastPeriod?: Maybe<Scalars['Float']['output']>;
};

export type GqlTrendingBrandsResponse = {
  __typename?: 'TrendingBrandsResponse';
  meta?: Maybe<GqlAnalyticsMeta>;
  trending?: Maybe<Array<Maybe<GqlTrending>>>;
};

export type GqlUnenrollEnrollmentResponse = {
  __typename?: 'UnenrollEnrollmentResponse';
  success: Scalars['Boolean']['output'];
};

export enum UnitOfMeasure {
  grams = 'grams',
  items = 'items',
  kilograms = 'kilograms',
  milligrams = 'milligrams',
  milliliters = 'milliliters',
  ounces = 'ounces',
  pounds = 'pounds'
}

export type GqlUpdateBillingGroupInput = {
  enterpriseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  notificationEmails: Array<InputMaybe<Scalars['String']['input']>>;
  payment: GqlPaymentMethodInput;
  retailers: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type GqlUpdateCollectionInput = {
  allConditions: Scalars['Boolean']['input'];
  audienceConditions?: InputMaybe<Array<GqlAudienceConditionInput>>;
  cardBadgeColor?: InputMaybe<Scalars['String']['input']>;
  cardBadgeEnabled: Scalars['Boolean']['input'];
  cardBadgeTitle?: InputMaybe<Scalars['String']['input']>;
  cardDisplayName?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<Scalars['String']['input']>;
  conditions: Array<InputMaybe<GqlUpdateConditionInput>>;
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isOutlet?: InputMaybe<Scalars['Boolean']['input']>;
  matchAllAudienceConditions?: InputMaybe<Scalars['Boolean']['input']>;
  navigationEnabled: Scalars['Boolean']['input'];
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  outletTimerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outletTimerMessage?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<GqlScheduleInput>;
  title: Scalars['String']['input'];
};

export type GqlUpdateCollectionPositionsInput = {
  productCollections: Array<GqlCollectionPositionsInput>;
};

export type GqlUpdateConditionInput = {
  condition: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  itemKey: Scalars['String']['input'];
  itemValue: Scalars['String']['input'];
  productCollectionId: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlUpdateEnterpriseAdSettingsResponse = {
  __typename?: 'UpdateEnterpriseAdSettingsResponse';
  adSettings: GqlDispensaryAdSettings;
};

export type GqlUpdateEnterprisePersonalizationSettingsResponse = {
  __typename?: 'UpdateEnterprisePersonalizationSettingsResponse';
  personalizationSettings: GqlDispensaryPersonalizationSettings;
};

export type GqlUpdateImageBannerInput = {
  _id: Scalars['String']['input'];
  alt?: InputMaybe<Scalars['String']['input']>;
  bannerType?: InputMaybe<ImageBannerType>;
  connectedId?: InputMaybe<Scalars['String']['input']>;
  connectedStatus?: InputMaybe<Scalars['String']['input']>;
  connectedType?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use platforms.link instead */
  link?: InputMaybe<Scalars['String']['input']>;
  mobileImage: Scalars['String']['input'];
  /** @deprecated Use platforms.openInNewTab instead */
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<GqlImageBannerPlatformInput>>>;
  position: Scalars['Int']['input'];
  schedule?: InputMaybe<GqlScheduleInput>;
};

export type GqlUpdateImageBannersInput = {
  imageBanners: Array<InputMaybe<GqlUpdateImageBannerInput>>;
};

export type GqlUpdateLibraryProductResponse = {
  __typename?: 'UpdateLibraryProductResponse';
  libraryProduct?: Maybe<GqlLibraryProduct>;
};

export type GqlUpdatePrinterInput = {
  deviceIdentifier: Scalars['String']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  queueConfig?: InputMaybe<GqlPrinterQueueConfigInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpdateRemoteExtensionsInput = {
  builderKey?: InputMaybe<Scalars['String']['input']>;
  theme: GqlRemoteExtensionsInput;
};

export type GqlUpdateSeoSettingsInput = {
  enabled: Scalars['Boolean']['input'];
};

export type GqlUpdateSingleDispensaryAdSettingsResponse = {
  __typename?: 'UpdateSingleDispensaryAdSettingsResponse';
  adSettings?: Maybe<GqlDispensaryAdSettings>;
  id: Scalars['String']['output'];
};

export type GqlUpdateSingleDispensaryPersonalizationSettingsResponse = {
  __typename?: 'UpdateSingleDispensaryPersonalizationSettingsResponse';
  id: Scalars['String']['output'];
  personalizationSettings?: Maybe<GqlDispensaryPersonalizationSettings>;
};

export type GqlUpdateWebCustomizationSettingsInput = {
  colorSettings: GqlColorSettingsInputV2;
  fontSettings: GqlFontSettingsInput;
};

export type GqlUpdateWebCustomizationSettingsV2Input = {
  categories?: InputMaybe<GqlCategoriesInput>;
  colors?: InputMaybe<GqlColorInput>;
  fonts?: InputMaybe<GqlFontInput>;
  mobile?: InputMaybe<GqlMobileCustomizationInput>;
  productCards?: InputMaybe<GqlProductCardsInput>;
  radius?: InputMaybe<GqlRadiusInput>;
  textTransforms?: InputMaybe<GqlTextTransformInput>;
};

export type GqlUpdatedLibraryProduct = {
  AdditionalOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  Description: Scalars['String']['input'];
  DispensaryID?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlLibraryProductPotencyInput>;
  _id?: InputMaybe<Scalars['String']['input']>;
  availableForWholesale?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  cannabinoids?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  cannabinoidsV2?: InputMaybe<Array<GqlLibraryProductCannabinoidsInputV2>>;
  caseSize?: InputMaybe<Scalars['Int']['input']>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  complianceRegionId?: InputMaybe<Scalars['String']['input']>;
  connectedCount?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<GqlLibraryProductLimitPerCustomerInput>>;
  manualInventory?: InputMaybe<Array<GqlLibraryProductManualInventoryInput>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']['input']>;
  msrpCents?: InputMaybe<Scalars['Int']['input']>;
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stockImage?: InputMaybe<Scalars['String']['input']>;
  stockImageAliases?: InputMaybe<Scalars['String']['input']>;
  stockImageCategory?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<GqlLibraryProductTerpenesInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wholesalePriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlUpsertPurchaseOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<GqlUpsertPurchaseOrderNoteInput>>;
  purchaseOrderItems?: InputMaybe<Array<GqlUpsertPurchaseOrderItemInput>>;
  status?: InputMaybe<PurchaseOrderStatus>;
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUpsertPurchaseOrderItemInput = {
  confirmedQuantity?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemStatus?: InputMaybe<PurchaseOrderItemStatus>;
  notes?: InputMaybe<Array<GqlUpsertPurchaseOrderNoteInput>>;
  substituteLibraryProductId?: InputMaybe<Scalars['String']['input']>;
  unitPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlUpsertPurchaseOrderNoteInput = {
  authorEmail: Scalars['String']['input'];
  authorParty: Scalars['String']['input'];
  content: Scalars['String']['input'];
  notableId?: InputMaybe<Scalars['String']['input']>;
  notableType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUserAuthInfo = {
  __typename?: 'UserAuthInfo';
  authTextMessageSent?: Maybe<Scalars['Boolean']['output']>;
  incorrectPinProvided?: Maybe<Scalars['Boolean']['output']>;
  pinConfirmed?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlUserEmails = {
  __typename?: 'UserEmails';
  address: Scalars['String']['output'];
  lastVerifiedAt?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlUserEnrollment = {
  __typename?: 'UserEnrollment';
  bankAccounts: Array<GqlBankAccount>;
  enrollment?: Maybe<GqlStatus>;
};

export enum UserRoles {
  super = 'SUPER',
  user = 'USER'
}

export type GqlUsers = {
  __typename?: 'Users';
  _id?: Maybe<Scalars['String']['output']>;
  audioNotificationsOnNewArrivalsDisabled?: Maybe<Scalars['Boolean']['output']>;
  audioNotificationsOnNewOrdersDisabled?: Maybe<Scalars['Boolean']['output']>;
  chainID?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  isWeeklyReportEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<GqlUsers_Permissions>;
  phone?: Maybe<Scalars['String']['output']>;
  roleAtDispensary?: Maybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GqlUsers_Permissions = {
  __typename?: 'Users_permissions';
  allLocations?: Maybe<Scalars['Boolean']['output']>;
  analytics?: Maybe<Scalars['Boolean']['output']>;
  billing?: Maybe<Scalars['Boolean']['output']>;
  customers?: Maybe<Scalars['Boolean']['output']>;
  dispensaryIds?: Maybe<Array<Scalars['String']['output']>>;
  driver?: Maybe<Scalars['Boolean']['output']>;
  enterpriseAdmin?: Maybe<Scalars['Boolean']['output']>;
  enterpriseSpecials?: Maybe<Scalars['Boolean']['output']>;
  menu?: Maybe<Scalars['Boolean']['output']>;
  menuReview?: Maybe<Scalars['Boolean']['output']>;
  messaging?: Maybe<Scalars['Boolean']['output']>;
  orders?: Maybe<Scalars['Boolean']['output']>;
  promote?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<Scalars['Boolean']['output']>;
  superMenuReview?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  users?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlValidationResponse = {
  __typename?: 'ValidationResponse';
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlVerifyLoginCodeResponse = {
  __typename?: 'VerifyLoginCodeResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  transferToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GqlIdentityConsumer>;
};

export enum Versions {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
  v4 = 'v4'
}

export type GqlWebCustomizationSettings = {
  __typename?: 'WebCustomizationSettings';
  colorSettings: GqlColorSettingsV2;
  fontSettings: GqlFontSettings;
};

export type GqlWebCustomizationSettingsV2 = {
  __typename?: 'WebCustomizationSettingsV2';
  categories?: Maybe<GqlCustomizedCategories>;
  colors?: Maybe<GqlColors>;
  fonts?: Maybe<GqlFonts>;
  mobile?: Maybe<GqlMobileCustomization>;
  productCards?: Maybe<GqlProductCards>;
  radius?: Maybe<GqlRadius>;
  textTransforms?: Maybe<GqlTextTransforms>;
};

export type GqlWeeklyHours = {
  __typename?: 'WeeklyHours';
  Friday?: Maybe<GqlDayBounds>;
  Monday?: Maybe<GqlDayBounds>;
  Saturday?: Maybe<GqlDayBounds>;
  Sunday?: Maybe<GqlDayBounds>;
  Thursday?: Maybe<GqlDayBounds>;
  Tuesday?: Maybe<GqlDayBounds>;
  Wednesday?: Maybe<GqlDayBounds>;
};

export type GqlWeeklyHoursInput = {
  Friday?: InputMaybe<GqlDayBoundsInput>;
  Monday?: InputMaybe<GqlDayBoundsInput>;
  Saturday?: InputMaybe<GqlDayBoundsInput>;
  Sunday?: InputMaybe<GqlDayBoundsInput>;
  Thursday?: InputMaybe<GqlDayBoundsInput>;
  Tuesday?: InputMaybe<GqlDayBoundsInput>;
  Wednesday?: InputMaybe<GqlDayBoundsInput>;
};

export type GqlWeight = {
  __typename?: 'Weight';
  amount?: Maybe<Scalars['Float']['output']>;
  weightUom?: Maybe<WeightUom>;
};

export type GqlWeightInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  weightUom?: InputMaybe<WeightUom>;
};

export enum WeightOperator {
  equalTo = 'equalTo',
  greaterThan = 'greaterThan',
  greaterThanEqualTo = 'greaterThanEqualTo',
  lessThan = 'lessThan',
  lessThanEqualTo = 'lessThanEqualTo'
}

export enum WeightUom {
  g = 'G',
  gc = 'GC',
  mg = 'MG',
  oz = 'OZ'
}

export type GqlActiveDispensariesInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<DispensaryOrderType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GqlActiveProductsCheckInput = {
  bypassThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isKiosk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlAddCustomerToOrderInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlAddressResidentialCheckInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GqlArchiveOrderInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  otherReasonText?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Orders_CancellationReasonIDs>;
  shouldNotifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlBrandCollisionFilters = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandNameQuery?: InputMaybe<Scalars['String']['input']>;
  collisionType?: InputMaybe<CollisionType>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandCollisionInput = {
  isAllowed: Scalars['Boolean']['input'];
};

export type GqlBrandCollisionsSort = {
  sortBy?: InputMaybe<SortByOptions>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GqlBrandEnterpriseSettingsInput = {
  adsEnabled: Scalars['Boolean']['input'];
  enterpriseId: Scalars['String']['input'];
};

export type GqlBrandInput = {
  aliasList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandMergeHistoriesFilters = {
  destinationBrandId?: InputMaybe<Scalars['String']['input']>;
  destinationDispensaryId?: InputMaybe<Scalars['String']['input']>;
  reverted?: InputMaybe<Scalars['Boolean']['input']>;
  sourceBrandId?: InputMaybe<Scalars['String']['input']>;
  sourceDispensaryId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandMergeHistoriesPagination = {
  number?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlBrandMergeHistoriesSort = {
  sortBy?: InputMaybe<BrandMergeHistoriesSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandPortalProductSearchFilters = {
  approvalStatus?: InputMaybe<BrandPortalProductSearchApprovalStatusFilterEnum>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  complianceRegion?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlBrandPortalProductSearchSort = {
  sortBy?: InputMaybe<BrandPortalProductSearchSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandUserCreateInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  manageAdCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrandGroup?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrands?: InputMaybe<Scalars['Boolean']['input']>;
  managedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentBrandId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
};

export type GqlBrandUserFocusedAccountInput = {
  dposLspId: Scalars['String']['input'];
  dposServerRegion: Scalars['String']['input'];
};

export type GqlBrandUserUpdateAccountInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type GqlBrandUserUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  focusedAccounts?: InputMaybe<Array<GqlBrandUserFocusedAccountInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  manageAdCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrandGroup?: InputMaybe<Scalars['Boolean']['input']>;
  manageBrands?: InputMaybe<Scalars['Boolean']['input']>;
  managedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandUsersFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBrandUsersSortInput = {
  sortBy?: InputMaybe<BrandUsersSortBy>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlBrandsSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

export type GqlCategoryPhotoInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
};

export type GqlColorSettingsInput = {
  linkColor?: InputMaybe<Scalars['String']['input']>;
  navBarColor?: InputMaybe<Scalars['String']['input']>;
};

export type GqlConsumerSignupDataInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  embedded: Scalars['Boolean']['input'];
};

export type GqlConsumerSignupInput = {
  data: GqlConsumerSignupDataInput;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profile: GqlConsumerSignupProfileInput;
};

export type GqlConsumerSignupMedicalCardInput = {
  expirationDate: Scalars['String']['input'];
  number: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type GqlConsumerSignupProfileInput = {
  address?: InputMaybe<GqlConsumerUserProfileAddress>;
  birthday: Scalars['String']['input'];
  driversLicense?: InputMaybe<Scalars['String']['input']>;
  emailNotifications: Scalars['Boolean']['input'];
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  medicalCard?: InputMaybe<GqlConsumerSignupMedicalCardInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  textNotifications: Scalars['Boolean']['input'];
};

export type GqlConsumerUserMedicalCard = {
  __typename?: 'consumerUserMedicalCard';
  expirationDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GqlConsumerUserMedicalCardInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GqlConsumerUserProfile = {
  __typename?: 'consumerUserProfile';
  birthday?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<GqlConsumerUserMedicalCard>;
  phone?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlConsumerUserProfileAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  ln2?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlConsumerUserProfileAddressType = {
  __typename?: 'consumerUserProfileAddressType';
  city?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  ln1?: Maybe<Scalars['String']['output']>;
  ln2?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GqlConsumerUserProfileInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<GqlConsumerUserProfileAddress>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  driversLicense?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inStoreEnrollmentCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicalCard?: InputMaybe<GqlConsumerUserMedicalCardInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  textNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCopuonApplicableCategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCouponApplicableCategory = {
  __typename?: 'couponApplicableCategory';
  category?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type GqlCouponRestrictions = {
  __typename?: 'couponRestrictions';
  minimumPurchase?: Maybe<Scalars['Boolean']['output']>;
  minimumPurchaseInCents?: Maybe<Scalars['Int']['output']>;
  noSpecials?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlCouponRestrictionsInput = {
  minimumPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPurchaseInCents?: InputMaybe<Scalars['Int']['input']>;
  noSpecials?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCouponValidationProductInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCoupon_ApplicableCategoriesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCouponsFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlApplicableCategoryInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCouponsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCouponsSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

export type GqlCreateBucketInput = {
  brandIds?: Array<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  connectionStatus?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryStatus?: InputMaybe<Scalars['String']['input']>;
  minimumConfidenceScore?: InputMaybe<Scalars['Int']['input']>;
  reviewStatus?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  thresholdFilter?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateBucketInputV3 = {
  brandIds?: Array<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  connectionStatus?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryStatus?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  thresholdFilter?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateCouponInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addedDate: Scalars['String']['input'];
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCopuonApplicableCategoryInput>>>;
  code: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  expDate: Scalars['String']['input'];
  fixedDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  numAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  numUses?: InputMaybe<Scalars['Int']['input']>;
  oneUsePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
};

export type GqlCustomCategoryPhotoInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCustomerExportInput = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  subscriptionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlCustomerUpdateInput = {
  _id: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCustomersFilterInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCustomersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCustomersSortInput = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDayBounds = {
  __typename?: 'dayBounds';
  active?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type GqlDayBoundsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  isNextDaySlot?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDeliveryZipCodesInput = {
  fee?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDeliveryZonesInput = {
  area?: InputMaybe<GqlPolygonInput>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensariesFilterInput = {
  acceptsCreditCardsDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsCreditCardsPickup?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsDutchiePay?: InputMaybe<Scalars['Boolean']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  cName?: InputMaybe<Scalars['String']['input']>;
  cNameOrID?: InputMaybe<Scalars['String']['input']>;
  chain?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  creditCards?: InputMaybe<Scalars['Boolean']['input']>;
  deliversToAddress?: InputMaybe<Scalars['Boolean']['input']>;
  destinationTaxState?: InputMaybe<Scalars['String']['input']>;
  destinationTaxZipcode?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  freeDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  getIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  hostDomain?: InputMaybe<Scalars['String']['input']>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  includeStealthMode?: InputMaybe<Scalars['Boolean']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  nearLat?: InputMaybe<Scalars['Float']['input']>;
  nearLng?: InputMaybe<Scalars['Float']['input']>;
  noMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  offerCurbsidePickup?: InputMaybe<Scalars['Boolean']['input']>;
  offerDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  offerPickup?: InputMaybe<Scalars['Boolean']['input']>;
  openForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  openForDeliveryRightNow?: InputMaybe<Scalars['Boolean']['input']>;
  openNowForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  openNowForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  recreational?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<DispensarySortByType>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryCustomerInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  ageVerified?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  textSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryDemoRequestInput = {
  dispensaryContactEmail?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactFirstName?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactLastName?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactName?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  dispensaryPos?: InputMaybe<Scalars['String']['input']>;
  dispensaryState?: InputMaybe<Scalars['String']['input']>;
  dispensaryType?: InputMaybe<Scalars['String']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
};

export type GqlDispensaryFeatureFlagOptions = {
  enableArrivals?: InputMaybe<Scalars['Boolean']['input']>;
  enableMenuImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatch?: InputMaybe<Scalars['Boolean']['input']>;
  enableNonTerminalAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  enablePausedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  hideDeliveryEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hideStoreHours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryMessagingSettingsInput = {
  disableReadyForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  disableStartDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryOnboardingInput = {
  dispensaryContactMethod?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactMethodValue?: InputMaybe<Scalars['String']['input']>;
  dispensaryContactName?: InputMaybe<Scalars['String']['input']>;
  dispensaryDelivery?: InputMaybe<Scalars['String']['input']>;
  dispensaryLogo?: InputMaybe<Scalars['String']['input']>;
  dispensaryLogoFileId?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  dispensaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  dispensaryPhoto?: InputMaybe<Scalars['String']['input']>;
  dispensaryPhotoFileId?: InputMaybe<Scalars['String']['input']>;
  dispensaryPos?: InputMaybe<Scalars['String']['input']>;
  dispensaryPosOther?: InputMaybe<Scalars['String']['input']>;
  dispensarySocialEquityEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryState?: InputMaybe<Scalars['String']['input']>;
  dispensaryTypeMedical?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryTypeRecreational?: InputMaybe<Scalars['Boolean']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
};

export type GqlDispensaryRemoveFromChainInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryStoreSettingsOptions = {
  collapseProductDescription?: InputMaybe<Scalars['Boolean']['input']>;
  customTermsText?: InputMaybe<Scalars['String']['input']>;
  defaultViewStyle?: InputMaybe<Scalars['Boolean']['input']>;
  disableGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  disableGuestDOB?: InputMaybe<Scalars['Boolean']['input']>;
  disablePurchaseLimits?: InputMaybe<Scalars['Boolean']['input']>;
  displayKioskAnonymousCheckoutDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  displayPhoneConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  dontCombineWeightedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  dontMapSubcategoriesByProductName?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomTerms?: InputMaybe<Scalars['Boolean']['input']>;
  enableDutchiePayConsumerSurcharge?: InputMaybe<Scalars['Boolean']['input']>;
  enableLimitPerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  enableOmniauthLoginCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  enableOrderStatusEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enableProductUrgencyMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  enableRoundToNearestDollar?: InputMaybe<Scalars['Boolean']['input']>;
  enableStorefrontAgeGate?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Age verification gate feature has been removed */
  hardAgeGateAgeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hardAgeGateHideMenuContent?: InputMaybe<Scalars['Boolean']['input']>;
  hideAddressFromDutchieMain?: InputMaybe<Scalars['Boolean']['input']>;
  hideDiscountsFromConsumer?: InputMaybe<Scalars['Boolean']['input']>;
  hideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  hideOutOfStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideRoundingLineItem?: InputMaybe<Scalars['Boolean']['input']>;
  isolatedMenus?: InputMaybe<Scalars['Boolean']['input']>;
  keepUncombinedWeights?: InputMaybe<Scalars['Boolean']['input']>;
  prioritizeStaffPicksInSearchResults?: InputMaybe<Scalars['Boolean']['input']>;
  provideBackInstockEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  quantityLimit?: InputMaybe<Scalars['Boolean']['input']>;
  quantityLimitMaxAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  requireEmailAddressForGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requirePaymentMethodSelection?: InputMaybe<Scalars['Boolean']['input']>;
  requireTermsAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  restrictSalesLanguage?: InputMaybe<Scalars['Boolean']['input']>;
  showLoyaltyRewards?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileAppSmartBanner?: InputMaybe<Scalars['Boolean']['input']>;
  showPOSPackageId?: InputMaybe<Scalars['Boolean']['input']>;
  stealthMode?: InputMaybe<Scalars['Boolean']['input']>;
  usePotencyForConcentrateLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStandardEquivalentForEdiblesLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStateRegulatedImageWatermarks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateCategoryLimits = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateCustomDomainSettings = {
  cloudflareDomain?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateEmbedSettings = {
  applyToAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  autoGTM?: InputMaybe<Scalars['Boolean']['input']>;
  autoScroll?: InputMaybe<Scalars['Boolean']['input']>;
  autoScrollOffset?: InputMaybe<Scalars['Int']['input']>;
  disablePageLoadsAtTop?: InputMaybe<Scalars['Boolean']['input']>;
  disableRouting?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimerText?: InputMaybe<Scalars['String']['input']>;
  disclaimerTextHtml?: InputMaybe<Scalars['String']['input']>;
  enableFullScreenEmbeddedCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  iframeCSS?: InputMaybe<Scalars['String']['input']>;
  pageCSS?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateExciseTax = {
  local?: InputMaybe<Scalars['Float']['input']>;
  medicalLocal?: InputMaybe<Scalars['Float']['input']>;
  medicalState?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensaryUpdateFeatureFlags = {
  /** @deprecated now defined per order type within BaseOrderingSettings */
  enableAfterHoursOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now defined per pickup order type within BaseOrderingSettings */
  enableAfterHoursOrderingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated defined within CurbsidePickupOrderingSettings in ordering-settings */
  enableArrivals?: InputMaybe<Scalars['Boolean']['input']>;
  enableMenuImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatch?: InputMaybe<Scalars['Boolean']['input']>;
  enableNonTerminalAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  enablePausedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now defined per order type within BaseOrderingSettings */
  enableScheduledOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  hideDeliveryEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hideStoreHours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateFeeTiers = {
  fee?: InputMaybe<Scalars['String']['input']>;
  feeType?: InputMaybe<FeeTypes>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  percentFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlDispensaryUpdateHours = {
  Friday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Monday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Saturday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Sunday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Thursday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Tuesday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  Wednesday?: InputMaybe<GqlDispensaryUpdateHoursDay>;
};

export type GqlDispensaryUpdateHoursDay = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateHoursSettingsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<GqlDispensaryUpdateHoursSettingsProfileInput>;
};

export type GqlDispensaryUpdateHoursSettingsProfileInput = {
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHours>;
  pickupHours?: InputMaybe<GqlDispensaryUpdateHours>;
  reservationConfig?: InputMaybe<GqlReservationConfigInput>;
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursInput>>>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
};

export type GqlDispensaryUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<GqlDispensaryUpdateProfileInput>;
};

export type GqlDispensaryUpdateKioskConfig = {
  anonymousCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  directedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  fullNameOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hideEmailField?: InputMaybe<Scalars['Boolean']['input']>;
  hidePhoneField?: InputMaybe<Scalars['Boolean']['input']>;
  notesField?: InputMaybe<Scalars['Boolean']['input']>;
  phoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateOptionsSettings = {
  acceptsCreditCardTips?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsDutchiePayTips?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsTips?: InputMaybe<Scalars['Boolean']['input']>;
  embedSettings?: InputMaybe<GqlDispensaryUpdateEmbedSettings>;
  featureFlags?: InputMaybe<GqlDispensaryFeatureFlagOptions>;
  messagingSettings?: InputMaybe<GqlDispensaryMessagingSettingsInput>;
  orderStatusEmailSettings?: InputMaybe<GqlOrderStatusEmailSettingsInput>;
  ordersConfig?: InputMaybe<GqlDispensaryUpdateOrdersConfig>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  removeMedicalCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicense?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicenseForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  storeSettings?: InputMaybe<GqlDispensaryStoreSettingsOptions>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateOptionsSettingsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  updatedSettings?: InputMaybe<GqlDispensaryUpdateOptionsSettings>;
};

export type GqlDispensaryUpdateOrderTypeConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTypes?: InputMaybe<GqlDispensaryUpdatePaymentTypeConfig>;
};

export type GqlDispensaryUpdateOrderTypesConfig = {
  curbsidePickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  delivery?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  driveThruPickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  kiosk?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
  pickup?: InputMaybe<GqlDispensaryUpdateOrderTypeConfig>;
};

export type GqlDispensaryUpdateOrdersConfig = {
  autoClose?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  posItemNames?: InputMaybe<Scalars['Boolean']['input']>;
  terminalReceiptOptions?: InputMaybe<GqlDispensaryUpdateTerminalReceiptOptions>;
};

export type GqlDispensaryUpdatePaymentFees = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdatePaymentTypeConfig = {
  aeropay?: InputMaybe<Scalars['Boolean']['input']>;
  alt36?: InputMaybe<Scalars['Boolean']['input']>;
  canPay?: InputMaybe<Scalars['Boolean']['input']>;
  cash?: InputMaybe<Scalars['Boolean']['input']>;
  check?: InputMaybe<Scalars['Boolean']['input']>;
  creditCardAtDoor?: InputMaybe<Scalars['Boolean']['input']>;
  creditCardByPhone?: InputMaybe<Scalars['Boolean']['input']>;
  debit?: InputMaybe<Scalars['Boolean']['input']>;
  dutchiePay?: InputMaybe<Scalars['Boolean']['input']>;
  linx?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineChase?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineHypur?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineMerrco?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineMoneris?: InputMaybe<Scalars['Boolean']['input']>;
  paytender?: InputMaybe<Scalars['Boolean']['input']>;
  rethinkPay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdatePlusSettings = {
  checkoutUrl?: InputMaybe<Scalars['String']['input']>;
  defaultReturnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateProfileInput = {
  SpecialLogoImage?: InputMaybe<Scalars['String']['input']>;
  acceptsDutchiePayTips?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsTips?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  aeropay?: InputMaybe<Scalars['Boolean']['input']>;
  ageVerificationBannerColor?: InputMaybe<Scalars['String']['input']>;
  ageVerificationBannerHtml?: InputMaybe<Scalars['String']['input']>;
  alt36?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  brandedDutchiePayEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brandedDutchiePayLogoDark?: InputMaybe<Scalars['String']['input']>;
  brandedDutchiePayLogoLight?: InputMaybe<Scalars['String']['input']>;
  brandedDutchiePayName?: InputMaybe<Scalars['String']['input']>;
  canPay?: InputMaybe<Scalars['Boolean']['input']>;
  cashOnly?: InputMaybe<Scalars['Boolean']['input']>;
  cashless?: InputMaybe<Scalars['Boolean']['input']>;
  categoryLimits?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateCategoryLimits>>>;
  categoryLimitsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  categoryPhotos?: InputMaybe<Array<InputMaybe<GqlCategoryPhotoInput>>>;
  chain?: InputMaybe<Scalars['String']['input']>;
  check?: InputMaybe<Scalars['Boolean']['input']>;
  colorSettings?: InputMaybe<GqlColorSettingsInput>;
  creditCardAtDoor?: InputMaybe<Scalars['Boolean']['input']>;
  creditCardByPhone?: InputMaybe<Scalars['Boolean']['input']>;
  customCategoryPhotos?: InputMaybe<Array<InputMaybe<GqlCustomCategoryPhotoInput>>>;
  customDomainSettings?: InputMaybe<GqlDispensaryUpdateCustomDomainSettings>;
  debitOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHours>;
  deliveryMin?: InputMaybe<Scalars['String']['input']>;
  deliveryMode?: InputMaybe<DeliveryModes>;
  deliveryZipCodes?: InputMaybe<Array<InputMaybe<GqlDeliveryZipCodesInput>>>;
  deliveryZones?: InputMaybe<Array<InputMaybe<GqlDeliveryZonesInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationEstimateOverrides?: InputMaybe<GqlDurationEstimatesInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  embedBackUrl?: InputMaybe<Scalars['String']['input']>;
  embedSettings?: InputMaybe<GqlDispensaryUpdateEmbedSettings>;
  embeddedLogoImage?: InputMaybe<Scalars['String']['input']>;
  embeddedMenuUrl?: InputMaybe<Scalars['String']['input']>;
  exciseTax?: InputMaybe<GqlDispensaryUpdateExciseTax>;
  exclusiveExciseTax?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<GqlDispensaryUpdateFeatureFlags>;
  feeTiers?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateFeeTiers>>>;
  hideFromCCT?: InputMaybe<Scalars['Boolean']['input']>;
  hypur?: InputMaybe<Scalars['Boolean']['input']>;
  includeSalesTaxInMenu?: InputMaybe<Scalars['Boolean']['input']>;
  inclusiveSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated defined in ordering-settings in KioskOrderingSettings */
  kioskConfig?: InputMaybe<GqlDispensaryUpdateKioskConfig>;
  /** @deprecated set as notes field in KioskOrderingSettings */
  kioskInstructions?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated defined in ordering-settings within KioskOrderingSettings */
  kioskOrderingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linx?: InputMaybe<Scalars['Boolean']['input']>;
  listImage?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<Scalars['String']['input']>;
  maxDeliveryDistance?: InputMaybe<Scalars['Float']['input']>;
  medSubjectToExciseTax?: InputMaybe<Scalars['Boolean']['input']>;
  medicalDispensary?: InputMaybe<Scalars['Boolean']['input']>;
  menuBannerColor?: InputMaybe<Scalars['String']['input']>;
  menuBannerHtml?: InputMaybe<Scalars['String']['input']>;
  menuBannerTextBannerCollapsed?: InputMaybe<Scalars['Boolean']['input']>;
  menuOrder?: InputMaybe<Scalars['String']['input']>;
  menuUrl?: InputMaybe<Scalars['String']['input']>;
  menuWeights?: InputMaybe<Scalars['String']['input']>;
  messagingSettings?: InputMaybe<GqlDispensaryMessagingSettingsInput>;
  mixAndMatchPricingWeights?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerCurbsidePickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerDriveThruPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  offerPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to OrderingSettingsUpdateInput */
  orderTypesConfig?: InputMaybe<GqlDispensaryUpdateOrderTypesConfig>;
  ordersConfig?: InputMaybe<GqlDispensaryUpdateOrdersConfig>;
  payInStore?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineHypur?: InputMaybe<Scalars['Boolean']['input']>;
  payOnlineMerrco?: InputMaybe<Scalars['Boolean']['input']>;
  paymentFees?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdatePaymentFees>>>;
  paytender?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  pickupHours?: InputMaybe<GqlDispensaryUpdateHours>;
  /** @deprecated moved to OrderMinimumInput */
  pickupMinimum?: InputMaybe<GqlPickupMinimumInput>;
  plusSettings?: InputMaybe<GqlDispensaryUpdatePlusSettings>;
  printedMenuSettings?: InputMaybe<GqlPrintedMenuSettingsInput>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  recDispensary?: InputMaybe<Scalars['Boolean']['input']>;
  removeMedicalCardFieldsAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhotoIdForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicense?: InputMaybe<Scalars['Boolean']['input']>;
  requiresDriversLicenseForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated moved to ReservationSlotsUpdateInput */
  reservationConfig?: InputMaybe<GqlReservationConfigInput>;
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated moved to HoursSettingsUpdateInput. RL 5/8/20 */
  specialHours?: InputMaybe<Array<InputMaybe<GqlSpecialHoursInput>>>;
  specialsSettings?: InputMaybe<GqlSpecialsSettingsInput>;
  storeSettings?: InputMaybe<GqlDispensaryUpdateStoreSettings>;
  taxCalculationMethod?: InputMaybe<Scalars['String']['input']>;
  taxConfig?: InputMaybe<GqlDispensaryUpdateTaxConfig>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUpdateStatusInput = {
  dispensaryId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type GqlDispensaryUpdateStoreSettings = {
  collapseProductDescription?: InputMaybe<Scalars['Boolean']['input']>;
  customTermsText?: InputMaybe<Scalars['String']['input']>;
  customerMessagingTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  defaultViewStyle?: InputMaybe<MenuViewStyles>;
  disableGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  disableGuestDOB?: InputMaybe<Scalars['Boolean']['input']>;
  disablePurchaseLimits?: InputMaybe<Scalars['Boolean']['input']>;
  displayKioskAnonymousCheckoutDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  displayPhoneConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  dontCombineWeightedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  dontMapSubcategoriesByProductName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableAfterHoursOrderingForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableAfterHoursOrderingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomTerms?: InputMaybe<Scalars['Boolean']['input']>;
  enableDutchiePayConsumerSurcharge?: InputMaybe<Scalars['Boolean']['input']>;
  enableLLxSaleDiscountSync?: InputMaybe<Scalars['Boolean']['input']>;
  enableLimitPerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatchPricingForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  enableMixAndMatchPricingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  enableOmniauthLoginCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  enableOrderStatusEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enableProductUrgencyMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  enableRoundToNearestDollar?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableScheduledOrderingForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated now updated via OrderingSettingsUpdateInput */
  enableScheduledOrderingForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  enableStorefrontAgeGate?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Age verification gate feature has been removed */
  hardAgeGateAgeVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hardAgeGateHideMenuContent?: InputMaybe<Scalars['Boolean']['input']>;
  hideAddressFromDutchieMain?: InputMaybe<Scalars['Boolean']['input']>;
  hideDiscountsFromConsumer?: InputMaybe<Scalars['Boolean']['input']>;
  hideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  hideFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  hideOutOfStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideRoundingLineItem?: InputMaybe<Scalars['Boolean']['input']>;
  isolatedMenus?: InputMaybe<Scalars['Boolean']['input']>;
  keepUncombinedWeights?: InputMaybe<Scalars['Boolean']['input']>;
  prioritizeStaffPicksInSearchResults?: InputMaybe<Scalars['Boolean']['input']>;
  provideBackInstockEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  quantityLimit?: InputMaybe<Scalars['Int']['input']>;
  quantityLimitMaxAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  requireEmailAddressForGuestCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  requireMedCardPhotoForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  requirePaymentMethodSelection?: InputMaybe<Scalars['Boolean']['input']>;
  requireTermsAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  restrictSalesLanguage?: InputMaybe<Scalars['Boolean']['input']>;
  rewardsIntegrationConfiguration?: InputMaybe<GqlRewards_Integration_ConfigurationInput>;
  showLoyaltyRewards?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileAppSmartBanner?: InputMaybe<Scalars['Boolean']['input']>;
  showPOSPackageId?: InputMaybe<Scalars['Boolean']['input']>;
  stealthMode?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptions?: InputMaybe<GqlDispensaries_SubscriptionsInput>;
  usePotencyForConcentrateLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStandardEquivalentForEdiblesLimits?: InputMaybe<Scalars['Boolean']['input']>;
  useStateRegulatedImageWatermarks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDispensaryUpdateTaxConfig = {
  calculationMethod?: InputMaybe<Scalars['String']['input']>;
  discountTaxOrder?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateTaxConfigTaxes>>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlDispensaryUpdateTaxConfigTaxApplyTo = {
  hemp?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlDispensaryUpdateTaxConfigTaxStage = {
  op?: InputMaybe<Dispensaries_TaxConfig_Tax_Stage_Ops>;
  type?: InputMaybe<Dispensaries_TaxConfig_Tax_Stage_Types>;
};

export type GqlDispensaryUpdateTaxConfigTaxes = {
  applyTo?: InputMaybe<GqlDispensaryUpdateTaxConfigTaxApplyTo>;
  deliveryPolicy?: InputMaybe<DeliveryPolicy>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeStateSalesTaxInDestinationRate?: InputMaybe<Scalars['Boolean']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  potency?: InputMaybe<PotencyType>;
  potencyRate?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  recreational?: InputMaybe<Scalars['Boolean']['input']>;
  stages?: InputMaybe<Array<InputMaybe<GqlDispensaryUpdateTaxConfigTaxStage>>>;
  taxBasis?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaxType>;
};

export type GqlDispensaryUpdateTerminalReceiptOptions = {
  birthdate?: InputMaybe<Scalars['Boolean']['input']>;
  customerNameOption?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['Boolean']['input']>;
  disableSocialImpact?: InputMaybe<Scalars['Boolean']['input']>;
  groupLineItemsBy?: InputMaybe<Scalars['String']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  potencyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  sortLineItemsBy?: InputMaybe<Scalars['String']['input']>;
};

export type GqlDispensaryUserStreamTokenInput = {
  dispensaryId: Scalars['String']['input'];
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlDurationEstimateRangeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  highInMinutes?: InputMaybe<Scalars['Int']['input']>;
  lowInMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlDurationEstimatesInput = {
  delivery?: InputMaybe<GqlDurationEstimateRangeInput>;
  pickup?: InputMaybe<GqlDurationEstimateRangeInput>;
};

export type GqlEndSpecialsInput = {
  dispensaryId: Scalars['String']['input'];
  ids: Array<InputMaybe<Scalars['String']['input']>>;
  source?: InputMaybe<SpecialSource>;
  triggeredByIntegration: Scalars['Boolean']['input'];
};

export type GqlExportCustomerReportInput = {
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  lastOrder?: InputMaybe<Scalars['String']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlExportOrderReportInput = {
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['ISODate']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISODate']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlFeeDonationInput = {
  feeDonationId: Scalars['Int']['input'];
};

export type GqlFilteredSpecialsInput = {
  current?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  excludeSourcePOS?: InputMaybe<Scalars['Boolean']['input']>;
  past?: InputMaybe<Scalars['Boolean']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<Scalars['String']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sortInput?: InputMaybe<GqlSpecialsSortInput>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlFilteredSpecialsInputV2 = {
  pageInput?: InputMaybe<GqlSpecialsPageInput>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
  sortInput?: InputMaybe<Array<InputMaybe<GqlSpecialsSortInputV2>>>;
  source?: InputMaybe<SpecialSource>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<SpecialTemporalStatus>;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlGetDeliveryInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlGetDispensariesAdSettingsByMenuVariantInput = {
  adsEnabledMenuVariant: Scalars['String']['input'];
};

export type GqlGetDispensariesByPersonalizationSettingsInput = {
  personalizationEnabledMenuVariant: Scalars['String']['input'];
};

export type GqlGetOrdersInput = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<GqlDateRange>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderTypes>;
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
  kiosk?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<GqlGetOrderSortInput>;
  status?: InputMaybe<OrderQueryStatuses>;
};

export type GqlGetTimezoneResult = {
  __typename?: 'getTimezoneResult';
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GqlGuestCustomerInput = {
  birthDay?: InputMaybe<Scalars['String']['input']>;
  birthMonth?: InputMaybe<Scalars['String']['input']>;
  birthYear?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  termsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlImageUploadInput = {
  image?: InputMaybe<Scalars['String']['input']>;
};

export type GqlImageUrl = {
  __typename?: 'imageUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type GqlIncrementClicksInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
};

export type GqlIntegrationCredsInput = {
  adHoc1?: InputMaybe<Scalars['String']['input']>;
  dispensary?: InputMaybe<Scalars['String']['input']>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type GqlListBrandsFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlListBrandsSort = {
  sortBy?: InputMaybe<ListBrandsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlListLibraryProductsFilters = {
  status: LibraryProductStatusEnum;
};

export type GqlListLibraryProductsSort = {
  sortBy?: InputMaybe<ListLibraryProductsSortByEnum>;
  sortDirection?: InputMaybe<StringSortDirections>;
};

export type GqlLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  ln1?: InputMaybe<Scalars['String']['input']>;
  ln2?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMarkOrderAutoPrintedInput = {
  autoPrintSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMarkOrderPosFailedInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMarkOrderPrintedInput = {
  action?: InputMaybe<PrintAction>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  durationInMs?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  printId?: InputMaybe<Scalars['String']['input']>;
  printerPreviouslyConnected?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type GqlMarkOrdersBatchPrintedInput = {
  action?: InputMaybe<PrintAction>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['ISODateTime']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMedicalCardInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum MenuPricingTypes {
  med = 'med',
  rec = 'rec'
}

export type GqlMenuSectionBulkUpdateInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  dispensaryId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<GqlUpdateImageBannerInput>;
  position: Scalars['Int']['input'];
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  sectionType: MenuSectionType;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMenuSectionCreateInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  dispensaryId: Scalars['String']['input'];
  image?: InputMaybe<GqlUpdateImageBannerInput>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  sectionType: MenuSectionType;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMenuSectionUpdateInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<GqlUpdateImageBannerInput>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  sectionType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMonerisInput = {
  bin?: InputMaybe<Scalars['String']['input']>;
  cardToken?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOrderStatusEmailSettingsInput = {
  disableConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  disableOutForDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaymentError?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaymentLifecycle?: InputMaybe<Scalars['Boolean']['input']>;
  disableReadyForPickup?: InputMaybe<Scalars['Boolean']['input']>;
  disableSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrderStatuses {
  closed = 'closed',
  confirmed = 'confirmed',
  inTransit = 'inTransit',
  open = 'open'
}

export type GqlOrdersCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  appliedRewards?: InputMaybe<Array<InputMaybe<GqlRewardInput>>>;
  bypassCanadaDeliveryTax?: InputMaybe<Scalars['Boolean']['input']>;
  channelSource?: InputMaybe<ChannelSources>;
  checkoutId?: InputMaybe<Scalars['String']['input']>;
  checkoutToken?: InputMaybe<Scalars['String']['input']>;
  considerPayerForIncentives?: InputMaybe<Scalars['Boolean']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  customerState?: InputMaybe<Scalars['String']['input']>;
  deliveryOption: Scalars['Boolean']['input'];
  destinationTerminal?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverNumber?: InputMaybe<Scalars['String']['input']>;
  driversLicense?: InputMaybe<Scalars['String']['input']>;
  embedded?: InputMaybe<Scalars['Boolean']['input']>;
  expectedTotal?: InputMaybe<Scalars['Float']['input']>;
  feeDonations?: InputMaybe<Array<GqlFeeDonationInput>>;
  guestCustomer?: InputMaybe<GqlGuestCustomerInput>;
  hypurAccessToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  isAfterHoursOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCurbsidePickupOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isDriveThruPickupOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isGuestOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isKioskOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isPTPOT?: InputMaybe<Scalars['Boolean']['input']>;
  isPreviewOrder?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GqlLocationInput>;
  loyaltyPointsApplied?: InputMaybe<Scalars['Float']['input']>;
  manualDiscount?: InputMaybe<GqlUpdateCouponInput>;
  medicalCard?: InputMaybe<GqlMedicalCardInput>;
  medicalOrder: Scalars['Boolean']['input'];
  mixAndMatch?: InputMaybe<Scalars['Float']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  monerisInput?: InputMaybe<GqlMonerisInput>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paysafeInput?: InputMaybe<GqlPaysafeInput>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<PlatformType>;
  posCustomerId?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<PreOrderType>;
  products: Array<GqlProductsInput>;
  reservation?: InputMaybe<GqlOrderReservationInput>;
  reservationType?: InputMaybe<Scalars['String']['input']>;
  roundupForCharityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  saveGuestInfo?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingData?: InputMaybe<GqlOrderSchedulingDataInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  tip?: InputMaybe<Array<InputMaybe<GqlTipInput>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  utmData?: InputMaybe<GqlUtmDataInput>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  variantSource?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOrdersFilterInput = {
  destinationTerminal?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  getDeliveryOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getKioskOrders?: InputMaybe<Scalars['Boolean']['input']>;
  getPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<OrderStatuses>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOrdersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlOrdersSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: StringSortDirections;
};

export type GqlOrdersStatusUpdateInput = {
  closedByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  driverEmail?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  noNotification?: InputMaybe<Scalars['Boolean']['input']>;
  noText?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
};

export enum Orders_CancellationReasonIDs {
  badinfo = 'BADINFO',
  cancelled = 'CANCELLED',
  complianceviolation = 'COMPLIANCEVIOLATION',
  noidentification = 'NOIDENTIFICATION',
  nopayment = 'NOPAYMENT',
  nopickup = 'NOPICKUP',
  other = 'OTHER',
  soldout = 'SOLDOUT'
}

export type GqlPagination = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
};

export type GqlPaysafeInput = {
  token?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPermissionsInput = {
  allLocations?: InputMaybe<Scalars['Boolean']['input']>;
  analytics?: InputMaybe<Scalars['Boolean']['input']>;
  billing?: InputMaybe<Scalars['Boolean']['input']>;
  customers?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driver?: InputMaybe<Scalars['Boolean']['input']>;
  enterpriseAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  enterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  menu?: InputMaybe<Scalars['Boolean']['input']>;
  menuReview?: InputMaybe<Scalars['Boolean']['input']>;
  messaging?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Scalars['Boolean']['input']>;
  promote?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['Boolean']['input']>;
  superMenuReview?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  users?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPrintOrderInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPrintedMenuSettingsInput = {
  Categories?: InputMaybe<Array<InputMaybe<GqlPrintedMenuSettings_CategoryEntryInput>>>;
  FooterText?: InputMaybe<GqlPrintedMenuSettings_TextInput>;
  HeaderText?: InputMaybe<GqlPrintedMenuSettings_TextInput>;
  MenuType?: InputMaybe<GqlPrintedMenuSettings_TypeInput>;
  Order?: InputMaybe<GqlPrintedMenuSettings_TypeInput>;
  PageBreaks?: InputMaybe<GqlPrintedMenuSettings_PageBreaksInput>;
  Photos?: InputMaybe<GqlPrintedMenuSettings_PhotosInput>;
  StrainTypes?: InputMaybe<Array<InputMaybe<GqlPrintedMenuSettings_StrainTypesEntryInput>>>;
};

export type GqlProductCreateInput = {
  AdditionalOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  CBD?: InputMaybe<Scalars['String']['input']>;
  CBDContent?: InputMaybe<GqlProductsPotencyInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DispensaryID?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THC?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlProductsPotencyInput>;
  _id?: InputMaybe<Scalars['String']['input']>;
  addedUsingCCT?: InputMaybe<Scalars['Boolean']['input']>;
  bottleDepositTaxCents?: InputMaybe<Scalars['Int']['input']>;
  brandDescription?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandLogo?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  cName?: InputMaybe<Scalars['String']['input']>;
  cannabinoidsV2?: InputMaybe<Array<InputMaybe<GqlProducts_CannabinoidInputV2>>>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  duplicatedProductId?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Scalars['JSON']['input']>;
  featured?: InputMaybe<GqlProducts_FeaturedInput>;
  images?: InputMaybe<Array<InputMaybe<GqlProducts_ImagesInput>>>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  limitsPerCustomer?: InputMaybe<Array<InputMaybe<GqlProducts_LimitPerCustomerInput>>>;
  manualInventory?: InputMaybe<Array<InputMaybe<GqlProducts_ManualInventoryInput>>>;
  medicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  medicalSpecialPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  originalPrices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overrides?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pastCNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preCropImage?: InputMaybe<Scalars['String']['input']>;
  qaRejectionReason?: InputMaybe<Scalars['String']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  recSpecialPrices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  score?: InputMaybe<Scalars['Float']['input']>;
  special?: InputMaybe<Scalars['Boolean']['input']>;
  stockImage?: InputMaybe<Scalars['String']['input']>;
  stockImageAliases?: InputMaybe<Scalars['String']['input']>;
  stockImageCategory?: InputMaybe<Scalars['String']['input']>;
  strainType?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<InputMaybe<GqlProducts_TerpeneInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum ProductsFilterByOption {
  highCbd = 'highCBD',
  highPotency = 'highPotency',
  newProducts = 'newProducts'
}

export type GqlProductsFilterInput = {
  CBDContent?: InputMaybe<GqlProductsPotencyInput>;
  Status?: InputMaybe<Scalars['String']['input']>;
  THCContent?: InputMaybe<GqlProductsPotencyInput>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bypassKioskThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  bypassOnlineThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  bypassSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  bypassThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  cName?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ProductsFilterByOption>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultSort?: InputMaybe<Scalars['Boolean']['input']>;
  isKioskMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  preOrderType?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<MenuPricingTypes>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  removeProductsBelowOptionThresholds?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  specialId?: InputMaybe<Scalars['String']['input']>;
  specialType?: InputMaybe<Scalars['String']['input']>;
  sponsoredProductsInventoryId?: InputMaybe<SponsoredProductsInventoryId>;
  sponsoredProductsLimit?: InputMaybe<Scalars['Int']['input']>;
  staffPicks?: InputMaybe<Scalars['Boolean']['input']>;
  strainTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  terpenes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlProductsInput = {
  AdditionalOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Prices?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  additionalOption?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
  rawOption?: InputMaybe<Scalars['String']['input']>;
  rawOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  special?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GqlProductsPotencyInput = {
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  unit: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlQueryInfoType = {
  __typename?: 'queryInfoType';
  perPage?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type GqlResetPasswordInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSalesOrdersQueryResponse = {
  __typename?: 'salesOrdersQueryResponse';
  ordersByDate?: Maybe<Array<Maybe<GqlAnalyticsOrdersByDate>>>;
  percentChange?: Maybe<Scalars['Float']['output']>;
  revenueChange?: Maybe<Scalars['Float']['output']>;
  totalOrders?: Maybe<Scalars['Float']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
};

export type GqlSearchBrandsFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  hasCollisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  localAndGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  missingDescription?: InputMaybe<Scalars['Boolean']['input']>;
  missingLogo?: InputMaybe<Scalars['Boolean']['input']>;
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
};

export type GqlSearchBrandsSort = {
  sortBy: BrandSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSearchLibraryProductsFilters = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  stateLibrary?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LibraryProductStatusEnum>;
  updatedByBrand?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlSearchLibraryProductsSort = {
  sortBy: LibraryProductSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSetPasswordInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSortInput = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['Int']['input'];
};

export type GqlSpecialHoursDayInput = {
  date: Scalars['String']['input'];
  deliveryHours?: InputMaybe<GqlDispensaryUpdateHoursDay>;
  pickupHours?: InputMaybe<GqlDispensaryUpdateHoursDay>;
};

export type GqlSpecialHoursInput = {
  endDate: Scalars['String']['input'];
  hoursPerDay?: InputMaybe<Array<InputMaybe<GqlSpecialHoursDayInput>>>;
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GqlSpecialsInputRecurring = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  setEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSpecialsPageInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlSpecialsSortInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};

export type GqlSpecialsSortInputV2 = {
  direction: Scalars['Int']['input'];
  key: SpecialSortKey;
};

export type GqlStrainInput = {
  aromas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  potentialHealthBenefits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ratio?: InputMaybe<Scalars['String']['input']>;
  terpenes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlStrainsFilterInput = {
  missingDescription?: InputMaybe<Scalars['Boolean']['input']>;
  missingImage?: InputMaybe<Scalars['Boolean']['input']>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlStrainsSortInput = {
  sortBy: StrainSortByEnum;
  sortDirection: StringSortDirections;
};

export type GqlSubscriptionsFilterInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSuperAdminCustomersFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GqlSuperProductsInput = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  connectionStatus: Scalars['String']['input'];
  dispensaryID?: InputMaybe<Scalars['String']['input']>;
  dispensaryState?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  productStatus: Scalars['String']['input'];
  reviewed?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  thresholdFilter?: InputMaybe<Scalars['String']['input']>;
};

export type GqlTerpeneInput = {
  aliasList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aromas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  effects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  potentialHealthBenefits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlTerpenesFilter = {
  searchStr?: InputMaybe<Scalars['String']['input']>;
};

export type GqlTerpenesSort = {
  sortBy: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
};

export type GqlTipInput = {
  dollar?: InputMaybe<Scalars['Float']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlUnsubscribeDispensaryCustomersInput = {
  _id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispensaryId: Scalars['String']['input'];
};

export type GqlUpdateCouponInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applicableCategories?: InputMaybe<Array<InputMaybe<GqlCopuonApplicableCategoryInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  expDate?: InputMaybe<Scalars['String']['input']>;
  fixedDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  numAllowedUses?: InputMaybe<Scalars['Int']['input']>;
  numUses?: InputMaybe<Scalars['Int']['input']>;
  oneUsePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  reimbursed?: InputMaybe<Scalars['Boolean']['input']>;
  restrictions?: InputMaybe<GqlCouponRestrictionsInput>;
  usedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GqlUpdateDeviceInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<GqlDevice_Config_Input>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpdateDispensaryAdSettingsInput = {
  adsEnabledMenuVariant: Scalars['String']['input'];
  disableGroup: Array<InputMaybe<Scalars['String']['input']>>;
  enableGroup: Array<InputMaybe<Scalars['String']['input']>>;
};

export type GqlUpdateDispensaryPersonalizationSettingsInput = {
  disableGroup: Array<InputMaybe<Scalars['String']['input']>>;
  enableGroup: Array<InputMaybe<Scalars['String']['input']>>;
  personalizationEnabledMenuVariant: Scalars['String']['input'];
};

export type GqlUpdateKioskOrderPaymentInput = {
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  tipCents?: InputMaybe<Scalars['Int']['input']>;
  updateOrderToken: Scalars['String']['input'];
};

export type GqlUpdateProductSortInput = {
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuOrder?: InputMaybe<Scalars['String']['input']>;
  menuSortSetting?: InputMaybe<GqlMenuSortSettingInput>;
  sortProductProxies?: InputMaybe<Array<InputMaybe<GqlSortProductProxy>>>;
};

export type GqlUpdateSingleDispensaryAdSettingsInput = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryAdSettingsInput;
};

export type GqlUpdateSingleDispensaryPersonalizationSettingsInput = {
  dispensaryId: Scalars['String']['input'];
  settings: GqlDispensaryPersonalizationSettingsInput;
};

export type GqlUserIdExistsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUsersCreateInput = {
  chain?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  legacyChain?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<GqlPermissionsInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUsersDeleteInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUsersFilterInput = {
  chainID?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<Scalars['Boolean']['input']>;
  superadmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUsersUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  audioNotificationsOnNewArrivalsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  audioNotificationsOnNewOrdersDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  browserNotification?: InputMaybe<Scalars['Boolean']['input']>;
  chain?: InputMaybe<Scalars['String']['input']>;
  desktopNotification?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isWeeklyReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  legacyChain?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<GqlPermissionsInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleAtDispensary?: InputMaybe<DispensaryRoles>;
  /** @deprecated no longer sending admin text notifications */
  textNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlUtmDataInput = {
  dtm_campaign?: InputMaybe<Scalars['String']['input']>;
  dtm_content?: InputMaybe<Scalars['String']['input']>;
  dtm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type GqlV4Condition = {
  __typename?: 'v4Condition';
  conditionType?: Maybe<ConditionType>;
  exclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  groupBySku?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeCannabis?: Maybe<Scalars['Boolean']['output']>;
  inclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  thresholds?: Maybe<Array<Maybe<GqlThreshold>>>;
};

export type GqlV4ConditionInput = {
  conditionType?: InputMaybe<ConditionType>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  groupBySku?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeCannabis?: InputMaybe<Scalars['Boolean']['input']>;
  inclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  thresholds?: InputMaybe<Array<InputMaybe<GqlThresholdInput>>>;
};

export type GqlV4Restriction = {
  __typename?: 'v4Restriction';
  brandId?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inventoryTag?: Maybe<Scalars['String']['output']>;
  matchOperator?: Maybe<Scalars['String']['output']>;
  pricingTierId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productTag?: Maybe<Scalars['String']['output']>;
  restrictionType?: Maybe<RestrictionType>;
  strainId?: Maybe<Scalars['String']['output']>;
  subcategoryId?: Maybe<Scalars['String']['output']>;
  subcategoryName?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<GqlWeight>;
};

export type GqlV4RestrictionInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inventoryTag?: InputMaybe<Scalars['String']['input']>;
  matchOperator?: InputMaybe<Scalars['String']['input']>;
  pricingTierId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productTag?: InputMaybe<Scalars['String']['input']>;
  restrictionType?: InputMaybe<RestrictionType>;
  strainId?: InputMaybe<Scalars['String']['input']>;
  subcategoryId?: InputMaybe<Scalars['String']['input']>;
  subcategoryName?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<GqlWeightInput>;
};

export type GqlV4Reward = {
  __typename?: 'v4Reward';
  amountOff?: Maybe<Scalars['Int']['output']>;
  discountType?: Maybe<DiscountType>;
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  exclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  groupBySku?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeNonCannabis?: Maybe<Scalars['Boolean']['output']>;
  inclusions?: Maybe<Array<Maybe<GqlV4Restriction>>>;
  percentDiscount?: Maybe<Scalars['Float']['output']>;
  rangeBehavior?: Maybe<RangeBehaviors>;
  rewardType?: Maybe<RewardType>;
  thresholds?: Maybe<Array<Maybe<GqlThreshold>>>;
};

export type GqlV4RewardInput = {
  amountOff?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<DiscountType>;
  discountedPrice?: InputMaybe<Scalars['Int']['input']>;
  exclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  groupBySku?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeNonCannabis?: InputMaybe<Scalars['Boolean']['input']>;
  inclusions?: InputMaybe<Array<InputMaybe<GqlV4RestrictionInput>>>;
  percentDiscount?: InputMaybe<Scalars['Float']['input']>;
  rangeBehavior?: InputMaybe<RangeBehaviors>;
  rewardType?: InputMaybe<RewardType>;
  thresholds?: InputMaybe<Array<InputMaybe<GqlThresholdInput>>>;
};

export type GqlV4Special = {
  __typename?: 'v4Special';
  allowedUsesPerUser?: Maybe<Scalars['Int']['output']>;
  applicableToItemsOnSpecial?: Maybe<Scalars['Boolean']['output']>;
  applicationMethod?: Maybe<SpecialApplicationMethodTypes>;
  cipher?: Maybe<Scalars['JSON']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  conditionLogicOperator?: Maybe<LogicOperator>;
  conditions?: Maybe<Array<Maybe<GqlV4Condition>>>;
  consumerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['ISODateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  discountPrecedence?: Maybe<Scalars['String']['output']>;
  dispensaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dispensaryId?: Maybe<Scalars['String']['output']>;
  displayRank?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<GqlSpecialEmail>;
  endedAt?: Maybe<Scalars['ISODateTime']['output']>;
  endedBy?: Maybe<Scalars['String']['output']>;
  enterpriseId?: Maybe<Scalars['String']['output']>;
  enterpriseSpecialId?: Maybe<Scalars['String']['output']>;
  firstTimeConsumerOnly?: Maybe<Scalars['Boolean']['output']>;
  generatedByPOS?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inactiveDispensaryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isAvailableOnline?: Maybe<Scalars['Boolean']['output']>;
  loyaltyPointsToRedeem?: Maybe<Scalars['Int']['output']>;
  manualDefaultApplyTo?: Maybe<ManualDefaultApplyTo>;
  menuDisplay?: Maybe<GqlSpecialMenuDisplay>;
  menuType?: Maybe<SpecialMenuType>;
  name?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<OrderType>;
  origin?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  quantityUsed?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerCart?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']['output']>;
  reimbursed?: Maybe<Scalars['Boolean']['output']>;
  requireManagerApproval?: Maybe<Scalars['Boolean']['output']>;
  rewardLogicOperator?: Maybe<LogicOperator>;
  rewards?: Maybe<Array<Maybe<GqlV4Reward>>>;
  schedule?: Maybe<GqlSpecialSchedule>;
  scope?: Maybe<Scalars['String']['output']>;
  specialType?: Maybe<SpecialType>;
  specialVersion?: Maybe<Scalars['Int']['output']>;
  stackingBehavior?: Maybe<StackingBehavior>;
  status?: Maybe<SpecialStatus>;
  totalAllowedUses?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISODateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type GqlBrandDispensaryFragmentFragment = { __typename?: 'Brand', dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null };

export type GqlBrandFragmentForDropdownFragment = { __typename?: 'Brand', _id: string, id: string, name: string, imageUrl?: string | null };

export type GqlBrandFragmentFragment = { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null };

export type GqlCreateBrandMutationVariables = Exact<{
  brand: GqlBrandInput;
}>;


export type GqlCreateBrandMutation = { __typename?: 'Mutation', createBrandV2?: { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null } | null };

export type GqlDeleteBrandMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteBrandMutation = { __typename?: 'Mutation', deleteBrand?: { __typename?: 'Brand', _id: string } | null };

export type GqlUpdateBrandMutationVariables = Exact<{
  id: Scalars['String']['input'];
  brand: GqlBrandInput;
}>;


export type GqlUpdateBrandMutation = { __typename?: 'Mutation', updateBrandV2?: { __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null } | null };

export type GqlBrandsForDropdownQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentBrandId?: InputMaybe<Scalars['ID']['input']>;
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  localAndGlobal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlBrandsForDropdownQuery = { __typename?: 'Query', searchBrandsV2?: { __typename?: 'BrandList', brands: Array<{ __typename?: 'Brand', isGlobal: boolean, _id: string, id: string, name: string, imageUrl?: string | null } | null> } | null };

export type GqlGetBrandRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetBrandRegionsQuery = { __typename?: 'Query', listRegions: Array<{ __typename?: 'Region', id: string, code: string, country: string, subdivision?: string | null, countryName?: string | null, subdivisionName?: string | null } | null> };

export type GqlGetBrandQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetBrandQuery = { __typename?: 'Query', getBrand?: { __typename?: 'Brand', isGlobal: boolean, source?: string | null, creatorUserId?: string | null, parentBrandId?: string | null, _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null, regions?: Array<{ __typename?: 'Region', id: string, code: string, country: string, subdivision?: string | null, countryName?: string | null, subdivisionName?: string | null }> | null, dispensary?: { __typename?: 'Dispensaries', name?: string | null, id: string } | null, enterprise?: { __typename?: 'Enterprise', id: string, name: string } | null } | null };

export type GqlSuperBrandsIndexQueryVariables = Exact<{
  filters?: InputMaybe<GqlSearchBrandsFilters>;
  pagination?: InputMaybe<GqlPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GqlSearchBrandsSort>;
}>;


export type GqlSuperBrandsIndexQuery = { __typename?: 'Query', searchBrandsV2?: { __typename?: 'BrandList', brands: Array<{ __typename?: 'Brand', _id: string, aliasList: Array<string | null>, companyEmail?: string | null, createdAt?: any | null, description?: string | null, id: string, imageUrl?: string | null, libraryProductsCount: number, name: string, productsCount: number, updatedAt?: any | null, websiteUrl?: string | null, dispensary?: { __typename?: 'Dispensaries', id: string, name?: string | null } | null } | null>, queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null } | null };

export type GqlBucketListFragmentFragment = { __typename?: 'Bucket', checkedOutAt?: any | null, completedReviewsCount?: number | null, id: string, name: string, productsCount: number, teamName: string, createdBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null, checkedOutBy?: { __typename?: 'Users', _id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type GqlComputeWithPriceCartV2MutationVariables = Exact<{
  priceCartInput: GqlCalculationsInput;
}>;


export type GqlComputeWithPriceCartV2Mutation = { __typename?: 'Mutation', computeWithPriceCartV2?: { __typename?: 'CalculationResults', subTotal?: number | null, taxes?: number | null, discount?: number | null, originalTotal?: number | null, roundedDifference?: number | null, grandTotal?: number | null, loyaltyPointsUsed?: number | null, totalSalesTax?: number | null, totalCannabisTax?: number | null, totalBottleDepositTax?: number | null, taxInclusivePricing?: boolean | null, loyaltyAppliedAsDiscount?: number | null, discountWithoutLoyalty?: number | null, posCustomerId?: number | null, itemTaxes?: Array<{ __typename?: 'ItemTax', taxAmount?: number | null, taxType?: string | null, productId?: number | null, feeItemId?: number | null, showOnMenu?: boolean | null, showOnCheckout?: boolean | null } | null> | null, cartItemPrices?: Array<{ __typename?: 'CartItem', productName?: string | null, productId?: number | null, quantity?: number | null, subtotal?: number | null, unitPrice?: number | null, pricingTierAdjustment?: number | null, pricingTierAdjustmentTotal?: number | null, summaryPrice?: number | null, menuPrice?: number | null, tax?: number | null, unitWeightGrams?: number | null, productType?: string | null, ecommKey?: string | null, discounts?: Array<{ __typename?: 'Discount', name?: string | null, amount?: number | null, discountId?: number | null, applicationMethod?: string | null, isLoyaltyReward?: boolean | null, isPaymentIncentive?: boolean | null, isRestricted?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null } | null> | null } | null> | null, fees?: Array<{ __typename?: 'Fees', feeItemId?: number | null, feeAmount?: number | null, feeName?: string | null, deliveryFee?: boolean | null, paymentFee?: boolean | null } | null> | null, rewardValidationErrors?: Array<{ __typename?: 'RewardValidationError', discountCode?: string | null, discountId?: number | null, message?: string | null } | null> | null, discountGamification?: { __typename?: 'CalculationResults_CartGamification', gamificationDetails?: Array<{ __typename?: 'GamificationDetailItem', discountId?: number | null, meetsAllConstraints?: boolean | null, satisfiers?: Array<{ __typename?: 'GamificationDetailItem_Satisfier', thresholdMet?: boolean | null, thresholdType?: string | null, minimumThreshold?: number | null, products?: Array<{ __typename?: 'GamificationDetailItem_Satisfiers_Product', productId?: number | null, ecommKey?: string | null, amount?: number | null } | null> | null } | null> | null } | null> | null } | null } | null };

export type GqlServerSideCalculationsMutationVariables = Exact<{
  input: GqlLegacyCalculationsInput;
}>;


export type GqlServerSideCalculationsMutation = { __typename?: 'Mutation', serverSideCalculations?: { __typename?: 'LegacyCalculationResults', bottleDepositTaxCents?: number | null, cannabisTax?: number | null, cartSubtotal?: number | null, credit?: number | null, deliveryFee?: number | null, menuTotal?: number | null, mixAndMatch?: number | null, otherFees?: number | null, paymentFee?: number | null, paymentIncentives?: Array<any | null> | null, reward?: number | null, rounding?: number | null, roundupForCharityAmount?: number | null, subtotal?: number | null, tax?: number | null, tip?: number | null, total?: number | null, receipt?: any | null, details?: Array<{ __typename?: 'DetailItem', basePrice?: number | null, basePriceMult?: number | null, bottleDepositTaxCents?: number | null, canonicalEffectivePotencyMg?: number | null, enterpriseProductId?: string | null, id?: string | null, isOnSale?: boolean | null, isVapeTaxed?: boolean | null, key?: string | null, menuBasePrice?: number | null, menuCannabisTax?: number | null, menuIndividualPrice?: number | null, menuSaleAdjustment?: number | null, menuPrice?: number | null, menuSalesTax?: number | null, option?: string | null, posId?: string | null, productBrand?: string | null, productBrandId?: string | null, productCategory?: string | null, productSubcategory?: string | null, quantity?: number | null, type?: string | null, weightInGrams?: number | null, weightInMg?: number | null, wholesalePrice?: number | null, bogoSavings?: { __typename?: 'BogoSavingsObj', displayAsPercentDiscount?: boolean | null, isDiscountToCartReward?: boolean | null, menuBogoDiscount?: string | null, total?: number | null, individual?: Array<{ __typename?: 'BogoSavings_Individual', conditionQuantity?: number | null, discountAmount?: number | null, discountStacking?: boolean | null, displayAsPercentDiscount?: boolean | null, isDiscountToCartReward?: boolean | null, maxApplicable?: number | null, nonStackingBehavior?: string | null, specialId?: string | null, stackingBehavior?: string | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', endWeight?: number | null, price?: number | null, pricePerGram?: number | null, startWeight?: number | null, weightUOM?: string | null } | null> | null } | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, discountBehavior?: string | null, discountPrecedence?: string | null, discountStacking?: boolean | null, endStamp?: string | null, excludeConditionItemsFromRewards?: boolean | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, rawPOSWeightMapping?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, percentDiscount?: string | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, targetPrice?: string | null, vendorIds?: Array<string | null> | null, weight?: string | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, discountType?: string | null, enabled?: boolean | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, percentDiscount?: boolean | null, rawPOSWeightMapping?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weightOperator?: WeightOperator | null, weights?: Array<string | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, bottleDepositTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null, cannabisTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null, lineitems?: Array<{ __typename?: 'LineItem', type?: string | null, value?: number | null } | null> | null, salesTaxExistence?: { __typename?: 'TaxExistence', med?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null, rec?: { __typename?: 'TaxExistenceInside', checkout?: string | null, menu?: string | null, pos?: string | null } | null } | null } | null };

export type GqlComputeWithPriceCartQueryVariables = Exact<{
  priceCartInput: GqlCalculationsInput;
}>;


export type GqlComputeWithPriceCartQuery = { __typename?: 'Query', computeWithPriceCart?: { __typename?: 'CalculationResults', subTotal?: number | null, taxes?: number | null, discount?: number | null, originalTotal?: number | null, roundedDifference?: number | null, grandTotal?: number | null, loyaltyPointsUsed?: number | null, totalSalesTax?: number | null, totalCannabisTax?: number | null, totalBottleDepositTax?: number | null, taxInclusivePricing?: boolean | null, loyaltyAppliedAsDiscount?: number | null, discountWithoutLoyalty?: number | null, posCustomerId?: number | null, itemTaxes?: Array<{ __typename?: 'ItemTax', taxAmount?: number | null, taxType?: string | null, productId?: number | null, feeItemId?: number | null, showOnMenu?: boolean | null, showOnCheckout?: boolean | null } | null> | null, cartItemPrices?: Array<{ __typename?: 'CartItem', productName?: string | null, productId?: number | null, quantity?: number | null, subtotal?: number | null, unitPrice?: number | null, pricingTierAdjustment?: number | null, pricingTierAdjustmentTotal?: number | null, summaryPrice?: number | null, menuPrice?: number | null, tax?: number | null, unitWeightGrams?: number | null, productType?: string | null, discounts?: Array<{ __typename?: 'Discount', name?: string | null, amount?: number | null, discountId?: number | null, applicationMethod?: string | null, isLoyaltyReward?: boolean | null, isPaymentIncentive?: boolean | null } | null> | null } | null> | null, fees?: Array<{ __typename?: 'Fees', feeItemId?: number | null, feeAmount?: number | null, feeName?: string | null, deliveryFee?: boolean | null, paymentFee?: boolean | null } | null> | null, rewardValidationErrors?: Array<{ __typename?: 'RewardValidationError', discountCode?: string | null, discountId?: number | null, message?: string | null } | null> | null } | null };

export type GqlGetCannabinoidsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCannabinoidsQuery = { __typename?: 'Query', getCannabinoids: Array<{ __typename?: 'Cannabinoid', name: string, id: string }> };

export type GqlCouponFragmentFragment = { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null };

export type GqlCreateCouponV2MutationVariables = Exact<{
  input: GqlCreateCouponInput;
}>;


export type GqlCreateCouponV2Mutation = { __typename?: 'Mutation', createCouponV2?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null };

export type GqlDeleteCouponMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteCouponMutation = { __typename?: 'Mutation', deleteCoupon?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDeleteCouponV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteCouponV2Mutation = { __typename?: 'Mutation', deleteCouponV2?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlUpdateCouponMutationVariables = Exact<{
  input: GqlUpdateCouponInput;
}>;


export type GqlUpdateCouponMutation = { __typename?: 'Mutation', updateCoupon?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null };

export type GqlFilteredCouponsQueryVariables = Exact<{
  filter?: InputMaybe<GqlCouponsFilterInput>;
  sort?: InputMaybe<GqlCouponsSortInput>;
  pagination?: InputMaybe<GqlCouponsPaginationInput>;
}>;


export type GqlFilteredCouponsQuery = { __typename?: 'Query', filteredCoupons?: { __typename?: 'CouponList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, coupons?: Array<{ __typename?: 'Coupons', dispensary?: string | null, reimbursed?: boolean | null, _id: string, active?: boolean | null, addedDate?: string | null, code?: string | null, dispensaryId?: string | null, expDate?: string | null, fixedDiscountInCents?: number | null, numAllowedUses?: number | null, numUses?: number | null, percentDiscount?: number | null, oneUsePerCustomer?: boolean | null, usedBy?: Array<string | null> | null, applicableCategories?: Array<{ __typename?: 'couponApplicableCategory', category?: string | null, subcategory?: string | null } | null> | null, restrictions?: { __typename?: 'couponRestrictions', minimumPurchase?: boolean | null, minimumPurchaseInCents?: number | null, noSpecials?: boolean | null } | null } | null> | null } | null };

export type GqlClearAllCurbsideArrivalsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlClearAllCurbsideArrivalsMutation = { __typename?: 'Mutation', clearAllCurbsideArrivals: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlClearCurbsideArrivalMutationVariables = Exact<{
  arrivalId: Scalars['String']['input'];
}>;


export type GqlClearCurbsideArrivalMutation = { __typename?: 'Mutation', clearCurbsideArrival: { __typename?: 'GenericResponse', success?: boolean | null } };

export type GqlMarkCurbsideArrivalArrivedV2MutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GqlMarkCurbsideArrivalArrivedV2Mutation = { __typename?: 'Mutation', markCurbsideArrivalArrivedV2: { __typename?: 'CurbsideArrival', id?: string | null } };

export type GqlUpdateCurbsideArrivalV2MutationVariables = Exact<{
  token: Scalars['String']['input'];
  arrivalInformation: Scalars['String']['input'];
}>;


export type GqlUpdateCurbsideArrivalV2Mutation = { __typename?: 'Mutation', updateCurbsideArrivalV2?: { __typename?: 'CurbsideArrival', id?: string | null } | null };

export type GqlGetCurbsideArrivalByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GqlGetCurbsideArrivalByTokenQuery = { __typename?: 'Query', getCurbsideArrivalByToken?: { __typename?: 'CurbsideArrival', id?: string | null, arrivalInformation?: string | null, arrivedAt?: any | null, clearedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, dispensary?: { __typename?: 'Dispensaries', id: string, phone?: string | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', arrivalInformationInstructions?: string | null } | null } | null } | null } | null };

export type GqlGetCurbsideArrivalsForBannerQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetCurbsideArrivalsForBannerQuery = { __typename?: 'Query', getCurbsideArrivals: Array<{ __typename?: 'CurbsideArrival', id?: string | null }> };

export type GqlGetCurbsideArrivalsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetCurbsideArrivalsQuery = { __typename?: 'Query', getCurbsideArrivals: Array<{ __typename?: 'CurbsideArrival', id?: string | null, arrivalInformation?: string | null, arrivedAt?: any | null, clearedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, order?: { __typename?: 'Orders', id?: string | null, orderId?: string | null, customer?: { __typename?: 'Orders_customer', profile?: { __typename?: 'Orders_customer_profile', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | null }> };

export type GqlUpdateCustomerSubscriptionMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
}>;


export type GqlUpdateCustomerSubscriptionMutation = { __typename?: 'Mutation', updateCustomerSubscription?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDeviceFragmentFragment = { __typename?: 'Devices', _id?: string | null, accessCode?: string | null, autoPrintDevice?: boolean | null, buildNumber?: string | null, dispensaryId?: string | null, lastSeenAt?: string | null, nickname?: string | null, online?: boolean | null, printerConnected?: boolean | null, updatedAt?: string | null, versionNumber?: string | null, config?: { __typename?: 'Device_config', getDeliveryOrders?: boolean | null, getKioskOrders?: boolean | null, getPickupOrders?: boolean | null, orderSource?: string | null } | null };

export type GqlGetDevicesQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetDevicesQuery = { __typename?: 'Query', getDevices: Array<{ __typename?: 'Devices', _id?: string | null, accessCode?: string | null, autoPrintDevice?: boolean | null, buildNumber?: string | null, dispensaryId?: string | null, lastSeenAt?: string | null, nickname?: string | null, online?: boolean | null, printerConnected?: boolean | null, updatedAt?: string | null, versionNumber?: string | null, config?: { __typename?: 'Device_config', getDeliveryOrders?: boolean | null, getKioskOrders?: boolean | null, getPickupOrders?: boolean | null, orderSource?: string | null } | null }> };

export type GqlGetKioskTerminalsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetKioskTerminalsQuery = { __typename?: 'Query', getKioskTerminals: Array<{ __typename?: 'KioskTerminal', id: string, dispensaryId: string, nickname?: string | null }> };

export type GqlAddSubscriptionToChainMutationVariables = Exact<{
  dispensaryIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  chargebeeCustomerId: Scalars['String']['input'];
}>;


export type GqlAddSubscriptionToChainMutation = { __typename?: 'Mutation', addSubscriptionToChain?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlRemoveSubscriptionFromChainMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  chargebeeCustomerId: Scalars['String']['input'];
}>;


export type GqlRemoveSubscriptionFromChainMutation = { __typename?: 'Mutation', removeSubscriptionFromChain?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlGetChainBillingInfoQueryVariables = Exact<{
  dispensaries?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlGetChainBillingInfoQuery = { __typename?: 'Query', getBillingSubscriptions: Array<{ __typename?: 'BillingSubscription', dispensaryBilling?: { __typename?: 'DispensaryBilling', chain?: boolean | null, chargebeeCustomerId?: string | null } | null } | null> };

export type GqlGetSubscriptionsForChainQueryVariables = Exact<{
  dispensaries?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlGetSubscriptionsForChainQuery = { __typename?: 'Query', getBillingSubscriptions: Array<{ __typename?: 'BillingSubscription', dispensaryBilling?: { __typename?: 'DispensaryBilling', chain?: boolean | null, chargebeeCustomer?: { __typename?: 'ChargebeeCustomer', company?: string | null } | null } | null } | null> };

export type GqlGetSubscriptionsV2PaymentSourcesFragment = { __typename?: 'DispensaryBillingV2', paymentSources?: Array<{ __typename?: 'ChargebeePaymentSource', type?: string | null, card?: { __typename?: 'ChargebeeCard', brand?: string | null, last4?: string | null } | null } | null> | null };

export type GqlGetSubscriptionsV2QueryVariables = Exact<{
  retailers: Array<InputMaybe<GqlRetailerInput>> | InputMaybe<GqlRetailerInput>;
}>;


export type GqlGetSubscriptionsV2Query = { __typename?: 'Query', getSubscriptionsV2: Array<{ __typename?: 'SubscriptionV2', manualPayments?: boolean | null, retailerId: string, dispensaryBilling?: { __typename?: 'DispensaryBillingV2', chain?: boolean | null, chargebeeCustomer?: { __typename?: 'ChargebeeCustomer', id?: string | null, company?: string | null, locationCount?: number | null, contacts?: Array<{ __typename?: 'ChargebeeContact', email?: string | null, sendBillingEmail?: boolean | null } | null> | null } | null, paymentSources?: Array<{ __typename?: 'ChargebeePaymentSource', type?: string | null, card?: { __typename?: 'ChargebeeCard', brand?: string | null, last4?: string | null } | null } | null> | null } | null, chargebeeSubscription?: { __typename?: 'ChargebeeSubscriptionV2', status: string, trialStart?: number | null, trialEnd?: number | null, currentTermStart?: number | null, currentTermEnd?: number | null, nextBillingAt?: number | null, createdAt?: number | null, startedAt?: number | null, activatedAt?: number | null, planAmount?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, total: number, status: string, amountPaid?: number | null, amountDue?: number | null, creditsApplied?: number | null, lineItems?: Array<{ __typename?: 'ChargebeeLineItem', dateFrom?: number | null, dateTo?: number | null, quantity?: number | null, amount?: number | null } | null> | null }> | null } | null, chargebeePlan?: { __typename?: 'ChargebeePlan', period: number, periodUnit: string } | null } | null> };

export type GqlGetSubscriptionsQueryVariables = Exact<{
  dispensaries?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlGetSubscriptionsQuery = { __typename?: 'Query', getBillingSubscriptions: Array<{ __typename?: 'BillingSubscription', dispensaryId?: string | null, chargebeeSubscriptionId?: string | null, manualPayments?: boolean | null, dispensaryBilling?: { __typename?: 'DispensaryBilling', chain?: boolean | null, chargebeeCustomerId?: string | null, chargebeeCustomer?: { __typename?: 'ChargebeeCustomer', company?: string | null, locationCount?: number | null, contacts?: Array<{ __typename?: 'ChargebeeContact', email?: string | null, sendBillingEmail?: boolean | null } | null> | null } | null, paymentSources?: Array<{ __typename?: 'ChargebeePaymentSource', type?: string | null, card?: { __typename?: 'ChargebeeCard', brand?: string | null, last4?: string | null } | null } | null> | null } | null, chargebeeSubscription?: { __typename?: 'ChargebeeSubscription', status: string, trialStart?: number | null, trialEnd?: number | null, currentTermStart?: number | null, currentTermEnd?: number | null, nextBillingAt?: number | null, createdAt?: number | null, startedAt?: number | null, activatedAt?: number | null, planAmount?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, total: number, status: string, amountPaid?: number | null, amountDue?: number | null, creditsApplied?: number | null, lineItems?: Array<{ __typename?: 'ChargebeeLineItem', dateFrom?: number | null, dateTo?: number | null, quantity?: number | null, amount?: number | null } | null> | null } | null> | null } | null, chargebeePlan: { __typename?: 'ChargebeePlan', period: number, periodUnit: string } } | null> };

export type GqlBaseDispensaryFragmentFragment = { __typename?: 'Dispensaries', id: string, distance?: number | null, name?: string | null, cName?: string | null, timezone?: string | null, phone?: string | null, address?: string | null, description?: string | null, dposLspName?: string | null, status?: string | null, chain?: string | null, offerAnyPickupService?: boolean | null, offerPickup?: boolean | null, offerCurbsidePickup?: boolean | null, offerDriveThruPickup?: boolean | null, offerDelivery?: boolean | null, listImage?: string | null, bannerImage?: string | null, logoImage?: string | null, embeddedLogoImage?: string | null, embeddedMenuUrl?: string | null, SpecialLogoImage?: string | null, brandedDutchiePayEnabled?: boolean | null, brandedDutchiePayName?: string | null, brandedDutchiePayLogoLight?: string | null, brandedDutchiePayLogoDark?: string | null, embedBackUrl?: string | null, alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, creditCardByPhone?: boolean | null, debitOnly?: boolean | null, cashOnly?: boolean | null, cashless?: boolean | null, createdAtISO?: any | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, recDispensary?: boolean | null, medicalDispensary?: boolean | null, maxDeliveryDistance?: number | null, mixAndMatchPricingWeights?: Array<string | null> | null, acceptsTips?: boolean | null, acceptsDutchiePayTips?: boolean | null, acceptsCreditCardTips?: boolean | null, requiresDriversLicense?: boolean | null, requiresDriversLicenseForPickup?: boolean | null, requirePhotoIdForDelivery?: boolean | null, requirePhotoIdForPickup?: boolean | null, removeMedicalCardFieldsAtCheckout?: boolean | null, menuOrder?: string | null, email?: string | null, emailConfirmation?: boolean | null, stealthMode?: boolean | null, kioskOrderingEnabled?: boolean | null, kioskInstructions?: string | null, categoryLimitsEnabled?: boolean | null, updatedAt?: string | null, updatedAtISO?: any | null, ordersArePaused?: boolean | null, ageVerificationBannerHtml?: string | null, ageVerificationBannerColor?: string | null, menuBannerHtml?: string | null, menuBannerColor?: string | null, menuBannerTextBannerCollapsed?: boolean | null, menuUrl?: string | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null, customDomainSettings?: { __typename?: 'Dispensaries_profile_customDomain_settings', domain?: string | null } | null, plusSettings?: { __typename?: 'Dispensaries_profile_plus_settings', checkoutUrl?: string | null, defaultReturnUrl?: string | null } | null, location?: { __typename?: 'Dispensaries_profile_location', ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipcode?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null } | null } | null, temporalLocation?: { __typename?: 'TemporalLocation', lastUpdatedAt?: any | null, coordinates?: any | null, onDuty?: boolean | null, nearbyEnabled?: boolean | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, categoryPhotos?: Array<{ __typename?: 'CategoryPhoto', src?: string | null, category?: string | null } | null> | null, customCategoryPhotos?: Array<{ __typename?: 'CustomCategoryPhoto', url?: string | null, category?: string | null, collectionId?: string | null } | null> | null, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, embedSettings?: { __typename?: 'Dispensaries_profile_embed_settings', disclaimerTextHtml?: string | null, disablePageLoadsAtTop?: boolean | null, enableFullScreenEmbeddedCheckout?: boolean | null, autoGTM?: boolean | null, privacyPolicyUrl?: string | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, feeType?: FeeTypes | null, max?: string | null, min?: string | null, percentFee?: number | null } | null> | null, menuOrderSettings: Array<{ __typename?: 'MenuOrderSetting', category: string, menuOrder: CategoryMenuOrder }>, menuSortSettings?: Array<{ __typename?: 'MenuSortSetting', brands?: Array<string> | null, category: string, menuOrder: string }> | null, actionEstimates?: { __typename?: 'ActionEstimates', pickup?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null } | null, delivery?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null, deliveryTimeInMinutes?: number | null } | null } | null, durationEstimateOverrides?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, paymentFees?: Array<{ __typename?: 'Dispensaries_paymentFees', fee?: number | null, feeType?: string | null, paymentType?: string | null } | null> | null, kioskConfig?: { __typename?: 'Dispensaries_kioskConfig', fullNameOnly?: boolean | null, phoneRequired?: boolean | null, notesField?: boolean | null, directedOrders?: boolean | null, hidePhoneField?: boolean | null, hideEmailField?: boolean | null, showBirthdateField?: boolean | null, type?: string | null } | null, categoryLimits?: Array<{ __typename?: 'Dispensaries_categoryLimits', name?: string | null, value?: string | null } | null> | null, specialsSettings?: { __typename?: 'SpecialsSettings', discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, enableIndividualSpecialPrecedence?: boolean | null, enableIndividualDiscountStacking?: boolean | null, stackingBehavior?: string | null, nonStackingBehavior?: string | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', isolatedMenus: boolean, customerMessagingTermsAccepted: boolean, showPOSPackageId: boolean, defaultViewStyle: MenuViewStyles, disablePurchaseLimits: boolean, disableGuestDOB: boolean, displayPhoneConfirmation: boolean, displayKioskAnonymousCheckoutDisclaimer?: boolean | null, enableDutchiePayConsumerSurcharge?: boolean | null, requireEmailAddressForGuestCheckout: boolean, requireMedCardPhotoForPickup?: boolean | null, hideAddressFromDutchieMain: boolean, hideFromMobileApp?: boolean | null, requireMedCardPhotoForDelivery?: boolean | null, enableAfterHoursOrderingForPickup: boolean, enableAfterHoursOrderingForDelivery: boolean, enableLLxSaleDiscountSync?: boolean | null, enableMixAndMatchPricingForPickup: boolean, enableMixAndMatchPricingForDelivery: boolean, enableProductUrgencyMessaging?: boolean | null, enableScheduledOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean, enableLimitPerCustomer: boolean, quantityLimit: number, quantityLimitMaxAvailable: boolean, enableOrderStatusEmails: boolean, enableStorefrontAgeGate: boolean, hardAgeGateHideMenuContent: boolean, collapseProductDescription: boolean, disableGuestCheckout: boolean, requirePaymentMethodSelection?: boolean | null, requireTermsAcceptance?: boolean | null, enableCustomTerms?: boolean | null, customTermsText?: string | null, showMobileAppSmartBanner?: boolean | null, stealthMode: boolean, dontCombineWeightedProducts: boolean, keepUncombinedWeights?: boolean | null, dontMapSubcategoriesByProductName?: boolean | null, prioritizeStaffPicksInSearchResults: boolean, provideBackInstockEmailNotifications: boolean, hideEffects: boolean, hideFilters?: boolean | null, hideOutOfStockProducts: boolean, showLoyaltyRewards?: boolean | null, hideDiscountsFromConsumer?: boolean | null, restrictSalesLanguage?: boolean | null, usePotencyForConcentrateLimits?: boolean | null, useStandardEquivalentForEdiblesLimits?: boolean | null, useStateRegulatedImageWatermarks?: boolean | null, enableOmniauthLoginCheckout?: boolean | null, enableRoundToNearestDollar?: boolean | null, hideRoundingLineItem?: boolean | null, subscriptions: { __typename?: 'Dispensaries_subscriptions', enabled?: boolean | null }, rewardsIntegrationConfiguration?: { __typename?: 'Rewards_integration_configuration', rewardsProgramDisplayDescription?: string | null, rewardsProgramDisplayEnrollment?: string | null, rewardsProgramDisplayName?: string | null } | null }, featureFlags: { __typename?: 'Dispensaries_featureFlags', enableAfterHoursOrdering?: boolean | null, enableArrivals?: boolean | null, enableMenuImport?: boolean | null, enableMixAndMatch?: boolean | null, enableNonTerminalAutoConfirm?: boolean | null, enablePausedOrders?: boolean | null, enableScheduledOrdering?: boolean | null, hideDeliveryEstimate?: boolean | null, hideMyAccount?: boolean | null, hideStoreHours?: boolean | null }, terminals?: Array<{ __typename?: 'Dispensaries_terminals', _id?: string | null, nickname?: string | null, versionNumber?: string | null, lastSeenAt?: string | null, lastSeenAtISO?: any | null, config?: { __typename?: 'Device_config', orderSource?: string | null } | null } | null> | null, colorSettings?: { __typename?: 'ColorSettings', linkColor?: string | null, navBarColor?: string | null } | null, pickupMinimum?: { __typename?: 'PickupMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, pickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, curbsidePickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, driveThruPickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null, kiosk?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null } | null } | null, paymentTypesAccepted?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_CurbsidePickupOrderingSettings_Fragment = { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_DeliveryOrderingSettings_Fragment = { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_DriveThruPickupOrderingSettings_Fragment = { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

type GqlBaseOrderingSettingsFragment_InStorePickupOrderingSettings_Fragment = { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlBaseOrderingSettingsFragmentFragment = GqlBaseOrderingSettingsFragment_CurbsidePickupOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_DeliveryOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_DriveThruPickupOrderingSettings_Fragment | GqlBaseOrderingSettingsFragment_InStorePickupOrderingSettings_Fragment;

export type GqlCurbsidePickupOrderingSettingsFragmentFragment = { __typename?: 'CurbsidePickupOrderingSettings', enableCurbsideArrivals?: boolean | null, arrivalInformationInstructions?: string | null, enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlDeliveryOrderingSettingsFragmentFragment = { __typename?: 'DeliveryOrderingSettings', deliveryMode?: DeliveryModes | null, enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, deliveryFeeTiers?: Array<{ __typename?: 'DeliveryFeeTiers', feeInCents?: number | null, maximumInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null } | null> | null, deliveryRadius?: { __typename?: 'DeliveryRadius', radiusInMiles?: number | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null } | null, deliveryZipCodes?: Array<{ __typename?: 'DeliveryZipCodes', zipCode?: string | null, feeInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null } | null> | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlDeliveryZonesFragmentFragment = { __typename?: 'DeliveryOrderingSettings', deliveryZones?: Array<{ __typename?: 'DeliveryZones', _id?: string | null, name?: string | null, feeInCents?: number | null, minimumInCents?: number | null, feeType?: FeeTypes | null, percentFee?: number | null, area?: { __typename?: 'Polygon', type?: string | null, features?: Array<{ __typename?: 'GeoJson_features', type?: string | null, geometry?: { __typename?: 'GeoJson_geometry', type?: string | null, coordinates?: any | null } | null } | null> | null } | null } | null> | null };

export type GqlDriveThruPickupOrderingSettingsFragmentFragment = { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlHourSetFragmentFragment = { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null };

export type GqlHoursForDayFragment = { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null };

export type GqlHoursSettingsForOrderTypeFragmentFragment = { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null };

export type GqlInStorePickupOrderingSettingsFragmentFragment = { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null, checkoutMessage?: string | null, orderMinimum?: { __typename?: 'OrderMinimum', enabled?: boolean | null, minimumInCents?: number | null } | null, pickupReminders?: { __typename?: 'PickupReminders', enabled?: boolean | null, reminderMinutesAfterReady?: number | null, reminderMessage?: string | null } | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, scheduledOrderingConfigV2?: { __typename?: 'ScheduledOrderingConfigV2', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null } | null };

export type GqlKioskOrderingSettingsFragmentFragment = { __typename?: 'KioskOrderingSettings', enabled?: boolean | null, fullNameOnly?: boolean | null, phoneRequired?: boolean | null, notesField?: boolean | null, directedOrders?: boolean | null, hideEmailField?: boolean | null, hidePhoneField?: boolean | null, showBirthdateField?: boolean | null, anonymousCheckout?: boolean | null, kioskInstructions?: string | null, type?: KioskTypes | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null } | null, timeout?: { __typename?: 'TimeoutConfig', enabled?: boolean | null, duration?: number | null } | null };

export type GqlMaxReservationSlotFragmentFragment = { __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null };

export type GqlMaxReservationSlotsByDayFragmentFragment = { __typename?: 'MaxReservationSlotsByDay', Monday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Tuesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Wednesday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Thursday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Friday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Saturday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null, Sunday?: Array<{ __typename?: 'MaxReservationSlot', active?: boolean | null, currentCount?: number | null, date?: any | null, startTime?: string | null, endTime?: string | null, maxOrders?: number | null, deliveryAreaId?: string | null, slotId?: string | null, isNextDaySlot?: boolean | null } | null> | null };

export type GqlMenuSectionFragmentFragment = { __typename?: 'MenuSection', id: string, brandId?: string | null, category?: string | null, label: string, linkLabel: string, position: number, subcategory?: string | null, sectionType: MenuSectionType, products?: Array<string> | null, collectionId?: string | null, sortBy?: string | null, image?: { __typename?: 'ImageBanner', _id: string, image: string, mobileImage: string, alt?: string | null, position: number, platforms?: Array<{ __typename?: 'ImageBannerPlatform', enabled: boolean, link?: string | null, openInNewTab?: boolean | null, type: ImageBannerPlatformType } | null> | null } | null, collectionSchedule?: { __typename?: 'Schedule', startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, startTime: string, endTime: string }> | null } | null };

export type GqlPaymentTypesFragmentFragment = { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null };

export type GqlScheduledOrderingConfigFragmentFragment = { __typename?: 'ReservationOptionsForOrderType', advancedDayOrderingEnabled?: boolean | null, sameDayDeliveryEnabled?: boolean | null, advancedDayOrderingLimit?: number | null, incrementInMinutes?: number | null, nextAvailableInMinutes?: number | null, orderLimitsEnabled?: boolean | null };

export type GqlSpecialHoursDayFragmentFragment = { __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } };

export type GqlSpecialHoursFragmentFragment = { __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null };

export type GqlTaxPropertiesFragment = { __typename?: 'Dispensaries_TaxConfig_Tax', id: string, type: TaxType, name: string, rate: number, potencyRate?: number | null, potency?: PotencyType | null, medical: boolean, recreational: boolean, taxBasis?: string | null, order?: number | null, deliveryPolicy?: DeliveryPolicy | null, includeStateSalesTaxInDestinationRate?: boolean | null, stages: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax_Stage', op: Dispensaries_TaxConfig_Tax_Stage_Ops, type: Dispensaries_TaxConfig_Tax_Stage_Types } | null>, applyTo: { __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo', types: Array<string | null>, hemp: boolean } };

export type GqlWeeklyHoursFragmentFragment = { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null };

export type GqlDispensaryOnboardingMutationVariables = Exact<{
  input: GqlDispensaryOnboardingInput;
}>;


export type GqlDispensaryOnboardingMutation = { __typename?: 'Mutation', dispensaryOnboarding?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDispensaryUploadOnboardingAssetMutationVariables = Exact<{
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type GqlDispensaryUploadOnboardingAssetMutation = { __typename?: 'Mutation', dispensaryUploadOnboardingAsset?: { __typename?: 'DispensaryAssetUploadResponse', fileIds?: Array<string | null> | null } | null };

export type GqlGetAddressBasedDispensaryDataQueryVariables = Exact<{
  input?: InputMaybe<GqlGetDeliveryInfoInput>;
}>;


export type GqlGetAddressBasedDispensaryDataQuery = { __typename?: 'Query', getAddressBasedDispensaryData?: { __typename?: 'AddressBasedDispensaryDataResult', deliveryInfo: { __typename?: 'Dispensaries_deliveryInfo', deliveryAreaId?: string | null, withinBounds?: boolean | null, fee?: number | null, minimum?: number | null, feeVaries?: boolean | null, minimumVaries?: boolean | null }, taxes?: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax', destinationRate?: number | null, id: string, type: TaxType, name: string, rate: number, potencyRate?: number | null, potency?: PotencyType | null, medical: boolean, recreational: boolean, taxBasis?: string | null, order?: number | null, deliveryPolicy?: DeliveryPolicy | null, includeStateSalesTaxInDestinationRate?: boolean | null, stages: Array<{ __typename?: 'Dispensaries_TaxConfig_Tax_Stage', op: Dispensaries_TaxConfig_Tax_Stage_Ops, type: Dispensaries_TaxConfig_Tax_Stage_Types } | null>, applyTo: { __typename?: 'Dispensaries_TaxConfig_Tax_ApplyTo', types: Array<string | null>, hemp: boolean } }> | null } | null };

export type GqlDispensarySearchQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlDispensarySearchQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, status?: string | null, recDispensary?: boolean | null, medicalDispensary?: boolean | null, offerPickup?: boolean | null, offerCurbsidePickup?: boolean | null, offerDriveThruPickup?: boolean | null, offerAnyPickupService?: boolean | null, offerDelivery?: boolean | null, listImage?: string | null, distance?: number | null, maxDeliveryDistance?: number | null, timezone?: string | null, location?: { __typename?: 'Dispensaries_profile_location', city?: string | null, county?: string | null, ln1?: string | null, ln2?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null, type?: string | null } | null } | null, actionEstimates?: { __typename?: 'ActionEstimates', delivery?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null, deliveryTimeInMinutes?: number | null } | null, pickup?: { __typename?: 'ActionEstimatesValues', readyInMinutes?: number | null, rangeInMinutes?: number | null } | null } | null, durationEstimateOverrides?: { __typename?: 'DurationEstimates', pickup?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null, delivery?: { __typename?: 'DurationEstimateRange', enabled?: boolean | null, lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', enableAfterHoursOrderingForPickup: boolean, enableAfterHoursOrderingForDelivery: boolean, enableScheduledOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean }, featureFlags: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null }, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, deliveryInfo?: { __typename?: 'Dispensaries_deliveryInfo', withinBounds?: boolean | null, fee?: number | null, minimum?: number | null, feeVaries?: boolean | null, minimumVaries?: boolean | null, feeType?: FeeTypes | null, percentFee?: number | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, feeType?: FeeTypes | null, max?: string | null, min?: string | null, percentFee?: number | null } | null> | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, pickupHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null }, deliveryHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null } } | null> | null } | null> | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, pickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, curbsidePickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, driveThruPickup?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null, kiosk?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null, paymentTypes?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null } | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, inStorePickup?: { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, driveThruPickup?: { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, delivery?: { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null } | null, hoursSettings?: { __typename?: 'DispensaryHoursSettings', inStorePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, curbsidePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, driveThruPickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, delivery?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null } | null, enabledOrderTypes?: { __typename?: 'EnabledOrderTypes', pickup?: boolean | null, inStorePickup?: boolean | null, curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, delivery?: boolean | null, kiosk?: boolean | null } | null, paymentTypesAccepted?: { __typename?: 'PaymentTypesConfig', alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineChase?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, payOnlineMoneris?: boolean | null, creditCardByPhone?: boolean | null, debit?: boolean | null, cash?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, dutchiePay?: boolean | null, rethinkPay?: boolean | null } | null } | null> | null };

export type GqlCopyToLocationsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  klass: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  enableAllLocations?: InputMaybe<Scalars['Boolean']['input']>;
  dispensaryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isoRegionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlCopyToLocationsMutation = { __typename?: 'Mutation', copyToLocations?: { __typename?: 'CopyToLocationsResponse', success: boolean, message?: string | null } | null };

export type GqlCreateEnterpriseLoyaltySettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreateEnterpriseLoyaltySettingsMutation = { __typename?: 'Mutation', createEnterpriseLoyaltySettings?: { __typename?: 'EnterpriseLoyaltySettings', enterpriseId: string, landingPageUrl?: string | null, loyaltyEnrollmentUrl?: string | null, name: string, uniqueName: string, dposLoyaltyIsoRegionCodes?: Array<string | null> | null, description?: string | null, displayName?: string | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null } | null };

export type GqlUpdateEnterpriseLoyaltySettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnrollmentUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlUpdateEnterpriseLoyaltySettingsMutation = { __typename?: 'Mutation', updateEnterpriseLoyaltySettings?: { __typename?: 'EnterpriseLoyaltySettings', enterpriseId: string, landingPageUrl?: string | null, loyaltyEnrollmentUrl?: string | null, name: string, uniqueName: string, dposLoyaltyIsoRegionCodes?: Array<string | null> | null, description?: string | null, displayName?: string | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null } | null };

export type GqlUpdateEnterpriseMobileAppSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  input?: InputMaybe<GqlEnterpriseMobileAppSettingsInput>;
}>;


export type GqlUpdateEnterpriseMobileAppSettingsMutation = { __typename?: 'Mutation', updateEnterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidExistingVersion?: string | null, androidExistingVersionCode?: number | null, androidOrganizationName?: string | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, automaticScreenshotGeneration?: boolean | null, buildForIpad?: boolean | null, firebaseProjectId?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosExistingVersion?: string | null, iosSplashBackgroundColor?: string | null, iosTeamId?: string | null, iosTeamName?: string | null, name?: string | null, shortName?: string | null } | null };

export type GqlEnterpriseLoyaltySettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseLoyaltySettingsQuery = { __typename?: 'Query', enterpriseLoyaltySettings?: { __typename?: 'EnterpriseLoyaltySettings', description?: string | null, displayName?: string | null, enterpriseId: string, landingPageUrl?: string | null, loyaltyEnrollmentUrl?: string | null, name: string, uniqueName: string, dposLoyaltyIsoRegionCodes?: Array<string | null> | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null } | null };

export type GqlEnterpriseMobileAppSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseMobileAppSettingsQuery = { __typename?: 'Query', enterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosSplashBackgroundColor?: string | null } | null };

export type GqlAdminEnterpriseMobileAppSettingsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlAdminEnterpriseMobileAppSettingsQuery = { __typename?: 'Query', enterpriseMobileAppSettings?: { __typename?: 'EnterpriseMobileAppSettings', androidAppIcon?: string | null, androidExistingVersion?: string | null, androidExistingVersionCode?: number | null, androidOrganizationName?: string | null, androidPackageName?: string | null, androidSplashBackgroundColor?: string | null, automaticScreenshotGeneration?: boolean | null, buildForIpad?: boolean | null, firebaseProjectId?: string | null, iosAppIcon?: string | null, iosAppStoreId?: string | null, iosBundleIdentifier?: string | null, iosExistingVersion?: string | null, iosSplashBackgroundColor?: string | null, iosTeamId?: string | null, iosTeamName?: string | null, name?: string | null, shortName?: string | null } | null };

export type GqlGeolocateConsumerQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGeolocateConsumerQuery = { __typename?: 'Query', geolocate?: { __typename?: 'IPInfo', ip?: string | null, hostname?: string | null, city?: string | null, region?: string | null, country?: string | null, loc?: string | null, org?: string | null, postal?: string | null, timezone?: string | null } | null };

export type GqlGenerateHypurTokenV2MutationVariables = Exact<{
  code: Scalars['String']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
}>;


export type GqlGenerateHypurTokenV2Mutation = { __typename?: 'Mutation', generateHypurTokenV2?: { __typename?: 'HypurToken', accessToken: string, embedded: boolean } | null };

export type GqlCreateLibraryProductV2MutationVariables = Exact<{
  libraryProduct: GqlNewLibraryProduct;
  state: Scalars['String']['input'];
}>;


export type GqlCreateLibraryProductV2Mutation = { __typename?: 'Mutation', createLibraryProductV2?: { __typename?: 'LibraryProduct', id: string } | null };

export type GqlCreateLibraryProductV3MutationVariables = Exact<{
  libraryProduct: GqlNewLibraryProductV2;
  state: Scalars['String']['input'];
}>;


export type GqlCreateLibraryProductV3Mutation = { __typename?: 'Mutation', createLibraryProductV3?: { __typename?: 'LibraryProduct', id: string } | null };

export type GqlMatchLibraryProductsV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GqlMatchLibraryProductsV2Query = { __typename?: 'Query', matchLibraryProductsV2?: Array<{ __typename?: 'LibraryProduct', id: string, category?: string | null, image?: string | null, name: string, price: number, productTemplate?: boolean | null, stockImage?: string | null, strainType?: string | null, subcategory?: string | null, brand?: { __typename?: 'Brand', id: string, name: string, imageUrl?: string | null } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, images?: Array<{ __typename?: 'Products_Images', _id?: string | null, url: string, active: boolean, origin: ImageOrigin } | null> | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null> | null };

export type GqlMatchLibraryProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  productTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlMatchLibraryProductsQuery = { __typename?: 'Query', matchLibraryProducts?: Array<{ __typename?: 'LibraryProduct', id: string, category?: string | null, image?: string | null, name: string, price: number, strainType?: string | null, subcategory?: string | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, cbdContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, thcContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null } | null> | null };

export type GqlAddressResidentialCheckQueryVariables = Exact<{
  input: GqlAddressResidentialCheckInput;
}>;


export type GqlAddressResidentialCheckQuery = { __typename?: 'Query', addressResidentialCheck?: { __typename?: 'ValidationResponse', isValid?: boolean | null } | null };

export type GqlHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlHealthCheckQuery = { __typename?: 'Query', healthCheck?: { __typename?: 'HealthCheck', status?: string | null } | null };

export type GqlResetPasswordV2MutationVariables = Exact<{
  input: GqlResetPasswordInput;
}>;


export type GqlResetPasswordV2Mutation = { __typename?: 'Mutation', resetPasswordV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendBrandUserPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GqlSendBrandUserPasswordResetEmailMutation = { __typename?: 'Mutation', sendBrandUserPasswordResetEmail?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendCompleteAccountSetupEmailMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlSendCompleteAccountSetupEmailMutation = { __typename?: 'Mutation', sendCompleteAccountSetupEmail?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendPasswordResetEmailV2MutationVariables = Exact<{
  email: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlSendPasswordResetEmailV2Mutation = { __typename?: 'Mutation', sendPasswordResetEmailV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSetPasswordV2MutationVariables = Exact<{
  input: GqlSetPasswordInput;
}>;


export type GqlSetPasswordV2Mutation = { __typename?: 'Mutation', setPasswordV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdatePasswordV2MutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type GqlUpdatePasswordV2Mutation = { __typename?: 'Mutation', updatePasswordV2?: { __typename?: 'PasswordUpdate', accessToken: string } | null };

export type GqlGetPaymentsCheckoutCredentialsQueryVariables = Exact<{
  adapter: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetPaymentsCheckoutCredentialsQuery = { __typename?: 'Query', getPaymentsCheckoutCredentials?: { __typename?: 'ChaseHostedProfileCredentials', uID: string } | { __typename?: 'MonerisHTProfileCredentials', profileId: string } | null };

export type GqlGetMonerisTokenizationProfileQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetMonerisTokenizationProfileQuery = { __typename?: 'Query', getMonerisTokenizationProfile?: { __typename?: 'MonerisTokenizationProfile', profileId: string } | null };

export type GqlGetCustomerCommunicationSettingsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GqlGetCustomerCommunicationSettingsQuery = { __typename?: 'Query', getCustomerCommunicationSettings?: { __typename?: 'CommunicationSettings', optInEmail?: boolean | null, optInSMS?: boolean | null, optInPush?: boolean | null } | null };

export type GqlUpdateCustomerCommunicationSettingsMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  optInPush?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlUpdateCustomerCommunicationSettingsMutation = { __typename?: 'Mutation', updateCustomerCommunicationSettings?: { __typename?: 'PreferenceSettingsResponse', success?: boolean | null } | null };

export type GqlArchivedProductLookupQueryVariables = Exact<{
  cname: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlArchivedProductLookupQuery = { __typename?: 'Query', archivedProductLookup?: Array<{ __typename?: 'Products', effects?: any | null, description?: string | null, descriptionHtml?: string | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null> | null };

export type GqlConsumerBaseProductFragmentFragment = { __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null };

export type GqlConsumerSponsoredProductFragmentFragment = { __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, adTrackers?: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string } | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null };

export type GqlFilteredProductsQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlFilteredProductsQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', effects?: any | null, provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, cannabinoidsV2?: Array<{ __typename?: 'Products_CannabinoidV2', value?: number | null, unit?: PotencyUnit | null, cannabinoid?: { __typename?: 'Cannabinoid', name: string } | null } | null> | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null>, queryInfo: { __typename?: 'queryInfoType', totalCount?: number | null, totalPages?: number | null } } | null };

export type GqlIndividualFilteredProductQueryVariables = Exact<{
  productsFilter: GqlProductsFilterInput;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlIndividualFilteredProductQuery = { __typename?: 'Query', filteredProducts?: { __typename?: 'ProductsList', products: Array<{ __typename?: 'Products', effects?: any | null, description?: string | null, descriptionHtml?: string | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, _id: string, description?: string | null, imageUrl?: string | null, name: string, parentBrandId?: string | null } | null, terpenes?: Array<{ __typename?: 'Products_Terpene', id?: string | null, terpeneId?: string | null, unit?: PotencyUnit | null, unitSymbol?: string | null, value?: number | null, libraryTerpene?: { __typename?: 'Terpene', aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, name?: string | null } | null } | null> | null, cannabinoidsV2?: Array<{ __typename?: 'Products_CannabinoidV2', value?: number | null, unit?: PotencyUnit | null, cannabinoid?: { __typename?: 'Cannabinoid', name: string, description?: string | null } | null } | null> | null, outletCollectionInfo?: { __typename?: 'OutletCollectionInfo', timerMessage?: string | null, endDate?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null> } | null };

export type GqlPosMetaDataFragmentFragment = { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null };

export type GqlCreateRedemptionMutationVariables = Exact<{
  code: Scalars['String']['input'];
  receiverUserId: Scalars['String']['input'];
}>;


export type GqlCreateRedemptionMutation = { __typename?: 'Mutation', createRedemption?: { __typename?: 'Redemption', id?: string | null, code?: string | null, receiverUserId?: string | null, lspName?: string | null, lspId?: string | null, status?: string | null } | null };

export type GqlFindOrCreateReferralCodeMutationVariables = Exact<{
  lspName: Scalars['String']['input'];
  senderUserId?: InputMaybe<Scalars['String']['input']>;
  dispensaryId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  posUniqueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlFindOrCreateReferralCodeMutation = { __typename?: 'Mutation', findOrCreateReferralCode?: { __typename?: 'ReferralCode', code?: string | null, id?: string | null, lspName?: string | null, senderEcommId?: string | null, senderPosUniqueId?: string | null, senderPoints?: string | null, receiverPoints?: string | null, learnMoreUrl?: string | null, referralUrl?: string | null } | null };

export type GqlCreateAlpineUserV2MutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  program: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  favoriteStore: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  acceptedTerms: Scalars['Boolean']['input'];
}>;


export type GqlCreateAlpineUserV2Mutation = { __typename?: 'Mutation', createAlpineUserV2?: { __typename?: 'RewardUserResponse', success?: boolean | null, wallet?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, costV2: number, value: string, rewardType: string } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null } | null } | null };

export type GqlCreateAlpineUserMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  program: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  favoriteStore: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  acceptedTerms: Scalars['Boolean']['input'];
}>;


export type GqlCreateAlpineUserMutation = { __typename?: 'Mutation', createAlpineUser?: { __typename?: 'RewardUserResponse', success?: boolean | null, wallet?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, costV2: number, value: string, rewardType: string } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null } | null } | null };

export type GqlCreateDutchiePosLoyaltyMemberV2MutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreateDutchiePosLoyaltyMemberV2Mutation = { __typename?: 'Mutation', createDutchiePosLoyaltyMemberV2?: { __typename?: 'LoyaltyMemberResponse', posCustomerId?: string | null, isLoyaltyMember?: boolean | null } | null };

export type GqlCreateDutchiePosLoyaltyMemberMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreateDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', createDutchiePosLoyaltyMember?: { __typename?: 'RewardUserResponse', success?: boolean | null } | null };

export type GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation = { __typename?: 'Mutation', createEnterpriseDutchiePosLoyaltyMemberV2?: { __typename?: 'LoyaltyMemberResponse', posCustomerId?: string | null, isLoyaltyMember?: boolean | null } | null };

export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
  isLoyaltyMember?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', createEnterpriseDutchiePosLoyaltyMember?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlCreateSpringbigUserMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GqlCreateSpringbigUserMutation = { __typename?: 'Mutation', createSpringbigUser?: { __typename?: 'RewardUserResponse', success?: boolean | null } | null };

export type GqlUpdateDutchiePosLoyaltyMemberMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  lastAndroidLoginUtc?: InputMaybe<Scalars['String']['input']>;
  lastIosLoginUtc?: InputMaybe<Scalars['String']['input']>;
  senderUniqueId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlUpdateDutchiePosLoyaltyMemberMutation = { __typename?: 'Mutation', updateDutchiePosLoyaltyMember?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetDutchiePosLoyaltyConfigQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetDutchiePosLoyaltyConfigQuery = { __typename?: 'Query', getDutchiePosLoyaltyConfig?: { __typename?: 'DutchiePosLoyaltyConfig', loyaltyRequireOptIn: boolean, isEnabled: boolean, loyaltyDaysToExpiration?: number | null, onlineName?: string | null, onlineDescription?: string | null, tierEarningBasis?: string | null, redemptionType?: string | null, mode?: string | null, dispensaryId?: string | null, tiers?: Array<{ __typename?: 'DutchiePosLoyaltyTier', id: number, name: string, threshold: number, badgeColor: string } | null> | null, referralConfig?: { __typename?: 'DutchieReferralConfig', isEnabled?: boolean | null, learnMoreUrl?: string | null, senderReward?: number | null, receiverReward?: number | null, minimumPurchaseAmount?: number | null } | null } | null };

export type GqlGetLoyaltyPassUrlQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetLoyaltyPassUrlQuery = { __typename?: 'Query', getLoyaltyPassUrl?: { __typename?: 'LoyaltyPassUrl', url: string, shortUrl?: string | null } | null };

export type GqlGetRewardsV2QueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  isoRegionCode?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetRewardsV2Query = { __typename?: 'Query', getRewardsV2?: { __typename?: 'RewardsListV2', balance: string, rewardBrand: string, userHasWallet: boolean, isLoyaltyMember?: boolean | null, currentYearTierBalance?: string | null, expirationDate?: string | null, tierName?: string | null, tierId?: number | null, posCustomerId?: string | null, posUniqueId?: string | null, isRevokedFromReferralProgram?: boolean | null, rewards: Array<{ __typename?: 'RewardV2', id: string, copy?: string | null, available: boolean, operator: string, cost: number, costV2: number, value: string, rewardType: string, discountId?: number | null, brand?: string | null, isRedeemableOnline?: boolean | null, isEligible?: boolean | null } | null>, auth?: { __typename?: 'UserAuthInfo', pinConfirmed?: boolean | null, incorrectPinProvided?: boolean | null, authTextMessageSent?: boolean | null } | null, rewardsActivity?: Array<{ __typename?: 'RewardsActivity', lspName?: string | null, location?: string | null, customerId?: string | null, transactionType?: string | null, transactionDateUtc?: string | null, points?: number | null, comment?: string | null, orderType?: string | null, isAdjustment?: boolean | null, totalPaid?: number | null } | null> | null } | null };

export type GqlScheduleFieldsFragment = { __typename?: 'Schedule', endDate?: any | null, id: string, startDate: any, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, endTime: string, startTime: string }> | null };

export type GqlBulkEndSpecialsV2MutationVariables = Exact<{
  input: GqlEndSpecialsInput;
}>;


export type GqlBulkEndSpecialsV2Mutation = { __typename?: 'Mutation', bulkEndSpecialsV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateEnterpriseSpecialV2MutationVariables = Exact<{
  input: GqlEnterpriseSpecialInputV2;
}>;


export type GqlCreateEnterpriseSpecialV2Mutation = { __typename?: 'Mutation', createEnterpriseSpecialV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateEnterpriseSpecialsSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  input: GqlEnterpriseSpecialsSettingsInput;
}>;


export type GqlCreateEnterpriseSpecialsSettingsMutation = { __typename?: 'Mutation', createEnterpriseSpecialsSettings?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlCreateSpecialV3MutationVariables = Exact<{
  input: GqlSpecialsInputV3;
}>;


export type GqlCreateSpecialV3Mutation = { __typename?: 'Mutation', createSpecialV3?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlDeleteEnterpriseSpecialMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GqlDeleteEnterpriseSpecialMutation = { __typename?: 'Mutation', deleteEnterpriseSpecial?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlDeleteSpecialV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteSpecialV2Mutation = { __typename?: 'Mutation', deleteSpecialV2?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlEndEnterpriseSpecialMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GqlEndEnterpriseSpecialMutation = { __typename?: 'Mutation', endEnterpriseSpecial?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlEndSpecialV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlEndSpecialV2Mutation = { __typename?: 'Mutation', endSpecialV2: { __typename?: 'Specials', _id?: string | null } };

export type GqlIncrementSpecialClicksMutationVariables = Exact<{
  input: GqlIncrementClicksInput;
}>;


export type GqlIncrementSpecialClicksMutation = { __typename?: 'Mutation', incrementClicks?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateEnterpriseSpecialV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GqlEnterpriseSpecialInputV2;
}>;


export type GqlUpdateEnterpriseSpecialV2Mutation = { __typename?: 'Mutation', updateEnterpriseSpecialV2?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateEnterpriseSpecialsSettingsMutationVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  input: GqlEnterpriseSpecialsSettingsInput;
}>;


export type GqlUpdateEnterpriseSpecialsSettingsMutation = { __typename?: 'Mutation', updateEnterpriseSpecialsSettings?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlUpdateSpecialV3MutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GqlSpecialsInputV3;
}>;


export type GqlUpdateSpecialV3Mutation = { __typename?: 'Mutation', updateSpecialV3?: { __typename?: 'Specials', _id?: string | null } | null };

export type GqlUpdateSpecialsSortOrderMutationVariables = Exact<{
  input: GqlSortOrderInput;
}>;


export type GqlUpdateSpecialsSortOrderMutation = { __typename?: 'Mutation', updateSpecialsSortOrder?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlEnterpriseSpecialsV3QueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
  filter?: InputMaybe<GqlFilteredSpecialsInputV2>;
}>;


export type GqlEnterpriseSpecialsV3Query = { __typename?: 'Query', enterpriseSpecialsV3?: { __typename?: 'FilteredEnterpriseSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, complete?: boolean | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, displayRank?: number | null, earliestStartStamp?: any | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, isRecurring?: boolean | null, latestEndStamp?: any | null, localTime?: boolean | null, menuDisplayDescription?: string | null, menuDisplayName?: string | null, menuDisplayImage?: string | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, retailers?: Array<string | null> | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlEnterpriseSpecialsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseSpecialsQuery = { __typename?: 'Query', enterpriseSpecials?: Array<{ __typename?: 'EnterpriseSpecial', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, cipher?: any | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, discount?: string | null, discountedPrices?: any | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: any | null, endStamp?: any | null, endTime?: string | null, enterpriseId?: string | null, enterpriseSpecialId?: string | null, heading?: string | null, isRecurring?: boolean | null, localTime?: boolean | null, menuDisplayDescription?: string | null, menuDisplayName?: string | null, menuDisplayImage?: string | null, menuType?: string | null, name?: string | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, retailers?: Array<string | null> | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, startDay?: any | null, startStamp?: any | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, timezone?: string | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, requiresSingleSku?: boolean | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, strainIds?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null };

export type GqlFilteredSpecialsV2QueryVariables = Exact<{
  specialsFilter: GqlFilteredSpecialsInput;
  translateSpecialsToV3?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlFilteredSpecialsV2Query = { __typename?: 'Query', filteredSpecialsV2?: { __typename?: 'FilteredSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, nonStackingBehavior?: string | null, platformType?: Array<PlatformType | null> | null, preOrderType?: Array<PreOrderType | null> | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'DiscountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlFilteredSpecialsQueryVariables = Exact<{
  specialsFilter: GqlFilteredSpecialsInput;
  includeEnterpriseSpecials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlFilteredSpecialsQuery = { __typename?: 'Query', filteredSpecials?: { __typename?: 'FilteredSpecials', queryInfo?: { __typename?: 'FilteredSpecialsInfo', totalCount?: number | null } | null, specials?: Array<{ __typename?: 'Specials', _id?: string | null, active?: boolean | null, applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, bogoConditionLogicOperator?: string | null, menuDisplayImage?: string | null, bogoRewardLogicOperator?: string | null, clicks?: number | null, createdAt?: any | null, createdBy?: string | null, description?: string | null, descriptionHtml?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, discount?: string | null, discountedPrices?: any | null, discountPrecedence?: string | null, discountStacking?: boolean | null, dispensaryId?: string | null, displayRank?: number | null, emailSpecial?: boolean | null, endDay?: string | null, endStamp?: string | null, endTime?: string | null, heading?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, name?: string | null, nonStackingBehavior?: string | null, platformType?: Array<PlatformType | null> | null, preOrderType?: Array<PreOrderType | null> | null, percentDiscount?: boolean | null, productDiscounts?: any | null, productGroup?: string | null, productGroupRewards?: string | null, products?: Array<string | null> | null, redemptionLimit?: number | null, scope?: SpecialScopes | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: SpecialTypes | null, stackingBehavior?: string | null, stackingMode?: string | null, startDate?: string | null, startDay?: string | null, startStamp?: string | null, startTime?: string | null, subject?: string | null, targetPrice?: boolean | null, updatedAt?: string | null, updatedBy?: string | null, version?: number | null, bogoConditions?: Array<{ __typename?: 'BogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'BogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, dollarDiscount?: string | null, discountAmount?: number | null, discountType?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, percentDiscount?: string | null, quantity?: number | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, requiresSingleSku?: boolean | null, targetPrice?: string | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: Array<{ __typename?: 'SpecialsExcludedProducts', _id?: string | null, Name?: string | null, key?: string | null, conditions?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null, rewards?: Array<{ __typename?: 'SpecialsExcludedBOGO', _id?: string | null, Name?: string | null, key?: string | null } | null> | null } | null> | null, itemsForAPrice?: { __typename?: 'ItemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, discountBundle?: { __typename?: 'DiscountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, recurring?: { __typename?: 'SpecialsRecurring', days?: Array<number | null> | null, endDate?: string | null, endTime?: string | null, setEndDate?: boolean | null, startTime?: string | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, inventoryTags?: Array<string> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null } | null };

export type GqlGetSpecialGamificationQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  menuType?: InputMaybe<Scalars['String']['input']>;
  specialIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GqlGetSpecialGamificationQuery = { __typename?: 'Query', getSpecialGamification?: { __typename?: 'SpecialGamificationList', gamificationThresholds?: Array<{ __typename?: 'GamificationDetailItem', discountId?: number | null, satisfiers?: Array<{ __typename?: 'GamificationDetailItem_Satisfier', thresholdType?: string | null, minimumThreshold?: number | null } | null> | null } | null> | null } | null };

export type GqlGetSpecialMenuCardsQueryVariables = Exact<{
  dispensaryId: Scalars['ID']['input'];
  menuType: Scalars['String']['input'];
  specialId?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  ecomUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetSpecialMenuCardsQuery = { __typename?: 'Query', getSpecialMenuCards?: { __typename?: 'SpecialMenuCardResponse', menuCards?: Array<{ __typename?: 'SpecialMenuCard', _id?: string | null, displayRank?: number | null, menuDisplayName?: string | null, menuDisplayDescription?: string | null, menuDisplayImage?: string | null, posDiscountId?: string | null, specialType?: string | null, isRestricted?: boolean | null } | null> | null } | null };

export type GqlGetStockImageQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetStockImageQuery = { __typename?: 'Query', getStockImage?: { __typename?: 'StockImage', url: string } | null };

export type GqlCreateStrainV2MutationVariables = Exact<{
  input: GqlStrainInput;
}>;


export type GqlCreateStrainV2Mutation = { __typename?: 'Mutation', createStrainV2?: { __typename?: 'Strain', id: string } | null };

export type GqlDeleteStrainMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteStrainMutation = { __typename?: 'Mutation', deleteStrain?: { __typename?: 'Strain', id: string } | null };

export type GqlUpdateStrainV2MutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GqlStrainInput;
}>;


export type GqlUpdateStrainV2Mutation = { __typename?: 'Mutation', updateStrainV2?: { __typename?: 'Strain', id: string } | null };

export type GqlFilteredStrainsQueryVariables = Exact<{
  filter?: InputMaybe<GqlStrainsFilterInput>;
  sort?: InputMaybe<GqlStrainsSortInput>;
  pagination?: InputMaybe<GqlPaginationInput>;
}>;


export type GqlFilteredStrainsQuery = { __typename?: 'Query', filteredStrains?: { __typename?: 'StrainList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, strains?: Array<{ __typename?: 'Strain', description?: string | null, effects?: Array<string | null> | null, id: string, imageUrl?: string | null, name?: string | null, potentialHealthBenefits?: Array<string | null> | null } | null> | null } | null };

export type GqlGetStrainQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetStrainQuery = { __typename?: 'Query', getStrain?: { __typename?: 'Strain', aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, imageUrl?: string | null, labels?: Array<string | null> | null, name?: string | null, potentialHealthBenefits?: Array<string | null> | null, ratio?: string | null, terpenes?: Array<{ __typename?: 'Terpene', id: string, name?: string | null } | null> | null } | null };

export type GqlGetCustomerSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCustomerSubscriptionsQuery = { __typename?: 'Query', getCustomerSubscriptions: Array<{ __typename?: 'CustomerSubscription', dispensaryId?: string | null, dispensaryName?: string | null, emailOptIn?: boolean | null, emailSubscription?: boolean | null, id: string }> };

export type GqlGetUnsubscribeDispensaryQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GqlGetUnsubscribeDispensaryQuery = { __typename?: 'Query', unsubscribeCustomerQuery?: { __typename?: 'CustomerUnsubscribe', subscribed?: boolean | null, dispensary?: { __typename?: 'Dispensaries', name?: string | null, logoImage?: string | null } | null } | null };

export type GqlTerpeneFragmentFragment = { __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null };

export type GqlCreateTerpeneMutationVariables = Exact<{
  terpene: GqlTerpeneInput;
}>;


export type GqlCreateTerpeneMutation = { __typename?: 'Mutation', createTerpeneV2?: { __typename?: 'Terpene', id: string } | null };

export type GqlDeleteTerpeneMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlDeleteTerpeneMutation = { __typename?: 'Mutation', deleteTerpene?: { __typename?: 'Terpene', id: string } | null };

export type GqlUpdateTerpeneMutationVariables = Exact<{
  id: Scalars['String']['input'];
  terpene: GqlTerpeneInput;
}>;


export type GqlUpdateTerpeneMutation = { __typename?: 'Mutation', updateTerpeneV2?: { __typename?: 'Terpene', id: string } | null };

export type GqlFilteredTerpenesQueryVariables = Exact<{
  filter?: InputMaybe<GqlTerpenesFilter>;
  sort?: InputMaybe<GqlTerpenesSort>;
}>;


export type GqlFilteredTerpenesQuery = { __typename?: 'Query', filteredTerpenes?: Array<{ __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null, strains: Array<{ __typename?: 'Strain', _id?: string | null } | null> } | null> | null };

export type GqlGetTerpeneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetTerpeneQuery = { __typename?: 'Query', getTerpene?: { __typename?: 'Terpene', aliasList?: Array<string | null> | null, aromas?: Array<string | null> | null, description?: string | null, effects?: Array<string | null> | null, id: string, name?: string | null, unitSymbol?: string | null, potentialHealthBenefits?: Array<string | null> | null } | null };

export type GqlAdminIdentityFragmentFragment = { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null };

export type GqlConsumerUserFragmentFragment = { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null };

export type GqlConsumerSignupMutationVariables = Exact<{
  input: GqlConsumerSignupInput;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlConsumerSignupMutation = { __typename?: 'Mutation', consumerSignup?: { __typename?: 'LoginConsumer', accessToken?: string | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlCreateUserMutationVariables = Exact<{
  input: GqlUsersCreateInput;
}>;


export type GqlCreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'Users', audioNotificationsOnNewArrivalsDisabled?: boolean | null, audioNotificationsOnNewOrdersDisabled?: boolean | null, chainID?: string | null, createdAt?: string | null, createdBy?: string | null, dispensaryId?: string | null, email?: string | null, fullName?: string | null, phone?: string | null, roleAtDispensary?: DispensaryRoles | null, type?: string | null, permissions?: { __typename?: 'Users_permissions', allLocations?: boolean | null, analytics?: boolean | null, billing?: boolean | null, customers?: boolean | null, dispensaryIds?: Array<string> | null, driver?: boolean | null, enterpriseAdmin?: boolean | null, menu?: boolean | null, menuReview?: boolean | null, orders?: boolean | null, promote?: boolean | null, settings?: boolean | null, superMenuReview?: boolean | null, users?: boolean | null } | null } | null };

export type GqlDeleteUserMutationVariables = Exact<{
  input: GqlUsersDeleteInput;
}>;


export type GqlDeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'Users', fullName?: string | null } | null };

export type GqlLoginAdminViaTokenMutationVariables = Exact<{
  transferToken: Scalars['String']['input'];
}>;


export type GqlLoginAdminViaTokenMutation = { __typename?: 'Mutation', loginAdminViaToken?: { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null } | null };

export type GqlLoginAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type GqlLoginAdminMutation = { __typename?: 'Mutation', loginAdmin?: { __typename?: 'LoginAdmin', accessToken?: string | null, user?: { __typename?: 'IdentityAdmin', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string } | null>, profile: { __typename?: 'IdentityAdminProfile', browserNotification?: boolean | null, chainID?: string | null, desktopNotification?: boolean | null, dispensaryId?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, phone?: string | null, type?: string | null, permissions?: { __typename?: 'IdentityAdminProfilePermissions', allLocations: boolean, billing: boolean, analytics: boolean, customers: boolean, driver: boolean, enterpriseAdmin?: boolean | null, enterpriseSpecials?: boolean | null, manageAds?: boolean | null, managePersonalization?: boolean | null, menu: boolean, menuReview?: boolean | null, superMenuReview?: boolean | null, orders: boolean, promote: boolean, settings: boolean, users: boolean, tasks?: boolean | null } | null } } | null } | null };

export type GqlLoginConsumerMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlLoginConsumerMutation = { __typename?: 'Mutation', loginConsumer?: { __typename?: 'LoginConsumer', accessToken?: string | null, transferToken?: string | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type GqlLogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'GenericResponse', message?: string | null, success?: boolean | null } | null };

export type GqlSendLoginCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlSendLoginCodeMutation = { __typename?: 'Mutation', sendLoginCode?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlUpdateUserMutationVariables = Exact<{
  input: GqlUsersUpdateInput;
}>;


export type GqlUpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'Users', audioNotificationsOnNewArrivalsDisabled?: boolean | null, audioNotificationsOnNewOrdersDisabled?: boolean | null, chainID?: string | null, createdAt?: string | null, createdBy?: string | null, dispensaryId?: string | null, email?: string | null, fullName?: string | null, isWeeklyReportEnabled?: boolean | null, phone?: string | null, roleAtDispensary?: DispensaryRoles | null, type?: string | null, permissions?: { __typename?: 'Users_permissions', allLocations?: boolean | null, analytics?: boolean | null, billing?: boolean | null, customers?: boolean | null, dispensaryIds?: Array<string> | null, driver?: boolean | null, enterpriseAdmin?: boolean | null, menu?: boolean | null, menuReview?: boolean | null, orders?: boolean | null, promote?: boolean | null, settings?: boolean | null, superMenuReview?: boolean | null, users?: boolean | null } | null } | null };

export type GqlVerifyLoginCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
  publicContextSessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlVerifyLoginCodeMutation = { __typename?: 'Mutation', verifyLoginCode?: { __typename?: 'VerifyLoginCodeResponse', accessToken?: string | null, transferToken?: string | null, isNewUser?: boolean | null, user?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null } | null };

export type GqlMeConsumerQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlMeConsumerQuery = { __typename?: 'Query', meConsumer?: { __typename?: 'IdentityConsumer', _id: string, createdAt?: any | null, emails: Array<{ __typename?: 'UserEmails', address: string, verified?: boolean | null, lastVerifiedAt?: string | null } | null>, profile: { __typename?: 'IdentityConsumerProfile', birthday?: string | null, emailNotifications?: boolean | null, emailOptIn?: boolean | null, firstName?: string | null, lastName?: string | null, phone?: string | null, textNotifications?: boolean | null, type?: string | null, photoId?: string | null, isExternalUser?: boolean | null, inStoreEnrollmentCompleted?: boolean | null, address?: { __typename?: 'consumerUserProfileAddressType', city?: string | null, lat?: number | null, ln1?: string | null, ln2?: string | null, lng?: number | null, state?: string | null, zipcode?: string | null } | null, medicalCard?: { __typename?: 'consumerUserMedicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null }, payByBankEnrollmentStatus?: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } | null } | null };

export type GqlCreateOrderMutationVariables = Exact<{
  input: GqlOrdersCreateInput;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreateOrderMutation = { __typename?: 'Mutation', createOrderV2?: { __typename?: 'CreateOrderResponse', valid: boolean, errors?: Array<{ __typename?: 'CreateOrderError', name?: string | null, path?: string | null, message?: string | null, params?: any | null, extensions?: any | null } | null> | null, order?: { __typename?: 'Orders', updateOrderToken?: string | null, paymentMethod?: string | null, paymentMethodId?: string | null, createdAt?: string | null, creditTotal?: string | null, medicalOrder?: boolean | null, mixAndMatch?: number | null, otherFees?: number | null, deliveryFee?: number | null, id?: string | null, orderId?: string | null, receipt?: any | null, specialInstructions?: string | null, status?: string | null, statusTimes?: Array<string | null> | null, taxAmount?: number | null, cannabisTax?: number | null, tipAmount?: number | null, subtotal?: string | null, totalCost?: string | null, isKioskOrder?: boolean | null, isPreviewOrder?: boolean | null, isGuestOrder?: boolean | null, isAfterHoursOrder?: boolean | null, messages?: Array<string | null> | null, destinationTerminal?: string | null, customerState?: string | null, isPTPOT?: boolean | null, coupon?: { __typename?: 'Coupons', _id: string } | null, tipValue?: { __typename?: 'Orders_tipValue', percent?: number | null, dollar?: number | null } | null, customer?: { __typename?: 'Orders_customer', _id?: string | null, profile?: { __typename?: 'Orders_customer_profile', driversLicense?: string | null, photoId?: string | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null } | null } | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null, durationEstimates?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', address?: string | null, apartmentNum?: string | null, deliveryAddress?: string | null, deliveryOption?: boolean | null, lastSearchedAddress?: string | null, nonDeliveryAddress?: string | null, location?: { __typename?: 'Orders_location', ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null } | null, dispensary?: { __typename?: 'Orders_dispensary', _id?: string | null, cName?: string | null, name?: string | null, phone?: string | null, address?: string | null, offerDelivery?: boolean | null, alt36?: boolean | null, check?: boolean | null, creditCardAtDoor?: boolean | null, payOnlineHypur?: boolean | null, payOnlineMerrco?: boolean | null, creditCardByPhone?: boolean | null, debitOnly?: boolean | null, linx?: boolean | null, canPay?: boolean | null, paytender?: boolean | null, aeropay?: boolean | null, deliveryMin?: string | null, timezone?: string | null, customDomainSettings?: { __typename?: 'Dispensaries_profile_customDomain_settings', domain?: string | null } | null, plusSettings?: { __typename?: 'Dispensaries_profile_plus_settings', checkoutUrl?: string | null, defaultReturnUrl?: string | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', end?: string | null, start?: string | null } | null } | null, feeTiers?: Array<{ __typename?: 'Dispensaries_profile_feeTiers', fee?: string | null, max?: string | null, min?: string | null } | null> | null, featureFlags?: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null } | null } | null, orders: Array<{ __typename?: 'Orders_order', basePrice?: number | null, option?: string | null, price?: number | null, quantity?: number | null, product?: { __typename?: 'Order_product', _id?: string | null, Name?: string | null, type?: string | null, strainType?: string | null } | null }>, statusEvents?: Array<{ __typename?: 'OrderStatusEvents', event?: string | null, at?: string | null, by?: string | null, byType?: string | null } | null> | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', phone?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthMonth?: string | null, birthDay?: string | null, birthYear?: string | null } | null, salesTaxExistence?: { __typename?: 'Order_salesTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, cannabisTaxExistence?: { __typename?: 'Order_cannabisTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, bottleDepositTaxExistence?: { __typename?: 'Order_bottleDepositTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, appliedRewards?: Array<{ __typename?: 'Reward', id?: string | null, copy?: string | null, available?: boolean | null, value?: string | null, operator?: string | null, brand?: string | null, discountId?: number | null } | null> | null } | null } | null };

export type GqlUpdateKioskOrderPaymentMutationVariables = Exact<{
  input: GqlUpdateKioskOrderPaymentInput;
}>;


export type GqlUpdateKioskOrderPaymentMutation = { __typename?: 'Mutation', updateKioskOrderPayment?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGenerateHypurRedirectV3MutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  embedded: Scalars['Boolean']['input'];
}>;


export type GqlGenerateHypurRedirectV3Mutation = { __typename?: 'Mutation', generateHypurRedirectV3?: { __typename?: 'HypurRedirect', url: string } | null };

export type GqlGetDispensaryCharitiesQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  menuType: Scalars['String']['input'];
}>;


export type GqlGetDispensaryCharitiesQuery = { __typename?: 'Query', getDispensaryCharities: Array<{ __typename?: 'Charity', name: string, description: string, websiteUrl: string, logoUrl: string, isActive: boolean, feeDonationId: number }> };

export type GqlCheckAllotmentQueryVariables = Exact<{
  input: GqlAllotmentCheckInput;
}>;


export type GqlCheckAllotmentQuery = { __typename?: 'Query', checkAllotment?: { __typename?: 'AllotmentInfo', status: AllotmentStatus, error?: string | null, details?: Array<{ __typename?: 'AllotmentDetail', category?: string | null, parentCategory?: string | null, limit?: number | null, status?: AllotmentStatus | null, used?: number | null, usedThisCycle?: number | null, usedInCart?: number | null, remainingThisCycle?: number | null, remainingWithCart?: number | null, unit?: string | null, isUnlimited?: boolean | null } | null> | null } | null };

export type GqlCheckoutQueryVariables = Exact<{
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlCheckoutQuery = { __typename?: 'Query', getCheckout?: { __typename?: 'Checkout', id: string, pricingType: string, orderType: string, address?: { __typename?: 'CheckoutAddress', deliverable: boolean, formatted?: string | null, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, valid: boolean, zip?: string | null, geometry?: { __typename?: 'CheckoutAddressGeometry', coordinates?: Array<number> | null, type?: string | null } | null } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, option: string, productId: string, quantity: number, product?: { __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null } | null }> } | null };

export type GqlUpdateCheckoutMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  checkoutId: Scalars['String']['input'];
  address?: InputMaybe<GqlCheckoutAddressInput>;
  orderType: Scalars['String']['input'];
  pricingType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlUpdateCheckoutMutation = { __typename?: 'Mutation', updateCheckout?: { __typename?: 'Checkout', id: string } | null };

export type GqlUpdateCheckoutItemQuantityMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  checkoutId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
}>;


export type GqlUpdateCheckoutItemQuantityMutation = { __typename?: 'Mutation', updateQuantity?: { __typename?: 'Checkout', id: string } | null };

export type GqlRemoveCheckoutItemMutationVariables = Exact<{
  checkoutId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlRemoveCheckoutItemMutation = { __typename?: 'Mutation', removeItem?: { __typename?: 'Checkout', id: string } | null };

export type GqlGetAllCitiesByStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetAllCitiesByStateQuery = { __typename?: 'Query', statesWithDispensaries: Array<{ __typename?: 'State', cities: Array<string | null>, name?: string | null, country?: string | null }> };

export type GqlGetCitiesWithDispensariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCitiesWithDispensariesQuery = { __typename?: 'Query', statesWithDispensaries: Array<{ __typename?: 'State', cities: Array<string | null>, name?: string | null, country?: string | null }> };

export type GqlMostPurchasedProductIdsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlMostPurchasedProductIdsQuery = { __typename?: 'Query', getMostPurchasedProducts?: Array<{ __typename?: 'MongoProduct', id: string }> | null };

export type GqlRecentlyViewedProductsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlRecentlyViewedProductsQuery = { __typename?: 'Query', getRecentlyViewedProducts?: Array<{ __typename?: 'Products', id?: string | null }> | null };

export type GqlProductDemandCountsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GqlProductDemandCountsQuery = { __typename?: 'Query', getProductDemandCounts?: Array<{ __typename?: 'ProductDemandCount', id: string, count: number } | null> | null };

export type GqlPosOrderFieldsFragment = { __typename?: 'PosOrder', id: string, orderNumber?: string | null, shipmentDeliveredLocal: string, lspId: number, lspLocId: number, orderType?: string | null, orderSource?: string | null, grandTotal: number, subTotal: number, totalDiscount: number, totalTax: number, tipAmount: number, fees?: Array<{ __typename?: 'PosOrderFee', name?: string | null, amount?: number | null }> | null, items?: Array<{ __typename?: 'PosOrderItem', productName: string, brandName?: string | null, option?: string | null, quantity: number, price: number }> | null, locationDetails: { __typename?: 'PosOrderLocationDetails', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null } };

export type GqlConsumerPosOrdersQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  pagination?: InputMaybe<GqlPaginationInput>;
}>;


export type GqlConsumerPosOrdersQuery = { __typename?: 'Query', consumerPosOrders?: { __typename?: 'PosOrders', orders?: Array<{ __typename?: 'PosOrder', id: string, orderNumber?: string | null, shipmentDeliveredLocal: string, lspId: number, lspLocId: number, orderType?: string | null, orderSource?: string | null, grandTotal: number, subTotal: number, totalDiscount: number, totalTax: number, tipAmount: number, fees?: Array<{ __typename?: 'PosOrderFee', name?: string | null, amount?: number | null }> | null, items?: Array<{ __typename?: 'PosOrderItem', productName: string, brandName?: string | null, option?: string | null, quantity: number, price: number }> | null, locationDetails: { __typename?: 'PosOrderLocationDetails', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null } }> | null, meta?: { __typename?: 'PosOrdersMeta', totalCount?: number | null } | null } | null };

export type GqlConsumerPosOrderQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GqlConsumerPosOrderQuery = { __typename?: 'Query', consumerPosOrder?: { __typename?: 'PosOrder', id: string, orderNumber?: string | null, shipmentDeliveredLocal: string, lspId: number, lspLocId: number, orderType?: string | null, orderSource?: string | null, grandTotal: number, subTotal: number, totalDiscount: number, totalTax: number, tipAmount: number, fees?: Array<{ __typename?: 'PosOrderFee', name?: string | null, amount?: number | null }> | null, items?: Array<{ __typename?: 'PosOrderItem', productName: string, brandName?: string | null, option?: string | null, quantity: number, price: number }> | null, locationDetails: { __typename?: 'PosOrderLocationDetails', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null } } | null };

export type GqlDispensariesForChainQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlDispensariesForChainQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, cName?: string | null, status?: string | null, chain?: string | null } | null> | null };

export type GqlOrdersForConsumerInChainQueryVariables = Exact<{
  ordersFilter: GqlOrdersFilterInput;
  ordersSort?: InputMaybe<GqlOrdersSortInput>;
  ordersPagination?: InputMaybe<GqlOrdersPaginationInput>;
}>;


export type GqlOrdersForConsumerInChainQuery = { __typename?: 'Query', filteredOrders?: { __typename?: 'OrderList', queryInfo?: { __typename?: 'queryInfoType', totalCount?: number | null } | null, orders?: Array<{ __typename?: 'Orders', createdAt?: string | null, credit?: number | null, deliveryFee?: number | null, id?: string | null, medicalOrder?: boolean | null, mixAndMatch?: number | null, orderId?: string | null, specialInstructions?: string | null, status?: string | null, taxAmount?: number | null, cannabisTax?: number | null, bottleDepositTaxCents?: number | null, tipAmount?: number | null, paymentFee?: number | null, paymentMethod?: string | null, subtotal?: string | null, totalCost?: string | null, isPreviewOrder?: boolean | null, terminal?: string | null, autoConfirmed?: boolean | null, autoClosed?: boolean | null, isKioskOrder?: boolean | null, isAfterHoursOrder?: boolean | null, isCurbsidePickupOrder?: boolean | null, isDriveThruPickupOrder?: boolean | null, driversLicense?: string | null, coupon?: { __typename?: 'Coupons', _id: string, active?: boolean | null, addedDate?: string | null, amount?: string | null, percentDiscount?: number | null, fixedDiscountInCents?: number | null, code?: string | null, dispensary?: string | null, expDate?: string | null, numAllowedUses?: number | null, numUses?: number | null, usedBy?: Array<string | null> | null } | null, durationEstimates?: { __typename?: 'DurationEstimates', delivery?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null, pickup?: { __typename?: 'DurationEstimateRange', lowInMinutes?: number | null, highInMinutes?: number | null } | null } | null, dispensary?: { __typename?: 'Orders_dispensary', _id?: string | null, name?: string | null, cName?: string | null, phone?: string | null, logoImage?: string | null, address?: string | null, timezone?: string | null, featureFlags?: { __typename?: 'Dispensaries_featureFlags', hideDeliveryEstimate?: boolean | null } | null } | null, customer?: { __typename?: 'Orders_customer', _id?: string | null, emails?: Array<{ __typename?: 'Orders_customer_emails', address?: string | null } | null> | null, profile?: { __typename?: 'Orders_customer_profile', driversLicense?: string | null, photoId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, birthday?: string | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null } | null } | null, guestCustomer?: { __typename?: 'Orders_guestCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, birthMonth?: string | null, birthDay?: string | null, birthYear?: string | null } | null, medicalCard?: { __typename?: 'Orders_medicalCard', expirationDate?: string | null, number?: string | null, state?: string | null, photo?: string | null } | null, orders: Array<{ __typename?: 'Orders_order', basePrice?: number | null, option?: string | null, price?: number | null, additionalOption?: string | null, quantity?: number | null, product?: { __typename?: 'Order_product', _id?: string | null, Name?: string | null, type?: string | null, Options?: Array<string | null> | null, Image?: string | null, AdditionalOptions?: Array<string | null> | null, brandName?: string | null, preTaxRecPrices?: Array<number | null> | null, preTaxMedPrices?: Array<number | null> | null } | null }>, deliveryInfo?: { __typename?: 'Orders_deliveryInfo', address?: string | null, apartmentNum?: string | null, deliveryAddress?: string | null, deliveryOption?: boolean | null, lastSearchedAddress?: string | null, nonDeliveryAddress?: string | null, location?: { __typename?: 'Orders_location', lat?: number | null, lng?: number | null, ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } | null } | null, cannabisTaxExistence?: { __typename?: 'Order_cannabisTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, salesTaxExistence?: { __typename?: 'Order_salesTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, bottleDepositTaxExistence?: { __typename?: 'Order_bottleDepositTaxExistence', med?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null, rec?: { __typename?: 'Order_taxStages', pos?: boolean | null, menu?: boolean | null, checkout?: boolean | null } | null } | null, appliedRewards?: Array<{ __typename?: 'Reward', copy?: string | null, value?: string | null, operator?: string | null } | null> | null, reservation?: { __typename?: 'OrderReservation', startTimeISO?: any | null, endTimeISO?: any | null } | null } | null> | null } | null };

export type GqlCreatePointsBoostMutationVariables = Exact<{
  input: GqlCreatePointsBoostInput;
}>;


export type GqlCreatePointsBoostMutation = { __typename?: 'Mutation', createPointsBoost?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlCreatePosMedUserMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  user: GqlCreatePosMedUserInput;
}>;


export type GqlCreatePosMedUserMutation = { __typename?: 'Mutation', createPOSMedUser?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null };

export type GqlGetPosMedCardInfoQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetPosMedCardInfoQuery = { __typename?: 'Query', getPosMedCardInfo?: { __typename?: 'PosMedCardInfo', number?: string | null, expirationDate?: string | null, valid?: boolean | null, message?: string | null } | null };

export type GqlUpdateProfileMutationVariables = Exact<{
  profile: GqlConsumerUserProfileInput;
}>;


export type GqlUpdateProfileMutation = { __typename?: 'Mutation', updateProfileV2?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlCreatePublicContextSessionMutationVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlCreatePublicContextSessionMutation = { __typename?: 'Mutation', createPublicContextSession?: { __typename?: 'PublicContextSession', id: string, dispensaryId: string, status: PublicContextSessionStatus, expiresAt: string } | null };

export type GqlUpdatePublicContextSessionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  loginMethodVerified?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlUpdatePublicContextSessionMutation = { __typename?: 'Mutation', updatePublicContextSession?: { __typename?: 'PublicContextSession', id: string, dispensaryId: string, status: PublicContextSessionStatus, expiresAt: string, loginMethodVerified?: boolean | null, claimedByUserId?: string | null } | null };

export type GqlClaimPublicContextSessionByPhoneMutationVariables = Exact<{
  id: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type GqlClaimPublicContextSessionByPhoneMutation = { __typename?: 'Mutation', claimPublicContextSessionByPhone?: { __typename?: 'PublicContextSession', id: string, dispensaryId: string, status: PublicContextSessionStatus, expiresAt: string, loginMethodVerified?: boolean | null, claimedByUserId?: string | null, accessToken?: string | null } | null };

export type GqlGetPublicContextSessionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GqlGetPublicContextSessionQuery = { __typename?: 'Query', getPublicContextSession?: { __typename?: 'PublicContextSession', id: string, dispensaryId: string, status: PublicContextSessionStatus, expiresAt: string, loginMethodVerified?: boolean | null, claimedByUserId?: string | null, accessToken?: string | null } | null };

export type GqlCreateInstoreCartUrlMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type GqlCreateInstoreCartUrlMutation = { __typename?: 'Mutation', createInstoreCartUrl?: { __typename?: 'CreateInstoreCartUrlResponse', instoreCartUrl: string } | null };

export type GqlCreateBackInStockSubscriptionMutationVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GqlCreateBackInStockSubscriptionMutation = { __typename?: 'Mutation', createBackInStockSubscription?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDeleteBackInStockSubscriptionMutationVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GqlDeleteBackInStockSubscriptionMutation = { __typename?: 'Mutation', deleteBackInStockSubscription?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlGetBackInStockSubscriptionStatusQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GqlGetBackInStockSubscriptionStatusQuery = { __typename?: 'Query', getBackInStockSubscriptionStatus?: { __typename?: 'BackInStockSubscriptionStatus', subscribed: boolean } | null };

export type GqlGetCollectionQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
}>;


export type GqlGetCollectionQuery = { __typename?: 'Query', getCollection: { __typename?: 'Collection', id: string, title: string, description?: string | null, image?: string | null, customCategory?: boolean | null, enabled?: boolean | null, isExclusive?: boolean | null, cardBadgeColor?: string | null, isAccessibleToCurrentUser?: boolean | null, isOutlet?: boolean | null, outletTimerEnabled?: boolean | null, outletTimerMessage?: string | null, schedule?: { __typename?: 'Schedule', id: string, startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, startTime: string, endTime: string }> | null } | null } };

export type GqlGetCollectionsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlGetCollectionsQuery = { __typename?: 'Query', getCollections: Array<{ __typename?: 'Collection', customCategory?: boolean | null, enabled?: boolean | null, id: string, navigationTitle?: string | null, slug: string, title: string, isExclusive?: boolean | null, cardBadgeColor?: string | null, isAccessibleToCurrentUser?: boolean | null }> };

export type GqlGetCollectionsNavigationQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  customCategory?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlGetCollectionsNavigationQuery = { __typename?: 'Query', getCollectionsNavigation: Array<{ __typename?: 'Collection', id: string, slug: string, title: string, cardDisplayName?: string | null, cardImage?: string | null, customCategory?: boolean | null, enabled?: boolean | null, navigationTitle?: string | null, isActive?: boolean | null, isOutlet?: boolean | null, schedule?: { __typename?: 'Schedule', id: string, startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, startTime: string, endTime: string }> | null } | null }> };

export type GqlEnterpriseProductsQueryVariables = Exact<{
  enterpriseId: Scalars['ID']['input'];
}>;


export type GqlEnterpriseProductsQuery = { __typename?: 'Query', enterpriseProductsV2?: { __typename?: 'EnterpriseProducts', products?: Array<{ __typename?: 'EnterpriseProduct', brandId?: string | null, brandName?: string | null, enterpriseProductId?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, name?: string | null, options?: Array<string | null> | null, prices?: Array<number | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, subcategory?: string | null, type?: string | null, dispensaryProducts?: Array<{ __typename?: 'EnterpriseDispensaryProduct', brandId?: string | null, brandName?: string | null, dispensaryId?: string | null, id?: string | null, status?: string | null, enterpriseProductId?: string | null } | null> | null } | null> | null } | null };

export type GqlGetMenuSectionsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  userSegmentIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GqlGetMenuSectionsQuery = { __typename?: 'Query', getMenuSections?: Array<{ __typename?: 'MenuSection', id: string, brandId?: string | null, category?: string | null, label: string, linkLabel: string, position: number, subcategory?: string | null, sectionType: MenuSectionType, products?: Array<string> | null, collectionId?: string | null, sortBy?: string | null, image?: { __typename?: 'ImageBanner', _id: string, image: string, mobileImage: string, alt?: string | null, position: number, platforms?: Array<{ __typename?: 'ImageBannerPlatform', enabled: boolean, link?: string | null, openInNewTab?: boolean | null, type: ImageBannerPlatformType } | null> | null } | null, collectionSchedule?: { __typename?: 'Schedule', startDate: any, endDate?: any | null, timeRanges?: Array<{ __typename?: 'TimeRange', id: string, dayOfWeek: number, startTime: string, endTime: string }> | null } | null } | null> | null };

export type GqlGetChainDispensariesQueryVariables = Exact<{
  dispensaryFilter: GqlDispensariesFilterInput;
}>;


export type GqlGetChainDispensariesQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', id: string, name?: string | null, phone?: string | null, cName?: string | null, status?: string | null, chain?: string | null, address?: string | null, distance?: number | null, logoImage?: string | null, offerAnyPickupService?: boolean | null, location?: { __typename?: 'Dispensaries_profile_location', ln1?: string | null, ln2?: string | null, city?: string | null, state?: string | null, country?: string | null, geometry?: { __typename?: 'Dispensaries_profile_location_geometry', coordinates?: Array<number | null> | null } | null } | null, effectiveHours?: { __typename?: 'EffectiveHours', deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null } | null, deliveryHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, pickupHours?: { __typename?: 'Dispensaries_profile_hours', Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, pickupHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null }, deliveryHours: { __typename?: 'dayBounds', active?: boolean | null, start?: string | null, end?: string | null } } | null> | null } | null> | null, hoursSettings?: { __typename?: 'DispensaryHoursSettings', inStorePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, curbsidePickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, driveThruPickup?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null, delivery?: { __typename?: 'HoursSettingsForOrderType', hours?: { __typename?: 'WeeklyHours', Friday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Monday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Saturday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Sunday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Thursday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Tuesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null, Wednesday?: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } | null } | null, specialHours?: Array<{ __typename?: 'SpecialHours', id: string, name: string, startDate: string, endDate: string, hoursPerDay?: Array<{ __typename?: 'SpecialHoursDay', date: string, hours: { __typename?: 'dayBounds', active?: boolean | null, end?: string | null, start?: string | null } } | null> | null } | null> | null } | null } | null, orderTypesConfig?: { __typename?: 'OrderTypesConfig', delivery?: { __typename?: 'OrderTypeConfig', enabled?: boolean | null } | null } | null, orderTypesConfigV2?: { __typename?: 'OrderTypesConfigV2', offerAnyPickupService?: boolean | null, offerDeliveryService?: boolean | null, inStorePickup?: { __typename?: 'InStorePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, curbsidePickup?: { __typename?: 'CurbsidePickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, driveThruPickup?: { __typename?: 'DriveThruPickupOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null, delivery?: { __typename?: 'DeliveryOrderingSettings', enableASAPOrdering?: boolean | null, enableScheduledOrdering?: boolean | null, enableAfterHoursOrdering?: boolean | null } | null } | null, enabledOrderTypes?: { __typename?: 'EnabledOrderTypes', pickup?: boolean | null, inStorePickup?: boolean | null, curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, delivery?: boolean | null, kiosk?: boolean | null } | null, storeSettings: { __typename?: 'Dispensaries_storeSettings', enableAfterHoursOrderingForDelivery: boolean, enableAfterHoursOrderingForPickup: boolean, enableScheduledOrderingForDelivery: boolean, enableScheduledOrderingForPickup: boolean } } | null> | null };

export type GqlDispensaryProductAddToCartFieldsFragment = { __typename?: 'Products', id?: string | null, enterpriseProductId?: string | null, Name?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, Options?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, optionsBelowThreshold?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, strainType?: string | null, type?: string | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', name: string, imageUrl?: string | null, description?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandName?: string | null, categoryName?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, quantity?: number | null, requiresSingleSku?: boolean | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandName?: string | null, categoryName?: string | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: string | null, productId?: string | null, percentDiscount?: string | null, quantity?: number | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, targetPrice?: string | null, requiresSingleSku?: boolean | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialRestrictions?: any | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null };

export type GqlDeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type GqlDeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'DeleteAccountResponse', success: boolean, error?: string | null } };

export type GqlGetIrlEventByDispensaryQueryVariables = Exact<{
  irlEventId: Scalars['ID']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetIrlEventByDispensaryQuery = { __typename?: 'Query', getIrlEventByDispensary?: { __typename?: 'IrlEvent', irlEventId: string, hasIncentive: boolean, headerImageUrl?: string | null, title: string, description: string, optInRequired: boolean, isOpen?: boolean | null, shopNowUrl?: string | null } | null };

export type GqlGetIrlEventRewardByDispensaryQueryVariables = Exact<{
  irlEventId: Scalars['ID']['input'];
  ecommUserId: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetIrlEventRewardByDispensaryQuery = { __typename?: 'Query', getIrlEventRewardByDispensary?: { __typename?: 'IrlEventRewardResponse', primary: { __typename?: 'IrlEventReward', title?: string | null, description?: string | null, rewardType: IrlEventRewardType, rewardName?: string | null, expiry?: string | null, shopNowUrl?: string | null, rewardImageUrl?: string | null } } | null };

export type GqlGetIrlEventRewardQueryVariables = Exact<{
  irlEventId: Scalars['ID']['input'];
  ecommUserId: Scalars['String']['input'];
  enterpriseId: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
}>;


export type GqlGetIrlEventRewardQuery = { __typename?: 'Query', getIrlEventReward?: { __typename?: 'IrlEventRewardResponse', primary: { __typename?: 'IrlEventReward', title?: string | null, description?: string | null, rewardType: IrlEventRewardType, rewardName?: string | null, expiry?: string | null, shopNowUrl?: string | null, rewardImageUrl?: string | null } } | null };

export type GqlGetIrlEventQueryVariables = Exact<{
  irlEventId: Scalars['ID']['input'];
  enterpriseId: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
}>;


export type GqlGetIrlEventQuery = { __typename?: 'Query', getIrlEvent?: { __typename?: 'IrlEvent', irlEventId: string, hasIncentive: boolean, headerImageUrl?: string | null, title: string, description: string, optInRequired: boolean, isOpen?: boolean | null, shopNowUrl?: string | null } | null };

export type GqlTrackIrlEventByDispensaryMutationVariables = Exact<{
  input: GqlTrackIrlEventByDispensaryInput;
}>;


export type GqlTrackIrlEventByDispensaryMutation = { __typename?: 'Mutation', trackIrlEventByDispensary?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlTrackIrlEventMutationVariables = Exact<{
  input: GqlTrackIrlEventInput;
}>;


export type GqlTrackIrlEventMutation = { __typename?: 'Mutation', trackIrlEvent?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlDispensaryDemoRequestMutationVariables = Exact<{
  input: GqlDispensaryDemoRequestInput;
}>;


export type GqlDispensaryDemoRequestMutation = { __typename?: 'Mutation', dispensaryDemoRequest?: { __typename?: 'GenericResponse', success?: boolean | null } | null };

export type GqlActivateBankAccountMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type GqlActivateBankAccountMutation = { __typename?: 'Mutation', activateBankAccount?: { __typename?: 'ActivateBankAccountResponse', success?: boolean | null } | null };

export type GqlActivatePaymentMethodV2MutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type GqlActivatePaymentMethodV2Mutation = { __typename?: 'Mutation', activatePaymentMethodV2: { __typename?: 'ActivatePaymentMethodResponse', genericResponse?: { __typename?: 'GenericResponse', success?: boolean | null, message?: string | null } | null } };

export type GqlApproveInstoreCartMutationVariables = Exact<{
  instoreCartId: Scalars['String']['input'];
  tipCents: Scalars['Int']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlApproveInstoreCartMutation = { __typename?: 'Mutation', approveInstoreCart?: { __typename?: 'ApproveInstoreCartResponse', success?: boolean | null, authorization: { __typename?: 'ApproveInstoreCartAuthorization', authorized: boolean, status: string, code: string } } | null };

export type GqlCompleteAggregatorLinkMutationVariables = Exact<{
  aggregatorToken: Scalars['String']['input'];
  aggregator: Scalars['String']['input'];
  plaid?: InputMaybe<GqlPlaidLinkMetadata>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  dispensaryName?: InputMaybe<Scalars['String']['input']>;
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCompleteAggregatorLinkMutation = { __typename?: 'Mutation', completeAggregatorLink: { __typename?: 'CompleteAggregatorLinkResponse', paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null } } | null> } };

export type GqlCreateBankAccountMutationVariables = Exact<{
  adapter: Scalars['String']['input'];
  aggregatorToken: Scalars['String']['input'];
  billingAddressId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreateBankAccountMutation = { __typename?: 'Mutation', createBankAccount?: { __typename?: 'CreateBankAccountResponse', bankAccount?: { __typename?: 'PaymentMethod', id?: string | null, bankAccount?: { __typename?: 'BankDetails', lastDigits: string, bankName: string, ownerName?: Array<string> | null } | null } | null } | null };

export type GqlCreateFraudAccountMutationVariables = Exact<{
  payload: GqlCreateFraudInput;
}>;


export type GqlCreateFraudAccountMutation = { __typename?: 'Mutation', createFraudAccount?: { __typename?: 'CreateFraudAccountResponse', success: boolean } | null };

export type GqlCreateMxEnrollmentMutationVariables = Exact<{
  billingAddress: GqlBillingAddressInput;
  entityId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  entityType: EntityTypes;
  entityEmail: Scalars['String']['input'];
  isMobileApp: Scalars['Boolean']['input'];
}>;


export type GqlCreateMxEnrollmentMutation = { __typename?: 'Mutation', createMxEnrollment?: { __typename?: 'CreateMxEnrollmentResponse', url: string, billingAddress?: { __typename?: 'BillingAddress', id: string } | null } | null };

export type GqlCreatePaymentMutationVariables = Exact<{
  amount: Scalars['Int']['input'];
  tipAmount?: InputMaybe<Scalars['Int']['input']>;
  checkoutToken: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  ecommLocationId: Scalars['String']['input'];
  card?: InputMaybe<GqlCreatePaymentCard>;
  customerDetails: GqlCreatePaymentCustomerDetails;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlCreatePaymentMutation = { __typename?: 'Mutation', createPayment?: { __typename?: 'CreatePaymentResponse', redirectUrl?: string | null, payment: { __typename?: 'CreatePaymentPayment', id?: string | null } } | null };

export type GqlRecordUserAcceptanceMutationVariables = Exact<{
  acceptanceDocumentId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  userId: Scalars['String']['input'];
}>;


export type GqlRecordUserAcceptanceMutation = { __typename?: 'Mutation', recordUserAcceptance?: { __typename?: 'RecordUserAcceptanceResponse', success?: boolean | null } | null };

export type GqlStartPreAuthCheckMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type GqlStartPreAuthCheckMutation = { __typename?: 'Mutation', startPreAuthCheck?: { __typename?: 'StartPreAuthCheckResponse', channelName?: string | null, checkId?: string | null, status: StartPreAuthCheckResponseStatus } | null };

export type GqlUnenrollPayByBankUserMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
}>;


export type GqlUnenrollPayByBankUserMutation = { __typename?: 'Mutation', unenrollPayByBankUser: { __typename?: 'UnenrollEnrollmentResponse', success: boolean } };

export type GqlGetCustomerDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetCustomerDetailsQuery = { __typename?: 'Query', getCustomerDetails: { __typename?: 'CustomerDetailsResponse', id: string, name: string, externalId: string, successfulOrderCount: number } };

export type GqlGetEnrollmentStatusQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
}>;


export type GqlGetEnrollmentStatusQuery = { __typename?: 'Query', getEnrollmentStatus?: { __typename?: 'UserEnrollment', enrollment?: { __typename?: 'Status', status: StatusTypes } | null, bankAccounts: Array<{ __typename?: 'BankAccount', id: string, billingAddress?: { __typename?: 'BillingAddress', line1: string, line2?: string | null, city: string, state: string, country: string, postalCode: string } | null, bankAccount?: { __typename?: 'BankDetails', bankName: string, lastDigits: string } | null }> } | null };

export type GqlGetEntityLinkingCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetEntityLinkingCodeQuery = { __typename?: 'Query', getEntityLinkingCode?: { __typename?: 'EntityLinkingCodeResponse', code: string } | null };

export type GqlFilteredDispensariesQueryVariables = Exact<{
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlFilteredDispensariesQuery = { __typename?: 'Query', filteredDispensaries?: Array<{ __typename?: 'Dispensaries', SpecialLogoImage?: string | null, name?: string | null } | null> | null };

export type GqlGetInstoreAnalyticsTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetInstoreAnalyticsTokenQuery = { __typename?: 'Query', getInstoreAnalyticsToken?: { __typename?: 'InstoreAnalyticsToken', instoreAnalyticsTokenId: string } | null };

export type GqlGetInstoreCartQueryVariables = Exact<{
  cartToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetInstoreCartQuery = { __typename?: 'Query', getInstoreCart?: { __typename?: 'ShowInstoreCartResponse', instoreCartData?: { __typename?: 'InstoreCartDataType', tippingDisabled: boolean, retailerId: string, instoreCart: { __typename?: 'InstoreCart', currency: string, id: string, subtotalCents: number, tipCents: number, totalCents: number, discounts?: Array<{ __typename?: 'SubtotalItem', name: string, valueCents: number }> | null, fees?: Array<{ __typename?: 'SubtotalItem', name: string, valueCents: number }> | null, items: Array<{ __typename?: 'InstoreCartItem', brandName: string, imageUrl?: string | null, name: string, quantity: string, valueCents: number }>, taxes: Array<{ __typename?: 'SubtotalItem', name: string, valueCents: number }> } } | null } | null };

export type GqlGetUserIncentiveEligibilityQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
  dispensaryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetUserIncentiveEligibilityQuery = { __typename?: 'Query', getUserIncentiveEligibility?: { __typename?: 'GetUserStatusResponse', eligible: boolean, incentive?: { __typename?: 'Incentive', id: string, name: string, description?: string | null, amountCents: number, cohortName: string, active: boolean } | null } | null };

export type GqlListBankAccountsQueryVariables = Exact<{
  aggregator: Scalars['String']['input'];
}>;


export type GqlListBankAccountsQuery = { __typename?: 'Query', listBankAccounts?: { __typename?: 'MxBankAccounts', bankAccounts?: Array<{ __typename?: 'MxBankAccount', accountAlias: string, bankName: string, billingAddressId: string, entityId: string, id: string, lastDigits: string, status: string, mx?: { __typename?: 'MxResponse', connectionStatus: string, widgetUrl: string } | null }> | null } | null };

export type GqlListRetailerPaymentTypesStatusQueryVariables = Exact<{
  ecommLocationId: Scalars['String']['input'];
}>;


export type GqlListRetailerPaymentTypesStatusQuery = { __typename?: 'Query', listRetailerPaymentTypesStatus?: { __typename?: 'RetailerPaymentTypes', paymentTypes: Array<{ __typename?: 'PaymentTypeConfig', enabled?: boolean | null, type?: PaymentsPaymentType | null, orderTypes?: { __typename?: 'PaymentsOrderTypes', curbsidePickup?: boolean | null, driveThruPickup?: boolean | null, pickup?: boolean | null, delivery?: boolean | null } | null } | null> } | null };

export type GqlShowEnrollmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlShowEnrollmentQuery = { __typename?: 'Query', showEnrollment: { __typename?: 'ShowEnrollmentResponse', enrollmentStatus: StatusTypes, requiresAggregatorMigration?: boolean | null, paymentMethods: Array<{ __typename?: 'BankAccountPaymentMethod', id: string, status: string, type?: DutchiePayPaymentMethodType | null, bankAccountDetails: { __typename?: 'BankAccountDetails', accountAlias: string, bankName: string, lastDigits: string, status: ConnectionStatus, aggregator: string, expiresAt?: any | null, billingAddressId?: string | null, financialInstitutionLogo?: string | null } } | null> } };

export type GqlStartAggregatorLinkV2QueryVariables = Exact<{
  aggregator: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  linkCustomizationName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlStartAggregatorLinkV2Query = { __typename?: 'Query', startAggregatorLinkV2: { __typename?: 'StartAggregatorLinkV2Response', plaid?: { __typename?: 'PlaidLinkStart', linkToken: string } | null, aerosync?: { __typename?: 'AeroSyncLinkStart', token: string, userId: string } | null } };

export type GqlStartAggregatorLinkQueryVariables = Exact<{
  aggregator: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  linkCustomizationName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlStartAggregatorLinkQuery = { __typename?: 'Query', startAggregatorLink: { __typename?: 'StartAggregatorLinkResponse', plaid: { __typename?: 'PlaidLinkStart', linkToken: string } } };

export type GqlVerifyMxMemberQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
  entityType: EntityTypes;
  memberGuid: Scalars['String']['input'];
  isMobileApp: Scalars['Boolean']['input'];
}>;


export type GqlVerifyMxMemberQuery = { __typename?: 'Query', verifyMxMember?: { __typename?: 'MxMemberVerification', identificationComplete: boolean, needsAccountSelection: boolean, needsMfa: boolean, url?: string | null, accounts: Array<{ __typename?: 'Account', accountAlias: string, accountGuid: string, availableBalance: number, bankName: string, lastDigits: string }> } | null };

export type GqlGetPersonalizedProductsV2QueryVariables = Exact<{
  input: GqlGetPersonalizedProductsV2Input;
}>;


export type GqlGetPersonalizedProductsV2Query = { __typename?: 'Query', getPersonalizedProductsV2?: { __typename?: 'PersonalizedProducts', products: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> } | null };

export type GqlGetRecommendedProductsQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetRecommendedProductsQuery = { __typename?: 'Query', getRecommendedProducts: Array<{ __typename?: 'Products', _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> };

export type GqlGetSortedProductRecommendationsQueryVariables = Exact<{
  input: GqlGetSortedProductRecommendationsInput;
}>;


export type GqlGetSortedProductRecommendationsQuery = { __typename?: 'Query', getSortedProductRecommendations?: { __typename?: 'ProductRecommendations', adapter?: string | null, products: Array<{ __typename?: 'ProductRecommendation', id: string }> } | null };

export type GqlGetPersonalizedProductsQueryVariables = Exact<{
  input: GqlGetPersonalizedProductsInput;
}>;


export type GqlGetPersonalizedProductsQuery = { __typename?: 'Query', getPersonalizedProducts?: { __typename?: 'PersonalizedProducts', products: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> } | null };

export type GqlGetTrackedCartQueryVariables = Exact<{
  checkoutToken: Scalars['String']['input'];
  dispensaryId: Scalars['String']['input'];
}>;


export type GqlGetTrackedCartQuery = { __typename?: 'Query', getTrackedCart?: { __typename?: 'TrackedCart', token: string, dispensaryId: string, createdAt?: string | null, updatedAt?: string | null, order?: any | null } | null };

export type GqlPersistCheckoutV2MutationVariables = Exact<{
  order: Scalars['JSON']['input'];
  dispensaryId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlPersistCheckoutV2Mutation = { __typename?: 'Mutation', persistCheckoutV2?: { __typename?: 'PersistCheckoutResponse', checkoutToken: string } | null };

export type GqlGetRemoteIntegrationValueQueryVariables = Exact<{
  dispensaryId: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type GqlGetRemoteIntegrationValueQuery = { __typename?: 'Query', getRemoteIntegrationValue?: string | null };

export type GqlGetSponsoredBrandQueryVariables = Exact<{
  input: GqlGetSponsoredBrandInput;
}>;


export type GqlGetSponsoredBrandQuery = { __typename?: 'Query', getSponsoredBrand?: { __typename?: 'SponsoredBrand', id: string, name: string, campaignId: string, trackers: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string }, products: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, adTrackers?: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string } | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> } | null };

export type GqlGetSponsoredProductsQueryVariables = Exact<{
  input: GqlGetSponsoredProductsInput;
}>;


export type GqlGetSponsoredProductsQuery = { __typename?: 'Query', getSponsoredProducts: Array<{ __typename?: 'Products', provider?: ProductsProvider | null, _id?: string | null, id?: string | null, AdditionalOptions?: Array<string | null> | null, duplicatedProductId?: string | null, libraryProductId?: string | null, libraryProductScore?: number | null, brandId?: string | null, brandName?: string | null, CBD?: string | null, certificateOfAnalysisEnabled?: boolean | null, comingSoon?: boolean | null, createdAt?: string | null, updatedAt?: any | null, DispensaryID?: string | null, enterpriseProductId?: string | null, Image?: string | null, medicalOnly?: boolean | null, medicalPrices?: Array<number | null> | null, medicalSpecialPrices?: Array<number | null> | null, wholesalePrices?: Array<number | null> | null, Name?: string | null, nonArmsLength?: boolean | null, Options?: Array<string | null> | null, Prices?: Array<number | null> | null, rawOptions?: Array<string | null> | null, recOnly?: boolean | null, recPrices?: Array<number | null> | null, recSpecialPrices?: Array<number | null> | null, special?: boolean | null, Status?: string | null, strainType?: string | null, subcategory?: string | null, THC?: string | null, type?: string | null, vapeTaxApplicable?: boolean | null, weight?: number | null, isBelowThreshold?: boolean | null, isBelowKioskThreshold?: boolean | null, optionsBelowThreshold?: Array<string | null> | null, optionsBelowKioskThreshold?: Array<string | null> | null, cName?: string | null, pastCNames?: Array<string | null> | null, brandLogo?: string | null, bottleDepositTaxCents?: number | null, useBetterPotencyTaxes?: boolean | null, adTrackers?: { __typename?: 'AdTrackers', clickUrl: string, impressionUrl: string } | null, brand?: { __typename?: 'Brand', id: string, name: string, parentBrandId?: string | null, imageUrl?: string | null } | null, CBDContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, collectionCardBadge?: { __typename?: 'CollectionCardBadge', color?: string | null, title?: string | null, isAccessibleToCurrentUser?: boolean | null, isExclusive?: boolean | null } | null, images?: Array<{ __typename?: 'Products_Images', url: string, description?: string | null, active: boolean }> | null, measurements?: { __typename?: 'Products_measurements', netWeight?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null, volume?: { __typename?: 'Products_measurement', unit?: string | null, values?: Array<number | null> | null } | null } | null, limitsPerCustomer?: Array<{ __typename?: 'Products_limitPerCustomer', key?: string | null, value?: string | null } | null> | null, manualInventory?: Array<{ __typename?: 'Products_manualInventory', option?: string | null, inventory?: number | null } | null> | null, POSMetaData?: { __typename?: 'Products_POSMetaData', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, integrationID?: string | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, children?: Array<{ __typename?: 'Products_POSMetaData_children', canonicalBrandId?: string | null, canonicalBrandName?: string | null, canonicalCategory?: string | null, canonicalCategoryId?: string | null, canonicalEffectivePotencyMg?: number | null, canonicalID?: string | null, canonicalPackageId?: string | null, canonicalImgUrl?: string | null, canonicalLabResultUrl?: string | null, canonicalName?: string | null, canonicalSKU?: string | null, canonicalStrainId?: string | null, canonicalVendorId?: string | null, kioskQuantityAvailable?: number | null, medPrice?: number | null, option?: string | null, packageQuantity?: number | null, price?: number | null, quantity?: number | null, quantityAvailable?: number | null, recPrice?: number | null, activeBatchTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, canonicalProductTags?: Array<{ __typename?: 'Tag', tagId?: string | null } | null> | null, recEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null, standardEquivalent?: { __typename?: 'Products_POSMetaData_children_equivalent', value?: number | null, unit?: string | null } | null } | null> | null } | null, pricingTierData?: { __typename?: 'Products_pricingTierData', generatedTiersId?: string | null, tiersId?: string | null, tiersName?: string | null, tiers?: Array<{ __typename?: 'Products_pricingTierData_tiers', startWeight?: number | null, endWeight?: number | null, price?: number | null, pricePerGram?: number | null, weightUOM?: string | null } | null> | null } | null, specialIdsPerOption?: Array<{ __typename?: 'Products_specialIdsPerOption', option?: string | null, conditionIds?: Array<string | null> | null, rewardIds?: Array<string | null> | null } | null> | null, specialData?: { __typename?: 'Products_specialData', bogoSpecials?: Array<{ __typename?: 'Products_specialData_bogoSpecials', applyRewardsToConditions?: boolean | null, excludeConditionItemsFromRewards?: boolean | null, bogoConditionLogicOperator?: string | null, bogoRewardLogicOperator?: string | null, createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discountBehavior?: string | null, discountStacking?: boolean | null, discountPrecedence?: string | null, endStamp?: string | null, isRecurring?: boolean | null, menuDisplayName?: string | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, recurringEndDate?: string | null, redemptionLimit?: number | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, stackingBehavior?: string | null, stackingMode?: string | null, sourceId?: string | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, qualifyingOptions?: Array<string | null> | null, qualifyingConditionOptions?: Array<string | null> | null, qualifyingRewardOptions?: Array<string | null> | null, bogoConditions?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoConditionItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, bogoRewards?: Array<{ __typename?: 'Products_specialData_bogoSpecials_bogoRewardItem', _id?: string | null, brandId?: string | null, brandIds?: Array<string | null> | null, brandName?: string | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryName?: string | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: string | null, dollarDiscount?: string | null, enterpriseProductId?: string | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: string | null, productId?: string | null, productIds?: Array<string | null> | null, percentDiscount?: string | null, productTags?: Array<string> | null, quantity?: number | null, requiresSingleSku?: boolean | null, selectedCategoriesAndSubcategories?: Array<string | null> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, targetPrice?: string | null, weight?: string | null, weights?: Array<string | null> | null, weightOperator?: Products_SpecialData_ComparisonOperators | null, applicationRules?: Array<{ __typename?: 'ApplicationRule', _id?: string | null, comparisonOperator?: ComparisonOperators | null, quantity?: number | null, applicationType?: ApplicationType | null }> | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, discountBundle?: { __typename?: 'Products_specialData_bogoSpecials_discountBundle', _id?: string | null, applyTo?: ApplicationScope | null, discountType?: string | null, enabled?: boolean | null, limit?: number | null, value?: string | null } | null, discountToCart?: { __typename?: 'DiscountToCart', _id?: string | null, enabled?: boolean | null, discountType?: string | null, value?: string | null } | null, excludedProducts?: { __typename?: 'ExcludedBOGOProducts', conditions?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null, rewards?: Array<{ __typename?: 'ExcludedBOGOProduct', _id?: string | null, key?: string | null, Name?: string | null } | null> | null } | null, itemsForAPrice?: { __typename?: 'Products_specialData_bogoSpecials_itemsForAPrice', _id?: string | null, enabled?: boolean | null, value?: string | null } | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, totalQuantity?: { __typename?: 'TotalQuantity', enabled: boolean, maxQuantity?: number | null, quantity?: number | null, quantityOperator?: ComparisonOperators | null } | null, totalWeight?: { __typename?: 'TotalWeight', enabled: boolean, weight?: string | null, weightOperator?: ComparisonOperators | null } | null, totalSpend?: { __typename?: 'TotalSpend', enabled: boolean, maximumSpend?: number | null, minimumSpend?: number | null, spendOperator?: ComparisonOperators | null } | null } | null> | null, saleSpecials?: Array<{ __typename?: 'Products_specialData_saleSpecials', createdBy?: string | null, directPOSProductIdMapping?: boolean | null, rawPOSWeightMapping?: boolean | null, useLatestCartCalculator?: boolean | null, discount?: number | null, discountStacking?: boolean | null, dollarDiscount?: boolean | null, eligibleProductOptions?: Array<string | null> | null, menuType?: string | null, minorVersion?: number | null, nonStackingBehavior?: string | null, payByBankIncentiveEnabled?: boolean | null, percentDiscount?: boolean | null, settingsDerivedFrom?: string | null, skipV4Merge?: boolean | null, source?: string | null, sourceId?: string | null, specialId?: string | null, specialName?: string | null, specialType?: string | null, specialRestrictions?: any | null, stackingBehavior?: string | null, stackingMode?: string | null, targetPrice?: boolean | null, useGreedOptimizedCalculator?: boolean | null, useTotalQtyCalcsFix?: boolean | null, version?: number | null, paymentRestrictions?: { __typename?: 'PaymentRestrictions', payByBankSignupIncentive?: boolean | null } | null, saleDiscounts?: Array<{ __typename?: 'SaleDiscount', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, discountAmount?: number | null, discountType?: DiscountType | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null, exclusions?: Array<{ __typename?: 'Exclusion', _id?: string | null, brandIds?: Array<string | null> | null, brandNames?: Array<string | null> | null, categoryIds?: Array<string | null> | null, categoryNames?: Array<string | null> | null, enterpriseProductIds?: Array<string | null> | null, inventoryTags?: Array<string> | null, matchOperator?: string | null, productGroup?: ProductGroup | null, productIds?: Array<string | null> | null, productTags?: Array<string> | null, strainIds?: Array<string | null> | null, subcategoryIds?: Array<string | null> | null, subcategoryNames?: Array<string | null> | null, vendorIds?: Array<string | null> | null, weights?: Array<string | null> | null, weightOperator?: WeightOperator | null } | null> | null } | null> | null } | null> | null } | null, THCContent?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, totalTerpenes?: { __typename?: 'ProductPotency', unit: string, range?: Array<number | null> | null } | null, featured?: { __typename?: 'Products_featured', current?: boolean | null, startTime?: string | null, endTime?: string | null } | null }> };

export const BrandDispensaryFragmentFragmentDoc = gql`
    fragment brandDispensaryFragment on Brand {
  dispensary {
    id
    name
  }
}
    `;
export const BrandFragmentForDropdownFragmentDoc = gql`
    fragment brandFragmentForDropdown on Brand {
  _id
  id
  name
  imageUrl
}
    `;
export const BrandFragmentFragmentDoc = gql`
    fragment brandFragment on Brand {
  _id
  aliasList
  companyEmail
  createdAt
  description
  id
  imageUrl
  libraryProductsCount
  name
  productsCount
  updatedAt
  websiteUrl
}
    `;
export const BucketListFragmentFragmentDoc = gql`
    fragment bucketListFragment on Bucket {
  createdBy {
    _id
    firstName
    lastName
  }
  checkedOutAt
  checkedOutBy {
    _id
    firstName
    lastName
  }
  completedReviewsCount
  id
  name
  productsCount
  teamName
}
    `;
export const CouponFragmentFragmentDoc = gql`
    fragment couponFragment on Coupons {
  _id
  active
  addedDate
  applicableCategories {
    category
    subcategory
  }
  code
  dispensaryId
  expDate
  fixedDiscountInCents
  numAllowedUses
  numUses
  percentDiscount
  oneUsePerCustomer
  restrictions {
    minimumPurchase
    minimumPurchaseInCents
    noSpecials
  }
  usedBy
}
    `;
export const DeviceFragmentFragmentDoc = gql`
    fragment deviceFragment on Devices {
  _id
  accessCode
  autoPrintDevice
  buildNumber
  config {
    getDeliveryOrders
    getKioskOrders
    getPickupOrders
    orderSource
  }
  dispensaryId
  lastSeenAt
  nickname
  online
  printerConnected
  updatedAt
  versionNumber
}
    `;
export const GetSubscriptionsV2PaymentSourcesFragmentDoc = gql`
    fragment GetSubscriptionsV2PaymentSources on DispensaryBillingV2 {
  paymentSources {
    card {
      brand
      last4
    }
    type
  }
}
    `;
export const HourSetFragmentFragmentDoc = gql`
    fragment hourSetFragment on Dispensaries_profile_hours {
  Monday {
    active
    end
    start
  }
  Tuesday {
    active
    end
    start
  }
  Wednesday {
    active
    end
    start
  }
  Thursday {
    active
    end
    start
  }
  Friday {
    active
    end
    start
  }
  Saturday {
    active
    end
    start
  }
  Sunday {
    active
    end
    start
  }
}
    `;
export const PaymentTypesFragmentFragmentDoc = gql`
    fragment paymentTypesFragment on PaymentTypesConfig {
  alt36
  check
  creditCardAtDoor
  payOnlineChase
  payOnlineHypur
  payOnlineMerrco
  payOnlineMoneris
  creditCardByPhone
  debit
  dutchiePay
  rethinkPay
  cash
  linx
  canPay
  paytender
  aeropay
}
    `;
export const BaseDispensaryFragmentFragmentDoc = gql`
    fragment baseDispensaryFragment on Dispensaries {
  id
  customDomainSettings {
    domain
  }
  plusSettings {
    checkoutUrl
    defaultReturnUrl
  }
  distance
  name
  cName
  timezone
  phone
  address
  description
  dposLspName
  status
  chain
  location {
    ln1
    ln2
    city
    state
    country
    zipcode
    geometry {
      coordinates
    }
  }
  temporalLocation {
    lastUpdatedAt
    coordinates
    onDuty
    nearbyEnabled
  }
  deliveryHours {
    ...hourSetFragment
  }
  pickupHours {
    ...hourSetFragment
  }
  categoryPhotos {
    src
    category
  }
  customCategoryPhotos {
    url
    category
    collectionId
  }
  effectiveHours {
    deliveryHours {
      ...hourSetFragment
    }
    pickupHours {
      ...hourSetFragment
    }
  }
  offerAnyPickupService
  offerPickup
  offerCurbsidePickup
  offerDriveThruPickup
  offerDelivery
  listImage
  bannerImage
  logoImage
  embeddedLogoImage
  embeddedMenuUrl
  SpecialLogoImage
  brandedDutchiePayEnabled
  brandedDutchiePayName
  brandedDutchiePayLogoLight
  brandedDutchiePayLogoDark
  embedBackUrl
  embedSettings {
    disclaimerTextHtml
    disablePageLoadsAtTop
    enableFullScreenEmbeddedCheckout
    autoGTM
    privacyPolicyUrl
  }
  alt36
  check
  creditCardAtDoor
  payOnlineHypur
  payOnlineMerrco
  creditCardByPhone
  debitOnly
  cashOnly
  cashless
  createdAtISO
  linx
  canPay
  paytender
  aeropay
  recDispensary
  medicalDispensary
  maxDeliveryDistance
  mixAndMatchPricingWeights
  feeTiers {
    fee
    feeType
    max
    min
    percentFee
  }
  acceptsTips
  acceptsDutchiePayTips
  acceptsCreditCardTips
  requiresDriversLicense
  requiresDriversLicenseForPickup
  requirePhotoIdForDelivery
  requirePhotoIdForPickup
  removeMedicalCardFieldsAtCheckout
  menuOrder
  menuOrderSettings {
    category
    menuOrder
  }
  menuSortSettings {
    brands
    category
    menuOrder
  }
  email
  emailConfirmation
  stealthMode
  actionEstimates {
    pickup {
      readyInMinutes
      rangeInMinutes
    }
    delivery {
      readyInMinutes
      rangeInMinutes
      deliveryTimeInMinutes
    }
  }
  durationEstimateOverrides {
    delivery {
      enabled
      lowInMinutes
      highInMinutes
    }
    pickup {
      enabled
      lowInMinutes
      highInMinutes
    }
  }
  paymentFees {
    fee
    feeType
    paymentType
  }
  kioskOrderingEnabled
  kioskInstructions
  kioskConfig {
    fullNameOnly
    phoneRequired
    notesField
    directedOrders
    hidePhoneField
    hideEmailField
    showBirthdateField
    type
  }
  categoryLimits {
    name
    value
  }
  categoryLimitsEnabled
  specialsSettings {
    discountBehavior
    discountStacking
    discountPrecedence
    enableIndividualSpecialPrecedence
    enableIndividualDiscountStacking
    stackingBehavior
    nonStackingBehavior
  }
  storeSettings {
    isolatedMenus
    customerMessagingTermsAccepted
    showPOSPackageId
    defaultViewStyle
    disablePurchaseLimits
    disableGuestDOB
    displayPhoneConfirmation
    displayKioskAnonymousCheckoutDisclaimer
    enableDutchiePayConsumerSurcharge
    requireEmailAddressForGuestCheckout
    requireMedCardPhotoForPickup
    hideAddressFromDutchieMain
    hideFromMobileApp
    requireMedCardPhotoForDelivery
    enableAfterHoursOrderingForPickup
    enableAfterHoursOrderingForDelivery
    enableLLxSaleDiscountSync
    enableMixAndMatchPricingForPickup
    enableMixAndMatchPricingForDelivery
    enableProductUrgencyMessaging
    enableScheduledOrderingForPickup
    enableScheduledOrderingForDelivery
    enableLimitPerCustomer
    quantityLimit
    quantityLimitMaxAvailable
    enableOrderStatusEmails
    enableStorefrontAgeGate
    hardAgeGateHideMenuContent
    collapseProductDescription
    disableGuestCheckout
    requirePaymentMethodSelection
    requireTermsAcceptance
    enableCustomTerms
    customTermsText
    showMobileAppSmartBanner
    stealthMode
    dontCombineWeightedProducts
    keepUncombinedWeights
    dontMapSubcategoriesByProductName
    prioritizeStaffPicksInSearchResults
    provideBackInstockEmailNotifications
    hideEffects
    hideFilters
    hideOutOfStockProducts
    showLoyaltyRewards
    hideDiscountsFromConsumer
    restrictSalesLanguage
    usePotencyForConcentrateLimits
    useStandardEquivalentForEdiblesLimits
    useStateRegulatedImageWatermarks
    enableOmniauthLoginCheckout
    showMobileAppSmartBanner
    subscriptions {
      enabled
    }
    rewardsIntegrationConfiguration {
      rewardsProgramDisplayDescription
      rewardsProgramDisplayEnrollment
      rewardsProgramDisplayName
    }
    enableRoundToNearestDollar
    hideRoundingLineItem
  }
  featureFlags {
    enableAfterHoursOrdering
    enableArrivals
    enableMenuImport
    enableMixAndMatch
    enableNonTerminalAutoConfirm
    enablePausedOrders
    enableScheduledOrdering
    hideDeliveryEstimate
    hideMyAccount
    hideStoreHours
  }
  updatedAt
  updatedAtISO
  terminals {
    _id
    nickname
    versionNumber
    lastSeenAt
    lastSeenAtISO
    config {
      orderSource
    }
  }
  ordersArePaused
  ageVerificationBannerHtml
  ageVerificationBannerColor
  menuBannerHtml
  menuBannerColor
  menuBannerTextBannerCollapsed
  menuUrl
  privacyPolicyUrl
  termsAndConditionsUrl
  colorSettings {
    linkColor
    navBarColor
  }
  pickupMinimum {
    enabled
    minimumInCents
  }
  orderTypesConfig {
    pickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    curbsidePickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    driveThruPickup {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    delivery {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    kiosk {
      enabled
      paymentTypes {
        ...paymentTypesFragment
      }
    }
    offerAnyPickupService
    offerDeliveryService
  }
  paymentTypesAccepted {
    alt36
    check
    creditCardAtDoor
    payOnlineChase
    payOnlineHypur
    payOnlineMerrco
    payOnlineMoneris
    creditCardByPhone
    debit
    dutchiePay
    rethinkPay
    cash
    linx
    canPay
    paytender
    aeropay
  }
}
    ${HourSetFragmentFragmentDoc}
${PaymentTypesFragmentFragmentDoc}`;
export const BaseOrderingSettingsFragmentFragmentDoc = gql`
    fragment baseOrderingSettingsFragment on BaseOrderingSettings {
  enableASAPOrdering
  enableScheduledOrdering
  enableAfterHoursOrdering
  checkoutMessage
  paymentTypes {
    ...paymentTypesFragment
  }
  scheduledOrderingConfigV2 {
    advancedDayOrderingEnabled
    sameDayDeliveryEnabled
    advancedDayOrderingLimit
    incrementInMinutes
    nextAvailableInMinutes
    orderLimitsEnabled
  }
}
    ${PaymentTypesFragmentFragmentDoc}`;
export const CurbsidePickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment curbsidePickupOrderingSettingsFragment on CurbsidePickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  enableCurbsideArrivals
  arrivalInformationInstructions
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const DeliveryOrderingSettingsFragmentFragmentDoc = gql`
    fragment deliveryOrderingSettingsFragment on DeliveryOrderingSettings {
  ...baseOrderingSettingsFragment
  deliveryFeeTiers {
    feeInCents
    maximumInCents
    minimumInCents
    feeType
    percentFee
  }
  deliveryMode
  deliveryRadius {
    orderMinimum {
      enabled
      minimumInCents
    }
    radiusInMiles
  }
  deliveryZipCodes {
    zipCode
    feeInCents
    minimumInCents
    feeType
    percentFee
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const DeliveryZonesFragmentFragmentDoc = gql`
    fragment deliveryZonesFragment on DeliveryOrderingSettings {
  deliveryZones {
    _id
    name
    area {
      type
      features {
        type
        geometry {
          type
          coordinates
        }
      }
    }
    feeInCents
    minimumInCents
    feeType
    percentFee
  }
}
    `;
export const DriveThruPickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment driveThruPickupOrderingSettingsFragment on DriveThruPickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const HoursForDayFragmentDoc = gql`
    fragment hoursForDay on dayBounds {
  active
  end
  start
}
    `;
export const WeeklyHoursFragmentFragmentDoc = gql`
    fragment weeklyHoursFragment on WeeklyHours {
  Friday {
    ...hoursForDay
  }
  Monday {
    ...hoursForDay
  }
  Saturday {
    ...hoursForDay
  }
  Sunday {
    ...hoursForDay
  }
  Thursday {
    ...hoursForDay
  }
  Tuesday {
    ...hoursForDay
  }
  Wednesday {
    ...hoursForDay
  }
}
    ${HoursForDayFragmentDoc}`;
export const SpecialHoursDayFragmentFragmentDoc = gql`
    fragment specialHoursDayFragment on SpecialHoursDay {
  date
  hours {
    ...hoursForDay
  }
}
    ${HoursForDayFragmentDoc}`;
export const SpecialHoursFragmentFragmentDoc = gql`
    fragment specialHoursFragment on SpecialHours {
  id
  name
  startDate
  endDate
  hoursPerDay {
    ...specialHoursDayFragment
  }
}
    ${SpecialHoursDayFragmentFragmentDoc}`;
export const HoursSettingsForOrderTypeFragmentFragmentDoc = gql`
    fragment hoursSettingsForOrderTypeFragment on HoursSettingsForOrderType {
  hours {
    ...weeklyHoursFragment
  }
  specialHours {
    ...specialHoursFragment
  }
}
    ${WeeklyHoursFragmentFragmentDoc}
${SpecialHoursFragmentFragmentDoc}`;
export const InStorePickupOrderingSettingsFragmentFragmentDoc = gql`
    fragment inStorePickupOrderingSettingsFragment on InStorePickupOrderingSettings {
  ...baseOrderingSettingsFragment
  orderMinimum {
    enabled
    minimumInCents
  }
  pickupReminders {
    enabled
    reminderMinutesAfterReady
    reminderMessage
  }
}
    ${BaseOrderingSettingsFragmentFragmentDoc}`;
export const KioskOrderingSettingsFragmentFragmentDoc = gql`
    fragment kioskOrderingSettingsFragment on KioskOrderingSettings {
  enabled
  fullNameOnly
  phoneRequired
  notesField
  directedOrders
  hideEmailField
  hidePhoneField
  showBirthdateField
  anonymousCheckout
  kioskInstructions
  type
  paymentTypes {
    ...paymentTypesFragment
  }
  timeout {
    enabled
    duration
  }
}
    ${PaymentTypesFragmentFragmentDoc}`;
export const MaxReservationSlotFragmentFragmentDoc = gql`
    fragment maxReservationSlotFragment on MaxReservationSlot {
  active
  currentCount
  date
  startTime
  endTime
  maxOrders
  deliveryAreaId
  slotId
  isNextDaySlot
}
    `;
export const MaxReservationSlotsByDayFragmentFragmentDoc = gql`
    fragment maxReservationSlotsByDayFragment on MaxReservationSlotsByDay {
  Monday {
    ...maxReservationSlotFragment
  }
  Tuesday {
    ...maxReservationSlotFragment
  }
  Wednesday {
    ...maxReservationSlotFragment
  }
  Thursday {
    ...maxReservationSlotFragment
  }
  Friday {
    ...maxReservationSlotFragment
  }
  Saturday {
    ...maxReservationSlotFragment
  }
  Sunday {
    ...maxReservationSlotFragment
  }
}
    ${MaxReservationSlotFragmentFragmentDoc}`;
export const MenuSectionFragmentFragmentDoc = gql`
    fragment menuSectionFragment on MenuSection {
  id
  brandId
  category
  image {
    _id
    image
    mobileImage
    alt
    platforms {
      enabled
      link
      openInNewTab
      type
    }
    position
  }
  label
  linkLabel
  position
  subcategory
  sectionType
  products
  collectionId
  sortBy
  collectionSchedule {
    startDate
    endDate
    timeRanges {
      id
      dayOfWeek
      startTime
      endTime
    }
  }
}
    `;
export const ScheduledOrderingConfigFragmentFragmentDoc = gql`
    fragment scheduledOrderingConfigFragment on ReservationOptionsForOrderType {
  advancedDayOrderingEnabled
  sameDayDeliveryEnabled
  advancedDayOrderingLimit
  incrementInMinutes
  nextAvailableInMinutes
  orderLimitsEnabled
}
    `;
export const TaxPropertiesFragmentDoc = gql`
    fragment taxProperties on Dispensaries_TaxConfig_Tax {
  id
  type
  name
  rate
  potencyRate
  potency
  medical
  recreational
  taxBasis
  stages {
    op
    type
  }
  applyTo {
    types
    hemp
  }
  order
  deliveryPolicy
  includeStateSalesTaxInDestinationRate
}
    `;
export const PosMetaDataFragmentFragmentDoc = gql`
    fragment POSMetaDataFragment on Products_POSMetaData {
  activeBatchTags {
    tagId
  }
  canonicalBrandId
  canonicalBrandName
  canonicalCategory
  canonicalCategoryId
  canonicalID
  canonicalPackageId
  canonicalImgUrl
  canonicalLabResultUrl
  canonicalName
  canonicalProductTags {
    tagId
  }
  canonicalSKU
  canonicalStrainId
  canonicalVendorId
  children {
    activeBatchTags {
      tagId
    }
    canonicalBrandId
    canonicalBrandName
    canonicalCategory
    canonicalCategoryId
    canonicalEffectivePotencyMg
    canonicalID
    canonicalPackageId
    canonicalImgUrl
    canonicalLabResultUrl
    canonicalName
    canonicalSKU
    canonicalProductTags {
      tagId
    }
    canonicalStrainId
    canonicalVendorId
    kioskQuantityAvailable
    medPrice
    option
    packageQuantity
    price
    quantity
    quantityAvailable
    recEquivalent {
      value
      unit
    }
    recPrice
    standardEquivalent {
      value
      unit
    }
  }
  integrationID
}
    `;
export const ConsumerBaseProductFragmentFragmentDoc = gql`
    fragment consumerBaseProductFragment on Products {
  _id
  id
  AdditionalOptions
  duplicatedProductId
  libraryProductId
  libraryProductScore
  brand {
    id
    name
    parentBrandId
    imageUrl
  }
  brandId
  brandName
  CBD
  CBDContent {
    unit
    range
  }
  certificateOfAnalysisEnabled
  collectionCardBadge {
    color
    title
    isAccessibleToCurrentUser
    isExclusive
  }
  comingSoon
  createdAt
  updatedAt
  DispensaryID
  enterpriseProductId
  Image
  images {
    url
    description
    active
  }
  measurements {
    netWeight {
      unit
      values
    }
    volume {
      unit
      values
    }
  }
  medicalOnly
  medicalPrices
  medicalSpecialPrices
  wholesalePrices
  Name
  nonArmsLength
  Options
  limitsPerCustomer {
    key
    value
  }
  manualInventory {
    option
    inventory
  }
  POSMetaData {
    ...POSMetaDataFragment
  }
  Prices
  pricingTierData {
    generatedTiersId
    tiersId
    tiersName
    tiers {
      startWeight
      endWeight
      price
      pricePerGram
      weightUOM
    }
  }
  specialIdsPerOption {
    option
    conditionIds
    rewardIds
  }
  rawOptions
  recOnly
  recPrices
  recSpecialPrices
  special
  specialData {
    bogoSpecials {
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        selectedCategoriesAndSubcategories
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        discountAmount
        discountType
        dollarDiscount
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        selectedCategoriesAndSubcategories
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      discountBehavior
      discountStacking
      discountPrecedence
      endStamp
      excludedProducts {
        conditions {
          _id
          key
          Name
        }
        rewards {
          _id
          key
          Name
        }
      }
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      menuDisplayName
      menuType
      minorVersion
      nonStackingBehavior
      payByBankIncentiveEnabled
      paymentRestrictions {
        payByBankSignupIncentive
      }
      recurringEndDate
      redemptionLimit
      settingsDerivedFrom
      skipV4Merge
      specialId
      specialName
      specialType
      stackingBehavior
      stackingMode
      sourceId
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      useGreedOptimizedCalculator
      useTotalQtyCalcsFix
      version
      qualifyingOptions
      qualifyingConditionOptions
      qualifyingRewardOptions
    }
    saleSpecials {
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discount
      discountStacking
      dollarDiscount
      eligibleProductOptions
      menuType
      minorVersion
      nonStackingBehavior
      payByBankIncentiveEnabled
      paymentRestrictions {
        payByBankSignupIncentive
      }
      percentDiscount
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      settingsDerivedFrom
      skipV4Merge
      source
      sourceId
      specialId
      specialName
      specialType
      specialRestrictions
      stackingBehavior
      stackingMode
      targetPrice
      useGreedOptimizedCalculator
      useTotalQtyCalcsFix
      version
    }
  }
  Status
  strainType
  subcategory
  THC
  THCContent {
    unit
    range
  }
  totalTerpenes {
    unit
    range
  }
  type
  vapeTaxApplicable
  weight
  featured {
    current
    startTime
    endTime
  }
  isBelowThreshold
  isBelowKioskThreshold
  optionsBelowThreshold
  optionsBelowKioskThreshold
  cName
  pastCNames
  brandLogo
  bottleDepositTaxCents
  useBetterPotencyTaxes
}
    ${PosMetaDataFragmentFragmentDoc}`;
export const ConsumerSponsoredProductFragmentFragmentDoc = gql`
    fragment consumerSponsoredProductFragment on Products {
  ...consumerBaseProductFragment
  adTrackers {
    clickUrl
    impressionUrl
  }
  provider
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;
export const ScheduleFieldsFragmentDoc = gql`
    fragment ScheduleFields on Schedule {
  endDate
  id
  startDate
  timeRanges {
    id
    dayOfWeek
    endTime
    startTime
  }
}
    `;
export const TerpeneFragmentFragmentDoc = gql`
    fragment TerpeneFragment on Terpene {
  aliasList
  aromas
  description
  effects
  id
  name
  unitSymbol
  potentialHealthBenefits
}
    `;
export const AdminIdentityFragmentFragmentDoc = gql`
    fragment adminIdentityFragment on LoginAdmin {
  accessToken
  user {
    _id
    createdAt
    emails {
      address
    }
    profile {
      browserNotification
      chainID
      desktopNotification
      dispensaryId
      emailNotifications
      emailOptIn
      firstName
      fullName
      lastName
      permissions {
        allLocations
        billing
        analytics
        customers
        driver
        enterpriseAdmin
        enterpriseSpecials
        manageAds
        managePersonalization
        menu
        menuReview
        superMenuReview
        orders
        promote
        settings
        users
        tasks
      }
      phone
      type
    }
  }
}
    `;
export const ConsumerUserFragmentFragmentDoc = gql`
    fragment consumerUserFragment on IdentityConsumer {
  _id
  createdAt
  emails {
    address
    verified
    lastVerifiedAt
  }
  profile {
    address {
      city
      lat
      ln1
      ln2
      lng
      state
      zipcode
    }
    birthday
    emailNotifications
    emailOptIn
    firstName
    lastName
    medicalCard {
      expirationDate
      number
      state
      photo
    }
    phone
    textNotifications
    type
    photoId
    isExternalUser
    inStoreEnrollmentCompleted
  }
  payByBankEnrollmentStatus {
    enrollmentStatus
    requiresAggregatorMigration
    paymentMethods {
      id
      status
      type
      bankAccountDetails {
        accountAlias
        bankName
        lastDigits
        status
        aggregator
        expiresAt
        billingAddressId
        financialInstitutionLogo
      }
    }
  }
}
    `;
export const PosOrderFieldsFragmentDoc = gql`
    fragment PosOrderFields on PosOrder {
  id
  orderNumber
  shipmentDeliveredLocal
  lspId
  lspLocId
  orderType
  orderSource
  grandTotal
  subTotal
  totalDiscount
  totalTax
  tipAmount
  fees {
    name
    amount
  }
  items {
    productName
    brandName
    option
    quantity
    price
  }
  locationDetails {
    name
    street
    city
    state
    zip
  }
}
    `;
export const DispensaryProductAddToCartFieldsFragmentDoc = gql`
    fragment DispensaryProductAddToCartFields on Products {
  id
  enterpriseProductId
  Name
  Image
  medicalOnly
  medicalPrices
  medicalSpecialPrices
  Options
  optionsBelowKioskThreshold
  optionsBelowThreshold
  Prices
  rawOptions
  recOnly
  recPrices
  recSpecialPrices
  strainType
  type
  brand {
    name
    imageUrl
    description
  }
  CBDContent {
    unit
    range
  }
  THCContent {
    unit
    range
  }
  POSMetaData {
    ...POSMetaDataFragment
  }
  manualInventory {
    option
    inventory
  }
  limitsPerCustomer {
    key
    value
  }
  specialData {
    bogoSpecials {
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandName
        categoryName
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          subcategoryIds
          subcategoryNames
          weights
          weightOperator
        }
        selectedCategoriesAndSubcategories
        productGroup
        productId
        quantity
        requiresSingleSku
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandName
        categoryName
        discountAmount
        discountType
        dollarDiscount
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          subcategoryIds
          subcategoryNames
          weights
          weightOperator
        }
        productGroup
        productId
        percentDiscount
        quantity
        selectedCategoriesAndSubcategories
        targetPrice
        requiresSingleSku
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      discountBehavior
      discountStacking
      discountPrecedence
      endStamp
      excludedProducts {
        conditions {
          _id
          key
          Name
        }
        rewards {
          _id
          key
          Name
        }
      }
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      menuType
      minorVersion
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      recurringEndDate
      redemptionLimit
      settingsDerivedFrom
      specialId
      specialName
      specialType
      stackingBehavior
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        minimumSpend
        spendOperator
      }
      version
      qualifyingOptions
    }
    saleSpecials {
      createdBy
      directPOSProductIdMapping
      rawPOSWeightMapping
      useLatestCartCalculator
      discount
      discountStacking
      dollarDiscount
      eligibleProductOptions
      menuType
      minorVersion
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      percentDiscount
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          subcategoryIds
          subcategoryNames
          weights
          weightOperator
        }
        productGroup
        productIds
        subcategoryIds
        subcategoryNames
        weights
        weightOperator
      }
      settingsDerivedFrom
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      targetPrice
      version
    }
  }
  useBetterPotencyTaxes
}
    ${PosMetaDataFragmentFragmentDoc}`;
export const CreateBrandDocument = gql`
    mutation CreateBrand($brand: brandInput!) {
  createBrandV2(brand: $brand) {
    ...brandFragment
  }
}
    ${BrandFragmentFragmentDoc}`;
export type GqlCreateBrandMutationFn = Apollo.MutationFunction<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>(CreateBrandDocument, options);
      }
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = Apollo.MutationResult<GqlCreateBrandMutation>;
export type CreateBrandMutationOptions = Apollo.BaseMutationOptions<GqlCreateBrandMutation, GqlCreateBrandMutationVariables>;
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: String!) {
  deleteBrand(id: $id) {
    _id
  }
}
    `;
export type GqlDeleteBrandMutationFn = Apollo.MutationFunction<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>(DeleteBrandDocument, options);
      }
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = Apollo.MutationResult<GqlDeleteBrandMutation>;
export type DeleteBrandMutationOptions = Apollo.BaseMutationOptions<GqlDeleteBrandMutation, GqlDeleteBrandMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($id: String!, $brand: brandInput!) {
  updateBrandV2(id: $id, brand: $brand) {
    ...brandFragment
  }
}
    ${BrandFragmentFragmentDoc}`;
export type GqlUpdateBrandMutationFn = Apollo.MutationFunction<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<GqlUpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<GqlUpdateBrandMutation, GqlUpdateBrandMutationVariables>;
export const BrandsForDropdownDocument = gql`
    query BrandsForDropdown($dispensaryId: String, $searchString: String, $limit: Int, $parentBrandId: ID, $hasParent: Boolean, $localAndGlobal: Boolean) {
  searchBrandsV2(
    filters: {dispensaryId: $dispensaryId, parentBrandId: $parentBrandId, hasParent: $hasParent, localAndGlobal: $localAndGlobal}
    pagination: {limit: $limit, offset: 0}
    search: $searchString
    sort: {sortBy: score, sortDirection: desc}
  ) {
    brands {
      ...brandFragmentForDropdown
      isGlobal
    }
  }
}
    ${BrandFragmentForDropdownFragmentDoc}`;

/**
 * __useBrandsForDropdownQuery__
 *
 * To run a query within a React component, call `useBrandsForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsForDropdownQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      parentBrandId: // value for 'parentBrandId'
 *      hasParent: // value for 'hasParent'
 *      localAndGlobal: // value for 'localAndGlobal'
 *   },
 * });
 */
export function useBrandsForDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>(BrandsForDropdownDocument, options);
      }
export function useBrandsForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>(BrandsForDropdownDocument, options);
        }
export type BrandsForDropdownQueryHookResult = ReturnType<typeof useBrandsForDropdownQuery>;
export type BrandsForDropdownLazyQueryHookResult = ReturnType<typeof useBrandsForDropdownLazyQuery>;
export type BrandsForDropdownQueryResult = Apollo.QueryResult<GqlBrandsForDropdownQuery, GqlBrandsForDropdownQueryVariables>;
export const GetBrandRegionsDocument = gql`
    query GetBrandRegions {
  listRegions {
    id
    code
    country
    subdivision
    countryName
    subdivisionName
  }
}
    `;

/**
 * __useGetBrandRegionsQuery__
 *
 * To run a query within a React component, call `useGetBrandRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>(GetBrandRegionsDocument, options);
      }
export function useGetBrandRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>(GetBrandRegionsDocument, options);
        }
export type GetBrandRegionsQueryHookResult = ReturnType<typeof useGetBrandRegionsQuery>;
export type GetBrandRegionsLazyQueryHookResult = ReturnType<typeof useGetBrandRegionsLazyQuery>;
export type GetBrandRegionsQueryResult = Apollo.QueryResult<GqlGetBrandRegionsQuery, GqlGetBrandRegionsQueryVariables>;
export const GetBrandDocument = gql`
    query GetBrand($id: String!) {
  getBrand(id: $id) {
    ...brandFragment
    isGlobal
    regions {
      id
      code
      country
      subdivision
      countryName
      subdivisionName
    }
    source
    creatorUserId
    dispensary {
      name
      id
    }
    parentBrandId
    enterprise {
      id
      name
    }
  }
}
    ${BrandFragmentFragmentDoc}`;

/**
 * __useGetBrandQuery__
 *
 * To run a query within a React component, call `useGetBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandQuery(baseOptions: Apollo.QueryHookOptions<GqlGetBrandQuery, GqlGetBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBrandQuery, GqlGetBrandQueryVariables>(GetBrandDocument, options);
      }
export function useGetBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBrandQuery, GqlGetBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBrandQuery, GqlGetBrandQueryVariables>(GetBrandDocument, options);
        }
export type GetBrandQueryHookResult = ReturnType<typeof useGetBrandQuery>;
export type GetBrandLazyQueryHookResult = ReturnType<typeof useGetBrandLazyQuery>;
export type GetBrandQueryResult = Apollo.QueryResult<GqlGetBrandQuery, GqlGetBrandQueryVariables>;
export const SuperBrandsIndexDocument = gql`
    query SuperBrandsIndex($filters: searchBrandsFilters, $pagination: paginationInput, $search: String, $sort: searchBrandsSort) {
  searchBrandsV2(
    filters: $filters
    pagination: $pagination
    search: $search
    sort: $sort
  ) {
    brands {
      ...brandFragment
      ...brandDispensaryFragment
    }
    queryInfo {
      totalCount
    }
  }
}
    ${BrandFragmentFragmentDoc}
${BrandDispensaryFragmentFragmentDoc}`;

/**
 * __useSuperBrandsIndexQuery__
 *
 * To run a query within a React component, call `useSuperBrandsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperBrandsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperBrandsIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSuperBrandsIndexQuery(baseOptions?: Apollo.QueryHookOptions<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>(SuperBrandsIndexDocument, options);
      }
export function useSuperBrandsIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>(SuperBrandsIndexDocument, options);
        }
export type SuperBrandsIndexQueryHookResult = ReturnType<typeof useSuperBrandsIndexQuery>;
export type SuperBrandsIndexLazyQueryHookResult = ReturnType<typeof useSuperBrandsIndexLazyQuery>;
export type SuperBrandsIndexQueryResult = Apollo.QueryResult<GqlSuperBrandsIndexQuery, GqlSuperBrandsIndexQueryVariables>;
export const ComputeWithPriceCartV2Document = gql`
    mutation ComputeWithPriceCartV2($priceCartInput: CalculationsInput!) {
  computeWithPriceCartV2(input: $priceCartInput) {
    itemTaxes {
      taxAmount
      taxType
      productId
      feeItemId
      showOnMenu
      showOnCheckout
    }
    cartItemPrices {
      productName
      productId
      quantity
      subtotal
      unitPrice
      pricingTierAdjustment
      pricingTierAdjustmentTotal
      summaryPrice
      menuPrice
      discounts {
        name
        amount
        discountId
        applicationMethod
        isLoyaltyReward
        isPaymentIncentive
        isRestricted
        menuDisplayName
        menuDisplayDescription
        menuDisplayImage
      }
      tax
      unitWeightGrams
      productType
      ecommKey
    }
    fees {
      feeItemId
      feeAmount
      feeName
      deliveryFee
      paymentFee
    }
    subTotal
    taxes
    discount
    originalTotal
    roundedDifference
    grandTotal
    loyaltyPointsUsed
    rewardValidationErrors {
      discountCode
      discountId
      message
    }
    totalSalesTax
    totalCannabisTax
    totalBottleDepositTax
    taxInclusivePricing
    loyaltyAppliedAsDiscount
    discountWithoutLoyalty
    posCustomerId
    discountGamification {
      gamificationDetails {
        discountId
        meetsAllConstraints
        satisfiers {
          thresholdMet
          thresholdType
          minimumThreshold
          products {
            productId
            ecommKey
            amount
          }
        }
      }
    }
  }
}
    `;
export type GqlComputeWithPriceCartV2MutationFn = Apollo.MutationFunction<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>;

/**
 * __useComputeWithPriceCartV2Mutation__
 *
 * To run a mutation, you first call `useComputeWithPriceCartV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeWithPriceCartV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeWithPriceCartV2Mutation, { data, loading, error }] = useComputeWithPriceCartV2Mutation({
 *   variables: {
 *      priceCartInput: // value for 'priceCartInput'
 *   },
 * });
 */
export function useComputeWithPriceCartV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>(ComputeWithPriceCartV2Document, options);
      }
export type ComputeWithPriceCartV2MutationHookResult = ReturnType<typeof useComputeWithPriceCartV2Mutation>;
export type ComputeWithPriceCartV2MutationResult = Apollo.MutationResult<GqlComputeWithPriceCartV2Mutation>;
export type ComputeWithPriceCartV2MutationOptions = Apollo.BaseMutationOptions<GqlComputeWithPriceCartV2Mutation, GqlComputeWithPriceCartV2MutationVariables>;
export const ServerSideCalculationsDocument = gql`
    mutation serverSideCalculations($input: LegacyCalculationsInput!) {
  serverSideCalculations(input: $input) {
    bottleDepositTaxCents
    cannabisTax
    cartSubtotal
    credit
    deliveryFee
    menuTotal
    mixAndMatch
    otherFees
    paymentFee
    paymentIncentives
    reward
    rounding
    roundupForCharityAmount
    subtotal
    tax
    tip
    total
    details {
      basePrice
      basePriceMult
      bogoSavings {
        displayAsPercentDiscount
        individual {
          conditionQuantity
          discountAmount
          discountStacking
          displayAsPercentDiscount
          isDiscountToCartReward
          maxApplicable
          nonStackingBehavior
          specialId
          stackingBehavior
        }
        isDiscountToCartReward
        menuBogoDiscount
        total
      }
      bottleDepositTaxCents
      canonicalEffectivePotencyMg
      enterpriseProductId
      id
      isOnSale
      isVapeTaxed
      key
      menuBasePrice
      menuCannabisTax
      menuIndividualPrice
      menuSaleAdjustment
      menuPrice
      menuSalesTax
      option
      posId
      productBrand
      productBrandId
      productCategory
      productSubcategory
      quantity
      type
      weightInGrams
      weightInMg
      wholesalePrice
      pricingTierData {
        generatedTiersId
        tiersId
        tiersName
        tiers {
          endWeight
          price
          pricePerGram
          startWeight
          weightUOM
        }
      }
      specialData {
        bogoSpecials {
          applyRewardsToConditions
          bogoConditionLogicOperator
          bogoConditions {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            productGroup
            productId
            productIds
            productTags
            quantity
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weight
            weightOperator
          }
          bogoRewardLogicOperator
          bogoRewards {
            _id
            brandId
            brandIds
            brandName
            brandNames
            categoryIds
            categoryName
            categoryNames
            dollarDiscount
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            percentDiscount
            productGroup
            productId
            productIds
            productTags
            quantity
            strainIds
            subcategoryIds
            subcategoryNames
            targetPrice
            vendorIds
            weight
          }
          createdBy
          directPOSProductIdMapping
          discountBehavior
          discountBundle {
            _id
            applyTo
            discountType
            enabled
            limit
            value
          }
          discountPrecedence
          discountStacking
          discountToCart {
            _id
            discountType
            enabled
            value
          }
          endStamp
          excludeConditionItemsFromRewards
          excludedProducts {
            conditions {
              _id
              Name
              key
            }
            rewards {
              _id
              Name
              key
            }
          }
          isRecurring
          itemsForAPrice {
            _id
            enabled
            value
          }
          menuType
          minorVersion
          nonStackingBehavior
          paymentRestrictions {
            payByBankSignupIncentive
          }
          rawPOSWeightMapping
          recurringEndDate
          redemptionLimit
          specialId
          specialName
          specialType
          stackingBehavior
          totalQuantity {
            enabled
            maxQuantity
            quantity
            quantityOperator
          }
          totalSpend {
            enabled
            maximumSpend
            minimumSpend
            spendOperator
          }
          totalWeight {
            enabled
            weight
            weightOperator
          }
          version
        }
        saleSpecials {
          createdBy
          directPOSProductIdMapping
          discount
          discountStacking
          dollarDiscount
          eligibleProductOptions
          menuType
          minorVersion
          nonStackingBehavior
          paymentRestrictions {
            payByBankSignupIncentive
          }
          percentDiscount
          rawPOSWeightMapping
          saleDiscounts {
            _id
            brandIds
            brandNames
            categoryIds
            categoryNames
            discountAmount
            discountType
            enterpriseProductIds
            exclusions {
              _id
              brandIds
              brandNames
              categoryIds
              categoryNames
              enterpriseProductIds
              inventoryTags
              matchOperator
              productGroup
              productIds
              productTags
              strainIds
              subcategoryIds
              subcategoryNames
              vendorIds
              weightOperator
              weights
            }
            inventoryTags
            productGroup
            productIds
            productTags
            strainIds
            subcategoryIds
            subcategoryNames
            vendorIds
            weightOperator
            weights
          }
          source
          sourceId
          specialId
          specialName
          specialRestrictions
          specialType
          stackingBehavior
          stackingMode
          targetPrice
          version
        }
      }
    }
    bottleDepositTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
    cannabisTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
    lineitems {
      type
      value
    }
    receipt
    salesTaxExistence {
      med {
        checkout
        menu
        pos
      }
      rec {
        checkout
        menu
        pos
      }
    }
  }
}
    `;
export type GqlServerSideCalculationsMutationFn = Apollo.MutationFunction<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>;

/**
 * __useServerSideCalculationsMutation__
 *
 * To run a mutation, you first call `useServerSideCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServerSideCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serverSideCalculationsMutation, { data, loading, error }] = useServerSideCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServerSideCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>(ServerSideCalculationsDocument, options);
      }
export type ServerSideCalculationsMutationHookResult = ReturnType<typeof useServerSideCalculationsMutation>;
export type ServerSideCalculationsMutationResult = Apollo.MutationResult<GqlServerSideCalculationsMutation>;
export type ServerSideCalculationsMutationOptions = Apollo.BaseMutationOptions<GqlServerSideCalculationsMutation, GqlServerSideCalculationsMutationVariables>;
export const ComputeWithPriceCartDocument = gql`
    query ComputeWithPriceCart($priceCartInput: CalculationsInput!) {
  computeWithPriceCart(input: $priceCartInput) {
    itemTaxes {
      taxAmount
      taxType
      productId
      feeItemId
      showOnMenu
      showOnCheckout
    }
    cartItemPrices {
      productName
      productId
      quantity
      subtotal
      unitPrice
      pricingTierAdjustment
      pricingTierAdjustmentTotal
      summaryPrice
      menuPrice
      discounts {
        name
        amount
        discountId
        applicationMethod
        isLoyaltyReward
        isPaymentIncentive
      }
      tax
      unitWeightGrams
      productType
    }
    fees {
      feeItemId
      feeAmount
      feeName
      deliveryFee
      paymentFee
    }
    subTotal
    taxes
    discount
    originalTotal
    roundedDifference
    grandTotal
    loyaltyPointsUsed
    rewardValidationErrors {
      discountCode
      discountId
      message
    }
    totalSalesTax
    totalCannabisTax
    totalBottleDepositTax
    taxInclusivePricing
    loyaltyAppliedAsDiscount
    discountWithoutLoyalty
    posCustomerId
  }
}
    `;

/**
 * __useComputeWithPriceCartQuery__
 *
 * To run a query within a React component, call `useComputeWithPriceCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeWithPriceCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeWithPriceCartQuery({
 *   variables: {
 *      priceCartInput: // value for 'priceCartInput'
 *   },
 * });
 */
export function useComputeWithPriceCartQuery(baseOptions: Apollo.QueryHookOptions<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>(ComputeWithPriceCartDocument, options);
      }
export function useComputeWithPriceCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>(ComputeWithPriceCartDocument, options);
        }
export type ComputeWithPriceCartQueryHookResult = ReturnType<typeof useComputeWithPriceCartQuery>;
export type ComputeWithPriceCartLazyQueryHookResult = ReturnType<typeof useComputeWithPriceCartLazyQuery>;
export type ComputeWithPriceCartQueryResult = Apollo.QueryResult<GqlComputeWithPriceCartQuery, GqlComputeWithPriceCartQueryVariables>;
export const GetCannabinoidsDocument = gql`
    query GetCannabinoids {
  getCannabinoids {
    name
    id
  }
}
    `;

/**
 * __useGetCannabinoidsQuery__
 *
 * To run a query within a React component, call `useGetCannabinoidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCannabinoidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCannabinoidsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCannabinoidsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>(GetCannabinoidsDocument, options);
      }
export function useGetCannabinoidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>(GetCannabinoidsDocument, options);
        }
export type GetCannabinoidsQueryHookResult = ReturnType<typeof useGetCannabinoidsQuery>;
export type GetCannabinoidsLazyQueryHookResult = ReturnType<typeof useGetCannabinoidsLazyQuery>;
export type GetCannabinoidsQueryResult = Apollo.QueryResult<GqlGetCannabinoidsQuery, GqlGetCannabinoidsQueryVariables>;
export const CreateCouponV2Document = gql`
    mutation CreateCouponV2($input: createCouponInput!) {
  createCouponV2(coupon: $input) {
    ...couponFragment
  }
}
    ${CouponFragmentFragmentDoc}`;
export type GqlCreateCouponV2MutationFn = Apollo.MutationFunction<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>;

/**
 * __useCreateCouponV2Mutation__
 *
 * To run a mutation, you first call `useCreateCouponV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponV2Mutation, { data, loading, error }] = useCreateCouponV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCouponV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>(CreateCouponV2Document, options);
      }
export type CreateCouponV2MutationHookResult = ReturnType<typeof useCreateCouponV2Mutation>;
export type CreateCouponV2MutationResult = Apollo.MutationResult<GqlCreateCouponV2Mutation>;
export type CreateCouponV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateCouponV2Mutation, GqlCreateCouponV2MutationVariables>;
export const DeleteCouponDocument = gql`
    mutation DeleteCoupon($id: String!) {
  deleteCoupon(id: $id) {
    success
  }
}
    `;
export type GqlDeleteCouponMutationFn = Apollo.MutationFunction<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>;

/**
 * __useDeleteCouponMutation__
 *
 * To run a mutation, you first call `useDeleteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponMutation, { data, loading, error }] = useDeleteCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>(DeleteCouponDocument, options);
      }
export type DeleteCouponMutationHookResult = ReturnType<typeof useDeleteCouponMutation>;
export type DeleteCouponMutationResult = Apollo.MutationResult<GqlDeleteCouponMutation>;
export type DeleteCouponMutationOptions = Apollo.BaseMutationOptions<GqlDeleteCouponMutation, GqlDeleteCouponMutationVariables>;
export const DeleteCouponV2Document = gql`
    mutation DeleteCouponV2($id: String!) {
  deleteCouponV2(id: $id) {
    success
  }
}
    `;
export type GqlDeleteCouponV2MutationFn = Apollo.MutationFunction<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>;

/**
 * __useDeleteCouponV2Mutation__
 *
 * To run a mutation, you first call `useDeleteCouponV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponV2Mutation, { data, loading, error }] = useDeleteCouponV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>(DeleteCouponV2Document, options);
      }
export type DeleteCouponV2MutationHookResult = ReturnType<typeof useDeleteCouponV2Mutation>;
export type DeleteCouponV2MutationResult = Apollo.MutationResult<GqlDeleteCouponV2Mutation>;
export type DeleteCouponV2MutationOptions = Apollo.BaseMutationOptions<GqlDeleteCouponV2Mutation, GqlDeleteCouponV2MutationVariables>;
export const UpdateCouponDocument = gql`
    mutation UpdateCoupon($input: updateCouponInput!) {
  updateCoupon(coupon: $input) {
    ...couponFragment
  }
}
    ${CouponFragmentFragmentDoc}`;
export type GqlUpdateCouponMutationFn = Apollo.MutationFunction<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>;

/**
 * __useUpdateCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponMutation, { data, loading, error }] = useUpdateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCouponMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>(UpdateCouponDocument, options);
      }
export type UpdateCouponMutationHookResult = ReturnType<typeof useUpdateCouponMutation>;
export type UpdateCouponMutationResult = Apollo.MutationResult<GqlUpdateCouponMutation>;
export type UpdateCouponMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCouponMutation, GqlUpdateCouponMutationVariables>;
export const FilteredCouponsDocument = gql`
    query FilteredCoupons($filter: couponsFilterInput, $sort: couponsSortInput, $pagination: couponsPaginationInput) {
  filteredCoupons(filter: $filter, sort: $sort, pagination: $pagination) {
    queryInfo {
      totalCount
    }
    coupons {
      ...couponFragment
      dispensary
      reimbursed
    }
  }
}
    ${CouponFragmentFragmentDoc}`;

/**
 * __useFilteredCouponsQuery__
 *
 * To run a query within a React component, call `useFilteredCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCouponsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFilteredCouponsQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>(FilteredCouponsDocument, options);
      }
export function useFilteredCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>(FilteredCouponsDocument, options);
        }
export type FilteredCouponsQueryHookResult = ReturnType<typeof useFilteredCouponsQuery>;
export type FilteredCouponsLazyQueryHookResult = ReturnType<typeof useFilteredCouponsLazyQuery>;
export type FilteredCouponsQueryResult = Apollo.QueryResult<GqlFilteredCouponsQuery, GqlFilteredCouponsQueryVariables>;
export const ClearAllCurbsideArrivalsDocument = gql`
    mutation ClearAllCurbsideArrivals($dispensaryId: String!) {
  clearAllCurbsideArrivals(dispensaryId: $dispensaryId) {
    success
  }
}
    `;
export type GqlClearAllCurbsideArrivalsMutationFn = Apollo.MutationFunction<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>;

/**
 * __useClearAllCurbsideArrivalsMutation__
 *
 * To run a mutation, you first call `useClearAllCurbsideArrivalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllCurbsideArrivalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllCurbsideArrivalsMutation, { data, loading, error }] = useClearAllCurbsideArrivalsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useClearAllCurbsideArrivalsMutation(baseOptions?: Apollo.MutationHookOptions<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>(ClearAllCurbsideArrivalsDocument, options);
      }
export type ClearAllCurbsideArrivalsMutationHookResult = ReturnType<typeof useClearAllCurbsideArrivalsMutation>;
export type ClearAllCurbsideArrivalsMutationResult = Apollo.MutationResult<GqlClearAllCurbsideArrivalsMutation>;
export type ClearAllCurbsideArrivalsMutationOptions = Apollo.BaseMutationOptions<GqlClearAllCurbsideArrivalsMutation, GqlClearAllCurbsideArrivalsMutationVariables>;
export const ClearCurbsideArrivalDocument = gql`
    mutation ClearCurbsideArrival($arrivalId: String!) {
  clearCurbsideArrival(arrivalId: $arrivalId) {
    success
  }
}
    `;
export type GqlClearCurbsideArrivalMutationFn = Apollo.MutationFunction<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>;

/**
 * __useClearCurbsideArrivalMutation__
 *
 * To run a mutation, you first call `useClearCurbsideArrivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCurbsideArrivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCurbsideArrivalMutation, { data, loading, error }] = useClearCurbsideArrivalMutation({
 *   variables: {
 *      arrivalId: // value for 'arrivalId'
 *   },
 * });
 */
export function useClearCurbsideArrivalMutation(baseOptions?: Apollo.MutationHookOptions<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>(ClearCurbsideArrivalDocument, options);
      }
export type ClearCurbsideArrivalMutationHookResult = ReturnType<typeof useClearCurbsideArrivalMutation>;
export type ClearCurbsideArrivalMutationResult = Apollo.MutationResult<GqlClearCurbsideArrivalMutation>;
export type ClearCurbsideArrivalMutationOptions = Apollo.BaseMutationOptions<GqlClearCurbsideArrivalMutation, GqlClearCurbsideArrivalMutationVariables>;
export const MarkCurbsideArrivalArrivedV2Document = gql`
    mutation MarkCurbsideArrivalArrivedV2($token: String!) {
  markCurbsideArrivalArrivedV2(token: $token) {
    id
  }
}
    `;
export type GqlMarkCurbsideArrivalArrivedV2MutationFn = Apollo.MutationFunction<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>;

/**
 * __useMarkCurbsideArrivalArrivedV2Mutation__
 *
 * To run a mutation, you first call `useMarkCurbsideArrivalArrivedV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCurbsideArrivalArrivedV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCurbsideArrivalArrivedV2Mutation, { data, loading, error }] = useMarkCurbsideArrivalArrivedV2Mutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMarkCurbsideArrivalArrivedV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>(MarkCurbsideArrivalArrivedV2Document, options);
      }
export type MarkCurbsideArrivalArrivedV2MutationHookResult = ReturnType<typeof useMarkCurbsideArrivalArrivedV2Mutation>;
export type MarkCurbsideArrivalArrivedV2MutationResult = Apollo.MutationResult<GqlMarkCurbsideArrivalArrivedV2Mutation>;
export type MarkCurbsideArrivalArrivedV2MutationOptions = Apollo.BaseMutationOptions<GqlMarkCurbsideArrivalArrivedV2Mutation, GqlMarkCurbsideArrivalArrivedV2MutationVariables>;
export const UpdateCurbsideArrivalV2Document = gql`
    mutation UpdateCurbsideArrivalV2($token: String!, $arrivalInformation: String!) {
  updateCurbsideArrivalV2(token: $token, arrivalInformation: $arrivalInformation) {
    id
  }
}
    `;
export type GqlUpdateCurbsideArrivalV2MutationFn = Apollo.MutationFunction<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>;

/**
 * __useUpdateCurbsideArrivalV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCurbsideArrivalV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurbsideArrivalV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurbsideArrivalV2Mutation, { data, loading, error }] = useUpdateCurbsideArrivalV2Mutation({
 *   variables: {
 *      token: // value for 'token'
 *      arrivalInformation: // value for 'arrivalInformation'
 *   },
 * });
 */
export function useUpdateCurbsideArrivalV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>(UpdateCurbsideArrivalV2Document, options);
      }
export type UpdateCurbsideArrivalV2MutationHookResult = ReturnType<typeof useUpdateCurbsideArrivalV2Mutation>;
export type UpdateCurbsideArrivalV2MutationResult = Apollo.MutationResult<GqlUpdateCurbsideArrivalV2Mutation>;
export type UpdateCurbsideArrivalV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateCurbsideArrivalV2Mutation, GqlUpdateCurbsideArrivalV2MutationVariables>;
export const GetCurbsideArrivalByTokenDocument = gql`
    query GetCurbsideArrivalByToken($token: String!) {
  getCurbsideArrivalByToken(token: $token) {
    id
    dispensary {
      id
      phone
      orderTypesConfigV2 {
        curbsidePickup {
          arrivalInformationInstructions
        }
      }
    }
    arrivalInformation
    arrivedAt
    clearedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCurbsideArrivalByTokenQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetCurbsideArrivalByTokenQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>(GetCurbsideArrivalByTokenDocument, options);
      }
export function useGetCurbsideArrivalByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>(GetCurbsideArrivalByTokenDocument, options);
        }
export type GetCurbsideArrivalByTokenQueryHookResult = ReturnType<typeof useGetCurbsideArrivalByTokenQuery>;
export type GetCurbsideArrivalByTokenLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalByTokenLazyQuery>;
export type GetCurbsideArrivalByTokenQueryResult = Apollo.QueryResult<GqlGetCurbsideArrivalByTokenQuery, GqlGetCurbsideArrivalByTokenQueryVariables>;
export const GetCurbsideArrivalsForBannerDocument = gql`
    query GetCurbsideArrivalsForBanner($dispensaryId: String!) {
  getCurbsideArrivals(dispensaryId: $dispensaryId) {
    id
  }
}
    `;

/**
 * __useGetCurbsideArrivalsForBannerQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalsForBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalsForBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalsForBannerQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCurbsideArrivalsForBannerQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>(GetCurbsideArrivalsForBannerDocument, options);
      }
export function useGetCurbsideArrivalsForBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>(GetCurbsideArrivalsForBannerDocument, options);
        }
export type GetCurbsideArrivalsForBannerQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsForBannerQuery>;
export type GetCurbsideArrivalsForBannerLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsForBannerLazyQuery>;
export type GetCurbsideArrivalsForBannerQueryResult = Apollo.QueryResult<GqlGetCurbsideArrivalsForBannerQuery, GqlGetCurbsideArrivalsForBannerQueryVariables>;
export const GetCurbsideArrivalsDocument = gql`
    query GetCurbsideArrivals($dispensaryId: String!) {
  getCurbsideArrivals(dispensaryId: $dispensaryId) {
    id
    order {
      id
      orderId
      customer {
        profile {
          firstName
          lastName
          phone
        }
      }
      guestCustomer {
        firstName
        lastName
        phone
      }
    }
    arrivalInformation
    arrivedAt
    clearedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCurbsideArrivalsQuery__
 *
 * To run a query within a React component, call `useGetCurbsideArrivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurbsideArrivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurbsideArrivalsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetCurbsideArrivalsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>(GetCurbsideArrivalsDocument, options);
      }
export function useGetCurbsideArrivalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>(GetCurbsideArrivalsDocument, options);
        }
export type GetCurbsideArrivalsQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsQuery>;
export type GetCurbsideArrivalsLazyQueryHookResult = ReturnType<typeof useGetCurbsideArrivalsLazyQuery>;
export type GetCurbsideArrivalsQueryResult = Apollo.QueryResult<GqlGetCurbsideArrivalsQuery, GqlGetCurbsideArrivalsQueryVariables>;
export const UpdateCustomerSubscriptionDocument = gql`
    mutation UpdateCustomerSubscription($customerId: String!, $subscribed: Boolean!) {
  updateCustomerSubscription(customerId: $customerId, subscribed: $subscribed) {
    success
  }
}
    `;
export type GqlUpdateCustomerSubscriptionMutationFn = Apollo.MutationFunction<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>;

/**
 * __useUpdateCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSubscriptionMutation, { data, loading, error }] = useUpdateCustomerSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscribed: // value for 'subscribed'
 *   },
 * });
 */
export function useUpdateCustomerSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>(UpdateCustomerSubscriptionDocument, options);
      }
export type UpdateCustomerSubscriptionMutationHookResult = ReturnType<typeof useUpdateCustomerSubscriptionMutation>;
export type UpdateCustomerSubscriptionMutationResult = Apollo.MutationResult<GqlUpdateCustomerSubscriptionMutation>;
export type UpdateCustomerSubscriptionMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCustomerSubscriptionMutation, GqlUpdateCustomerSubscriptionMutationVariables>;
export const GetDevicesDocument = gql`
    query GetDevices($dispensaryId: String!) {
  getDevices(dispensaryId: $dispensaryId) {
    ...deviceFragment
  }
}
    ${DeviceFragmentFragmentDoc}`;

/**
 * __useGetDevicesQuery__
 *
 * To run a query within a React component, call `useGetDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetDevicesQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>(GetDevicesDocument, options);
      }
export function useGetDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>(GetDevicesDocument, options);
        }
export type GetDevicesQueryHookResult = ReturnType<typeof useGetDevicesQuery>;
export type GetDevicesLazyQueryHookResult = ReturnType<typeof useGetDevicesLazyQuery>;
export type GetDevicesQueryResult = Apollo.QueryResult<GqlGetDevicesQuery, GqlGetDevicesQueryVariables>;
export const GetKioskTerminalsDocument = gql`
    query GetKioskTerminals($dispensaryId: String!) {
  getKioskTerminals(dispensaryId: $dispensaryId) {
    id
    dispensaryId
    nickname
  }
}
    `;

/**
 * __useGetKioskTerminalsQuery__
 *
 * To run a query within a React component, call `useGetKioskTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKioskTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKioskTerminalsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetKioskTerminalsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>(GetKioskTerminalsDocument, options);
      }
export function useGetKioskTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>(GetKioskTerminalsDocument, options);
        }
export type GetKioskTerminalsQueryHookResult = ReturnType<typeof useGetKioskTerminalsQuery>;
export type GetKioskTerminalsLazyQueryHookResult = ReturnType<typeof useGetKioskTerminalsLazyQuery>;
export type GetKioskTerminalsQueryResult = Apollo.QueryResult<GqlGetKioskTerminalsQuery, GqlGetKioskTerminalsQueryVariables>;
export const AddSubscriptionToChainDocument = gql`
    mutation AddSubscriptionToChain($dispensaryIds: [String]!, $chargebeeCustomerId: String!) {
  addSubscriptionToChain(
    dispensaryIds: $dispensaryIds
    chargebeeCustomerId: $chargebeeCustomerId
  ) {
    message
    success
  }
}
    `;
export type GqlAddSubscriptionToChainMutationFn = Apollo.MutationFunction<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>;

/**
 * __useAddSubscriptionToChainMutation__
 *
 * To run a mutation, you first call `useAddSubscriptionToChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriptionToChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubscriptionToChainMutation, { data, loading, error }] = useAddSubscriptionToChainMutation({
 *   variables: {
 *      dispensaryIds: // value for 'dispensaryIds'
 *      chargebeeCustomerId: // value for 'chargebeeCustomerId'
 *   },
 * });
 */
export function useAddSubscriptionToChainMutation(baseOptions?: Apollo.MutationHookOptions<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>(AddSubscriptionToChainDocument, options);
      }
export type AddSubscriptionToChainMutationHookResult = ReturnType<typeof useAddSubscriptionToChainMutation>;
export type AddSubscriptionToChainMutationResult = Apollo.MutationResult<GqlAddSubscriptionToChainMutation>;
export type AddSubscriptionToChainMutationOptions = Apollo.BaseMutationOptions<GqlAddSubscriptionToChainMutation, GqlAddSubscriptionToChainMutationVariables>;
export const RemoveSubscriptionFromChainDocument = gql`
    mutation RemoveSubscriptionFromChain($ids: [String]!, $chargebeeCustomerId: String!) {
  removeSubscriptionFromChain(
    ids: $ids
    chargebeeCustomerId: $chargebeeCustomerId
  ) {
    message
    success
  }
}
    `;
export type GqlRemoveSubscriptionFromChainMutationFn = Apollo.MutationFunction<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>;

/**
 * __useRemoveSubscriptionFromChainMutation__
 *
 * To run a mutation, you first call `useRemoveSubscriptionFromChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubscriptionFromChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSubscriptionFromChainMutation, { data, loading, error }] = useRemoveSubscriptionFromChainMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      chargebeeCustomerId: // value for 'chargebeeCustomerId'
 *   },
 * });
 */
export function useRemoveSubscriptionFromChainMutation(baseOptions?: Apollo.MutationHookOptions<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>(RemoveSubscriptionFromChainDocument, options);
      }
export type RemoveSubscriptionFromChainMutationHookResult = ReturnType<typeof useRemoveSubscriptionFromChainMutation>;
export type RemoveSubscriptionFromChainMutationResult = Apollo.MutationResult<GqlRemoveSubscriptionFromChainMutation>;
export type RemoveSubscriptionFromChainMutationOptions = Apollo.BaseMutationOptions<GqlRemoveSubscriptionFromChainMutation, GqlRemoveSubscriptionFromChainMutationVariables>;
export const GetChainBillingInfoDocument = gql`
    query GetChainBillingInfo($dispensaries: [String!]) {
  getBillingSubscriptions(dispensaries: $dispensaries) {
    dispensaryBilling {
      chain
      chargebeeCustomerId
    }
  }
}
    `;

/**
 * __useGetChainBillingInfoQuery__
 *
 * To run a query within a React component, call `useGetChainBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainBillingInfoQuery({
 *   variables: {
 *      dispensaries: // value for 'dispensaries'
 *   },
 * });
 */
export function useGetChainBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>(GetChainBillingInfoDocument, options);
      }
export function useGetChainBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>(GetChainBillingInfoDocument, options);
        }
export type GetChainBillingInfoQueryHookResult = ReturnType<typeof useGetChainBillingInfoQuery>;
export type GetChainBillingInfoLazyQueryHookResult = ReturnType<typeof useGetChainBillingInfoLazyQuery>;
export type GetChainBillingInfoQueryResult = Apollo.QueryResult<GqlGetChainBillingInfoQuery, GqlGetChainBillingInfoQueryVariables>;
export const GetSubscriptionsForChainDocument = gql`
    query GetSubscriptionsForChain($dispensaries: [String!]) {
  getBillingSubscriptions(dispensaries: $dispensaries) {
    dispensaryBilling {
      chain
      chargebeeCustomer {
        company
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionsForChainQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsForChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsForChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsForChainQuery({
 *   variables: {
 *      dispensaries: // value for 'dispensaries'
 *   },
 * });
 */
export function useGetSubscriptionsForChainQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>(GetSubscriptionsForChainDocument, options);
      }
export function useGetSubscriptionsForChainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>(GetSubscriptionsForChainDocument, options);
        }
export type GetSubscriptionsForChainQueryHookResult = ReturnType<typeof useGetSubscriptionsForChainQuery>;
export type GetSubscriptionsForChainLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsForChainLazyQuery>;
export type GetSubscriptionsForChainQueryResult = Apollo.QueryResult<GqlGetSubscriptionsForChainQuery, GqlGetSubscriptionsForChainQueryVariables>;
export const GetSubscriptionsV2Document = gql`
    query GetSubscriptionsV2($retailers: [RetailerInput]!) {
  getSubscriptionsV2(retailers: $retailers) {
    dispensaryBilling {
      chain
      chargebeeCustomer {
        id
        company
        contacts {
          email
          sendBillingEmail
        }
        locationCount
      }
      ...GetSubscriptionsV2PaymentSources
    }
    chargebeeSubscription {
      status
      trialStart
      trialEnd
      currentTermStart
      currentTermEnd
      nextBillingAt
      createdAt
      startedAt
      activatedAt
      invoices {
        id
        total
        lineItems {
          dateFrom
          dateTo
          quantity
          amount
        }
        status
        amountPaid
        amountDue
        creditsApplied
      }
      planAmount
    }
    manualPayments
    chargebeePlan {
      period
      periodUnit
    }
    retailerId
  }
}
    ${GetSubscriptionsV2PaymentSourcesFragmentDoc}`;

/**
 * __useGetSubscriptionsV2Query__
 *
 * To run a query within a React component, call `useGetSubscriptionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsV2Query({
 *   variables: {
 *      retailers: // value for 'retailers'
 *   },
 * });
 */
export function useGetSubscriptionsV2Query(baseOptions: Apollo.QueryHookOptions<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>(GetSubscriptionsV2Document, options);
      }
export function useGetSubscriptionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>(GetSubscriptionsV2Document, options);
        }
export type GetSubscriptionsV2QueryHookResult = ReturnType<typeof useGetSubscriptionsV2Query>;
export type GetSubscriptionsV2LazyQueryHookResult = ReturnType<typeof useGetSubscriptionsV2LazyQuery>;
export type GetSubscriptionsV2QueryResult = Apollo.QueryResult<GqlGetSubscriptionsV2Query, GqlGetSubscriptionsV2QueryVariables>;
export const GetSubscriptionsDocument = gql`
    query GetSubscriptions($dispensaries: [String!]) {
  getBillingSubscriptions(dispensaries: $dispensaries) {
    dispensaryBilling {
      chain
      chargebeeCustomerId
      chargebeeCustomer {
        company
        contacts {
          email
          sendBillingEmail
        }
        locationCount
      }
      paymentSources {
        card {
          brand
          last4
        }
        type
      }
    }
    dispensaryId
    chargebeeSubscriptionId
    chargebeeSubscription {
      status
      trialStart
      trialEnd
      currentTermStart
      currentTermEnd
      nextBillingAt
      createdAt
      startedAt
      activatedAt
      invoices {
        id
        total
        lineItems {
          dateFrom
          dateTo
          quantity
          amount
        }
        status
        amountPaid
        amountDue
        creditsApplied
      }
      planAmount
    }
    manualPayments
    chargebeePlan {
      period
      periodUnit
    }
  }
}
    `;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      dispensaries: // value for 'dispensaries'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GqlGetSubscriptionsQuery, GqlGetSubscriptionsQueryVariables>;
export const DispensaryOnboardingDocument = gql`
    mutation DispensaryOnboarding($input: dispensaryOnboardingInput!) {
  dispensaryOnboarding(input: $input) {
    success
  }
}
    `;
export type GqlDispensaryOnboardingMutationFn = Apollo.MutationFunction<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>;

/**
 * __useDispensaryOnboardingMutation__
 *
 * To run a mutation, you first call `useDispensaryOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryOnboardingMutation, { data, loading, error }] = useDispensaryOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispensaryOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>(DispensaryOnboardingDocument, options);
      }
export type DispensaryOnboardingMutationHookResult = ReturnType<typeof useDispensaryOnboardingMutation>;
export type DispensaryOnboardingMutationResult = Apollo.MutationResult<GqlDispensaryOnboardingMutation>;
export type DispensaryOnboardingMutationOptions = Apollo.BaseMutationOptions<GqlDispensaryOnboardingMutation, GqlDispensaryOnboardingMutationVariables>;
export const DispensaryUploadOnboardingAssetDocument = gql`
    mutation DispensaryUploadOnboardingAsset($data: String!, $fileName: String!) {
  dispensaryUploadOnboardingAsset(data: $data, fileName: $fileName) {
    fileIds
  }
}
    `;
export type GqlDispensaryUploadOnboardingAssetMutationFn = Apollo.MutationFunction<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>;

/**
 * __useDispensaryUploadOnboardingAssetMutation__
 *
 * To run a mutation, you first call `useDispensaryUploadOnboardingAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryUploadOnboardingAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryUploadOnboardingAssetMutation, { data, loading, error }] = useDispensaryUploadOnboardingAssetMutation({
 *   variables: {
 *      data: // value for 'data'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useDispensaryUploadOnboardingAssetMutation(baseOptions?: Apollo.MutationHookOptions<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>(DispensaryUploadOnboardingAssetDocument, options);
      }
export type DispensaryUploadOnboardingAssetMutationHookResult = ReturnType<typeof useDispensaryUploadOnboardingAssetMutation>;
export type DispensaryUploadOnboardingAssetMutationResult = Apollo.MutationResult<GqlDispensaryUploadOnboardingAssetMutation>;
export type DispensaryUploadOnboardingAssetMutationOptions = Apollo.BaseMutationOptions<GqlDispensaryUploadOnboardingAssetMutation, GqlDispensaryUploadOnboardingAssetMutationVariables>;
export const GetAddressBasedDispensaryDataDocument = gql`
    query GetAddressBasedDispensaryData($input: getDeliveryInfoInput) {
  getAddressBasedDispensaryData(input: $input) {
    deliveryInfo {
      deliveryAreaId
      withinBounds
      fee
      minimum
      feeVaries
      minimumVaries
    }
    taxes {
      ...taxProperties
      destinationRate
    }
  }
}
    ${TaxPropertiesFragmentDoc}`;

/**
 * __useGetAddressBasedDispensaryDataQuery__
 *
 * To run a query within a React component, call `useGetAddressBasedDispensaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressBasedDispensaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressBasedDispensaryDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAddressBasedDispensaryDataQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>(GetAddressBasedDispensaryDataDocument, options);
      }
export function useGetAddressBasedDispensaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>(GetAddressBasedDispensaryDataDocument, options);
        }
export type GetAddressBasedDispensaryDataQueryHookResult = ReturnType<typeof useGetAddressBasedDispensaryDataQuery>;
export type GetAddressBasedDispensaryDataLazyQueryHookResult = ReturnType<typeof useGetAddressBasedDispensaryDataLazyQuery>;
export type GetAddressBasedDispensaryDataQueryResult = Apollo.QueryResult<GqlGetAddressBasedDispensaryDataQuery, GqlGetAddressBasedDispensaryDataQueryVariables>;
export const DispensarySearchDocument = gql`
    query DispensarySearch($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    id
    name
    cName
    status
    recDispensary
    medicalDispensary
    offerPickup
    offerCurbsidePickup
    offerDriveThruPickup
    offerAnyPickupService
    offerDelivery
    listImage
    location {
      city
      county
      geometry {
        coordinates
        type
      }
      ln1
      ln2
      state
      zipcode
      country
    }
    actionEstimates {
      delivery {
        readyInMinutes
        rangeInMinutes
        deliveryTimeInMinutes
      }
      pickup {
        readyInMinutes
        rangeInMinutes
      }
    }
    durationEstimateOverrides {
      pickup {
        enabled
        lowInMinutes
        highInMinutes
      }
      delivery {
        enabled
        lowInMinutes
        highInMinutes
      }
    }
    storeSettings {
      enableAfterHoursOrderingForPickup
      enableAfterHoursOrderingForDelivery
      enableScheduledOrderingForPickup
      enableScheduledOrderingForDelivery
    }
    featureFlags {
      hideDeliveryEstimate
    }
    effectiveHours {
      deliveryHours {
        ...hourSetFragment
      }
      pickupHours {
        ...hourSetFragment
      }
    }
    deliveryHours {
      ...hourSetFragment
    }
    deliveryInfo {
      withinBounds
      fee
      minimum
      feeVaries
      minimumVaries
      feeType
      percentFee
    }
    feeTiers {
      fee
      feeType
      max
      min
      percentFee
    }
    pickupHours {
      ...hourSetFragment
    }
    specialHours {
      name
      startDate
      endDate
      hoursPerDay {
        date
        pickupHours {
          active
          start
          end
        }
        deliveryHours {
          active
          start
          end
        }
      }
    }
    distance
    maxDeliveryDistance
    timezone
    orderTypesConfig {
      pickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      curbsidePickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      driveThruPickup {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      delivery {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      kiosk {
        enabled
        paymentTypes {
          alt36
          check
          creditCardAtDoor
          payOnlineChase
          payOnlineHypur
          payOnlineMerrco
          payOnlineMoneris
          creditCardByPhone
          debit
          cash
          linx
          canPay
          paytender
          aeropay
          dutchiePay
          rethinkPay
        }
      }
      offerAnyPickupService
      offerDeliveryService
    }
    orderTypesConfigV2 {
      inStorePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      curbsidePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      driveThruPickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      delivery {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      offerAnyPickupService
      offerDeliveryService
    }
    hoursSettings {
      inStorePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      curbsidePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      driveThruPickup {
        ...hoursSettingsForOrderTypeFragment
      }
      delivery {
        ...hoursSettingsForOrderTypeFragment
      }
    }
    enabledOrderTypes {
      pickup
      inStorePickup
      curbsidePickup
      driveThruPickup
      delivery
      kiosk
    }
    paymentTypesAccepted {
      alt36
      check
      creditCardAtDoor
      payOnlineChase
      payOnlineHypur
      payOnlineMerrco
      payOnlineMoneris
      creditCardByPhone
      debit
      cash
      linx
      canPay
      paytender
      aeropay
      dutchiePay
      rethinkPay
    }
  }
}
    ${HourSetFragmentFragmentDoc}
${HoursSettingsForOrderTypeFragmentFragmentDoc}`;

/**
 * __useDispensarySearchQuery__
 *
 * To run a query within a React component, call `useDispensarySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispensarySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispensarySearchQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useDispensarySearchQuery(baseOptions: Apollo.QueryHookOptions<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>(DispensarySearchDocument, options);
      }
export function useDispensarySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>(DispensarySearchDocument, options);
        }
export type DispensarySearchQueryHookResult = ReturnType<typeof useDispensarySearchQuery>;
export type DispensarySearchLazyQueryHookResult = ReturnType<typeof useDispensarySearchLazyQuery>;
export type DispensarySearchQueryResult = Apollo.QueryResult<GqlDispensarySearchQuery, GqlDispensarySearchQueryVariables>;
export const CopyToLocationsDocument = gql`
    mutation CopyToLocations($enterpriseId: ID!, $klass: String!, $dispensaryId: String!, $itemId: String!, $enableAllLocations: Boolean, $dispensaryIds: [String!], $isoRegionCodes: [String!]) {
  copyToLocations(
    enterpriseId: $enterpriseId
    klass: $klass
    dispensaryId: $dispensaryId
    itemId: $itemId
    enableAllLocations: $enableAllLocations
    dispensaryIds: $dispensaryIds
    isoRegionCodes: $isoRegionCodes
  ) {
    success
    message
  }
}
    `;
export type GqlCopyToLocationsMutationFn = Apollo.MutationFunction<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>;

/**
 * __useCopyToLocationsMutation__
 *
 * To run a mutation, you first call `useCopyToLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyToLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyToLocationsMutation, { data, loading, error }] = useCopyToLocationsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      klass: // value for 'klass'
 *      dispensaryId: // value for 'dispensaryId'
 *      itemId: // value for 'itemId'
 *      enableAllLocations: // value for 'enableAllLocations'
 *      dispensaryIds: // value for 'dispensaryIds'
 *      isoRegionCodes: // value for 'isoRegionCodes'
 *   },
 * });
 */
export function useCopyToLocationsMutation(baseOptions?: Apollo.MutationHookOptions<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>(CopyToLocationsDocument, options);
      }
export type CopyToLocationsMutationHookResult = ReturnType<typeof useCopyToLocationsMutation>;
export type CopyToLocationsMutationResult = Apollo.MutationResult<GqlCopyToLocationsMutation>;
export type CopyToLocationsMutationOptions = Apollo.BaseMutationOptions<GqlCopyToLocationsMutation, GqlCopyToLocationsMutationVariables>;
export const CreateEnterpriseLoyaltySettingsDocument = gql`
    mutation CreateEnterpriseLoyaltySettings($enterpriseId: ID!, $landingPageUrl: String, $loyaltyEnrollmentUrl: String, $privacyPolicyUrl: String, $termsAndConditionsUrl: String) {
  createEnterpriseLoyaltySettings(
    enterpriseId: $enterpriseId
    landingPageUrl: $landingPageUrl
    loyaltyEnrollmentUrl: $loyaltyEnrollmentUrl
    privacyPolicyUrl: $privacyPolicyUrl
    termsAndConditionsUrl: $termsAndConditionsUrl
  ) {
    enterpriseId
    landingPageUrl
    loyaltyEnrollmentUrl
    name
    uniqueName
    dposLoyaltyIsoRegionCodes
    description
    displayName
    privacyPolicyUrl
    termsAndConditionsUrl
  }
}
    `;
export type GqlCreateEnterpriseLoyaltySettingsMutationFn = Apollo.MutationFunction<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>;

/**
 * __useCreateEnterpriseLoyaltySettingsMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseLoyaltySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseLoyaltySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseLoyaltySettingsMutation, { data, loading, error }] = useCreateEnterpriseLoyaltySettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      landingPageUrl: // value for 'landingPageUrl'
 *      loyaltyEnrollmentUrl: // value for 'loyaltyEnrollmentUrl'
 *      privacyPolicyUrl: // value for 'privacyPolicyUrl'
 *      termsAndConditionsUrl: // value for 'termsAndConditionsUrl'
 *   },
 * });
 */
export function useCreateEnterpriseLoyaltySettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>(CreateEnterpriseLoyaltySettingsDocument, options);
      }
export type CreateEnterpriseLoyaltySettingsMutationHookResult = ReturnType<typeof useCreateEnterpriseLoyaltySettingsMutation>;
export type CreateEnterpriseLoyaltySettingsMutationResult = Apollo.MutationResult<GqlCreateEnterpriseLoyaltySettingsMutation>;
export type CreateEnterpriseLoyaltySettingsMutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseLoyaltySettingsMutation, GqlCreateEnterpriseLoyaltySettingsMutationVariables>;
export const UpdateEnterpriseLoyaltySettingsDocument = gql`
    mutation UpdateEnterpriseLoyaltySettings($enterpriseId: ID!, $landingPageUrl: String, $loyaltyEnrollmentUrl: String, $description: String, $displayName: String, $privacyPolicyUrl: String, $termsAndConditionsUrl: String) {
  updateEnterpriseLoyaltySettings(
    enterpriseId: $enterpriseId
    landingPageUrl: $landingPageUrl
    loyaltyEnrollmentUrl: $loyaltyEnrollmentUrl
    description: $description
    displayName: $displayName
    privacyPolicyUrl: $privacyPolicyUrl
    termsAndConditionsUrl: $termsAndConditionsUrl
  ) {
    enterpriseId
    landingPageUrl
    loyaltyEnrollmentUrl
    name
    uniqueName
    dposLoyaltyIsoRegionCodes
    description
    displayName
    privacyPolicyUrl
    termsAndConditionsUrl
  }
}
    `;
export type GqlUpdateEnterpriseLoyaltySettingsMutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>;

/**
 * __useUpdateEnterpriseLoyaltySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseLoyaltySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseLoyaltySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseLoyaltySettingsMutation, { data, loading, error }] = useUpdateEnterpriseLoyaltySettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      landingPageUrl: // value for 'landingPageUrl'
 *      loyaltyEnrollmentUrl: // value for 'loyaltyEnrollmentUrl'
 *      description: // value for 'description'
 *      displayName: // value for 'displayName'
 *      privacyPolicyUrl: // value for 'privacyPolicyUrl'
 *      termsAndConditionsUrl: // value for 'termsAndConditionsUrl'
 *   },
 * });
 */
export function useUpdateEnterpriseLoyaltySettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>(UpdateEnterpriseLoyaltySettingsDocument, options);
      }
export type UpdateEnterpriseLoyaltySettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseLoyaltySettingsMutation>;
export type UpdateEnterpriseLoyaltySettingsMutationResult = Apollo.MutationResult<GqlUpdateEnterpriseLoyaltySettingsMutation>;
export type UpdateEnterpriseLoyaltySettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseLoyaltySettingsMutation, GqlUpdateEnterpriseLoyaltySettingsMutationVariables>;
export const UpdateEnterpriseMobileAppSettingsDocument = gql`
    mutation UpdateEnterpriseMobileAppSettings($enterpriseId: ID!, $input: EnterpriseMobileAppSettingsInput) {
  updateEnterpriseMobileAppSettings(enterpriseId: $enterpriseId, input: $input) {
    androidAppIcon
    androidExistingVersion
    androidExistingVersionCode
    androidOrganizationName
    androidPackageName
    androidSplashBackgroundColor
    automaticScreenshotGeneration
    buildForIpad
    firebaseProjectId
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosExistingVersion
    iosSplashBackgroundColor
    iosTeamId
    iosTeamName
    name
    shortName
  }
}
    `;
export type GqlUpdateEnterpriseMobileAppSettingsMutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>;

/**
 * __useUpdateEnterpriseMobileAppSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseMobileAppSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseMobileAppSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseMobileAppSettingsMutation, { data, loading, error }] = useUpdateEnterpriseMobileAppSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseMobileAppSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>(UpdateEnterpriseMobileAppSettingsDocument, options);
      }
export type UpdateEnterpriseMobileAppSettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseMobileAppSettingsMutation>;
export type UpdateEnterpriseMobileAppSettingsMutationResult = Apollo.MutationResult<GqlUpdateEnterpriseMobileAppSettingsMutation>;
export type UpdateEnterpriseMobileAppSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseMobileAppSettingsMutation, GqlUpdateEnterpriseMobileAppSettingsMutationVariables>;
export const EnterpriseLoyaltySettingsDocument = gql`
    query EnterpriseLoyaltySettings($enterpriseId: ID!) {
  enterpriseLoyaltySettings(id: $enterpriseId) {
    description
    displayName
    enterpriseId
    landingPageUrl
    loyaltyEnrollmentUrl
    name
    uniqueName
    dposLoyaltyIsoRegionCodes
    description
    displayName
    privacyPolicyUrl
    termsAndConditionsUrl
  }
}
    `;

/**
 * __useEnterpriseLoyaltySettingsQuery__
 *
 * To run a query within a React component, call `useEnterpriseLoyaltySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseLoyaltySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseLoyaltySettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseLoyaltySettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>(EnterpriseLoyaltySettingsDocument, options);
      }
export function useEnterpriseLoyaltySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>(EnterpriseLoyaltySettingsDocument, options);
        }
export type EnterpriseLoyaltySettingsQueryHookResult = ReturnType<typeof useEnterpriseLoyaltySettingsQuery>;
export type EnterpriseLoyaltySettingsLazyQueryHookResult = ReturnType<typeof useEnterpriseLoyaltySettingsLazyQuery>;
export type EnterpriseLoyaltySettingsQueryResult = Apollo.QueryResult<GqlEnterpriseLoyaltySettingsQuery, GqlEnterpriseLoyaltySettingsQueryVariables>;
export const EnterpriseMobileAppSettingsDocument = gql`
    query EnterpriseMobileAppSettings($enterpriseId: ID!) {
  enterpriseMobileAppSettings(enterpriseId: $enterpriseId) {
    androidAppIcon
    androidPackageName
    androidSplashBackgroundColor
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosSplashBackgroundColor
  }
}
    `;

/**
 * __useEnterpriseMobileAppSettingsQuery__
 *
 * To run a query within a React component, call `useEnterpriseMobileAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseMobileAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseMobileAppSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseMobileAppSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>(EnterpriseMobileAppSettingsDocument, options);
      }
export function useEnterpriseMobileAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>(EnterpriseMobileAppSettingsDocument, options);
        }
export type EnterpriseMobileAppSettingsQueryHookResult = ReturnType<typeof useEnterpriseMobileAppSettingsQuery>;
export type EnterpriseMobileAppSettingsLazyQueryHookResult = ReturnType<typeof useEnterpriseMobileAppSettingsLazyQuery>;
export type EnterpriseMobileAppSettingsQueryResult = Apollo.QueryResult<GqlEnterpriseMobileAppSettingsQuery, GqlEnterpriseMobileAppSettingsQueryVariables>;
export const AdminEnterpriseMobileAppSettingsDocument = gql`
    query AdminEnterpriseMobileAppSettings($enterpriseId: ID!) {
  enterpriseMobileAppSettings(enterpriseId: $enterpriseId) {
    androidAppIcon
    androidExistingVersion
    androidExistingVersionCode
    androidOrganizationName
    androidPackageName
    androidSplashBackgroundColor
    automaticScreenshotGeneration
    buildForIpad
    firebaseProjectId
    iosAppIcon
    iosAppStoreId
    iosBundleIdentifier
    iosExistingVersion
    iosSplashBackgroundColor
    iosTeamId
    iosTeamName
    name
    shortName
  }
}
    `;

/**
 * __useAdminEnterpriseMobileAppSettingsQuery__
 *
 * To run a query within a React component, call `useAdminEnterpriseMobileAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEnterpriseMobileAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEnterpriseMobileAppSettingsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useAdminEnterpriseMobileAppSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>(AdminEnterpriseMobileAppSettingsDocument, options);
      }
export function useAdminEnterpriseMobileAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>(AdminEnterpriseMobileAppSettingsDocument, options);
        }
export type AdminEnterpriseMobileAppSettingsQueryHookResult = ReturnType<typeof useAdminEnterpriseMobileAppSettingsQuery>;
export type AdminEnterpriseMobileAppSettingsLazyQueryHookResult = ReturnType<typeof useAdminEnterpriseMobileAppSettingsLazyQuery>;
export type AdminEnterpriseMobileAppSettingsQueryResult = Apollo.QueryResult<GqlAdminEnterpriseMobileAppSettingsQuery, GqlAdminEnterpriseMobileAppSettingsQueryVariables>;
export const GeolocateConsumerDocument = gql`
    query GeolocateConsumer {
  geolocate {
    ip
    hostname
    city
    region
    country
    loc
    org
    postal
    timezone
  }
}
    `;

/**
 * __useGeolocateConsumerQuery__
 *
 * To run a query within a React component, call `useGeolocateConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeolocateConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeolocateConsumerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeolocateConsumerQuery(baseOptions?: Apollo.QueryHookOptions<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>(GeolocateConsumerDocument, options);
      }
export function useGeolocateConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>(GeolocateConsumerDocument, options);
        }
export type GeolocateConsumerQueryHookResult = ReturnType<typeof useGeolocateConsumerQuery>;
export type GeolocateConsumerLazyQueryHookResult = ReturnType<typeof useGeolocateConsumerLazyQuery>;
export type GeolocateConsumerQueryResult = Apollo.QueryResult<GqlGeolocateConsumerQuery, GqlGeolocateConsumerQueryVariables>;
export const GenerateHypurTokenV2Document = gql`
    mutation GenerateHypurTokenV2($code: String!, $hostname: String, $state: String!) {
  generateHypurTokenV2(code: $code, hostname: $hostname, state: $state) {
    accessToken
    embedded
  }
}
    `;
export type GqlGenerateHypurTokenV2MutationFn = Apollo.MutationFunction<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>;

/**
 * __useGenerateHypurTokenV2Mutation__
 *
 * To run a mutation, you first call `useGenerateHypurTokenV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHypurTokenV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHypurTokenV2Mutation, { data, loading, error }] = useGenerateHypurTokenV2Mutation({
 *   variables: {
 *      code: // value for 'code'
 *      hostname: // value for 'hostname'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGenerateHypurTokenV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>(GenerateHypurTokenV2Document, options);
      }
export type GenerateHypurTokenV2MutationHookResult = ReturnType<typeof useGenerateHypurTokenV2Mutation>;
export type GenerateHypurTokenV2MutationResult = Apollo.MutationResult<GqlGenerateHypurTokenV2Mutation>;
export type GenerateHypurTokenV2MutationOptions = Apollo.BaseMutationOptions<GqlGenerateHypurTokenV2Mutation, GqlGenerateHypurTokenV2MutationVariables>;
export const CreateLibraryProductV2Document = gql`
    mutation CreateLibraryProductV2($libraryProduct: NewLibraryProduct!, $state: String!) {
  createLibraryProductV2(libraryProduct: $libraryProduct, state: $state) {
    id
  }
}
    `;
export type GqlCreateLibraryProductV2MutationFn = Apollo.MutationFunction<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>;

/**
 * __useCreateLibraryProductV2Mutation__
 *
 * To run a mutation, you first call `useCreateLibraryProductV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryProductV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryProductV2Mutation, { data, loading, error }] = useCreateLibraryProductV2Mutation({
 *   variables: {
 *      libraryProduct: // value for 'libraryProduct'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCreateLibraryProductV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>(CreateLibraryProductV2Document, options);
      }
export type CreateLibraryProductV2MutationHookResult = ReturnType<typeof useCreateLibraryProductV2Mutation>;
export type CreateLibraryProductV2MutationResult = Apollo.MutationResult<GqlCreateLibraryProductV2Mutation>;
export type CreateLibraryProductV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateLibraryProductV2Mutation, GqlCreateLibraryProductV2MutationVariables>;
export const CreateLibraryProductV3Document = gql`
    mutation CreateLibraryProductV3($libraryProduct: NewLibraryProductV2!, $state: String!) {
  createLibraryProductV3(libraryProduct: $libraryProduct, state: $state) {
    id
  }
}
    `;
export type GqlCreateLibraryProductV3MutationFn = Apollo.MutationFunction<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>;

/**
 * __useCreateLibraryProductV3Mutation__
 *
 * To run a mutation, you first call `useCreateLibraryProductV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryProductV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryProductV3Mutation, { data, loading, error }] = useCreateLibraryProductV3Mutation({
 *   variables: {
 *      libraryProduct: // value for 'libraryProduct'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCreateLibraryProductV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>(CreateLibraryProductV3Document, options);
      }
export type CreateLibraryProductV3MutationHookResult = ReturnType<typeof useCreateLibraryProductV3Mutation>;
export type CreateLibraryProductV3MutationResult = Apollo.MutationResult<GqlCreateLibraryProductV3Mutation>;
export type CreateLibraryProductV3MutationOptions = Apollo.BaseMutationOptions<GqlCreateLibraryProductV3Mutation, GqlCreateLibraryProductV3MutationVariables>;
export const MatchLibraryProductsV2Document = gql`
    query MatchLibraryProductsV2($limit: Int, $name: String!, $state: String!, $category: String, $subcategory: String, $brandIds: [String], $brand: String, $scopes: [String]) {
  matchLibraryProductsV2(
    limit: $limit
    name: $name
    state: $state
    category: $category
    subcategory: $subcategory
    brandIds: $brandIds
    brand: $brand
    scopes: $scopes
  ) {
    id
    brand {
      id
      name
      imageUrl
    }
    category
    cbdContent {
      unit
      range
    }
    image
    images {
      _id
      url
      active
      origin
    }
    name
    price
    productTemplate
    stockImage
    strainType
    subcategory
    thcContent {
      unit
      range
    }
  }
}
    `;

/**
 * __useMatchLibraryProductsV2Query__
 *
 * To run a query within a React component, call `useMatchLibraryProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useMatchLibraryProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchLibraryProductsV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      brandIds: // value for 'brandIds'
 *      brand: // value for 'brand'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useMatchLibraryProductsV2Query(baseOptions: Apollo.QueryHookOptions<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>(MatchLibraryProductsV2Document, options);
      }
export function useMatchLibraryProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>(MatchLibraryProductsV2Document, options);
        }
export type MatchLibraryProductsV2QueryHookResult = ReturnType<typeof useMatchLibraryProductsV2Query>;
export type MatchLibraryProductsV2LazyQueryHookResult = ReturnType<typeof useMatchLibraryProductsV2LazyQuery>;
export type MatchLibraryProductsV2QueryResult = Apollo.QueryResult<GqlMatchLibraryProductsV2Query, GqlMatchLibraryProductsV2QueryVariables>;
export const MatchLibraryProductsDocument = gql`
    query MatchLibraryProducts($limit: Int, $name: String!, $state: String!, $category: String, $subcategory: String, $brandIds: [String], $brand: String, $productTemplate: Boolean) {
  matchLibraryProducts(
    limit: $limit
    name: $name
    state: $state
    category: $category
    subcategory: $subcategory
    brandIds: $brandIds
    brand: $brand
    productTemplate: $productTemplate
  ) {
    id
    brand {
      id
      name
    }
    category
    cbdContent {
      unit
      range
    }
    image
    name
    price
    strainType
    subcategory
    thcContent {
      unit
      range
    }
  }
}
    `;

/**
 * __useMatchLibraryProductsQuery__
 *
 * To run a query within a React component, call `useMatchLibraryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchLibraryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchLibraryProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      brandIds: // value for 'brandIds'
 *      brand: // value for 'brand'
 *      productTemplate: // value for 'productTemplate'
 *   },
 * });
 */
export function useMatchLibraryProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>(MatchLibraryProductsDocument, options);
      }
export function useMatchLibraryProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>(MatchLibraryProductsDocument, options);
        }
export type MatchLibraryProductsQueryHookResult = ReturnType<typeof useMatchLibraryProductsQuery>;
export type MatchLibraryProductsLazyQueryHookResult = ReturnType<typeof useMatchLibraryProductsLazyQuery>;
export type MatchLibraryProductsQueryResult = Apollo.QueryResult<GqlMatchLibraryProductsQuery, GqlMatchLibraryProductsQueryVariables>;
export const AddressResidentialCheckDocument = gql`
    query AddressResidentialCheck($input: addressResidentialCheckInput!) {
  addressResidentialCheck(input: $input) {
    isValid
  }
}
    `;

/**
 * __useAddressResidentialCheckQuery__
 *
 * To run a query within a React component, call `useAddressResidentialCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressResidentialCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressResidentialCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressResidentialCheckQuery(baseOptions: Apollo.QueryHookOptions<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>(AddressResidentialCheckDocument, options);
      }
export function useAddressResidentialCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>(AddressResidentialCheckDocument, options);
        }
export type AddressResidentialCheckQueryHookResult = ReturnType<typeof useAddressResidentialCheckQuery>;
export type AddressResidentialCheckLazyQueryHookResult = ReturnType<typeof useAddressResidentialCheckLazyQuery>;
export type AddressResidentialCheckQueryResult = Apollo.QueryResult<GqlAddressResidentialCheckQuery, GqlAddressResidentialCheckQueryVariables>;
export const HealthCheckDocument = gql`
    query HealthCheck {
  healthCheck {
    status
  }
}
    `;

/**
 * __useHealthCheckQuery__
 *
 * To run a query within a React component, call `useHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>(HealthCheckDocument, options);
      }
export function useHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>(HealthCheckDocument, options);
        }
export type HealthCheckQueryHookResult = ReturnType<typeof useHealthCheckQuery>;
export type HealthCheckLazyQueryHookResult = ReturnType<typeof useHealthCheckLazyQuery>;
export type HealthCheckQueryResult = Apollo.QueryResult<GqlHealthCheckQuery, GqlHealthCheckQueryVariables>;
export const ResetPasswordV2Document = gql`
    mutation ResetPasswordV2($input: resetPasswordInput!) {
  resetPasswordV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlResetPasswordV2MutationFn = Apollo.MutationFunction<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>;

/**
 * __useResetPasswordV2Mutation__
 *
 * To run a mutation, you first call `useResetPasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordV2Mutation, { data, loading, error }] = useResetPasswordV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>(ResetPasswordV2Document, options);
      }
export type ResetPasswordV2MutationHookResult = ReturnType<typeof useResetPasswordV2Mutation>;
export type ResetPasswordV2MutationResult = Apollo.MutationResult<GqlResetPasswordV2Mutation>;
export type ResetPasswordV2MutationOptions = Apollo.BaseMutationOptions<GqlResetPasswordV2Mutation, GqlResetPasswordV2MutationVariables>;
export const SendBrandUserPasswordResetEmailDocument = gql`
    mutation SendBrandUserPasswordResetEmail($email: String!) {
  sendBrandUserPasswordResetEmail(email: $email) {
    message
    success
  }
}
    `;
export type GqlSendBrandUserPasswordResetEmailMutationFn = Apollo.MutationFunction<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>;

/**
 * __useSendBrandUserPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendBrandUserPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBrandUserPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBrandUserPasswordResetEmailMutation, { data, loading, error }] = useSendBrandUserPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendBrandUserPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>(SendBrandUserPasswordResetEmailDocument, options);
      }
export type SendBrandUserPasswordResetEmailMutationHookResult = ReturnType<typeof useSendBrandUserPasswordResetEmailMutation>;
export type SendBrandUserPasswordResetEmailMutationResult = Apollo.MutationResult<GqlSendBrandUserPasswordResetEmailMutation>;
export type SendBrandUserPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<GqlSendBrandUserPasswordResetEmailMutation, GqlSendBrandUserPasswordResetEmailMutationVariables>;
export const SendCompleteAccountSetupEmailDocument = gql`
    mutation SendCompleteAccountSetupEmail($dispensaryId: String!, $email: String!, $orderId: String) {
  sendCompleteAccountSetupEmail(
    dispensaryId: $dispensaryId
    email: $email
    orderId: $orderId
  ) {
    message
    success
  }
}
    `;
export type GqlSendCompleteAccountSetupEmailMutationFn = Apollo.MutationFunction<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>;

/**
 * __useSendCompleteAccountSetupEmailMutation__
 *
 * To run a mutation, you first call `useSendCompleteAccountSetupEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCompleteAccountSetupEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCompleteAccountSetupEmailMutation, { data, loading, error }] = useSendCompleteAccountSetupEmailMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      email: // value for 'email'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendCompleteAccountSetupEmailMutation(baseOptions?: Apollo.MutationHookOptions<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>(SendCompleteAccountSetupEmailDocument, options);
      }
export type SendCompleteAccountSetupEmailMutationHookResult = ReturnType<typeof useSendCompleteAccountSetupEmailMutation>;
export type SendCompleteAccountSetupEmailMutationResult = Apollo.MutationResult<GqlSendCompleteAccountSetupEmailMutation>;
export type SendCompleteAccountSetupEmailMutationOptions = Apollo.BaseMutationOptions<GqlSendCompleteAccountSetupEmailMutation, GqlSendCompleteAccountSetupEmailMutationVariables>;
export const SendPasswordResetEmailV2Document = gql`
    mutation SendPasswordResetEmailV2($email: String!, $dispensaryId: String) {
  sendPasswordResetEmailV2(email: $email, dispensaryId: $dispensaryId) {
    message
    success
  }
}
    `;
export type GqlSendPasswordResetEmailV2MutationFn = Apollo.MutationFunction<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>;

/**
 * __useSendPasswordResetEmailV2Mutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailV2Mutation, { data, loading, error }] = useSendPasswordResetEmailV2Mutation({
 *   variables: {
 *      email: // value for 'email'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useSendPasswordResetEmailV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>(SendPasswordResetEmailV2Document, options);
      }
export type SendPasswordResetEmailV2MutationHookResult = ReturnType<typeof useSendPasswordResetEmailV2Mutation>;
export type SendPasswordResetEmailV2MutationResult = Apollo.MutationResult<GqlSendPasswordResetEmailV2Mutation>;
export type SendPasswordResetEmailV2MutationOptions = Apollo.BaseMutationOptions<GqlSendPasswordResetEmailV2Mutation, GqlSendPasswordResetEmailV2MutationVariables>;
export const SetPasswordV2Document = gql`
    mutation SetPasswordV2($input: setPasswordInput!) {
  setPasswordV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlSetPasswordV2MutationFn = Apollo.MutationFunction<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>;

/**
 * __useSetPasswordV2Mutation__
 *
 * To run a mutation, you first call `useSetPasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordV2Mutation, { data, loading, error }] = useSetPasswordV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>(SetPasswordV2Document, options);
      }
export type SetPasswordV2MutationHookResult = ReturnType<typeof useSetPasswordV2Mutation>;
export type SetPasswordV2MutationResult = Apollo.MutationResult<GqlSetPasswordV2Mutation>;
export type SetPasswordV2MutationOptions = Apollo.BaseMutationOptions<GqlSetPasswordV2Mutation, GqlSetPasswordV2MutationVariables>;
export const UpdatePasswordV2Document = gql`
    mutation UpdatePasswordV2($oldPassword: String!, $newPassword: String!) {
  updatePasswordV2(oldPassword: $oldPassword, newPassword: $newPassword) {
    accessToken
  }
}
    `;
export type GqlUpdatePasswordV2MutationFn = Apollo.MutationFunction<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>;

/**
 * __useUpdatePasswordV2Mutation__
 *
 * To run a mutation, you first call `useUpdatePasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordV2Mutation, { data, loading, error }] = useUpdatePasswordV2Mutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>(UpdatePasswordV2Document, options);
      }
export type UpdatePasswordV2MutationHookResult = ReturnType<typeof useUpdatePasswordV2Mutation>;
export type UpdatePasswordV2MutationResult = Apollo.MutationResult<GqlUpdatePasswordV2Mutation>;
export type UpdatePasswordV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdatePasswordV2Mutation, GqlUpdatePasswordV2MutationVariables>;
export const GetPaymentsCheckoutCredentialsDocument = gql`
    query GetPaymentsCheckoutCredentials($adapter: String!, $dispensaryId: String!) {
  getPaymentsCheckoutCredentials(adapter: $adapter, dispensaryId: $dispensaryId) {
    ... on ChaseHostedProfileCredentials {
      uID
    }
    ... on MonerisHTProfileCredentials {
      profileId
    }
  }
}
    `;

/**
 * __useGetPaymentsCheckoutCredentialsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsCheckoutCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsCheckoutCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsCheckoutCredentialsQuery({
 *   variables: {
 *      adapter: // value for 'adapter'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetPaymentsCheckoutCredentialsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>(GetPaymentsCheckoutCredentialsDocument, options);
      }
export function useGetPaymentsCheckoutCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>(GetPaymentsCheckoutCredentialsDocument, options);
        }
export type GetPaymentsCheckoutCredentialsQueryHookResult = ReturnType<typeof useGetPaymentsCheckoutCredentialsQuery>;
export type GetPaymentsCheckoutCredentialsLazyQueryHookResult = ReturnType<typeof useGetPaymentsCheckoutCredentialsLazyQuery>;
export type GetPaymentsCheckoutCredentialsQueryResult = Apollo.QueryResult<GqlGetPaymentsCheckoutCredentialsQuery, GqlGetPaymentsCheckoutCredentialsQueryVariables>;
export const GetMonerisTokenizationProfileDocument = gql`
    query GetMonerisTokenizationProfile($dispensaryId: String!) {
  getMonerisTokenizationProfile(dispensaryId: $dispensaryId) {
    profileId
  }
}
    `;

/**
 * __useGetMonerisTokenizationProfileQuery__
 *
 * To run a query within a React component, call `useGetMonerisTokenizationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonerisTokenizationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonerisTokenizationProfileQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetMonerisTokenizationProfileQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>(GetMonerisTokenizationProfileDocument, options);
      }
export function useGetMonerisTokenizationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>(GetMonerisTokenizationProfileDocument, options);
        }
export type GetMonerisTokenizationProfileQueryHookResult = ReturnType<typeof useGetMonerisTokenizationProfileQuery>;
export type GetMonerisTokenizationProfileLazyQueryHookResult = ReturnType<typeof useGetMonerisTokenizationProfileLazyQuery>;
export type GetMonerisTokenizationProfileQueryResult = Apollo.QueryResult<GqlGetMonerisTokenizationProfileQuery, GqlGetMonerisTokenizationProfileQueryVariables>;
export const GetCustomerCommunicationSettingsDocument = gql`
    query GetCustomerCommunicationSettings($dispensaryId: String!, $userId: String!) {
  getCustomerCommunicationSettings(dispensaryId: $dispensaryId, userId: $userId) {
    optInEmail
    optInSMS
    optInPush
  }
}
    `;

/**
 * __useGetCustomerCommunicationSettingsQuery__
 *
 * To run a query within a React component, call `useGetCustomerCommunicationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCommunicationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCommunicationSettingsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCustomerCommunicationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>(GetCustomerCommunicationSettingsDocument, options);
      }
export function useGetCustomerCommunicationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>(GetCustomerCommunicationSettingsDocument, options);
        }
export type GetCustomerCommunicationSettingsQueryHookResult = ReturnType<typeof useGetCustomerCommunicationSettingsQuery>;
export type GetCustomerCommunicationSettingsLazyQueryHookResult = ReturnType<typeof useGetCustomerCommunicationSettingsLazyQuery>;
export type GetCustomerCommunicationSettingsQueryResult = Apollo.QueryResult<GqlGetCustomerCommunicationSettingsQuery, GqlGetCustomerCommunicationSettingsQueryVariables>;
export const UpdateCustomerCommunicationSettingsDocument = gql`
    mutation UpdateCustomerCommunicationSettings($dispensaryId: String!, $userId: String!, $optInEmail: Boolean, $optInSMS: Boolean, $optInPush: Boolean) {
  updateCustomerCommunicationSettings(
    dispensaryId: $dispensaryId
    userId: $userId
    optInEmail: $optInEmail
    optInSMS: $optInSMS
    optInPush: $optInPush
  ) {
    success
  }
}
    `;
export type GqlUpdateCustomerCommunicationSettingsMutationFn = Apollo.MutationFunction<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>;

/**
 * __useUpdateCustomerCommunicationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerCommunicationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerCommunicationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerCommunicationSettingsMutation, { data, loading, error }] = useUpdateCustomerCommunicationSettingsMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      optInEmail: // value for 'optInEmail'
 *      optInSMS: // value for 'optInSMS'
 *      optInPush: // value for 'optInPush'
 *   },
 * });
 */
export function useUpdateCustomerCommunicationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>(UpdateCustomerCommunicationSettingsDocument, options);
      }
export type UpdateCustomerCommunicationSettingsMutationHookResult = ReturnType<typeof useUpdateCustomerCommunicationSettingsMutation>;
export type UpdateCustomerCommunicationSettingsMutationResult = Apollo.MutationResult<GqlUpdateCustomerCommunicationSettingsMutation>;
export type UpdateCustomerCommunicationSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCustomerCommunicationSettingsMutation, GqlUpdateCustomerCommunicationSettingsMutationVariables>;
export const ArchivedProductLookupDocument = gql`
    query ArchivedProductLookup($cname: String!, $dispensaryId: String!) {
  archivedProductLookup(cname: $cname, dispensaryId: $dispensaryId) {
    ...consumerBaseProductFragment
    brand {
      id
      _id
      description
      imageUrl
      name
    }
    effects
    description
    descriptionHtml
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useArchivedProductLookupQuery__
 *
 * To run a query within a React component, call `useArchivedProductLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedProductLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedProductLookupQuery({
 *   variables: {
 *      cname: // value for 'cname'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useArchivedProductLookupQuery(baseOptions: Apollo.QueryHookOptions<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>(ArchivedProductLookupDocument, options);
      }
export function useArchivedProductLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>(ArchivedProductLookupDocument, options);
        }
export type ArchivedProductLookupQueryHookResult = ReturnType<typeof useArchivedProductLookupQuery>;
export type ArchivedProductLookupLazyQueryHookResult = ReturnType<typeof useArchivedProductLookupLazyQuery>;
export type ArchivedProductLookupQueryResult = Apollo.QueryResult<GqlArchivedProductLookupQuery, GqlArchivedProductLookupQueryVariables>;
export const FilteredProductsDocument = gql`
    query FilteredProducts($productsFilter: productsFilterInput!, $useCache: Boolean, $page: Int, $perPage: Int, $includeEnterpriseSpecials: Boolean = false) {
  filteredProducts(
    filter: $productsFilter
    useCache: $useCache
    page: $page
    perPage: $perPage
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    products {
      ...consumerBaseProductFragment
      brand {
        id
        _id
        description
        imageUrl
        name
      }
      effects
      cannabinoidsV2 {
        value
        unit
        cannabinoid {
          name
        }
      }
      provider
    }
    queryInfo {
      totalCount
      totalPages
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useFilteredProductsQuery__
 *
 * To run a query within a React component, call `useFilteredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredProductsQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      useCache: // value for 'useCache'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useFilteredProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>(FilteredProductsDocument, options);
      }
export function useFilteredProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>(FilteredProductsDocument, options);
        }
export type FilteredProductsQueryHookResult = ReturnType<typeof useFilteredProductsQuery>;
export type FilteredProductsLazyQueryHookResult = ReturnType<typeof useFilteredProductsLazyQuery>;
export type FilteredProductsQueryResult = Apollo.QueryResult<GqlFilteredProductsQuery, GqlFilteredProductsQueryVariables>;
export const IndividualFilteredProductDocument = gql`
    query IndividualFilteredProduct($productsFilter: productsFilterInput!, $useCache: Boolean, $includeEnterpriseSpecials: Boolean = false) {
  filteredProducts(
    filter: $productsFilter
    useCache: $useCache
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    products {
      ...consumerBaseProductFragment
      brand {
        id
        _id
        description
        imageUrl
        name
      }
      terpenes {
        id
        libraryTerpene {
          aromas
          description
          effects
          name
        }
        terpeneId
        unit
        unitSymbol
        value
      }
      cannabinoidsV2 {
        value
        unit
        cannabinoid {
          name
          description
        }
      }
      effects
      description
      descriptionHtml
      outletCollectionInfo {
        timerMessage
        endDate
      }
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useIndividualFilteredProductQuery__
 *
 * To run a query within a React component, call `useIndividualFilteredProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualFilteredProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualFilteredProductQuery({
 *   variables: {
 *      productsFilter: // value for 'productsFilter'
 *      useCache: // value for 'useCache'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useIndividualFilteredProductQuery(baseOptions: Apollo.QueryHookOptions<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>(IndividualFilteredProductDocument, options);
      }
export function useIndividualFilteredProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>(IndividualFilteredProductDocument, options);
        }
export type IndividualFilteredProductQueryHookResult = ReturnType<typeof useIndividualFilteredProductQuery>;
export type IndividualFilteredProductLazyQueryHookResult = ReturnType<typeof useIndividualFilteredProductLazyQuery>;
export type IndividualFilteredProductQueryResult = Apollo.QueryResult<GqlIndividualFilteredProductQuery, GqlIndividualFilteredProductQueryVariables>;
export const CreateRedemptionDocument = gql`
    mutation CreateRedemption($code: String!, $receiverUserId: String!) {
  createRedemption(code: $code, receiverUserId: $receiverUserId) {
    id
    code
    receiverUserId
    lspName
    lspId
    status
  }
}
    `;
export type GqlCreateRedemptionMutationFn = Apollo.MutationFunction<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>;

/**
 * __useCreateRedemptionMutation__
 *
 * To run a mutation, you first call `useCreateRedemptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRedemptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRedemptionMutation, { data, loading, error }] = useCreateRedemptionMutation({
 *   variables: {
 *      code: // value for 'code'
 *      receiverUserId: // value for 'receiverUserId'
 *   },
 * });
 */
export function useCreateRedemptionMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>(CreateRedemptionDocument, options);
      }
export type CreateRedemptionMutationHookResult = ReturnType<typeof useCreateRedemptionMutation>;
export type CreateRedemptionMutationResult = Apollo.MutationResult<GqlCreateRedemptionMutation>;
export type CreateRedemptionMutationOptions = Apollo.BaseMutationOptions<GqlCreateRedemptionMutation, GqlCreateRedemptionMutationVariables>;
export const FindOrCreateReferralCodeDocument = gql`
    mutation FindOrCreateReferralCode($lspName: String!, $senderUserId: String, $dispensaryId: String!, $code: String, $posUniqueId: String) {
  findOrCreateReferralCode(
    lspName: $lspName
    senderUserId: $senderUserId
    dispensaryId: $dispensaryId
    code: $code
    posUniqueId: $posUniqueId
  ) {
    code
    id
    lspName
    senderEcommId
    senderPosUniqueId
    senderPoints
    receiverPoints
    learnMoreUrl
    referralUrl
  }
}
    `;
export type GqlFindOrCreateReferralCodeMutationFn = Apollo.MutationFunction<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>;

/**
 * __useFindOrCreateReferralCodeMutation__
 *
 * To run a mutation, you first call `useFindOrCreateReferralCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateReferralCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateReferralCodeMutation, { data, loading, error }] = useFindOrCreateReferralCodeMutation({
 *   variables: {
 *      lspName: // value for 'lspName'
 *      senderUserId: // value for 'senderUserId'
 *      dispensaryId: // value for 'dispensaryId'
 *      code: // value for 'code'
 *      posUniqueId: // value for 'posUniqueId'
 *   },
 * });
 */
export function useFindOrCreateReferralCodeMutation(baseOptions?: Apollo.MutationHookOptions<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>(FindOrCreateReferralCodeDocument, options);
      }
export type FindOrCreateReferralCodeMutationHookResult = ReturnType<typeof useFindOrCreateReferralCodeMutation>;
export type FindOrCreateReferralCodeMutationResult = Apollo.MutationResult<GqlFindOrCreateReferralCodeMutation>;
export type FindOrCreateReferralCodeMutationOptions = Apollo.BaseMutationOptions<GqlFindOrCreateReferralCodeMutation, GqlFindOrCreateReferralCodeMutationVariables>;
export const CreateAlpineUserV2Document = gql`
    mutation CreateAlpineUserV2($firstName: String, $lastName: String, $address: String, $email: String, $program: String!, $dispensaryId: String!, $favoriteStore: String!, $phoneNumber: String!, $acceptedTerms: Boolean!) {
  createAlpineUserV2(
    firstName: $firstName
    lastName: $lastName
    address: $address
    email: $email
    program: $program
    dispensaryId: $dispensaryId
    favoriteStore: $favoriteStore
    phoneNumber: $phoneNumber
    acceptedTerms: $acceptedTerms
  ) {
    success
    wallet {
      balance
      rewardBrand
      rewards {
        id
        copy
        available
        operator
        cost
        costV2
        value
        rewardType
      }
      userHasWallet
      auth {
        pinConfirmed
        incorrectPinProvided
        authTextMessageSent
      }
    }
  }
}
    `;
export type GqlCreateAlpineUserV2MutationFn = Apollo.MutationFunction<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>;

/**
 * __useCreateAlpineUserV2Mutation__
 *
 * To run a mutation, you first call `useCreateAlpineUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlpineUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlpineUserV2Mutation, { data, loading, error }] = useCreateAlpineUserV2Mutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      program: // value for 'program'
 *      dispensaryId: // value for 'dispensaryId'
 *      favoriteStore: // value for 'favoriteStore'
 *      phoneNumber: // value for 'phoneNumber'
 *      acceptedTerms: // value for 'acceptedTerms'
 *   },
 * });
 */
export function useCreateAlpineUserV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>(CreateAlpineUserV2Document, options);
      }
export type CreateAlpineUserV2MutationHookResult = ReturnType<typeof useCreateAlpineUserV2Mutation>;
export type CreateAlpineUserV2MutationResult = Apollo.MutationResult<GqlCreateAlpineUserV2Mutation>;
export type CreateAlpineUserV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateAlpineUserV2Mutation, GqlCreateAlpineUserV2MutationVariables>;
export const CreateAlpineUserDocument = gql`
    mutation CreateAlpineUser($firstName: String, $lastName: String, $address: String, $email: String, $program: String!, $dispensaryId: String!, $favoriteStore: String!, $phoneNumber: String!, $acceptedTerms: Boolean!) {
  createAlpineUser(
    firstName: $firstName
    lastName: $lastName
    address: $address
    email: $email
    program: $program
    dispensaryId: $dispensaryId
    favoriteStore: $favoriteStore
    phoneNumber: $phoneNumber
    acceptedTerms: $acceptedTerms
  ) {
    success
    wallet {
      balance
      rewardBrand
      rewards {
        id
        copy
        available
        operator
        cost
        costV2
        value
        rewardType
      }
      userHasWallet
      auth {
        pinConfirmed
        incorrectPinProvided
        authTextMessageSent
      }
    }
  }
}
    `;
export type GqlCreateAlpineUserMutationFn = Apollo.MutationFunction<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>;

/**
 * __useCreateAlpineUserMutation__
 *
 * To run a mutation, you first call `useCreateAlpineUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlpineUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlpineUserMutation, { data, loading, error }] = useCreateAlpineUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      program: // value for 'program'
 *      dispensaryId: // value for 'dispensaryId'
 *      favoriteStore: // value for 'favoriteStore'
 *      phoneNumber: // value for 'phoneNumber'
 *      acceptedTerms: // value for 'acceptedTerms'
 *   },
 * });
 */
export function useCreateAlpineUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>(CreateAlpineUserDocument, options);
      }
export type CreateAlpineUserMutationHookResult = ReturnType<typeof useCreateAlpineUserMutation>;
export type CreateAlpineUserMutationResult = Apollo.MutationResult<GqlCreateAlpineUserMutation>;
export type CreateAlpineUserMutationOptions = Apollo.BaseMutationOptions<GqlCreateAlpineUserMutation, GqlCreateAlpineUserMutationVariables>;
export const CreateDutchiePosLoyaltyMemberV2Document = gql`
    mutation CreateDutchiePosLoyaltyMemberV2($dispensaryId: String!, $userId: String!, $isLoyaltyMember: Boolean, $senderUniqueId: String) {
  createDutchiePosLoyaltyMemberV2(
    dispensaryId: $dispensaryId
    userId: $userId
    isLoyaltyMember: $isLoyaltyMember
    senderUniqueId: $senderUniqueId
  ) {
    posCustomerId
    isLoyaltyMember
  }
}
    `;
export type GqlCreateDutchiePosLoyaltyMemberV2MutationFn = Apollo.MutationFunction<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>;

/**
 * __useCreateDutchiePosLoyaltyMemberV2Mutation__
 *
 * To run a mutation, you first call `useCreateDutchiePosLoyaltyMemberV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDutchiePosLoyaltyMemberV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDutchiePosLoyaltyMemberV2Mutation, { data, loading, error }] = useCreateDutchiePosLoyaltyMemberV2Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      isLoyaltyMember: // value for 'isLoyaltyMember'
 *      senderUniqueId: // value for 'senderUniqueId'
 *   },
 * });
 */
export function useCreateDutchiePosLoyaltyMemberV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>(CreateDutchiePosLoyaltyMemberV2Document, options);
      }
export type CreateDutchiePosLoyaltyMemberV2MutationHookResult = ReturnType<typeof useCreateDutchiePosLoyaltyMemberV2Mutation>;
export type CreateDutchiePosLoyaltyMemberV2MutationResult = Apollo.MutationResult<GqlCreateDutchiePosLoyaltyMemberV2Mutation>;
export type CreateDutchiePosLoyaltyMemberV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateDutchiePosLoyaltyMemberV2Mutation, GqlCreateDutchiePosLoyaltyMemberV2MutationVariables>;
export const CreateDutchiePosLoyaltyMemberDocument = gql`
    mutation CreateDutchiePosLoyaltyMember($dispensaryId: String!, $userId: String!, $senderUniqueId: String) {
  createDutchiePosLoyaltyMember(
    dispensaryId: $dispensaryId
    userId: $userId
    senderUniqueId: $senderUniqueId
  ) {
    success
  }
}
    `;
export type GqlCreateDutchiePosLoyaltyMemberMutationFn = Apollo.MutationFunction<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useCreateDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useCreateDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      senderUniqueId: // value for 'senderUniqueId'
 *   },
 * });
 */
export function useCreateDutchiePosLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>(CreateDutchiePosLoyaltyMemberDocument, options);
      }
export type CreateDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateDutchiePosLoyaltyMemberMutation>;
export type CreateDutchiePosLoyaltyMemberMutationResult = Apollo.MutationResult<GqlCreateDutchiePosLoyaltyMemberMutation>;
export type CreateDutchiePosLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<GqlCreateDutchiePosLoyaltyMemberMutation, GqlCreateDutchiePosLoyaltyMemberMutationVariables>;
export const CreateEnterpriseDutchiePosLoyaltyMemberV2Document = gql`
    mutation CreateEnterpriseDutchiePosLoyaltyMemberV2($enterpriseId: String!, $userId: String!, $isoRegionCode: String!, $isLoyaltyMember: Boolean) {
  createEnterpriseDutchiePosLoyaltyMemberV2(
    enterpriseId: $enterpriseId
    userId: $userId
    isoRegionCode: $isoRegionCode
    isLoyaltyMember: $isLoyaltyMember
  ) {
    posCustomerId
    isLoyaltyMember
  }
}
    `;
export type GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationFn = Apollo.MutationFunction<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>;

/**
 * __useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseDutchiePosLoyaltyMemberV2Mutation, { data, loading, error }] = useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      userId: // value for 'userId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *      isLoyaltyMember: // value for 'isLoyaltyMember'
 *   },
 * });
 */
export function useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>(CreateEnterpriseDutchiePosLoyaltyMemberV2Document, options);
      }
export type CreateEnterpriseDutchiePosLoyaltyMemberV2MutationHookResult = ReturnType<typeof useCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberV2MutationResult = Apollo.MutationResult<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberV2Mutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberV2MutationVariables>;
export const CreateEnterpriseDutchiePosLoyaltyMemberDocument = gql`
    mutation CreateEnterpriseDutchiePosLoyaltyMember($enterpriseId: String!, $userId: String!, $isoRegionCode: String!, $isLoyaltyMember: Boolean) {
  createEnterpriseDutchiePosLoyaltyMember(
    enterpriseId: $enterpriseId
    userId: $userId
    isoRegionCode: $isoRegionCode
    isLoyaltyMember: $isLoyaltyMember
  ) {
    success
    message
  }
}
    `;
export type GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationFn = Apollo.MutationFunction<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useCreateEnterpriseDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useCreateEnterpriseDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      userId: // value for 'userId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *      isLoyaltyMember: // value for 'isLoyaltyMember'
 *   },
 * });
 */
export function useCreateEnterpriseDutchiePosLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>(CreateEnterpriseDutchiePosLoyaltyMemberDocument, options);
      }
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateEnterpriseDutchiePosLoyaltyMemberMutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationResult = Apollo.MutationResult<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation>;
export type CreateEnterpriseDutchiePosLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseDutchiePosLoyaltyMemberMutation, GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationVariables>;
export const CreateSpringbigUserDocument = gql`
    mutation CreateSpringbigUser($dispensaryId: String!, $userId: String!) {
  createSpringbigUser(dispensaryId: $dispensaryId, userId: $userId) {
    success
  }
}
    `;
export type GqlCreateSpringbigUserMutationFn = Apollo.MutationFunction<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>;

/**
 * __useCreateSpringbigUserMutation__
 *
 * To run a mutation, you first call `useCreateSpringbigUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpringbigUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpringbigUserMutation, { data, loading, error }] = useCreateSpringbigUserMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSpringbigUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>(CreateSpringbigUserDocument, options);
      }
export type CreateSpringbigUserMutationHookResult = ReturnType<typeof useCreateSpringbigUserMutation>;
export type CreateSpringbigUserMutationResult = Apollo.MutationResult<GqlCreateSpringbigUserMutation>;
export type CreateSpringbigUserMutationOptions = Apollo.BaseMutationOptions<GqlCreateSpringbigUserMutation, GqlCreateSpringbigUserMutationVariables>;
export const UpdateDutchiePosLoyaltyMemberDocument = gql`
    mutation UpdateDutchiePosLoyaltyMember($dispensaryId: String!, $userId: String!, $phone: String!, $lastAndroidLoginUtc: String, $lastIosLoginUtc: String, $senderUniqueId: String) {
  updateDutchiePosLoyaltyMember(
    dispensaryId: $dispensaryId
    userId: $userId
    phone: $phone
    lastAndroidLoginUtc: $lastAndroidLoginUtc
    lastIosLoginUtc: $lastIosLoginUtc
    senderUniqueId: $senderUniqueId
  ) {
    success
  }
}
    `;
export type GqlUpdateDutchiePosLoyaltyMemberMutationFn = Apollo.MutationFunction<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>;

/**
 * __useUpdateDutchiePosLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useUpdateDutchiePosLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDutchiePosLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDutchiePosLoyaltyMemberMutation, { data, loading, error }] = useUpdateDutchiePosLoyaltyMemberMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userId: // value for 'userId'
 *      phone: // value for 'phone'
 *      lastAndroidLoginUtc: // value for 'lastAndroidLoginUtc'
 *      lastIosLoginUtc: // value for 'lastIosLoginUtc'
 *      senderUniqueId: // value for 'senderUniqueId'
 *   },
 * });
 */
export function useUpdateDutchiePosLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>(UpdateDutchiePosLoyaltyMemberDocument, options);
      }
export type UpdateDutchiePosLoyaltyMemberMutationHookResult = ReturnType<typeof useUpdateDutchiePosLoyaltyMemberMutation>;
export type UpdateDutchiePosLoyaltyMemberMutationResult = Apollo.MutationResult<GqlUpdateDutchiePosLoyaltyMemberMutation>;
export type UpdateDutchiePosLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<GqlUpdateDutchiePosLoyaltyMemberMutation, GqlUpdateDutchiePosLoyaltyMemberMutationVariables>;
export const GetDutchiePosLoyaltyConfigDocument = gql`
    query GetDutchiePosLoyaltyConfig($dispensaryId: String, $enterpriseId: String, $isoRegionCode: String) {
  getDutchiePosLoyaltyConfig(
    dispensaryId: $dispensaryId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
  ) {
    loyaltyRequireOptIn
    isEnabled
    loyaltyDaysToExpiration
    onlineName
    onlineDescription
    tierEarningBasis
    redemptionType
    mode
    tiers {
      id
      name
      threshold
      badgeColor
    }
    referralConfig {
      isEnabled
      learnMoreUrl
      senderReward
      receiverReward
      minimumPurchaseAmount
    }
    dispensaryId
  }
}
    `;

/**
 * __useGetDutchiePosLoyaltyConfigQuery__
 *
 * To run a query within a React component, call `useGetDutchiePosLoyaltyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDutchiePosLoyaltyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDutchiePosLoyaltyConfigQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *   },
 * });
 */
export function useGetDutchiePosLoyaltyConfigQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>(GetDutchiePosLoyaltyConfigDocument, options);
      }
export function useGetDutchiePosLoyaltyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>(GetDutchiePosLoyaltyConfigDocument, options);
        }
export type GetDutchiePosLoyaltyConfigQueryHookResult = ReturnType<typeof useGetDutchiePosLoyaltyConfigQuery>;
export type GetDutchiePosLoyaltyConfigLazyQueryHookResult = ReturnType<typeof useGetDutchiePosLoyaltyConfigLazyQuery>;
export type GetDutchiePosLoyaltyConfigQueryResult = Apollo.QueryResult<GqlGetDutchiePosLoyaltyConfigQuery, GqlGetDutchiePosLoyaltyConfigQueryVariables>;
export const GetLoyaltyPassUrlDocument = gql`
    query GetLoyaltyPassUrl($dispensaryId: String!) {
  getLoyaltyPassUrl(dispensaryId: $dispensaryId) {
    url
    shortUrl
  }
}
    `;

/**
 * __useGetLoyaltyPassUrlQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyPassUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyPassUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyPassUrlQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetLoyaltyPassUrlQuery(baseOptions: Apollo.QueryHookOptions<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>(GetLoyaltyPassUrlDocument, options);
      }
export function useGetLoyaltyPassUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>(GetLoyaltyPassUrlDocument, options);
        }
export type GetLoyaltyPassUrlQueryHookResult = ReturnType<typeof useGetLoyaltyPassUrlQuery>;
export type GetLoyaltyPassUrlLazyQueryHookResult = ReturnType<typeof useGetLoyaltyPassUrlLazyQuery>;
export type GetLoyaltyPassUrlQueryResult = Apollo.QueryResult<GqlGetLoyaltyPassUrlQuery, GqlGetLoyaltyPassUrlQueryVariables>;
export const GetRewardsV2Document = gql`
    query GetRewardsV2($phoneNumber: String!, $dispensaryId: String, $enterpriseId: String, $isoRegionCode: String, $dob: String, $pin: String, $customerId: String) {
  getRewardsV2(
    phoneNumber: $phoneNumber
    dispensaryId: $dispensaryId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
    dob: $dob
    pin: $pin
    customerId: $customerId
  ) {
    balance
    rewards {
      id
      copy
      available
      operator
      cost
      costV2
      value
      rewardType
      discountId
      brand
      isRedeemableOnline
      isEligible
    }
    rewardBrand
    userHasWallet
    isLoyaltyMember
    currentYearTierBalance
    expirationDate
    tierName
    tierId
    auth {
      pinConfirmed
      incorrectPinProvided
      authTextMessageSent
    }
    rewardsActivity {
      lspName
      location
      customerId
      transactionType
      transactionDateUtc
      points
      comment
      orderType
      isAdjustment
      totalPaid
    }
    posCustomerId
    posUniqueId
    isRevokedFromReferralProgram
  }
}
    `;

/**
 * __useGetRewardsV2Query__
 *
 * To run a query within a React component, call `useGetRewardsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsV2Query({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      dispensaryId: // value for 'dispensaryId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *      dob: // value for 'dob'
 *      pin: // value for 'pin'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetRewardsV2Query(baseOptions: Apollo.QueryHookOptions<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>(GetRewardsV2Document, options);
      }
export function useGetRewardsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>(GetRewardsV2Document, options);
        }
export type GetRewardsV2QueryHookResult = ReturnType<typeof useGetRewardsV2Query>;
export type GetRewardsV2LazyQueryHookResult = ReturnType<typeof useGetRewardsV2LazyQuery>;
export type GetRewardsV2QueryResult = Apollo.QueryResult<GqlGetRewardsV2Query, GqlGetRewardsV2QueryVariables>;
export const BulkEndSpecialsV2Document = gql`
    mutation BulkEndSpecialsV2($input: endSpecialsInput!) {
  bulkEndSpecialsV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlBulkEndSpecialsV2MutationFn = Apollo.MutationFunction<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>;

/**
 * __useBulkEndSpecialsV2Mutation__
 *
 * To run a mutation, you first call `useBulkEndSpecialsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEndSpecialsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEndSpecialsV2Mutation, { data, loading, error }] = useBulkEndSpecialsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkEndSpecialsV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>(BulkEndSpecialsV2Document, options);
      }
export type BulkEndSpecialsV2MutationHookResult = ReturnType<typeof useBulkEndSpecialsV2Mutation>;
export type BulkEndSpecialsV2MutationResult = Apollo.MutationResult<GqlBulkEndSpecialsV2Mutation>;
export type BulkEndSpecialsV2MutationOptions = Apollo.BaseMutationOptions<GqlBulkEndSpecialsV2Mutation, GqlBulkEndSpecialsV2MutationVariables>;
export const CreateEnterpriseSpecialV2Document = gql`
    mutation CreateEnterpriseSpecialV2($input: EnterpriseSpecialInputV2!) {
  createEnterpriseSpecialV2(input: $input) {
    message
    success
  }
}
    `;
export type GqlCreateEnterpriseSpecialV2MutationFn = Apollo.MutationFunction<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>;

/**
 * __useCreateEnterpriseSpecialV2Mutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseSpecialV2Mutation, { data, loading, error }] = useCreateEnterpriseSpecialV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnterpriseSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>(CreateEnterpriseSpecialV2Document, options);
      }
export type CreateEnterpriseSpecialV2MutationHookResult = ReturnType<typeof useCreateEnterpriseSpecialV2Mutation>;
export type CreateEnterpriseSpecialV2MutationResult = Apollo.MutationResult<GqlCreateEnterpriseSpecialV2Mutation>;
export type CreateEnterpriseSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseSpecialV2Mutation, GqlCreateEnterpriseSpecialV2MutationVariables>;
export const CreateEnterpriseSpecialsSettingsDocument = gql`
    mutation CreateEnterpriseSpecialsSettings($enterpriseId: ID!, $input: EnterpriseSpecialsSettingsInput!) {
  createEnterpriseSpecialsSettings(enterpriseId: $enterpriseId, input: $input) {
    message
    success
  }
}
    `;
export type GqlCreateEnterpriseSpecialsSettingsMutationFn = Apollo.MutationFunction<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>;

/**
 * __useCreateEnterpriseSpecialsSettingsMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseSpecialsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseSpecialsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseSpecialsSettingsMutation, { data, loading, error }] = useCreateEnterpriseSpecialsSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnterpriseSpecialsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>(CreateEnterpriseSpecialsSettingsDocument, options);
      }
export type CreateEnterpriseSpecialsSettingsMutationHookResult = ReturnType<typeof useCreateEnterpriseSpecialsSettingsMutation>;
export type CreateEnterpriseSpecialsSettingsMutationResult = Apollo.MutationResult<GqlCreateEnterpriseSpecialsSettingsMutation>;
export type CreateEnterpriseSpecialsSettingsMutationOptions = Apollo.BaseMutationOptions<GqlCreateEnterpriseSpecialsSettingsMutation, GqlCreateEnterpriseSpecialsSettingsMutationVariables>;
export const CreateSpecialV3Document = gql`
    mutation CreateSpecialV3($input: SpecialsInputV3!) {
  createSpecialV3(input: $input) {
    _id
  }
}
    `;
export type GqlCreateSpecialV3MutationFn = Apollo.MutationFunction<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>;

/**
 * __useCreateSpecialV3Mutation__
 *
 * To run a mutation, you first call `useCreateSpecialV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialV3Mutation, { data, loading, error }] = useCreateSpecialV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpecialV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>(CreateSpecialV3Document, options);
      }
export type CreateSpecialV3MutationHookResult = ReturnType<typeof useCreateSpecialV3Mutation>;
export type CreateSpecialV3MutationResult = Apollo.MutationResult<GqlCreateSpecialV3Mutation>;
export type CreateSpecialV3MutationOptions = Apollo.BaseMutationOptions<GqlCreateSpecialV3Mutation, GqlCreateSpecialV3MutationVariables>;
export const DeleteEnterpriseSpecialDocument = gql`
    mutation DeleteEnterpriseSpecial($enterpriseId: String!, $id: String!) {
  deleteEnterpriseSpecial(enterprise_id: $enterpriseId, id: $id) {
    message
    success
  }
}
    `;
export type GqlDeleteEnterpriseSpecialMutationFn = Apollo.MutationFunction<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>;

/**
 * __useDeleteEnterpriseSpecialMutation__
 *
 * To run a mutation, you first call `useDeleteEnterpriseSpecialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnterpriseSpecialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnterpriseSpecialMutation, { data, loading, error }] = useDeleteEnterpriseSpecialMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnterpriseSpecialMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>(DeleteEnterpriseSpecialDocument, options);
      }
export type DeleteEnterpriseSpecialMutationHookResult = ReturnType<typeof useDeleteEnterpriseSpecialMutation>;
export type DeleteEnterpriseSpecialMutationResult = Apollo.MutationResult<GqlDeleteEnterpriseSpecialMutation>;
export type DeleteEnterpriseSpecialMutationOptions = Apollo.BaseMutationOptions<GqlDeleteEnterpriseSpecialMutation, GqlDeleteEnterpriseSpecialMutationVariables>;
export const DeleteSpecialV2Document = gql`
    mutation DeleteSpecialV2($id: String!) {
  deleteSpecialV2(id: $id) {
    _id
  }
}
    `;
export type GqlDeleteSpecialV2MutationFn = Apollo.MutationFunction<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>;

/**
 * __useDeleteSpecialV2Mutation__
 *
 * To run a mutation, you first call `useDeleteSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialV2Mutation, { data, loading, error }] = useDeleteSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>(DeleteSpecialV2Document, options);
      }
export type DeleteSpecialV2MutationHookResult = ReturnType<typeof useDeleteSpecialV2Mutation>;
export type DeleteSpecialV2MutationResult = Apollo.MutationResult<GqlDeleteSpecialV2Mutation>;
export type DeleteSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlDeleteSpecialV2Mutation, GqlDeleteSpecialV2MutationVariables>;
export const EndEnterpriseSpecialDocument = gql`
    mutation EndEnterpriseSpecial($enterpriseId: String!, $id: String!) {
  endEnterpriseSpecial(enterprise_id: $enterpriseId, id: $id) {
    success
    message
  }
}
    `;
export type GqlEndEnterpriseSpecialMutationFn = Apollo.MutationFunction<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>;

/**
 * __useEndEnterpriseSpecialMutation__
 *
 * To run a mutation, you first call `useEndEnterpriseSpecialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndEnterpriseSpecialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endEnterpriseSpecialMutation, { data, loading, error }] = useEndEnterpriseSpecialMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndEnterpriseSpecialMutation(baseOptions?: Apollo.MutationHookOptions<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>(EndEnterpriseSpecialDocument, options);
      }
export type EndEnterpriseSpecialMutationHookResult = ReturnType<typeof useEndEnterpriseSpecialMutation>;
export type EndEnterpriseSpecialMutationResult = Apollo.MutationResult<GqlEndEnterpriseSpecialMutation>;
export type EndEnterpriseSpecialMutationOptions = Apollo.BaseMutationOptions<GqlEndEnterpriseSpecialMutation, GqlEndEnterpriseSpecialMutationVariables>;
export const EndSpecialV2Document = gql`
    mutation EndSpecialV2($id: String!) {
  endSpecialV2(id: $id) {
    _id
  }
}
    `;
export type GqlEndSpecialV2MutationFn = Apollo.MutationFunction<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>;

/**
 * __useEndSpecialV2Mutation__
 *
 * To run a mutation, you first call `useEndSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endSpecialV2Mutation, { data, loading, error }] = useEndSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>(EndSpecialV2Document, options);
      }
export type EndSpecialV2MutationHookResult = ReturnType<typeof useEndSpecialV2Mutation>;
export type EndSpecialV2MutationResult = Apollo.MutationResult<GqlEndSpecialV2Mutation>;
export type EndSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlEndSpecialV2Mutation, GqlEndSpecialV2MutationVariables>;
export const IncrementSpecialClicksDocument = gql`
    mutation IncrementSpecialClicks($input: incrementClicksInput!) {
  incrementClicks(special: $input) {
    message
    success
  }
}
    `;
export type GqlIncrementSpecialClicksMutationFn = Apollo.MutationFunction<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>;

/**
 * __useIncrementSpecialClicksMutation__
 *
 * To run a mutation, you first call `useIncrementSpecialClicksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementSpecialClicksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementSpecialClicksMutation, { data, loading, error }] = useIncrementSpecialClicksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIncrementSpecialClicksMutation(baseOptions?: Apollo.MutationHookOptions<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>(IncrementSpecialClicksDocument, options);
      }
export type IncrementSpecialClicksMutationHookResult = ReturnType<typeof useIncrementSpecialClicksMutation>;
export type IncrementSpecialClicksMutationResult = Apollo.MutationResult<GqlIncrementSpecialClicksMutation>;
export type IncrementSpecialClicksMutationOptions = Apollo.BaseMutationOptions<GqlIncrementSpecialClicksMutation, GqlIncrementSpecialClicksMutationVariables>;
export const UpdateEnterpriseSpecialV2Document = gql`
    mutation UpdateEnterpriseSpecialV2($id: String!, $input: EnterpriseSpecialInputV2!) {
  updateEnterpriseSpecialV2(id: $id, input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateEnterpriseSpecialV2MutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>;

/**
 * __useUpdateEnterpriseSpecialV2Mutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseSpecialV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseSpecialV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseSpecialV2Mutation, { data, loading, error }] = useUpdateEnterpriseSpecialV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseSpecialV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>(UpdateEnterpriseSpecialV2Document, options);
      }
export type UpdateEnterpriseSpecialV2MutationHookResult = ReturnType<typeof useUpdateEnterpriseSpecialV2Mutation>;
export type UpdateEnterpriseSpecialV2MutationResult = Apollo.MutationResult<GqlUpdateEnterpriseSpecialV2Mutation>;
export type UpdateEnterpriseSpecialV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseSpecialV2Mutation, GqlUpdateEnterpriseSpecialV2MutationVariables>;
export const UpdateEnterpriseSpecialsSettingsDocument = gql`
    mutation UpdateEnterpriseSpecialsSettings($enterpriseId: ID!, $input: EnterpriseSpecialsSettingsInput!) {
  updateEnterpriseSpecialsSettings(enterpriseId: $enterpriseId, input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateEnterpriseSpecialsSettingsMutationFn = Apollo.MutationFunction<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>;

/**
 * __useUpdateEnterpriseSpecialsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseSpecialsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseSpecialsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseSpecialsSettingsMutation, { data, loading, error }] = useUpdateEnterpriseSpecialsSettingsMutation({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseSpecialsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>(UpdateEnterpriseSpecialsSettingsDocument, options);
      }
export type UpdateEnterpriseSpecialsSettingsMutationHookResult = ReturnType<typeof useUpdateEnterpriseSpecialsSettingsMutation>;
export type UpdateEnterpriseSpecialsSettingsMutationResult = Apollo.MutationResult<GqlUpdateEnterpriseSpecialsSettingsMutation>;
export type UpdateEnterpriseSpecialsSettingsMutationOptions = Apollo.BaseMutationOptions<GqlUpdateEnterpriseSpecialsSettingsMutation, GqlUpdateEnterpriseSpecialsSettingsMutationVariables>;
export const UpdateSpecialV3Document = gql`
    mutation UpdateSpecialV3($id: String!, $input: SpecialsInputV3!) {
  updateSpecialV3(id: $id, input: $input) {
    _id
  }
}
    `;
export type GqlUpdateSpecialV3MutationFn = Apollo.MutationFunction<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>;

/**
 * __useUpdateSpecialV3Mutation__
 *
 * To run a mutation, you first call `useUpdateSpecialV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialV3Mutation, { data, loading, error }] = useUpdateSpecialV3Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>(UpdateSpecialV3Document, options);
      }
export type UpdateSpecialV3MutationHookResult = ReturnType<typeof useUpdateSpecialV3Mutation>;
export type UpdateSpecialV3MutationResult = Apollo.MutationResult<GqlUpdateSpecialV3Mutation>;
export type UpdateSpecialV3MutationOptions = Apollo.BaseMutationOptions<GqlUpdateSpecialV3Mutation, GqlUpdateSpecialV3MutationVariables>;
export const UpdateSpecialsSortOrderDocument = gql`
    mutation UpdateSpecialsSortOrder($input: SortOrderInput!) {
  updateSpecialsSortOrder(input: $input) {
    message
    success
  }
}
    `;
export type GqlUpdateSpecialsSortOrderMutationFn = Apollo.MutationFunction<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>;

/**
 * __useUpdateSpecialsSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialsSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialsSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialsSortOrderMutation, { data, loading, error }] = useUpdateSpecialsSortOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpecialsSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>(UpdateSpecialsSortOrderDocument, options);
      }
export type UpdateSpecialsSortOrderMutationHookResult = ReturnType<typeof useUpdateSpecialsSortOrderMutation>;
export type UpdateSpecialsSortOrderMutationResult = Apollo.MutationResult<GqlUpdateSpecialsSortOrderMutation>;
export type UpdateSpecialsSortOrderMutationOptions = Apollo.BaseMutationOptions<GqlUpdateSpecialsSortOrderMutation, GqlUpdateSpecialsSortOrderMutationVariables>;
export const EnterpriseSpecialsV3Document = gql`
    query EnterpriseSpecialsV3($enterpriseId: ID!, $filter: filteredSpecialsInputV2) {
  enterpriseSpecialsV3(enterpriseId: $enterpriseId, filter: $filter) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      bogoConditionLogicOperator
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          productTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      cipher
      clicks
      complete
      createdAt
      createdBy
      description
      descriptionHtml
      discount
      discountedPrices
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      displayRank
      earliestStartStamp
      emailSpecial
      endDay
      endStamp
      endTime
      enterpriseId
      enterpriseSpecialId
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      latestEndStamp
      localTime
      menuDisplayDescription
      menuDisplayName
      menuDisplayImage
      menuType
      name
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      retailers
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          subcategoryIds
          subcategoryNames
          strainIds
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialRestrictions
      specialType
      startDay
      startStamp
      startTime
      subject
      targetPrice
      timezone
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useEnterpriseSpecialsV3Query__
 *
 * To run a query within a React component, call `useEnterpriseSpecialsV3Query` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseSpecialsV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseSpecialsV3Query({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEnterpriseSpecialsV3Query(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>(EnterpriseSpecialsV3Document, options);
      }
export function useEnterpriseSpecialsV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>(EnterpriseSpecialsV3Document, options);
        }
export type EnterpriseSpecialsV3QueryHookResult = ReturnType<typeof useEnterpriseSpecialsV3Query>;
export type EnterpriseSpecialsV3LazyQueryHookResult = ReturnType<typeof useEnterpriseSpecialsV3LazyQuery>;
export type EnterpriseSpecialsV3QueryResult = Apollo.QueryResult<GqlEnterpriseSpecialsV3Query, GqlEnterpriseSpecialsV3QueryVariables>;
export const EnterpriseSpecialsDocument = gql`
    query EnterpriseSpecials($enterpriseId: ID!) {
  enterpriseSpecials(enterpriseId: $enterpriseId) {
    _id
    active
    applyRewardsToConditions
    excludeConditionItemsFromRewards
    bogoConditionLogicOperator
    bogoConditions {
      _id
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productId
      productIds
      productTags
      quantity
      requiresSingleSku
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      weight
      weights
      weightOperator
    }
    bogoRewardLogicOperator
    bogoRewards {
      _id
      applicationRules {
        _id
        comparisonOperator
        quantity
        applicationType
      }
      brandId
      brandIds
      brandName
      brandNames
      categoryIds
      categoryName
      categoryNames
      dollarDiscount
      discountAmount
      discountType
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productId
      productIds
      productTags
      percentDiscount
      productTags
      quantity
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      requiresSingleSku
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      weight
      weights
      weightOperator
    }
    cipher
    clicks
    createdAt
    createdBy
    description
    descriptionHtml
    discount
    discountedPrices
    discountToCart {
      _id
      enabled
      discountType
      value
    }
    displayRank
    emailSpecial
    endDay
    endStamp
    endTime
    enterpriseId
    enterpriseSpecialId
    excludedProducts {
      _id
      Name
      key
      conditions {
        _id
        Name
        key
      }
      rewards {
        _id
        Name
        key
      }
    }
    heading
    isRecurring
    itemsForAPrice {
      _id
      enabled
      value
    }
    localTime
    menuDisplayDescription
    menuDisplayName
    menuDisplayImage
    menuType
    name
    percentDiscount
    productDiscounts
    productGroup
    productGroupRewards
    products
    recurring {
      days
      endDate
      endTime
      setEndDate
      startTime
    }
    redemptionLimit
    retailers
    saleDiscounts {
      _id
      brandIds
      brandNames
      categoryIds
      categoryNames
      discountAmount
      discountType
      enterpriseProductIds
      exclusions {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        enterpriseProductIds
        inventoryTags
        matchOperator
        productGroup
        productIds
        productTags
        subcategoryIds
        subcategoryNames
        strainIds
        vendorIds
        weights
        weightOperator
      }
      inventoryTags
      productGroup
      productIds
      productTags
      subcategoryIds
      subcategoryNames
      strainIds
      vendorIds
      weights
      weightOperator
    }
    scope
    source
    sourceId
    specialRestrictions
    specialType
    startDay
    startStamp
    startTime
    subject
    targetPrice
    timezone
    totalQuantity {
      enabled
      maxQuantity
      quantity
      quantityOperator
    }
    totalWeight {
      enabled
      weight
      weightOperator
    }
    totalSpend {
      enabled
      maximumSpend
      minimumSpend
      spendOperator
    }
    updatedAt
    updatedBy
    version
  }
}
    `;

/**
 * __useEnterpriseSpecialsQuery__
 *
 * To run a query within a React component, call `useEnterpriseSpecialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseSpecialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseSpecialsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseSpecialsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>(EnterpriseSpecialsDocument, options);
      }
export function useEnterpriseSpecialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>(EnterpriseSpecialsDocument, options);
        }
export type EnterpriseSpecialsQueryHookResult = ReturnType<typeof useEnterpriseSpecialsQuery>;
export type EnterpriseSpecialsLazyQueryHookResult = ReturnType<typeof useEnterpriseSpecialsLazyQuery>;
export type EnterpriseSpecialsQueryResult = Apollo.QueryResult<GqlEnterpriseSpecialsQuery, GqlEnterpriseSpecialsQueryVariables>;
export const FilteredSpecialsV2Document = gql`
    query FilteredSpecialsV2($specialsFilter: filteredSpecialsInput!, $translateSpecialsToV3: Boolean = false) {
  filteredSpecialsV2(
    filter: $specialsFilter
    translateSpecialsToV3: $translateSpecialsToV3
  ) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      menuDisplayName
      menuDisplayDescription
      bogoConditionLogicOperator
      menuDisplayImage
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        percentDiscount
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      clicks
      createdAt
      createdBy
      description
      descriptionHtml
      directPOSProductIdMapping
      rawPOSWeightMapping
      discount
      discountedPrices
      discountPrecedence
      discountStacking
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      dispensaryId
      displayRank
      emailSpecial
      endDay
      endStamp
      endTime
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      menuType
      minorVersion
      name
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      platformType
      preOrderType
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      startDate
      startDay
      startStamp
      startTime
      subject
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useFilteredSpecialsV2Query__
 *
 * To run a query within a React component, call `useFilteredSpecialsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSpecialsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSpecialsV2Query({
 *   variables: {
 *      specialsFilter: // value for 'specialsFilter'
 *      translateSpecialsToV3: // value for 'translateSpecialsToV3'
 *   },
 * });
 */
export function useFilteredSpecialsV2Query(baseOptions: Apollo.QueryHookOptions<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>(FilteredSpecialsV2Document, options);
      }
export function useFilteredSpecialsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>(FilteredSpecialsV2Document, options);
        }
export type FilteredSpecialsV2QueryHookResult = ReturnType<typeof useFilteredSpecialsV2Query>;
export type FilteredSpecialsV2LazyQueryHookResult = ReturnType<typeof useFilteredSpecialsV2LazyQuery>;
export type FilteredSpecialsV2QueryResult = Apollo.QueryResult<GqlFilteredSpecialsV2Query, GqlFilteredSpecialsV2QueryVariables>;
export const FilteredSpecialsDocument = gql`
    query FilteredSpecials($specialsFilter: filteredSpecialsInput!, $includeEnterpriseSpecials: Boolean = false) {
  filteredSpecials(
    filter: $specialsFilter
    includeEnterpriseSpecials: $includeEnterpriseSpecials
  ) {
    queryInfo {
      totalCount
    }
    specials {
      _id
      active
      applyRewardsToConditions
      excludeConditionItemsFromRewards
      menuDisplayName
      menuDisplayDescription
      bogoConditionLogicOperator
      menuDisplayImage
      bogoConditions {
        _id
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          inventoryTags
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        quantity
        requiresSingleSku
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        weight
        weights
        weightOperator
      }
      bogoRewardLogicOperator
      bogoRewards {
        _id
        applicationRules {
          _id
          comparisonOperator
          quantity
          applicationType
        }
        brandId
        brandIds
        brandName
        brandNames
        categoryIds
        categoryName
        categoryNames
        dollarDiscount
        discountAmount
        discountType
        enterpriseProductId
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          inventoryTags
          enterpriseProductIds
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productId
        productIds
        productTags
        percentDiscount
        quantity
        strainIds
        subcategoryIds
        subcategoryNames
        requiresSingleSku
        targetPrice
        totalQuantity {
          enabled
          maxQuantity
          quantity
          quantityOperator
        }
        totalWeight {
          enabled
          weight
          weightOperator
        }
        totalSpend {
          enabled
          maximumSpend
          minimumSpend
          spendOperator
        }
        vendorIds
        weight
        weights
        weightOperator
      }
      clicks
      createdAt
      createdBy
      description
      descriptionHtml
      directPOSProductIdMapping
      rawPOSWeightMapping
      discount
      discountedPrices
      discountPrecedence
      discountStacking
      discountToCart {
        _id
        enabled
        discountType
        value
      }
      dispensaryId
      displayRank
      emailSpecial
      endDay
      endStamp
      endTime
      excludedProducts {
        _id
        Name
        key
        conditions {
          _id
          Name
          key
        }
        rewards {
          _id
          Name
          key
        }
      }
      heading
      isRecurring
      itemsForAPrice {
        _id
        enabled
        value
      }
      discountBundle {
        _id
        applyTo
        discountType
        enabled
        limit
        value
      }
      menuType
      minorVersion
      name
      nonStackingBehavior
      paymentRestrictions {
        payByBankSignupIncentive
      }
      platformType
      preOrderType
      percentDiscount
      productDiscounts
      productGroup
      productGroupRewards
      products
      recurring {
        days
        endDate
        endTime
        setEndDate
        startTime
      }
      redemptionLimit
      saleDiscounts {
        _id
        brandIds
        brandNames
        categoryIds
        categoryNames
        inventoryTags
        discountAmount
        discountType
        enterpriseProductIds
        exclusions {
          _id
          brandIds
          brandNames
          categoryIds
          categoryNames
          enterpriseProductIds
          inventoryTags
          matchOperator
          productGroup
          productIds
          productTags
          strainIds
          subcategoryIds
          subcategoryNames
          vendorIds
          weights
          weightOperator
        }
        inventoryTags
        productGroup
        productIds
        productTags
        strainIds
        subcategoryIds
        subcategoryNames
        vendorIds
        weights
        weightOperator
      }
      scope
      source
      sourceId
      specialId
      specialRestrictions
      specialType
      stackingBehavior
      stackingMode
      startDate
      startDay
      startStamp
      startTime
      subject
      targetPrice
      totalQuantity {
        enabled
        maxQuantity
        quantity
        quantityOperator
      }
      totalWeight {
        enabled
        weight
        weightOperator
      }
      totalSpend {
        enabled
        maximumSpend
        minimumSpend
        spendOperator
      }
      updatedAt
      updatedBy
      version
    }
  }
}
    `;

/**
 * __useFilteredSpecialsQuery__
 *
 * To run a query within a React component, call `useFilteredSpecialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSpecialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSpecialsQuery({
 *   variables: {
 *      specialsFilter: // value for 'specialsFilter'
 *      includeEnterpriseSpecials: // value for 'includeEnterpriseSpecials'
 *   },
 * });
 */
export function useFilteredSpecialsQuery(baseOptions: Apollo.QueryHookOptions<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>(FilteredSpecialsDocument, options);
      }
export function useFilteredSpecialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>(FilteredSpecialsDocument, options);
        }
export type FilteredSpecialsQueryHookResult = ReturnType<typeof useFilteredSpecialsQuery>;
export type FilteredSpecialsLazyQueryHookResult = ReturnType<typeof useFilteredSpecialsLazyQuery>;
export type FilteredSpecialsQueryResult = Apollo.QueryResult<GqlFilteredSpecialsQuery, GqlFilteredSpecialsQueryVariables>;
export const GetSpecialGamificationDocument = gql`
    query GetSpecialGamification($dispensaryId: String, $menuType: String, $specialIds: [String]) {
  getSpecialGamification(
    dispensaryId: $dispensaryId
    menuType: $menuType
    specialIds: $specialIds
  ) {
    gamificationThresholds {
      discountId
      satisfiers {
        thresholdType
        minimumThreshold
      }
    }
  }
}
    `;

/**
 * __useGetSpecialGamificationQuery__
 *
 * To run a query within a React component, call `useGetSpecialGamificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialGamificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialGamificationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuType: // value for 'menuType'
 *      specialIds: // value for 'specialIds'
 *   },
 * });
 */
export function useGetSpecialGamificationQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>(GetSpecialGamificationDocument, options);
      }
export function useGetSpecialGamificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>(GetSpecialGamificationDocument, options);
        }
export type GetSpecialGamificationQueryHookResult = ReturnType<typeof useGetSpecialGamificationQuery>;
export type GetSpecialGamificationLazyQueryHookResult = ReturnType<typeof useGetSpecialGamificationLazyQuery>;
export type GetSpecialGamificationQueryResult = Apollo.QueryResult<GqlGetSpecialGamificationQuery, GqlGetSpecialGamificationQueryVariables>;
export const GetSpecialMenuCardsDocument = gql`
    query GetSpecialMenuCards($dispensaryId: ID!, $menuType: String!, $specialId: String, $platformType: String, $ecomUserId: String) {
  getSpecialMenuCards(
    dispensaryId: $dispensaryId
    menuType: $menuType
    specialId: $specialId
    platformType: $platformType
    ecomUserId: $ecomUserId
  ) {
    menuCards {
      _id
      displayRank
      menuDisplayName
      menuDisplayDescription
      menuDisplayImage
      posDiscountId
      specialType
      isRestricted
    }
  }
}
    `;

/**
 * __useGetSpecialMenuCardsQuery__
 *
 * To run a query within a React component, call `useGetSpecialMenuCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialMenuCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialMenuCardsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuType: // value for 'menuType'
 *      specialId: // value for 'specialId'
 *      platformType: // value for 'platformType'
 *      ecomUserId: // value for 'ecomUserId'
 *   },
 * });
 */
export function useGetSpecialMenuCardsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>(GetSpecialMenuCardsDocument, options);
      }
export function useGetSpecialMenuCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>(GetSpecialMenuCardsDocument, options);
        }
export type GetSpecialMenuCardsQueryHookResult = ReturnType<typeof useGetSpecialMenuCardsQuery>;
export type GetSpecialMenuCardsLazyQueryHookResult = ReturnType<typeof useGetSpecialMenuCardsLazyQuery>;
export type GetSpecialMenuCardsQueryResult = Apollo.QueryResult<GqlGetSpecialMenuCardsQuery, GqlGetSpecialMenuCardsQueryVariables>;
export const GetStockImageDocument = gql`
    query getStockImage($category: String, $productName: String) {
  getStockImage(category: $category, productName: $productName) {
    url
  }
}
    `;

/**
 * __useGetStockImageQuery__
 *
 * To run a query within a React component, call `useGetStockImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockImageQuery({
 *   variables: {
 *      category: // value for 'category'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useGetStockImageQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>(GetStockImageDocument, options);
      }
export function useGetStockImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>(GetStockImageDocument, options);
        }
export type GetStockImageQueryHookResult = ReturnType<typeof useGetStockImageQuery>;
export type GetStockImageLazyQueryHookResult = ReturnType<typeof useGetStockImageLazyQuery>;
export type GetStockImageQueryResult = Apollo.QueryResult<GqlGetStockImageQuery, GqlGetStockImageQueryVariables>;
export const CreateStrainV2Document = gql`
    mutation CreateStrainV2($input: strainInput!) {
  createStrainV2(strain: $input) {
    id
  }
}
    `;
export type GqlCreateStrainV2MutationFn = Apollo.MutationFunction<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>;

/**
 * __useCreateStrainV2Mutation__
 *
 * To run a mutation, you first call `useCreateStrainV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStrainV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStrainV2Mutation, { data, loading, error }] = useCreateStrainV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStrainV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>(CreateStrainV2Document, options);
      }
export type CreateStrainV2MutationHookResult = ReturnType<typeof useCreateStrainV2Mutation>;
export type CreateStrainV2MutationResult = Apollo.MutationResult<GqlCreateStrainV2Mutation>;
export type CreateStrainV2MutationOptions = Apollo.BaseMutationOptions<GqlCreateStrainV2Mutation, GqlCreateStrainV2MutationVariables>;
export const DeleteStrainDocument = gql`
    mutation DeleteStrain($id: String!) {
  deleteStrain(id: $id) {
    id
  }
}
    `;
export type GqlDeleteStrainMutationFn = Apollo.MutationFunction<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>;

/**
 * __useDeleteStrainMutation__
 *
 * To run a mutation, you first call `useDeleteStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStrainMutation, { data, loading, error }] = useDeleteStrainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStrainMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>(DeleteStrainDocument, options);
      }
export type DeleteStrainMutationHookResult = ReturnType<typeof useDeleteStrainMutation>;
export type DeleteStrainMutationResult = Apollo.MutationResult<GqlDeleteStrainMutation>;
export type DeleteStrainMutationOptions = Apollo.BaseMutationOptions<GqlDeleteStrainMutation, GqlDeleteStrainMutationVariables>;
export const UpdateStrainV2Document = gql`
    mutation UpdateStrainV2($id: String!, $input: strainInput!) {
  updateStrainV2(id: $id, strain: $input) {
    id
  }
}
    `;
export type GqlUpdateStrainV2MutationFn = Apollo.MutationFunction<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>;

/**
 * __useUpdateStrainV2Mutation__
 *
 * To run a mutation, you first call `useUpdateStrainV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStrainV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStrainV2Mutation, { data, loading, error }] = useUpdateStrainV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStrainV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>(UpdateStrainV2Document, options);
      }
export type UpdateStrainV2MutationHookResult = ReturnType<typeof useUpdateStrainV2Mutation>;
export type UpdateStrainV2MutationResult = Apollo.MutationResult<GqlUpdateStrainV2Mutation>;
export type UpdateStrainV2MutationOptions = Apollo.BaseMutationOptions<GqlUpdateStrainV2Mutation, GqlUpdateStrainV2MutationVariables>;
export const FilteredStrainsDocument = gql`
    query FilteredStrains($filter: strainsFilterInput, $sort: strainsSortInput, $pagination: paginationInput) {
  filteredStrains(filter: $filter, sort: $sort, pagination: $pagination) {
    queryInfo {
      totalCount
    }
    strains {
      description
      effects
      id
      imageUrl
      name
      potentialHealthBenefits
    }
  }
}
    `;

/**
 * __useFilteredStrainsQuery__
 *
 * To run a query within a React component, call `useFilteredStrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredStrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredStrainsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFilteredStrainsQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>(FilteredStrainsDocument, options);
      }
export function useFilteredStrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>(FilteredStrainsDocument, options);
        }
export type FilteredStrainsQueryHookResult = ReturnType<typeof useFilteredStrainsQuery>;
export type FilteredStrainsLazyQueryHookResult = ReturnType<typeof useFilteredStrainsLazyQuery>;
export type FilteredStrainsQueryResult = Apollo.QueryResult<GqlFilteredStrainsQuery, GqlFilteredStrainsQueryVariables>;
export const GetStrainDocument = gql`
    query GetStrain($id: String!) {
  getStrain(id: $id) {
    aromas
    description
    effects
    id
    imageUrl
    labels
    name
    potentialHealthBenefits
    ratio
    terpenes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStrainQuery__
 *
 * To run a query within a React component, call `useGetStrainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrainQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStrainQuery(baseOptions: Apollo.QueryHookOptions<GqlGetStrainQuery, GqlGetStrainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetStrainQuery, GqlGetStrainQueryVariables>(GetStrainDocument, options);
      }
export function useGetStrainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetStrainQuery, GqlGetStrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetStrainQuery, GqlGetStrainQueryVariables>(GetStrainDocument, options);
        }
export type GetStrainQueryHookResult = ReturnType<typeof useGetStrainQuery>;
export type GetStrainLazyQueryHookResult = ReturnType<typeof useGetStrainLazyQuery>;
export type GetStrainQueryResult = Apollo.QueryResult<GqlGetStrainQuery, GqlGetStrainQueryVariables>;
export const GetCustomerSubscriptionsDocument = gql`
    query GetCustomerSubscriptions {
  getCustomerSubscriptions {
    dispensaryId
    dispensaryName
    emailOptIn
    emailSubscription
    id
  }
}
    `;

/**
 * __useGetCustomerSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetCustomerSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>(GetCustomerSubscriptionsDocument, options);
      }
export function useGetCustomerSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>(GetCustomerSubscriptionsDocument, options);
        }
export type GetCustomerSubscriptionsQueryHookResult = ReturnType<typeof useGetCustomerSubscriptionsQuery>;
export type GetCustomerSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetCustomerSubscriptionsLazyQuery>;
export type GetCustomerSubscriptionsQueryResult = Apollo.QueryResult<GqlGetCustomerSubscriptionsQuery, GqlGetCustomerSubscriptionsQueryVariables>;
export const GetUnsubscribeDispensaryDocument = gql`
    query GetUnsubscribeDispensary($customerId: String!) {
  unsubscribeCustomerQuery(customerId: $customerId) {
    subscribed
    dispensary {
      name
      logoImage
    }
  }
}
    `;

/**
 * __useGetUnsubscribeDispensaryQuery__
 *
 * To run a query within a React component, call `useGetUnsubscribeDispensaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnsubscribeDispensaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnsubscribeDispensaryQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetUnsubscribeDispensaryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>(GetUnsubscribeDispensaryDocument, options);
      }
export function useGetUnsubscribeDispensaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>(GetUnsubscribeDispensaryDocument, options);
        }
export type GetUnsubscribeDispensaryQueryHookResult = ReturnType<typeof useGetUnsubscribeDispensaryQuery>;
export type GetUnsubscribeDispensaryLazyQueryHookResult = ReturnType<typeof useGetUnsubscribeDispensaryLazyQuery>;
export type GetUnsubscribeDispensaryQueryResult = Apollo.QueryResult<GqlGetUnsubscribeDispensaryQuery, GqlGetUnsubscribeDispensaryQueryVariables>;
export const CreateTerpeneDocument = gql`
    mutation CreateTerpene($terpene: terpeneInput!) {
  createTerpeneV2(terpene: $terpene) {
    id
  }
}
    `;
export type GqlCreateTerpeneMutationFn = Apollo.MutationFunction<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>;

/**
 * __useCreateTerpeneMutation__
 *
 * To run a mutation, you first call `useCreateTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTerpeneMutation, { data, loading, error }] = useCreateTerpeneMutation({
 *   variables: {
 *      terpene: // value for 'terpene'
 *   },
 * });
 */
export function useCreateTerpeneMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>(CreateTerpeneDocument, options);
      }
export type CreateTerpeneMutationHookResult = ReturnType<typeof useCreateTerpeneMutation>;
export type CreateTerpeneMutationResult = Apollo.MutationResult<GqlCreateTerpeneMutation>;
export type CreateTerpeneMutationOptions = Apollo.BaseMutationOptions<GqlCreateTerpeneMutation, GqlCreateTerpeneMutationVariables>;
export const DeleteTerpeneDocument = gql`
    mutation DeleteTerpene($id: String!) {
  deleteTerpene(id: $id) {
    id
  }
}
    `;
export type GqlDeleteTerpeneMutationFn = Apollo.MutationFunction<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>;

/**
 * __useDeleteTerpeneMutation__
 *
 * To run a mutation, you first call `useDeleteTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTerpeneMutation, { data, loading, error }] = useDeleteTerpeneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTerpeneMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>(DeleteTerpeneDocument, options);
      }
export type DeleteTerpeneMutationHookResult = ReturnType<typeof useDeleteTerpeneMutation>;
export type DeleteTerpeneMutationResult = Apollo.MutationResult<GqlDeleteTerpeneMutation>;
export type DeleteTerpeneMutationOptions = Apollo.BaseMutationOptions<GqlDeleteTerpeneMutation, GqlDeleteTerpeneMutationVariables>;
export const UpdateTerpeneDocument = gql`
    mutation UpdateTerpene($id: String!, $terpene: terpeneInput!) {
  updateTerpeneV2(id: $id, terpene: $terpene) {
    id
  }
}
    `;
export type GqlUpdateTerpeneMutationFn = Apollo.MutationFunction<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>;

/**
 * __useUpdateTerpeneMutation__
 *
 * To run a mutation, you first call `useUpdateTerpeneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerpeneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerpeneMutation, { data, loading, error }] = useUpdateTerpeneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      terpene: // value for 'terpene'
 *   },
 * });
 */
export function useUpdateTerpeneMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>(UpdateTerpeneDocument, options);
      }
export type UpdateTerpeneMutationHookResult = ReturnType<typeof useUpdateTerpeneMutation>;
export type UpdateTerpeneMutationResult = Apollo.MutationResult<GqlUpdateTerpeneMutation>;
export type UpdateTerpeneMutationOptions = Apollo.BaseMutationOptions<GqlUpdateTerpeneMutation, GqlUpdateTerpeneMutationVariables>;
export const FilteredTerpenesDocument = gql`
    query FilteredTerpenes($filter: terpenesFilter, $sort: terpenesSort) {
  filteredTerpenes(filter: $filter, sort: $sort) {
    ...TerpeneFragment
    strains {
      _id
    }
  }
}
    ${TerpeneFragmentFragmentDoc}`;

/**
 * __useFilteredTerpenesQuery__
 *
 * To run a query within a React component, call `useFilteredTerpenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTerpenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTerpenesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFilteredTerpenesQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>(FilteredTerpenesDocument, options);
      }
export function useFilteredTerpenesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>(FilteredTerpenesDocument, options);
        }
export type FilteredTerpenesQueryHookResult = ReturnType<typeof useFilteredTerpenesQuery>;
export type FilteredTerpenesLazyQueryHookResult = ReturnType<typeof useFilteredTerpenesLazyQuery>;
export type FilteredTerpenesQueryResult = Apollo.QueryResult<GqlFilteredTerpenesQuery, GqlFilteredTerpenesQueryVariables>;
export const GetTerpeneDocument = gql`
    query GetTerpene($id: String!) {
  getTerpene(id: $id) {
    ...TerpeneFragment
  }
}
    ${TerpeneFragmentFragmentDoc}`;

/**
 * __useGetTerpeneQuery__
 *
 * To run a query within a React component, call `useGetTerpeneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerpeneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerpeneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTerpeneQuery(baseOptions: Apollo.QueryHookOptions<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>(GetTerpeneDocument, options);
      }
export function useGetTerpeneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>(GetTerpeneDocument, options);
        }
export type GetTerpeneQueryHookResult = ReturnType<typeof useGetTerpeneQuery>;
export type GetTerpeneLazyQueryHookResult = ReturnType<typeof useGetTerpeneLazyQuery>;
export type GetTerpeneQueryResult = Apollo.QueryResult<GqlGetTerpeneQuery, GqlGetTerpeneQueryVariables>;
export const ConsumerSignupDocument = gql`
    mutation ConsumerSignup($input: consumerSignupInput!, $turnstileToken: String, $publicContextSessionId: String) {
  consumerSignup(
    input: $input
    turnstileToken: $turnstileToken
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    user {
      ...consumerUserFragment
    }
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;
export type GqlConsumerSignupMutationFn = Apollo.MutationFunction<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>;

/**
 * __useConsumerSignupMutation__
 *
 * To run a mutation, you first call `useConsumerSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerSignupMutation, { data, loading, error }] = useConsumerSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      turnstileToken: // value for 'turnstileToken'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useConsumerSignupMutation(baseOptions?: Apollo.MutationHookOptions<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>(ConsumerSignupDocument, options);
      }
export type ConsumerSignupMutationHookResult = ReturnType<typeof useConsumerSignupMutation>;
export type ConsumerSignupMutationResult = Apollo.MutationResult<GqlConsumerSignupMutation>;
export type ConsumerSignupMutationOptions = Apollo.BaseMutationOptions<GqlConsumerSignupMutation, GqlConsumerSignupMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: usersCreateInput!) {
  createUser(user: $input) {
    audioNotificationsOnNewArrivalsDisabled
    audioNotificationsOnNewOrdersDisabled
    chainID
    createdAt
    createdBy
    dispensaryId
    email
    fullName
    permissions {
      allLocations
      analytics
      billing
      customers
      dispensaryIds
      driver
      enterpriseAdmin
      menu
      menuReview
      orders
      promote
      settings
      superMenuReview
      users
    }
    phone
    roleAtDispensary
    type
  }
}
    `;
export type GqlCreateUserMutationFn = Apollo.MutationFunction<GqlCreateUserMutation, GqlCreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateUserMutation, GqlCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateUserMutation, GqlCreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<GqlCreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<GqlCreateUserMutation, GqlCreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($input: usersDeleteInput!) {
  deleteUser(user: $input) {
    fullName
  }
}
    `;
export type GqlDeleteUserMutationFn = Apollo.MutationFunction<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<GqlDeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<GqlDeleteUserMutation, GqlDeleteUserMutationVariables>;
export const LoginAdminViaTokenDocument = gql`
    mutation LoginAdminViaToken($transferToken: String!) {
  loginAdminViaToken(transferToken: $transferToken) {
    ...adminIdentityFragment
  }
}
    ${AdminIdentityFragmentFragmentDoc}`;
export type GqlLoginAdminViaTokenMutationFn = Apollo.MutationFunction<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>;

/**
 * __useLoginAdminViaTokenMutation__
 *
 * To run a mutation, you first call `useLoginAdminViaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminViaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminViaTokenMutation, { data, loading, error }] = useLoginAdminViaTokenMutation({
 *   variables: {
 *      transferToken: // value for 'transferToken'
 *   },
 * });
 */
export function useLoginAdminViaTokenMutation(baseOptions?: Apollo.MutationHookOptions<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>(LoginAdminViaTokenDocument, options);
      }
export type LoginAdminViaTokenMutationHookResult = ReturnType<typeof useLoginAdminViaTokenMutation>;
export type LoginAdminViaTokenMutationResult = Apollo.MutationResult<GqlLoginAdminViaTokenMutation>;
export type LoginAdminViaTokenMutationOptions = Apollo.BaseMutationOptions<GqlLoginAdminViaTokenMutation, GqlLoginAdminViaTokenMutationVariables>;
export const LoginAdminDocument = gql`
    mutation LoginAdmin($email: String!, $password: String!) {
  loginAdmin(email: $email, password: $password) {
    ...adminIdentityFragment
  }
}
    ${AdminIdentityFragmentFragmentDoc}`;
export type GqlLoginAdminMutationFn = Apollo.MutationFunction<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>;

/**
 * __useLoginAdminMutation__
 *
 * To run a mutation, you first call `useLoginAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminMutation, { data, loading, error }] = useLoginAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminMutation(baseOptions?: Apollo.MutationHookOptions<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>(LoginAdminDocument, options);
      }
export type LoginAdminMutationHookResult = ReturnType<typeof useLoginAdminMutation>;
export type LoginAdminMutationResult = Apollo.MutationResult<GqlLoginAdminMutation>;
export type LoginAdminMutationOptions = Apollo.BaseMutationOptions<GqlLoginAdminMutation, GqlLoginAdminMutationVariables>;
export const LoginConsumerDocument = gql`
    mutation LoginConsumer($email: String!, $password: String!, $turnstileToken: String, $dispensaryId: String, $publicContextSessionId: String) {
  loginConsumer(
    email: $email
    password: $password
    turnstileToken: $turnstileToken
    dispensaryId: $dispensaryId
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    transferToken
    user {
      ...consumerUserFragment
    }
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;
export type GqlLoginConsumerMutationFn = Apollo.MutationFunction<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>;

/**
 * __useLoginConsumerMutation__
 *
 * To run a mutation, you first call `useLoginConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginConsumerMutation, { data, loading, error }] = useLoginConsumerMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      turnstileToken: // value for 'turnstileToken'
 *      dispensaryId: // value for 'dispensaryId'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useLoginConsumerMutation(baseOptions?: Apollo.MutationHookOptions<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>(LoginConsumerDocument, options);
      }
export type LoginConsumerMutationHookResult = ReturnType<typeof useLoginConsumerMutation>;
export type LoginConsumerMutationResult = Apollo.MutationResult<GqlLoginConsumerMutation>;
export type LoginConsumerMutationOptions = Apollo.BaseMutationOptions<GqlLoginConsumerMutation, GqlLoginConsumerMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    message
    success
  }
}
    `;
export type GqlLogoutMutationFn = Apollo.MutationFunction<GqlLogoutMutation, GqlLogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<GqlLogoutMutation, GqlLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlLogoutMutation, GqlLogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<GqlLogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<GqlLogoutMutation, GqlLogoutMutationVariables>;
export const SendLoginCodeDocument = gql`
    mutation SendLoginCode($email: String!, $dispensaryId: String, $turnstileToken: String) {
  sendLoginCode(
    email: $email
    dispensaryId: $dispensaryId
    turnstileToken: $turnstileToken
  ) {
    success
    message
  }
}
    `;
export type GqlSendLoginCodeMutationFn = Apollo.MutationFunction<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>;

/**
 * __useSendLoginCodeMutation__
 *
 * To run a mutation, you first call `useSendLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLoginCodeMutation, { data, loading, error }] = useSendLoginCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      dispensaryId: // value for 'dispensaryId'
 *      turnstileToken: // value for 'turnstileToken'
 *   },
 * });
 */
export function useSendLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>(SendLoginCodeDocument, options);
      }
export type SendLoginCodeMutationHookResult = ReturnType<typeof useSendLoginCodeMutation>;
export type SendLoginCodeMutationResult = Apollo.MutationResult<GqlSendLoginCodeMutation>;
export type SendLoginCodeMutationOptions = Apollo.BaseMutationOptions<GqlSendLoginCodeMutation, GqlSendLoginCodeMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: usersUpdateInput!) {
  updateUser(user: $input) {
    audioNotificationsOnNewArrivalsDisabled
    audioNotificationsOnNewOrdersDisabled
    chainID
    createdAt
    createdBy
    dispensaryId
    email
    fullName
    isWeeklyReportEnabled
    permissions {
      allLocations
      analytics
      billing
      customers
      dispensaryIds
      driver
      enterpriseAdmin
      menu
      menuReview
      orders
      promote
      settings
      superMenuReview
      users
    }
    phone
    roleAtDispensary
    type
  }
}
    `;
export type GqlUpdateUserMutationFn = Apollo.MutationFunction<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<GqlUpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<GqlUpdateUserMutation, GqlUpdateUserMutationVariables>;
export const VerifyLoginCodeDocument = gql`
    mutation VerifyLoginCode($email: String!, $code: String!, $dispensaryId: String, $publicContextSessionId: String) {
  verifyLoginCode(
    email: $email
    code: $code
    dispensaryId: $dispensaryId
    publicContextSessionId: $publicContextSessionId
  ) {
    accessToken
    transferToken
    isNewUser
    user {
      ...consumerUserFragment
    }
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;
export type GqlVerifyLoginCodeMutationFn = Apollo.MutationFunction<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>;

/**
 * __useVerifyLoginCodeMutation__
 *
 * To run a mutation, you first call `useVerifyLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyLoginCodeMutation, { data, loading, error }] = useVerifyLoginCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *      dispensaryId: // value for 'dispensaryId'
 *      publicContextSessionId: // value for 'publicContextSessionId'
 *   },
 * });
 */
export function useVerifyLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>(VerifyLoginCodeDocument, options);
      }
export type VerifyLoginCodeMutationHookResult = ReturnType<typeof useVerifyLoginCodeMutation>;
export type VerifyLoginCodeMutationResult = Apollo.MutationResult<GqlVerifyLoginCodeMutation>;
export type VerifyLoginCodeMutationOptions = Apollo.BaseMutationOptions<GqlVerifyLoginCodeMutation, GqlVerifyLoginCodeMutationVariables>;
export const MeConsumerDocument = gql`
    query MeConsumer {
  meConsumer {
    ...consumerUserFragment
  }
}
    ${ConsumerUserFragmentFragmentDoc}`;

/**
 * __useMeConsumerQuery__
 *
 * To run a query within a React component, call `useMeConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeConsumerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeConsumerQuery(baseOptions?: Apollo.QueryHookOptions<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>(MeConsumerDocument, options);
      }
export function useMeConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>(MeConsumerDocument, options);
        }
export type MeConsumerQueryHookResult = ReturnType<typeof useMeConsumerQuery>;
export type MeConsumerLazyQueryHookResult = ReturnType<typeof useMeConsumerLazyQuery>;
export type MeConsumerQueryResult = Apollo.QueryResult<GqlMeConsumerQuery, GqlMeConsumerQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: ordersCreateInput!, $turnstileToken: String) {
  createOrderV2(order: $input, turnstileToken: $turnstileToken) {
    valid
    errors {
      name
      path
      message
      params
      extensions
    }
    order {
      updateOrderToken
      paymentMethod
      paymentMethodId
      coupon {
        _id
      }
      tipValue {
        percent
        dollar
      }
      createdAt
      creditTotal
      customer {
        _id
        profile {
          medicalCard {
            expirationDate
            number
            state
            photo
          }
          driversLicense
          photoId
        }
      }
      medicalOrder
      medicalCard {
        expirationDate
        number
        state
        photo
      }
      mixAndMatch
      durationEstimates {
        delivery {
          lowInMinutes
          highInMinutes
        }
        pickup {
          lowInMinutes
          highInMinutes
        }
      }
      deliveryInfo {
        address
        apartmentNum
        deliveryAddress
        deliveryOption
        lastSearchedAddress
        nonDeliveryAddress
        location {
          ln1
          ln2
          city
          state
          zipcode
        }
      }
      otherFees
      deliveryFee
      dispensary {
        _id
        cName
        name
        phone
        address
        offerDelivery
        alt36
        check
        creditCardAtDoor
        customDomainSettings {
          domain
        }
        plusSettings {
          checkoutUrl
          defaultReturnUrl
        }
        payOnlineHypur
        payOnlineMerrco
        creditCardByPhone
        debitOnly
        linx
        canPay
        paytender
        aeropay
        deliveryMin
        timezone
        deliveryHours {
          Monday {
            end
            start
          }
          Tuesday {
            end
            start
          }
          Wednesday {
            end
            start
          }
          Thursday {
            end
            start
          }
          Friday {
            end
            start
          }
          Saturday {
            end
            start
          }
          Sunday {
            end
            start
          }
        }
        pickupHours {
          Monday {
            end
            start
          }
          Tuesday {
            end
            start
          }
          Wednesday {
            end
            start
          }
          Thursday {
            end
            start
          }
          Friday {
            end
            start
          }
          Saturday {
            end
            start
          }
          Sunday {
            end
            start
          }
        }
        feeTiers {
          fee
          max
          min
        }
        featureFlags {
          hideDeliveryEstimate
        }
      }
      id
      orderId
      orders {
        basePrice
        option
        price
        product {
          _id
          Name
          type
          strainType
        }
        quantity
      }
      receipt
      specialInstructions
      status
      statusTimes
      statusEvents {
        event
        at
        by
        byType
      }
      taxAmount
      cannabisTax
      tipAmount
      subtotal
      totalCost
      guestCustomer {
        phone
        firstName
        lastName
        email
        birthMonth
        birthDay
        birthYear
      }
      isKioskOrder
      isPreviewOrder
      isGuestOrder
      isAfterHoursOrder
      messages
      destinationTerminal
      customerState
      salesTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      cannabisTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      bottleDepositTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      appliedRewards {
        id
        copy
        available
        value
        operator
        brand
        discountId
      }
      isPTPOT
    }
  }
}
    `;
export type GqlCreateOrderMutationFn = Apollo.MutationFunction<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      turnstileToken: // value for 'turnstileToken'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<GqlCreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<GqlCreateOrderMutation, GqlCreateOrderMutationVariables>;
export const UpdateKioskOrderPaymentDocument = gql`
    mutation UpdateKioskOrderPayment($input: updateKioskOrderPaymentInput!) {
  updateKioskOrderPayment(input: $input) {
    success
  }
}
    `;
export type GqlUpdateKioskOrderPaymentMutationFn = Apollo.MutationFunction<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>;

/**
 * __useUpdateKioskOrderPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateKioskOrderPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKioskOrderPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKioskOrderPaymentMutation, { data, loading, error }] = useUpdateKioskOrderPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKioskOrderPaymentMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>(UpdateKioskOrderPaymentDocument, options);
      }
export type UpdateKioskOrderPaymentMutationHookResult = ReturnType<typeof useUpdateKioskOrderPaymentMutation>;
export type UpdateKioskOrderPaymentMutationResult = Apollo.MutationResult<GqlUpdateKioskOrderPaymentMutation>;
export type UpdateKioskOrderPaymentMutationOptions = Apollo.BaseMutationOptions<GqlUpdateKioskOrderPaymentMutation, GqlUpdateKioskOrderPaymentMutationVariables>;
export const GenerateHypurRedirectV3Document = gql`
    mutation GenerateHypurRedirectV3($dispensaryId: String!, $hostname: String, $embedded: Boolean!) {
  generateHypurRedirectV3(
    dispensaryId: $dispensaryId
    hostname: $hostname
    embedded: $embedded
  ) {
    url
  }
}
    `;
export type GqlGenerateHypurRedirectV3MutationFn = Apollo.MutationFunction<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>;

/**
 * __useGenerateHypurRedirectV3Mutation__
 *
 * To run a mutation, you first call `useGenerateHypurRedirectV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHypurRedirectV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHypurRedirectV3Mutation, { data, loading, error }] = useGenerateHypurRedirectV3Mutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      hostname: // value for 'hostname'
 *      embedded: // value for 'embedded'
 *   },
 * });
 */
export function useGenerateHypurRedirectV3Mutation(baseOptions?: Apollo.MutationHookOptions<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>(GenerateHypurRedirectV3Document, options);
      }
export type GenerateHypurRedirectV3MutationHookResult = ReturnType<typeof useGenerateHypurRedirectV3Mutation>;
export type GenerateHypurRedirectV3MutationResult = Apollo.MutationResult<GqlGenerateHypurRedirectV3Mutation>;
export type GenerateHypurRedirectV3MutationOptions = Apollo.BaseMutationOptions<GqlGenerateHypurRedirectV3Mutation, GqlGenerateHypurRedirectV3MutationVariables>;
export const GetDispensaryCharitiesDocument = gql`
    query GetDispensaryCharities($dispensaryId: String!, $menuType: String!) {
  getDispensaryCharities(dispensaryId: $dispensaryId, menuType: $menuType) {
    name
    description
    websiteUrl
    logoUrl
    isActive
    feeDonationId
  }
}
    `;

/**
 * __useGetDispensaryCharitiesQuery__
 *
 * To run a query within a React component, call `useGetDispensaryCharitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispensaryCharitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispensaryCharitiesQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      menuType: // value for 'menuType'
 *   },
 * });
 */
export function useGetDispensaryCharitiesQuery(baseOptions: Apollo.QueryHookOptions<GqlGetDispensaryCharitiesQuery, GqlGetDispensaryCharitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetDispensaryCharitiesQuery, GqlGetDispensaryCharitiesQueryVariables>(GetDispensaryCharitiesDocument, options);
      }
export function useGetDispensaryCharitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetDispensaryCharitiesQuery, GqlGetDispensaryCharitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetDispensaryCharitiesQuery, GqlGetDispensaryCharitiesQueryVariables>(GetDispensaryCharitiesDocument, options);
        }
export type GetDispensaryCharitiesQueryHookResult = ReturnType<typeof useGetDispensaryCharitiesQuery>;
export type GetDispensaryCharitiesLazyQueryHookResult = ReturnType<typeof useGetDispensaryCharitiesLazyQuery>;
export type GetDispensaryCharitiesQueryResult = Apollo.QueryResult<GqlGetDispensaryCharitiesQuery, GqlGetDispensaryCharitiesQueryVariables>;
export const CheckAllotmentDocument = gql`
    query CheckAllotment($input: AllotmentCheckInput!) {
  checkAllotment(input: $input) {
    status
    details {
      category
      parentCategory
      limit
      status
      used
      usedThisCycle
      usedInCart
      remainingThisCycle
      remainingWithCart
      unit
      isUnlimited
    }
    error
  }
}
    `;

/**
 * __useCheckAllotmentQuery__
 *
 * To run a query within a React component, call `useCheckAllotmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAllotmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAllotmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckAllotmentQuery(baseOptions: Apollo.QueryHookOptions<GqlCheckAllotmentQuery, GqlCheckAllotmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCheckAllotmentQuery, GqlCheckAllotmentQueryVariables>(CheckAllotmentDocument, options);
      }
export function useCheckAllotmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCheckAllotmentQuery, GqlCheckAllotmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCheckAllotmentQuery, GqlCheckAllotmentQueryVariables>(CheckAllotmentDocument, options);
        }
export type CheckAllotmentQueryHookResult = ReturnType<typeof useCheckAllotmentQuery>;
export type CheckAllotmentLazyQueryHookResult = ReturnType<typeof useCheckAllotmentLazyQuery>;
export type CheckAllotmentQueryResult = Apollo.QueryResult<GqlCheckAllotmentQuery, GqlCheckAllotmentQueryVariables>;
export const CheckoutDocument = gql`
    query Checkout($checkoutId: String!, $dispensaryId: String!) {
  getCheckout(checkoutId: $checkoutId, dispensaryId: $dispensaryId) {
    id
    address {
      deliverable
      formatted
      geometry {
        coordinates
        type
      }
      street1
      street2
      city
      state
      valid
      zip
    }
    pricingType
    orderType
    items {
      id
      option
      productId
      product {
        ...consumerBaseProductFragment
      }
      quantity
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions: Apollo.QueryHookOptions<GqlCheckoutQuery, GqlCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCheckoutQuery, GqlCheckoutQueryVariables>(CheckoutDocument, options);
      }
export function useCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCheckoutQuery, GqlCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCheckoutQuery, GqlCheckoutQueryVariables>(CheckoutDocument, options);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutQueryResult = Apollo.QueryResult<GqlCheckoutQuery, GqlCheckoutQueryVariables>;
export const UpdateCheckoutDocument = gql`
    mutation UpdateCheckout($dispensaryId: String!, $checkoutId: String!, $address: CheckoutAddressInput, $orderType: String!, $pricingType: String) {
  updateCheckout(
    dispensaryId: $dispensaryId
    checkoutId: $checkoutId
    address: $address
    orderType: $orderType
    pricingType: $pricingType
  ) {
    id
  }
}
    `;
export type GqlUpdateCheckoutMutationFn = Apollo.MutationFunction<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>;

/**
 * __useUpdateCheckoutMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutMutation, { data, loading, error }] = useUpdateCheckoutMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      checkoutId: // value for 'checkoutId'
 *      address: // value for 'address'
 *      orderType: // value for 'orderType'
 *      pricingType: // value for 'pricingType'
 *   },
 * });
 */
export function useUpdateCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>(UpdateCheckoutDocument, options);
      }
export type UpdateCheckoutMutationHookResult = ReturnType<typeof useUpdateCheckoutMutation>;
export type UpdateCheckoutMutationResult = Apollo.MutationResult<GqlUpdateCheckoutMutation>;
export type UpdateCheckoutMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCheckoutMutation, GqlUpdateCheckoutMutationVariables>;
export const UpdateCheckoutItemQuantityDocument = gql`
    mutation UpdateCheckoutItemQuantity($dispensaryId: String!, $checkoutId: String!, $productId: String!, $option: String, $quantity: Int!) {
  updateQuantity(
    dispensaryId: $dispensaryId
    checkoutId: $checkoutId
    productId: $productId
    option: $option
    quantity: $quantity
  ) {
    id
  }
}
    `;
export type GqlUpdateCheckoutItemQuantityMutationFn = Apollo.MutationFunction<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>;

/**
 * __useUpdateCheckoutItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutItemQuantityMutation, { data, loading, error }] = useUpdateCheckoutItemQuantityMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      checkoutId: // value for 'checkoutId'
 *      productId: // value for 'productId'
 *      option: // value for 'option'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateCheckoutItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>(UpdateCheckoutItemQuantityDocument, options);
      }
export type UpdateCheckoutItemQuantityMutationHookResult = ReturnType<typeof useUpdateCheckoutItemQuantityMutation>;
export type UpdateCheckoutItemQuantityMutationResult = Apollo.MutationResult<GqlUpdateCheckoutItemQuantityMutation>;
export type UpdateCheckoutItemQuantityMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCheckoutItemQuantityMutation, GqlUpdateCheckoutItemQuantityMutationVariables>;
export const RemoveCheckoutItemDocument = gql`
    mutation RemoveCheckoutItem($checkoutId: String!, $dispensaryId: String!, $productId: String!, $option: String) {
  removeItem(
    checkoutId: $checkoutId
    dispensaryId: $dispensaryId
    productId: $productId
    option: $option
  ) {
    id
  }
}
    `;
export type GqlRemoveCheckoutItemMutationFn = Apollo.MutationFunction<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>;

/**
 * __useRemoveCheckoutItemMutation__
 *
 * To run a mutation, you first call `useRemoveCheckoutItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCheckoutItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCheckoutItemMutation, { data, loading, error }] = useRemoveCheckoutItemMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      dispensaryId: // value for 'dispensaryId'
 *      productId: // value for 'productId'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useRemoveCheckoutItemMutation(baseOptions?: Apollo.MutationHookOptions<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>(RemoveCheckoutItemDocument, options);
      }
export type RemoveCheckoutItemMutationHookResult = ReturnType<typeof useRemoveCheckoutItemMutation>;
export type RemoveCheckoutItemMutationResult = Apollo.MutationResult<GqlRemoveCheckoutItemMutation>;
export type RemoveCheckoutItemMutationOptions = Apollo.BaseMutationOptions<GqlRemoveCheckoutItemMutation, GqlRemoveCheckoutItemMutationVariables>;
export const GetAllCitiesByStateDocument = gql`
    query getAllCitiesByState {
  statesWithDispensaries {
    cities
    name
    country
  }
}
    `;

/**
 * __useGetAllCitiesByStateQuery__
 *
 * To run a query within a React component, call `useGetAllCitiesByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCitiesByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCitiesByStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCitiesByStateQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>(GetAllCitiesByStateDocument, options);
      }
export function useGetAllCitiesByStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>(GetAllCitiesByStateDocument, options);
        }
export type GetAllCitiesByStateQueryHookResult = ReturnType<typeof useGetAllCitiesByStateQuery>;
export type GetAllCitiesByStateLazyQueryHookResult = ReturnType<typeof useGetAllCitiesByStateLazyQuery>;
export type GetAllCitiesByStateQueryResult = Apollo.QueryResult<GqlGetAllCitiesByStateQuery, GqlGetAllCitiesByStateQueryVariables>;
export const GetCitiesWithDispensariesDocument = gql`
    query GetCitiesWithDispensaries {
  statesWithDispensaries {
    cities
    name
    country
  }
}
    `;

/**
 * __useGetCitiesWithDispensariesQuery__
 *
 * To run a query within a React component, call `useGetCitiesWithDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesWithDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesWithDispensariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCitiesWithDispensariesQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>(GetCitiesWithDispensariesDocument, options);
      }
export function useGetCitiesWithDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>(GetCitiesWithDispensariesDocument, options);
        }
export type GetCitiesWithDispensariesQueryHookResult = ReturnType<typeof useGetCitiesWithDispensariesQuery>;
export type GetCitiesWithDispensariesLazyQueryHookResult = ReturnType<typeof useGetCitiesWithDispensariesLazyQuery>;
export type GetCitiesWithDispensariesQueryResult = Apollo.QueryResult<GqlGetCitiesWithDispensariesQuery, GqlGetCitiesWithDispensariesQueryVariables>;
export const MostPurchasedProductIdsDocument = gql`
    query MostPurchasedProductIds($dispensaryId: String!) {
  getMostPurchasedProducts(dispensaryId: $dispensaryId) {
    id
  }
}
    `;

/**
 * __useMostPurchasedProductIdsQuery__
 *
 * To run a query within a React component, call `useMostPurchasedProductIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostPurchasedProductIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostPurchasedProductIdsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useMostPurchasedProductIdsQuery(baseOptions: Apollo.QueryHookOptions<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>(MostPurchasedProductIdsDocument, options);
      }
export function useMostPurchasedProductIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>(MostPurchasedProductIdsDocument, options);
        }
export type MostPurchasedProductIdsQueryHookResult = ReturnType<typeof useMostPurchasedProductIdsQuery>;
export type MostPurchasedProductIdsLazyQueryHookResult = ReturnType<typeof useMostPurchasedProductIdsLazyQuery>;
export type MostPurchasedProductIdsQueryResult = Apollo.QueryResult<GqlMostPurchasedProductIdsQuery, GqlMostPurchasedProductIdsQueryVariables>;
export const RecentlyViewedProductsDocument = gql`
    query RecentlyViewedProducts($dispensaryId: String!) {
  getRecentlyViewedProducts(dispensaryId: $dispensaryId) {
    id
  }
}
    `;

/**
 * __useRecentlyViewedProductsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedProductsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useRecentlyViewedProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>(RecentlyViewedProductsDocument, options);
      }
export function useRecentlyViewedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>(RecentlyViewedProductsDocument, options);
        }
export type RecentlyViewedProductsQueryHookResult = ReturnType<typeof useRecentlyViewedProductsQuery>;
export type RecentlyViewedProductsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedProductsLazyQuery>;
export type RecentlyViewedProductsQueryResult = Apollo.QueryResult<GqlRecentlyViewedProductsQuery, GqlRecentlyViewedProductsQueryVariables>;
export const ProductDemandCountsDocument = gql`
    query ProductDemandCounts($dispensaryId: String!, $productIds: [String!]!) {
  getProductDemandCounts(dispensaryId: $dispensaryId, productIds: $productIds) {
    id
    count
  }
}
    `;

/**
 * __useProductDemandCountsQuery__
 *
 * To run a query within a React component, call `useProductDemandCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDemandCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDemandCountsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useProductDemandCountsQuery(baseOptions: Apollo.QueryHookOptions<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>(ProductDemandCountsDocument, options);
      }
export function useProductDemandCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>(ProductDemandCountsDocument, options);
        }
export type ProductDemandCountsQueryHookResult = ReturnType<typeof useProductDemandCountsQuery>;
export type ProductDemandCountsLazyQueryHookResult = ReturnType<typeof useProductDemandCountsLazyQuery>;
export type ProductDemandCountsQueryResult = Apollo.QueryResult<GqlProductDemandCountsQuery, GqlProductDemandCountsQueryVariables>;
export const ConsumerPosOrdersDocument = gql`
    query ConsumerPosOrders($dispensaryId: String!, $pagination: paginationInput) {
  consumerPosOrders(dispensaryId: $dispensaryId, pagination: $pagination) {
    orders {
      ...PosOrderFields
    }
    meta {
      totalCount
    }
  }
}
    ${PosOrderFieldsFragmentDoc}`;

/**
 * __useConsumerPosOrdersQuery__
 *
 * To run a query within a React component, call `useConsumerPosOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerPosOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerPosOrdersQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useConsumerPosOrdersQuery(baseOptions: Apollo.QueryHookOptions<GqlConsumerPosOrdersQuery, GqlConsumerPosOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlConsumerPosOrdersQuery, GqlConsumerPosOrdersQueryVariables>(ConsumerPosOrdersDocument, options);
      }
export function useConsumerPosOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlConsumerPosOrdersQuery, GqlConsumerPosOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlConsumerPosOrdersQuery, GqlConsumerPosOrdersQueryVariables>(ConsumerPosOrdersDocument, options);
        }
export type ConsumerPosOrdersQueryHookResult = ReturnType<typeof useConsumerPosOrdersQuery>;
export type ConsumerPosOrdersLazyQueryHookResult = ReturnType<typeof useConsumerPosOrdersLazyQuery>;
export type ConsumerPosOrdersQueryResult = Apollo.QueryResult<GqlConsumerPosOrdersQuery, GqlConsumerPosOrdersQueryVariables>;
export const ConsumerPosOrderDocument = gql`
    query ConsumerPosOrder($dispensaryId: String!, $id: String!) {
  consumerPosOrder(dispensaryId: $dispensaryId, id: $id) {
    ...PosOrderFields
  }
}
    ${PosOrderFieldsFragmentDoc}`;

/**
 * __useConsumerPosOrderQuery__
 *
 * To run a query within a React component, call `useConsumerPosOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerPosOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerPosOrderQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsumerPosOrderQuery(baseOptions: Apollo.QueryHookOptions<GqlConsumerPosOrderQuery, GqlConsumerPosOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlConsumerPosOrderQuery, GqlConsumerPosOrderQueryVariables>(ConsumerPosOrderDocument, options);
      }
export function useConsumerPosOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlConsumerPosOrderQuery, GqlConsumerPosOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlConsumerPosOrderQuery, GqlConsumerPosOrderQueryVariables>(ConsumerPosOrderDocument, options);
        }
export type ConsumerPosOrderQueryHookResult = ReturnType<typeof useConsumerPosOrderQuery>;
export type ConsumerPosOrderLazyQueryHookResult = ReturnType<typeof useConsumerPosOrderLazyQuery>;
export type ConsumerPosOrderQueryResult = Apollo.QueryResult<GqlConsumerPosOrderQuery, GqlConsumerPosOrderQueryVariables>;
export const DispensariesForChainDocument = gql`
    query DispensariesForChain($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    id
    name
    cName
    status
    chain
  }
}
    `;

/**
 * __useDispensariesForChainQuery__
 *
 * To run a query within a React component, call `useDispensariesForChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispensariesForChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispensariesForChainQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useDispensariesForChainQuery(baseOptions: Apollo.QueryHookOptions<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>(DispensariesForChainDocument, options);
      }
export function useDispensariesForChainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>(DispensariesForChainDocument, options);
        }
export type DispensariesForChainQueryHookResult = ReturnType<typeof useDispensariesForChainQuery>;
export type DispensariesForChainLazyQueryHookResult = ReturnType<typeof useDispensariesForChainLazyQuery>;
export type DispensariesForChainQueryResult = Apollo.QueryResult<GqlDispensariesForChainQuery, GqlDispensariesForChainQueryVariables>;
export const OrdersForConsumerInChainDocument = gql`
    query OrdersForConsumerInChain($ordersFilter: ordersFilterInput!, $ordersSort: ordersSortInput, $ordersPagination: ordersPaginationInput) {
  filteredOrders(
    filter: $ordersFilter
    sort: $ordersSort
    pagination: $ordersPagination
  ) {
    queryInfo {
      totalCount
    }
    orders {
      coupon {
        _id
        active
        addedDate
        amount
        percentDiscount
        fixedDiscountInCents
        code
        dispensary
        expDate
        numAllowedUses
        numUses
        usedBy
      }
      createdAt
      credit
      durationEstimates {
        delivery {
          lowInMinutes
          highInMinutes
        }
        pickup {
          lowInMinutes
          highInMinutes
        }
      }
      deliveryFee
      dispensary {
        _id
        name
        cName
        phone
        logoImage
        address
        timezone
        featureFlags {
          hideDeliveryEstimate
        }
      }
      id
      customer {
        _id
        emails {
          address
        }
        profile {
          medicalCard {
            expirationDate
            number
            state
            photo
          }
          driversLicense
          photoId
          firstName
          lastName
          email
          phone
          birthday
        }
      }
      guestCustomer {
        firstName
        lastName
        email
        phone
        birthMonth
        birthDay
        birthYear
      }
      medicalOrder
      medicalCard {
        expirationDate
        number
        state
        photo
      }
      mixAndMatch
      orderId
      orders {
        basePrice
        option
        price
        additionalOption
        product {
          _id
          Name
          type
          Options
          Image
          AdditionalOptions
          brandName
          preTaxRecPrices
          preTaxMedPrices
        }
        quantity
      }
      specialInstructions
      status
      taxAmount
      cannabisTax
      bottleDepositTaxCents
      tipAmount
      paymentFee
      paymentMethod
      subtotal
      totalCost
      isPreviewOrder
      terminal
      autoConfirmed
      autoClosed
      isKioskOrder
      isAfterHoursOrder
      isCurbsidePickupOrder
      isDriveThruPickupOrder
      driversLicense
      deliveryInfo {
        address
        apartmentNum
        deliveryAddress
        deliveryOption
        lastSearchedAddress
        nonDeliveryAddress
        address
        location {
          lat
          lng
          ln1
          ln2
          city
          state
          zipcode
        }
      }
      cannabisTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      salesTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      bottleDepositTaxExistence {
        med {
          pos
          menu
          checkout
        }
        rec {
          pos
          menu
          checkout
        }
      }
      appliedRewards {
        copy
        value
        operator
      }
      reservation {
        startTimeISO
        endTimeISO
      }
    }
  }
}
    `;

/**
 * __useOrdersForConsumerInChainQuery__
 *
 * To run a query within a React component, call `useOrdersForConsumerInChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersForConsumerInChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersForConsumerInChainQuery({
 *   variables: {
 *      ordersFilter: // value for 'ordersFilter'
 *      ordersSort: // value for 'ordersSort'
 *      ordersPagination: // value for 'ordersPagination'
 *   },
 * });
 */
export function useOrdersForConsumerInChainQuery(baseOptions: Apollo.QueryHookOptions<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>(OrdersForConsumerInChainDocument, options);
      }
export function useOrdersForConsumerInChainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>(OrdersForConsumerInChainDocument, options);
        }
export type OrdersForConsumerInChainQueryHookResult = ReturnType<typeof useOrdersForConsumerInChainQuery>;
export type OrdersForConsumerInChainLazyQueryHookResult = ReturnType<typeof useOrdersForConsumerInChainLazyQuery>;
export type OrdersForConsumerInChainQueryResult = Apollo.QueryResult<GqlOrdersForConsumerInChainQuery, GqlOrdersForConsumerInChainQueryVariables>;
export const CreatePointsBoostDocument = gql`
    mutation CreatePointsBoost($input: CreatePointsBoostInput!) {
  createPointsBoost(input: $input) {
    success
    message
  }
}
    `;
export type GqlCreatePointsBoostMutationFn = Apollo.MutationFunction<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>;

/**
 * __useCreatePointsBoostMutation__
 *
 * To run a mutation, you first call `useCreatePointsBoostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointsBoostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointsBoostMutation, { data, loading, error }] = useCreatePointsBoostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePointsBoostMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>(CreatePointsBoostDocument, options);
      }
export type CreatePointsBoostMutationHookResult = ReturnType<typeof useCreatePointsBoostMutation>;
export type CreatePointsBoostMutationResult = Apollo.MutationResult<GqlCreatePointsBoostMutation>;
export type CreatePointsBoostMutationOptions = Apollo.BaseMutationOptions<GqlCreatePointsBoostMutation, GqlCreatePointsBoostMutationVariables>;
export const CreatePosMedUserDocument = gql`
    mutation CreatePOSMedUser($dispensaryId: String!, $user: CreatePOSMedUserInput!) {
  createPOSMedUser(dispensaryId: $dispensaryId, user: $user) {
    success
    message
  }
}
    `;
export type GqlCreatePosMedUserMutationFn = Apollo.MutationFunction<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>;

/**
 * __useCreatePosMedUserMutation__
 *
 * To run a mutation, you first call `useCreatePosMedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePosMedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPosMedUserMutation, { data, loading, error }] = useCreatePosMedUserMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreatePosMedUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>(CreatePosMedUserDocument, options);
      }
export type CreatePosMedUserMutationHookResult = ReturnType<typeof useCreatePosMedUserMutation>;
export type CreatePosMedUserMutationResult = Apollo.MutationResult<GqlCreatePosMedUserMutation>;
export type CreatePosMedUserMutationOptions = Apollo.BaseMutationOptions<GqlCreatePosMedUserMutation, GqlCreatePosMedUserMutationVariables>;
export const GetPosMedCardInfoDocument = gql`
    query GetPosMedCardInfo($dispensaryId: String!) {
  getPosMedCardInfo(dispensaryId: $dispensaryId) {
    number
    expirationDate
    valid
    message
  }
}
    `;

/**
 * __useGetPosMedCardInfoQuery__
 *
 * To run a query within a React component, call `useGetPosMedCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosMedCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosMedCardInfoQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetPosMedCardInfoQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>(GetPosMedCardInfoDocument, options);
      }
export function useGetPosMedCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>(GetPosMedCardInfoDocument, options);
        }
export type GetPosMedCardInfoQueryHookResult = ReturnType<typeof useGetPosMedCardInfoQuery>;
export type GetPosMedCardInfoLazyQueryHookResult = ReturnType<typeof useGetPosMedCardInfoLazyQuery>;
export type GetPosMedCardInfoQueryResult = Apollo.QueryResult<GqlGetPosMedCardInfoQuery, GqlGetPosMedCardInfoQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($profile: consumerUserProfileInput!) {
  updateProfileV2(profile: $profile) {
    success
  }
}
    `;
export type GqlUpdateProfileMutationFn = Apollo.MutationFunction<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<GqlUpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<GqlUpdateProfileMutation, GqlUpdateProfileMutationVariables>;
export const CreatePublicContextSessionDocument = gql`
    mutation CreatePublicContextSession($dispensaryId: String!) {
  createPublicContextSession(dispensaryId: $dispensaryId) {
    id
    dispensaryId
    status
    expiresAt
  }
}
    `;
export type GqlCreatePublicContextSessionMutationFn = Apollo.MutationFunction<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>;

/**
 * __useCreatePublicContextSessionMutation__
 *
 * To run a mutation, you first call `useCreatePublicContextSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicContextSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicContextSessionMutation, { data, loading, error }] = useCreatePublicContextSessionMutation({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCreatePublicContextSessionMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>(CreatePublicContextSessionDocument, options);
      }
export type CreatePublicContextSessionMutationHookResult = ReturnType<typeof useCreatePublicContextSessionMutation>;
export type CreatePublicContextSessionMutationResult = Apollo.MutationResult<GqlCreatePublicContextSessionMutation>;
export type CreatePublicContextSessionMutationOptions = Apollo.BaseMutationOptions<GqlCreatePublicContextSessionMutation, GqlCreatePublicContextSessionMutationVariables>;
export const UpdatePublicContextSessionDocument = gql`
    mutation UpdatePublicContextSession($id: String!, $loginMethodVerified: Boolean) {
  updatePublicContextSession(id: $id, loginMethodVerified: $loginMethodVerified) {
    id
    dispensaryId
    status
    expiresAt
    loginMethodVerified
    claimedByUserId
  }
}
    `;
export type GqlUpdatePublicContextSessionMutationFn = Apollo.MutationFunction<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>;

/**
 * __useUpdatePublicContextSessionMutation__
 *
 * To run a mutation, you first call `useUpdatePublicContextSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicContextSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicContextSessionMutation, { data, loading, error }] = useUpdatePublicContextSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      loginMethodVerified: // value for 'loginMethodVerified'
 *   },
 * });
 */
export function useUpdatePublicContextSessionMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>(UpdatePublicContextSessionDocument, options);
      }
export type UpdatePublicContextSessionMutationHookResult = ReturnType<typeof useUpdatePublicContextSessionMutation>;
export type UpdatePublicContextSessionMutationResult = Apollo.MutationResult<GqlUpdatePublicContextSessionMutation>;
export type UpdatePublicContextSessionMutationOptions = Apollo.BaseMutationOptions<GqlUpdatePublicContextSessionMutation, GqlUpdatePublicContextSessionMutationVariables>;
export const ClaimPublicContextSessionByPhoneDocument = gql`
    mutation ClaimPublicContextSessionByPhone($id: String!, $phone: String!) {
  claimPublicContextSessionByPhone(id: $id, phone: $phone) {
    id
    dispensaryId
    status
    expiresAt
    loginMethodVerified
    claimedByUserId
    accessToken
  }
}
    `;
export type GqlClaimPublicContextSessionByPhoneMutationFn = Apollo.MutationFunction<GqlClaimPublicContextSessionByPhoneMutation, GqlClaimPublicContextSessionByPhoneMutationVariables>;

/**
 * __useClaimPublicContextSessionByPhoneMutation__
 *
 * To run a mutation, you first call `useClaimPublicContextSessionByPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimPublicContextSessionByPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimPublicContextSessionByPhoneMutation, { data, loading, error }] = useClaimPublicContextSessionByPhoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useClaimPublicContextSessionByPhoneMutation(baseOptions?: Apollo.MutationHookOptions<GqlClaimPublicContextSessionByPhoneMutation, GqlClaimPublicContextSessionByPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlClaimPublicContextSessionByPhoneMutation, GqlClaimPublicContextSessionByPhoneMutationVariables>(ClaimPublicContextSessionByPhoneDocument, options);
      }
export type ClaimPublicContextSessionByPhoneMutationHookResult = ReturnType<typeof useClaimPublicContextSessionByPhoneMutation>;
export type ClaimPublicContextSessionByPhoneMutationResult = Apollo.MutationResult<GqlClaimPublicContextSessionByPhoneMutation>;
export type ClaimPublicContextSessionByPhoneMutationOptions = Apollo.BaseMutationOptions<GqlClaimPublicContextSessionByPhoneMutation, GqlClaimPublicContextSessionByPhoneMutationVariables>;
export const GetPublicContextSessionDocument = gql`
    query GetPublicContextSession($id: String!) {
  getPublicContextSession(id: $id) {
    id
    dispensaryId
    status
    expiresAt
    loginMethodVerified
    claimedByUserId
    accessToken
  }
}
    `;

/**
 * __useGetPublicContextSessionQuery__
 *
 * To run a query within a React component, call `useGetPublicContextSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicContextSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicContextSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublicContextSessionQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>(GetPublicContextSessionDocument, options);
      }
export function useGetPublicContextSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>(GetPublicContextSessionDocument, options);
        }
export type GetPublicContextSessionQueryHookResult = ReturnType<typeof useGetPublicContextSessionQuery>;
export type GetPublicContextSessionLazyQueryHookResult = ReturnType<typeof useGetPublicContextSessionLazyQuery>;
export type GetPublicContextSessionQueryResult = Apollo.QueryResult<GqlGetPublicContextSessionQuery, GqlGetPublicContextSessionQueryVariables>;
export const CreateInstoreCartUrlDocument = gql`
    mutation CreateInstoreCartUrl($orderId: String!) {
  createInstoreCartUrl(orderId: $orderId) {
    instoreCartUrl
  }
}
    `;
export type GqlCreateInstoreCartUrlMutationFn = Apollo.MutationFunction<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>;

/**
 * __useCreateInstoreCartUrlMutation__
 *
 * To run a mutation, you first call `useCreateInstoreCartUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstoreCartUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstoreCartUrlMutation, { data, loading, error }] = useCreateInstoreCartUrlMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateInstoreCartUrlMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>(CreateInstoreCartUrlDocument, options);
      }
export type CreateInstoreCartUrlMutationHookResult = ReturnType<typeof useCreateInstoreCartUrlMutation>;
export type CreateInstoreCartUrlMutationResult = Apollo.MutationResult<GqlCreateInstoreCartUrlMutation>;
export type CreateInstoreCartUrlMutationOptions = Apollo.BaseMutationOptions<GqlCreateInstoreCartUrlMutation, GqlCreateInstoreCartUrlMutationVariables>;
export const CreateBackInStockSubscriptionDocument = gql`
    mutation CreateBackInStockSubscription($productId: String!) {
  createBackInStockSubscription(productId: $productId) {
    success
  }
}
    `;
export type GqlCreateBackInStockSubscriptionMutationFn = Apollo.MutationFunction<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>;

/**
 * __useCreateBackInStockSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateBackInStockSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBackInStockSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBackInStockSubscriptionMutation, { data, loading, error }] = useCreateBackInStockSubscriptionMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCreateBackInStockSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>(CreateBackInStockSubscriptionDocument, options);
      }
export type CreateBackInStockSubscriptionMutationHookResult = ReturnType<typeof useCreateBackInStockSubscriptionMutation>;
export type CreateBackInStockSubscriptionMutationResult = Apollo.MutationResult<GqlCreateBackInStockSubscriptionMutation>;
export type CreateBackInStockSubscriptionMutationOptions = Apollo.BaseMutationOptions<GqlCreateBackInStockSubscriptionMutation, GqlCreateBackInStockSubscriptionMutationVariables>;
export const DeleteBackInStockSubscriptionDocument = gql`
    mutation DeleteBackInStockSubscription($productId: String!) {
  deleteBackInStockSubscription(productId: $productId) {
    success
  }
}
    `;
export type GqlDeleteBackInStockSubscriptionMutationFn = Apollo.MutationFunction<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>;

/**
 * __useDeleteBackInStockSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteBackInStockSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBackInStockSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBackInStockSubscriptionMutation, { data, loading, error }] = useDeleteBackInStockSubscriptionMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDeleteBackInStockSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>(DeleteBackInStockSubscriptionDocument, options);
      }
export type DeleteBackInStockSubscriptionMutationHookResult = ReturnType<typeof useDeleteBackInStockSubscriptionMutation>;
export type DeleteBackInStockSubscriptionMutationResult = Apollo.MutationResult<GqlDeleteBackInStockSubscriptionMutation>;
export type DeleteBackInStockSubscriptionMutationOptions = Apollo.BaseMutationOptions<GqlDeleteBackInStockSubscriptionMutation, GqlDeleteBackInStockSubscriptionMutationVariables>;
export const GetBackInStockSubscriptionStatusDocument = gql`
    query GetBackInStockSubscriptionStatus($productId: String!) {
  getBackInStockSubscriptionStatus(productId: $productId) {
    subscribed
  }
}
    `;

/**
 * __useGetBackInStockSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useGetBackInStockSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackInStockSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackInStockSubscriptionStatusQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetBackInStockSubscriptionStatusQuery(baseOptions: Apollo.QueryHookOptions<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>(GetBackInStockSubscriptionStatusDocument, options);
      }
export function useGetBackInStockSubscriptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>(GetBackInStockSubscriptionStatusDocument, options);
        }
export type GetBackInStockSubscriptionStatusQueryHookResult = ReturnType<typeof useGetBackInStockSubscriptionStatusQuery>;
export type GetBackInStockSubscriptionStatusLazyQueryHookResult = ReturnType<typeof useGetBackInStockSubscriptionStatusLazyQuery>;
export type GetBackInStockSubscriptionStatusQueryResult = Apollo.QueryResult<GqlGetBackInStockSubscriptionStatusQuery, GqlGetBackInStockSubscriptionStatusQueryVariables>;
export const GetCollectionDocument = gql`
    query GetCollection($dispensaryId: String!, $collectionId: String!) {
  getCollection(dispensaryId: $dispensaryId, collectionId: $collectionId) {
    id
    title
    description
    image
    customCategory
    enabled
    isExclusive
    cardBadgeColor
    isAccessibleToCurrentUser
    isOutlet
    outletTimerEnabled
    outletTimerMessage
    schedule {
      id
      startDate
      endDate
      timeRanges {
        id
        dayOfWeek
        startTime
        endTime
      }
    }
  }
}
    `;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>(GetCollectionDocument, options);
      }
export function useGetCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>(GetCollectionDocument, options);
        }
export type GetCollectionQueryHookResult = ReturnType<typeof useGetCollectionQuery>;
export type GetCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionLazyQuery>;
export type GetCollectionQueryResult = Apollo.QueryResult<GqlGetCollectionQuery, GqlGetCollectionQueryVariables>;
export const GetCollectionsDocument = gql`
    query GetCollections($dispensaryId: String!, $customCategory: Boolean) {
  getCollections(dispensaryId: $dispensaryId, customCategory: $customCategory) {
    customCategory
    enabled
    id
    navigationTitle
    slug
    title
    isExclusive
    cardBadgeColor
    isAccessibleToCurrentUser
  }
}
    `;

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      customCategory: // value for 'customCategory'
 *   },
 * });
 */
export function useGetCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>(GetCollectionsDocument, options);
      }
export function useGetCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>(GetCollectionsDocument, options);
        }
export type GetCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsQuery>;
export type GetCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsLazyQuery>;
export type GetCollectionsQueryResult = Apollo.QueryResult<GqlGetCollectionsQuery, GqlGetCollectionsQueryVariables>;
export const GetCollectionsNavigationDocument = gql`
    query GetCollectionsNavigation($dispensaryId: String!, $customCategory: Boolean, $enabled: Boolean, $activeOnly: Boolean) {
  getCollectionsNavigation(
    dispensaryId: $dispensaryId
    customCategory: $customCategory
    enabled: $enabled
    activeOnly: $activeOnly
  ) {
    id
    slug
    title
    cardDisplayName
    cardImage
    customCategory
    enabled
    navigationTitle
    isActive
    isOutlet
    schedule {
      id
      startDate
      endDate
      timeRanges {
        id
        dayOfWeek
        startTime
        endTime
      }
    }
  }
}
    `;

/**
 * __useGetCollectionsNavigationQuery__
 *
 * To run a query within a React component, call `useGetCollectionsNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsNavigationQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      customCategory: // value for 'customCategory'
 *      enabled: // value for 'enabled'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetCollectionsNavigationQuery(baseOptions: Apollo.QueryHookOptions<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>(GetCollectionsNavigationDocument, options);
      }
export function useGetCollectionsNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>(GetCollectionsNavigationDocument, options);
        }
export type GetCollectionsNavigationQueryHookResult = ReturnType<typeof useGetCollectionsNavigationQuery>;
export type GetCollectionsNavigationLazyQueryHookResult = ReturnType<typeof useGetCollectionsNavigationLazyQuery>;
export type GetCollectionsNavigationQueryResult = Apollo.QueryResult<GqlGetCollectionsNavigationQuery, GqlGetCollectionsNavigationQueryVariables>;
export const EnterpriseProductsDocument = gql`
    query EnterpriseProducts($enterpriseId: ID!) {
  enterpriseProductsV2(enterpriseId: $enterpriseId) {
    products {
      brandId
      brandName
      dispensaryProducts {
        brandId
        brandName
        dispensaryId
        id
        status
        enterpriseProductId
      }
      enterpriseProductId
      medicalOnly
      medicalPrices
      name
      options
      prices
      recOnly
      recPrices
      subcategory
      type
    }
  }
}
    `;

/**
 * __useEnterpriseProductsQuery__
 *
 * To run a query within a React component, call `useEnterpriseProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseProductsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useEnterpriseProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>(EnterpriseProductsDocument, options);
      }
export function useEnterpriseProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>(EnterpriseProductsDocument, options);
        }
export type EnterpriseProductsQueryHookResult = ReturnType<typeof useEnterpriseProductsQuery>;
export type EnterpriseProductsLazyQueryHookResult = ReturnType<typeof useEnterpriseProductsLazyQuery>;
export type EnterpriseProductsQueryResult = Apollo.QueryResult<GqlEnterpriseProductsQuery, GqlEnterpriseProductsQueryVariables>;
export const GetMenuSectionsDocument = gql`
    query GetMenuSections($dispensaryId: String!, $userSegmentIds: [String!]) {
  getMenuSections(dispensaryId: $dispensaryId, userSegmentIds: $userSegmentIds) {
    ...menuSectionFragment
  }
}
    ${MenuSectionFragmentFragmentDoc}`;

/**
 * __useGetMenuSectionsQuery__
 *
 * To run a query within a React component, call `useGetMenuSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuSectionsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      userSegmentIds: // value for 'userSegmentIds'
 *   },
 * });
 */
export function useGetMenuSectionsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetMenuSectionsQuery, GqlGetMenuSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetMenuSectionsQuery, GqlGetMenuSectionsQueryVariables>(GetMenuSectionsDocument, options);
      }
export function useGetMenuSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetMenuSectionsQuery, GqlGetMenuSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetMenuSectionsQuery, GqlGetMenuSectionsQueryVariables>(GetMenuSectionsDocument, options);
        }
export type GetMenuSectionsQueryHookResult = ReturnType<typeof useGetMenuSectionsQuery>;
export type GetMenuSectionsLazyQueryHookResult = ReturnType<typeof useGetMenuSectionsLazyQuery>;
export type GetMenuSectionsQueryResult = Apollo.QueryResult<GqlGetMenuSectionsQuery, GqlGetMenuSectionsQueryVariables>;
export const GetChainDispensariesDocument = gql`
    query getChainDispensaries($dispensaryFilter: dispensariesFilterInput!) {
  filteredDispensaries(filter: $dispensaryFilter) {
    id
    name
    phone
    cName
    status
    chain
    address
    distance
    logoImage
    location {
      ln1
      ln2
      city
      state
      country
      geometry {
        coordinates
      }
    }
    effectiveHours {
      deliveryHours {
        ...hourSetFragment
      }
      pickupHours {
        ...hourSetFragment
      }
    }
    deliveryHours {
      ...hourSetFragment
    }
    pickupHours {
      ...hourSetFragment
    }
    specialHours {
      name
      startDate
      endDate
      hoursPerDay {
        date
        pickupHours {
          active
          start
          end
        }
        deliveryHours {
          active
          start
          end
        }
      }
    }
    hoursSettings {
      inStorePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      curbsidePickup {
        ...hoursSettingsForOrderTypeFragment
      }
      driveThruPickup {
        ...hoursSettingsForOrderTypeFragment
      }
      delivery {
        ...hoursSettingsForOrderTypeFragment
      }
    }
    offerAnyPickupService
    orderTypesConfig {
      delivery {
        enabled
      }
    }
    orderTypesConfigV2 {
      inStorePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      curbsidePickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      driveThruPickup {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      delivery {
        enableASAPOrdering
        enableScheduledOrdering
        enableAfterHoursOrdering
      }
      offerAnyPickupService
      offerDeliveryService
    }
    enabledOrderTypes {
      pickup
      inStorePickup
      curbsidePickup
      driveThruPickup
      delivery
      kiosk
    }
    storeSettings {
      enableAfterHoursOrderingForDelivery
      enableAfterHoursOrderingForPickup
      enableScheduledOrderingForDelivery
      enableScheduledOrderingForPickup
    }
  }
}
    ${HourSetFragmentFragmentDoc}
${HoursSettingsForOrderTypeFragmentFragmentDoc}`;

/**
 * __useGetChainDispensariesQuery__
 *
 * To run a query within a React component, call `useGetChainDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainDispensariesQuery({
 *   variables: {
 *      dispensaryFilter: // value for 'dispensaryFilter'
 *   },
 * });
 */
export function useGetChainDispensariesQuery(baseOptions: Apollo.QueryHookOptions<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>(GetChainDispensariesDocument, options);
      }
export function useGetChainDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>(GetChainDispensariesDocument, options);
        }
export type GetChainDispensariesQueryHookResult = ReturnType<typeof useGetChainDispensariesQuery>;
export type GetChainDispensariesLazyQueryHookResult = ReturnType<typeof useGetChainDispensariesLazyQuery>;
export type GetChainDispensariesQueryResult = Apollo.QueryResult<GqlGetChainDispensariesQuery, GqlGetChainDispensariesQueryVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount {
  deleteAccount {
    success
    error
  }
}
    `;
export type GqlDeleteAccountMutationFn = Apollo.MutationFunction<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<GqlDeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<GqlDeleteAccountMutation, GqlDeleteAccountMutationVariables>;
export const GetIrlEventByDispensaryDocument = gql`
    query GetIrlEventByDispensary($irlEventId: ID!, $dispensaryId: String!) {
  getIrlEventByDispensary(irlEventId: $irlEventId, dispensaryId: $dispensaryId) {
    irlEventId
    hasIncentive
    headerImageUrl
    title
    description
    optInRequired
    isOpen
    shopNowUrl
  }
}
    `;

/**
 * __useGetIrlEventByDispensaryQuery__
 *
 * To run a query within a React component, call `useGetIrlEventByDispensaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIrlEventByDispensaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIrlEventByDispensaryQuery({
 *   variables: {
 *      irlEventId: // value for 'irlEventId'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetIrlEventByDispensaryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetIrlEventByDispensaryQuery, GqlGetIrlEventByDispensaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetIrlEventByDispensaryQuery, GqlGetIrlEventByDispensaryQueryVariables>(GetIrlEventByDispensaryDocument, options);
      }
export function useGetIrlEventByDispensaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetIrlEventByDispensaryQuery, GqlGetIrlEventByDispensaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetIrlEventByDispensaryQuery, GqlGetIrlEventByDispensaryQueryVariables>(GetIrlEventByDispensaryDocument, options);
        }
export type GetIrlEventByDispensaryQueryHookResult = ReturnType<typeof useGetIrlEventByDispensaryQuery>;
export type GetIrlEventByDispensaryLazyQueryHookResult = ReturnType<typeof useGetIrlEventByDispensaryLazyQuery>;
export type GetIrlEventByDispensaryQueryResult = Apollo.QueryResult<GqlGetIrlEventByDispensaryQuery, GqlGetIrlEventByDispensaryQueryVariables>;
export const GetIrlEventRewardByDispensaryDocument = gql`
    query GetIrlEventRewardByDispensary($irlEventId: ID!, $ecommUserId: String!, $dispensaryId: String!) {
  getIrlEventRewardByDispensary(
    irlEventId: $irlEventId
    ecommUserId: $ecommUserId
    dispensaryId: $dispensaryId
  ) {
    primary {
      title
      description
      rewardType
      rewardName
      expiry
      shopNowUrl
      rewardImageUrl
    }
  }
}
    `;

/**
 * __useGetIrlEventRewardByDispensaryQuery__
 *
 * To run a query within a React component, call `useGetIrlEventRewardByDispensaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIrlEventRewardByDispensaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIrlEventRewardByDispensaryQuery({
 *   variables: {
 *      irlEventId: // value for 'irlEventId'
 *      ecommUserId: // value for 'ecommUserId'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetIrlEventRewardByDispensaryQuery(baseOptions: Apollo.QueryHookOptions<GqlGetIrlEventRewardByDispensaryQuery, GqlGetIrlEventRewardByDispensaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetIrlEventRewardByDispensaryQuery, GqlGetIrlEventRewardByDispensaryQueryVariables>(GetIrlEventRewardByDispensaryDocument, options);
      }
export function useGetIrlEventRewardByDispensaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetIrlEventRewardByDispensaryQuery, GqlGetIrlEventRewardByDispensaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetIrlEventRewardByDispensaryQuery, GqlGetIrlEventRewardByDispensaryQueryVariables>(GetIrlEventRewardByDispensaryDocument, options);
        }
export type GetIrlEventRewardByDispensaryQueryHookResult = ReturnType<typeof useGetIrlEventRewardByDispensaryQuery>;
export type GetIrlEventRewardByDispensaryLazyQueryHookResult = ReturnType<typeof useGetIrlEventRewardByDispensaryLazyQuery>;
export type GetIrlEventRewardByDispensaryQueryResult = Apollo.QueryResult<GqlGetIrlEventRewardByDispensaryQuery, GqlGetIrlEventRewardByDispensaryQueryVariables>;
export const GetIrlEventRewardDocument = gql`
    query GetIrlEventReward($irlEventId: ID!, $ecommUserId: String!, $enterpriseId: String!, $isoRegionCode: String!) {
  getIrlEventReward(
    irlEventId: $irlEventId
    ecommUserId: $ecommUserId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
  ) {
    primary {
      title
      description
      rewardType
      rewardName
      expiry
      shopNowUrl
      rewardImageUrl
    }
  }
}
    `;

/**
 * __useGetIrlEventRewardQuery__
 *
 * To run a query within a React component, call `useGetIrlEventRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIrlEventRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIrlEventRewardQuery({
 *   variables: {
 *      irlEventId: // value for 'irlEventId'
 *      ecommUserId: // value for 'ecommUserId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *   },
 * });
 */
export function useGetIrlEventRewardQuery(baseOptions: Apollo.QueryHookOptions<GqlGetIrlEventRewardQuery, GqlGetIrlEventRewardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetIrlEventRewardQuery, GqlGetIrlEventRewardQueryVariables>(GetIrlEventRewardDocument, options);
      }
export function useGetIrlEventRewardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetIrlEventRewardQuery, GqlGetIrlEventRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetIrlEventRewardQuery, GqlGetIrlEventRewardQueryVariables>(GetIrlEventRewardDocument, options);
        }
export type GetIrlEventRewardQueryHookResult = ReturnType<typeof useGetIrlEventRewardQuery>;
export type GetIrlEventRewardLazyQueryHookResult = ReturnType<typeof useGetIrlEventRewardLazyQuery>;
export type GetIrlEventRewardQueryResult = Apollo.QueryResult<GqlGetIrlEventRewardQuery, GqlGetIrlEventRewardQueryVariables>;
export const GetIrlEventDocument = gql`
    query GetIrlEvent($irlEventId: ID!, $enterpriseId: String!, $isoRegionCode: String!) {
  getIrlEvent(
    irlEventId: $irlEventId
    enterpriseId: $enterpriseId
    isoRegionCode: $isoRegionCode
  ) {
    irlEventId
    hasIncentive
    headerImageUrl
    title
    description
    optInRequired
    isOpen
    shopNowUrl
  }
}
    `;

/**
 * __useGetIrlEventQuery__
 *
 * To run a query within a React component, call `useGetIrlEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIrlEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIrlEventQuery({
 *   variables: {
 *      irlEventId: // value for 'irlEventId'
 *      enterpriseId: // value for 'enterpriseId'
 *      isoRegionCode: // value for 'isoRegionCode'
 *   },
 * });
 */
export function useGetIrlEventQuery(baseOptions: Apollo.QueryHookOptions<GqlGetIrlEventQuery, GqlGetIrlEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetIrlEventQuery, GqlGetIrlEventQueryVariables>(GetIrlEventDocument, options);
      }
export function useGetIrlEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetIrlEventQuery, GqlGetIrlEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetIrlEventQuery, GqlGetIrlEventQueryVariables>(GetIrlEventDocument, options);
        }
export type GetIrlEventQueryHookResult = ReturnType<typeof useGetIrlEventQuery>;
export type GetIrlEventLazyQueryHookResult = ReturnType<typeof useGetIrlEventLazyQuery>;
export type GetIrlEventQueryResult = Apollo.QueryResult<GqlGetIrlEventQuery, GqlGetIrlEventQueryVariables>;
export const TrackIrlEventByDispensaryDocument = gql`
    mutation TrackIrlEventByDispensary($input: TrackIrlEventByDispensaryInput!) {
  trackIrlEventByDispensary(input: $input) {
    success
  }
}
    `;
export type GqlTrackIrlEventByDispensaryMutationFn = Apollo.MutationFunction<GqlTrackIrlEventByDispensaryMutation, GqlTrackIrlEventByDispensaryMutationVariables>;

/**
 * __useTrackIrlEventByDispensaryMutation__
 *
 * To run a mutation, you first call `useTrackIrlEventByDispensaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackIrlEventByDispensaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackIrlEventByDispensaryMutation, { data, loading, error }] = useTrackIrlEventByDispensaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackIrlEventByDispensaryMutation(baseOptions?: Apollo.MutationHookOptions<GqlTrackIrlEventByDispensaryMutation, GqlTrackIrlEventByDispensaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlTrackIrlEventByDispensaryMutation, GqlTrackIrlEventByDispensaryMutationVariables>(TrackIrlEventByDispensaryDocument, options);
      }
export type TrackIrlEventByDispensaryMutationHookResult = ReturnType<typeof useTrackIrlEventByDispensaryMutation>;
export type TrackIrlEventByDispensaryMutationResult = Apollo.MutationResult<GqlTrackIrlEventByDispensaryMutation>;
export type TrackIrlEventByDispensaryMutationOptions = Apollo.BaseMutationOptions<GqlTrackIrlEventByDispensaryMutation, GqlTrackIrlEventByDispensaryMutationVariables>;
export const TrackIrlEventDocument = gql`
    mutation TrackIrlEvent($input: TrackIrlEventInput!) {
  trackIrlEvent(input: $input) {
    success
  }
}
    `;
export type GqlTrackIrlEventMutationFn = Apollo.MutationFunction<GqlTrackIrlEventMutation, GqlTrackIrlEventMutationVariables>;

/**
 * __useTrackIrlEventMutation__
 *
 * To run a mutation, you first call `useTrackIrlEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackIrlEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackIrlEventMutation, { data, loading, error }] = useTrackIrlEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackIrlEventMutation(baseOptions?: Apollo.MutationHookOptions<GqlTrackIrlEventMutation, GqlTrackIrlEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlTrackIrlEventMutation, GqlTrackIrlEventMutationVariables>(TrackIrlEventDocument, options);
      }
export type TrackIrlEventMutationHookResult = ReturnType<typeof useTrackIrlEventMutation>;
export type TrackIrlEventMutationResult = Apollo.MutationResult<GqlTrackIrlEventMutation>;
export type TrackIrlEventMutationOptions = Apollo.BaseMutationOptions<GqlTrackIrlEventMutation, GqlTrackIrlEventMutationVariables>;
export const DispensaryDemoRequestDocument = gql`
    mutation DispensaryDemoRequest($input: dispensaryDemoRequestInput!) {
  dispensaryDemoRequest(input: $input) {
    success
  }
}
    `;
export type GqlDispensaryDemoRequestMutationFn = Apollo.MutationFunction<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>;

/**
 * __useDispensaryDemoRequestMutation__
 *
 * To run a mutation, you first call `useDispensaryDemoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispensaryDemoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispensaryDemoRequestMutation, { data, loading, error }] = useDispensaryDemoRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispensaryDemoRequestMutation(baseOptions?: Apollo.MutationHookOptions<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>(DispensaryDemoRequestDocument, options);
      }
export type DispensaryDemoRequestMutationHookResult = ReturnType<typeof useDispensaryDemoRequestMutation>;
export type DispensaryDemoRequestMutationResult = Apollo.MutationResult<GqlDispensaryDemoRequestMutation>;
export type DispensaryDemoRequestMutationOptions = Apollo.BaseMutationOptions<GqlDispensaryDemoRequestMutation, GqlDispensaryDemoRequestMutationVariables>;
export const ActivateBankAccountDocument = gql`
    mutation activateBankAccount($paymentMethodId: String!) {
  activateBankAccount(paymentMethodId: $paymentMethodId) {
    success
  }
}
    `;
export type GqlActivateBankAccountMutationFn = Apollo.MutationFunction<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>;

/**
 * __useActivateBankAccountMutation__
 *
 * To run a mutation, you first call `useActivateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBankAccountMutation, { data, loading, error }] = useActivateBankAccountMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useActivateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>(ActivateBankAccountDocument, options);
      }
export type ActivateBankAccountMutationHookResult = ReturnType<typeof useActivateBankAccountMutation>;
export type ActivateBankAccountMutationResult = Apollo.MutationResult<GqlActivateBankAccountMutation>;
export type ActivateBankAccountMutationOptions = Apollo.BaseMutationOptions<GqlActivateBankAccountMutation, GqlActivateBankAccountMutationVariables>;
export const ActivatePaymentMethodV2Document = gql`
    mutation ActivatePaymentMethodV2($paymentMethodId: String!) {
  activatePaymentMethodV2(paymentMethodId: $paymentMethodId) {
    genericResponse {
      success
      message
    }
  }
}
    `;
export type GqlActivatePaymentMethodV2MutationFn = Apollo.MutationFunction<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>;

/**
 * __useActivatePaymentMethodV2Mutation__
 *
 * To run a mutation, you first call `useActivatePaymentMethodV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePaymentMethodV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePaymentMethodV2Mutation, { data, loading, error }] = useActivatePaymentMethodV2Mutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useActivatePaymentMethodV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>(ActivatePaymentMethodV2Document, options);
      }
export type ActivatePaymentMethodV2MutationHookResult = ReturnType<typeof useActivatePaymentMethodV2Mutation>;
export type ActivatePaymentMethodV2MutationResult = Apollo.MutationResult<GqlActivatePaymentMethodV2Mutation>;
export type ActivatePaymentMethodV2MutationOptions = Apollo.BaseMutationOptions<GqlActivatePaymentMethodV2Mutation, GqlActivatePaymentMethodV2MutationVariables>;
export const ApproveInstoreCartDocument = gql`
    mutation ApproveInstoreCart($instoreCartId: String!, $tipCents: Int!, $sessionId: String) {
  approveInstoreCart(
    instoreCartId: $instoreCartId
    tipCents: $tipCents
    sessionId: $sessionId
  ) {
    success
    authorization {
      authorized
      status
      code
    }
  }
}
    `;
export type GqlApproveInstoreCartMutationFn = Apollo.MutationFunction<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>;

/**
 * __useApproveInstoreCartMutation__
 *
 * To run a mutation, you first call `useApproveInstoreCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInstoreCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInstoreCartMutation, { data, loading, error }] = useApproveInstoreCartMutation({
 *   variables: {
 *      instoreCartId: // value for 'instoreCartId'
 *      tipCents: // value for 'tipCents'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useApproveInstoreCartMutation(baseOptions?: Apollo.MutationHookOptions<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>(ApproveInstoreCartDocument, options);
      }
export type ApproveInstoreCartMutationHookResult = ReturnType<typeof useApproveInstoreCartMutation>;
export type ApproveInstoreCartMutationResult = Apollo.MutationResult<GqlApproveInstoreCartMutation>;
export type ApproveInstoreCartMutationOptions = Apollo.BaseMutationOptions<GqlApproveInstoreCartMutation, GqlApproveInstoreCartMutationVariables>;
export const CompleteAggregatorLinkDocument = gql`
    mutation CompleteAggregatorLink($aggregatorToken: String!, $aggregator: String!, $plaid: PlaidLinkMetadata, $paymentMethodId: String, $sessionId: String, $dispensaryName: String, $dispensaryId: String) {
  completeAggregatorLink(
    aggregatorToken: $aggregatorToken
    aggregator: $aggregator
    plaid: $plaid
    paymentMethodId: $paymentMethodId
    sessionId: $sessionId
    dispensaryName: $dispensaryName
    dispensaryId: $dispensaryId
  ) {
    paymentMethods {
      id
      status
      type
      bankAccountDetails {
        accountAlias
        bankName
        lastDigits
        status
        aggregator
        expiresAt
        billingAddressId
      }
    }
  }
}
    `;
export type GqlCompleteAggregatorLinkMutationFn = Apollo.MutationFunction<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>;

/**
 * __useCompleteAggregatorLinkMutation__
 *
 * To run a mutation, you first call `useCompleteAggregatorLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAggregatorLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAggregatorLinkMutation, { data, loading, error }] = useCompleteAggregatorLinkMutation({
 *   variables: {
 *      aggregatorToken: // value for 'aggregatorToken'
 *      aggregator: // value for 'aggregator'
 *      plaid: // value for 'plaid'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      sessionId: // value for 'sessionId'
 *      dispensaryName: // value for 'dispensaryName'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useCompleteAggregatorLinkMutation(baseOptions?: Apollo.MutationHookOptions<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>(CompleteAggregatorLinkDocument, options);
      }
export type CompleteAggregatorLinkMutationHookResult = ReturnType<typeof useCompleteAggregatorLinkMutation>;
export type CompleteAggregatorLinkMutationResult = Apollo.MutationResult<GqlCompleteAggregatorLinkMutation>;
export type CompleteAggregatorLinkMutationOptions = Apollo.BaseMutationOptions<GqlCompleteAggregatorLinkMutation, GqlCompleteAggregatorLinkMutationVariables>;
export const CreateBankAccountDocument = gql`
    mutation createBankAccount($adapter: String!, $aggregatorToken: String!, $billingAddressId: String!, $entityId: String!, $entityType: EntityTypes!, $sessionId: String) {
  createBankAccount(
    adapter: $adapter
    aggregatorToken: $aggregatorToken
    billingAddressId: $billingAddressId
    entityId: $entityId
    entityType: $entityType
    sessionId: $sessionId
  ) {
    bankAccount {
      id
      bankAccount {
        lastDigits
        bankName
        ownerName
      }
    }
  }
}
    `;
export type GqlCreateBankAccountMutationFn = Apollo.MutationFunction<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>;

/**
 * __useCreateBankAccountMutation__
 *
 * To run a mutation, you first call `useCreateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankAccountMutation, { data, loading, error }] = useCreateBankAccountMutation({
 *   variables: {
 *      adapter: // value for 'adapter'
 *      aggregatorToken: // value for 'aggregatorToken'
 *      billingAddressId: // value for 'billingAddressId'
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCreateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>(CreateBankAccountDocument, options);
      }
export type CreateBankAccountMutationHookResult = ReturnType<typeof useCreateBankAccountMutation>;
export type CreateBankAccountMutationResult = Apollo.MutationResult<GqlCreateBankAccountMutation>;
export type CreateBankAccountMutationOptions = Apollo.BaseMutationOptions<GqlCreateBankAccountMutation, GqlCreateBankAccountMutationVariables>;
export const CreateFraudAccountDocument = gql`
    mutation CreateFraudAccount($payload: CreateFraudInput!) {
  createFraudAccount(payload: $payload) {
    success
  }
}
    `;
export type GqlCreateFraudAccountMutationFn = Apollo.MutationFunction<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>;

/**
 * __useCreateFraudAccountMutation__
 *
 * To run a mutation, you first call `useCreateFraudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFraudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFraudAccountMutation, { data, loading, error }] = useCreateFraudAccountMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateFraudAccountMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>(CreateFraudAccountDocument, options);
      }
export type CreateFraudAccountMutationHookResult = ReturnType<typeof useCreateFraudAccountMutation>;
export type CreateFraudAccountMutationResult = Apollo.MutationResult<GqlCreateFraudAccountMutation>;
export type CreateFraudAccountMutationOptions = Apollo.BaseMutationOptions<GqlCreateFraudAccountMutation, GqlCreateFraudAccountMutationVariables>;
export const CreateMxEnrollmentDocument = gql`
    mutation createMxEnrollment($billingAddress: BillingAddressInput!, $entityId: String!, $entityName: String!, $entityType: EntityTypes!, $entityEmail: String!, $isMobileApp: Boolean!) {
  createMxEnrollment(
    billingAddress: $billingAddress
    entityId: $entityId
    entityName: $entityName
    entityType: $entityType
    entityEmail: $entityEmail
    isMobileApp: $isMobileApp
  ) {
    url
    billingAddress {
      id
    }
  }
}
    `;
export type GqlCreateMxEnrollmentMutationFn = Apollo.MutationFunction<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>;

/**
 * __useCreateMxEnrollmentMutation__
 *
 * To run a mutation, you first call `useCreateMxEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMxEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMxEnrollmentMutation, { data, loading, error }] = useCreateMxEnrollmentMutation({
 *   variables: {
 *      billingAddress: // value for 'billingAddress'
 *      entityId: // value for 'entityId'
 *      entityName: // value for 'entityName'
 *      entityType: // value for 'entityType'
 *      entityEmail: // value for 'entityEmail'
 *      isMobileApp: // value for 'isMobileApp'
 *   },
 * });
 */
export function useCreateMxEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>(CreateMxEnrollmentDocument, options);
      }
export type CreateMxEnrollmentMutationHookResult = ReturnType<typeof useCreateMxEnrollmentMutation>;
export type CreateMxEnrollmentMutationResult = Apollo.MutationResult<GqlCreateMxEnrollmentMutation>;
export type CreateMxEnrollmentMutationOptions = Apollo.BaseMutationOptions<GqlCreateMxEnrollmentMutation, GqlCreateMxEnrollmentMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation CreatePayment($amount: Int!, $tipAmount: Int, $checkoutToken: String!, $currency: String!, $ecommLocationId: String!, $card: CreatePaymentCard, $customerDetails: CreatePaymentCustomerDetails!, $redirectUrl: String) {
  createPayment(
    amount: $amount
    tipAmount: $tipAmount
    checkoutToken: $checkoutToken
    currency: $currency
    ecommLocationId: $ecommLocationId
    card: $card
    customerDetails: $customerDetails
    redirectUrl: $redirectUrl
  ) {
    payment {
      id
    }
    redirectUrl
  }
}
    `;
export type GqlCreatePaymentMutationFn = Apollo.MutationFunction<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      tipAmount: // value for 'tipAmount'
 *      checkoutToken: // value for 'checkoutToken'
 *      currency: // value for 'currency'
 *      ecommLocationId: // value for 'ecommLocationId'
 *      card: // value for 'card'
 *      customerDetails: // value for 'customerDetails'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<GqlCreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<GqlCreatePaymentMutation, GqlCreatePaymentMutationVariables>;
export const RecordUserAcceptanceDocument = gql`
    mutation recordUserAcceptance($acceptanceDocumentId: String!, $entityId: String!, $entityType: EntityTypes!, $userId: String!) {
  recordUserAcceptance(
    acceptanceDocumentId: $acceptanceDocumentId
    entityId: $entityId
    entityType: $entityType
    userId: $userId
  ) {
    success
  }
}
    `;
export type GqlRecordUserAcceptanceMutationFn = Apollo.MutationFunction<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>;

/**
 * __useRecordUserAcceptanceMutation__
 *
 * To run a mutation, you first call `useRecordUserAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordUserAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordUserAcceptanceMutation, { data, loading, error }] = useRecordUserAcceptanceMutation({
 *   variables: {
 *      acceptanceDocumentId: // value for 'acceptanceDocumentId'
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRecordUserAcceptanceMutation(baseOptions?: Apollo.MutationHookOptions<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>(RecordUserAcceptanceDocument, options);
      }
export type RecordUserAcceptanceMutationHookResult = ReturnType<typeof useRecordUserAcceptanceMutation>;
export type RecordUserAcceptanceMutationResult = Apollo.MutationResult<GqlRecordUserAcceptanceMutation>;
export type RecordUserAcceptanceMutationOptions = Apollo.BaseMutationOptions<GqlRecordUserAcceptanceMutation, GqlRecordUserAcceptanceMutationVariables>;
export const StartPreAuthCheckDocument = gql`
    mutation StartPreAuthCheck($paymentMethodId: String!) {
  startPreAuthCheck(paymentMethodId: $paymentMethodId) {
    channelName
    checkId
    status
  }
}
    `;
export type GqlStartPreAuthCheckMutationFn = Apollo.MutationFunction<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>;

/**
 * __useStartPreAuthCheckMutation__
 *
 * To run a mutation, you first call `useStartPreAuthCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPreAuthCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPreAuthCheckMutation, { data, loading, error }] = useStartPreAuthCheckMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStartPreAuthCheckMutation(baseOptions?: Apollo.MutationHookOptions<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>(StartPreAuthCheckDocument, options);
      }
export type StartPreAuthCheckMutationHookResult = ReturnType<typeof useStartPreAuthCheckMutation>;
export type StartPreAuthCheckMutationResult = Apollo.MutationResult<GqlStartPreAuthCheckMutation>;
export type StartPreAuthCheckMutationOptions = Apollo.BaseMutationOptions<GqlStartPreAuthCheckMutation, GqlStartPreAuthCheckMutationVariables>;
export const UnenrollPayByBankUserDocument = gql`
    mutation UnenrollPayByBankUser($entityId: String!, $entityType: EntityTypes!) {
  unenrollPayByBankUser(entityId: $entityId, entityType: $entityType) {
    success
  }
}
    `;
export type GqlUnenrollPayByBankUserMutationFn = Apollo.MutationFunction<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>;

/**
 * __useUnenrollPayByBankUserMutation__
 *
 * To run a mutation, you first call `useUnenrollPayByBankUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollPayByBankUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollPayByBankUserMutation, { data, loading, error }] = useUnenrollPayByBankUserMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useUnenrollPayByBankUserMutation(baseOptions?: Apollo.MutationHookOptions<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>(UnenrollPayByBankUserDocument, options);
      }
export type UnenrollPayByBankUserMutationHookResult = ReturnType<typeof useUnenrollPayByBankUserMutation>;
export type UnenrollPayByBankUserMutationResult = Apollo.MutationResult<GqlUnenrollPayByBankUserMutation>;
export type UnenrollPayByBankUserMutationOptions = Apollo.BaseMutationOptions<GqlUnenrollPayByBankUserMutation, GqlUnenrollPayByBankUserMutationVariables>;
export const GetCustomerDetailsDocument = gql`
    query GetCustomerDetails {
  getCustomerDetails {
    id
    name
    externalId
    successfulOrderCount
  }
}
    `;

/**
 * __useGetCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
      }
export function useGetCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
        }
export type GetCustomerDetailsQueryHookResult = ReturnType<typeof useGetCustomerDetailsQuery>;
export type GetCustomerDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerDetailsLazyQuery>;
export type GetCustomerDetailsQueryResult = Apollo.QueryResult<GqlGetCustomerDetailsQuery, GqlGetCustomerDetailsQueryVariables>;
export const GetEnrollmentStatusDocument = gql`
    query GetEnrollmentStatus($entityId: String!, $entityType: EntityTypes!) {
  getEnrollmentStatus(entityId: $entityId, entityType: $entityType) {
    enrollment {
      status
    }
    bankAccounts {
      id
      billingAddress {
        line1
        line2
        city
        state
        country
        postalCode
      }
      bankAccount {
        bankName
        lastDigits
      }
    }
  }
}
    `;

/**
 * __useGetEnrollmentStatusQuery__
 *
 * To run a query within a React component, call `useGetEnrollmentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrollmentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrollmentStatusQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetEnrollmentStatusQuery(baseOptions: Apollo.QueryHookOptions<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>(GetEnrollmentStatusDocument, options);
      }
export function useGetEnrollmentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>(GetEnrollmentStatusDocument, options);
        }
export type GetEnrollmentStatusQueryHookResult = ReturnType<typeof useGetEnrollmentStatusQuery>;
export type GetEnrollmentStatusLazyQueryHookResult = ReturnType<typeof useGetEnrollmentStatusLazyQuery>;
export type GetEnrollmentStatusQueryResult = Apollo.QueryResult<GqlGetEnrollmentStatusQuery, GqlGetEnrollmentStatusQueryVariables>;
export const GetEntityLinkingCodeDocument = gql`
    query GetEntityLinkingCode {
  getEntityLinkingCode {
    code
  }
}
    `;

/**
 * __useGetEntityLinkingCodeQuery__
 *
 * To run a query within a React component, call `useGetEntityLinkingCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityLinkingCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityLinkingCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntityLinkingCodeQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>(GetEntityLinkingCodeDocument, options);
      }
export function useGetEntityLinkingCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>(GetEntityLinkingCodeDocument, options);
        }
export type GetEntityLinkingCodeQueryHookResult = ReturnType<typeof useGetEntityLinkingCodeQuery>;
export type GetEntityLinkingCodeLazyQueryHookResult = ReturnType<typeof useGetEntityLinkingCodeLazyQuery>;
export type GetEntityLinkingCodeQueryResult = Apollo.QueryResult<GqlGetEntityLinkingCodeQuery, GqlGetEntityLinkingCodeQueryVariables>;
export const FilteredDispensariesDocument = gql`
    query filteredDispensaries($dispensaryId: String) {
  filteredDispensaries(filter: {cNameOrID: $dispensaryId}) {
    SpecialLogoImage
    name
  }
}
    `;

/**
 * __useFilteredDispensariesQuery__
 *
 * To run a query within a React component, call `useFilteredDispensariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDispensariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDispensariesQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useFilteredDispensariesQuery(baseOptions?: Apollo.QueryHookOptions<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>(FilteredDispensariesDocument, options);
      }
export function useFilteredDispensariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>(FilteredDispensariesDocument, options);
        }
export type FilteredDispensariesQueryHookResult = ReturnType<typeof useFilteredDispensariesQuery>;
export type FilteredDispensariesLazyQueryHookResult = ReturnType<typeof useFilteredDispensariesLazyQuery>;
export type FilteredDispensariesQueryResult = Apollo.QueryResult<GqlFilteredDispensariesQuery, GqlFilteredDispensariesQueryVariables>;
export const GetInstoreAnalyticsTokenDocument = gql`
    query GetInstoreAnalyticsToken {
  getInstoreAnalyticsToken {
    instoreAnalyticsTokenId
  }
}
    `;

/**
 * __useGetInstoreAnalyticsTokenQuery__
 *
 * To run a query within a React component, call `useGetInstoreAnalyticsTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstoreAnalyticsTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstoreAnalyticsTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstoreAnalyticsTokenQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>(GetInstoreAnalyticsTokenDocument, options);
      }
export function useGetInstoreAnalyticsTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>(GetInstoreAnalyticsTokenDocument, options);
        }
export type GetInstoreAnalyticsTokenQueryHookResult = ReturnType<typeof useGetInstoreAnalyticsTokenQuery>;
export type GetInstoreAnalyticsTokenLazyQueryHookResult = ReturnType<typeof useGetInstoreAnalyticsTokenLazyQuery>;
export type GetInstoreAnalyticsTokenQueryResult = Apollo.QueryResult<GqlGetInstoreAnalyticsTokenQuery, GqlGetInstoreAnalyticsTokenQueryVariables>;
export const GetInstoreCartDocument = gql`
    query GetInstoreCart($cartToken: String) {
  getInstoreCart(cartToken: $cartToken) {
    instoreCartData {
      instoreCart {
        currency
        discounts {
          name
          valueCents
        }
        fees {
          name
          valueCents
        }
        id
        items {
          brandName
          imageUrl
          name
          quantity
          valueCents
        }
        subtotalCents
        taxes {
          name
          valueCents
        }
        tipCents
        totalCents
      }
      tippingDisabled
      retailerId
    }
  }
}
    `;

/**
 * __useGetInstoreCartQuery__
 *
 * To run a query within a React component, call `useGetInstoreCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstoreCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstoreCartQuery({
 *   variables: {
 *      cartToken: // value for 'cartToken'
 *   },
 * });
 */
export function useGetInstoreCartQuery(baseOptions?: Apollo.QueryHookOptions<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>(GetInstoreCartDocument, options);
      }
export function useGetInstoreCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>(GetInstoreCartDocument, options);
        }
export type GetInstoreCartQueryHookResult = ReturnType<typeof useGetInstoreCartQuery>;
export type GetInstoreCartLazyQueryHookResult = ReturnType<typeof useGetInstoreCartLazyQuery>;
export type GetInstoreCartQueryResult = Apollo.QueryResult<GqlGetInstoreCartQuery, GqlGetInstoreCartQueryVariables>;
export const GetUserIncentiveEligibilityDocument = gql`
    query getUserIncentiveEligibility($externalId: String!, $dispensaryId: String) {
  getUserIncentiveEligibility(
    externalId: $externalId
    dispensaryId: $dispensaryId
  ) {
    eligible
    incentive {
      id
      name
      description
      amountCents
      cohortName
      active
    }
  }
}
    `;

/**
 * __useGetUserIncentiveEligibilityQuery__
 *
 * To run a query within a React component, call `useGetUserIncentiveEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIncentiveEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIncentiveEligibilityQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetUserIncentiveEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>(GetUserIncentiveEligibilityDocument, options);
      }
export function useGetUserIncentiveEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>(GetUserIncentiveEligibilityDocument, options);
        }
export type GetUserIncentiveEligibilityQueryHookResult = ReturnType<typeof useGetUserIncentiveEligibilityQuery>;
export type GetUserIncentiveEligibilityLazyQueryHookResult = ReturnType<typeof useGetUserIncentiveEligibilityLazyQuery>;
export type GetUserIncentiveEligibilityQueryResult = Apollo.QueryResult<GqlGetUserIncentiveEligibilityQuery, GqlGetUserIncentiveEligibilityQueryVariables>;
export const ListBankAccountsDocument = gql`
    query ListBankAccounts($aggregator: String!) {
  listBankAccounts(aggregator: $aggregator) {
    bankAccounts {
      accountAlias
      bankName
      billingAddressId
      entityId
      id
      lastDigits
      mx {
        connectionStatus
        widgetUrl
      }
      status
    }
  }
}
    `;

/**
 * __useListBankAccountsQuery__
 *
 * To run a query within a React component, call `useListBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBankAccountsQuery({
 *   variables: {
 *      aggregator: // value for 'aggregator'
 *   },
 * });
 */
export function useListBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>(ListBankAccountsDocument, options);
      }
export function useListBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>(ListBankAccountsDocument, options);
        }
export type ListBankAccountsQueryHookResult = ReturnType<typeof useListBankAccountsQuery>;
export type ListBankAccountsLazyQueryHookResult = ReturnType<typeof useListBankAccountsLazyQuery>;
export type ListBankAccountsQueryResult = Apollo.QueryResult<GqlListBankAccountsQuery, GqlListBankAccountsQueryVariables>;
export const ListRetailerPaymentTypesStatusDocument = gql`
    query ListRetailerPaymentTypesStatus($ecommLocationId: String!) {
  listRetailerPaymentTypesStatus(ecommLocationId: $ecommLocationId) {
    paymentTypes {
      enabled
      type
      orderTypes {
        curbsidePickup
        driveThruPickup
        pickup
        delivery
      }
    }
  }
}
    `;

/**
 * __useListRetailerPaymentTypesStatusQuery__
 *
 * To run a query within a React component, call `useListRetailerPaymentTypesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRetailerPaymentTypesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRetailerPaymentTypesStatusQuery({
 *   variables: {
 *      ecommLocationId: // value for 'ecommLocationId'
 *   },
 * });
 */
export function useListRetailerPaymentTypesStatusQuery(baseOptions: Apollo.QueryHookOptions<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>(ListRetailerPaymentTypesStatusDocument, options);
      }
export function useListRetailerPaymentTypesStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>(ListRetailerPaymentTypesStatusDocument, options);
        }
export type ListRetailerPaymentTypesStatusQueryHookResult = ReturnType<typeof useListRetailerPaymentTypesStatusQuery>;
export type ListRetailerPaymentTypesStatusLazyQueryHookResult = ReturnType<typeof useListRetailerPaymentTypesStatusLazyQuery>;
export type ListRetailerPaymentTypesStatusQueryResult = Apollo.QueryResult<GqlListRetailerPaymentTypesStatusQuery, GqlListRetailerPaymentTypesStatusQueryVariables>;
export const ShowEnrollmentDocument = gql`
    query ShowEnrollment {
  showEnrollment {
    enrollmentStatus
    requiresAggregatorMigration
    paymentMethods {
      id
      status
      type
      bankAccountDetails {
        accountAlias
        bankName
        lastDigits
        status
        aggregator
        expiresAt
        billingAddressId
        financialInstitutionLogo
      }
    }
  }
}
    `;

/**
 * __useShowEnrollmentQuery__
 *
 * To run a query within a React component, call `useShowEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowEnrollmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowEnrollmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowEnrollmentQuery(baseOptions?: Apollo.QueryHookOptions<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>(ShowEnrollmentDocument, options);
      }
export function useShowEnrollmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>(ShowEnrollmentDocument, options);
        }
export type ShowEnrollmentQueryHookResult = ReturnType<typeof useShowEnrollmentQuery>;
export type ShowEnrollmentLazyQueryHookResult = ReturnType<typeof useShowEnrollmentLazyQuery>;
export type ShowEnrollmentQueryResult = Apollo.QueryResult<GqlShowEnrollmentQuery, GqlShowEnrollmentQueryVariables>;
export const StartAggregatorLinkV2Document = gql`
    query StartAggregatorLinkV2($aggregator: String!, $firstName: String!, $lastName: String!, $email: String!, $phone: String!, $paymentMethodId: String, $linkCustomizationName: String) {
  startAggregatorLinkV2(
    aggregator: $aggregator
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    paymentMethodId: $paymentMethodId
    linkCustomizationName: $linkCustomizationName
  ) {
    plaid {
      linkToken
    }
    aerosync {
      token
      userId
    }
  }
}
    `;

/**
 * __useStartAggregatorLinkV2Query__
 *
 * To run a query within a React component, call `useStartAggregatorLinkV2Query` and pass it any options that fit your needs.
 * When your component renders, `useStartAggregatorLinkV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartAggregatorLinkV2Query({
 *   variables: {
 *      aggregator: // value for 'aggregator'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      linkCustomizationName: // value for 'linkCustomizationName'
 *   },
 * });
 */
export function useStartAggregatorLinkV2Query(baseOptions: Apollo.QueryHookOptions<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>(StartAggregatorLinkV2Document, options);
      }
export function useStartAggregatorLinkV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>(StartAggregatorLinkV2Document, options);
        }
export type StartAggregatorLinkV2QueryHookResult = ReturnType<typeof useStartAggregatorLinkV2Query>;
export type StartAggregatorLinkV2LazyQueryHookResult = ReturnType<typeof useStartAggregatorLinkV2LazyQuery>;
export type StartAggregatorLinkV2QueryResult = Apollo.QueryResult<GqlStartAggregatorLinkV2Query, GqlStartAggregatorLinkV2QueryVariables>;
export const StartAggregatorLinkDocument = gql`
    query StartAggregatorLink($aggregator: String!, $redirectUrl: String, $paymentMethodId: String, $entityName: String, $email: String, $phone: String, $linkCustomizationName: String) {
  startAggregatorLink(
    aggregator: $aggregator
    redirectUrl: $redirectUrl
    paymentMethodId: $paymentMethodId
    entityName: $entityName
    email: $email
    phone: $phone
    linkCustomizationName: $linkCustomizationName
  ) {
    plaid {
      linkToken
    }
  }
}
    `;

/**
 * __useStartAggregatorLinkQuery__
 *
 * To run a query within a React component, call `useStartAggregatorLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartAggregatorLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartAggregatorLinkQuery({
 *   variables: {
 *      aggregator: // value for 'aggregator'
 *      redirectUrl: // value for 'redirectUrl'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      entityName: // value for 'entityName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      linkCustomizationName: // value for 'linkCustomizationName'
 *   },
 * });
 */
export function useStartAggregatorLinkQuery(baseOptions: Apollo.QueryHookOptions<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>(StartAggregatorLinkDocument, options);
      }
export function useStartAggregatorLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>(StartAggregatorLinkDocument, options);
        }
export type StartAggregatorLinkQueryHookResult = ReturnType<typeof useStartAggregatorLinkQuery>;
export type StartAggregatorLinkLazyQueryHookResult = ReturnType<typeof useStartAggregatorLinkLazyQuery>;
export type StartAggregatorLinkQueryResult = Apollo.QueryResult<GqlStartAggregatorLinkQuery, GqlStartAggregatorLinkQueryVariables>;
export const VerifyMxMemberDocument = gql`
    query VerifyMxMember($entityId: String!, $entityType: EntityTypes!, $memberGuid: String!, $isMobileApp: Boolean!) {
  verifyMxMember(
    entityId: $entityId
    entityType: $entityType
    memberGuid: $memberGuid
    isMobileApp: $isMobileApp
  ) {
    identificationComplete
    needsAccountSelection
    needsMfa
    url
    accounts {
      accountAlias
      accountGuid
      availableBalance
      bankName
      lastDigits
    }
  }
}
    `;

/**
 * __useVerifyMxMemberQuery__
 *
 * To run a query within a React component, call `useVerifyMxMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyMxMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyMxMemberQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      memberGuid: // value for 'memberGuid'
 *      isMobileApp: // value for 'isMobileApp'
 *   },
 * });
 */
export function useVerifyMxMemberQuery(baseOptions: Apollo.QueryHookOptions<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>(VerifyMxMemberDocument, options);
      }
export function useVerifyMxMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>(VerifyMxMemberDocument, options);
        }
export type VerifyMxMemberQueryHookResult = ReturnType<typeof useVerifyMxMemberQuery>;
export type VerifyMxMemberLazyQueryHookResult = ReturnType<typeof useVerifyMxMemberLazyQuery>;
export type VerifyMxMemberQueryResult = Apollo.QueryResult<GqlVerifyMxMemberQuery, GqlVerifyMxMemberQueryVariables>;
export const GetPersonalizedProductsV2Document = gql`
    query GetPersonalizedProductsV2($input: GetPersonalizedProductsV2Input!) {
  getPersonalizedProductsV2(input: $input) {
    products {
      ...consumerBaseProductFragment
      provider
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useGetPersonalizedProductsV2Query__
 *
 * To run a query within a React component, call `useGetPersonalizedProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedProductsV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPersonalizedProductsV2Query(baseOptions: Apollo.QueryHookOptions<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>(GetPersonalizedProductsV2Document, options);
      }
export function useGetPersonalizedProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>(GetPersonalizedProductsV2Document, options);
        }
export type GetPersonalizedProductsV2QueryHookResult = ReturnType<typeof useGetPersonalizedProductsV2Query>;
export type GetPersonalizedProductsV2LazyQueryHookResult = ReturnType<typeof useGetPersonalizedProductsV2LazyQuery>;
export type GetPersonalizedProductsV2QueryResult = Apollo.QueryResult<GqlGetPersonalizedProductsV2Query, GqlGetPersonalizedProductsV2QueryVariables>;
export const GetRecommendedProductsDocument = gql`
    query GetRecommendedProducts($dispensaryId: String!) {
  getRecommendedProducts(dispensaryId: $dispensaryId) {
    ...consumerBaseProductFragment
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useGetRecommendedProductsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedProductsQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetRecommendedProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, options);
      }
export function useGetRecommendedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, options);
        }
export type GetRecommendedProductsQueryHookResult = ReturnType<typeof useGetRecommendedProductsQuery>;
export type GetRecommendedProductsLazyQueryHookResult = ReturnType<typeof useGetRecommendedProductsLazyQuery>;
export type GetRecommendedProductsQueryResult = Apollo.QueryResult<GqlGetRecommendedProductsQuery, GqlGetRecommendedProductsQueryVariables>;
export const GetSortedProductRecommendationsDocument = gql`
    query GetSortedProductRecommendations($input: GetSortedProductRecommendationsInput!) {
  getSortedProductRecommendations(input: $input) {
    products {
      id
    }
    adapter
  }
}
    `;

/**
 * __useGetSortedProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetSortedProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSortedProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSortedProductRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSortedProductRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>(GetSortedProductRecommendationsDocument, options);
      }
export function useGetSortedProductRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>(GetSortedProductRecommendationsDocument, options);
        }
export type GetSortedProductRecommendationsQueryHookResult = ReturnType<typeof useGetSortedProductRecommendationsQuery>;
export type GetSortedProductRecommendationsLazyQueryHookResult = ReturnType<typeof useGetSortedProductRecommendationsLazyQuery>;
export type GetSortedProductRecommendationsQueryResult = Apollo.QueryResult<GqlGetSortedProductRecommendationsQuery, GqlGetSortedProductRecommendationsQueryVariables>;
export const GetPersonalizedProductsDocument = gql`
    query GetPersonalizedProducts($input: GetPersonalizedProductsInput!) {
  getPersonalizedProducts(input: $input) {
    products {
      ...consumerBaseProductFragment
      provider
    }
  }
}
    ${ConsumerBaseProductFragmentFragmentDoc}`;

/**
 * __useGetPersonalizedProductsQuery__
 *
 * To run a query within a React component, call `useGetPersonalizedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPersonalizedProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>(GetPersonalizedProductsDocument, options);
      }
export function useGetPersonalizedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>(GetPersonalizedProductsDocument, options);
        }
export type GetPersonalizedProductsQueryHookResult = ReturnType<typeof useGetPersonalizedProductsQuery>;
export type GetPersonalizedProductsLazyQueryHookResult = ReturnType<typeof useGetPersonalizedProductsLazyQuery>;
export type GetPersonalizedProductsQueryResult = Apollo.QueryResult<GqlGetPersonalizedProductsQuery, GqlGetPersonalizedProductsQueryVariables>;
export const GetTrackedCartDocument = gql`
    query GetTrackedCart($checkoutToken: String!, $dispensaryId: String!) {
  getTrackedCart(checkoutToken: $checkoutToken, dispensaryId: $dispensaryId) {
    token
    dispensaryId
    createdAt
    updatedAt
    order
  }
}
    `;

/**
 * __useGetTrackedCartQuery__
 *
 * To run a query within a React component, call `useGetTrackedCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedCartQuery({
 *   variables: {
 *      checkoutToken: // value for 'checkoutToken'
 *      dispensaryId: // value for 'dispensaryId'
 *   },
 * });
 */
export function useGetTrackedCartQuery(baseOptions: Apollo.QueryHookOptions<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>(GetTrackedCartDocument, options);
      }
export function useGetTrackedCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>(GetTrackedCartDocument, options);
        }
export type GetTrackedCartQueryHookResult = ReturnType<typeof useGetTrackedCartQuery>;
export type GetTrackedCartLazyQueryHookResult = ReturnType<typeof useGetTrackedCartLazyQuery>;
export type GetTrackedCartQueryResult = Apollo.QueryResult<GqlGetTrackedCartQuery, GqlGetTrackedCartQueryVariables>;
export const PersistCheckoutV2Document = gql`
    mutation PersistCheckoutV2($order: JSON!, $dispensaryId: String!, $token: String) {
  persistCheckoutV2(order: $order, dispensaryId: $dispensaryId, token: $token) {
    checkoutToken
  }
}
    `;
export type GqlPersistCheckoutV2MutationFn = Apollo.MutationFunction<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>;

/**
 * __usePersistCheckoutV2Mutation__
 *
 * To run a mutation, you first call `usePersistCheckoutV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistCheckoutV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistCheckoutV2Mutation, { data, loading, error }] = usePersistCheckoutV2Mutation({
 *   variables: {
 *      order: // value for 'order'
 *      dispensaryId: // value for 'dispensaryId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePersistCheckoutV2Mutation(baseOptions?: Apollo.MutationHookOptions<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>(PersistCheckoutV2Document, options);
      }
export type PersistCheckoutV2MutationHookResult = ReturnType<typeof usePersistCheckoutV2Mutation>;
export type PersistCheckoutV2MutationResult = Apollo.MutationResult<GqlPersistCheckoutV2Mutation>;
export type PersistCheckoutV2MutationOptions = Apollo.BaseMutationOptions<GqlPersistCheckoutV2Mutation, GqlPersistCheckoutV2MutationVariables>;
export const GetRemoteIntegrationValueDocument = gql`
    query GetRemoteIntegrationValue($dispensaryId: String!, $key: String!) {
  getRemoteIntegrationValue(dispensaryId: $dispensaryId, key: $key)
}
    `;

/**
 * __useGetRemoteIntegrationValueQuery__
 *
 * To run a query within a React component, call `useGetRemoteIntegrationValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteIntegrationValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteIntegrationValueQuery({
 *   variables: {
 *      dispensaryId: // value for 'dispensaryId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetRemoteIntegrationValueQuery(baseOptions: Apollo.QueryHookOptions<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>(GetRemoteIntegrationValueDocument, options);
      }
export function useGetRemoteIntegrationValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>(GetRemoteIntegrationValueDocument, options);
        }
export type GetRemoteIntegrationValueQueryHookResult = ReturnType<typeof useGetRemoteIntegrationValueQuery>;
export type GetRemoteIntegrationValueLazyQueryHookResult = ReturnType<typeof useGetRemoteIntegrationValueLazyQuery>;
export type GetRemoteIntegrationValueQueryResult = Apollo.QueryResult<GqlGetRemoteIntegrationValueQuery, GqlGetRemoteIntegrationValueQueryVariables>;
export const GetSponsoredBrandDocument = gql`
    query GetSponsoredBrand($input: GetSponsoredBrandInput!) {
  getSponsoredBrand(input: $input) {
    id
    name
    campaignId
    trackers {
      clickUrl
      impressionUrl
    }
    products {
      ...consumerSponsoredProductFragment
    }
  }
}
    ${ConsumerSponsoredProductFragmentFragmentDoc}`;

/**
 * __useGetSponsoredBrandQuery__
 *
 * To run a query within a React component, call `useGetSponsoredBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSponsoredBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSponsoredBrandQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSponsoredBrandQuery(baseOptions: Apollo.QueryHookOptions<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>(GetSponsoredBrandDocument, options);
      }
export function useGetSponsoredBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>(GetSponsoredBrandDocument, options);
        }
export type GetSponsoredBrandQueryHookResult = ReturnType<typeof useGetSponsoredBrandQuery>;
export type GetSponsoredBrandLazyQueryHookResult = ReturnType<typeof useGetSponsoredBrandLazyQuery>;
export type GetSponsoredBrandQueryResult = Apollo.QueryResult<GqlGetSponsoredBrandQuery, GqlGetSponsoredBrandQueryVariables>;
export const GetSponsoredProductsDocument = gql`
    query getSponsoredProducts($input: GetSponsoredProductsInput!) {
  getSponsoredProducts(input: $input) {
    ...consumerSponsoredProductFragment
  }
}
    ${ConsumerSponsoredProductFragmentFragmentDoc}`;

/**
 * __useGetSponsoredProductsQuery__
 *
 * To run a query within a React component, call `useGetSponsoredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSponsoredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSponsoredProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSponsoredProductsQuery(baseOptions: Apollo.QueryHookOptions<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>(GetSponsoredProductsDocument, options);
      }
export function useGetSponsoredProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>(GetSponsoredProductsDocument, options);
        }
export type GetSponsoredProductsQueryHookResult = ReturnType<typeof useGetSponsoredProductsQuery>;
export type GetSponsoredProductsLazyQueryHookResult = ReturnType<typeof useGetSponsoredProductsLazyQuery>;
export type GetSponsoredProductsQueryResult = Apollo.QueryResult<GqlGetSponsoredProductsQuery, GqlGetSponsoredProductsQueryVariables>;